(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === "object" && typeof module === "object") module.exports = factory(); else if (typeof define === "function" && define.amd) define([], factory); else if (typeof exports === "object") exports["pylon-bootstrap-vue"] = factory(); else root["pylon-bootstrap-vue"] = factory();
})(this, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) {
                return installedModules[moduleId].exports;
            }
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: false,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = true;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.i = function(value) {
            return value;
        };
        __webpack_require__.d = function(exports, name, getter) {
            if (!__webpack_require__.o(exports, name)) {
                Object.defineProperty(exports, name, {
                    configurable: false,
                    enumerable: true,
                    get: getter
                });
            }
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function getDefault() {
                return module["default"];
            } : function getModuleExports() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "/";
        return __webpack_require__(__webpack_require__.s = 228);
    }([ function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return mergeData;
        });
        var __assign = Object.assign || function(e) {
            for (var a, s = 1, t = arguments.length; s < t; s++) for (var r in a = arguments[s]) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
            return e;
        };
        function mergeData() {
            for (var e, a, s = {}, t = arguments.length; t--; ) for (var r = 0, c = Object.keys(arguments[t]); r < c.length; r++) switch (e = c[r]) {
              case "class":
              case "style":
              case "directives":
                Array.isArray(s[e]) || (s[e] = []), s[e] = s[e].concat(arguments[t][e]);
                break;

              case "staticClass":
                if (!arguments[t][e]) break;
                void 0 === s[e] && (s[e] = ""), s[e] && (s[e] += " "), s[e] += arguments[t][e].trim();
                break;

              case "on":
              case "nativeOn":
                s[e] || (s[e] = {});
                for (var o = 0, n = Object.keys(arguments[t][e] || {}); o < n.length; o++) a = n[o], 
                s[e][a] ? s[e][a] = [].concat(s[e][a], arguments[t][e][a]) : s[e][a] = arguments[t][e][a];
                break;

              case "attrs":
              case "props":
              case "domProps":
              case "scopedSlots":
              case "staticStyle":
              case "hook":
              case "transition":
                s[e] || (s[e] = {}), s[e] = __assign({}, arguments[t][e], s[e]);
                break;

              case "slot":
              case "key":
              case "ref":
              case "tag":
              case "show":
              case "keepAlive":
              default:
                s[e] || (s[e] = arguments[t][e]);
            }
            return s;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = registerComponents;
        __webpack_exports__["c"] = registerDirectives;
        __webpack_exports__["b"] = vueUse;
        function registerComponent(Vue, name, def) {
            Vue._bootstrap_vue_components_ = Vue._bootstrap_vue_components_ || {};
            var loaded = Vue._bootstrap_vue_components_[name];
            if (!loaded && def && name) {
                Vue._bootstrap_vue_components_[name] = true;
                Vue.component(name, def);
            }
            return loaded;
        }
        function registerComponents(Vue, components) {
            for (var component in components) {
                registerComponent(Vue, component, components[component]);
            }
        }
        function registerDirective(Vue, name, def) {
            Vue._bootstrap_vue_directives_ = Vue._bootstrap_vue_directives_ || {};
            var loaded = Vue._bootstrap_vue_directives_[name];
            if (!loaded && def && name) {
                Vue._bootstrap_vue_directives_[name] = true;
                Vue.directive(name, def);
            }
            return loaded;
        }
        function registerDirectives(Vue, directives) {
            for (var directive in directives) {
                registerDirective(Vue, directive, directives[directive]);
            }
        }
        function vueUse(VuePlugin) {
            if (typeof window !== "undefined" && window.Vue) {
                window.Vue.use(VuePlugin);
            }
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return assign;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return keys;
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return defineProperties;
        });
        __webpack_require__.d(__webpack_exports__, "e", function() {
            return defineProperty;
        });
        __webpack_require__.d(__webpack_exports__, "f", function() {
            return create;
        });
        __webpack_exports__["d"] = readonlyDescriptor;
        if (typeof Object.assign !== "function") {
            Object.assign = function(target, varArgs) {
                if (target == null) {
                    throw new TypeError("Cannot convert undefined or null to object");
                }
                var to = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];
                    if (nextSource != null) {
                        for (var nextKey in nextSource) {
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            };
        }
        if (!Object.is) {
            Object.is = function(x, y) {
                if (x === y) {
                    return x !== 0 || 1 / x === 1 / y;
                } else {
                    return x !== x && y !== y;
                }
            };
        }
        var assign = Object.assign;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var keys = Object.keys;
        var defineProperties = Object.defineProperties;
        var defineProperty = Object.defineProperty;
        var freeze = Object.freeze;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getPrototypeOf = Object.getPrototypeOf;
        var create = Object.create;
        var isFrozen = Object.isFrozen;
        var is = Object.is;
        function readonlyDescriptor() {
            return {
                enumerable: true,
                configurable: false,
                writable: false
            };
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return from;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return isArray;
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return arrayIncludes;
        });
        __webpack_exports__["c"] = concat;
        if (!Array.from) {
            Array.from = function() {
                var toStr = Object.prototype.toString;
                var isCallable = function isCallable(fn) {
                    return typeof fn === "function" || toStr.call(fn) === "[object Function]";
                };
                var toInteger = function toInteger(value) {
                    var number = Number(value);
                    if (isNaN(number)) {
                        return 0;
                    }
                    if (number === 0 || !isFinite(number)) {
                        return number;
                    }
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function toLength(value) {
                    return Math.min(Math.max(toInteger(value), 0), maxSafeInteger);
                };
                return function from(arrayLike) {
                    var C = this;
                    var items = Object(arrayLike);
                    if (arrayLike == null) {
                        throw new TypeError("Array.from requires an array-like object - not null or undefined");
                    }
                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                    var T = void 0;
                    if (typeof mapFn !== "undefined") {
                        if (!isCallable(mapFn)) {
                            throw new TypeError("Array.from: when provided, the second argument must be a function");
                        }
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }
                    var len = toLength(items.length);
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                    var k = 0;
                    var kValue = void 0;
                    while (k < len) {
                        kValue = items[k];
                        if (mapFn) {
                            A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        } else {
                            A[k] = kValue;
                        }
                        k += 1;
                    }
                    A.length = len;
                    return A;
                };
            }();
        }
        if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    var len = o.length >>> 0;
                    if (typeof predicate !== "function") {
                        throw new TypeError("predicate must be a function");
                    }
                    var thisArg = arguments[1];
                    var k = 0;
                    while (k < len) {
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        k++;
                    }
                    return undefined;
                }
            });
        }
        if (!Array.isArray) {
            Array.isArray = function(arg) {
                return Object.prototype.toString.call(arg) === "[object Array]";
            };
        }
        var from = Array.from;
        var isArray = Array.isArray;
        var arrayIncludes = function arrayIncludes(array, value) {
            return array.indexOf(value) !== -1;
        };
        var arrayFind = function arrayFind(array, fn, thisArg) {
            return array.find(fn, thisArg);
        };
        function concat() {
            return Array.prototype.concat.apply([], arguments);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            props: {
                id: {
                    type: String,
                    default: null
                }
            },
            methods: {
                safeId: function safeId() {
                    var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    var id = this.id || this.localId_ || null;
                    if (!id) {
                        return null;
                    }
                    suffix = String(suffix).replace(/\s+/g, "_");
                    return suffix ? id + "_" + suffix : id;
                }
            },
            computed: {
                localId_: function localId_() {
                    if (!this.$isServer && !this.id && typeof this._uid !== "undefined") {
                        return "__BVID__" + this._uid;
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "n", function() {
            return isElement;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return isVisible;
        });
        __webpack_require__.d(__webpack_exports__, "l", function() {
            return isDisabled;
        });
        __webpack_require__.d(__webpack_exports__, "v", function() {
            return reflow;
        });
        __webpack_require__.d(__webpack_exports__, "q", function() {
            return selectAll;
        });
        __webpack_require__.d(__webpack_exports__, "i", function() {
            return select;
        });
        __webpack_require__.d(__webpack_exports__, "s", function() {
            return matches;
        });
        __webpack_require__.d(__webpack_exports__, "h", function() {
            return closest;
        });
        __webpack_require__.d(__webpack_exports__, "t", function() {
            return getById;
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return addClass;
        });
        __webpack_require__.d(__webpack_exports__, "e", function() {
            return removeClass;
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return hasClass;
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return setAttr;
        });
        __webpack_require__.d(__webpack_exports__, "k", function() {
            return removeAttr;
        });
        __webpack_require__.d(__webpack_exports__, "j", function() {
            return getAttr;
        });
        __webpack_require__.d(__webpack_exports__, "u", function() {
            return hasAttr;
        });
        __webpack_require__.d(__webpack_exports__, "r", function() {
            return getBCR;
        });
        __webpack_require__.d(__webpack_exports__, "m", function() {
            return getCS;
        });
        __webpack_require__.d(__webpack_exports__, "p", function() {
            return offset;
        });
        __webpack_require__.d(__webpack_exports__, "o", function() {
            return position;
        });
        __webpack_require__.d(__webpack_exports__, "f", function() {
            return eventOn;
        });
        __webpack_require__.d(__webpack_exports__, "g", function() {
            return eventOff;
        });
        var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);
        var isElement = function isElement(el) {
            return el && el.nodeType === Node.ELEMENT_NODE;
        };
        var isVisible = function isVisible(el) {
            return isElement(el) && document.body.contains(el) && el.getBoundingClientRect().height > 0 && el.getBoundingClientRect().width > 0;
        };
        var isDisabled = function isDisabled(el) {
            return !isElement(el) || el.disabled || el.classList.contains("disabled") || Boolean(el.getAttribute("disabled"));
        };
        var reflow = function reflow(el) {
            return isElement(el) && el.offsetHeight;
        };
        var selectAll = function selectAll(selector, root) {
            if (!isElement(root)) {
                root = document;
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a"])(root.querySelectorAll(selector));
        };
        var select = function select(selector, root) {
            if (!isElement(root)) {
                root = document;
            }
            return root.querySelector(selector) || null;
        };
        var matches = function matches(el, selector) {
            if (!isElement(el)) {
                return false;
            }
            var proto = Element.prototype;
            var Matches = proto.matches || proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector || function(sel) {
                var element = this;
                var m = selectAll(sel, element.document || element.ownerDocument);
                var i = m.length;
                while (--i >= 0 && m.item(i) !== element) {}
                return i > -1;
            };
            return Matches.call(el, selector);
        };
        var closest = function closest(selector, root) {
            if (!isElement(root)) {
                return null;
            }
            var Closest = Element.prototype.closest || function(sel) {
                var element = this;
                if (!document.documentElement.contains(element)) {
                    return null;
                }
                do {
                    if (matches(element, sel)) {
                        return element;
                    }
                    element = element.parentElement;
                } while (element !== null);
                return null;
            };
            var el = Closest.call(root, selector);
            return el === root ? null : el;
        };
        var getById = function getById(id) {
            return document.getElementById(/^#/.test(id) ? id.slice(1) : id) || null;
        };
        var addClass = function addClass(el, className) {
            if (className && isElement(el)) {
                el.classList.add(className);
            }
        };
        var removeClass = function removeClass(el, className) {
            if (className && isElement(el)) {
                el.classList.remove(className);
            }
        };
        var hasClass = function hasClass(el, className) {
            if (className && isElement(el)) {
                return el.classList.contains(className);
            }
            return false;
        };
        var setAttr = function setAttr(el, attr, value) {
            if (attr && isElement(el)) {
                el.setAttribute(attr, value);
            }
        };
        var removeAttr = function removeAttr(el, attr) {
            if (attr && isElement(el)) {
                el.removeAttribute(attr);
            }
        };
        var getAttr = function getAttr(el, attr) {
            if (attr && isElement(el)) {
                return el.getAttribute(attr);
            }
            return null;
        };
        var hasAttr = function hasAttr(el, attr) {
            if (attr && isElement(el)) {
                return el.hasAttribute(attr);
            }
            return null;
        };
        var getBCR = function getBCR(el) {
            return isElement(el) ? el.getBoundingClientRect() : null;
        };
        var getCS = function getCS(el) {
            return isElement(el) ? window.getComputedStyle(el) : {};
        };
        var offset = function offset(el) {
            if (isElement(el)) {
                if (!el.getClientRects().length) {
                    return {
                        top: 0,
                        left: 0
                    };
                }
                var bcr = getBCR(el);
                var win = el.ownerDocument.defaultView;
                return {
                    top: bcr.top + win.pageYOffset,
                    left: bcr.left + win.pageXOffset
                };
            }
        };
        var position = function position(el) {
            if (!isElement(el)) {
                return;
            }
            var parentOffset = {
                top: 0,
                left: 0
            };
            var offsetSelf = void 0;
            var offsetParent = void 0;
            if (getCS(el).position === "fixed") {
                offsetSelf = getBCR(el);
            } else {
                offsetSelf = offset(el);
                var doc = el.ownerDocument;
                offsetParent = el.offsetParent || doc.documentElement;
                while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && getCS(offsetParent).position === "static") {
                    offsetParent = offsetParent.parentNode;
                }
                if (offsetParent && offsetParent !== el && offsetParent.nodeType === Node.ELEMENT_NODE) {
                    parentOffset = offset(offsetParent);
                    parentOffset.top += parseFloat(getCS(offsetParent).borderTopWidth);
                    parentOffset.left += parseFloat(getCS(offsetParent).borderLeftWidth);
                }
            }
            return {
                top: offsetSelf.top - parentOffset.top - parseFloat(getCS(el).marginTop),
                left: offsetSelf.left - parentOffset.left - parseFloat(getCS(el).marginLeft)
            };
        };
        var eventOn = function eventOn(el, evtName, handler) {
            if (el && el.addEventListener) {
                el.addEventListener(evtName, handler);
            }
        };
        var eventOff = function eventOff(el, evtName, handler) {
            if (el && el.removeEventListener) {
                el.removeEventListener(evtName, handler);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["c"] = propsFactory;
        __webpack_exports__["b"] = pickLinkProps;
        var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__ = __webpack_require__(0);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function propsFactory() {
            return {
                href: {
                    type: String,
                    default: null
                },
                rel: {
                    type: String,
                    default: null
                },
                target: {
                    type: String,
                    default: "_self"
                },
                active: {
                    type: Boolean,
                    default: false
                },
                activeClass: {
                    type: String,
                    default: "active"
                },
                append: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                event: {
                    type: [ String, Array ],
                    default: "click"
                },
                exact: {
                    type: Boolean,
                    default: false
                },
                exactActiveClass: {
                    type: String,
                    default: "active"
                },
                replace: {
                    type: Boolean,
                    default: false
                },
                routerTag: {
                    type: String,
                    default: "a"
                },
                to: {
                    type: [ String, Object ],
                    default: null
                }
            };
        }
        var props = propsFactory();
        function pickLinkProps(propsToPick) {
            var freshLinkProps = propsFactory();
            propsToPick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["c"])(propsToPick);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(freshLinkProps).reduce(function(memo, prop) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])(propsToPick, prop)) {
                    memo[prop] = freshLinkProps[prop];
                }
                return memo;
            }, {});
        }
        function omitLinkProps(propsToOmit) {
            var freshLinkProps = propsFactory();
            propsToOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["c"])(propsToOmit);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(props).reduce(function(memo, prop) {
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])(propsToOmit, prop)) {
                    memo[prop] = freshLinkProps[prop];
                }
                return memo;
            }, {});
        }
        var computed = {
            linkProps: function linkProps() {
                var linkProps = {};
                var propKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(props);
                for (var i = 0; i < propKeys.length; i++) {
                    var prop = propKeys[i];
                    linkProps[prop] = this[prop];
                }
                return linkProps;
            }
        };
        function computeTag(props, parent) {
            return Boolean(parent.$router) && props.to && !props.disabled ? "router-link" : "a";
        }
        function computeHref(_ref, tag) {
            var disabled = _ref.disabled, href = _ref.href, to = _ref.to;
            if (tag === "router-link") return void 0;
            if (href) return href;
            if (to) {
                if (typeof to === "string") return to;
                if ((typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" && typeof to.path === "string") return to.path;
            }
            return "#";
        }
        function computeRel(_ref2) {
            var target = _ref2.target, rel = _ref2.rel;
            if (target === "_blank" && rel === null) {
                return "noopener";
            }
            return rel || null;
        }
        function clickHandlerFactory(_ref3) {
            var disabled = _ref3.disabled, tag = _ref3.tag, href = _ref3.href, suppliedHandler = _ref3.suppliedHandler, parent = _ref3.parent;
            var isRouterLink = tag === "router-link";
            return function onClick(e) {
                if (disabled && e instanceof Event) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                } else {
                    parent.$root.$emit("clicked::link", e);
                    if (isRouterLink && e.target.__vue__) {
                        e.target.__vue__.$emit("click", e);
                    }
                    if (typeof suppliedHandler === "function") {
                        suppliedHandler.apply(undefined, arguments);
                    }
                }
                if (!isRouterLink && href === "#" || disabled) {
                    e.preventDefault();
                }
            };
        }
        __webpack_exports__["a"] = {
            functional: true,
            props: propsFactory(),
            render: function render(h, _ref4) {
                var props = _ref4.props, data = _ref4.data, parent = _ref4.parent, children = _ref4.children;
                var tag = computeTag(props, parent);
                var rel = computeRel(props);
                var href = computeHref(props, tag);
                var eventType = tag === "router-link" ? "nativeOn" : "on";
                var suppliedHandler = (data[eventType] || {}).click;
                var handlers = {
                    click: clickHandlerFactory({
                        tag: tag,
                        href: href,
                        disabled: props.disabled,
                        suppliedHandler: suppliedHandler,
                        parent: parent
                    })
                };
                var componentData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__["a"])(data, {
                    class: [ props.active ? props.exact ? props.exactActiveClass : props.activeClass : null, {
                        disabled: props.disabled
                    } ],
                    attrs: {
                        rel: rel,
                        href: href,
                        target: props.target,
                        tabindex: props.disabled ? "-1" : data.attrs ? data.attrs.tabindex : null,
                        "aria-disabled": tag === "a" && props.disabled ? "true" : null
                    },
                    props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])(props, {
                        tag: props.routerTag
                    })
                });
                if (!componentData.attrs.href) {
                    delete componentData.attrs.href;
                }
                componentData[eventType] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])(componentData[eventType] || {}, handlers);
                return h(tag, componentData, children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function warn(message) {
            console.warn("[Bootstrap-Vue warn]: " + message);
        }
        __webpack_exports__["a"] = warn;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            props: {
                state: {
                    type: [ Boolean, String ],
                    default: null
                }
            },
            computed: {
                computedState: function computedState() {
                    var state = this.state;
                    if (state === true || state === "valid") {
                        return true;
                    } else if (state === false || state === "invalid") {
                        return false;
                    }
                    return null;
                },
                stateClass: function stateClass() {
                    var state = this.computedState;
                    if (state === true) {
                        return "is-valid";
                    } else if (state === false) {
                        return "is-invalid";
                    }
                    return null;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            props: {
                name: {
                    type: String
                },
                id: {
                    type: String
                },
                disabled: {
                    type: Boolean
                },
                required: {
                    type: Boolean,
                    default: false
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            SPACE: 32,
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            PAGEUP: 33,
            PAGEDOWN: 34,
            HOME: 36,
            END: 35
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            props: {
                size: {
                    type: String,
                    default: null
                }
            },
            computed: {
                sizeFormClass: function sizeFormClass() {
                    return [ this.size ? "form-control-" + this.size : null ];
                },
                sizeBtnClass: function sizeBtnClass() {
                    return [ this.size ? "btn-" + this.size : null ];
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = pluckProps;
        var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(156);
        function pluckProps(keysToPluck, objToPluck) {
            var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__identity__["a"];
            return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["b"])(keysToPluck) ? keysToPluck.slice() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["b"])(keysToPluck)).reduce(function(memo, prop) {
                return memo[transformFn(prop)] = objToPluck[prop], memo;
            }, {});
        }
    }, function(module, exports) {
        var g;
        g = function() {
            return this;
        }();
        try {
            g = g || Function("return this")() || (1, eval)("this");
        } catch (e) {
            if (typeof window === "object") g = window;
        }
        module.exports = g;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            computed: {
                custom: function custom() {
                    return !this.plain;
                }
            },
            props: {
                plain: {
                    type: Boolean,
                    default: false
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
        function _toConsumableArray(arr) {
            if (Array.isArray(arr)) {
                for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                    arr2[i] = arr[i];
                }
                return arr2;
            } else {
                return Array.from(arr);
            }
        }
        var BVRL = "__BV_root_listeners__";
        __webpack_exports__["a"] = {
            methods: {
                listenOnRoot: function listenOnRoot(event, callback) {
                    if (!this[BVRL] || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["b"])(this[BVRL])) {
                        this[BVRL] = [];
                    }
                    this[BVRL].push({
                        event: event,
                        callback: callback
                    });
                    this.$root.$on(event, callback);
                    return this;
                },
                emitOnRoot: function emitOnRoot(event) {
                    var _$root;
                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }
                    (_$root = this.$root).$emit.apply(_$root, [ event ].concat(_toConsumableArray(args)));
                    return this;
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (this[BVRL] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["b"])(this[BVRL])) {
                    while (this[BVRL].length > 0) {
                        var _BVRL$shift = this[BVRL].shift(), event = _BVRL$shift.event, callback = _BVRL$shift.callback;
                        this.$root.$off(event, callback);
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = observeDOM;
        var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        function observeDOM(el, callback, opts) {
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            var eventListenerSupported = window.addEventListener;
            el = el ? el.$el || el : null;
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["n"])(el)) {
                return null;
            }
            var obs = null;
            if (MutationObserver) {
                obs = new MutationObserver(function(mutations) {
                    var changed = false;
                    for (var i = 0; i < mutations.length && !changed; i++) {
                        var mutation = mutations[i];
                        var type = mutation.type;
                        var target = mutation.target;
                        if (type === "characterData" && target.nodeType === Node.TEXT_NODE) {
                            changed = true;
                        } else if (type === "attributes") {
                            changed = true;
                        } else if (type === "childList" && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
                            changed = true;
                        }
                    }
                    if (changed) {
                        callback();
                    }
                });
                obs.observe(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["a"])({
                    childList: true,
                    subtree: true
                }, opts));
            } else if (eventListenerSupported) {
                el.addEventListener("DOMNodeInserted", callback, false);
                el.addEventListener("DOMNodeRemoved", callback, false);
            }
            return obs;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        (function(global) {
            /**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.3
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
            var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
            var longerTimeoutBrowsers = [ "Edge", "Trident", "Firefox" ];
            var timeoutDuration = 0;
            for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
                if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
                    timeoutDuration = 1;
                    break;
                }
            }
            function microtaskDebounce(fn) {
                var called = false;
                return function() {
                    if (called) {
                        return;
                    }
                    called = true;
                    window.Promise.resolve().then(function() {
                        called = false;
                        fn();
                    });
                };
            }
            function taskDebounce(fn) {
                var scheduled = false;
                return function() {
                    if (!scheduled) {
                        scheduled = true;
                        setTimeout(function() {
                            scheduled = false;
                            fn();
                        }, timeoutDuration);
                    }
                };
            }
            var supportsMicroTasks = isBrowser && window.Promise;
            var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
            function isFunction(functionToCheck) {
                var getType = {};
                return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
            }
            function getStyleComputedProperty(element, property) {
                if (element.nodeType !== 1) {
                    return [];
                }
                var css = getComputedStyle(element, null);
                return property ? css[property] : css;
            }
            function getParentNode(element) {
                if (element.nodeName === "HTML") {
                    return element;
                }
                return element.parentNode || element.host;
            }
            function getScrollParent(element) {
                if (!element) {
                    return document.body;
                }
                switch (element.nodeName) {
                  case "HTML":
                  case "BODY":
                    return element.ownerDocument.body;

                  case "#document":
                    return element.body;
                }
                var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
                if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
                    return element;
                }
                return getScrollParent(getParentNode(element));
            }
            var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
            var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
            function isIE(version) {
                if (version === 11) {
                    return isIE11;
                }
                if (version === 10) {
                    return isIE10;
                }
                return isIE11 || isIE10;
            }
            function getOffsetParent(element) {
                if (!element) {
                    return document.documentElement;
                }
                var noOffsetParent = isIE(10) ? document.body : null;
                var offsetParent = element.offsetParent;
                while (offsetParent === noOffsetParent && element.nextElementSibling) {
                    offsetParent = (element = element.nextElementSibling).offsetParent;
                }
                var nodeName = offsetParent && offsetParent.nodeName;
                if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
                    return element ? element.ownerDocument.documentElement : document.documentElement;
                }
                if ([ "TD", "TABLE" ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") {
                    return getOffsetParent(offsetParent);
                }
                return offsetParent;
            }
            function isOffsetContainer(element) {
                var nodeName = element.nodeName;
                if (nodeName === "BODY") {
                    return false;
                }
                return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
            }
            function getRoot(node) {
                if (node.parentNode !== null) {
                    return getRoot(node.parentNode);
                }
                return node;
            }
            function findCommonOffsetParent(element1, element2) {
                if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
                    return document.documentElement;
                }
                var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
                var start = order ? element1 : element2;
                var end = order ? element2 : element1;
                var range = document.createRange();
                range.setStart(start, 0);
                range.setEnd(end, 0);
                var commonAncestorContainer = range.commonAncestorContainer;
                if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
                    if (isOffsetContainer(commonAncestorContainer)) {
                        return commonAncestorContainer;
                    }
                    return getOffsetParent(commonAncestorContainer);
                }
                var element1root = getRoot(element1);
                if (element1root.host) {
                    return findCommonOffsetParent(element1root.host, element2);
                } else {
                    return findCommonOffsetParent(element1, getRoot(element2).host);
                }
            }
            function getScroll(element) {
                var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
                var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
                var nodeName = element.nodeName;
                if (nodeName === "BODY" || nodeName === "HTML") {
                    var html = element.ownerDocument.documentElement;
                    var scrollingElement = element.ownerDocument.scrollingElement || html;
                    return scrollingElement[upperSide];
                }
                return element[upperSide];
            }
            function includeScroll(rect, element) {
                var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var scrollTop = getScroll(element, "top");
                var scrollLeft = getScroll(element, "left");
                var modifier = subtract ? -1 : 1;
                rect.top += scrollTop * modifier;
                rect.bottom += scrollTop * modifier;
                rect.left += scrollLeft * modifier;
                rect.right += scrollLeft * modifier;
                return rect;
            }
            function getBordersSize(styles, axis) {
                var sideA = axis === "x" ? "Left" : "Top";
                var sideB = sideA === "Left" ? "Right" : "Bottom";
                return parseFloat(styles["border" + sideA + "Width"], 10) + parseFloat(styles["border" + sideB + "Width"], 10);
            }
            function getSize(axis, body, html, computedStyle) {
                return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? html["offset" + axis] + computedStyle["margin" + (axis === "Height" ? "Top" : "Left")] + computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")] : 0);
            }
            function getWindowSizes() {
                var body = document.body;
                var html = document.documentElement;
                var computedStyle = isIE(10) && getComputedStyle(html);
                return {
                    height: getSize("Height", body, html, computedStyle),
                    width: getSize("Width", body, html, computedStyle)
                };
            }
            var classCallCheck = function(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            };
            var createClass = function() {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var defineProperty = function(obj, key, value) {
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            };
            var _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            };
            function getClientRect(offsets) {
                return _extends({}, offsets, {
                    right: offsets.left + offsets.width,
                    bottom: offsets.top + offsets.height
                });
            }
            function getBoundingClientRect(element) {
                var rect = {};
                try {
                    if (isIE(10)) {
                        rect = element.getBoundingClientRect();
                        var scrollTop = getScroll(element, "top");
                        var scrollLeft = getScroll(element, "left");
                        rect.top += scrollTop;
                        rect.left += scrollLeft;
                        rect.bottom += scrollTop;
                        rect.right += scrollLeft;
                    } else {
                        rect = element.getBoundingClientRect();
                    }
                } catch (e) {}
                var result = {
                    left: rect.left,
                    top: rect.top,
                    width: rect.right - rect.left,
                    height: rect.bottom - rect.top
                };
                var sizes = element.nodeName === "HTML" ? getWindowSizes() : {};
                var width = sizes.width || element.clientWidth || result.right - result.left;
                var height = sizes.height || element.clientHeight || result.bottom - result.top;
                var horizScrollbar = element.offsetWidth - width;
                var vertScrollbar = element.offsetHeight - height;
                if (horizScrollbar || vertScrollbar) {
                    var styles = getStyleComputedProperty(element);
                    horizScrollbar -= getBordersSize(styles, "x");
                    vertScrollbar -= getBordersSize(styles, "y");
                    result.width -= horizScrollbar;
                    result.height -= vertScrollbar;
                }
                return getClientRect(result);
            }
            function getOffsetRectRelativeToArbitraryNode(children, parent) {
                var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var isIE10 = isIE(10);
                var isHTML = parent.nodeName === "HTML";
                var childrenRect = getBoundingClientRect(children);
                var parentRect = getBoundingClientRect(parent);
                var scrollParent = getScrollParent(children);
                var styles = getStyleComputedProperty(parent);
                var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
                var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
                if (fixedPosition && parent.nodeName === "HTML") {
                    parentRect.top = Math.max(parentRect.top, 0);
                    parentRect.left = Math.max(parentRect.left, 0);
                }
                var offsets = getClientRect({
                    top: childrenRect.top - parentRect.top - borderTopWidth,
                    left: childrenRect.left - parentRect.left - borderLeftWidth,
                    width: childrenRect.width,
                    height: childrenRect.height
                });
                offsets.marginTop = 0;
                offsets.marginLeft = 0;
                if (!isIE10 && isHTML) {
                    var marginTop = parseFloat(styles.marginTop, 10);
                    var marginLeft = parseFloat(styles.marginLeft, 10);
                    offsets.top -= borderTopWidth - marginTop;
                    offsets.bottom -= borderTopWidth - marginTop;
                    offsets.left -= borderLeftWidth - marginLeft;
                    offsets.right -= borderLeftWidth - marginLeft;
                    offsets.marginTop = marginTop;
                    offsets.marginLeft = marginLeft;
                }
                if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") {
                    offsets = includeScroll(offsets, parent);
                }
                return offsets;
            }
            function getViewportOffsetRectRelativeToArtbitraryNode(element) {
                var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var html = element.ownerDocument.documentElement;
                var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
                var width = Math.max(html.clientWidth, window.innerWidth || 0);
                var height = Math.max(html.clientHeight, window.innerHeight || 0);
                var scrollTop = !excludeScroll ? getScroll(html) : 0;
                var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
                var offset = {
                    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
                    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
                    width: width,
                    height: height
                };
                return getClientRect(offset);
            }
            function isFixed(element) {
                var nodeName = element.nodeName;
                if (nodeName === "BODY" || nodeName === "HTML") {
                    return false;
                }
                if (getStyleComputedProperty(element, "position") === "fixed") {
                    return true;
                }
                return isFixed(getParentNode(element));
            }
            function getFixedPositionOffsetParent(element) {
                if (!element || !element.parentElement || isIE()) {
                    return document.documentElement;
                }
                var el = element.parentElement;
                while (el && getStyleComputedProperty(el, "transform") === "none") {
                    el = el.parentElement;
                }
                return el || document.documentElement;
            }
            function getBoundaries(popper, reference, padding, boundariesElement) {
                var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var boundaries = {
                    top: 0,
                    left: 0
                };
                var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
                if (boundariesElement === "viewport") {
                    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
                } else {
                    var boundariesNode = void 0;
                    if (boundariesElement === "scrollParent") {
                        boundariesNode = getScrollParent(getParentNode(reference));
                        if (boundariesNode.nodeName === "BODY") {
                            boundariesNode = popper.ownerDocument.documentElement;
                        }
                    } else if (boundariesElement === "window") {
                        boundariesNode = popper.ownerDocument.documentElement;
                    } else {
                        boundariesNode = boundariesElement;
                    }
                    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
                    if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
                        var _getWindowSizes = getWindowSizes(), height = _getWindowSizes.height, width = _getWindowSizes.width;
                        boundaries.top += offsets.top - offsets.marginTop;
                        boundaries.bottom = height + offsets.top;
                        boundaries.left += offsets.left - offsets.marginLeft;
                        boundaries.right = width + offsets.left;
                    } else {
                        boundaries = offsets;
                    }
                }
                boundaries.left += padding;
                boundaries.top += padding;
                boundaries.right -= padding;
                boundaries.bottom -= padding;
                return boundaries;
            }
            function getArea(_ref) {
                var width = _ref.width, height = _ref.height;
                return width * height;
            }
            function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
                var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
                if (placement.indexOf("auto") === -1) {
                    return placement;
                }
                var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
                var rects = {
                    top: {
                        width: boundaries.width,
                        height: refRect.top - boundaries.top
                    },
                    right: {
                        width: boundaries.right - refRect.right,
                        height: boundaries.height
                    },
                    bottom: {
                        width: boundaries.width,
                        height: boundaries.bottom - refRect.bottom
                    },
                    left: {
                        width: refRect.left - boundaries.left,
                        height: boundaries.height
                    }
                };
                var sortedAreas = Object.keys(rects).map(function(key) {
                    return _extends({
                        key: key
                    }, rects[key], {
                        area: getArea(rects[key])
                    });
                }).sort(function(a, b) {
                    return b.area - a.area;
                });
                var filteredAreas = sortedAreas.filter(function(_ref2) {
                    var width = _ref2.width, height = _ref2.height;
                    return width >= popper.clientWidth && height >= popper.clientHeight;
                });
                var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
                var variation = placement.split("-")[1];
                return computedPlacement + (variation ? "-" + variation : "");
            }
            function getReferenceOffsets(state, popper, reference) {
                var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
                return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
            }
            function getOuterSizes(element) {
                var styles = getComputedStyle(element);
                var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
                var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
                var result = {
                    width: element.offsetWidth + y,
                    height: element.offsetHeight + x
                };
                return result;
            }
            function getOppositePlacement(placement) {
                var hash = {
                    left: "right",
                    right: "left",
                    bottom: "top",
                    top: "bottom"
                };
                return placement.replace(/left|right|bottom|top/g, function(matched) {
                    return hash[matched];
                });
            }
            function getPopperOffsets(popper, referenceOffsets, placement) {
                placement = placement.split("-")[0];
                var popperRect = getOuterSizes(popper);
                var popperOffsets = {
                    width: popperRect.width,
                    height: popperRect.height
                };
                var isHoriz = [ "right", "left" ].indexOf(placement) !== -1;
                var mainSide = isHoriz ? "top" : "left";
                var secondarySide = isHoriz ? "left" : "top";
                var measurement = isHoriz ? "height" : "width";
                var secondaryMeasurement = !isHoriz ? "height" : "width";
                popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
                if (placement === secondarySide) {
                    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
                } else {
                    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
                }
                return popperOffsets;
            }
            function find(arr, check) {
                if (Array.prototype.find) {
                    return arr.find(check);
                }
                return arr.filter(check)[0];
            }
            function findIndex(arr, prop, value) {
                if (Array.prototype.findIndex) {
                    return arr.findIndex(function(cur) {
                        return cur[prop] === value;
                    });
                }
                var match = find(arr, function(obj) {
                    return obj[prop] === value;
                });
                return arr.indexOf(match);
            }
            function runModifiers(modifiers, data, ends) {
                var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, "name", ends));
                modifiersToRun.forEach(function(modifier) {
                    if (modifier["function"]) {
                        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                    }
                    var fn = modifier["function"] || modifier.fn;
                    if (modifier.enabled && isFunction(fn)) {
                        data.offsets.popper = getClientRect(data.offsets.popper);
                        data.offsets.reference = getClientRect(data.offsets.reference);
                        data = fn(data, modifier);
                    }
                });
                return data;
            }
            function update() {
                if (this.state.isDestroyed) {
                    return;
                }
                var data = {
                    instance: this,
                    styles: {},
                    arrowStyles: {},
                    attributes: {},
                    flipped: false,
                    offsets: {}
                };
                data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
                data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
                data.originalPlacement = data.placement;
                data.positionFixed = this.options.positionFixed;
                data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
                data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
                data = runModifiers(this.modifiers, data);
                if (!this.state.isCreated) {
                    this.state.isCreated = true;
                    this.options.onCreate(data);
                } else {
                    this.options.onUpdate(data);
                }
            }
            function isModifierEnabled(modifiers, modifierName) {
                return modifiers.some(function(_ref) {
                    var name = _ref.name, enabled = _ref.enabled;
                    return enabled && name === modifierName;
                });
            }
            function getSupportedPropertyName(property) {
                var prefixes = [ false, "ms", "Webkit", "Moz", "O" ];
                var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
                for (var i = 0; i < prefixes.length; i++) {
                    var prefix = prefixes[i];
                    var toCheck = prefix ? "" + prefix + upperProp : property;
                    if (typeof document.body.style[toCheck] !== "undefined") {
                        return toCheck;
                    }
                }
                return null;
            }
            function destroy() {
                this.state.isDestroyed = true;
                if (isModifierEnabled(this.modifiers, "applyStyle")) {
                    this.popper.removeAttribute("x-placement");
                    this.popper.style.position = "";
                    this.popper.style.top = "";
                    this.popper.style.left = "";
                    this.popper.style.right = "";
                    this.popper.style.bottom = "";
                    this.popper.style.willChange = "";
                    this.popper.style[getSupportedPropertyName("transform")] = "";
                }
                this.disableEventListeners();
                if (this.options.removeOnDestroy) {
                    this.popper.parentNode.removeChild(this.popper);
                }
                return this;
            }
            function getWindow(element) {
                var ownerDocument = element.ownerDocument;
                return ownerDocument ? ownerDocument.defaultView : window;
            }
            function attachToScrollParents(scrollParent, event, callback, scrollParents) {
                var isBody = scrollParent.nodeName === "BODY";
                var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
                target.addEventListener(event, callback, {
                    passive: true
                });
                if (!isBody) {
                    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
                }
                scrollParents.push(target);
            }
            function setupEventListeners(reference, options, state, updateBound) {
                state.updateBound = updateBound;
                getWindow(reference).addEventListener("resize", state.updateBound, {
                    passive: true
                });
                var scrollElement = getScrollParent(reference);
                attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
                state.scrollElement = scrollElement;
                state.eventsEnabled = true;
                return state;
            }
            function enableEventListeners() {
                if (!this.state.eventsEnabled) {
                    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
                }
            }
            function removeEventListeners(reference, state) {
                getWindow(reference).removeEventListener("resize", state.updateBound);
                state.scrollParents.forEach(function(target) {
                    target.removeEventListener("scroll", state.updateBound);
                });
                state.updateBound = null;
                state.scrollParents = [];
                state.scrollElement = null;
                state.eventsEnabled = false;
                return state;
            }
            function disableEventListeners() {
                if (this.state.eventsEnabled) {
                    cancelAnimationFrame(this.scheduleUpdate);
                    this.state = removeEventListeners(this.reference, this.state);
                }
            }
            function isNumeric(n) {
                return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
            }
            function setStyles(element, styles) {
                Object.keys(styles).forEach(function(prop) {
                    var unit = "";
                    if ([ "width", "height", "top", "right", "bottom", "left" ].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
                        unit = "px";
                    }
                    element.style[prop] = styles[prop] + unit;
                });
            }
            function setAttributes(element, attributes) {
                Object.keys(attributes).forEach(function(prop) {
                    var value = attributes[prop];
                    if (value !== false) {
                        element.setAttribute(prop, attributes[prop]);
                    } else {
                        element.removeAttribute(prop);
                    }
                });
            }
            function applyStyle(data) {
                setStyles(data.instance.popper, data.styles);
                setAttributes(data.instance.popper, data.attributes);
                if (data.arrowElement && Object.keys(data.arrowStyles).length) {
                    setStyles(data.arrowElement, data.arrowStyles);
                }
                return data;
            }
            function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
                var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
                var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
                popper.setAttribute("x-placement", placement);
                setStyles(popper, {
                    position: options.positionFixed ? "fixed" : "absolute"
                });
                return options;
            }
            function computeStyle(data, options) {
                var x = options.x, y = options.y;
                var popper = data.offsets.popper;
                var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
                    return modifier.name === "applyStyle";
                }).gpuAcceleration;
                if (legacyGpuAccelerationOption !== undefined) {
                    console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                }
                var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
                var offsetParent = getOffsetParent(data.instance.popper);
                var offsetParentRect = getBoundingClientRect(offsetParent);
                var styles = {
                    position: popper.position
                };
                var offsets = {
                    left: Math.floor(popper.left),
                    top: Math.round(popper.top),
                    bottom: Math.round(popper.bottom),
                    right: Math.floor(popper.right)
                };
                var sideA = x === "bottom" ? "top" : "bottom";
                var sideB = y === "right" ? "left" : "right";
                var prefixedProperty = getSupportedPropertyName("transform");
                var left = void 0, top = void 0;
                if (sideA === "bottom") {
                    top = -offsetParentRect.height + offsets.bottom;
                } else {
                    top = offsets.top;
                }
                if (sideB === "right") {
                    left = -offsetParentRect.width + offsets.right;
                } else {
                    left = offsets.left;
                }
                if (gpuAcceleration && prefixedProperty) {
                    styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
                    styles[sideA] = 0;
                    styles[sideB] = 0;
                    styles.willChange = "transform";
                } else {
                    var invertTop = sideA === "bottom" ? -1 : 1;
                    var invertLeft = sideB === "right" ? -1 : 1;
                    styles[sideA] = top * invertTop;
                    styles[sideB] = left * invertLeft;
                    styles.willChange = sideA + ", " + sideB;
                }
                var attributes = {
                    "x-placement": data.placement
                };
                data.attributes = _extends({}, attributes, data.attributes);
                data.styles = _extends({}, styles, data.styles);
                data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
                return data;
            }
            function isModifierRequired(modifiers, requestingName, requestedName) {
                var requesting = find(modifiers, function(_ref) {
                    var name = _ref.name;
                    return name === requestingName;
                });
                var isRequired = !!requesting && modifiers.some(function(modifier) {
                    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
                });
                if (!isRequired) {
                    var _requesting = "`" + requestingName + "`";
                    var requested = "`" + requestedName + "`";
                    console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
                }
                return isRequired;
            }
            function arrow(data, options) {
                var _data$offsets$arrow;
                if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
                    return data;
                }
                var arrowElement = options.element;
                if (typeof arrowElement === "string") {
                    arrowElement = data.instance.popper.querySelector(arrowElement);
                    if (!arrowElement) {
                        return data;
                    }
                } else {
                    if (!data.instance.popper.contains(arrowElement)) {
                        console.warn("WARNING: `arrow.element` must be child of its popper element!");
                        return data;
                    }
                }
                var placement = data.placement.split("-")[0];
                var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
                var isVertical = [ "left", "right" ].indexOf(placement) !== -1;
                var len = isVertical ? "height" : "width";
                var sideCapitalized = isVertical ? "Top" : "Left";
                var side = sideCapitalized.toLowerCase();
                var altSide = isVertical ? "left" : "top";
                var opSide = isVertical ? "bottom" : "right";
                var arrowElementSize = getOuterSizes(arrowElement)[len];
                if (reference[opSide] - arrowElementSize < popper[side]) {
                    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
                }
                if (reference[side] + arrowElementSize > popper[opSide]) {
                    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
                }
                data.offsets.popper = getClientRect(data.offsets.popper);
                var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
                var css = getStyleComputedProperty(data.instance.popper);
                var popperMarginSide = parseFloat(css["margin" + sideCapitalized], 10);
                var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"], 10);
                var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
                sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
                data.arrowElement = arrowElement;
                data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), 
                defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
                return data;
            }
            function getOppositeVariation(variation) {
                if (variation === "end") {
                    return "start";
                } else if (variation === "start") {
                    return "end";
                }
                return variation;
            }
            var placements = [ "auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start" ];
            var validPlacements = placements.slice(3);
            function clockwise(placement) {
                var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var index = validPlacements.indexOf(placement);
                var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
                return counter ? arr.reverse() : arr;
            }
            var BEHAVIORS = {
                FLIP: "flip",
                CLOCKWISE: "clockwise",
                COUNTERCLOCKWISE: "counterclockwise"
            };
            function flip(data, options) {
                if (isModifierEnabled(data.instance.modifiers, "inner")) {
                    return data;
                }
                if (data.flipped && data.placement === data.originalPlacement) {
                    return data;
                }
                var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
                var placement = data.placement.split("-")[0];
                var placementOpposite = getOppositePlacement(placement);
                var variation = data.placement.split("-")[1] || "";
                var flipOrder = [];
                switch (options.behavior) {
                  case BEHAVIORS.FLIP:
                    flipOrder = [ placement, placementOpposite ];
                    break;

                  case BEHAVIORS.CLOCKWISE:
                    flipOrder = clockwise(placement);
                    break;

                  case BEHAVIORS.COUNTERCLOCKWISE:
                    flipOrder = clockwise(placement, true);
                    break;

                  default:
                    flipOrder = options.behavior;
                }
                flipOrder.forEach(function(step, index) {
                    if (placement !== step || flipOrder.length === index + 1) {
                        return data;
                    }
                    placement = data.placement.split("-")[0];
                    placementOpposite = getOppositePlacement(placement);
                    var popperOffsets = data.offsets.popper;
                    var refOffsets = data.offsets.reference;
                    var floor = Math.floor;
                    var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
                    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
                    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
                    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
                    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
                    var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
                    var isVertical = [ "top", "bottom" ].indexOf(placement) !== -1;
                    var flippedVariation = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
                    if (overlapsRef || overflowsBoundaries || flippedVariation) {
                        data.flipped = true;
                        if (overlapsRef || overflowsBoundaries) {
                            placement = flipOrder[index + 1];
                        }
                        if (flippedVariation) {
                            variation = getOppositeVariation(variation);
                        }
                        data.placement = placement + (variation ? "-" + variation : "");
                        data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
                        data = runModifiers(data.instance.modifiers, data, "flip");
                    }
                });
                return data;
            }
            function keepTogether(data) {
                var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
                var placement = data.placement.split("-")[0];
                var floor = Math.floor;
                var isVertical = [ "top", "bottom" ].indexOf(placement) !== -1;
                var side = isVertical ? "right" : "bottom";
                var opSide = isVertical ? "left" : "top";
                var measurement = isVertical ? "width" : "height";
                if (popper[side] < floor(reference[opSide])) {
                    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
                }
                if (popper[opSide] > floor(reference[side])) {
                    data.offsets.popper[opSide] = floor(reference[side]);
                }
                return data;
            }
            function toValue(str, measurement, popperOffsets, referenceOffsets) {
                var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
                var value = +split[1];
                var unit = split[2];
                if (!value) {
                    return str;
                }
                if (unit.indexOf("%") === 0) {
                    var element = void 0;
                    switch (unit) {
                      case "%p":
                        element = popperOffsets;
                        break;

                      case "%":
                      case "%r":
                      default:
                        element = referenceOffsets;
                    }
                    var rect = getClientRect(element);
                    return rect[measurement] / 100 * value;
                } else if (unit === "vh" || unit === "vw") {
                    var size = void 0;
                    if (unit === "vh") {
                        size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                    } else {
                        size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    }
                    return size / 100 * value;
                } else {
                    return value;
                }
            }
            function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
                var offsets = [ 0, 0 ];
                var useHeight = [ "right", "left" ].indexOf(basePlacement) !== -1;
                var fragments = offset.split(/(\+|\-)/).map(function(frag) {
                    return frag.trim();
                });
                var divider = fragments.indexOf(find(fragments, function(frag) {
                    return frag.search(/,|\s/) !== -1;
                }));
                if (fragments[divider] && fragments[divider].indexOf(",") === -1) {
                    console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                }
                var splitRegex = /\s*,\s*|\s+/;
                var ops = divider !== -1 ? [ fragments.slice(0, divider).concat([ fragments[divider].split(splitRegex)[0] ]), [ fragments[divider].split(splitRegex)[1] ].concat(fragments.slice(divider + 1)) ] : [ fragments ];
                ops = ops.map(function(op, index) {
                    var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
                    var mergeWithPrevious = false;
                    return op.reduce(function(a, b) {
                        if (a[a.length - 1] === "" && [ "+", "-" ].indexOf(b) !== -1) {
                            a[a.length - 1] = b;
                            mergeWithPrevious = true;
                            return a;
                        } else if (mergeWithPrevious) {
                            a[a.length - 1] += b;
                            mergeWithPrevious = false;
                            return a;
                        } else {
                            return a.concat(b);
                        }
                    }, []).map(function(str) {
                        return toValue(str, measurement, popperOffsets, referenceOffsets);
                    });
                });
                ops.forEach(function(op, index) {
                    op.forEach(function(frag, index2) {
                        if (isNumeric(frag)) {
                            offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
                        }
                    });
                });
                return offsets;
            }
            function offset(data, _ref) {
                var offset = _ref.offset;
                var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
                var basePlacement = placement.split("-")[0];
                var offsets = void 0;
                if (isNumeric(+offset)) {
                    offsets = [ +offset, 0 ];
                } else {
                    offsets = parseOffset(offset, popper, reference, basePlacement);
                }
                if (basePlacement === "left") {
                    popper.top += offsets[0];
                    popper.left -= offsets[1];
                } else if (basePlacement === "right") {
                    popper.top += offsets[0];
                    popper.left += offsets[1];
                } else if (basePlacement === "top") {
                    popper.left += offsets[0];
                    popper.top -= offsets[1];
                } else if (basePlacement === "bottom") {
                    popper.left += offsets[0];
                    popper.top += offsets[1];
                }
                data.popper = popper;
                return data;
            }
            function preventOverflow(data, options) {
                var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
                if (data.instance.reference === boundariesElement) {
                    boundariesElement = getOffsetParent(boundariesElement);
                }
                var transformProp = getSupportedPropertyName("transform");
                var popperStyles = data.instance.popper.style;
                var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
                popperStyles.top = "";
                popperStyles.left = "";
                popperStyles[transformProp] = "";
                var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
                popperStyles.top = top;
                popperStyles.left = left;
                popperStyles[transformProp] = transform;
                options.boundaries = boundaries;
                var order = options.priority;
                var popper = data.offsets.popper;
                var check = {
                    primary: function primary(placement) {
                        var value = popper[placement];
                        if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
                            value = Math.max(popper[placement], boundaries[placement]);
                        }
                        return defineProperty({}, placement, value);
                    },
                    secondary: function secondary(placement) {
                        var mainSide = placement === "right" ? "left" : "top";
                        var value = popper[mainSide];
                        if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
                            value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
                        }
                        return defineProperty({}, mainSide, value);
                    }
                };
                order.forEach(function(placement) {
                    var side = [ "left", "top" ].indexOf(placement) !== -1 ? "primary" : "secondary";
                    popper = _extends({}, popper, check[side](placement));
                });
                data.offsets.popper = popper;
                return data;
            }
            function shift(data) {
                var placement = data.placement;
                var basePlacement = placement.split("-")[0];
                var shiftvariation = placement.split("-")[1];
                if (shiftvariation) {
                    var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
                    var isVertical = [ "bottom", "top" ].indexOf(basePlacement) !== -1;
                    var side = isVertical ? "left" : "top";
                    var measurement = isVertical ? "width" : "height";
                    var shiftOffsets = {
                        start: defineProperty({}, side, reference[side]),
                        end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
                    };
                    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
                }
                return data;
            }
            function hide(data) {
                if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) {
                    return data;
                }
                var refRect = data.offsets.reference;
                var bound = find(data.instance.modifiers, function(modifier) {
                    return modifier.name === "preventOverflow";
                }).boundaries;
                if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
                    if (data.hide === true) {
                        return data;
                    }
                    data.hide = true;
                    data.attributes["x-out-of-boundaries"] = "";
                } else {
                    if (data.hide === false) {
                        return data;
                    }
                    data.hide = false;
                    data.attributes["x-out-of-boundaries"] = false;
                }
                return data;
            }
            function inner(data) {
                var placement = data.placement;
                var basePlacement = placement.split("-")[0];
                var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
                var isHoriz = [ "left", "right" ].indexOf(basePlacement) !== -1;
                var subtractLength = [ "top", "left" ].indexOf(basePlacement) === -1;
                popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
                data.placement = getOppositePlacement(placement);
                data.offsets.popper = getClientRect(popper);
                return data;
            }
            var modifiers = {
                shift: {
                    order: 100,
                    enabled: true,
                    fn: shift
                },
                offset: {
                    order: 200,
                    enabled: true,
                    fn: offset,
                    offset: 0
                },
                preventOverflow: {
                    order: 300,
                    enabled: true,
                    fn: preventOverflow,
                    priority: [ "left", "right", "top", "bottom" ],
                    padding: 5,
                    boundariesElement: "scrollParent"
                },
                keepTogether: {
                    order: 400,
                    enabled: true,
                    fn: keepTogether
                },
                arrow: {
                    order: 500,
                    enabled: true,
                    fn: arrow,
                    element: "[x-arrow]"
                },
                flip: {
                    order: 600,
                    enabled: true,
                    fn: flip,
                    behavior: "flip",
                    padding: 5,
                    boundariesElement: "viewport"
                },
                inner: {
                    order: 700,
                    enabled: false,
                    fn: inner
                },
                hide: {
                    order: 800,
                    enabled: true,
                    fn: hide
                },
                computeStyle: {
                    order: 850,
                    enabled: true,
                    fn: computeStyle,
                    gpuAcceleration: true,
                    x: "bottom",
                    y: "right"
                },
                applyStyle: {
                    order: 900,
                    enabled: true,
                    fn: applyStyle,
                    onLoad: applyStyleOnLoad,
                    gpuAcceleration: undefined
                }
            };
            var Defaults = {
                placement: "bottom",
                positionFixed: false,
                eventsEnabled: true,
                removeOnDestroy: false,
                onCreate: function onCreate() {},
                onUpdate: function onUpdate() {},
                modifiers: modifiers
            };
            var Popper = function() {
                function Popper(reference, popper) {
                    var _this = this;
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    classCallCheck(this, Popper);
                    this.scheduleUpdate = function() {
                        return requestAnimationFrame(_this.update);
                    };
                    this.update = debounce(this.update.bind(this));
                    this.options = _extends({}, Popper.Defaults, options);
                    this.state = {
                        isDestroyed: false,
                        isCreated: false,
                        scrollParents: []
                    };
                    this.reference = reference && reference.jquery ? reference[0] : reference;
                    this.popper = popper && popper.jquery ? popper[0] : popper;
                    this.options.modifiers = {};
                    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
                        _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
                    });
                    this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
                        return _extends({
                            name: name
                        }, _this.options.modifiers[name]);
                    }).sort(function(a, b) {
                        return a.order - b.order;
                    });
                    this.modifiers.forEach(function(modifierOptions) {
                        if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
                            modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
                        }
                    });
                    this.update();
                    var eventsEnabled = this.options.eventsEnabled;
                    if (eventsEnabled) {
                        this.enableEventListeners();
                    }
                    this.state.eventsEnabled = eventsEnabled;
                }
                createClass(Popper, [ {
                    key: "update",
                    value: function update$$1() {
                        return update.call(this);
                    }
                }, {
                    key: "destroy",
                    value: function destroy$$1() {
                        return destroy.call(this);
                    }
                }, {
                    key: "enableEventListeners",
                    value: function enableEventListeners$$1() {
                        return enableEventListeners.call(this);
                    }
                }, {
                    key: "disableEventListeners",
                    value: function disableEventListeners$$1() {
                        return disableEventListeners.call(this);
                    }
                } ]);
                return Popper;
            }();
            Popper.Utils = (typeof window !== "undefined" ? window : global).PopperUtils;
            Popper.placements = placements;
            Popper.Defaults = Defaults;
            __webpack_exports__["a"] = Popper;
        }).call(__webpack_exports__, __webpack_require__(13));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            disabled: {
                type: Boolean,
                default: false
            },
            ariaLabel: {
                type: String,
                default: "Close"
            },
            textVariant: {
                type: String,
                default: null
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, listeners = _ref.listeners, slots = _ref.slots;
                var componentData = {
                    staticClass: "close",
                    class: _defineProperty({}, "text-" + props.textVariant, props.textVariant),
                    attrs: {
                        type: "button",
                        disabled: props.disabled,
                        "aria-label": props.ariaLabel ? String(props.ariaLabel) : null
                    },
                    on: {
                        click: function click(e) {
                            if (props.disabled && e instanceof Event) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }
                    }
                };
                if (!slots().default) {
                    componentData.domProps = {
                        innerHTML: "&times;"
                    };
                }
                return h("button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), slots().default);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_5__link_link__ = __webpack_require__(6);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var btnProps = {
            block: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: null
            },
            variant: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: "button"
            },
            pressed: {
                type: Boolean,
                default: null
            }
        };
        var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__link_link__["c"])();
        delete linkProps.href.default;
        delete linkProps.to.default;
        var linkPropKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b"])(linkProps);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])(linkProps, btnProps);
        function handleFocus(evt) {
            if (evt.type === "focusin") {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["d"])(evt.target, "focus");
            } else if (evt.type === "focusout") {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["e"])(evt.target, "focus");
            }
        }
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, listeners = _ref.listeners, children = _ref.children;
                var isLink = Boolean(props.href || props.to);
                var isToggle = typeof props.pressed === "boolean";
                var on = {
                    click: function click(e) {
                        if (props.disabled && e instanceof Event) {
                            e.stopPropagation();
                            e.preventDefault();
                        } else if (isToggle) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c"])(listeners["update:pressed"]).forEach(function(fn) {
                                if (typeof fn === "function") {
                                    fn(!props.pressed);
                                }
                            });
                        }
                    }
                };
                if (isToggle) {
                    on.focusin = handleFocus;
                    on.focusout = handleFocus;
                }
                var componentData = {
                    staticClass: "btn",
                    class: [ props.variant ? "btn-" + props.variant : "btn-secondary", (_ref2 = {}, 
                    _defineProperty(_ref2, "btn-" + props.size, Boolean(props.size)), _defineProperty(_ref2, "btn-block", props.block), 
                    _defineProperty(_ref2, "disabled", props.disabled), _defineProperty(_ref2, "active", props.pressed), 
                    _ref2) ],
                    props: isLink ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a"])(linkPropKeys, props) : null,
                    attrs: {
                        type: isLink ? null : props.type,
                        disabled: isLink ? null : props.disabled,
                        "data-toggle": isToggle ? "button" : null,
                        "aria-pressed": isToggle ? String(props.pressed) : null,
                        tabindex: props.disabled && isLink ? "-1" : data.attrs ? data.attrs["tabindex"] : null
                    },
                    on: on
                };
                return h(isLink ? __WEBPACK_IMPORTED_MODULE_5__link_link__["a"] : "button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__dropdown__ = __webpack_require__(84);
        var __WEBPACK_IMPORTED_MODULE_1__dropdown_item__ = __webpack_require__(83);
        var __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__ = __webpack_require__(82);
        var __WEBPACK_IMPORTED_MODULE_3__dropdown_header__ = __webpack_require__(81);
        var __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__ = __webpack_require__(80);
        var __WEBPACK_IMPORTED_MODULE_5__utils_plugins__ = __webpack_require__(1);
        var components = {
            bDropdown: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a"],
            bDd: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a"],
            bDropdownItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a"],
            bDdItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a"],
            bDropdownItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a"],
            bDropdownItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a"],
            bDdItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a"],
            bDdItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a"],
            bDropdownHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a"],
            bDdHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a"],
            bDropdownDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a"],
            bDdDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var BLANK_TEMPLATE = '<svg width="%{w}" height="%{h}" ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'viewBox="0 0 %{w} %{h}" preserveAspectRatio="none">' + '<rect width="100%" height="100%" style="fill:%{f};"></rect>' + "</svg>";
        function makeBlankImgSrc(width, height, color) {
            var src = encodeURIComponent(BLANK_TEMPLATE.replace("%{w}", String(width)).replace("%{h}", String(height)).replace("%{f}", color));
            return "data:image/svg+xml;charset=UTF-8," + src;
        }
        var props = {
            src: {
                type: String,
                default: null
            },
            alt: {
                type: String,
                default: null
            },
            width: {
                type: [ Number, String ],
                default: null
            },
            height: {
                type: [ Number, String ],
                default: null
            },
            block: {
                type: Boolean,
                default: false
            },
            fluid: {
                type: Boolean,
                default: false
            },
            fluidGrow: {
                type: Boolean,
                default: false
            },
            rounded: {
                type: [ Boolean, String ],
                default: false
            },
            thumbnail: {
                type: Boolean,
                default: false
            },
            left: {
                type: Boolean,
                default: false
            },
            right: {
                type: Boolean,
                default: false
            },
            center: {
                type: Boolean,
                default: false
            },
            blank: {
                type: Boolean,
                default: false
            },
            blankColor: {
                type: String,
                default: "transparent"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data;
                var src = props.src;
                var width = parseInt(props.width, 10) ? parseInt(props.width, 10) : null;
                var height = parseInt(props.height, 10) ? parseInt(props.height, 10) : null;
                var align = null;
                var block = props.block;
                if (props.blank) {
                    if (!height && Boolean(width)) {
                        height = width;
                    } else if (!width && Boolean(height)) {
                        width = height;
                    }
                    if (!width && !height) {
                        width = 1;
                        height = 1;
                    }
                    src = makeBlankImgSrc(width, height, props.blankColor || "transparent");
                }
                if (props.left) {
                    align = "float-left";
                } else if (props.right) {
                    align = "float-right";
                } else if (props.center) {
                    align = "mx-auto";
                    block = true;
                }
                return h("img", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    attrs: {
                        src: src,
                        alt: props.alt,
                        width: width ? String(width) : null,
                        height: height ? String(height) : null
                    },
                    class: (_class = {
                        "img-thumbnail": props.thumbnail,
                        "img-fluid": props.fluid || props.fluidGrow,
                        "w-100": props.fluidGrow,
                        rounded: props.rounded === "" || props.rounded === true
                    }, _defineProperty(_class, "rounded-" + props.rounded, typeof props.rounded === "string" && props.rounded !== ""), 
                    _defineProperty(_class, align, Boolean(align)), _defineProperty(_class, "d-block", block), 
                    _class)
                }));
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return propsFactory;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__input_group_text__ = __webpack_require__(23);
        var propsFactory = function propsFactory(append) {
            return {
                id: {
                    type: String,
                    default: null
                },
                tag: {
                    type: String,
                    default: "div"
                },
                append: {
                    type: Boolean,
                    default: append
                },
                isText: {
                    type: Boolean,
                    default: false
                }
            };
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: propsFactory(false),
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group-" + (props.append ? "append" : "prepend"),
                    attrs: {
                        id: props.id
                    }
                }), props.isText ? [ h(__WEBPACK_IMPORTED_MODULE_1__input_group_text__["a"], children) ] : children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            }
        };
        __webpack_exports__["a"] = {
            props: props,
            functional: true,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group-text"
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "form-row"
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            props: {
                tag: {
                    type: String,
                    default: "div"
                },
                bgVariant: {
                    type: String,
                    default: null
                },
                borderVariant: {
                    type: String,
                    default: null
                },
                textVariant: {
                    type: String,
                    default: null
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = copyProps;
        var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(156);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function copyProps(props) {
            var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__identity__["a"];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["b"])(props)) {
                return props.map(transformFn);
            }
            var copied = {};
            for (var prop in props) {
                if (props.hasOwnProperty(prop)) {
                    if ((typeof prop === "undefined" ? "undefined" : _typeof(prop)) === "object") {
                        copied[transformFn(prop)] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["a"])({}, props[prop]);
                    } else {
                        copied[transformFn(prop)] = props[prop];
                    }
                }
            }
            return copied;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = prefixPropName;
        var __WEBPACK_IMPORTED_MODULE_0__upper_first__ = __webpack_require__(159);
        function prefixPropName(prefix, value) {
            return prefix + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__upper_first__["a"])(value);
        }
    }, function(module, exports) {
        module.exports = function normalizeComponent(rawScriptExports, compiledTemplate, functionalTemplate, injectStyles, scopeId, moduleIdentifier) {
            var esModule;
            var scriptExports = rawScriptExports = rawScriptExports || {};
            var type = typeof rawScriptExports.default;
            if (type === "object" || type === "function") {
                esModule = rawScriptExports;
                scriptExports = rawScriptExports.default;
            }
            var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
            if (compiledTemplate) {
                options.render = compiledTemplate.render;
                options.staticRenderFns = compiledTemplate.staticRenderFns;
                options._compiled = true;
            }
            if (functionalTemplate) {
                options.functional = true;
            }
            if (scopeId) {
                options._scopeId = scopeId;
            }
            var hook;
            if (moduleIdentifier) {
                hook = function(context) {
                    context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
                    if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
                        context = __VUE_SSR_CONTEXT__;
                    }
                    if (injectStyles) {
                        injectStyles.call(this, context);
                    }
                    if (context && context._registeredComponents) {
                        context._registeredComponents.add(moduleIdentifier);
                    }
                };
                options._ssrRegister = hook;
            } else if (injectStyles) {
                hook = injectStyles;
            }
            if (hook) {
                var functional = options.functional;
                var existing = functional ? options.render : options.beforeCreate;
                if (!functional) {
                    options.beforeCreate = existing ? [].concat(existing, hook) : [ hook ];
                } else {
                    options._injectStyles = hook;
                    options.render = function renderWithStyleInjection(h, context) {
                        hook.call(context);
                        return existing(h, context);
                    };
                }
            }
            return {
                esModule: esModule,
                exports: scriptExports,
                options: options
            };
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(30);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a"])({}, __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["b"], {
            text: {
                type: String,
                default: null
            },
            href: {
                type: String,
                default: null
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h("li", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "breadcrumb-item",
                    class: {
                        active: props.active
                    },
                    attrs: {
                        role: "presentation"
                    }
                }), [ h(__WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["a"], {
                    props: props
                }, children) ]);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return props;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__link_link__ = __webpack_require__(6);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__link_link__["c"])(), {
            text: {
                type: String,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            href: {
                type: String,
                default: "#"
            },
            ariaCurrent: {
                type: String,
                default: "location"
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var suppliedProps = _ref.props, data = _ref.data, children = _ref.children;
                var tag = suppliedProps.active ? "span" : __WEBPACK_IMPORTED_MODULE_3__link_link__["a"];
                var componentData = {
                    props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a"])(props, suppliedProps),
                    domProps: {
                        innerHTML: suppliedProps.text
                    }
                };
                if (suppliedProps.active) {
                    componentData.attrs = {
                        "aria-current": suppliedProps.ariaCurrent
                    };
                } else {
                    componentData.attrs = {
                        href: suppliedProps.href
                    };
                }
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return props;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(27);
        var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(26);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(25);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a"])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a"].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a"].bind(null, "body")), {
            bodyClass: {
                type: [ String, Object, Array ],
                default: null
            },
            title: {
                type: String,
                default: null
            },
            titleTag: {
                type: String,
                default: "h4"
            },
            subTitle: {
                type: String,
                default: null
            },
            subTitleTag: {
                type: String,
                default: "h6"
            },
            overlay: {
                type: Boolean,
                default: false
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var cardBodyChildren = [];
                if (props.title) {
                    cardBodyChildren.push(h(props.titleTag, {
                        staticClass: "card-title",
                        domProps: {
                            innerHTML: props.title
                        }
                    }));
                }
                if (props.subTitle) {
                    cardBodyChildren.push(h(props.subTitleTag, {
                        staticClass: "card-subtitle mb-2 text-muted",
                        domProps: {
                            innerHTML: props.subTitle
                        }
                    }));
                }
                cardBodyChildren.push(slots().default);
                return h(props.bodyTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-body",
                    class: [ (_ref2 = {
                        "card-img-overlay": props.overlay
                    }, _defineProperty(_ref2, "bg-" + props.bodyBgVariant, Boolean(props.bodyBgVariant)), 
                    _defineProperty(_ref2, "border-" + props.bodyBorderVariant, Boolean(props.bodyBorderVariant)), 
                    _defineProperty(_ref2, "text-" + props.bodyTextVariant, Boolean(props.bodyTextVariant)), 
                    _ref2), props.bodyClass || {} ]
                }), cardBodyChildren);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return props;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(27);
        var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(26);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(25);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a"])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a"].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a"].bind(null, "footer")), {
            footer: {
                type: String,
                default: null
            },
            footerClass: {
                type: [ String, Object, Array ],
                default: null
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                return h(props.footerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-footer",
                    class: [ props.footerClass, (_ref2 = {}, _defineProperty(_ref2, "bg-" + props.footerBgVariant, Boolean(props.footerBgVariant)), 
                    _defineProperty(_ref2, "border-" + props.footerBorderVariant, Boolean(props.footerBorderVariant)), 
                    _defineProperty(_ref2, "text-" + props.footerTextVariant, Boolean(props.footerTextVariant)), 
                    _ref2) ]
                }), children || [ h("div", {
                    domProps: {
                        innerHTML: props.footer
                    }
                }) ]);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return props;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(27);
        var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(26);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(25);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a"])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a"].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a"].bind(null, "header")), {
            header: {
                type: String,
                default: null
            },
            headerClass: {
                type: [ String, Object, Array ],
                default: null
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                return h(props.headerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-header",
                    class: [ props.headerClass, (_ref2 = {}, _defineProperty(_ref2, "bg-" + props.headerBgVariant, Boolean(props.headerBgVariant)), 
                    _defineProperty(_ref2, "border-" + props.headerBorderVariant, Boolean(props.headerBorderVariant)), 
                    _defineProperty(_ref2, "text-" + props.headerTextVariant, Boolean(props.headerTextVariant)), 
                    _ref2) ]
                }), children || [ h("div", {
                    domProps: {
                        innerHTML: props.header
                    }
                }) ]);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return props;
        });
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            src: {
                type: String,
                default: null,
                required: true
            },
            alt: {
                type: String,
                default: null
            },
            top: {
                type: Boolean,
                default: false
            },
            bottom: {
                type: Boolean,
                default: false
            },
            fluid: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var staticClass = "card-img";
                if (props.top) {
                    staticClass += "-top";
                } else if (props.bottom) {
                    staticClass += "-bottom";
                }
                return h("img", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: staticClass,
                    class: {
                        "img-fluid": props.fluid
                    },
                    attrs: {
                        src: props.src,
                        alt: props.alt
                    }
                }));
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__collapse__ = __webpack_require__(79);
        var __WEBPACK_IMPORTED_MODULE_1__directives_toggle__ = __webpack_require__(148);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bCollapse: __WEBPACK_IMPORTED_MODULE_0__collapse__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
                Vue.use(__WEBPACK_IMPORTED_MODULE_1__directives_toggle__["a"]);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form_radio_check__ = __webpack_require__(152);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__ = __webpack_require__(50);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form_radio_check__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a"], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a"] ],
            render: function render(h) {
                var _this = this;
                var input = h("input", {
                    ref: "check",
                    class: [ this.is_ButtonMode ? "" : this.is_Plain ? "form-check-input" : "custom-control-input", this.get_StateClass ],
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.computedLocalChecked,
                        expression: "computedLocalChecked"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        type: "checkbox",
                        name: this.get_Name,
                        disabled: this.is_Disabled,
                        required: this.is_Required,
                        autocomplete: "off",
                        "true-value": this.value,
                        "false-value": this.uncheckedValue,
                        "aria-required": this.is_Required ? "true" : null
                    },
                    domProps: {
                        value: this.value,
                        checked: this.is_Checked
                    },
                    on: {
                        focus: this.handleFocus,
                        blur: this.handleFocus,
                        change: this.emitChange,
                        __c: function __c(evt) {
                            var $$a = _this.computedLocalChecked;
                            var $$el = evt.target;
                            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b"])($$a)) {
                                var $$v = _this.value;
                                var $$i = _this._i($$a, $$v);
                                if ($$el.checked) {
                                    $$i < 0 && (_this.computedLocalChecked = $$a.concat([ $$v ]));
                                } else {
                                    $$i > -1 && (_this.computedLocalChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                                }
                            } else {
                                _this.computedLocalChecked = $$el.checked ? _this.value : _this.uncheckedValue;
                            }
                        }
                    }
                });
                var description = h(this.is_ButtonMode ? "span" : "label", {
                    class: this.is_ButtonMode ? null : this.is_Plain ? "form-check-label" : "custom-control-label",
                    attrs: {
                        for: this.is_ButtonMode ? null : this.safeId()
                    }
                }, [ this.$slots.default ]);
                if (!this.is_ButtonMode) {
                    return h("div", {
                        class: [ this.is_Plain ? "form-check" : this.labelClasses, {
                            "form-check-inline": this.is_Plain && !this.is_Stacked
                        }, {
                            "custom-control-inline": !this.is_Plain && !this.is_Stacked
                        } ]
                    }, [ input, description ]);
                } else {
                    return h("label", {
                        class: [ this.buttonClasses ]
                    }, [ input, description ]);
                }
            },
            props: {
                value: {
                    default: true
                },
                uncheckedValue: {
                    default: false
                },
                indeterminate: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                labelClasses: function labelClasses() {
                    return [ "custom-control", "custom-checkbox", this.get_Size ? "form-control-" + this.get_Size : "", this.get_StateClass ];
                },
                is_Checked: function is_Checked() {
                    var checked = this.computedLocalChecked;
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b"])(checked)) {
                        for (var i = 0; i < checked.length; i++) {
                            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a"])(checked[i], this.value)) {
                                return true;
                            }
                        }
                        return false;
                    } else {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a"])(checked, this.value);
                    }
                }
            },
            watch: {
                computedLocalChecked: function computedLocalChecked(newVal, oldVal) {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a"])(newVal, oldVal)) {
                        return;
                    }
                    this.$emit("input", newVal);
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                },
                checked: function checked(newVal, oldVal) {
                    if (this.is_Child || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a"])(newVal, oldVal)) {
                        return;
                    }
                    this.computedLocalChecked = newVal;
                },
                indeterminate: function indeterminate(newVal, oldVal) {
                    this.setIndeterminate(newVal);
                }
            },
            methods: {
                emitChange: function emitChange(_ref) {
                    var checked = _ref.target.checked;
                    if (this.is_Child || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b"])(this.computedLocalChecked)) {
                        this.$emit("change", checked ? this.value : null);
                        if (this.is_Child) {
                            this.$parent.$emit("change", this.computedLocalChecked);
                        }
                    } else {
                        this.$emit("change", checked ? this.value : this.uncheckedValue);
                    }
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                },
                setIndeterminate: function setIndeterminate(state) {
                    if (this.is_Child || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b"])(this.computedLocalChecked)) {
                        return;
                    }
                    this.$refs.check.indeterminate = state;
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                }
            },
            mounted: function mounted() {
                this.setIndeterminate(this.indeterminate);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__ = __webpack_require__(152);
        var __WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__ = __webpack_require__(50);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__["a"] ],
            render: function render(h) {
                var _this = this;
                var input = h("input", {
                    ref: "radio",
                    class: [ this.is_ButtonMode ? "" : this.is_Plain ? "form-check-input" : "custom-control-input", this.get_StateClass ],
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.computedLocalChecked,
                        expression: "computedLocalChecked"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        type: "radio",
                        name: this.get_Name,
                        required: this.get_Name && this.is_Required,
                        disabled: this.is_Disabled,
                        autocomplete: "off"
                    },
                    domProps: {
                        value: this.value,
                        checked: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a"])(this.computedLocalChecked, this.value)
                    },
                    on: {
                        focus: this.handleFocus,
                        blur: this.handleFocus,
                        change: this.emitChange,
                        __c: function __c(evt) {
                            _this.computedLocalChecked = _this.value;
                        }
                    }
                });
                var description = h(this.is_ButtonMode ? "span" : "label", {
                    class: this.is_ButtonMode ? null : this.is_Plain ? "form-check-label" : "custom-control-label",
                    attrs: {
                        for: this.is_ButtonMode ? null : this.safeId()
                    }
                }, [ this.$slots.default ]);
                if (!this.is_ButtonMode) {
                    return h("div", {
                        class: [ this.is_Plain ? "form-check" : this.labelClasses, {
                            "form-check-inline": this.is_Plain && !this.is_Stacked
                        }, {
                            "custom-control-inline": !this.is_Plain && !this.is_Stacked
                        } ]
                    }, [ input, description ]);
                } else {
                    return h("label", {
                        class: [ this.buttonClasses ]
                    }, [ input, description ]);
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.computedLocalChecked = newVal;
                },
                computedLocalChceked: function computedLocalChceked(newVal, oldVal) {
                    this.$emit("input", this.computedLocalChceked);
                }
            },
            computed: {
                is_Checked: function is_Checked() {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a"])(this.value, this.computedLocalChecked);
                },
                labelClasses: function labelClasses() {
                    return [ this.get_Size ? "form-control-" + this.get_Size : "", "custom-control", "custom-radio", this.get_StateClass ];
                }
            },
            methods: {
                emitChange: function emitChange(_ref) {
                    var checked = _ref.target.checked;
                    this.$emit("change", checked ? this.value : null);
                    if (this.is_Child) {
                        this.$parent.$emit("change", this.computedLocalChecked);
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            },
            forceShow: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "invalid-feedback",
                    class: {
                        "d-block": props.forceShow
                    },
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "small"
            },
            textVariant: {
                type: String,
                default: "muted"
            },
            inline: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: _defineProperty({
                        "form-text": !props.inline
                    }, "text-" + props.textVariant, Boolean(props.textVariant)),
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            },
            forceShow: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "valid-feedback",
                    class: {
                        "d-block": props.forceShow
                    },
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            id: {
                type: String,
                default: null
            },
            inline: {
                type: Boolean,
                default: false
            },
            novalidate: {
                type: Boolean,
                default: false
            },
            validated: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h("form", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        "form-inline": props.inline,
                        "was-validated": props.validated
                    },
                    attrs: {
                        id: props.id,
                        novalidate: props.novalidate
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__input_group_addon__ = __webpack_require__(22);
        __webpack_exports__["a"] = {
            functional: true,
            props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__input_group_addon__["b"])(true),
            render: __WEBPACK_IMPORTED_MODULE_0__input_group_addon__["a"].render
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__input_group_addon__ = __webpack_require__(22);
        __webpack_exports__["a"] = {
            functional: true,
            props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__input_group_addon__["b"])(false),
            render: __WEBPACK_IMPORTED_MODULE_0__input_group_addon__["a"].render
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            fluid: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        container: !props.fluid,
                        "container-fluid": props.fluid
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            verticalAlign: {
                type: String,
                default: "top"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "d-flex",
                    class: _defineProperty({}, "align-self-" + props.verticalAlign, props.verticalAlign)
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "media-body"
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(123);
        var __WEBPACK_IMPORTED_MODULE_1__nav_item__ = __webpack_require__(121);
        var __WEBPACK_IMPORTED_MODULE_2__nav_text__ = __webpack_require__(122);
        var __WEBPACK_IMPORTED_MODULE_3__nav_form__ = __webpack_require__(119);
        var __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__ = __webpack_require__(120);
        var __WEBPACK_IMPORTED_MODULE_5__dropdown__ = __webpack_require__(20);
        var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(1);
        var components = {
            bNav: __WEBPACK_IMPORTED_MODULE_0__nav__["a"],
            bNavItem: __WEBPACK_IMPORTED_MODULE_1__nav_item__["a"],
            bNavText: __WEBPACK_IMPORTED_MODULE_2__nav_text__["a"],
            bNavForm: __WEBPACK_IMPORTED_MODULE_3__nav_form__["a"],
            bNavItemDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a"],
            bNavItemDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a"],
            bNavDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a"],
            bNavDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["a"])(Vue, components);
                Vue.use(__WEBPACK_IMPORTED_MODULE_5__dropdown__["a"]);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            render: function render(h) {
                var childNodes = h(false);
                if (this.$slots.default) {
                    childNodes = this.$slots.default;
                } else if (this.label) {
                    childNodes = h("span", {
                        domProps: {
                            innerHTML: this.label
                        }
                    });
                } else if (this.computedShowProgress) {
                    childNodes = this.progress.toFixed(this.computedPrecision);
                } else if (this.computedShowValue) {
                    childNodes = this.value.toFixed(this.computedPrecision);
                }
                return h("div", {
                    class: this.progressBarClasses,
                    style: this.progressBarStyles,
                    attrs: {
                        role: "progressbar",
                        "aria-valuemin": "0",
                        "aria-valuemax": this.computedMax.toString(),
                        "aria-valuenow": this.value.toFixed(this.computedPrecision)
                    }
                }, [ childNodes ]);
            },
            computed: {
                progressBarClasses: function progressBarClasses() {
                    return [ "progress-bar", this.computedVariant ? "bg-" + this.computedVariant : "", this.computedStriped || this.computedAnimated ? "progress-bar-striped" : "", this.computedAnimated ? "progress-bar-animated" : "" ];
                },
                progressBarStyles: function progressBarStyles() {
                    return {
                        width: 100 * (this.value / this.computedMax) + "%"
                    };
                },
                progress: function progress() {
                    var p = Math.pow(10, this.computedPrecision);
                    return Math.round(100 * p * this.value / this.computedMax) / p;
                },
                computedMax: function computedMax() {
                    return typeof this.max === "number" ? this.max : this.$parent.max || 100;
                },
                computedVariant: function computedVariant() {
                    return this.variant || this.$parent.variant;
                },
                computedPrecision: function computedPrecision() {
                    return typeof this.precision === "number" ? this.precision : this.$parent.precision || 0;
                },
                computedStriped: function computedStriped() {
                    return typeof this.striped === "boolean" ? this.striped : this.$parent.striped || false;
                },
                computedAnimated: function computedAnimated() {
                    return typeof this.animated === "boolean" ? this.animated : this.$parent.animated || false;
                },
                computedShowProgress: function computedShowProgress() {
                    return typeof this.showProgress === "boolean" ? this.showProgress : this.$parent.showProgress || false;
                },
                computedShowValue: function computedShowValue() {
                    return typeof this.showValue === "boolean" ? this.showValue : this.$parent.showValue || false;
                }
            },
            props: {
                value: {
                    type: Number,
                    default: 0
                },
                label: {
                    type: String,
                    default: null
                },
                max: {
                    type: Number,
                    default: null
                },
                precision: {
                    type: Number,
                    default: null
                },
                variant: {
                    type: String,
                    default: null
                },
                striped: {
                    type: Boolean,
                    default: null
                },
                animated: {
                    type: Boolean,
                    default: null
                },
                showProgress: {
                    type: Boolean,
                    default: null
                },
                showValue: {
                    type: Boolean,
                    default: null
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
        function isObject(obj) {
            return obj && {}.toString.call(obj) === "[object Object]";
        }
        __webpack_exports__["a"] = {
            props: {
                options: {
                    type: [ Array, Object ],
                    default: function _default() {
                        return [];
                    }
                },
                valueField: {
                    type: String,
                    default: "value"
                },
                textField: {
                    type: String,
                    default: "text"
                },
                disabledField: {
                    type: String,
                    default: "disabled"
                }
            },
            computed: {
                formOptions: function formOptions() {
                    var options = this.options;
                    var valueField = this.valueField;
                    var textField = this.textField;
                    var disabledField = this.disabledField;
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["b"])(options)) {
                        return options.map(function(option) {
                            if (isObject(option)) {
                                return {
                                    value: option[valueField],
                                    text: String(option[textField]),
                                    disabled: option[disabledField] || false
                                };
                            }
                            return {
                                value: option,
                                text: String(option),
                                disabled: false
                            };
                        });
                    } else {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b"])(options).map(function(key) {
                            var option = options[key] || {};
                            if (isObject(option)) {
                                var value = option[valueField];
                                var text = option[textField];
                                return {
                                    value: typeof value === "undefined" ? key : value,
                                    text: typeof text === "undefined" ? key : String(text),
                                    disabled: option[disabledField] || false
                                };
                            }
                            return {
                                value: key,
                                text: String(option),
                                disabled: false
                            };
                        });
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function isObject(obj) {
            return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
        }
        function looseEqual(a, b) {
            if (a === b) return true;
            var isObjectA = isObject(a);
            var isObjectB = isObject(b);
            if (isObjectA && isObjectB) {
                try {
                    var isArrayA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["b"])(a);
                    var isArrayB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["b"])(b);
                    if (isArrayA && isArrayB) {
                        return a.length === b.length && a.every(function(e, i) {
                            return looseEqual(e, b[i]);
                        });
                    } else if (!isArrayA && !isArrayB) {
                        var keysA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["b"])(a);
                        var keysB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["b"])(b);
                        return keysA.length === keysB.length && keysA.every(function(key) {
                            return looseEqual(a[key], b[key]);
                        });
                    } else {
                        return false;
                    }
                } catch (e) {
                    return false;
                }
            } else if (!isObjectA && !isObjectB) {
                return String(a) === String(b);
            } else {
                return false;
            }
        }
        __webpack_exports__["a"] = looseEqual;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(17);
        var __WEBPACK_IMPORTED_MODULE_1__bv_event_class__ = __webpack_require__(155);
        var __WEBPACK_IMPORTED_MODULE_2__object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_4__dom__ = __webpack_require__(5);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        var NAME = "tooltip";
        var CLASS_PREFIX = "bs-tooltip";
        var BSCLS_PREFIX_REGEX = new RegExp("\\b" + CLASS_PREFIX + "\\S+", "g");
        var TRANSITION_DURATION = 150;
        var MODAL_CLOSE_EVENT = "bv::modal::hidden";
        var MODAL_CLASS = ".modal-content";
        var AttachmentMap = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left",
            TOPLEFT: "top",
            TOPRIGHT: "top",
            RIGHTTOP: "right",
            RIGHTBOTTOM: "right",
            BOTTOMLEFT: "bottom",
            BOTTOMRIGHT: "bottom",
            LEFTTOP: "left",
            LEFTBOTTOM: "left"
        };
        var OffsetMap = {
            AUTO: 0,
            TOPLEFT: -1,
            TOP: 0,
            TOPRIGHT: +1,
            RIGHTTOP: -1,
            RIGHT: 0,
            RIGHTBOTTOM: +1,
            BOTTOMLEFT: -1,
            BOTTOM: 0,
            BOTTOMRIGHT: +1,
            LEFTTOP: -1,
            LEFT: 0,
            LEFTBOTTOM: +1
        };
        var HoverState = {
            SHOW: "show",
            OUT: "out"
        };
        var ClassName = {
            FADE: "fade",
            SHOW: "show"
        };
        var Selector = {
            TOOLTIP: ".tooltip",
            TOOLTIP_INNER: ".tooltip-inner",
            ARROW: ".arrow"
        };
        var Defaults = {
            animation: true,
            template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div>' + "</div>",
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: false,
            placement: "top",
            offset: 0,
            arrowPadding: 6,
            container: false,
            fallbackPlacement: "flip",
            callbacks: {},
            boundary: "scrollParent"
        };
        var TransitionEndEvents = {
            WebkitTransition: [ "webkitTransitionEnd" ],
            MozTransition: [ "transitionend" ],
            OTransition: [ "otransitionend", "oTransitionEnd" ],
            transition: [ "transitionend" ]
        };
        var NEXTID = 1;
        function generateId(name) {
            return "__BV_" + name + "_" + NEXTID++ + "__";
        }
        var ToolTip = function() {
            function ToolTip(element, config, $root) {
                _classCallCheck(this, ToolTip);
                this.$isEnabled = true;
                this.$fadeTimeout = null;
                this.$hoverTimeout = null;
                this.$visibleInterval = null;
                this.$hoverState = "";
                this.$activeTrigger = {};
                this.$popper = null;
                this.$element = element;
                this.$tip = null;
                this.$id = generateId(this.constructor.NAME);
                this.$root = $root || null;
                this.$routeWatcher = null;
                this.$forceHide = this.forceHide.bind(this);
                this.$doHide = this.doHide.bind(this);
                this.$doShow = this.doShow.bind(this);
                this.$doDisable = this.doDisable.bind(this);
                this.$doEnable = this.doEnable.bind(this);
                this.updateConfig(config);
            }
            _createClass(ToolTip, [ {
                key: "updateConfig",
                value: function updateConfig(config) {
                    var updatedConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__object__["a"])({}, this.constructor.Default, config);
                    if (config.delay && typeof config.delay === "number") {
                        updatedConfig.delay = {
                            show: config.delay,
                            hide: config.delay
                        };
                    }
                    if (config.title && typeof config.title === "number") {
                        updatedConfig.title = config.title.toString();
                    }
                    if (config.content && typeof config.content === "number") {
                        updatedConfig.content = config.content.toString();
                    }
                    this.fixTitle();
                    this.$config = updatedConfig;
                    this.unListen();
                    this.listen();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.unListen();
                    this.setWhileOpenListeners(false);
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverTimeout = null;
                    clearTimeout(this.$fadeTimeout);
                    this.$fadeTimeout = null;
                    if (this.$popper) {
                        this.$popper.destroy();
                    }
                    this.$popper = null;
                    if (this.$tip && this.$tip.parentElement) {
                        this.$tip.parentElement.removeChild(this.$tip);
                    }
                    this.$tip = null;
                    this.$id = null;
                    this.$isEnabled = null;
                    this.$root = null;
                    this.$element = null;
                    this.$config = null;
                    this.$hoverState = null;
                    this.$activeTrigger = null;
                    this.$forceHide = null;
                    this.$doHide = null;
                    this.$doShow = null;
                    this.$doDisable = null;
                    this.$doEnable = null;
                }
            }, {
                key: "enable",
                value: function enable() {
                    var enabledEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("enabled", {
                        cancelable: false,
                        target: this.$element,
                        relatedTarget: null
                    });
                    this.$isEnabled = true;
                    this.emitEvent(enabledEvt);
                }
            }, {
                key: "disable",
                value: function disable() {
                    var disabledEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("disabled", {
                        cancelable: false,
                        target: this.$element,
                        relatedTarget: null
                    });
                    this.$isEnabled = false;
                    this.emitEvent(disabledEvt);
                }
            }, {
                key: "toggle",
                value: function toggle(event) {
                    if (!this.$isEnabled) {
                        return;
                    }
                    if (event) {
                        this.$activeTrigger.click = !this.$activeTrigger.click;
                        if (this.isWithActiveTrigger()) {
                            this.enter(null);
                        } else {
                            this.leave(null);
                        }
                    } else {
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["a"])(this.getTipElement(), ClassName.SHOW)) {
                            this.leave(null);
                        } else {
                            this.enter(null);
                        }
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (!document.body.contains(this.$element) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["b"])(this.$element)) {
                        return;
                    }
                    var tip = this.getTipElement();
                    this.fixTitle();
                    this.setContent(tip);
                    if (!this.isWithContent(tip)) {
                        this.$tip = null;
                        return;
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["c"])(tip, "id", this.$id);
                    this.addAriaDescribedby();
                    if (this.$config.animation) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["d"])(tip, ClassName.FADE);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.FADE);
                    }
                    var placement = this.getPlacement();
                    var attachment = this.constructor.getAttachment(placement);
                    this.addAttachmentClass(attachment);
                    var showEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("show", {
                        cancelable: true,
                        target: this.$element,
                        relatedTarget: tip
                    });
                    this.emitEvent(showEvt);
                    if (showEvt.defaultPrevented) {
                        this.$tip = null;
                        return;
                    }
                    var container = this.getContainer();
                    if (!document.body.contains(tip)) {
                        container.appendChild(tip);
                    }
                    this.removePopper();
                    this.$popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a"](this.$element, tip, this.getPopperConfig(placement, tip));
                    var complete = function complete() {
                        if (_this.$config.animation) {
                            _this.fixTransition(tip);
                        }
                        var prevHoverState = _this.$hoverState;
                        _this.$hoverState = null;
                        if (prevHoverState === HoverState.OUT) {
                            _this.leave(null);
                        }
                        var shownEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("shown", {
                            cancelable: false,
                            target: _this.$element,
                            relatedTarget: tip
                        });
                        _this.emitEvent(shownEvt);
                    };
                    this.setWhileOpenListeners(true);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["d"])(tip, ClassName.SHOW);
                    this.transitionOnce(tip, complete);
                }
            }, {
                key: "visibleCheck",
                value: function visibleCheck(on) {
                    var _this2 = this;
                    clearInterval(this.$visibleInterval);
                    this.$visibleInterval = null;
                    if (on) {
                        this.$visibleInterval = setInterval(function() {
                            var tip = _this2.getTipElement();
                            if (tip && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["b"])(_this2.$element) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["a"])(tip, ClassName.SHOW)) {
                                _this2.forceHide();
                            }
                        }, 100);
                    }
                }
            }, {
                key: "setWhileOpenListeners",
                value: function setWhileOpenListeners(on) {
                    this.setModalListener(on);
                    this.visibleCheck(on);
                    this.setRouteWatcher(on);
                    this.setOnTouchStartListener(on);
                    if (on && /(focus|blur)/.test(this.$config.trigger)) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(this.$tip, "focusout", this);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["g"])(this.$tip, "focusout", this);
                    }
                }
            }, {
                key: "forceHide",
                value: function forceHide() {
                    if (!this.$tip || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["a"])(this.$tip, ClassName.SHOW)) {
                        return;
                    }
                    this.setWhileOpenListeners(false);
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverTimeout = null;
                    this.$hoverState = "";
                    this.hide(null, true);
                }
            }, {
                key: "hide",
                value: function hide(callback, force) {
                    var _this3 = this;
                    var tip = this.$tip;
                    if (!tip) {
                        return;
                    }
                    var hideEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("hide", {
                        cancelable: !force,
                        target: this.$element,
                        relatedTarget: tip
                    });
                    this.emitEvent(hideEvt);
                    if (hideEvt.defaultPrevented) {
                        return;
                    }
                    var complete = function complete() {
                        if (_this3.$hoverState !== HoverState.SHOW && tip.parentNode) {
                            tip.parentNode.removeChild(tip);
                            _this3.removeAriaDescribedby();
                            _this3.removePopper();
                            _this3.$tip = null;
                        }
                        if (callback) {
                            callback();
                        }
                        var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a"]("hidden", {
                            cancelable: false,
                            target: _this3.$element,
                            relatedTarget: null
                        });
                        _this3.emitEvent(hiddenEvt);
                    };
                    this.setWhileOpenListeners(false);
                    if (force) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.FADE);
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.SHOW);
                    this.$activeTrigger.click = false;
                    this.$activeTrigger.focus = false;
                    this.$activeTrigger.hover = false;
                    this.transitionOnce(tip, complete);
                    this.$hoverState = "";
                }
            }, {
                key: "emitEvent",
                value: function emitEvent(evt) {
                    var evtName = evt.type;
                    if (this.$root && this.$root.$emit) {
                        this.$root.$emit("bv::" + this.constructor.NAME + "::" + evtName, evt);
                    }
                    var callbacks = this.$config.callbacks || {};
                    if (typeof callbacks[evtName] === "function") {
                        callbacks[evtName](evt);
                    }
                }
            }, {
                key: "getContainer",
                value: function getContainer() {
                    var container = this.$config.container;
                    var body = document.body;
                    return container === false ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["h"])(MODAL_CLASS, this.$element) || body : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["i"])(container, body) || body;
                }
            }, {
                key: "addAriaDescribedby",
                value: function addAriaDescribedby() {
                    var desc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(this.$element, "aria-describedby") || "";
                    desc = desc.split(/\s+/).concat(this.$id).join(" ").trim();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["c"])(this.$element, "aria-describedby", desc);
                }
            }, {
                key: "removeAriaDescribedby",
                value: function removeAriaDescribedby() {
                    var _this4 = this;
                    var desc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(this.$element, "aria-describedby") || "";
                    desc = desc.split(/\s+/).filter(function(d) {
                        return d !== _this4.$id;
                    }).join(" ").trim();
                    if (desc) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["c"])(this.$element, "aria-describedby", desc);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["k"])(this.$element, "aria-describedby");
                    }
                }
            }, {
                key: "removePopper",
                value: function removePopper() {
                    if (this.$popper) {
                        this.$popper.destroy();
                    }
                    this.$popper = null;
                }
            }, {
                key: "transitionOnce",
                value: function transitionOnce(tip, complete) {
                    var _this5 = this;
                    var transEvents = this.getTransitionEndEvents();
                    var called = false;
                    clearTimeout(this.$fadeTimeout);
                    this.$fadeTimeout = null;
                    var fnOnce = function fnOnce() {
                        if (called) {
                            return;
                        }
                        called = true;
                        clearTimeout(_this5.$fadeTimeout);
                        _this5.$fadeTimeout = null;
                        transEvents.forEach(function(evtName) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["g"])(tip, evtName, fnOnce);
                        });
                        complete();
                    };
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["a"])(tip, ClassName.FADE)) {
                        transEvents.forEach(function(evtName) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(tip, evtName, fnOnce);
                        });
                        this.$fadeTimeout = setTimeout(fnOnce, TRANSITION_DURATION);
                    } else {
                        fnOnce();
                    }
                }
            }, {
                key: "getTransitionEndEvents",
                value: function getTransitionEndEvents() {
                    for (var name in TransitionEndEvents) {
                        if (this.$element.style[name] !== undefined) {
                            return TransitionEndEvents[name];
                        }
                    }
                    return [];
                }
            }, {
                key: "update",
                value: function update() {
                    if (this.$popper !== null) {
                        this.$popper.scheduleUpdate();
                    }
                }
            }, {
                key: "isWithContent",
                value: function isWithContent(tip) {
                    tip = tip || this.$tip;
                    if (!tip) {
                        return false;
                    }
                    return Boolean((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["i"])(Selector.TOOLTIP_INNER, tip) || {}).innerHTML);
                }
            }, {
                key: "addAttachmentClass",
                value: function addAttachmentClass(attachment) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["d"])(this.getTipElement(), CLASS_PREFIX + "-" + attachment);
                }
            }, {
                key: "getTipElement",
                value: function getTipElement() {
                    if (!this.$tip) {
                        this.$tip = this.compileTemplate(this.$config.template) || this.compileTemplate(this.constructor.Default.template);
                    }
                    this.$tip.tabIndex = -1;
                    return this.$tip;
                }
            }, {
                key: "compileTemplate",
                value: function compileTemplate(html) {
                    if (!html || typeof html !== "string") {
                        return null;
                    }
                    var div = document.createElement("div");
                    div.innerHTML = html.trim();
                    var node = div.firstElementChild ? div.removeChild(div.firstElementChild) : null;
                    div = null;
                    return node;
                }
            }, {
                key: "setContent",
                value: function setContent(tip) {
                    this.setElementContent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["i"])(Selector.TOOLTIP_INNER, tip), this.getTitle());
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.FADE);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.SHOW);
                }
            }, {
                key: "setElementContent",
                value: function setElementContent(container, content) {
                    if (!container) {
                        return;
                    }
                    var allowHtml = this.$config.html;
                    if ((typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" && content.nodeType) {
                        if (allowHtml) {
                            if (content.parentElement !== container) {
                                container.innerHtml = "";
                                container.appendChild(content);
                            }
                        } else {
                            container.innerText = content.innerText;
                        }
                    } else {
                        container[allowHtml ? "innerHTML" : "innerText"] = content;
                    }
                }
            }, {
                key: "getTitle",
                value: function getTitle() {
                    var title = this.$config.title || "";
                    if (typeof title === "function") {
                        title = title(this.$element);
                    }
                    if ((typeof title === "undefined" ? "undefined" : _typeof(title)) === "object" && title.nodeType && !title.innerHTML.trim()) {
                        title = "";
                    }
                    if (typeof title === "string") {
                        title = title.trim();
                    }
                    if (!title) {
                        title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(this.$element, "title") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(this.$element, "data-original-title") || "";
                        title = title.trim();
                    }
                    return title;
                }
            }, {
                key: "listen",
                value: function listen() {
                    var _this6 = this;
                    var triggers = this.$config.trigger.trim().split(/\s+/);
                    var el = this.$element;
                    this.setRootListener(true);
                    triggers.forEach(function(trigger) {
                        if (trigger === "click") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "click", _this6);
                        } else if (trigger === "focus") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "focusin", _this6);
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "focusout", _this6);
                        } else if (trigger === "blur") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "focusout", _this6);
                        } else if (trigger === "hover") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "mouseenter", _this6);
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "mouseleave", _this6);
                        }
                    }, this);
                }
            }, {
                key: "unListen",
                value: function unListen() {
                    var _this7 = this;
                    var events = [ "click", "focusin", "focusout", "mouseenter", "mouseleave" ];
                    events.forEach(function(evt) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["g"])(_this7.$element, evt, _this7);
                    }, this);
                    this.setRootListener(false);
                }
            }, {
                key: "handleEvent",
                value: function handleEvent(e) {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["l"])(this.$element)) {
                        return;
                    }
                    if (!this.$isEnabled) {
                        return;
                    }
                    var type = e.type;
                    var target = e.target;
                    var relatedTarget = e.relatedTarget;
                    var $element = this.$element;
                    var $tip = this.$tip;
                    if (type === "click") {
                        this.toggle(e);
                    } else if (type === "focusin" || type === "mouseenter") {
                        this.enter(e);
                    } else if (type === "focusout") {
                        if ($tip && $element && $element.contains(target) && $tip.contains(relatedTarget)) {
                            return;
                        }
                        if ($tip && $element && $tip.contains(target) && $element.contains(relatedTarget)) {
                            return;
                        }
                        if ($tip && $tip.contains(target) && $tip.contains(relatedTarget)) {
                            return;
                        }
                        if ($element && $element.contains(target) && $element.contains(relatedTarget)) {
                            return;
                        }
                        this.leave(e);
                    } else if (type === "mouseleave") {
                        this.leave(e);
                    }
                }
            }, {
                key: "setRouteWatcher",
                value: function setRouteWatcher(on) {
                    var _this8 = this;
                    if (on) {
                        this.setRouteWatcher(false);
                        if (this.$root && Boolean(this.$root.$route)) {
                            this.$routeWatcher = this.$root.$watch("$route", function(newVal, oldVal) {
                                if (newVal === oldVal) {
                                    return;
                                }
                                _this8.forceHide();
                            });
                        }
                    } else {
                        if (this.$routeWatcher) {
                            this.$routeWatcher();
                            this.$routeWatcher = null;
                        }
                    }
                }
            }, {
                key: "setModalListener",
                value: function setModalListener(on) {
                    var modal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["h"])(MODAL_CLASS, this.$element);
                    if (!modal) {
                        return;
                    }
                    if (this.$root) {
                        this.$root[on ? "$on" : "$off"](MODAL_CLOSE_EVENT, this.$forceHide);
                    }
                }
            }, {
                key: "setRootListener",
                value: function setRootListener(on) {
                    if (this.$root) {
                        this.$root[on ? "$on" : "$off"]("bv::hide::" + this.constructor.NAME, this.$doHide);
                        this.$root[on ? "$on" : "$off"]("bv::show::" + this.constructor.NAME, this.$doShow);
                        this.$root[on ? "$on" : "$off"]("bv::disable::" + this.constructor.NAME, this.$doDisable);
                        this.$root[on ? "$on" : "$off"]("bv::enable::" + this.constructor.NAME, this.$doEnable);
                    }
                }
            }, {
                key: "doHide",
                value: function doHide(id) {
                    if (!id) {
                        this.forceHide();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.hide();
                    }
                }
            }, {
                key: "doShow",
                value: function doShow(id) {
                    if (!id) {
                        this.show();
                    } else if (id && this.$element && this.$element.id && this.$element.id === id) {
                        this.show();
                    }
                }
            }, {
                key: "doDisable",
                value: function doDisable(id) {
                    if (!id) {
                        this.disable();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.disable();
                    }
                }
            }, {
                key: "doEnable",
                value: function doEnable(id) {
                    if (!id) {
                        this.enable();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.enable();
                    }
                }
            }, {
                key: "setOnTouchStartListener",
                value: function setOnTouchStartListener(on) {
                    var _this9 = this;
                    if ("ontouchstart" in document.documentElement) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__array__["a"])(document.body.children).forEach(function(el) {
                            if (on) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["f"])(el, "mouseover", _this9._noop);
                            } else {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["g"])(el, "mouseover", _this9._noop);
                            }
                        });
                    }
                }
            }, {
                key: "_noop",
                value: function _noop() {}
            }, {
                key: "fixTitle",
                value: function fixTitle() {
                    var el = this.$element;
                    var titleType = _typeof(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(el, "data-original-title"));
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(el, "title") || titleType !== "string") {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["c"])(el, "data-original-title", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(el, "title") || "");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["c"])(el, "title", "");
                    }
                }
            }, {
                key: "enter",
                value: function enter(e) {
                    var _this10 = this;
                    if (e) {
                        this.$activeTrigger[e.type === "focusin" ? "focus" : "hover"] = true;
                    }
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["a"])(this.getTipElement(), ClassName.SHOW) || this.$hoverState === HoverState.SHOW) {
                        this.$hoverState = HoverState.SHOW;
                        return;
                    }
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverState = HoverState.SHOW;
                    if (!this.$config.delay || !this.$config.delay.show) {
                        this.show();
                        return;
                    }
                    this.$hoverTimeout = setTimeout(function() {
                        if (_this10.$hoverState === HoverState.SHOW) {
                            _this10.show();
                        }
                    }, this.$config.delay.show);
                }
            }, {
                key: "leave",
                value: function leave(e) {
                    var _this11 = this;
                    if (e) {
                        this.$activeTrigger[e.type === "focusout" ? "focus" : "hover"] = false;
                        if (e.type === "focusout" && /blur/.test(this.$config.trigger)) {
                            this.$activeTrigger.click = false;
                            this.$activeTrigger.hover = false;
                        }
                    }
                    if (this.isWithActiveTrigger()) {
                        return;
                    }
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverState = HoverState.OUT;
                    if (!this.$config.delay || !this.$config.delay.hide) {
                        this.hide();
                        return;
                    }
                    this.$hoverTimeout = setTimeout(function() {
                        if (_this11.$hoverState === HoverState.OUT) {
                            _this11.hide();
                        }
                    }, this.$config.delay.hide);
                }
            }, {
                key: "getPopperConfig",
                value: function getPopperConfig(placement, tip) {
                    var _this12 = this;
                    return {
                        placement: this.constructor.getAttachment(placement),
                        modifiers: {
                            offset: {
                                offset: this.getOffset(placement, tip)
                            },
                            flip: {
                                behavior: this.$config.fallbackPlacement
                            },
                            arrow: {
                                element: ".arrow"
                            },
                            preventOverflow: {
                                boundariesElement: this.$config.boundary
                            }
                        },
                        onCreate: function onCreate(data) {
                            if (data.originalPlacement !== data.placement) {
                                _this12.handlePopperPlacementChange(data);
                            }
                        },
                        onUpdate: function onUpdate(data) {
                            _this12.handlePopperPlacementChange(data);
                        }
                    };
                }
            }, {
                key: "getOffset",
                value: function getOffset(placement, tip) {
                    if (!this.$config.offset) {
                        var arrow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["i"])(Selector.ARROW, tip);
                        var arrowOffset = parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["m"])(arrow).width) + parseFloat(this.$config.arrowPadding);
                        switch (OffsetMap[placement.toUpperCase()]) {
                          case +1:
                            return "+50%p - " + arrowOffset + "px";

                          case -1:
                            return "-50%p + " + arrowOffset + "px";

                          default:
                            return 0;
                        }
                    }
                    return parseFloat(this.$config.offset);
                }
            }, {
                key: "getPlacement",
                value: function getPlacement() {
                    var placement = this.$config.placement;
                    if (typeof placement === "function") {
                        return placement.call(this, this.$tip, this.$element);
                    }
                    return placement;
                }
            }, {
                key: "isWithActiveTrigger",
                value: function isWithActiveTrigger() {
                    for (var trigger in this.$activeTrigger) {
                        if (this.$activeTrigger[trigger]) {
                            return true;
                        }
                    }
                    return false;
                }
            }, {
                key: "cleanTipClass",
                value: function cleanTipClass() {
                    var tip = this.getTipElement();
                    var tabClass = tip.className.match(BSCLS_PREFIX_REGEX);
                    if (tabClass !== null && tabClass.length > 0) {
                        tabClass.forEach(function(cls) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, cls);
                        });
                    }
                }
            }, {
                key: "handlePopperPlacementChange",
                value: function handlePopperPlacementChange(data) {
                    this.cleanTipClass();
                    this.addAttachmentClass(this.constructor.getAttachment(data.placement));
                }
            }, {
                key: "fixTransition",
                value: function fixTransition(tip) {
                    var initConfigAnimation = this.$config.animation || false;
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["j"])(tip, "x-placement") !== null) {
                        return;
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom__["e"])(tip, ClassName.FADE);
                    this.$config.animation = false;
                    this.hide();
                    this.show();
                    this.$config.animation = initConfigAnimation;
                }
            } ], [ {
                key: "getAttachment",
                value: function getAttachment(placement) {
                    return AttachmentMap[placement.toUpperCase()];
                }
            }, {
                key: "Default",
                get: function get() {
                    return Defaults;
                }
            }, {
                key: "NAME",
                get: function get() {
                    return NAME;
                }
            } ]);
            return ToolTip;
        }();
        __webpack_exports__["a"] = ToolTip;
    }, function(module, exports) {
        var core = module.exports = {
            version: "2.5.3"
        };
        if (typeof __e == "number") __e = core;
    }, function(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(54)(function() {
            return Object.defineProperty({}, "a", {
                get: function() {
                    return 7;
                }
            }).a != 7;
        });
    }, function(module, exports) {
        module.exports = function(exec) {
            try {
                return !!exec();
            } catch (e) {
                return true;
            }
        };
    }, function(module, exports) {
        var global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
        if (typeof __g == "number") __g = global;
    }, function(module, exports) {
        module.exports = function(it) {
            return typeof it === "object" ? it !== null : typeof it === "function";
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__(221);
        __webpack_exports__["a"] = {
            name: "app",
            components: {
                Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello__["a"]
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            name: "custom",
            data: function data() {
                return {
                    msg: "1. Custom Pylon-Vue Component"
                };
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            name: "hello",
            data: function data() {
                return {
                    msg: "Pylon Bootstrap Vue 2"
                };
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
        var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
        __webpack_exports__["a"] = {
            name: "liteGrid",
            props: {
                data: Array,
                columns: Array,
                filterKey: String
            },
            data: function data() {
                var sortOrders = {};
                this.columns.forEach(function(key) {
                    sortOrders[key] = 1;
                });
                return {
                    sortKey: "",
                    sortOrders: sortOrders
                };
            },
            computed: {
                filteredData: function filteredData() {
                    var sortKey = this.sortKey;
                    var filterKey = this.filterKey && this.filterKey.toLowerCase();
                    var order = this.sortOrders[sortKey] || 1;
                    var data = this.data;
                    if (filterKey) {
                        data = data.filter(function(row) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function(key) {
                                return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                            });
                        });
                    }
                    if (sortKey) {
                        data = data.slice().sort(function(a, b) {
                            a = a[sortKey];
                            b = b[sortKey];
                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        });
                    }
                    return data;
                }
            },
            filters: {
                capitalize: function capitalize(str) {
                    return str.charAt(0).toUpperCase() + str.slice(1);
                }
            },
            methods: {
                sortBy: function sortBy(key) {
                    this.sortKey = key;
                    this.sortOrders[key] = this.sortOrders[key] * -1;
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            default: __webpack_require__(184),
            __esModule: true
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__button_button_close__ = __webpack_require__(18);
        __webpack_exports__["a"] = {
            components: {
                bButtonClose: __WEBPACK_IMPORTED_MODULE_0__button_button_close__["a"]
            },
            render: function render(h) {
                if (!this.localShow) {
                    return h(false);
                }
                var dismissBtn = h(false);
                if (this.dismissible) {
                    dismissBtn = h("b-button-close", {
                        attrs: {
                            "aria-label": this.dismissLabel
                        },
                        on: {
                            click: this.dismiss
                        }
                    }, [ this.$slots.dismiss ]);
                }
                return h("div", {
                    class: this.classObject,
                    attrs: {
                        role: "alert",
                        "aria-live": "polite",
                        "aria-atomic": true
                    }
                }, [ dismissBtn, this.$slots.default ]);
            },
            model: {
                prop: "show",
                event: "input"
            },
            data: function data() {
                return {
                    countDownTimerId: null,
                    dismissed: false
                };
            },
            computed: {
                classObject: function classObject() {
                    return [ "alert", this.alertVariant, this.dismissible ? "alert-dismissible" : "" ];
                },
                alertVariant: function alertVariant() {
                    var variant = this.variant;
                    return "alert-" + variant;
                },
                localShow: function localShow() {
                    return !this.dismissed && (this.countDownTimerId || this.show);
                }
            },
            props: {
                variant: {
                    type: String,
                    default: "info"
                },
                dismissible: {
                    type: Boolean,
                    default: false
                },
                dismissLabel: {
                    type: String,
                    default: "Close"
                },
                show: {
                    type: [ Boolean, Number ],
                    default: false
                }
            },
            watch: {
                show: function show() {
                    this.showChanged();
                }
            },
            mounted: function mounted() {
                this.showChanged();
            },
            destroyed: function destroyed() {
                this.clearCounter();
            },
            methods: {
                dismiss: function dismiss() {
                    this.clearCounter();
                    this.dismissed = true;
                    this.$emit("dismissed");
                    this.$emit("input", false);
                    if (typeof this.show === "number") {
                        this.$emit("dismiss-count-down", 0);
                        this.$emit("input", 0);
                    } else {
                        this.$emit("input", false);
                    }
                },
                clearCounter: function clearCounter() {
                    if (this.countDownTimerId) {
                        clearInterval(this.countDownTimerId);
                        this.countDownTimerId = null;
                    }
                },
                showChanged: function showChanged() {
                    var _this = this;
                    this.clearCounter();
                    this.dismissed = false;
                    if (this.show === true || this.show === false || this.show === null || this.show === 0) {
                        return;
                    }
                    var dismissCountDown = this.show;
                    this.countDownTimerId = setInterval(function() {
                        if (dismissCountDown < 1) {
                            _this.dismiss();
                            return;
                        }
                        dismissCountDown--;
                        _this.$emit("dismiss-count-down", dismissCountDown);
                        _this.$emit("input", dismissCountDown);
                    }, 1e3);
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(62);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bAlert: __WEBPACK_IMPORTED_MODULE_0__alert__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__link_link__ = __webpack_require__(6);
        var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__link_link__["c"])();
        delete linkProps.href.default;
        delete linkProps.to.default;
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])(linkProps, {
            tag: {
                type: String,
                default: "span"
            },
            variant: {
                type: String,
                default: "secondary"
            },
            pill: {
                type: Boolean,
                default: false
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var tag = !props.href && !props.to ? props.tag : __WEBPACK_IMPORTED_MODULE_3__link_link__["a"];
                var componentData = {
                    staticClass: "badge",
                    class: [ !props.variant ? "badge-secondary" : "badge-" + props.variant, {
                        "badge-pill": Boolean(props.pill),
                        active: props.active,
                        disabled: props.disabled
                    } ],
                    props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a"])(linkProps, props)
                };
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(64);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bBadge: __WEBPACK_IMPORTED_MODULE_0__badge__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__ = __webpack_require__(29);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var props = {
            items: {
                type: Array,
                default: null
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var childNodes = children;
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b"])(props.items)) {
                    var activeDefined = false;
                    childNodes = props.items.map(function(item, idx) {
                        if ((typeof item === "undefined" ? "undefined" : _typeof(item)) !== "object") {
                            item = {
                                text: item
                            };
                        }
                        var active = item.active;
                        if (active) {
                            activeDefined = true;
                        }
                        if (!active && !activeDefined) {
                            active = idx + 1 === props.items.length;
                        }
                        return h(__WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__["a"], {
                            props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])({}, item, {
                                active: active
                            })
                        });
                    });
                }
                return h("ol", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "breadcrumb"
                }), childNodes);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__breadcrumb__ = __webpack_require__(66);
        var __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__ = __webpack_require__(29);
        var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(30);
        var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(1);
        var components = {
            bBreadcrumb: __WEBPACK_IMPORTED_MODULE_0__breadcrumb__["a"],
            bBreadcrumbItem: __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__["a"],
            bBreadcrumbLink: __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            vertical: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: null,
                validator: function validator(size) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])([ "sm", "", "lg" ], size);
                }
            },
            tag: {
                type: String,
                default: "div"
            },
            ariaRole: {
                type: String,
                default: "group"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: _defineProperty({
                        "btn-group": !props.vertical,
                        "btn-group-vertical": props.vertical
                    }, "btn-group-" + props.size, Boolean(props.size)),
                    attrs: {
                        role: props.ariaRole
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__button_group__ = __webpack_require__(68);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bButtonGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a"],
            bBtnGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(10);
        var ITEM_SELECTOR = [ ".btn:not(.disabled):not([disabled]):not(.dropdown-item)", ".form-control:not(.disabled):not([disabled])", "select:not(.disabled):not([disabled])", 'input[type="checkbox"]:not(.disabled)', 'input[type="radio"]:not(.disabled)' ].join(",");
        __webpack_exports__["a"] = {
            render: function render(h) {
                return h("div", {
                    class: this.classObject,
                    attrs: {
                        role: "toolbar",
                        tabindex: this.keyNav ? "0" : null
                    },
                    on: {
                        focusin: this.onFocusin,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
            },
            computed: {
                classObject: function classObject() {
                    return [ "btn-toolbar", this.justify && !this.vertical ? "justify-content-between" : "" ];
                }
            },
            props: {
                justify: {
                    type: Boolean,
                    default: false
                },
                keyNav: {
                    type: Boolean,
                    default: false
                }
            },
            methods: {
                onFocusin: function onFocusin(evt) {
                    if (evt.target === this.$el) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.focusFirst(evt);
                    }
                },
                onKeydown: function onKeydown(evt) {
                    if (!this.keyNav) {
                        return;
                    }
                    var key = evt.keyCode;
                    var shift = evt.shiftKey;
                    if (key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].UP || key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].LEFT) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (shift) {
                            this.focusFirst(evt);
                        } else {
                            this.focusNext(evt, true);
                        }
                    } else if (key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].DOWN || key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].RIGHT) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (shift) {
                            this.focusLast(evt);
                        } else {
                            this.focusNext(evt, false);
                        }
                    }
                },
                setItemFocus: function setItemFocus(item) {
                    this.$nextTick(function() {
                        item.focus();
                    });
                },
                focusNext: function focusNext(evt, prev) {
                    var items = this.getItems();
                    if (items.length < 1) {
                        return;
                    }
                    var index = items.indexOf(evt.target);
                    if (prev && index > 0) {
                        index--;
                    } else if (!prev && index < items.length - 1) {
                        index++;
                    }
                    if (index < 0) {
                        index = 0;
                    }
                    this.setItemFocus(items[index]);
                },
                focusFirst: function focusFirst(evt) {
                    var items = this.getItems();
                    if (items.length > 0) {
                        this.setItemFocus(items[0]);
                    }
                },
                focusLast: function focusLast(evt) {
                    var items = this.getItems();
                    if (items.length > 0) {
                        this.setItemFocus([ items.length - 1 ]);
                    }
                },
                getItems: function getItems() {
                    var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["q"])(ITEM_SELECTOR, this.$el);
                    items.forEach(function(item) {
                        item.tabIndex = -1;
                    });
                    return items.filter(function(el) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b"])(el);
                    });
                }
            },
            mounted: function mounted() {
                if (this.keyNav) {
                    this.getItems();
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__button_toolbar__ = __webpack_require__(70);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bButtonToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a"],
            bBtnToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(19);
        var __WEBPACK_IMPORTED_MODULE_1__button_close__ = __webpack_require__(18);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bButton: __WEBPACK_IMPORTED_MODULE_0__button__["a"],
            bBtn: __WEBPACK_IMPORTED_MODULE_0__button__["a"],
            bButtonClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a"],
            bBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            deck: {
                type: Boolean,
                default: false
            },
            columns: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var staticClass = "card-group";
                if (props.columns) {
                    staticClass = "card-columns";
                }
                if (props.deck) {
                    staticClass = "card-deck";
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: staticClass
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(27);
        var __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__ = __webpack_require__(183);
        var __WEBPACK_IMPORTED_MODULE_3__utils_copyProps__ = __webpack_require__(26);
        var __WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__ = __webpack_require__(25);
        var __WEBPACK_IMPORTED_MODULE_7__card_body__ = __webpack_require__(31);
        var __WEBPACK_IMPORTED_MODULE_8__card_header__ = __webpack_require__(33);
        var __WEBPACK_IMPORTED_MODULE_9__card_footer__ = __webpack_require__(32);
        var __WEBPACK_IMPORTED_MODULE_10__card_img__ = __webpack_require__(34);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var cardImgProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a"])(__WEBPACK_IMPORTED_MODULE_10__card_img__["b"], __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a"].bind(null, "img"));
        cardImgProps.imgSrc.required = false;
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a"])({}, __WEBPACK_IMPORTED_MODULE_7__card_body__["b"], __WEBPACK_IMPORTED_MODULE_8__card_header__["b"], __WEBPACK_IMPORTED_MODULE_9__card_footer__["b"], cardImgProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a"])(__WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__["a"].props), {
            align: {
                type: String,
                default: null
            },
            noBody: {
                type: Boolean,
                default: false
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                var childNodes = [];
                var $slots = slots();
                var img = props.imgSrc ? h(__WEBPACK_IMPORTED_MODULE_10__card_img__["a"], {
                    props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a"])(cardImgProps, props, __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__["a"].bind(null, "img"))
                }) : null;
                if (img) {
                    if (props.imgTop || !props.imgBottom) {
                        childNodes.push(img);
                    }
                }
                if (props.header || $slots.header) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_8__card_header__["a"], {
                        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a"])(__WEBPACK_IMPORTED_MODULE_8__card_header__["b"], props)
                    }, $slots.header));
                }
                if (props.noBody) {
                    childNodes.push($slots.default);
                } else {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_7__card_body__["a"], {
                        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a"])(__WEBPACK_IMPORTED_MODULE_7__card_body__["b"], props)
                    }, $slots.default));
                }
                if (props.footer || $slots.footer) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_9__card_footer__["a"], {
                        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a"])(__WEBPACK_IMPORTED_MODULE_9__card_footer__["b"], props)
                    }, $slots.footer));
                }
                if (img && props.imgBottom) {
                    childNodes.push(img);
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card",
                    class: (_class = {}, _defineProperty(_class, "text-" + props.align, Boolean(props.align)), 
                    _defineProperty(_class, "bg-" + props.bgVariant, Boolean(props.bgVariant)), _defineProperty(_class, "border-" + props.borderVariant, Boolean(props.borderVariant)), 
                    _defineProperty(_class, "text-" + props.textVariant, Boolean(props.textVariant)), 
                    _class)
                }), childNodes);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(74);
        var __WEBPACK_IMPORTED_MODULE_1__card_header__ = __webpack_require__(33);
        var __WEBPACK_IMPORTED_MODULE_2__card_body__ = __webpack_require__(31);
        var __WEBPACK_IMPORTED_MODULE_3__card_footer__ = __webpack_require__(32);
        var __WEBPACK_IMPORTED_MODULE_4__card_img__ = __webpack_require__(34);
        var __WEBPACK_IMPORTED_MODULE_5__card_group__ = __webpack_require__(73);
        var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(1);
        var components = {
            bCard: __WEBPACK_IMPORTED_MODULE_0__card__["a"],
            bCardHeader: __WEBPACK_IMPORTED_MODULE_1__card_header__["a"],
            bCardBody: __WEBPACK_IMPORTED_MODULE_2__card_body__["a"],
            bCardFooter: __WEBPACK_IMPORTED_MODULE_3__card_footer__["a"],
            bCardImg: __WEBPACK_IMPORTED_MODULE_4__card_img__["a"],
            bCardGroup: __WEBPACK_IMPORTED_MODULE_5__card_group__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__image_img__ = __webpack_require__(21);
        var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(4);
        __webpack_exports__["a"] = {
            components: {
                bImg: __WEBPACK_IMPORTED_MODULE_0__image_img__["a"]
            },
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_id__["a"] ],
            render: function render(h) {
                var $slots = this.$slots;
                var img = $slots.img;
                if (!img && (this.imgSrc || this.imgBlank)) {
                    img = h("b-img", {
                        props: {
                            fluidGrow: true,
                            block: true,
                            src: this.imgSrc,
                            blank: this.imgBlank,
                            blankColor: this.imgBlankColor,
                            width: this.computedWidth,
                            height: this.computedHeight,
                            alt: this.imgAlt
                        }
                    });
                }
                var content = h(this.contentTag, {
                    class: this.contentClasses
                }, [ this.caption ? h(this.captionTag, {
                    domProps: {
                        innerHTML: this.caption
                    }
                }) : h(false), this.text ? h(this.textTag, {
                    domProps: {
                        innerHTML: this.text
                    }
                }) : h(false), $slots.default ]);
                return h("div", {
                    class: [ "carousel-item" ],
                    style: {
                        background: this.background
                    },
                    attrs: {
                        id: this.safeId(),
                        role: "listitem"
                    }
                }, [ img, content ]);
            },
            props: {
                imgSrc: {
                    type: String,
                    default: function _default() {
                        if (this && this.src) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a"])("b-carousel-slide: prop 'src' has been deprecated. Use 'img-src' instead");
                            return this.src;
                        }
                        return null;
                    }
                },
                src: {
                    type: String
                },
                imgAlt: {
                    type: String
                },
                imgWidth: {
                    type: [ Number, String ]
                },
                imgHeight: {
                    type: [ Number, String ]
                },
                imgBlank: {
                    type: Boolean,
                    default: false
                },
                imgBlankColor: {
                    type: String,
                    default: "transparent"
                },
                contentVisibleUp: {
                    type: String
                },
                contentTag: {
                    type: String,
                    default: "div"
                },
                caption: {
                    type: String
                },
                captionTag: {
                    type: String,
                    default: "h3"
                },
                text: {
                    type: String
                },
                textTag: {
                    type: String,
                    default: "p"
                },
                background: {
                    type: String
                }
            },
            computed: {
                contentClasses: function contentClasses() {
                    return [ "carousel-caption", this.contentVisibleUp ? "d-none" : "", this.contentVisibleUp ? "d-" + this.contentVisibleUp + "-block" : "" ];
                },
                computedWidth: function computedWidth() {
                    return this.imgWidth || this.$parent.imgWidth;
                },
                computedHeight: function computedHeight() {
                    return this.imgHeight || this.$parent.imgHeight;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__ = __webpack_require__(16);
        var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_id__ = __webpack_require__(4);
        var DIRECTION = {
            next: {
                dirClass: "carousel-item-left",
                overlayClass: "carousel-item-next"
            },
            prev: {
                dirClass: "carousel-item-right",
                overlayClass: "carousel-item-prev"
            }
        };
        var TRANS_DURATION = 600 + 50;
        var TransitionEndEvents = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "otransitionend oTransitionEnd",
            transition: "transitionend"
        };
        function getTransisionEndEvent(el) {
            for (var name in TransitionEndEvents) {
                if (el.style[name] !== undefined) {
                    return TransitionEndEvents[name];
                }
            }
            return null;
        }
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_3__mixins_id__["a"] ],
            render: function render(h) {
                var _this = this;
                var inner = h("div", {
                    ref: "inner",
                    class: [ "carousel-inner" ],
                    attrs: {
                        id: this.safeId("__BV_inner_"),
                        role: "list"
                    }
                }, [ this.$slots.default ]);
                var controls = h(false);
                if (this.controls) {
                    controls = [ h("a", {
                        class: [ "carousel-control-prev" ],
                        attrs: {
                            href: "#",
                            role: "button",
                            "aria-controls": this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this.prev();
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.prev();
                                }
                            }
                        }
                    }, [ h("span", {
                        class: [ "carousel-control-prev-icon" ],
                        attrs: {
                            "aria-hidden": "true"
                        }
                    }), h("span", {
                        class: [ "sr-only" ]
                    }, [ this.labelPrev ]) ]), h("a", {
                        class: [ "carousel-control-next" ],
                        attrs: {
                            href: "#",
                            role: "button",
                            "aria-controls": this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this.next();
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.next();
                                }
                            }
                        }
                    }, [ h("span", {
                        class: [ "carousel-control-next-icon" ],
                        attrs: {
                            "aria-hidden": "true"
                        }
                    }), h("span", {
                        class: [ "sr-only" ]
                    }, [ this.labelNext ]) ]) ];
                }
                var indicators = h("ol", {
                    class: [ "carousel-indicators" ],
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: this.indicators,
                        expression: "indicators"
                    } ],
                    attrs: {
                        id: this.safeId("__BV_indicators_"),
                        "aria-hidden": this.indicators ? "false" : "true",
                        "aria-label": this.labelIndicators,
                        "aria-owns": this.safeId("__BV_inner_")
                    }
                }, this.slides.map(function(slide, n) {
                    return h("li", {
                        key: "slide_" + n,
                        class: {
                            active: n === _this.index
                        },
                        attrs: {
                            role: "button",
                            id: _this.safeId("__BV_indicator_" + (n + 1) + "_"),
                            tabindex: _this.indicators ? "0" : "-1",
                            "aria-current": n === _this.index ? "true" : "false",
                            "aria-label": _this.labelGotoSlide + " " + (n + 1),
                            "aria-describedby": _this.slides[n].id || null,
                            "aria-controls": _this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                _this.setSlide(n);
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.setSlide(n);
                                }
                            }
                        }
                    });
                }));
                return h("div", {
                    class: [ "carousel", "slide" ],
                    style: {
                        background: this.background
                    },
                    attrs: {
                        role: "region",
                        id: this.safeId(),
                        "aria-busy": this.isSliding ? "true" : "false"
                    },
                    on: {
                        mouseenter: this.pause,
                        mouseleave: this.restart,
                        focusin: this.pause,
                        focusout: this.restart,
                        keydown: function keydown(evt) {
                            var keyCode = evt.keyCode;
                            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].LEFT || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].RIGHT) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this[keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].LEFT ? "prev" : "next"]();
                            }
                        }
                    }
                }, [ inner, controls, indicators ]);
            },
            data: function data() {
                return {
                    index: this.value || 0,
                    isSliding: false,
                    intervalId: null,
                    transitionEndEvent: null,
                    slides: [],
                    direction: null
                };
            },
            props: {
                labelPrev: {
                    type: String,
                    default: "Previous Slide"
                },
                labelNext: {
                    type: String,
                    default: "Next Slide"
                },
                labelGotoSlide: {
                    type: String,
                    default: "Goto Slide"
                },
                labelIndicators: {
                    type: String,
                    default: "Select a slide to display"
                },
                interval: {
                    type: Number,
                    default: 5e3
                },
                indicators: {
                    type: Boolean,
                    default: false
                },
                controls: {
                    type: Boolean,
                    default: false
                },
                imgWidth: {
                    type: [ Number, String ]
                },
                imgHeight: {
                    type: [ Number, String ]
                },
                background: {
                    type: String
                },
                value: {
                    type: Number,
                    default: 0
                }
            },
            computed: {
                isCycling: function isCycling() {
                    return Boolean(this.intervalId);
                }
            },
            methods: {
                setSlide: function setSlide(slide) {
                    var _this2 = this;
                    if (typeof document !== "undefined" && document.visibilityState && document.hidden) {
                        return;
                    }
                    var len = this.slides.length;
                    if (len === 0) {
                        return;
                    }
                    if (this.isSliding) {
                        this.$once("sliding-end", function() {
                            return _this2.setSlide(slide);
                        });
                        return;
                    }
                    slide = Math.floor(slide);
                    this.index = slide >= len ? 0 : slide >= 0 ? slide : len - 1;
                },
                prev: function prev() {
                    this.direction = "prev";
                    this.setSlide(this.index - 1);
                },
                next: function next() {
                    this.direction = "next";
                    this.setSlide(this.index + 1);
                },
                pause: function pause() {
                    if (this.isCycling) {
                        clearInterval(this.intervalId);
                        this.intervalId = null;
                        if (this.slides[this.index]) {
                            this.slides[this.index].tabIndex = 0;
                        }
                    }
                },
                start: function start() {
                    var _this3 = this;
                    if (!this.interval || this.isCycling) {
                        return;
                    }
                    this.slides.forEach(function(slide) {
                        slide.tabIndex = -1;
                    });
                    this.intervalId = setInterval(function() {
                        _this3.next();
                    }, Math.max(1e3, this.interval));
                },
                restart: function restart(evt) {
                    if (!this.$el.contains(document.activeElement)) {
                        this.start();
                    }
                },
                updateSlides: function updateSlides() {
                    this.pause();
                    this.slides = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q"])(".carousel-item", this.$refs.inner);
                    var numSlides = this.slides.length;
                    var index = Math.max(0, Math.min(Math.floor(this.index), numSlides - 1));
                    this.slides.forEach(function(slide, idx) {
                        var n = idx + 1;
                        if (idx === index) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d"])(slide, "active");
                        } else {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(slide, "active");
                        }
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(slide, "aria-current", idx === index ? "true" : "false");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(slide, "aria-posinset", String(n));
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(slide, "aria-setsize", String(numSlides));
                        slide.tabIndex = -1;
                    });
                    this.setSlide(index);
                    this.start();
                },
                calcDirection: function calcDirection() {
                    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var curIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var nextIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    if (!direction) {
                        return nextIndex > curIndex ? DIRECTION.next : DIRECTION.prev;
                    }
                    return DIRECTION[direction];
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.setSlide(newVal);
                    }
                },
                interval: function interval(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    if (!newVal) {
                        this.pause();
                    } else {
                        this.pause();
                        this.start();
                    }
                },
                index: function index(val, oldVal) {
                    var _this4 = this;
                    if (val === oldVal || this.isSliding) {
                        return;
                    }
                    var direction = this.calcDirection(this.direction, oldVal, val);
                    var currentSlide = this.slides[oldVal];
                    var nextSlide = this.slides[val];
                    if (!currentSlide || !nextSlide) {
                        return;
                    }
                    this.isSliding = true;
                    this.$emit("sliding-start", val);
                    this.$emit("input", this.index);
                    nextSlide.classList.add(direction.overlayClass);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v"])(nextSlide);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d"])(currentSlide, direction.dirClass);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d"])(nextSlide, direction.dirClass);
                    var called = false;
                    var onceTransEnd = function onceTransEnd(evt) {
                        if (called) {
                            return;
                        }
                        called = true;
                        if (_this4.transitionEndEvent) {
                            var events = _this4.transitionEndEvent.split(/\s+/);
                            events.forEach(function(event) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["g"])(currentSlide, event, onceTransEnd);
                            });
                        }
                        _this4._animationTimeout = null;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(nextSlide, direction.dirClass);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(nextSlide, direction.overlayClass);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d"])(nextSlide, "active");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(currentSlide, "active");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(currentSlide, direction.dirClass);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e"])(currentSlide, direction.overlayClass);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(currentSlide, "aria-current", "false");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(nextSlide, "aria-current", "true");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(currentSlide, "aria-hidden", "true");
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c"])(nextSlide, "aria-hidden", "false");
                        currentSlide.tabIndex = -1;
                        nextSlide.tabIndex = -1;
                        if (!_this4.isCycling) {
                            nextSlide.tabIndex = 0;
                            _this4.$nextTick(function() {
                                nextSlide.focus();
                            });
                        }
                        _this4.isSliding = false;
                        _this4.direction = null;
                        _this4.$nextTick(function() {
                            return _this4.$emit("sliding-end", val);
                        });
                    };
                    if (this.transitionEndEvent) {
                        var events = this.transitionEndEvent.split(/\s+/);
                        events.forEach(function(event) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["f"])(currentSlide, event, onceTransEnd);
                        });
                    }
                    this._animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
                }
            },
            created: function created() {
                this._animationTimeout = null;
            },
            mounted: function mounted() {
                this.transitionEndEvent = getTransisionEndEvent(this.$el) || null;
                this.updateSlides();
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__["a"])(this.$refs.inner, this.updateSlides.bind(this), {
                    subtree: false,
                    childList: true,
                    attributes: true,
                    attributeFilter: [ "id" ]
                });
            },
            beforeDestroy: function beforeDestroy() {
                clearInterval(this.intervalId);
                clearTimeout(this._animationTimeout);
                this.intervalId = null;
                this._animationTimeout = null;
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(77);
        var __WEBPACK_IMPORTED_MODULE_1__carousel_slide__ = __webpack_require__(76);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bCarousel: __WEBPACK_IMPORTED_MODULE_0__carousel__["a"],
            bCarouselSlide: __WEBPACK_IMPORTED_MODULE_1__carousel_slide__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__ = __webpack_require__(15);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var EVENT_STATE = "bv::collapse::state";
        var EVENT_ACCORDION = "bv::collapse::accordion";
        var EVENT_TOGGLE = "bv::toggle::collapse";
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__["a"] ],
            render: function render(h) {
                var content = h(this.tag, {
                    class: this.classObject,
                    directives: [ {
                        name: "show",
                        value: this.show
                    } ],
                    attrs: {
                        id: this.id || null
                    },
                    on: {
                        click: this.clickHandler
                    }
                }, [ this.$slots.default ]);
                return h("transition", {
                    props: {
                        enterClass: "",
                        enterActiveClass: "collapsing",
                        enterToClass: "",
                        leaveClass: "",
                        leaveActiveClass: "collapsing",
                        leaveToClass: ""
                    },
                    on: {
                        enter: this.onEnter,
                        afterEnter: this.onAfterEnter,
                        leave: this.onLeave,
                        afterLeave: this.onAfterLeave
                    }
                }, [ content ]);
            },
            data: function data() {
                return {
                    show: this.visible,
                    transitioning: false
                };
            },
            model: {
                prop: "visible",
                event: "input"
            },
            props: {
                id: {
                    type: String,
                    required: true
                },
                isNav: {
                    type: Boolean,
                    default: false
                },
                accordion: {
                    type: String,
                    default: null
                },
                visible: {
                    type: Boolean,
                    default: false
                },
                tag: {
                    type: String,
                    default: "div"
                }
            },
            watch: {
                visible: function visible(newVal) {
                    if (newVal !== this.show) {
                        this.show = newVal;
                    }
                },
                show: function show(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.emitState();
                    }
                }
            },
            computed: {
                classObject: function classObject() {
                    return {
                        "navbar-collapse": this.isNav,
                        collapse: !this.transitioning,
                        show: this.show && !this.transitioning
                    };
                }
            },
            methods: {
                toggle: function toggle() {
                    this.show = !this.show;
                },
                onEnter: function onEnter(el) {
                    el.style.height = 0;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v"])(el);
                    el.style.height = el.scrollHeight + "px";
                    this.transitioning = true;
                    this.$emit("show");
                },
                onAfterEnter: function onAfterEnter(el) {
                    el.style.height = null;
                    this.transitioning = false;
                    this.$emit("shown");
                },
                onLeave: function onLeave(el) {
                    el.style.height = "auto";
                    el.style.display = "block";
                    el.style.height = el.getBoundingClientRect().height + "px";
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v"])(el);
                    this.transitioning = true;
                    el.style.height = 0;
                    this.$emit("hide");
                },
                onAfterLeave: function onAfterLeave(el) {
                    el.style.height = null;
                    this.transitioning = false;
                    this.$emit("hidden");
                },
                emitState: function emitState() {
                    this.$emit("input", this.show);
                    this.$root.$emit(EVENT_STATE, this.id, this.show);
                    if (this.accordion && this.show) {
                        this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
                    }
                },
                clickHandler: function clickHandler(evt) {
                    var el = evt.target;
                    if (!this.isNav || !el || getComputedStyle(this.$el).display !== "block") {
                        return;
                    }
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a"])(el, "nav-link") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a"])(el, "dropdown-item")) {
                        this.show = false;
                    }
                },
                handleToggleEvt: function handleToggleEvt(target) {
                    if (target !== this.id) {
                        return;
                    }
                    this.toggle();
                },
                handleAccordionEvt: function handleAccordionEvt(openedId, accordion) {
                    if (!this.accordion || accordion !== this.accordion) {
                        return;
                    }
                    if (openedId === this.id) {
                        if (!this.show) {
                            this.toggle();
                        }
                    } else {
                        if (this.show) {
                            this.toggle();
                        }
                    }
                },
                handleResize: function handleResize() {
                    this.show = getComputedStyle(this.$el).display === "block";
                }
            },
            created: function created() {
                this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);
                this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
            },
            mounted: function mounted() {
                if (this.isNav && typeof document !== "undefined") {
                    window.addEventListener("resize", this.handleResize, false);
                    window.addEventListener("orientationchange", this.handleResize, false);
                    this.handleResize();
                }
                this.emitState();
            },
            beforeDestroy: function beforeDestroy() {
                if (this.isNav && typeof document !== "undefined") {
                    window.removeEventListener("resize", this.handleResize, false);
                    window.removeEventListener("orientationchange", this.handleResize, false);
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "dropdown-divider",
                    attrs: {
                        role: "separator"
                    }
                }));
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "h6"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "dropdown-header",
                    attrs: {
                        id: props.id || null
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            disabled: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, parent = _ref.parent, children = _ref.children;
                return h("button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    props: props,
                    staticClass: "dropdown-item",
                    attrs: {
                        role: "menuitem",
                        type: "button",
                        disabled: props.disabled
                    },
                    on: {
                        click: function click(e) {
                            parent.$root.$emit("clicked::link", e);
                        }
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__link_link__ = __webpack_require__(6);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__link_link__["c"])();
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(__WEBPACK_IMPORTED_MODULE_1__link_link__["a"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    props: props,
                    staticClass: "dropdown-item",
                    attrs: {
                        role: "menuitem"
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__ = __webpack_require__(151);
        var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(19);
        var __WEBPACK_IMPORTED_MODULE_3__dropdown_css__ = __webpack_require__(210);
        var __WEBPACK_IMPORTED_MODULE_3__dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dropdown_css__);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__["a"] ],
            components: {
                bButton: __WEBPACK_IMPORTED_MODULE_2__button_button__["a"]
            },
            render: function render(h) {
                var split = h(false);
                if (this.split) {
                    split = h("b-button", {
                        ref: "button",
                        props: {
                            disabled: this.disabled,
                            variant: this.variant,
                            size: this.size
                        },
                        attrs: {
                            id: this.safeId("_BV_button_")
                        },
                        on: {
                            click: this.click
                        }
                    }, [ this.$slots["button-content"] || this.$slots.text || this.text ]);
                }
                var toggle = h("b-button", {
                    ref: "toggle",
                    class: this.toggleClasses,
                    props: {
                        variant: this.variant,
                        size: this.size,
                        disabled: this.disabled
                    },
                    attrs: {
                        id: this.safeId("_BV_toggle_"),
                        "aria-haspopup": "true",
                        "aria-expanded": this.visible ? "true" : "false"
                    },
                    on: {
                        click: this.toggle,
                        keydown: this.toggle
                    }
                }, [ this.split ? h("span", {
                    class: [ "sr-only" ]
                }, [ this.toggleText ]) : this.$slots["button-content"] || this.$slots.text || this.text ]);
                var menu = h("div", {
                    ref: "menu",
                    class: this.menuClasses,
                    attrs: {
                        role: this.role,
                        "aria-labelledby": this.safeId(this.split ? "_BV_toggle_" : "_BV_button_")
                    },
                    on: {
                        mouseover: this.onMouseOver,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
                return h("div", {
                    attrs: {
                        id: this.safeId()
                    },
                    class: this.dropdownClasses
                }, [ split, toggle, menu ]);
            },
            props: {
                split: {
                    type: Boolean,
                    default: false
                },
                toggleText: {
                    type: String,
                    default: "Toggle Dropdown"
                },
                size: {
                    type: String,
                    default: null
                },
                variant: {
                    type: String,
                    default: null
                },
                menuClass: {
                    type: [ String, Array ],
                    default: null
                },
                toggleClass: {
                    type: [ String, Array ],
                    default: null
                },
                noCaret: {
                    type: Boolean,
                    default: false
                },
                role: {
                    type: String,
                    default: "menu"
                },
                boundary: {
                    type: [ String, Object ],
                    default: "scrollParent"
                }
            },
            computed: {
                dropdownClasses: function dropdownClasses() {
                    var position = "";
                    if (this.boundary !== "scrollParent" || !this.boundary) {
                        position = "position-static";
                    }
                    return [ "btn-group", "b-dropdown", "dropdown", this.dropup ? "dropup" : "", this.visible ? "show" : "", position ];
                },
                menuClasses: function menuClasses() {
                    return [ "dropdown-menu", {
                        "dropdown-menu-right": this.right,
                        show: this.visible
                    }, this.menuClass ];
                },
                toggleClasses: function toggleClasses() {
                    return [ {
                        "dropdown-toggle": !this.noCaret || this.split,
                        "dropdown-toggle-split": this.split
                    }, this.toggleClass ];
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            type: {
                type: String,
                default: "iframe",
                validator: function validator(str) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])([ "iframe", "embed", "video", "object", "img", "b-img", "b-img-lazy" ], str);
                }
            },
            tag: {
                type: String,
                default: "div"
            },
            aspect: {
                type: String,
                default: "16by9"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, {
                    ref: data.ref,
                    staticClass: "embed-responsive",
                    class: _defineProperty({}, "embed-responsive-" + props.aspect, Boolean(props.aspect))
                }, [ h(props.type, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    ref: "",
                    staticClass: "embed-responsive-item"
                }), children) ]);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__embed__ = __webpack_require__(85);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bEmbed: __WEBPACK_IMPORTED_MODULE_0__embed__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form_options__ = __webpack_require__(49);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_6__form_checkbox__ = __webpack_require__(36);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a"], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form_options__["a"] ],
            components: {
                bFormCheckbox: __WEBPACK_IMPORTED_MODULE_6__form_checkbox__["a"]
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var checks = this.formOptions.map(function(option, idx) {
                    return h("b-form-checkbox", {
                        key: "check_" + idx + "_opt",
                        props: {
                            id: _this.safeId("_BV_check_" + idx + "_opt_"),
                            name: _this.name,
                            value: option.value,
                            required: _this.name && _this.required,
                            disabled: option.disabled
                        }
                    }, [ h("span", {
                        domProps: {
                            innerHTML: option.text
                        }
                    }) ]);
                });
                return h("div", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        role: "group",
                        tabindex: "-1",
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    }
                }, [ $slots.first, checks, $slots.default ]);
            },
            data: function data() {
                return {
                    localChecked: this.checked || [],
                    is_RadioCheckGroup: true
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                checked: {
                    type: [ String, Number, Object, Array, Boolean ],
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: Boolean,
                    default: false
                },
                buttons: {
                    type: Boolean,
                    default: false
                },
                buttonVariant: {
                    type: String,
                    default: "secondary"
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.localChecked = this.checked;
                },
                localChecked: function localChecked(newVal, oldVal) {
                    this.$emit("input", newVal);
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    if (this.buttons) {
                        return [ "btn-group-toggle", this.stacked ? "btn-group-vertical" : "btn-group", this.size ? "btn-group-" + this.size : "", this.validated ? "was-validated" : "" ];
                    }
                    return [ this.sizeFormClass, this.stacked && this.custom ? "custom-controls-stacked" : "", this.validated ? "was-validated" : "" ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true" || this.ariaInvalid === "") {
                        return "true";
                    }
                    return this.get_State === false ? "true" : null;
                },
                get_State: function get_State() {
                    return this.computedState;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_checkbox__ = __webpack_require__(36);
        var __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__ = __webpack_require__(87);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a"],
            bCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a"],
            bCheck: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a"],
            bFormCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a"],
            bCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a"],
            bCheckGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_custom__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_custom__["a"] ],
            render: function render(h) {
                var input = h("input", {
                    ref: "input",
                    class: [ {
                        "form-control-file": this.plain,
                        "custom-file-input": this.custom,
                        focus: this.custom && this.hasFocus
                    }, this.stateClass ],
                    attrs: {
                        type: "file",
                        id: this.safeId(),
                        name: this.name,
                        disabled: this.disabled,
                        required: this.required,
                        capture: this.capture || null,
                        accept: this.accept || null,
                        multiple: this.multiple,
                        webkitdirectory: this.directory,
                        "aria-required": this.required ? "true" : null,
                        "aria-describedby": this.plain ? null : this.safeId("_BV_file_control_")
                    },
                    on: {
                        change: this.onFileChange,
                        focusin: this.focusHandler,
                        focusout: this.focusHandler
                    }
                });
                if (this.plain) {
                    return input;
                }
                var label = h("label", {
                    class: [ "custom-file-label", this.dragging ? "dragging" : null ],
                    attrs: {
                        id: this.safeId("_BV_file_control_")
                    }
                }, this.selectLabel);
                return h("div", {
                    class: [ "custom-file", "b-form-file", this.stateClass ],
                    attrs: {
                        id: this.safeId("_BV_file_outer_")
                    },
                    on: {
                        dragover: this.dragover
                    }
                }, [ input, label ]);
            },
            data: function data() {
                return {
                    selectedFile: null,
                    dragging: false,
                    hasFocus: false
                };
            },
            props: {
                accept: {
                    type: String,
                    default: ""
                },
                capture: {
                    type: Boolean,
                    default: false
                },
                placeholder: {
                    type: String,
                    default: undefined
                },
                multiple: {
                    type: Boolean,
                    default: false
                },
                directory: {
                    type: Boolean,
                    default: false
                },
                noTraverse: {
                    type: Boolean,
                    default: false
                },
                noDrop: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                selectLabel: function selectLabel() {
                    if (!this.selectedFile || this.selectedFile.length === 0) {
                        return this.placeholder;
                    }
                    if (this.multiple) {
                        if (this.selectedFile.length === 1) {
                            return this.selectedFile[0].name;
                        }
                        return this.selectedFile.map(function(file) {
                            return file.name;
                        }).join(", ");
                    }
                    return this.selectedFile.name;
                }
            },
            watch: {
                selectedFile: function selectedFile(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    if (!newVal && this.multiple) {
                        this.$emit("input", []);
                    } else {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                focusHandler: function focusHandler(evt) {
                    if (this.plain || evt.type === "focusout") {
                        this.hasFocus = false;
                    } else {
                        this.hasFocus = true;
                    }
                },
                reset: function reset() {
                    try {
                        this.$refs.input.value = "";
                    } catch (e) {}
                    this.$refs.input.type = "";
                    this.$refs.input.type = "file";
                    this.selectedFile = this.multiple ? [] : null;
                },
                onFileChange: function onFileChange(evt) {
                    var _this = this;
                    this.$emit("change", evt);
                    var items = evt.dataTransfer && evt.dataTransfer.items;
                    if (items && !this.noTraverse) {
                        var queue = [];
                        for (var i = 0; i < items.length; i++) {
                            var item = items[i].webkitGetAsEntry();
                            if (item) {
                                queue.push(this.traverseFileTree(item));
                            }
                        }
                        Promise.all(queue).then(function(filesArr) {
                            _this.setFiles(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a"])(filesArr));
                        });
                        return;
                    }
                    this.setFiles(evt.target.files || evt.dataTransfer.files);
                },
                setFiles: function setFiles(files) {
                    if (!files) {
                        this.selectedFile = null;
                        return;
                    }
                    if (!this.multiple) {
                        this.selectedFile = files[0];
                        return;
                    }
                    var filesArray = [];
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].type.match(this.accept)) {
                            filesArray.push(files[i]);
                        }
                    }
                    this.selectedFile = filesArray;
                },
                dragover: function dragover(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.noDrop || !this.custom) {
                        return;
                    }
                    this.dragging = true;
                    evt.dataTransfer.dropEffect = "copy";
                },
                dragleave: function dragleave(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.dragging = false;
                },
                drop: function drop(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.noDrop) {
                        return;
                    }
                    this.dragging = false;
                    if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                        this.onFileChange(evt);
                    }
                },
                traverseFileTree: function traverseFileTree(item, path) {
                    var _this2 = this;
                    return new Promise(function(resolve) {
                        path = path || "";
                        if (item.isFile) {
                            item.file(function(file) {
                                file.$path = path;
                                resolve(file);
                            });
                        } else if (item.isDirectory) {
                            item.createReader().readEntries(function(entries) {
                                var queue = [];
                                for (var i = 0; i < entries.length; i++) {
                                    queue.push(_this2.traverseFileTree(entries[i], path + item.name + "/"));
                                }
                                Promise.all(queue).then(function(filesArr) {
                                    resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a"])(filesArr));
                                });
                            });
                        }
                    });
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(89);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a"],
            bFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_4__layout_form_row__ = __webpack_require__(24);
        var __WEBPACK_IMPORTED_MODULE_5__form_form_text__ = __webpack_require__(39);
        var __WEBPACK_IMPORTED_MODULE_6__form_form_invalid_feedback__ = __webpack_require__(38);
        var __WEBPACK_IMPORTED_MODULE_7__form_form_valid_feedback__ = __webpack_require__(40);
        var SELECTOR = "input:not(:disabled),textarea:not(:disabled),select:not(:disabled)";
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a"] ],
            components: {
                bFormRow: __WEBPACK_IMPORTED_MODULE_4__layout_form_row__["a"],
                bFormText: __WEBPACK_IMPORTED_MODULE_5__form_form_text__["a"],
                bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_6__form_form_invalid_feedback__["a"],
                bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_7__form_form_valid_feedback__["a"]
            },
            render: function render(h) {
                var $slots = this.$slots;
                var legend = h(false);
                if (this.hasLabel) {
                    var children = $slots["label"];
                    var legendTag = this.labelFor ? "label" : "legend";
                    var legendDomProps = children ? {} : {
                        innerHTML: this.label
                    };
                    var legendAttrs = {
                        id: this.labelId,
                        for: this.labelFor || null
                    };
                    var legendClick = this.labelFor || this.labelSrOnly ? {} : {
                        click: this.legendClick
                    };
                    if (this.horizontal) {
                        if (this.labelSrOnly) {
                            children = h(legendTag, {
                                class: [ "sr-only" ],
                                attrs: legendAttrs,
                                domProps: legendDomProps
                            }, children);
                            legend = h("div", {
                                class: this.labelLayoutClasses
                            }, [ children ]);
                        } else {
                            legend = h(legendTag, {
                                class: [ this.labelLayoutClasses, this.labelClasses ],
                                attrs: legendAttrs,
                                domProps: legendDomProps,
                                on: legendClick
                            }, children);
                        }
                    } else {
                        legend = h(legendTag, {
                            class: this.labelSrOnly ? [ "sr-only" ] : this.labelClasses,
                            attrs: legendAttrs,
                            domProps: legendDomProps,
                            on: legendClick
                        }, children);
                    }
                } else if (this.horizontal) {
                    legend = h("div", {
                        class: this.labelLayoutClasses
                    });
                }
                var invalidFeedback = h(false);
                if (this.hasInvalidFeedback) {
                    var domProps = {};
                    if (!$slots["invalid-feedback"] && !$slots["feedback"]) {
                        domProps = {
                            innerHTML: this.invalidFeedback || this.feedback || ""
                        };
                    }
                    invalidFeedback = h("b-form-invalid-feedback", {
                        props: {
                            id: this.invalidFeedbackId,
                            forceShow: this.computedState === false
                        },
                        attrs: {
                            role: "alert",
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                        },
                        domProps: domProps
                    }, $slots["invalid-feedback"] || $slots["feedback"]);
                }
                var validFeedback = h(false);
                if (this.hasValidFeedback) {
                    var _domProps = $slots["valid-feedback"] ? {} : {
                        innerHTML: this.validFeedback || ""
                    };
                    validFeedback = h("b-form-valid-feedback", {
                        props: {
                            id: this.validFeedbackId,
                            forceShow: this.computedState === true
                        },
                        attrs: {
                            role: "alert",
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                        },
                        domProps: _domProps
                    }, $slots["valid-feedback"]);
                }
                var description = h(false);
                if (this.hasDescription) {
                    var _domProps2 = $slots["description"] ? {} : {
                        innerHTML: this.description || ""
                    };
                    description = h("b-form-text", {
                        attrs: {
                            id: this.descriptionId
                        },
                        domProps: _domProps2
                    }, $slots["description"]);
                }
                var content = h("div", {
                    ref: "content",
                    class: this.inputLayoutClasses,
                    attrs: this.labelFor ? {} : {
                        role: "group",
                        "aria-labelledby": this.labelId
                    }
                }, [ $slots["default"], invalidFeedback, validFeedback, description ]);
                return h(this.labelFor ? "div" : "fieldset", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        disabled: this.disabled,
                        role: "group",
                        "aria-invalid": this.computedState === false ? "true" : null,
                        "aria-labelledby": this.labelId,
                        "aria-describedby": this.labelFor ? null : this.describedByIds
                    }
                }, this.horizontal ? [ h("b-form-row", {}, [ legend, content ]) ] : [ legend, content ]);
            },
            props: {
                horizontal: {
                    type: Boolean,
                    default: false
                },
                labelCols: {
                    type: [ Number, String ],
                    default: 3,
                    validator: function validator(value) {
                        if (Number(value) >= 1 && Number(value) <= 11) {
                            return true;
                        }
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warn__["a"])("b-form-group: label-cols must be a value between 1 and 11");
                        return false;
                    }
                },
                breakpoint: {
                    type: String,
                    default: "sm"
                },
                labelTextAlign: {
                    type: String,
                    default: null
                },
                label: {
                    type: String,
                    default: null
                },
                labelFor: {
                    type: String,
                    default: null
                },
                labelSize: {
                    type: String,
                    default: null
                },
                labelSrOnly: {
                    type: Boolean,
                    default: false
                },
                labelClass: {
                    type: [ String, Array ],
                    default: null
                },
                description: {
                    type: String,
                    default: null
                },
                invalidFeedback: {
                    type: String,
                    default: null
                },
                feedback: {
                    type: String,
                    default: null
                },
                validFeedback: {
                    type: String,
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    return [ "b-form-group", "form-group", this.validated ? "was-validated" : null, this.stateClass ];
                },
                labelClasses: function labelClasses() {
                    return [ "col-form-label", this.labelSize ? "col-form-label-" + this.labelSize : null, this.labelTextAlign ? "text-" + this.labelTextAlign : null, this.horizontal ? null : "pt-0", this.labelClass ];
                },
                labelLayoutClasses: function labelLayoutClasses() {
                    return [ this.horizontal ? "col-" + this.breakpoint + "-" + this.labelCols : null ];
                },
                inputLayoutClasses: function inputLayoutClasses() {
                    return [ this.horizontal ? "col-" + this.breakpoint + "-" + (12 - Number(this.labelCols)) : null ];
                },
                hasLabel: function hasLabel() {
                    return this.label || this.$slots["label"];
                },
                hasDescription: function hasDescription() {
                    return this.description || this.$slots["description"];
                },
                hasInvalidFeedback: function hasInvalidFeedback() {
                    if (this.computedState === true) {
                        return false;
                    }
                    return this.invalidFeedback || this.feedback || this.$slots["invalid-feedback"] || this.$slots["feedback"];
                },
                hasValidFeedback: function hasValidFeedback() {
                    if (this.computedState === false) {
                        return false;
                    }
                    return this.validFeedback || this.$slots["valid-feedback"];
                },
                labelId: function labelId() {
                    return this.hasLabel ? this.safeId("_BV_label_") : null;
                },
                descriptionId: function descriptionId() {
                    return this.hasDescription ? this.safeId("_BV_description_") : null;
                },
                invalidFeedbackId: function invalidFeedbackId() {
                    return this.hasInvalidFeedback ? this.safeId("_BV_feedback_invalid_") : null;
                },
                validFeedbackId: function validFeedbackId() {
                    return this.hasValidFeedback ? this.safeId("_BV_feedback_valid_") : null;
                },
                describedByIds: function describedByIds() {
                    return [ this.descriptionId, this.invalidFeedbackId, this.validFeedbackId ].filter(function(i) {
                        return i;
                    }).join(" ") || null;
                }
            },
            watch: {
                describedByIds: function describedByIds(add, remove) {
                    if (add !== remove) {
                        this.setInputDescribedBy(add, remove);
                    }
                }
            },
            methods: {
                legendClick: function legendClick(evt) {
                    var tagName = evt.target ? evt.target.tagName : "";
                    if (/^(input|select|textarea|label)$/i.test(tagName)) {
                        return;
                    }
                    var inputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["q"])(SELECTOR, this.$refs.content).filter(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["b"]);
                    if (inputs[0] && inputs[0].focus) {
                        inputs[0].focus();
                    }
                },
                setInputDescribedBy: function setInputDescribedBy(add, remove) {
                    if (this.labelFor && typeof document !== "undefined") {
                        var input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["i"])("#" + this.labelFor, this.$refs.content);
                        if (input) {
                            var adb = "aria-describedby";
                            var ids = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["j"])(input, adb) || "").split(/\s+/);
                            remove = (remove || "").split(/\s+/);
                            ids = ids.filter(function(id) {
                                return remove.indexOf(id) === -1;
                            }).concat(add || "").join(" ").trim();
                            if (ids) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(input, adb, ids);
                            } else {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["k"])(input, adb);
                            }
                        }
                    }
                }
            },
            mounted: function mounted() {
                var _this = this;
                this.$nextTick(function() {
                    _this.setInputDescribedBy(_this.describedByIds);
                });
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_group__ = __webpack_require__(91);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormGroup: __WEBPACK_IMPORTED_MODULE_0__form_group__["a"],
            bFormFieldset: __WEBPACK_IMPORTED_MODULE_0__form_group__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_5__form_input_css__ = __webpack_require__(211);
        var __WEBPACK_IMPORTED_MODULE_5__form_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__form_input_css__);
        var TYPES = [ "text", "password", "email", "number", "url", "tel", "search", "range", "color", "date", "time", "datetime", "datetime-local", "month", "week" ];
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a"] ],
            render: function render(h) {
                return h("input", {
                    ref: "input",
                    class: this.inputClass,
                    domProps: {
                        value: this.localValue
                    },
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        type: this.localType,
                        disabled: this.disabled,
                        required: this.required,
                        readonly: this.readonly || this.plaintext,
                        placeholder: this.placeholder,
                        autocomplete: this.autocomplete || null,
                        step: this.step || null,
                        min: this.min || null,
                        max: this.max || null,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        input: this.onInput,
                        change: this.onChange
                    }
                });
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            props: {
                value: {
                    default: null
                },
                type: {
                    type: String,
                    default: "text",
                    validator: function validator(type) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["d"])(TYPES, type);
                    }
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                readonly: {
                    type: Boolean,
                    default: false
                },
                plaintext: {
                    type: Boolean,
                    default: false
                },
                autocomplete: {
                    type: String,
                    default: null
                },
                placeholder: {
                    type: String,
                    default: null
                },
                formatter: {
                    type: Function
                },
                lazyFormatter: {
                    type: Boolean,
                    default: false
                },
                step: {
                    type: Number,
                    default: null
                },
                min: {
                    type: Number,
                    default: null
                },
                max: {
                    type: Number,
                    default: null
                }
            },
            computed: {
                localType: function localType() {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["d"])(TYPES, this.type) ? this.type : "text";
                },
                inputClass: function inputClass() {
                    return [ this.plaintext ? "form-control-plaintext" : "form-control", this.sizeFormClass, this.stateClass ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (!this.ariaInvalid || this.ariaInvalid === "false") {
                        return this.computedState === false ? "true" : null;
                    }
                    if (this.ariaInvalid === true) {
                        return "true";
                    }
                    return this.ariaInvalid;
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.localValue = newVal;
                    }
                },
                localValue: function localValue(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                format: function format(value, e) {
                    if (this.formatter) {
                        var formattedValue = this.formatter(value, e);
                        if (formattedValue !== value) {
                            return formattedValue;
                        }
                    }
                    return value;
                },
                onInput: function onInput(evt) {
                    var value = evt.target.value;
                    if (this.lazyFormatter) {
                        this.localValue = value;
                    } else {
                        this.localValue = this.format(value, evt);
                    }
                },
                onChange: function onChange(evt) {
                    this.localValue = this.format(evt.target.value, evt);
                    this.$emit("change", this.localValue);
                },
                focus: function focus() {
                    if (!this.disabled) {
                        this.$el.focus();
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(93);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a"],
            bInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__ = __webpack_require__(49);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_6__form_radio__ = __webpack_require__(37);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a"], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__["a"] ],
            components: {
                bFormRadio: __WEBPACK_IMPORTED_MODULE_6__form_radio__["a"]
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var radios = this.formOptions.map(function(option, idx) {
                    return h("b-form-radio", {
                        key: "radio_" + idx + "_opt",
                        props: {
                            id: _this.safeId("_BV_radio_" + idx + "_opt_"),
                            name: _this.name,
                            value: option.value,
                            required: Boolean(_this.name && _this.required),
                            disabled: option.disabled
                        }
                    }, [ h("span", {
                        domProps: {
                            innerHTML: option.text
                        }
                    }) ]);
                });
                return h("div", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        role: "radiogroup",
                        tabindex: "-1",
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    }
                }, [ $slots.first, radios, $slots.default ]);
            },
            data: function data() {
                return {
                    localChecked: this.checked,
                    is_RadioCheckGroup: true
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                checked: {
                    type: [ String, Object, Number, Boolean ],
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: Boolean,
                    default: false
                },
                buttons: {
                    type: Boolean,
                    default: false
                },
                buttonVariant: {
                    type: String,
                    default: "secondary"
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.localChecked = this.checked;
                },
                localChecked: function localChecked(newVal, oldVal) {
                    this.$emit("input", newVal);
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    if (this.buttons) {
                        return [ "btn-group-toggle", this.stacked ? "btn-group-vertical" : "btn-group", this.size ? "btn-group-" + this.size : "", this.validated ? "was-validated" : "" ];
                    }
                    return [ this.sizeFormClass, this.stacked && this.custom ? "custom-controls-stacked" : "", this.validated ? "was-validated" : "" ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true" || this.ariaInvalid === "") {
                        return "true";
                    }
                    return this.get_State === false ? "true" : null;
                },
                get_State: function get_State() {
                    return this.computedState;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_radio__ = __webpack_require__(37);
        var __WEBPACK_IMPORTED_MODULE_1__form_radio_group__ = __webpack_require__(95);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a"],
            bRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a"],
            bFormRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a"],
            bRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__ = __webpack_require__(49);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(3);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a"], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__["a"] ],
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var options = this.formOptions.map(function(option, index) {
                    return h("option", {
                        key: "option_" + index + "_opt",
                        attrs: {
                            disabled: Boolean(option.disabled)
                        },
                        domProps: {
                            innerHTML: option.text,
                            value: option.value
                        }
                    });
                });
                return h("select", {
                    ref: "input",
                    class: this.inputClass,
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.localValue,
                        expression: "localValue"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        multiple: this.multiple || null,
                        size: this.computedSelectSize,
                        disabled: this.disabled,
                        required: this.required,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        change: function change(evt) {
                            var target = evt.target;
                            var selectedVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a"])(target.options).filter(function(o) {
                                return o.selected;
                            }).map(function(o) {
                                return "_value" in o ? o._value : o.value;
                            });
                            _this.localValue = target.multiple ? selectedVal : selectedVal[0];
                            _this.$emit("change", _this.localValue);
                        }
                    }
                }, [ $slots.first, options, $slots.default ]);
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            watch: {
                value: function value(newVal, oldVal) {
                    this.localValue = newVal;
                },
                localValue: function localValue(newVal, oldVal) {
                    this.$emit("input", this.localValue);
                }
            },
            props: {
                value: {},
                multiple: {
                    type: Boolean,
                    default: false
                },
                selectSize: {
                    type: Number,
                    default: 0
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                }
            },
            computed: {
                computedSelectSize: function computedSelectSize() {
                    return !this.plain && this.selectSize === 0 ? null : this.selectSize;
                },
                inputClass: function inputClass() {
                    return [ "form-control", this.stateClass, this.sizeFormClass, this.plain ? null : "custom-select", this.plain || !this.size ? null : "custom-select-" + this.size ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true") {
                        return "true";
                    }
                    return this.stateClass === "is-invalid" ? "true" : null;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_select__ = __webpack_require__(97);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a"],
            bSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(9);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(8);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a"], __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a"] ],
            render: function render(h) {
                var _this = this;
                return h("textarea", {
                    ref: "input",
                    class: this.inputClass,
                    style: this.inputStyle,
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.localValue,
                        expression: "localValue"
                    } ],
                    domProps: {
                        value: this.value
                    },
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        disabled: this.disabled,
                        placeholder: this.placeholder,
                        required: this.required,
                        autocomplete: this.autocomplete || null,
                        readonly: this.readonly || this.plaintext,
                        rows: this.rowsCount,
                        wrap: this.wrap || null,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        input: function input(evt) {
                            _this.localValue = evt.target.value;
                        }
                    }
                });
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            props: {
                value: {
                    type: String,
                    default: ""
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                readonly: {
                    type: Boolean,
                    default: false
                },
                plaintext: {
                    type: Boolean,
                    default: false
                },
                autocomplete: {
                    type: String,
                    default: null
                },
                placeholder: {
                    type: String,
                    default: null
                },
                rows: {
                    type: [ Number, String ],
                    default: null
                },
                maxRows: {
                    type: [ Number, String ],
                    default: null
                },
                wrap: {
                    type: String,
                    default: "soft"
                },
                noResize: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                rowsCount: function rowsCount() {
                    var rows = parseInt(this.rows, 10) || 1;
                    var maxRows = parseInt(this.maxRows, 10) || 0;
                    var lines = (this.localValue || "").toString().split("\n").length;
                    return maxRows ? Math.min(maxRows, Math.max(rows, lines)) : Math.max(rows, lines);
                },
                inputClass: function inputClass() {
                    return [ this.plaintext ? "form-control-plaintext" : "form-control", this.sizeFormClass, this.stateClass ];
                },
                inputStyle: function inputStyle() {
                    return {
                        width: this.plaintext ? "100%" : null,
                        resize: this.noResize ? "none" : null
                    };
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (!this.ariaInvalid || this.ariaInvalid === "false") {
                        return this.computedState === false ? "true" : null;
                    }
                    if (this.ariaInvalid === true) {
                        return "true";
                    }
                    return this.ariaInvalid;
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.localValue = newVal;
                    }
                },
                localValue: function localValue(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                focus: function focus() {
                    if (!this.disabled) {
                        this.$el.focus();
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_textarea__ = __webpack_require__(99);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bFormTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a"],
            bTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(41);
        var __WEBPACK_IMPORTED_MODULE_1__form_row__ = __webpack_require__(169);
        var __WEBPACK_IMPORTED_MODULE_2__form_text__ = __webpack_require__(39);
        var __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__ = __webpack_require__(38);
        var __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__ = __webpack_require__(40);
        var __WEBPACK_IMPORTED_MODULE_5__utils_plugins__ = __webpack_require__(1);
        var components = {
            bForm: __WEBPACK_IMPORTED_MODULE_0__form__["a"],
            bFormRow: __WEBPACK_IMPORTED_MODULE_1__form_row__["a"],
            bFormText: __WEBPACK_IMPORTED_MODULE_2__form_text__["a"],
            bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a"],
            bFormFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a"],
            bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(21);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var THROTTLE = 100;
        __webpack_exports__["a"] = {
            components: {
                bImg: __WEBPACK_IMPORTED_MODULE_0__img__["a"]
            },
            render: function render(h) {
                return h("b-img", {
                    props: {
                        src: this.computedSrc,
                        alt: this.alt,
                        blank: this.computedBlank,
                        blankColor: this.blankColor,
                        width: this.computedWidth,
                        height: this.computedHeight,
                        fluid: this.fluid,
                        fluidGrow: this.fluidGrow,
                        block: this.block,
                        thumbnail: this.thumbnail,
                        rounded: this.rounded,
                        left: this.left,
                        right: this.right,
                        center: this.center
                    }
                });
            },
            data: function data() {
                return {
                    isShown: false,
                    scrollTimeout: null
                };
            },
            props: {
                src: {
                    type: String,
                    default: null,
                    required: true
                },
                alt: {
                    type: String,
                    default: null
                },
                width: {
                    type: [ Number, String ],
                    default: null
                },
                height: {
                    type: [ Number, String ],
                    default: null
                },
                blankSrc: {
                    type: String,
                    default: null
                },
                blankColor: {
                    type: String,
                    default: "transparent"
                },
                blankWidth: {
                    type: [ Number, String ],
                    default: null
                },
                blankHeight: {
                    type: [ Number, String ],
                    default: null
                },
                fluid: {
                    type: Boolean,
                    default: false
                },
                fluidGrow: {
                    type: Boolean,
                    default: false
                },
                block: {
                    type: Boolean,
                    default: false
                },
                thumbnail: {
                    type: Boolean,
                    default: false
                },
                rounded: {
                    type: [ Boolean, String ],
                    default: false
                },
                left: {
                    type: Boolean,
                    default: false
                },
                right: {
                    type: Boolean,
                    default: false
                },
                center: {
                    type: Boolean,
                    default: false
                },
                offset: {
                    type: [ Number, String ],
                    default: 360
                },
                throttle: {
                    type: [ Number, String ],
                    default: THROTTLE
                }
            },
            computed: {
                computedSrc: function computedSrc() {
                    return !this.blankSrc || this.isShown ? this.src : this.blankSrc;
                },
                computedBlank: function computedBlank() {
                    return !(this.isShown || this.blankSrc);
                },
                computedWidth: function computedWidth() {
                    return this.isShown ? this.width : this.blankWidth || this.width;
                },
                computedHeight: function computedHeight() {
                    return this.isShown ? this.height : this.blankHeight || this.height;
                }
            },
            mounted: function mounted() {
                this.setListeners(true);
                this.checkView();
            },
            activated: function activated() {
                this.setListeners(true);
                this.checkView();
            },
            deactivated: function deactivated() {
                this.setListeners(false);
            },
            beforeDdestroy: function beforeDdestroy() {
                this.setListeners(false);
            },
            methods: {
                setListeners: function setListeners(on) {
                    clearTimeout(this.scrollTimer);
                    this.scrollTimout = null;
                    var root = window;
                    if (on) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f"])(root, "scroll", this.onScroll);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f"])(root, "resize", this.onScroll);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f"])(root, "orientationchange", this.onScroll);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["g"])(root, "scroll", this.onScroll);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["g"])(root, "resize", this.onScroll);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["g"])(root, "orientationchange", this.onScroll);
                    }
                },
                checkView: function checkView() {
                    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["b"])(this.$el)) {
                        return;
                    }
                    var offset = parseInt(this.offset, 10) || 0;
                    var docElement = document.documentElement;
                    var view = {
                        l: 0 - offset,
                        t: 0 - offset,
                        b: docElement.clientHeight + offset,
                        r: docElement.clientWidth + offset
                    };
                    var box = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["r"])(this.$el);
                    if (box.right >= view.l && box.bottom >= view.t && box.left <= view.r && box.top <= view.b) {
                        this.isShown = true;
                        this.setListeners(false);
                    }
                },
                onScroll: function onScroll() {
                    if (this.isShown) {
                        this.setListeners(false);
                    } else {
                        clearTimeout(this.scrollTimeout);
                        this.scrollTimeout = setTimeout(this.checkView, parseInt(this.throttle, 10) || THROTTLE);
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(21);
        var __WEBPACK_IMPORTED_MODULE_1__img_lazy__ = __webpack_require__(102);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bImg: __WEBPACK_IMPORTED_MODULE_0__img__["a"],
            bImgLazy: __WEBPACK_IMPORTED_MODULE_1__img_lazy__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(1);
        var __WEBPACK_IMPORTED_MODULE_1__input_group__ = __webpack_require__(105);
        var __WEBPACK_IMPORTED_MODULE_2__input_group_addon__ = __webpack_require__(22);
        var __WEBPACK_IMPORTED_MODULE_3__input_group_prepend__ = __webpack_require__(43);
        var __WEBPACK_IMPORTED_MODULE_4__input_group_append__ = __webpack_require__(42);
        var __WEBPACK_IMPORTED_MODULE_5__input_group_text__ = __webpack_require__(23);
        var components = {
            bInputGroup: __WEBPACK_IMPORTED_MODULE_1__input_group__["a"],
            bInputGroupAddon: __WEBPACK_IMPORTED_MODULE_2__input_group_addon__["a"],
            bInputGroupPrepend: __WEBPACK_IMPORTED_MODULE_3__input_group_prepend__["a"],
            bInputGroupAppend: __WEBPACK_IMPORTED_MODULE_4__input_group_append__["a"],
            bInputGroupText: __WEBPACK_IMPORTED_MODULE_5__input_group_text__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__input_group_prepend__ = __webpack_require__(43);
        var __WEBPACK_IMPORTED_MODULE_2__input_group_append__ = __webpack_require__(42);
        var __WEBPACK_IMPORTED_MODULE_3__input_group_text__ = __webpack_require__(23);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            id: {
                type: String,
                default: null
            },
            size: {
                type: String,
                default: null
            },
            prepend: {
                type: String,
                default: null
            },
            append: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var $slots = slots();
                var childNodes = [];
                if (props.prepend) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__input_group_prepend__["a"], [ h(__WEBPACK_IMPORTED_MODULE_3__input_group_text__["a"], {
                        domProps: {
                            innerHTML: props.prepend
                        }
                    }) ]));
                }
                if ($slots.prepend) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__input_group_prepend__["a"], $slots.prepend));
                }
                childNodes.push($slots.default);
                if (props.append) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__input_group_append__["a"], [ h(__WEBPACK_IMPORTED_MODULE_3__input_group_text__["a"], {
                        domProps: {
                            innerHTML: props.append
                        }
                    }) ]));
                }
                if ($slots.append) {
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__input_group_append__["a"], $slots.append));
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group",
                    class: _defineProperty({}, "input-group-" + props.size, Boolean(props.size)),
                    attrs: {
                        id: props.id || null,
                        role: "group"
                    }
                }), childNodes);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__jumbotron__ = __webpack_require__(107);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bJumbotron: __WEBPACK_IMPORTED_MODULE_0__jumbotron__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__layout_container__ = __webpack_require__(44);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            fluid: {
                type: Boolean,
                default: false
            },
            containerFluid: {
                type: Boolean,
                default: false
            },
            header: {
                type: String,
                default: null
            },
            headerTag: {
                type: String,
                default: "h1"
            },
            headerLevel: {
                type: [ Number, String ],
                default: "3"
            },
            lead: {
                type: String,
                default: null
            },
            leadTag: {
                type: String,
                default: "p"
            },
            tag: {
                type: String,
                default: "div"
            },
            bgVariant: {
                type: String,
                default: null
            },
            borderVariant: {
                type: String,
                default: null
            },
            textVariant: {
                type: String,
                default: null
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var childNodes = [];
                var $slots = slots();
                if (props.header || $slots.header) {
                    childNodes.push(h(props.headerTag, {
                        class: _defineProperty({}, "display-" + props.headerLevel, Boolean(props.headerLevel))
                    }, $slots.header || props.header));
                }
                if (props.lead || $slots.lead) {
                    childNodes.push(h(props.leadTag, {
                        staticClass: "lead"
                    }, $slots.lead || props.lead));
                }
                if ($slots.default) {
                    childNodes.push($slots.default);
                }
                if (props.fluid) {
                    childNodes = [ h(__WEBPACK_IMPORTED_MODULE_1__layout_container__["a"], {
                        props: {
                            fluid: props.containerFluid
                        }
                    }, childNodes) ];
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "jumbotron",
                    class: (_class2 = {
                        "jumbotron-fluid": props.fluid
                    }, _defineProperty(_class2, "text-" + props.textVariant, Boolean(props.textVariant)), 
                    _defineProperty(_class2, "bg-" + props.bgVariant, Boolean(props.bgVariant)), _defineProperty(_class2, "border-" + props.borderVariant, Boolean(props.borderVariant)), 
                    _defineProperty(_class2, "border", Boolean(props.borderVariant)), _class2)
                }), childNodes);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_memoize__ = __webpack_require__(178);
        var __WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__ = __webpack_require__(182);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        function boolStrNum() {
            return {
                type: [ Boolean, String, Number ],
                default: false
            };
        }
        function strNum() {
            return {
                type: [ String, Number ],
                default: null
            };
        }
        var computeBkPtClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_memoize__["a"])(function computeBkPt(type, breakpoint, val) {
            var className = type;
            if (val === false || val === null || val === undefined) {
                return undefined;
            }
            if (breakpoint) {
                className += "-" + breakpoint;
            }
            if (type === "col" && (val === "" || val === true)) {
                return className.toLowerCase();
            }
            className += "-" + val;
            return className.toLowerCase();
        });
        var BREAKPOINTS = [ "sm", "md", "lg", "xl" ];
        var breakpointCol = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[breakpoint] = boolStrNum(), propMap;
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["f"])(null));
        var breakpointOffset = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__["a"])(breakpoint, "offset")] = strNum(), 
            propMap;
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["f"])(null));
        var breakpointOrder = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__["a"])(breakpoint, "order")] = strNum(), 
            propMap;
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["f"])(null));
        var breakpointPropMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["f"])(null), {
            col: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b"])(breakpointCol),
            offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b"])(breakpointOffset),
            order: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b"])(breakpointOrder)
        });
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])({}, breakpointCol, breakpointOffset, breakpointOrder, {
            tag: {
                type: String,
                default: "div"
            },
            col: {
                type: Boolean,
                default: false
            },
            cols: strNum(),
            offset: strNum(),
            order: strNum(),
            alignSelf: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["d"])([ "auto", "start", "end", "center", "baseline", "stretch" ], str);
                }
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _classList$push;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var classList = [];
                for (var type in breakpointPropMap) {
                    var _keys = breakpointPropMap[type];
                    for (var i = 0; i < _keys.length; i++) {
                        var c = computeBkPtClass(type, _keys[i].replace(type, ""), props[_keys[i]]);
                        if (c) {
                            classList.push(c);
                        }
                    }
                }
                classList.push((_classList$push = {
                    col: props.col || classList.length === 0 && !props.cols
                }, _defineProperty(_classList$push, "col-" + props.cols, props.cols), _defineProperty(_classList$push, "offset-" + props.offset, props.offset), 
                _defineProperty(_classList$push, "order-" + props.order, props.order), _defineProperty(_classList$push, "align-self-" + props.alignSelf, props.alignSelf), 
                _classList$push));
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: classList
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(44);
        var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(110);
        var __WEBPACK_IMPORTED_MODULE_2__col__ = __webpack_require__(108);
        var __WEBPACK_IMPORTED_MODULE_3__form_row__ = __webpack_require__(24);
        var __WEBPACK_IMPORTED_MODULE_4__utils_plugins__ = __webpack_require__(1);
        var components = {
            bContainer: __WEBPACK_IMPORTED_MODULE_0__container__["a"],
            bRow: __WEBPACK_IMPORTED_MODULE_1__row__["a"],
            bCol: __WEBPACK_IMPORTED_MODULE_2__col__["a"],
            bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_row__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var COMMON_ALIGNMENT = [ "start", "end", "center" ];
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            noGutters: {
                type: Boolean,
                default: false
            },
            alignV: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])(COMMON_ALIGNMENT.concat([ "baseline", "stretch" ]), str);
                }
            },
            alignH: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])(COMMON_ALIGNMENT.concat([ "between", "around" ]), str);
                }
            },
            alignContent: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d"])(COMMON_ALIGNMENT.concat([ "between", "around", "stretch" ]), str);
                }
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "row",
                    class: (_class = {
                        "no-gutters": props.noGutters
                    }, _defineProperty(_class, "align-items-" + props.alignV, props.alignV), _defineProperty(_class, "justify-content-" + props.alignH, props.alignH), 
                    _defineProperty(_class, "align-content-" + props.alignContent, props.alignContent), 
                    _class)
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(6);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bLink: __WEBPACK_IMPORTED_MODULE_0__link__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__list_group__ = __webpack_require__(114);
        var __WEBPACK_IMPORTED_MODULE_1__list_group_item__ = __webpack_require__(113);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bListGroup: __WEBPACK_IMPORTED_MODULE_0__list_group__["a"],
            bListGroupItem: __WEBPACK_IMPORTED_MODULE_1__list_group_item__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_4__link_link__ = __webpack_require__(6);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var actionTags = [ "a", "router-link", "button", "b-link" ];
        var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__link_link__["c"])();
        delete linkProps.href.default;
        delete linkProps.to.default;
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])({
            tag: {
                type: String,
                default: "div"
            },
            action: {
                type: Boolean,
                default: null
            },
            button: {
                type: Boolean,
                default: null
            },
            variant: {
                type: String,
                default: null
            }
        }, linkProps);
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var tag = props.button ? "button" : !props.href && !props.to ? props.tag : __WEBPACK_IMPORTED_MODULE_4__link_link__["a"];
                var isAction = Boolean(props.href || props.to || props.action || props.button || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d"])(actionTags, props.tag));
                var componentData = {
                    staticClass: "list-group-item",
                    class: (_class = {}, _defineProperty(_class, "list-group-item-" + props.variant, Boolean(props.variant)), 
                    _defineProperty(_class, "list-group-item-action", isAction), _defineProperty(_class, "active", props.active), 
                    _defineProperty(_class, "disabled", props.disabled), _class),
                    attrs: tag === "button" && props.disabled ? {
                        disabled: true
                    } : {},
                    props: props.button ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a"])(linkProps, props)
                };
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            flush: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var componentData = {
                    staticClass: "list-group",
                    class: {
                        "list-group-flush": props.flush
                    }
                };
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__media__ = __webpack_require__(116);
        var __WEBPACK_IMPORTED_MODULE_1__media_aside__ = __webpack_require__(45);
        var __WEBPACK_IMPORTED_MODULE_2__media_body__ = __webpack_require__(46);
        var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(1);
        var components = {
            bMedia: __WEBPACK_IMPORTED_MODULE_0__media__["a"],
            bMediaAside: __WEBPACK_IMPORTED_MODULE_1__media_aside__["a"],
            bMediaBody: __WEBPACK_IMPORTED_MODULE_2__media_body__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__media_body__ = __webpack_require__(46);
        var __WEBPACK_IMPORTED_MODULE_2__media_aside__ = __webpack_require__(45);
        var props = {
            tag: {
                type: String,
                default: "div"
            },
            rightAlign: {
                type: Boolean,
                default: false
            },
            verticalAlign: {
                type: String,
                default: "top"
            },
            noBody: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                var childNodes = props.noBody ? children : [];
                var $slots = slots();
                if (!props.noBody) {
                    if ($slots.aside && !props.rightAlign) {
                        childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__media_aside__["a"], {
                            staticClass: "mr-3",
                            props: {
                                verticalAlign: props.verticalAlign
                            }
                        }, $slots.aside));
                    }
                    childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__media_body__["a"], $slots.default));
                    if ($slots.aside && props.rightAlign) {
                        childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__media_aside__["a"], {
                            staticClass: "ml-3",
                            props: {
                                verticalAlign: props.verticalAlign
                            }
                        }, $slots.aside));
                    }
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "media"
                }), childNodes);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(118);
        var __WEBPACK_IMPORTED_MODULE_1__directives_modal__ = __webpack_require__(144);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
                Vue.use(__WEBPACK_IMPORTED_MODULE_1__directives_modal__["a"]);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__button_button__ = __webpack_require__(19);
        var __WEBPACK_IMPORTED_MODULE_1__button_button_close__ = __webpack_require__(18);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_3__mixins_listen_on_root__ = __webpack_require__(15);
        var __WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__ = __webpack_require__(16);
        var __WEBPACK_IMPORTED_MODULE_5__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_6__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__ = __webpack_require__(155);
        var __WEBPACK_IMPORTED_MODULE_8__utils_dom__ = __webpack_require__(5);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var Selector = {
            FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
            STICKY_CONTENT: ".sticky-top",
            NAVBAR_TOGGLER: ".navbar-toggler"
        };
        var OBSERVER_CONFIG = {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: [ "style", "class" ]
        };
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_3__mixins_listen_on_root__["a"] ],
            components: {
                bBtn: __WEBPACK_IMPORTED_MODULE_0__button_button__["a"],
                bBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_button_close__["a"]
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var header = h(false);
                if (!this.hideHeader) {
                    var modalHeader = $slots["modal-header"];
                    if (!modalHeader) {
                        var closeButton = h(false);
                        if (!this.hideHeaderClose) {
                            closeButton = h("b-btn-close", {
                                props: {
                                    disabled: this.is_transitioning,
                                    ariaLabel: this.headerCloseLabel,
                                    textVariant: this.headerTextVariant
                                },
                                on: {
                                    click: function click(evt) {
                                        _this.hide("header-close");
                                    }
                                }
                            }, [ $slots["modal-header-close"] ]);
                        }
                        modalHeader = [ h(this.titleTag, {
                            class: [ "modal-title" ]
                        }, [ $slots["modal-title"] || this.title ]), closeButton ];
                    }
                    header = h("header", {
                        ref: "header",
                        class: this.headerClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_header_")
                        }
                    }, [ modalHeader ]);
                }
                var body = h("div", {
                    ref: "body",
                    class: this.bodyClasses,
                    attrs: {
                        id: this.safeId("__BV_modal_body_")
                    }
                }, [ $slots.default ]);
                var footer = h(false);
                if (!this.hideFooter) {
                    var modalFooter = $slots["modal-footer"];
                    if (!modalFooter) {
                        var cancelButton = h(false);
                        if (!this.okOnly) {
                            cancelButton = h("b-btn", {
                                props: {
                                    variant: this.cancelVariant,
                                    size: this.buttonSize,
                                    disabled: this.cancelDisabled || this.busy || this.is_transitioning
                                },
                                on: {
                                    click: function click(evt) {
                                        _this.hide("cancel");
                                    }
                                }
                            }, [ $slots["modal-cancel"] || this.cancelTitle ]);
                        }
                        var okButton = h("b-btn", {
                            props: {
                                variant: this.okVariant,
                                size: this.buttonSize,
                                disabled: this.okDisabled || this.busy || this.is_transitioning
                            },
                            on: {
                                click: function click(evt) {
                                    _this.hide("ok");
                                }
                            }
                        }, [ $slots["modal-ok"] || this.okTitle ]);
                        modalFooter = [ cancelButton, okButton ];
                    }
                    footer = h("footer", {
                        ref: "footer",
                        class: this.footerClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_footer_")
                        }
                    }, [ modalFooter ]);
                }
                var modalContent = h("div", {
                    ref: "content",
                    class: [ "modal-content" ],
                    attrs: {
                        tabindex: "-1",
                        role: "document",
                        "aria-labelledby": this.hideHeader ? null : this.safeId("__BV_modal_header_"),
                        "aria-describedby": this.safeId("__BV_modal_body_")
                    },
                    on: {
                        focusout: this.onFocusout,
                        click: function click(evt) {
                            evt.stopPropagation();
                            _this.$root.$emit("bv::dropdown::shown");
                        }
                    }
                }, [ header, body, footer ]);
                var modalDialog = h("div", {
                    class: this.dialogClasses
                }, [ modalContent ]);
                var modal = h("div", {
                    ref: "modal",
                    class: this.modalClasses,
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: this.is_visible,
                        expression: "is_visible"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        role: "dialog",
                        "aria-hidden": this.is_visible ? null : "true"
                    },
                    on: {
                        click: this.onClickOut,
                        keydown: this.onEsc
                    }
                }, [ modalDialog ]);
                modal = h("transition", {
                    props: {
                        enterClass: "",
                        enterToClass: "",
                        enterActiveClass: "",
                        leaveClass: "",
                        leaveActiveClass: "",
                        leaveToClass: ""
                    },
                    on: {
                        "before-enter": this.onBeforeEnter,
                        enter: this.onEnter,
                        "after-enter": this.onAfterEnter,
                        "before-leave": this.onBeforeLeave,
                        leave: this.onLeave,
                        "after-leave": this.onAfterLeave
                    }
                }, [ modal ]);
                var backdrop = h(false);
                if (!this.hideBackdrop && (this.is_visible || this.is_transitioning)) {
                    backdrop = h("div", {
                        class: this.backdropClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_backdrop_")
                        }
                    });
                }
                var outer = h(false);
                if (!this.is_hidden) {
                    outer = h("div", {
                        attrs: {
                            id: this.safeId("__BV_modal_outer_")
                        }
                    }, [ modal, backdrop ]);
                }
                return h("div", {}, [ outer ]);
            },
            data: function data() {
                return {
                    is_hidden: this.lazy || false,
                    is_visible: false,
                    is_transitioning: false,
                    is_show: false,
                    is_block: false,
                    scrollbarWidth: 0,
                    isBodyOverflowing: false,
                    return_focus: this.returnFocus || null
                };
            },
            model: {
                prop: "visible",
                event: "change"
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                titleTag: {
                    type: String,
                    default: "h5"
                },
                size: {
                    type: String,
                    default: "md"
                },
                centered: {
                    type: Boolean,
                    default: false
                },
                buttonSize: {
                    type: String,
                    default: ""
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                noCloseOnBackdrop: {
                    type: Boolean,
                    default: false
                },
                noCloseOnEsc: {
                    type: Boolean,
                    default: false
                },
                noEnforceFocus: {
                    type: Boolean,
                    default: false
                },
                headerBgVariant: {
                    type: String,
                    default: null
                },
                headerBorderVariant: {
                    type: String,
                    default: null
                },
                headerTextVariant: {
                    type: String,
                    default: null
                },
                headerClass: {
                    type: [ String, Array ],
                    default: null
                },
                bodyBgVariant: {
                    type: String,
                    default: null
                },
                bodyTextVariant: {
                    type: String,
                    default: null
                },
                modalClass: {
                    type: [ String, Array ],
                    default: null
                },
                bodyClass: {
                    type: [ String, Array ],
                    default: null
                },
                footerBgVariant: {
                    type: String,
                    default: null
                },
                footerBorderVariant: {
                    type: String,
                    default: null
                },
                footerTextVariant: {
                    type: String,
                    default: null
                },
                footerClass: {
                    type: [ String, Array ],
                    default: null
                },
                hideHeader: {
                    type: Boolean,
                    default: false
                },
                hideFooter: {
                    type: Boolean,
                    default: false
                },
                hideHeaderClose: {
                    type: Boolean,
                    default: false
                },
                hideBackdrop: {
                    type: Boolean,
                    default: false
                },
                okOnly: {
                    type: Boolean,
                    default: false
                },
                okDisabled: {
                    type: Boolean,
                    default: false
                },
                cancelDisabled: {
                    type: Boolean,
                    default: false
                },
                visible: {
                    type: Boolean,
                    default: false
                },
                returnFocus: {
                    default: null
                },
                headerCloseLabel: {
                    type: String,
                    default: "Close"
                },
                cancelTitle: {
                    type: String,
                    default: "Cancel"
                },
                okTitle: {
                    type: String,
                    default: "OK"
                },
                cancelVariant: {
                    type: String,
                    default: "secondary"
                },
                okVariant: {
                    type: String,
                    default: "primary"
                },
                lazy: {
                    type: Boolean,
                    default: false
                },
                busy: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                modalClasses: function modalClasses() {
                    return [ "modal", {
                        fade: !this.noFade,
                        show: this.is_show,
                        "d-block": this.is_block
                    }, this.modalClass ];
                },
                dialogClasses: function dialogClasses() {
                    var _ref;
                    return [ "modal-dialog", (_ref = {}, _defineProperty(_ref, "modal-" + this.size, Boolean(this.size)), 
                    _defineProperty(_ref, "modal-dialog-centered", this.centered), _ref) ];
                },
                backdropClasses: function backdropClasses() {
                    return [ "modal-backdrop", {
                        fade: !this.noFade,
                        show: this.is_show || this.noFade
                    } ];
                },
                headerClasses: function headerClasses() {
                    var _ref2;
                    return [ "modal-header", (_ref2 = {}, _defineProperty(_ref2, "bg-" + this.headerBgVariant, Boolean(this.headerBgVariant)), 
                    _defineProperty(_ref2, "text-" + this.headerTextVariant, Boolean(this.headerTextVariant)), 
                    _defineProperty(_ref2, "border-" + this.headerBorderVariant, Boolean(this.headerBorderVariant)), 
                    _ref2), this.headerClass ];
                },
                bodyClasses: function bodyClasses() {
                    var _ref3;
                    return [ "modal-body", (_ref3 = {}, _defineProperty(_ref3, "bg-" + this.bodyBgVariant, Boolean(this.bodyBgVariant)), 
                    _defineProperty(_ref3, "text-" + this.bodyTextVariant, Boolean(this.bodyTextVariant)), 
                    _ref3), this.bodyClass ];
                },
                footerClasses: function footerClasses() {
                    var _ref4;
                    return [ "modal-footer", (_ref4 = {}, _defineProperty(_ref4, "bg-" + this.footerBgVariant, Boolean(this.footerBgVariant)), 
                    _defineProperty(_ref4, "text-" + this.footerTextVariant, Boolean(this.footerTextVariant)), 
                    _defineProperty(_ref4, "border-" + this.footerBorderVariant, Boolean(this.footerBorderVariant)), 
                    _ref4), this.footerClass ];
                }
            },
            watch: {
                visible: function visible(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    this[newVal ? "show" : "hide"]();
                }
            },
            methods: {
                show: function show() {
                    if (this.is_visible) {
                        return;
                    }
                    var showEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a"]("show", {
                        cancelable: true,
                        vueTarget: this,
                        target: this.$refs.modal,
                        relatedTarget: null
                    });
                    this.emitEvent(showEvt);
                    if (showEvt.defaultPrevented || this.is_visible) {
                        return;
                    }
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["a"])(document.body, "modal-open")) {
                        this.$root.$once("bv::modal::hidden", this.doShow);
                    } else {
                        this.doShow();
                    }
                },
                hide: function hide(trigger) {
                    if (!this.is_visible) {
                        return;
                    }
                    var hideEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a"]("hide", {
                        cancelable: true,
                        vueTarget: this,
                        target: this.$refs.modal,
                        relatedTarget: null,
                        isOK: trigger || null,
                        trigger: trigger || null,
                        cancel: function cancel() {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_warn__["a"])("b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().");
                            this.preventDefault();
                        }
                    });
                    if (trigger === "ok") {
                        this.$emit("ok", hideEvt);
                    } else if (trigger === "cancel") {
                        this.$emit("cancel", hideEvt);
                    }
                    this.emitEvent(hideEvt);
                    if (hideEvt.defaultPrevented || !this.is_visible) {
                        return;
                    }
                    if (this._observer) {
                        this._observer.disconnect();
                        this._observer = null;
                    }
                    this.is_visible = false;
                    this.$emit("change", false);
                },
                doShow: function doShow() {
                    var _this2 = this;
                    this.is_hidden = false;
                    this.$nextTick(function() {
                        _this2.is_visible = true;
                        _this2.$emit("change", true);
                        _this2._observer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a"])(_this2.$refs.content, _this2.adjustDialog.bind(_this2), OBSERVER_CONFIG);
                    });
                },
                onBeforeEnter: function onBeforeEnter() {
                    this.is_transitioning = true;
                    this.checkScrollbar();
                    this.setScrollbar();
                    this.adjustDialog();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["d"])(document.body, "modal-open");
                    this.setResizeEvent(true);
                },
                onEnter: function onEnter() {
                    this.is_block = true;
                    this.$refs.modal.scrollTop = 0;
                },
                onAfterEnter: function onAfterEnter() {
                    var _this3 = this;
                    this.is_show = true;
                    this.is_transitioning = false;
                    this.$nextTick(function() {
                        _this3.focusFirst();
                        var shownEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a"]("shown", {
                            cancelable: false,
                            vueTarget: _this3,
                            target: _this3.$refs.modal,
                            relatedTarget: null
                        });
                        _this3.emitEvent(shownEvt);
                    });
                },
                onBeforeLeave: function onBeforeLeave() {
                    this.is_transitioning = true;
                    this.setResizeEvent(false);
                },
                onLeave: function onLeave() {
                    this.is_show = false;
                },
                onAfterLeave: function onAfterLeave() {
                    var _this4 = this;
                    this.is_block = false;
                    this.resetAdjustments();
                    this.resetScrollbar();
                    this.is_transitioning = false;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e"])(document.body, "modal-open");
                    this.$nextTick(function() {
                        _this4.is_hidden = _this4.lazy || false;
                        _this4.returnFocusTo();
                        var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a"]("hidden", {
                            cancelable: false,
                            vueTarget: _this4,
                            target: _this4.lazy ? null : _this4.$refs.modal,
                            relatedTarget: null
                        });
                        _this4.emitEvent(hiddenEvt);
                    });
                },
                emitEvent: function emitEvent(bvEvt) {
                    var type = bvEvt.type;
                    this.$emit(type, bvEvt);
                    this.$root.$emit("bv::modal::" + type, bvEvt);
                },
                onClickOut: function onClickOut(evt) {
                    if (this.is_visible && !this.noCloseOnBackdrop) {
                        this.hide("backdrop");
                    }
                },
                onEsc: function onEsc(evt) {
                    if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_6__utils_key_codes__["a"].ESC && this.is_visible && !this.noCloseOnEsc) {
                        this.hide("esc");
                    }
                },
                onFocusout: function onFocusout(evt) {
                    var content = this.$refs.content;
                    if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                        content.focus();
                    }
                },
                setResizeEvent: function setResizeEvent(on) {
                    var _this5 = this;
                    [ "resize", "orientationchange" ].forEach(function(evtName) {
                        if (on) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["f"])(window, evtName, _this5.adjustDialog);
                        } else {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["g"])(window, evtName, _this5.adjustDialog);
                        }
                    });
                },
                showHandler: function showHandler(id, triggerEl) {
                    if (id === this.id) {
                        this.return_focus = triggerEl || null;
                        this.show();
                    }
                },
                hideHandler: function hideHandler(id) {
                    if (id === this.id) {
                        this.hide();
                    }
                },
                modalListener: function modalListener(bvEvt) {
                    if (bvEvt.vueTarget !== this) {
                        this.hide();
                    }
                },
                focusFirst: function focusFirst() {
                    if (typeof document === "undefined") {
                        return;
                    }
                    var content = this.$refs.content;
                    var modal = this.$refs.modal;
                    var activeElement = document.activeElement;
                    if (activeElement && content && content.contains(activeElement)) {} else if (content) {
                        if (modal) {
                            modal.scrollTop = 0;
                        }
                        content.focus();
                    }
                },
                returnFocusTo: function returnFocusTo() {
                    var el = this.returnFocus || this.return_focus || null;
                    if (typeof el === "string") {
                        el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["i"])(el);
                    }
                    if (el) {
                        el = el.$el || el;
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["b"])(el)) {
                            el.focus();
                        }
                    }
                },
                getScrollbarWidth: function getScrollbarWidth() {
                    var scrollDiv = document.createElement("div");
                    scrollDiv.className = "modal-scrollbar-measure";
                    document.body.appendChild(scrollDiv);
                    this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                },
                adjustDialog: function adjustDialog() {
                    if (!this.is_visible) {
                        return;
                    }
                    var modal = this.$refs.modal;
                    var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
                    if (!this.isBodyOverflowing && isModalOverflowing) {
                        modal.style.paddingLeft = this.scrollbarWidth + "px";
                    }
                    if (this.isBodyOverflowing && !isModalOverflowing) {
                        modal.style.paddingRight = this.scrollbarWidth + "px";
                    }
                },
                resetAdjustments: function resetAdjustments() {
                    var modal = this.$refs.modal;
                    if (modal) {
                        modal.style.paddingLeft = "";
                        modal.style.paddingRight = "";
                    }
                },
                checkScrollbar: function checkScrollbar() {
                    var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["r"])(document.body);
                    this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
                },
                setScrollbar: function setScrollbar() {
                    if (this.isBodyOverflowing) {
                        var computedStyle = window.getComputedStyle;
                        var body = document.body;
                        var scrollbarWidth = this.scrollbarWidth;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["q"])(Selector.FIXED_CONTENT).forEach(function(el) {
                            var actualPadding = el.style.paddingRight;
                            var calculatedPadding = computedStyle(el).paddingRight || 0;
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c"])(el, "data-padding-right", actualPadding);
                            el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + "px";
                        });
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["q"])(Selector.STICKY_CONTENT).forEach(function(el) {
                            var actualMargin = el.style.marginRight;
                            var calculatedMargin = computedStyle(el).marginRight || 0;
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c"])(el, "data-margin-right", actualMargin);
                            el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + "px";
                        });
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["q"])(Selector.NAVBAR_TOGGLER).forEach(function(el) {
                            var actualMargin = el.style.marginRight;
                            var calculatedMargin = computedStyle(el).marginRight || 0;
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c"])(el, "data-margin-right", actualMargin);
                            el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + "px";
                        });
                        var actualPadding = body.style.paddingRight;
                        var calculatedPadding = computedStyle(body).paddingRight;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c"])(body, "data-padding-right", actualPadding);
                        body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + "px";
                    }
                },
                resetScrollbar: function resetScrollbar() {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["q"])(Selector.FIXED_CONTENT).forEach(function(el) {
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u"])(el, "data-padding-right")) {
                            el.style.paddingRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["j"])(el, "data-padding-right") || "";
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["k"])(el, "data-padding-right");
                        }
                    });
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["q"])(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).forEach(function(el) {
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u"])(el, "data-margin-right")) {
                            el.style.marginRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["j"])(el, "data-margin-right") || "";
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["k"])(el, "data-margin-right");
                        }
                    });
                    var body = document.body;
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u"])(body, "data-padding-right")) {
                        body.style.paddingRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["j"])(body, "data-padding-right") || "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["k"])(body, "data-padding-right");
                    }
                }
            },
            created: function created() {
                this._observer = null;
            },
            mounted: function mounted() {
                this.getScrollbarWidth();
                this.listenOnRoot("bv::show::modal", this.showHandler);
                this.listenOnRoot("bv::hide::modal", this.hideHandler);
                this.listenOnRoot("bv::modal::show", this.modalListener);
                if (this.visible === true) {
                    this.show();
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (this._observer) {
                    this._observer.disconnect();
                    this._observer = null;
                }
                this.setResizeEvent(false);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e"])(document.body, "modal-open");
                this.resetAdjustments();
                this.resetScrollbar();
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__form_form__ = __webpack_require__(41);
        var __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__ = __webpack_require__(0);
        __webpack_exports__["a"] = {
            functional: true,
            props: {
                id: {
                    type: String,
                    default: null
                }
            },
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(__WEBPACK_IMPORTED_MODULE_0__form_form__["a"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__["a"])(data, {
                    attrs: {
                        id: props.id
                    },
                    props: {
                        inline: true
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__ = __webpack_require__(151);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__["a"] ],
            render: function render(h) {
                var button = h("a", {
                    class: this.toggleClasses,
                    ref: "toggle",
                    attrs: {
                        href: "#",
                        id: this.safeId("_BV_button_"),
                        disabled: this.disabled,
                        "aria-haspopup": "true",
                        "aria-expanded": this.visible ? "true" : "false"
                    },
                    on: {
                        click: this.toggle,
                        keydown: this.toggle
                    }
                }, [ this.$slots["button-content"] || this.$slots.text || h("span", {
                    domProps: {
                        innerHTML: this.text
                    }
                }) ]);
                var menu = h("div", {
                    class: this.menuClasses,
                    ref: "menu",
                    attrs: {
                        "aria-labelledby": this.safeId("_BV_button_")
                    },
                    on: {
                        mouseover: this.onMouseOver,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
                return h("li", {
                    attrs: {
                        id: this.safeId()
                    },
                    class: this.dropdownClasses
                }, [ button, menu ]);
            },
            computed: {
                isNav: function isNav() {
                    return true;
                },
                dropdownClasses: function dropdownClasses() {
                    return [ "nav-item", "b-nav-dropdown", "dropdown", this.dropup ? "dropup" : "", this.visible ? "show" : "" ];
                },
                toggleClasses: function toggleClasses() {
                    return [ "nav-link", this.noCaret ? "" : "dropdown-toggle", this.disabled ? "disabled" : "", this.extraToggleClasses ? this.extraToggleClasses : "" ];
                },
                menuClasses: function menuClasses() {
                    return [ "dropdown-menu", this.right ? "dropdown-menu-right" : "dropdown-menu-left", this.visible ? "show" : "", this.extraMenuClasses ? this.extraMenuClasses : "" ];
                }
            },
            props: {
                noCaret: {
                    type: Boolean,
                    default: false
                },
                extraToggleClasses: {
                    type: String,
                    default: ""
                },
                extraMenuClasses: {
                    type: String,
                    default: ""
                },
                role: {
                    type: String,
                    default: "menu"
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__link_link__ = __webpack_require__(6);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__link_link__["c"])();
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h("li", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "nav-item"
                }), [ h(__WEBPACK_IMPORTED_MODULE_1__link_link__["a"], {
                    staticClass: "nav-link",
                    props: props
                }, children) ]);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "span"
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-text"
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(7);
        var props = {
            tag: {
                type: String,
                default: "ul"
            },
            fill: {
                type: Boolean,
                default: false
            },
            justified: {
                type: Boolean,
                default: false
            },
            tabs: {
                type: Boolean,
                default: false
            },
            pills: {
                type: Boolean,
                default: false
            },
            vertical: {
                type: Boolean,
                default: false
            },
            isNavBar: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                if (props.isNavBar) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a"])("b-nav: Prop 'is-nav-bar' is deprecated. Please use component '<b-navbar-nav>' instead.");
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        nav: !props.isNavBar,
                        "navbar-nav": props.isNavBar,
                        "nav-tabs": props.tabs && !props.isNavBar,
                        "nav-pills": props.pills && !props.isNavBar,
                        "flex-column": props.vertical && !props.isNavBar,
                        "nav-fill": props.fill,
                        "nav-justified": props.justified
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__navbar__ = __webpack_require__(128);
        var __WEBPACK_IMPORTED_MODULE_1__navbar_nav__ = __webpack_require__(126);
        var __WEBPACK_IMPORTED_MODULE_2__navbar_brand__ = __webpack_require__(125);
        var __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__ = __webpack_require__(127);
        var __WEBPACK_IMPORTED_MODULE_4__nav__ = __webpack_require__(47);
        var __WEBPACK_IMPORTED_MODULE_5__collapse__ = __webpack_require__(35);
        var __WEBPACK_IMPORTED_MODULE_6__dropdown__ = __webpack_require__(20);
        var __WEBPACK_IMPORTED_MODULE_7__utils_plugins__ = __webpack_require__(1);
        var components = {
            bNavbar: __WEBPACK_IMPORTED_MODULE_0__navbar__["a"],
            bNavbarNav: __WEBPACK_IMPORTED_MODULE_1__navbar_nav__["a"],
            bNavbarBrand: __WEBPACK_IMPORTED_MODULE_2__navbar_brand__["a"],
            bNavbarToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a"],
            bNavToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_plugins__["a"])(Vue, components);
                Vue.use(__WEBPACK_IMPORTED_MODULE_4__nav__["a"]);
                Vue.use(__WEBPACK_IMPORTED_MODULE_5__collapse__["a"]);
                Vue.use(__WEBPACK_IMPORTED_MODULE_6__dropdown__["a"]);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__link_link__ = __webpack_require__(6);
        var __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_2__utils_pluck_props__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
        var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__link_link__["c"])();
        linkProps.href.default = undefined;
        linkProps.to.default = undefined;
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a"])(linkProps, {
            tag: {
                type: String,
                default: "div"
            }
        });
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var isLink = Boolean(props.to || props.href);
                var tag = isLink ? __WEBPACK_IMPORTED_MODULE_0__link_link__["a"] : props.tag;
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-brand",
                    props: isLink ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_pluck_props__["a"])(linkProps, props) : {}
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var props = {
            tag: {
                type: String,
                default: "ul"
            },
            fill: {
                type: Boolean,
                default: false
            },
            justified: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-nav",
                    class: {
                        "nav-fill": props.fill,
                        "nav-justified": props.justified
                    }
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__ = __webpack_require__(15);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__["a"] ],
            render: function render(h) {
                return h("button", {
                    class: [ "navbar-toggler" ],
                    attrs: {
                        type: "button",
                        "aria-label": this.label,
                        "aria-controls": this.target,
                        "aria-expanded": this.toggleState ? "true" : "false"
                    },
                    on: {
                        click: this.onClick
                    }
                }, [ this.$slots.default || h("span", {
                    class: [ "navbar-toggler-icon" ]
                }) ]);
            },
            data: function data() {
                return {
                    toggleState: false
                };
            },
            props: {
                label: {
                    type: String,
                    default: "Toggle navigation"
                },
                target: {
                    type: String,
                    required: true
                }
            },
            methods: {
                onClick: function onClick() {
                    this.$root.$emit("bv::toggle::collapse", this.target);
                },
                handleStateEvt: function handleStateEvt(id, state) {
                    if (id === this.target) {
                        this.toggleState = state;
                    }
                }
            },
            created: function created() {
                this.listenOnRoot("bv::collapse::state", this.handleStateEvt);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var props = {
            tag: {
                type: String,
                default: "nav"
            },
            type: {
                type: String,
                default: "light"
            },
            variant: {
                type: String
            },
            toggleable: {
                type: [ Boolean, String ],
                default: false
            },
            toggleBreakpoint: {
                type: String,
                default: null
            },
            fixed: {
                type: String
            },
            sticky: {
                type: Boolean,
                default: false
            }
        };
        __webpack_exports__["a"] = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var breakpoint = props.toggleBreakpoint || (props.toggleable === true ? "sm" : props.toggleable) || "sm";
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar",
                    class: (_class = {}, _defineProperty(_class, "navbar-" + props.type, Boolean(props.type)), 
                    _defineProperty(_class, "bg-" + props.variant, Boolean(props.variant)), _defineProperty(_class, "fixed-" + props.fixed, Boolean(props.fixed)), 
                    _defineProperty(_class, "sticky-top", props.sticky), _defineProperty(_class, "navbar-expand-" + breakpoint, props.toggleable !== false), 
                    _class)
                }), children);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__pagination_nav__ = __webpack_require__(130);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bPaginationNav: __WEBPACK_IMPORTED_MODULE_0__pagination_nav__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__mixins_pagination__ = __webpack_require__(153);
        var __WEBPACK_IMPORTED_MODULE_2__link_link__ = __webpack_require__(6);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var routerProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__link_link__["b"])("activeClass", "exactActiveClass", "append", "exact", "replace", "target", "rel");
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])({
            numberOfPages: {
                type: Number,
                default: 1
            },
            baseUrl: {
                type: String,
                default: "/"
            },
            useRouter: {
                type: Boolean,
                default: false
            },
            linkGen: {
                type: Function,
                default: null
            },
            pageGen: {
                type: Function,
                default: null
            }
        }, routerProps);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_1__mixins_pagination__["a"] ],
            props: props,
            computed: {
                isNav: function isNav() {
                    return true;
                }
            },
            methods: {
                onClick: function onClick(pageNum, evt) {
                    this.currentPage = pageNum;
                },
                makePage: function makePage(pagenum) {
                    if (this.pageGen && typeof this.pageGen === "function") {
                        return this.pageGen(pagenum);
                    }
                    return pagenum;
                },
                makeLink: function makeLink(pagenum) {
                    if (this.linkGen && typeof this.linkGen === "function") {
                        return this.linkGen(pagenum);
                    }
                    var link = "" + this.baseUrl + pagenum;
                    return this.useRouter ? {
                        path: link
                    } : link;
                },
                linkProps: function linkProps(pagenum) {
                    var link = this.makeLink(pagenum);
                    var props = {
                        href: typeof link === "string" ? link : void 0,
                        target: this.target || null,
                        rel: this.rel || null,
                        disabled: this.disabled
                    };
                    if (this.useRouter || (typeof link === "undefined" ? "undefined" : _typeof(link)) === "object") {
                        props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])(props, {
                            to: link,
                            exact: this.exact,
                            activeClass: this.activeClass,
                            exactActiveClass: this.exactActiveClass,
                            append: this.append,
                            replace: this.replace
                        });
                    }
                    return props;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__pagination__ = __webpack_require__(132);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bPagination: __WEBPACK_IMPORTED_MODULE_0__pagination__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_pagination__ = __webpack_require__(153);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var props = {
            perPage: {
                type: Number,
                default: 20
            },
            totalRows: {
                type: Number,
                default: 20
            },
            ariaControls: {
                type: String,
                default: null
            }
        };
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_pagination__["a"] ],
            props: props,
            computed: {
                numberOfPages: function numberOfPages() {
                    var result = Math.ceil(this.totalRows / this.perPage);
                    return result < 1 ? 1 : result;
                }
            },
            methods: {
                onClick: function onClick(num, evt) {
                    var _this = this;
                    if (num > this.numberOfPages) {
                        num = this.numberOfPages;
                    } else if (num < 1) {
                        num = 1;
                    }
                    this.currentPage = num;
                    this.$nextTick(function() {
                        var target = evt.target;
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["b"])(target) && _this.$el.contains(target) && target.focus) {
                            target.focus();
                        } else {
                            _this.focusCurrent();
                        }
                    });
                    this.$emit("change", this.currentPage);
                },
                makePage: function makePage(pagenum) {
                    return pagenum;
                },
                linkProps: function linkProps(pagenum) {
                    return {
                        href: "#"
                    };
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(134);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__ = __webpack_require__(157);
        var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__ = __webpack_require__(154);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__["a"] ],
            render: function render(h) {
                return h("div", {
                    class: [ "d-none" ],
                    style: {
                        display: "none"
                    },
                    attrs: {
                        "aria-hidden": true
                    }
                }, [ h("div", {
                    ref: "title"
                }, this.$slots.title), h("div", {
                    ref: "content"
                }, this.$slots.default) ]);
            },
            data: function data() {
                return {};
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                content: {
                    type: String,
                    default: ""
                },
                triggers: {
                    type: [ String, Array ],
                    default: "click"
                },
                placement: {
                    type: String,
                    default: "right"
                }
            },
            methods: {
                createToolpop: function createToolpop() {
                    var target = this.getTarget();
                    if (target) {
                        this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__["a"](target, this.getConfig(), this.$root);
                    } else {
                        this._toolpop = null;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a"])("b-popover: 'target' element not found!");
                    }
                    return this._toolpop;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(136);
        var __WEBPACK_IMPORTED_MODULE_1__progress_bar__ = __webpack_require__(48);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bProgress: __WEBPACK_IMPORTED_MODULE_0__progress__["a"],
            bProgressBar: __WEBPACK_IMPORTED_MODULE_1__progress_bar__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__(48);
        __webpack_exports__["a"] = {
            components: {
                bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a"]
            },
            render: function render(h) {
                var childNodes = this.$slots.default;
                if (!childNodes) {
                    childNodes = h("b-progress-bar", {
                        props: {
                            value: this.value,
                            max: this.max,
                            precision: this.precision,
                            variant: this.variant,
                            animated: this.animated,
                            striped: this.striped,
                            showProgress: this.showProgress,
                            showValue: this.showValue
                        }
                    });
                }
                return h("div", {
                    class: [ "progress" ],
                    style: this.progressHeight
                }, [ childNodes ]);
            },
            props: {
                variant: {
                    type: String,
                    default: null
                },
                striped: {
                    type: Boolean,
                    default: false
                },
                animated: {
                    type: Boolean,
                    default: false
                },
                height: {
                    type: String,
                    default: null
                },
                precision: {
                    type: Number,
                    default: 0
                },
                showProgress: {
                    type: Boolean,
                    default: false
                },
                showValue: {
                    type: Boolean,
                    default: false
                },
                max: {
                    type: Number,
                    default: 100
                },
                value: {
                    type: Number,
                    default: 0
                }
            },
            computed: {
                progressHeight: function progressHeight() {
                    return {
                        height: this.height || null
                    };
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(138);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bTable: __WEBPACK_IMPORTED_MODULE_0__table__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_lodash_startcase__ = __webpack_require__(164);
        var __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_startcase__);
        var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(163);
        var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
        var __WEBPACK_IMPORTED_MODULE_2__utils_loose_equal__ = __webpack_require__(50);
        var __WEBPACK_IMPORTED_MODULE_3__utils_stable_sort__ = __webpack_require__(181);
        var __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_5__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_7__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_8__mixins_id__ = __webpack_require__(4);
        var __WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__ = __webpack_require__(15);
        var __WEBPACK_IMPORTED_MODULE_10__table_css__ = __webpack_require__(212);
        var __WEBPACK_IMPORTED_MODULE_10__table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__table_css__);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function toString(v) {
            if (!v) {
                return "";
            }
            if (v instanceof Object) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(v).map(function(k) {
                    return toString(v[k]);
                }).join(" ");
            }
            return String(v);
        }
        function recToString(obj) {
            if (!(obj instanceof Object)) {
                return "";
            }
            return toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(obj).reduce(function(o, k) {
                if (!/^_/.test(k)) {
                    o[k] = obj[k];
                }
                return o;
            }, {}));
        }
        function defaultSortCompare(a, b, sortBy) {
            if (typeof a[sortBy] === "number" && typeof b[sortBy] === "number") {
                return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
            }
            return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
                numeric: true
            });
        }
        function processField(key, value) {
            var field = null;
            if (typeof value === "string") {
                field = {
                    key: key,
                    label: value
                };
            } else if (typeof value === "function") {
                field = {
                    key: key,
                    formatter: value
                };
            } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
                field = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a"])({}, value);
                field.key = field.key || key;
            } else if (value !== false) {
                field = {
                    key: key
                };
            }
            return field;
        }
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_8__mixins_id__["a"], __WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__["a"] ],
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var $scoped = this.$scopedSlots;
                var fields = this.computedFields;
                var items = this.computedItems;
                var caption = h(false);
                if (this.caption || $slots["table-caption"]) {
                    var data = {
                        style: this.captionStyles
                    };
                    if (!$slots["table-caption"]) {
                        data.domProps = {
                            innerHTML: this.caption
                        };
                    }
                    caption = h("caption", data, $slots["table-caption"]);
                }
                var colgroup = $slots["table-colgroup"] ? h("colgroup", {}, $slots["table-colgroup"]) : h(false);
                var makeHeadCells = function makeHeadCells() {
                    var isFoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    return fields.map(function(field, colIndex) {
                        var data = {
                            key: field.key,
                            class: _this.fieldClasses(field),
                            style: field.thStyle || {},
                            attrs: {
                                tabindex: field.sortable ? "0" : null,
                                abbr: field.headerAbbr || null,
                                title: field.headerTitle || null,
                                "aria-colindex": String(colIndex + 1),
                                "aria-label": field.sortable ? _this.localSortDesc && _this.localSortBy === field.key ? _this.labelSortAsc : _this.labelSortDesc : null,
                                "aria-sort": field.sortable && _this.localSortBy === field.key ? _this.localSortDesc ? "descending" : "ascending" : null
                            },
                            on: {
                                click: function click(evt) {
                                    evt.stopPropagation();
                                    evt.preventDefault();
                                    _this.headClicked(evt, field);
                                },
                                keydown: function keydown(evt) {
                                    var keyCode = evt.keyCode;
                                    if (keyCode === __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__["a"].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__["a"].SPACE) {
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                        _this.headClicked(evt, field);
                                    }
                                }
                            }
                        };
                        var slot = isFoot && $scoped["FOOT_" + field.key] ? $scoped["FOOT_" + field.key] : $scoped["HEAD_" + field.key];
                        if (slot) {
                            slot = [ slot({
                                label: field.label,
                                column: field.key,
                                field: field
                            }) ];
                        } else {
                            data.domProps = {
                                innerHTML: field.label
                            };
                        }
                        return h("th", data, slot);
                    });
                };
                var thead = h(false);
                if (this.isStacked !== true) {
                    thead = h("thead", {
                        class: this.headClasses
                    }, [ h("tr", {
                        class: this.theadTrClass
                    }, makeHeadCells(false)) ]);
                }
                var tfoot = h(false);
                if (this.footClone && this.isStacked !== true) {
                    tfoot = h("tfoot", {
                        class: this.footClasses
                    }, [ h("tr", {
                        class: this.tfootTrClass
                    }, makeHeadCells(true)) ]);
                }
                var rows = [];
                if ($scoped["top-row"] && this.isStacked !== true) {
                    rows.push(h("tr", {
                        key: "top-row",
                        class: [ "b-table-top-row", this.tbodyTrClass ]
                    }, [ $scoped["top-row"]({
                        columns: fields.length,
                        fields: fields
                    }) ]));
                } else {
                    rows.push(h(false));
                }
                items.forEach(function(item, rowIndex) {
                    var detailsSlot = $scoped["row-details"];
                    var rowShowDetails = Boolean(item._showDetails && detailsSlot);
                    var detailsId = rowShowDetails ? _this.safeId("_details_" + rowIndex + "_") : null;
                    var toggleDetailsFn = function toggleDetailsFn() {
                        if (detailsSlot) {
                            _this.$set(item, "_showDetails", !item._showDetails);
                        }
                    };
                    var tds = fields.map(function(field, colIndex) {
                        var data = {
                            key: "row-" + rowIndex + "-cell-" + colIndex,
                            class: _this.tdClasses(field, item),
                            attrs: field.tdAttr || {},
                            domProps: {}
                        };
                        data.attrs["aria-colindex"] = String(colIndex + 1);
                        var childNodes = void 0;
                        if ($scoped[field.key]) {
                            childNodes = [ $scoped[field.key]({
                                item: item,
                                index: rowIndex,
                                field: field,
                                unformatted: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, field.key),
                                value: _this.getFormattedValue(item, field),
                                toggleDetails: toggleDetailsFn,
                                detailsShowing: Boolean(item._showDetails)
                            }) ];
                            if (_this.isStacked) {
                                childNodes = [ h("div", {}, [ childNodes ]) ];
                            }
                        } else {
                            var formatted = _this.getFormattedValue(item, field);
                            if (_this.isStacked) {
                                childNodes = [ h("div", formatted) ];
                            } else {
                                childNodes = formatted;
                            }
                        }
                        if (_this.isStacked) {
                            data.attrs["data-label"] = field.label;
                            if (field.isRowHeader) {
                                data.attrs["role"] = "rowheader";
                            } else {
                                data.attrs["role"] = "cell";
                            }
                        }
                        return h(field.isRowHeader ? "th" : "td", data, childNodes);
                    });
                    var ariaRowIndex = null;
                    if (_this.currentPage && _this.perPage && _this.perPage > 0) {
                        ariaRowIndex = (_this.currentPage - 1) * _this.perPage + rowIndex + 1;
                    }
                    rows.push(h("tr", {
                        key: "row-" + rowIndex,
                        class: [ _this.rowClasses(item), {
                            "b-table-has-details": rowShowDetails
                        } ],
                        attrs: {
                            "aria-describedby": detailsId,
                            "aria-rowindex": ariaRowIndex,
                            role: _this.isStacked ? "row" : null
                        },
                        on: {
                            click: function click(evt) {
                                _this.rowClicked(evt, item, rowIndex);
                            },
                            dblclick: function dblclick(evt) {
                                _this.rowDblClicked(evt, item, rowIndex);
                            },
                            mouseenter: function mouseenter(evt) {
                                _this.rowHovered(evt, item, rowIndex);
                            }
                        }
                    }, tds));
                    if (rowShowDetails) {
                        var tdAttrs = {
                            colspan: String(fields.length)
                        };
                        var trAttrs = {
                            id: detailsId
                        };
                        if (_this.isStacked) {
                            tdAttrs["role"] = "cell";
                            trAttrs["role"] = "row";
                        }
                        var details = h("td", {
                            attrs: tdAttrs
                        }, [ detailsSlot({
                            item: item,
                            index: rowIndex,
                            fields: fields,
                            toggleDetails: toggleDetailsFn
                        }) ]);
                        rows.push(h("tr", {
                            key: "details-" + rowIndex,
                            class: [ "b-table-details", _this.tbodyTrClass ],
                            attrs: trAttrs
                        }, [ details ]));
                    } else if (detailsSlot) {
                        rows.push(h(false));
                    }
                });
                if (this.showEmpty && (!items || items.length === 0)) {
                    var empty = this.filter ? $slots["emptyfiltered"] : $slots["empty"];
                    if (!empty) {
                        empty = h("div", {
                            class: [ "text-center", "my-2" ],
                            domProps: {
                                innerHTML: this.filter ? this.emptyFilteredText : this.emptyText
                            }
                        });
                    }
                    empty = h("td", {
                        attrs: {
                            colspan: String(fields.length),
                            role: this.isStacked ? "cell" : null
                        }
                    }, [ h("div", {
                        attrs: {
                            role: "alert",
                            "aria-live": "polite"
                        }
                    }, [ empty ]) ]);
                    rows.push(h("tr", {
                        key: "empty-row",
                        class: [ "b-table-empty-row", this.tbodyTrClass ],
                        attrs: this.isStacked ? {
                            role: "row"
                        } : {}
                    }, [ empty ]));
                } else {
                    rows.push(h(false));
                }
                if ($scoped["bottom-row"] && this.isStacked !== true) {
                    rows.push(h("tr", {
                        key: "bottom-row",
                        class: [ "b-table-bottom-row", this.tbodyTrClass ]
                    }, [ $scoped["bottom-row"]({
                        columns: fields.length,
                        fields: fields
                    }) ]));
                } else {
                    rows.push(h(false));
                }
                var tbody = h("tbody", {
                    class: this.bodyClasses,
                    attrs: this.isStacked ? {
                        role: "rowgroup"
                    } : {}
                }, rows);
                var table = h("table", {
                    class: this.tableClasses,
                    attrs: {
                        id: this.safeId(),
                        role: this.isStacked ? "table" : null,
                        "aria-busy": this.computedBusy ? "true" : "false",
                        "aria-colcount": String(fields.length),
                        "aria-rowcount": this.$attrs["aria-rowcount"] || this.perPage && this.perPage > 0 ? "-1" : null
                    }
                }, [ caption, colgroup, thead, tfoot, tbody ]);
                return this.isResponsive ? h("div", {
                    class: this.responsiveClass
                }, [ table ]) : table;
            },
            data: function data() {
                return {
                    localSortBy: this.sortBy || "",
                    localSortDesc: this.sortDesc || false,
                    localItems: [],
                    filteredItems: [],
                    localBusy: false
                };
            },
            props: {
                items: {
                    type: [ Array, Function ],
                    default: function _default() {
                        return [];
                    }
                },
                fields: {
                    type: [ Object, Array ],
                    default: null
                },
                sortBy: {
                    type: String,
                    default: null
                },
                sortDesc: {
                    type: Boolean,
                    default: false
                },
                caption: {
                    type: String,
                    default: null
                },
                captionTop: {
                    type: Boolean,
                    default: false
                },
                striped: {
                    type: Boolean,
                    default: false
                },
                bordered: {
                    type: Boolean,
                    default: false
                },
                outlined: {
                    type: Boolean,
                    default: false
                },
                dark: {
                    type: Boolean,
                    default: function _default() {
                        if (this && typeof this.inverse === "boolean") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_warn__["a"])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
                            return this.dark;
                        }
                        return false;
                    }
                },
                inverse: {
                    type: Boolean,
                    default: null
                },
                hover: {
                    type: Boolean,
                    default: false
                },
                small: {
                    type: Boolean,
                    default: false
                },
                fixed: {
                    type: Boolean,
                    default: false
                },
                footClone: {
                    type: Boolean,
                    default: false
                },
                responsive: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: [ Boolean, String ],
                    default: false
                },
                headVariant: {
                    type: String,
                    default: ""
                },
                footVariant: {
                    type: String,
                    default: ""
                },
                theadClass: {
                    type: [ String, Array ],
                    default: null
                },
                theadTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                tbodyClass: {
                    type: [ String, Array ],
                    default: null
                },
                tbodyTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                tfootClass: {
                    type: [ String, Array ],
                    default: null
                },
                tfootTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                perPage: {
                    type: Number,
                    default: 0
                },
                currentPage: {
                    type: Number,
                    default: 1
                },
                filter: {
                    type: [ String, RegExp, Function ],
                    default: null
                },
                sortCompare: {
                    type: Function,
                    default: null
                },
                noLocalSorting: {
                    type: Boolean,
                    default: false
                },
                noProviderPaging: {
                    type: Boolean,
                    default: false
                },
                noProviderSorting: {
                    type: Boolean,
                    default: false
                },
                noProviderFiltering: {
                    type: Boolean,
                    default: false
                },
                busy: {
                    type: Boolean,
                    default: false
                },
                value: {
                    type: Array,
                    default: function _default() {
                        return [];
                    }
                },
                labelSortAsc: {
                    type: String,
                    default: "Click to sort Ascending"
                },
                labelSortDesc: {
                    type: String,
                    default: "Click to sort Descending"
                },
                showEmpty: {
                    type: Boolean,
                    default: false
                },
                emptyText: {
                    type: String,
                    default: "There are no records to show"
                },
                emptyFilteredText: {
                    type: String,
                    default: "There are no records matching your request"
                },
                apiUrl: {
                    type: String,
                    default: ""
                }
            },
            watch: {
                items: function items(newVal, oldVal) {
                    if (oldVal !== newVal) {
                        this._providerUpdate();
                    }
                },
                context: function context(newVal, oldVal) {
                    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_loose_equal__["a"])(newVal, oldVal)) {
                        this.$emit("context-changed", newVal);
                    }
                },
                filteredItems: function filteredItems(newVal, oldVal) {
                    if (this.localFiltering && newVal.length !== oldVal.length) {
                        this.$emit("filtered", newVal);
                    }
                },
                sortDesc: function sortDesc(newVal, oldVal) {
                    if (newVal === this.localSortDesc) {
                        return;
                    }
                    this.localSortDesc = newVal || false;
                },
                localSortDesc: function localSortDesc(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:sortDesc", newVal);
                        if (!this.noProviderSorting) {
                            this._providerUpdate();
                        }
                    }
                },
                sortBy: function sortBy(newVal, oldVal) {
                    if (newVal === this.localSortBy) {
                        return;
                    }
                    this.localSortBy = newVal || null;
                },
                localSortBy: function localSortBy(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:sortBy", newVal);
                        if (!this.noProviderSorting) {
                            this._providerUpdate();
                        }
                    }
                },
                perPage: function perPage(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderPaging) {
                        this._providerUpdate();
                    }
                },
                currentPage: function currentPage(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderPaging) {
                        this._providerUpdate();
                    }
                },
                filter: function filter(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderFiltering) {
                        this._providerUpdate();
                    }
                },
                localBusy: function localBusy(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:busy", newVal);
                    }
                }
            },
            mounted: function mounted() {
                var _this2 = this;
                this.localSortBy = this.sortBy;
                this.localSortDesc = this.sortDesc;
                if (this.hasProvider) {
                    this._providerUpdate();
                }
                this.listenOnRoot("bv::refresh::table", function(id) {
                    if (id === _this2.id || id === _this2) {
                        _this2._providerUpdate();
                    }
                });
            },
            computed: {
                isStacked: function isStacked() {
                    return this.stacked === "" ? true : this.stacked;
                },
                isResponsive: function isResponsive() {
                    var responsive = this.responsive === "" ? true : this.responsive;
                    return this.isStacked ? false : responsive;
                },
                responsiveClass: function responsiveClass() {
                    return this.isResponsive === true ? "table-responsive" : this.isResponsive ? "table-responsive-" + this.responsive : "";
                },
                tableClasses: function tableClasses() {
                    return [ "table", "b-table", this.striped ? "table-striped" : "", this.hover ? "table-hover" : "", this.dark ? "table-dark" : "", this.bordered ? "table-bordered" : "", this.small ? "table-sm" : "", this.outlined ? "border" : "", this.fixed ? "b-table-fixed" : "", this.isStacked === true ? "b-table-stacked" : this.isStacked ? "b-table-stacked-" + this.stacked : "" ];
                },
                headClasses: function headClasses() {
                    return [ this.headVariant ? "thead-" + this.headVariant : "", this.theadClass ];
                },
                bodyClasses: function bodyClasses() {
                    return [ this.tbodyClass ];
                },
                footClasses: function footClasses() {
                    var variant = this.footVariant || this.headVariant || null;
                    return [ variant ? "thead-" + variant : "", this.tfootClass ];
                },
                captionStyles: function captionStyles() {
                    return this.captionTop ? {
                        captionSide: "top"
                    } : {};
                },
                hasProvider: function hasProvider() {
                    return this.items instanceof Function;
                },
                localFiltering: function localFiltering() {
                    return this.hasProvider ? this.noProviderFiltering : true;
                },
                localSorting: function localSorting() {
                    return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
                },
                localPaging: function localPaging() {
                    return this.hasProvider ? this.noProviderPaging : true;
                },
                context: function context() {
                    return {
                        perPage: this.perPage,
                        currentPage: this.currentPage,
                        filter: this.filter,
                        sortBy: this.localSortBy,
                        sortDesc: this.localSortDesc,
                        apiUrl: this.apiUrl
                    };
                },
                computedFields: function computedFields() {
                    var _this3 = this;
                    var fields = [];
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b"])(this.fields)) {
                        this.fields.filter(function(f) {
                            return f;
                        }).forEach(function(f) {
                            if (typeof f === "string") {
                                fields.push({
                                    key: f,
                                    label: __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(f)
                                });
                            } else if ((typeof f === "undefined" ? "undefined" : _typeof(f)) === "object" && f.key && typeof f.key === "string") {
                                fields.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a"])({}, f));
                            } else if ((typeof f === "undefined" ? "undefined" : _typeof(f)) === "object" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(f).length === 1) {
                                var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(f)[0];
                                var field = processField(key, f[key]);
                                if (field) {
                                    fields.push(field);
                                }
                            }
                        });
                    } else if (this.fields && _typeof(this.fields) === "object" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(this.fields).length > 0) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(this.fields).forEach(function(key) {
                            var field = processField(key, _this3.fields[key]);
                            if (field) {
                                fields.push(field);
                            }
                        });
                    }
                    if (fields.length === 0 && this.computedItems.length > 0) {
                        var sample = this.computedItems[0];
                        var ignoredKeys = [ "_rowVariant", "_cellVariants", "_showDetails" ];
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["b"])(sample).forEach(function(k) {
                            if (!ignoredKeys.includes(k)) {
                                fields.push({
                                    key: k,
                                    label: __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(k)
                                });
                            }
                        });
                    }
                    var memo = {};
                    return fields.filter(function(f) {
                        if (!memo[f.key]) {
                            memo[f.key] = true;
                            f.label = typeof f.label === "string" ? f.label : __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(f.key);
                            return true;
                        }
                        return false;
                    });
                },
                computedItems: function computedItems() {
                    var perPage = this.perPage;
                    var currentPage = this.currentPage;
                    var filter = this.filter;
                    var sortBy = this.localSortBy;
                    var sortDesc = this.localSortDesc;
                    var sortCompare = this.sortCompare;
                    var localFiltering = this.localFiltering;
                    var localSorting = this.localSorting;
                    var localPaging = this.localPaging;
                    var items = this.hasProvider ? this.localItems : this.items;
                    if (!items) {
                        this.$nextTick(this._providerUpdate);
                        return [];
                    }
                    items = items.slice();
                    if (filter && localFiltering) {
                        if (filter instanceof Function) {
                            items = items.filter(filter);
                        } else {
                            var regex = void 0;
                            if (filter instanceof RegExp) {
                                regex = filter;
                            } else {
                                regex = new RegExp(".*" + filter + ".*", "ig");
                            }
                            items = items.filter(function(item) {
                                var test = regex.test(recToString(item));
                                regex.lastIndex = 0;
                                return test;
                            });
                        }
                    }
                    if (localFiltering) {
                        this.filteredItems = items.slice();
                    }
                    if (sortBy && localSorting) {
                        items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_stable_sort__["a"])(items, function(a, b) {
                            var ret = null;
                            if (typeof sortCompare === "function") {
                                ret = sortCompare(a, b, sortBy);
                            }
                            if (ret === null || ret === undefined) {
                                ret = defaultSortCompare(a, b, sortBy);
                            }
                            return (ret || 0) * (sortDesc ? -1 : 1);
                        });
                    }
                    if (Boolean(perPage) && localPaging) {
                        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
                    }
                    this.$emit("input", items);
                    return items;
                },
                computedBusy: function computedBusy() {
                    return this.busy || this.localBusy;
                }
            },
            methods: {
                keys: __WEBPACK_IMPORTED_MODULE_6__utils_object__["b"],
                fieldClasses: function fieldClasses(field) {
                    return [ field.sortable ? "sorting" : "", field.sortable && this.localSortBy === field.key ? "sorting_" + (this.localSortDesc ? "desc" : "asc") : "", field.variant ? "table-" + field.variant : "", field.class ? field.class : "", field.thClass ? field.thClass : "" ];
                },
                tdClasses: function tdClasses(field, item) {
                    var t = this;
                    var cellVariant = "";
                    if (item._cellVariants && item._cellVariants[field.key]) {
                        cellVariant = (this.dark ? "bg" : "table") + "-" + item._cellVariants[field.key];
                    }
                    return [ field.variant && !cellVariant ? (this.dark ? "bg" : "table") + "-" + field.variant : "", cellVariant, field.class ? field.class : "", t.getTdClasses(item, field) ];
                },
                rowClasses: function rowClasses(item) {
                    return [ item._rowVariant ? (this.dark ? "bg" : "table") + "-" + item._rowVariant : "", this.tbodyTrClass ];
                },
                rowClicked: function rowClicked(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-clicked", item, index, e);
                },
                rowDblClicked: function rowDblClicked(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-dblclicked", item, index, e);
                },
                rowHovered: function rowHovered(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-hovered", item, index, e);
                },
                headClicked: function headClicked(e, field) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    var sortChanged = false;
                    if (field.sortable) {
                        if (field.key === this.localSortBy) {
                            this.localSortDesc = !this.localSortDesc;
                        } else {
                            this.localSortBy = field.key;
                            this.localSortDesc = false;
                        }
                        sortChanged = true;
                    } else if (this.localSortBy) {
                        this.localSortBy = null;
                        this.localSortDesc = false;
                        sortChanged = true;
                    }
                    this.$emit("head-clicked", field.key, field, e);
                    if (sortChanged) {
                        this.$emit("sort-changed", this.context);
                    }
                },
                stopIfBusy: function stopIfBusy(evt) {
                    if (this.computedBusy) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        return true;
                    }
                    return false;
                },
                refresh: function refresh() {
                    if (this.hasProvider) {
                        this._providerUpdate();
                    }
                },
                _providerSetLocal: function _providerSetLocal(items) {
                    this.localItems = items && items.length > 0 ? items.slice() : [];
                    this.localBusy = false;
                    this.$emit("refreshed");
                    this.emitOnRoot("table::refreshed", this.id);
                    if (this.id) {
                        this.emitOnRoot("bv::table::refreshed", this.id);
                    }
                },
                _providerUpdate: function _providerUpdate() {
                    var _this4 = this;
                    if (this.computedBusy || !this.hasProvider) {
                        return;
                    }
                    this.localBusy = true;
                    var data = this.items(this.context, this._providerSetLocal);
                    if (data && data.then && typeof data.then === "function") {
                        data.then(function(items) {
                            _this4._providerSetLocal(items);
                        });
                    } else {
                        this._providerSetLocal(data);
                    }
                },
                getTdClasses: function getTdClasses(item, field) {
                    var key = field.key;
                    var tdClass = field.tdClass;
                    var parent = this.$parent;
                    if (tdClass) {
                        if (typeof tdClass === "function") {
                            var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
                            return tdClass(value, key, item);
                        } else if (typeof tdClass === "string" && typeof parent[tdClass] === "function") {
                            var _value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
                            return parent[tdClass](_value, key, item);
                        }
                        return tdClass;
                    }
                    return "";
                },
                getFormattedValue: function getFormattedValue(item, field) {
                    var key = field.key;
                    var formatter = field.formatter;
                    var parent = this.$parent;
                    var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
                    if (formatter) {
                        if (typeof formatter === "function") {
                            value = formatter(value, key, item);
                        } else if (typeof formatter === "string" && typeof parent[formatter] === "function") {
                            value = parent[formatter](value, key, item);
                        }
                    }
                    return value;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(141);
        var __WEBPACK_IMPORTED_MODULE_1__tab__ = __webpack_require__(140);
        var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);
        var components = {
            bTabs: __WEBPACK_IMPORTED_MODULE_0__tabs__["a"],
            bTab: __WEBPACK_IMPORTED_MODULE_1__tab__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(4);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_0__mixins_id__["a"] ],
            render: function render(h) {
                var content = h(false);
                if (this.localActive || !this.computedLazy) {
                    content = h(this.tag, {
                        ref: "panel",
                        class: this.tabClasses,
                        directives: [ {
                            name: "show",
                            value: this.localActive
                        } ],
                        attrs: {
                            role: "tabpanel",
                            id: this.safeId(),
                            "aria-hidden": this.localActive ? "false" : "true",
                            "aria-expanded": this.localActive ? "true" : "false",
                            "aria-lablelledby": this.controlledBy || null
                        }
                    }, [ this.$slots.default ]);
                }
                return h("transition", {
                    props: {
                        mode: "out-in"
                    },
                    on: {
                        beforeEnter: this.beforeEnter,
                        afterEnter: this.afterEnter,
                        afterLeave: this.afterLeave
                    }
                }, [ content ]);
            },
            methods: {
                beforeEnter: function beforeEnter() {
                    this.show = false;
                },
                afterEnter: function afterEnter() {
                    this.show = true;
                },
                afterLeave: function afterLeave() {
                    this.show = false;
                }
            },
            data: function data() {
                return {
                    localActive: this.active && !this.disabled,
                    show: false
                };
            },
            mounted: function mounted() {
                this.show = this.localActive;
            },
            computed: {
                tabClasses: function tabClasses() {
                    return [ "tab-pane", this.$parent && this.$parent.card && !this.noBody ? "card-body" : "", this.show ? "show" : "", this.computedFade ? "fade" : "", this.disabled ? "disabled" : "", this.localActive ? "active" : "" ];
                },
                controlledBy: function controlledBy() {
                    return this.buttonId || this.safeId("__BV_tab_button__");
                },
                computedFade: function computedFade() {
                    return this.$parent.fade;
                },
                computedLazy: function computedLazy() {
                    return this.$parent.lazy;
                },
                _isTab: function _isTab() {
                    return true;
                }
            },
            props: {
                active: {
                    type: Boolean,
                    default: false
                },
                tag: {
                    type: String,
                    default: "div"
                },
                buttonId: {
                    type: String,
                    default: ""
                },
                title: {
                    type: String,
                    default: ""
                },
                titleItemClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                titleLinkClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                headHtml: {
                    type: String,
                    default: null
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                noBody: {
                    type: Boolean,
                    default: false
                },
                href: {
                    type: String,
                    default: "#"
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__ = __webpack_require__(16);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(4);
        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        }
        var bTabButtonHelper = {
            name: "bTabButtonHelper",
            props: {
                content: {
                    type: [ String, Array ],
                    default: ""
                },
                href: {
                    type: String,
                    default: "#"
                },
                posInSet: {
                    type: Number,
                    default: null
                },
                setSize: {
                    type: Number,
                    default: null
                },
                controls: {
                    type: String,
                    default: null
                },
                id: {
                    type: String,
                    default: null
                },
                active: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                linkClass: {
                    default: null
                },
                itemClass: {
                    default: null
                },
                noKeyNav: {
                    type: Boolean,
                    default: false
                }
            },
            render: function render(h) {
                var link = h("a", {
                    class: [ "nav-link", {
                        active: this.active,
                        disabled: this.disabled
                    }, this.linkClass ],
                    attrs: {
                        role: "tab",
                        tabindex: this.noKeyNav ? null : "-1",
                        href: this.href,
                        id: this.id,
                        disabled: this.disabled,
                        "aria-selected": this.active ? "true" : "false",
                        "aria-setsize": this.setSize,
                        "aria-posinset": this.posInSet,
                        "aria-controls": this.controls
                    },
                    on: {
                        click: this.handleClick,
                        keydown: this.handleClick
                    }
                }, this.content);
                return h("li", {
                    class: [ "nav-item", this.itemClass ],
                    attrs: {
                        role: "presentation"
                    }
                }, [ link ]);
            },
            methods: {
                handleClick: function handleClick(evt) {
                    function stop() {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    if (evt.type !== "click" && this.noKeyNav) {
                        return;
                    }
                    if (this.disabled) {
                        stop();
                        return;
                    }
                    if (evt.type === "click" || evt.keyCode === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].ENTER || evt.keyCode === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].SPACE) {
                        stop();
                        this.$emit("click", evt);
                    }
                }
            }
        };
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_id__["a"] ],
            render: function render(h) {
                var _this = this, _ref;
                var tabs = this.tabs;
                var buttons = tabs.map(function(tab, index) {
                    return h(bTabButtonHelper, {
                        key: index,
                        props: {
                            content: tab.$slots.title || tab.title,
                            href: tab.href,
                            id: tab.controlledBy || _this.safeId("_BV_tab_" + (index + 1) + "_"),
                            active: tab.localActive,
                            disabled: tab.disabled,
                            setSize: tabs.length,
                            posInSet: index + 1,
                            controls: _this.safeId("_BV_tab_container_"),
                            linkClass: tab.titleLinkClass,
                            itemClass: tab.titleItemClass,
                            noKeyNav: _this.noKeyNav
                        },
                        on: {
                            click: function click(evt) {
                                _this.setTab(index);
                            }
                        }
                    });
                });
                var navs = h("ul", {
                    class: [ "nav", (_ref = {}, _defineProperty(_ref, "nav-" + this.navStyle, !this.noNavStyle), 
                    _defineProperty(_ref, "card-header-" + this.navStyle, this.card && !this.vertical), 
                    _defineProperty(_ref, "card-header", this.card && this.vertical), _defineProperty(_ref, "h-100", this.card && this.vertical), 
                    _defineProperty(_ref, "flex-column", this.vertical), _defineProperty(_ref, "border-bottom-0", this.vertical), 
                    _defineProperty(_ref, "rounded-0", this.vertical), _defineProperty(_ref, "small", this.small), 
                    _ref), this.navClass ],
                    attrs: {
                        role: "tablist",
                        tabindex: this.noKeyNav ? null : "0",
                        id: this.safeId("_BV_tab_controls_")
                    },
                    on: {
                        keydown: this.onKeynav
                    }
                }, [ buttons, this.$slots.tabs ]);
                navs = h("div", {
                    class: [ {
                        "card-header": this.card && !this.vertical && !(this.end || this.bottom),
                        "card-footer": this.card && !this.vertical && (this.end || this.bottom),
                        "col-auto": this.vertical
                    }, this.navWrapperClass ]
                }, [ navs ]);
                var empty = void 0;
                if (tabs && tabs.length) {
                    empty = h(false);
                } else {
                    empty = h("div", {
                        class: [ "tab-pane", "active", {
                            "card-body": this.card
                        } ]
                    }, this.$slots.empty);
                }
                var content = h("div", {
                    ref: "tabsContainer",
                    class: [ "tab-content", {
                        col: this.vertical
                    }, this.contentClass ],
                    attrs: {
                        id: this.safeId("_BV_tab_container_")
                    }
                }, [ this.$slots.default, empty ]);
                return h(this.tag, {
                    class: [ "tabs", {
                        row: this.vertical,
                        "no-gutters": this.vertical && this.card
                    } ],
                    attrs: {
                        id: this.safeId()
                    }
                }, [ this.end || this.bottom ? content : h(false), [ navs ], this.end || this.bottom ? h(false) : content ]);
            },
            data: function data() {
                return {
                    currentTab: this.value,
                    tabs: []
                };
            },
            props: {
                tag: {
                    type: String,
                    default: "div"
                },
                card: {
                    type: Boolean,
                    default: false
                },
                small: {
                    type: Boolean,
                    default: false
                },
                value: {
                    type: Number,
                    default: null
                },
                pills: {
                    type: Boolean,
                    default: false
                },
                vertical: {
                    type: Boolean,
                    default: false
                },
                bottom: {
                    type: Boolean,
                    default: false
                },
                end: {
                    type: Boolean,
                    default: false
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                noNavStyle: {
                    type: Boolean,
                    default: false
                },
                noKeyNav: {
                    type: Boolean,
                    default: false
                },
                lazy: {
                    type: Boolean,
                    default: false
                },
                contentClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                navClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                navWrapperClass: {
                    type: [ String, Array, Object ],
                    default: null
                }
            },
            watch: {
                currentTab: function currentTab(val, old) {
                    if (val === old) {
                        return;
                    }
                    this.$root.$emit("changed::tab", this, val, this.tabs[val]);
                    this.$emit("input", val);
                    this.tabs[val].$emit("click");
                },
                value: function value(val, old) {
                    if (val === old) {
                        return;
                    }
                    if (typeof old !== "number") {
                        old = 0;
                    }
                    var direction = val < old ? -1 : 1;
                    this.setTab(val, false, direction);
                }
            },
            computed: {
                fade: function fade() {
                    return !this.noFade;
                },
                navStyle: function navStyle() {
                    return this.pills ? "pills" : "tabs";
                }
            },
            methods: {
                sign: function sign(x) {
                    return x === 0 ? 0 : x > 0 ? 1 : -1;
                },
                onKeynav: function onKeynav(evt) {
                    if (this.noKeyNav) {
                        return;
                    }
                    var key = evt.keyCode;
                    var shift = evt.shiftKey;
                    function stop() {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    if (key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].UP || key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].LEFT) {
                        stop();
                        if (shift) {
                            this.setTab(0, false, 1);
                        } else {
                            this.previousTab();
                        }
                    } else if (key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].DOWN || key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a"].RIGHT) {
                        stop();
                        if (shift) {
                            this.setTab(this.tabs.length - 1, false, -1);
                        } else {
                            this.nextTab();
                        }
                    }
                },
                nextTab: function nextTab() {
                    this.setTab(this.currentTab + 1, false, 1);
                },
                previousTab: function previousTab() {
                    this.setTab(this.currentTab - 1, false, -1);
                },
                setTab: function setTab(index, force, direction) {
                    var _this2 = this;
                    direction = this.sign(direction || 0);
                    index = index || 0;
                    if (!force && index === this.currentTab) {
                        return;
                    }
                    var tab = this.tabs[index];
                    if (!tab) {
                        this.$emit("input", this.currentTab);
                        return;
                    }
                    if (tab.disabled) {
                        if (direction) {
                            this.setTab(index + direction, force, direction);
                        }
                        return;
                    }
                    this.tabs.forEach(function(t) {
                        if (t === tab) {
                            _this2.$set(t, "localActive", true);
                        } else {
                            _this2.$set(t, "localActive", false);
                        }
                    });
                    this.currentTab = index;
                },
                updateTabs: function updateTabs() {
                    this.tabs = this.$children.filter(function(child) {
                        return child._isTab;
                    });
                    var tabIndex = null;
                    this.tabs.forEach(function(tab, index) {
                        if (tab.localActive && !tab.disabled) {
                            tabIndex = index;
                        }
                    });
                    if (tabIndex === null) {
                        if (this.currentTab >= this.tabs.length) {
                            this.setTab(this.tabs.length - 1, true, -1);
                            return;
                        } else if (this.tabs[this.currentTab] && !this.tabs[this.currentTab].disabled) {
                            tabIndex = this.currentTab;
                        }
                    }
                    if (tabIndex === null) {
                        this.tabs.forEach(function(tab, index) {
                            if (!tab.disabled && tabIndex === null) {
                                tabIndex = index;
                            }
                        });
                    }
                    this.setTab(tabIndex || 0, true, 0);
                }
            },
            mounted: function mounted() {
                this.updateTabs();
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a"])(this.$refs.tabsContainer, this.updateTabs.bind(this), {
                    subtree: false
                });
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(143);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var components = {
            bTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a"])(Vue, components);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__ = __webpack_require__(51);
        var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__ = __webpack_require__(154);
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__["a"] ],
            render: function render(h) {
                return h("div", {
                    class: [ "d-none" ],
                    style: {
                        display: "none"
                    },
                    attrs: {
                        "aria-hidden": true
                    }
                }, [ h("div", {
                    ref: "title"
                }, this.$slots.default) ]);
            },
            data: function data() {
                return {};
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                triggers: {
                    type: [ String, Array ],
                    default: "hover focus"
                },
                placement: {
                    type: String,
                    default: "top"
                }
            },
            methods: {
                createToolpop: function createToolpop() {
                    var target = this.getTarget();
                    if (target) {
                        this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__["a"](target, this.getConfig(), this.$root);
                    } else {
                        this._toolpop = null;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a"])("b-tooltip: 'target' element not found!");
                    }
                    return this._toolpop;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(145);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var directives = {
            bModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c"])(Vue, directives);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_target__ = __webpack_require__(158);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var listenTypes = {
            click: true
        };
        __webpack_exports__["a"] = {
            bind: function bind(el, binding, vnode) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_target__["a"])(vnode, binding, listenTypes, function(_ref) {
                    var targets = _ref.targets, vnode = _ref.vnode;
                    targets.forEach(function(target) {
                        vnode.context.$root.$emit("bv::show::modal", target, vnode.elm);
                    });
                });
                if (el.tagName !== "BUTTON") {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(el, "role", "button");
                }
            },
            unbind: function unbind(el, binding, vnode) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_target__["b"])(vnode, binding, listenTypes);
                if (el.tagName !== "BUTTON") {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["k"])(el, "role", "button");
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(17);
        var __WEBPACK_IMPORTED_MODULE_1__utils_popover_class__ = __webpack_require__(157);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__utils_warn__ = __webpack_require__(7);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var inBrowser = typeof window !== "undefined" && typeof document !== "undefined";
        var BVPO = "__BV_PopOver__";
        var validTriggers = {
            focus: true,
            hover: true,
            click: true,
            blur: true
        };
        function parseBindings(bindings) {
            var config = {};
            if (typeof bindings.value === "string") {
                config.content = bindings.value;
            } else if (typeof bindings.value === "function") {
                config.content = bindings.value;
            } else if (_typeof(bindings.value) === "object") {
                config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])(bindings.value);
            }
            if (bindings.arg) {
                config.container = "#" + bindings.arg;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(bindings.modifiers).forEach(function(mod) {
                if (/^html$/.test(mod)) {
                    config.html = true;
                } else if (/^nofade$/.test(mod)) {
                    config.animation = false;
                } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
                    config.placement = mod;
                } else if (/^(window|viewport)$/.test(mod)) {
                    config.boundary = mod;
                } else if (/^d\d+$/.test(mod)) {
                    var delay = parseInt(mod.slice(1), 10) || 0;
                    if (delay) {
                        config.delay = delay;
                    }
                } else if (/^o-?\d+$/.test(mod)) {
                    var offset = parseInt(mod.slice(1), 10) || 0;
                    if (offset) {
                        config.offset = offset;
                    }
                }
            });
            var selectedTriggers = {};
            var triggers = typeof config.trigger === "string" ? config.trigger.trim().split(/\s+/) : [];
            triggers.forEach(function(trigger) {
                if (validTriggers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(validTriggers).forEach(function(trigger) {
                if (bindings.modifiers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            config.trigger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(selectedTriggers).join(" ");
            if (config.trigger === "blur") {
                config.trigger = "focus";
            }
            if (!config.trigger) {
                delete config.trigger;
            }
            return config;
        }
        function applyBVPO(el, bindings, vnode) {
            if (!inBrowser) {
                return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_0_popper_js__["a"]) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warn__["a"])("v-b-popover: Popper.js is required for popovers to work");
                return;
            }
            if (el[BVPO]) {
                el[BVPO].updateConfig(parseBindings(bindings));
            } else {
                el[BVPO] = new __WEBPACK_IMPORTED_MODULE_1__utils_popover_class__["a"](el, parseBindings(bindings), vnode.context.$root);
            }
        }
        function removeBVPO(el) {
            if (!inBrowser) {
                return;
            }
            if (el[BVPO]) {
                el[BVPO].destroy();
                el[BVPO] = null;
                delete el[BVPO];
            }
        }
        __webpack_exports__["a"] = {
            bind: function bind(el, bindings, vnode) {
                applyBVPO(el, bindings, vnode);
            },
            inserted: function inserted(el, bindings, vnode) {
                applyBVPO(el, bindings, vnode);
            },
            update: function update(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVPO(el, bindings, vnode);
                }
            },
            componentUpdated: function componentUpdated(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVPO(el, bindings, vnode);
                }
            },
            unbind: function unbind(el) {
                removeBVPO(el);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__scrollspy_class__ = __webpack_require__(174);
        var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var inBrowser = typeof window !== "undefined";
        var isServer = !inBrowser;
        var BVSS = "__BV_ScrollSpy__";
        function makeConfig(binding) {
            var config = {};
            if (binding.arg) {
                config.element = "#" + binding.arg;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b"])(binding.modifiers).forEach(function(mod) {
                if (/^\d+$/.test(mod)) {
                    config.offset = parseInt(mod, 10);
                } else if (/^(auto|position|offset)$/.test(mod)) {
                    config.method = mod;
                }
            });
            if (typeof binding.value === "string") {
                config.element = binding.value;
            } else if (typeof binding.value === "number") {
                config.offset = Math.round(binding.value);
            } else if (_typeof(binding.value) === "object") {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b"])(binding.value).filter(function(k) {
                    return Boolean(__WEBPACK_IMPORTED_MODULE_0__scrollspy_class__["a"].DefaultType[k]);
                }).forEach(function(k) {
                    config[k] = binding.value[k];
                });
            }
            return config;
        }
        function addBVSS(el, binding, vnode) {
            if (isServer) {
                return;
            }
            var cfg = makeConfig(binding);
            if (!el[BVSS]) {
                el[BVSS] = new __WEBPACK_IMPORTED_MODULE_0__scrollspy_class__["a"](el, cfg, vnode.context.$root);
            } else {
                el[BVSS].updateConfig(cfg, vnode.context.$root);
            }
            return el[BVSS];
        }
        function removeBVSS(el) {
            if (el[BVSS]) {
                el[BVSS].dispose();
                el[BVSS] = null;
            }
        }
        __webpack_exports__["a"] = {
            bind: function bind(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            inserted: function inserted(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            update: function update(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            componentUpdated: function componentUpdated(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            unbind: function unbind(el) {
                if (isServer) {
                    return;
                }
                removeBVSS(el);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__toggle__ = __webpack_require__(149);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var directives = {
            bToggle: __WEBPACK_IMPORTED_MODULE_0__toggle__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c"])(Vue, directives);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_target__ = __webpack_require__(158);
        var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
        var inBrowser = typeof window !== "undefined";
        var listenTypes = {
            click: true
        };
        var BVT = "__BV_toggle__";
        var EVENT_TOGGLE = "bv::toggle::collapse";
        var EVENT_STATE = "bv::collapse::state";
        __webpack_exports__["a"] = {
            bind: function bind(el, binding, vnode) {
                var targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_target__["c"])(vnode, binding, listenTypes, function(_ref) {
                    var targets = _ref.targets, vnode = _ref.vnode;
                    targets.forEach(function(target) {
                        vnode.context.$root.$emit(EVENT_TOGGLE, target);
                    });
                });
                if (inBrowser && vnode.context && targets.length > 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(el, "aria-controls", targets.join(" "));
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(el, "aria-expanded", "false");
                    if (el.tagName !== "BUTTON") {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(el, "role", "button");
                    }
                    el[BVT] = function toggleDirectiveHandler(id, state) {
                        if (targets.indexOf(id) !== -1) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c"])(el, "aria-expanded", state ? "true" : "false");
                            if (state) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e"])(el, "collapsed");
                            } else {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d"])(el, "collapsed");
                            }
                        }
                    };
                    vnode.context.$root.$on(EVENT_STATE, el[BVT]);
                }
            },
            unbind: function unbind(el, binding, vnode) {
                if (el[BVT]) {
                    vnode.context.$root.$off(EVENT_STATE, el[BVT]);
                    el[BVT] = null;
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(17);
        var __WEBPACK_IMPORTED_MODULE_1__utils_tooltip_class__ = __webpack_require__(51);
        var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_3__utils_warn__ = __webpack_require__(7);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var inBrowser = typeof window !== "undefined" && typeof document !== "undefined";
        var BVTT = "__BV_ToolTip__";
        var validTriggers = {
            focus: true,
            hover: true,
            click: true,
            blur: true
        };
        function parseBindings(bindings) {
            var config = {};
            if (typeof bindings.value === "string") {
                config.title = bindings.value;
            } else if (typeof bindings.value === "function") {
                config.title = bindings.value;
            } else if (_typeof(bindings.value) === "object") {
                config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a"])(bindings.value);
            }
            if (bindings.arg) {
                config.container = "#" + bindings.arg;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(bindings.modifiers).forEach(function(mod) {
                if (/^html$/.test(mod)) {
                    config.html = true;
                } else if (/^nofade$/.test(mod)) {
                    config.animation = false;
                } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
                    config.placement = mod;
                } else if (/^(window|viewport)$/.test(mod)) {
                    config.boundary = mod;
                } else if (/^d\d+$/.test(mod)) {
                    var delay = parseInt(mod.slice(1), 10) || 0;
                    if (delay) {
                        config.delay = delay;
                    }
                } else if (/^o-?\d+$/.test(mod)) {
                    var offset = parseInt(mod.slice(1), 10) || 0;
                    if (offset) {
                        config.offset = offset;
                    }
                }
            });
            var selectedTriggers = {};
            var triggers = typeof config.trigger === "string" ? config.trigger.trim().split(/\s+/) : [];
            triggers.forEach(function(trigger) {
                if (validTriggers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(validTriggers).forEach(function(trigger) {
                if (bindings.modifiers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            config.trigger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b"])(selectedTriggers).join(" ");
            if (config.trigger === "blur") {
                config.trigger = "focus";
            }
            if (!config.trigger) {
                delete config.trigger;
            }
            return config;
        }
        function applyBVTT(el, bindings, vnode) {
            if (!inBrowser) {
                return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_0_popper_js__["a"]) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warn__["a"])("v-b-tooltip: Popper.js is required for tooltips to work");
                return;
            }
            if (el[BVTT]) {
                el[BVTT].updateConfig(parseBindings(bindings));
            } else {
                el[BVTT] = new __WEBPACK_IMPORTED_MODULE_1__utils_tooltip_class__["a"](el, parseBindings(bindings), vnode.context.$root);
            }
        }
        function removeBVTT(el) {
            if (!inBrowser) {
                return;
            }
            if (el[BVTT]) {
                el[BVTT].destroy();
                el[BVTT] = null;
                delete el[BVTT];
            }
        }
        __webpack_exports__["a"] = {
            bind: function bind(el, bindings, vnode) {
                applyBVTT(el, bindings, vnode);
            },
            inserted: function inserted(el, bindings, vnode) {
                applyBVTT(el, bindings, vnode);
            },
            update: function update(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVTT(el, bindings, vnode);
                }
            },
            componentUpdated: function componentUpdated(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVTT(el, bindings, vnode);
                }
            },
            unbind: function unbind(el) {
                removeBVTT(el);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(17);
        var __WEBPACK_IMPORTED_MODULE_1__clickout__ = __webpack_require__(176);
        var __WEBPACK_IMPORTED_MODULE_2__listen_on_root__ = __webpack_require__(15);
        var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_6__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(5);
        function filterVisible(els) {
            return (els || []).filter(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["b"]);
        }
        var ITEM_SELECTOR = ".dropdown-item:not(.disabled):not([disabled])";
        var AttachmentMap = {
            TOP: "top-start",
            TOPEND: "top-end",
            BOTTOM: "bottom-start",
            BOTTOMEND: "bottom-end"
        };
        __webpack_exports__["a"] = {
            mixins: [ __WEBPACK_IMPORTED_MODULE_1__clickout__["a"], __WEBPACK_IMPORTED_MODULE_2__listen_on_root__["a"] ],
            props: {
                disabled: {
                    type: Boolean,
                    default: false
                },
                text: {
                    type: String,
                    default: ""
                },
                dropup: {
                    type: Boolean,
                    default: false
                },
                right: {
                    type: Boolean,
                    default: false
                },
                offset: {
                    type: [ Number, String ],
                    default: 0
                },
                noFlip: {
                    type: Boolean,
                    default: false
                },
                popperOpts: {
                    type: Object,
                    default: function _default() {}
                }
            },
            data: function data() {
                return {
                    visible: false,
                    inNavbar: null
                };
            },
            created: function created() {
                this._popper = null;
            },
            mounted: function mounted() {
                this.listenOnRoot("bv::dropdown::shown", this.rootCloseListener);
                this.listenOnRoot("clicked::link", this.rootCloseListener);
                this.listenOnRoot("bv::link::clicked", this.rootCloseListener);
            },
            deactivated: function deactivated() {
                this.visible = false;
                this.setTouchStart(false);
                this.removePopper();
            },
            beforeDestroy: function beforeDestroy() {
                this.visible = false;
                this.setTouchStart(false);
                this.removePopper();
            },
            watch: {
                visible: function visible(state, old) {
                    if (state === old) {
                        return;
                    }
                    if (state) {
                        this.showMenu();
                    } else {
                        this.hideMenu();
                    }
                },
                disabled: function disabled(state, old) {
                    if (state !== old && state && this.visible) {
                        this.visible = false;
                    }
                }
            },
            computed: {
                toggler: function toggler() {
                    return this.$refs.toggle.$el || this.$refs.toggle;
                }
            },
            methods: {
                showMenu: function showMenu() {
                    if (this.disabled) {
                        return;
                    }
                    this.$emit("show");
                    this.emitOnRoot("bv::dropdown::shown", this);
                    if (this.inNavbar === null && this.isNav) {
                        this.inNavbar = Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["h"])(".navbar", this.$el));
                    }
                    if (!this.inNavbar) {
                        if (typeof __WEBPACK_IMPORTED_MODULE_0_popper_js__["a"] === "undefined") {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_warn__["a"])("b-dropdown: Popper.js not found. Falling back to CSS positioning.");
                        } else {
                            var element = this.dropup && this.right || this.split ? this.$el : this.$refs.toggle;
                            element = element.$el || element;
                            this.createPopper(element);
                        }
                    }
                    this.setTouchStart(true);
                    this.$emit("shown");
                    this.$nextTick(this.focusFirstItem);
                },
                hideMenu: function hideMenu() {
                    this.$emit("hide");
                    this.setTouchStart(false);
                    this.emitOnRoot("bv::dropdown::hidden", this);
                    this.$emit("hidden");
                    this.removePopper();
                },
                createPopper: function createPopper(element) {
                    this.removePopper();
                    this._popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a"](element, this.$refs.menu, this.getPopperConfig());
                },
                removePopper: function removePopper() {
                    if (this._popper) {
                        this._popper.destroy();
                    }
                    this._popper = null;
                },
                getPopperConfig: function getPopperConfig() {
                    var placement = AttachmentMap.BOTTOM;
                    if (this.dropup && this.right) {
                        placement = AttachmentMap.TOPEND;
                    } else if (this.dropup) {
                        placement = AttachmentMap.TOP;
                    } else if (this.right) {
                        placement = AttachmentMap.BOTTOMEND;
                    }
                    var popperConfig = {
                        placement: placement,
                        modifiers: {
                            offset: {
                                offset: this.offset || 0
                            },
                            flip: {
                                enabled: !this.noFlip
                            }
                        }
                    };
                    if (this.boundary) {
                        popperConfig.modifiers.preventOverflow = {
                            boundariesElement: this.boundary
                        };
                    }
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a"])(popperConfig, this.popperOpts || {});
                },
                setTouchStart: function setTouchStart(on) {
                    var _this = this;
                    if ("ontouchstart" in document.documentElement) {
                        var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["a"])(document.body.children);
                        children.forEach(function(el) {
                            if (on) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["f"])("mouseover", _this._noop);
                            } else {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["g"])("mouseover", _this._noop);
                            }
                        });
                    }
                },
                _noop: function _noop() {},
                rootCloseListener: function rootCloseListener(vm) {
                    if (vm !== this) {
                        this.visible = false;
                    }
                },
                clickOutListener: function clickOutListener() {
                    this.visible = false;
                },
                show: function show() {
                    if (this.disabled) {
                        return;
                    }
                    this.visible = true;
                },
                hide: function hide() {
                    if (this.disabled) {
                        return;
                    }
                    this.visible = false;
                },
                toggle: function toggle(evt) {
                    evt = evt || {};
                    var type = evt.type;
                    var key = evt.keyCode;
                    if (type !== "click" && !(type === "keydown" && (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].ENTER || key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].SPACE || key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].DOWN))) {
                        return;
                    }
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.disabled) {
                        this.visible = false;
                        return;
                    }
                    this.visible = !this.visible;
                },
                click: function click(evt) {
                    if (this.disabled) {
                        this.visible = false;
                        return;
                    }
                    this.$emit("click", evt);
                },
                onKeydown: function onKeydown(evt) {
                    var key = evt.keyCode;
                    if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].ESC) {
                        this.onEsc(evt);
                    } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].TAB) {
                        this.onTab(evt);
                    } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].DOWN) {
                        this.focusNext(evt, false);
                    } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a"].UP) {
                        this.focusNext(evt, true);
                    }
                },
                onEsc: function onEsc(evt) {
                    if (this.visible) {
                        this.visible = false;
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.$nextTick(this.focusToggler);
                    }
                },
                onTab: function onTab(evt) {
                    if (this.visible) {
                        this.visible = false;
                    }
                },
                onFocusOut: function onFocusOut(evt) {
                    if (this.$refs.menu.contains(evt.relatedTarget)) {
                        return;
                    }
                    this.visible = false;
                },
                onMouseOver: function onMouseOver(evt) {
                    var item = evt.target;
                    if (item.classList.contains("dropdown-item") && !item.disabled && !item.classList.contains("disabled") && item.focus) {
                        item.focus();
                    }
                },
                focusNext: function focusNext(evt, up) {
                    var _this2 = this;
                    if (!this.visible) {
                        return;
                    }
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.$nextTick(function() {
                        var items = _this2.getItems();
                        if (items.length < 1) {
                            return;
                        }
                        var index = items.indexOf(evt.target);
                        if (up && index > 0) {
                            index--;
                        } else if (!up && index < items.length - 1) {
                            index++;
                        }
                        if (index < 0) {
                            index = 0;
                        }
                        _this2.focusItem(index, items);
                    });
                },
                focusItem: function focusItem(idx, items) {
                    var el = items.find(function(el, i) {
                        return i === idx;
                    });
                    if (el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j"])(el, "tabindex") !== "-1") {
                        el.focus();
                    }
                },
                getItems: function getItems() {
                    return filterVisible(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q"])(ITEM_SELECTOR, this.$refs.menu));
                },
                getFirstItem: function getFirstItem() {
                    var item = this.getItems()[0];
                    return item || null;
                },
                focusFirstItem: function focusFirstItem() {
                    var item = this.getFirstItem();
                    if (item) {
                        this.focusItem(0, [ item ]);
                    }
                },
                focusToggler: function focusToggler() {
                    var toggler = this.toggler;
                    if (toggler && toggler.focus) {
                        toggler.focus();
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            data: function data() {
                return {
                    localChecked: this.checked,
                    hasFocus: false
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                value: {},
                checked: {},
                buttonVariant: {
                    type: String,
                    default: null
                }
            },
            computed: {
                computedLocalChecked: {
                    get: function get() {
                        if (this.is_Child) {
                            return this.$parent.localChecked;
                        } else {
                            return this.localChecked;
                        }
                    },
                    set: function set(val) {
                        if (this.is_Child) {
                            this.$parent.localChecked = val;
                        } else {
                            this.localChecked = val;
                        }
                    }
                },
                is_Child: function is_Child() {
                    return Boolean(this.$parent && this.$parent.is_RadioCheckGroup);
                },
                is_Disabled: function is_Disabled() {
                    return Boolean(this.is_Child ? this.$parent.disabled || this.disabled : this.disabled);
                },
                is_Required: function is_Required() {
                    return Boolean(this.is_Child ? this.$parent.required : this.required);
                },
                is_Plain: function is_Plain() {
                    return Boolean(this.is_Child ? this.$parent.plain : this.plain);
                },
                is_Custom: function is_Custom() {
                    return !this.is_Plain;
                },
                get_Size: function get_Size() {
                    return this.is_Child ? this.$parent.size : this.size;
                },
                get_State: function get_State() {
                    if (this.is_Child && typeof this.$parent.get_State === "boolean") {
                        return this.$parent.get_State;
                    }
                    return this.computedState;
                },
                get_StateClass: function get_StateClass() {
                    return typeof this.get_State === "boolean" ? this.get_State ? "is-valid" : "is-invalid" : "";
                },
                is_Stacked: function is_Stacked() {
                    return Boolean(this.is_Child && this.$parent.stacked);
                },
                is_Inline: function is_Inline() {
                    return !this.is_Stacked;
                },
                is_ButtonMode: function is_ButtonMode() {
                    return Boolean(this.is_Child && this.$parent.buttons);
                },
                get_ButtonVariant: function get_ButtonVariant() {
                    return this.buttonVariant || (this.is_Child ? this.$parent.buttonVariant : null) || "secondary";
                },
                get_Name: function get_Name() {
                    return (this.is_Child ? this.$parent.name || this.$parent.safeId() : this.name) || null;
                },
                buttonClasses: function buttonClasses() {
                    return [ "btn", "btn-" + this.get_ButtonVariant, this.get_Size ? "btn-" + this.get_Size : "", this.is_Disabled ? "disabled" : "", this.is_Checked ? "active" : "", this.hasFocus ? "focus" : "" ];
                }
            },
            methods: {
                handleFocus: function handleFocus(evt) {
                    if (this.is_ButtonMode && evt.target) {
                        if (evt.type === "focus") {
                            this.hasFocus = true;
                        } else if (evt.type === "blur") {
                            this.hasFocus = false;
                        }
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_range__ = __webpack_require__(179);
        var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_3__components_link_link__ = __webpack_require__(6);
        function makePageArray(startNum, numPages) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_range__["a"])(numPages).map(function(value, index) {
                return {
                    number: index + startNum,
                    className: null
                };
            });
        }
        var ELLIPSIS_THRESHOLD = 3;
        var props = {
            disabled: {
                type: Boolean,
                default: false
            },
            value: {
                type: Number,
                default: 1
            },
            limit: {
                type: Number,
                default: 5
            },
            size: {
                type: String,
                default: "md"
            },
            align: {
                type: String,
                default: "left"
            },
            hideGotoEndButtons: {
                type: Boolean,
                default: false
            },
            ariaLabel: {
                type: String,
                default: "Pagination"
            },
            labelFirstPage: {
                type: String,
                default: "Goto first page"
            },
            firstText: {
                type: String,
                default: "&laquo;"
            },
            labelPrevPage: {
                type: String,
                default: "Goto previous page"
            },
            prevText: {
                type: String,
                default: "&lsaquo;"
            },
            labelNextPage: {
                type: String,
                default: "Goto next page"
            },
            nextText: {
                type: String,
                default: "&rsaquo;"
            },
            labelLastPage: {
                type: String,
                default: "Goto last page"
            },
            lastText: {
                type: String,
                default: "&raquo;"
            },
            labelPage: {
                type: String,
                default: "Goto page"
            },
            hideEllipsis: {
                type: Boolean,
                default: false
            },
            ellipsisText: {
                type: String,
                default: "&hellip;"
            }
        };
        __webpack_exports__["a"] = {
            components: {
                bLink: __WEBPACK_IMPORTED_MODULE_3__components_link_link__["a"]
            },
            data: function data() {
                return {
                    showFirstDots: false,
                    showLastDots: false,
                    currentPage: this.value
                };
            },
            props: props,
            render: function render(h) {
                var _this = this;
                var buttons = [];
                var makeEndBtns = function makeEndBtns(linkTo, ariaLabel, btnText, pageTest) {
                    var button = void 0;
                    pageTest = pageTest || linkTo;
                    if (_this.disabled || _this.isActive(pageTest)) {
                        button = h("li", {
                            class: [ "page-item", "disabled" ],
                            attrs: {
                                role: "none presentation",
                                "aria-hidden": "true"
                            }
                        }, [ h("span", {
                            class: [ "page-link" ],
                            domProps: {
                                innerHTML: btnText
                            }
                        }) ]);
                    } else {
                        button = h("li", {
                            class: [ "page-item" ],
                            attrs: {
                                role: "none presentation"
                            }
                        }, [ h("b-link", {
                            class: [ "page-link" ],
                            props: _this.linkProps(linkTo),
                            attrs: {
                                role: "menuitem",
                                tabindex: "-1",
                                "aria-label": ariaLabel,
                                "aria-controls": _this.ariaControls || null
                            },
                            on: {
                                click: function click(evt) {
                                    _this.onClick(linkTo, evt);
                                },
                                keydown: function keydown(evt) {
                                    if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].SPACE) {
                                        evt.preventDefault();
                                        _this.onClick(linkTo, evt);
                                    }
                                }
                            }
                        }, [ h("span", {
                            attrs: {
                                "aria-hidden": "true"
                            },
                            domProps: {
                                innerHTML: btnText
                            }
                        }) ]) ]);
                    }
                    return button;
                };
                var makeEllipsis = function makeEllipsis() {
                    return h("li", {
                        class: [ "page-item", "disabled", "d-none", "d-sm-flex" ],
                        attrs: {
                            role: "separator"
                        }
                    }, [ h("span", {
                        class: [ "page-link" ],
                        domProps: {
                            innerHTML: _this.ellipsisText
                        }
                    }) ]);
                };
                buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(1, this.labelFirstPage, this.firstText));
                buttons.push(makeEndBtns(this.currentPage - 1, this.labelPrevPage, this.prevText, 1));
                buttons.push(this.showFirstDots ? makeEllipsis() : h(false));
                this.pageList.forEach(function(page) {
                    var inner = void 0;
                    var pageNum = _this.makePage(page.number);
                    if (_this.disabled) {
                        inner = h("span", {
                            class: [ "page-link" ],
                            domProps: {
                                innerHTML: pageNum
                            }
                        });
                    } else {
                        var active = _this.isActive(page.number);
                        inner = h("b-link", {
                            class: _this.pageLinkClasses(page),
                            props: _this.linkProps(page.number),
                            attrs: {
                                role: "menuitemradio",
                                tabindex: active ? "0" : "-1",
                                "aria-controls": _this.ariaControls || null,
                                "aria-label": _this.labelPage + " " + page.number,
                                "aria-checked": active ? "true" : "false",
                                "aria-posinset": page.number,
                                "aria-setsize": _this.numberOfPages
                            },
                            domProps: {
                                innerHTML: pageNum
                            },
                            on: {
                                click: function click(evt) {
                                    _this.onClick(page.number, evt);
                                },
                                keydown: function keydown(evt) {
                                    if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].SPACE) {
                                        evt.preventDefault();
                                        _this.onClick(page.number, evt);
                                    }
                                }
                            }
                        });
                    }
                    buttons.push(h("li", {
                        key: page.number,
                        class: _this.pageItemClasses(page),
                        attrs: {
                            role: "none presentation"
                        }
                    }, [ inner ]));
                });
                buttons.push(this.showLastDots ? makeEllipsis() : h(false));
                buttons.push(makeEndBtns(this.currentPage + 1, this.labelNextPage, this.nextText, this.numberOfPages));
                buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(this.numberOfPages, this.labelLastPage, this.lastText));
                var pagination = h("ul", {
                    ref: "ul",
                    class: [ "pagination", "b-pagination", this.btnSize, this.alignment ],
                    attrs: {
                        role: "menubar",
                        "aria-disabled": this.disabled ? "true" : "false",
                        "aria-label": this.ariaLabel || null
                    },
                    on: {
                        keydown: function keydown(evt) {
                            var keyCode = evt.keyCode;
                            var shift = evt.shiftKey;
                            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].LEFT) {
                                evt.preventDefault();
                                shift ? _this.focusFirst() : _this.focusPrev();
                            } else if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a"].RIGHT) {
                                evt.preventDefault();
                                shift ? _this.focusLast() : _this.focusNext();
                            }
                        }
                    }
                }, buttons);
                return this.isNav ? h("nav", {}, [ pagination ]) : pagination;
            },
            watch: {
                currentPage: function currentPage(newPage, oldPage) {
                    if (newPage !== oldPage) {
                        this.$emit("input", newPage);
                    }
                },
                value: function value(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        this.currentPage = newValue;
                    }
                }
            },
            computed: {
                btnSize: function btnSize() {
                    return this.size ? "pagination-" + this.size : "";
                },
                alignment: function alignment() {
                    if (this.align === "center") {
                        return "justify-content-center";
                    } else if (this.align === "end" || this.align === "right") {
                        return "justify-content-end";
                    }
                    return "";
                },
                pageList: function pageList() {
                    if (this.currentPage > this.numberOfPages) {
                        this.currentPage = this.numberOfPages;
                    } else if (this.currentPage < 1) {
                        this.currentPage = 1;
                    }
                    this.showFirstDots = false;
                    this.showLastDots = false;
                    var numLinks = this.limit;
                    var startNum = 1;
                    if (this.numberOfPages <= this.limit) {
                        numLinks = this.numberOfPages;
                    } else if (this.currentPage < this.limit - 1 && this.limit > ELLIPSIS_THRESHOLD) {
                        if (!this.hideEllipsis) {
                            numLinks = this.limit - 1;
                            this.showLastDots = true;
                        }
                    } else if (this.numberOfPages - this.currentPage + 2 < this.limit && this.limit > ELLIPSIS_THRESHOLD) {
                        if (!this.hideEllipsis) {
                            this.showFirstDots = true;
                            numLinks = this.limit - 1;
                        }
                        startNum = this.numberOfPages - numLinks + 1;
                    } else {
                        if (this.limit > ELLIPSIS_THRESHOLD && !this.hideEllipsis) {
                            this.showFirstDots = true;
                            this.showLastDots = true;
                            numLinks = this.limit - 2;
                        }
                        startNum = this.currentPage - Math.floor(numLinks / 2);
                    }
                    if (startNum < 1) {
                        startNum = 1;
                    } else if (startNum > this.numberOfPages - numLinks) {
                        startNum = this.numberOfPages - numLinks + 1;
                    }
                    var pages = makePageArray(startNum, numLinks);
                    if (pages.length > 3) {
                        var idx = this.currentPage - startNum;
                        if (idx === 0) {
                            for (var i = 3; i < pages.length; i++) {
                                pages[i].className = "d-none d-sm-flex";
                            }
                        } else if (idx === pages.length - 1) {
                            for (var _i = 0; _i < pages.length - 3; _i++) {
                                pages[_i].className = "d-none d-sm-flex";
                            }
                        } else {
                            for (var _i2 = 0; _i2 < idx - 1; _i2++) {
                                pages[_i2].className = "d-none d-sm-flex";
                            }
                            for (var _i3 = pages.length - 1; _i3 > idx + 1; _i3--) {
                                pages[_i3].className = "d-none d-sm-flex";
                            }
                        }
                    }
                    return pages;
                }
            },
            methods: {
                isActive: function isActive(pagenum) {
                    return pagenum === this.currentPage;
                },
                pageItemClasses: function pageItemClasses(page) {
                    return [ "page-item", this.disabled ? "disabled" : "", this.isActive(page.number) ? "active" : "", page.className ];
                },
                pageLinkClasses: function pageLinkClasses(page) {
                    return [ "page-link", this.disabled ? "disabled" : "", this.isActive(page.number) ? "btn-primary" : "" ];
                },
                getButtons: function getButtons() {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q"])("a.page-link", this.$el).filter(function(btn) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["b"])(btn);
                    });
                },
                setBtnFocus: function setBtnFocus(btn) {
                    this.$nextTick(function() {
                        btn.focus();
                    });
                },
                focusCurrent: function focusCurrent() {
                    var _this2 = this;
                    var btn = this.getButtons().find(function(el) {
                        return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j"])(el, "aria-posinset"), 10) === _this2.currentPage;
                    });
                    if (btn && btn.focus) {
                        this.setBtnFocus(btn);
                    } else {
                        this.focusFirst();
                    }
                },
                focusFirst: function focusFirst() {
                    var btn = this.getButtons().find(function(el) {
                        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l"])(el);
                    });
                    if (btn && btn.focus && btn !== document.activeElement) {
                        this.setBtnFocus(btn);
                    }
                },
                focusLast: function focusLast() {
                    var btn = this.getButtons().reverse().find(function(el) {
                        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l"])(el);
                    });
                    if (btn && btn.focus && btn !== document.activeElement) {
                        this.setBtnFocus(btn);
                    }
                },
                focusPrev: function focusPrev() {
                    var buttons = this.getButtons();
                    var idx = buttons.indexOf(document.activeElement);
                    if (idx > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l"])(buttons[idx - 1]) && buttons[idx - 1].focus) {
                        this.setBtnFocus(buttons[idx - 1]);
                    }
                },
                focusNext: function focusNext() {
                    var buttons = this.getButtons();
                    var idx = buttons.indexOf(document.activeElement);
                    var cnt = buttons.length - 1;
                    if (idx < cnt && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l"])(buttons[idx + 1]) && buttons[idx + 1].focus) {
                        this.setBtnFocus(buttons[idx + 1]);
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(5);
        var __WEBPACK_IMPORTED_MODULE_3__utils_ssr__ = __webpack_require__(180);
        var __WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__ = __webpack_require__(16);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var PLACEMENTS = {
            top: "top",
            topleft: "topleft",
            topright: "topright",
            right: "right",
            righttop: "righttop",
            rightbottom: "rightbottom",
            bottom: "bottom",
            bottomleft: "bottomleft",
            bottomright: "bottomright",
            left: "left",
            lefttop: "lefttop",
            leftbottom: "leftbottom",
            auto: "auto"
        };
        var OBSERVER_CONFIG = {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: [ "class", "style" ]
        };
        __webpack_exports__["a"] = {
            props: {
                target: {
                    type: [ String, Object, __WEBPACK_IMPORTED_MODULE_3__utils_ssr__["a"], Function ]
                },
                delay: {
                    type: [ Number, Object, String ],
                    default: 0
                },
                offset: {
                    type: [ Number, String ],
                    default: 0
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                container: {
                    type: String,
                    default: null
                },
                boundary: {
                    type: [ String, Object ],
                    default: "scrollParent"
                },
                show: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                }
            },
            watch: {
                show: function show(_show, old) {
                    if (_show === old) {
                        return;
                    }
                    _show ? this.onOpen() : this.onClose();
                },
                disabled: function disabled(_disabled, old) {
                    if (_disabled === old) {
                        return;
                    }
                    _disabled ? this.onDisable() : this.onEnable();
                }
            },
            created: function created() {
                this._toolpop = null;
                this._obs_title = null;
                this._obs_content = null;
            },
            mounted: function mounted() {
                var _this = this;
                this.$nextTick(function() {
                    if (_this.createToolpop()) {
                        if (_this.disabled) {
                            _this.onDisable();
                        }
                        _this.$on("open", _this.onOpen);
                        _this.$on("close", _this.onClose);
                        _this.$on("disable", _this.onDisable);
                        _this.$on("enable", _this.onEnable);
                        _this.setObservers(true);
                        if (_this.show) {
                            _this.onOpen();
                        }
                    }
                });
            },
            updated: function updated() {
                if (this._toolpop) {
                    this._toolpop.updateConfig(this.getConfig());
                }
            },
            activated: function activated() {
                this.setObservers(true);
            },
            deactivated: function deactivated() {
                if (this._toolpop) {
                    this.setObservers(false);
                    this._toolpop.hide();
                }
            },
            beforeDestroy: function beforeDestroy() {
                this.$off("open", this.onOpen);
                this.$off("close", this.onClose);
                this.$off("disable", this.onDisable);
                this.$off("enable", this.onEnable);
                this.setObservers(false);
                this.bringItBack();
                if (this._toolpop) {
                    this._toolpop.destroy();
                    this._toolpop = null;
                }
            },
            computed: {
                baseConfig: function baseConfig() {
                    var cont = this.container;
                    var delay = _typeof(this.delay) === "object" ? this.delay : parseInt(this.delay, 10) || 0;
                    return {
                        title: (this.title || "").trim() || "",
                        content: (this.content || "").trim() || "",
                        placement: PLACEMENTS[this.placement] || "auto",
                        container: cont ? /^#/.test(cont) ? cont : "#" + cont : false,
                        boundary: this.boundary,
                        delay: delay || 0,
                        offset: this.offset || 0,
                        animation: !this.noFade,
                        trigger: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["b"])(this.triggers) ? this.triggers.join(" ") : this.triggers,
                        callbacks: {
                            show: this.onShow,
                            shown: this.onShown,
                            hide: this.onHide,
                            hidden: this.onHidden,
                            enabled: this.onEnabled,
                            disabled: this.onDisabled
                        }
                    };
                }
            },
            methods: {
                getConfig: function getConfig() {
                    var cfg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a"])({}, this.baseConfig);
                    if (this.$refs.title && this.$refs.title.innerHTML.trim()) {
                        cfg.title = this.$refs.title;
                        cfg.html = true;
                    }
                    if (this.$refs.content && this.$refs.content.innerHTML.trim()) {
                        cfg.content = this.$refs.content;
                        cfg.html = true;
                    }
                    return cfg;
                },
                onOpen: function onOpen() {
                    if (this._toolpop) {
                        this._toolpop.show();
                    }
                },
                onClose: function onClose(callback) {
                    if (this._toolpop) {
                        this._toolpop.hide(callback);
                    } else if (typeof callback === "function") {
                        callback();
                    }
                },
                onDisable: function onDisable() {
                    if (this._toolpop) {
                        this._toolpop.disable();
                    }
                },
                onEnable: function onEnable() {
                    if (this._toolpop) {
                        this._toolpop.enable();
                    }
                },
                updatePosition: function updatePosition() {
                    if (this._toolpop) {
                        this._toolpop.update();
                    }
                },
                getTarget: function getTarget() {
                    var target = this.target;
                    if (typeof target === "function") {
                        target = target();
                    }
                    if (typeof target === "string") {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["t"])(target);
                    } else if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["n"])(target.$el)) {
                        return target.$el;
                    } else if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["n"])(target)) {
                        return target;
                    }
                    return null;
                },
                onShow: function onShow(evt) {
                    this.$emit("show", evt);
                },
                onShown: function onShown(evt) {
                    this.setObservers(true);
                    this.$emit("update:show", true);
                    this.$emit("shown", evt);
                },
                onHide: function onHide(evt) {
                    this.$emit("hide", evt);
                },
                onHidden: function onHidden(evt) {
                    this.setObservers(false);
                    this.bringItBack();
                    this.$emit("update:show", false);
                    this.$emit("hidden", evt);
                },
                onEnabled: function onEnabled(evt) {
                    if (!evt || evt.type !== "enabled") {
                        return;
                    }
                    this.$emit("update:disabled", false);
                    this.$emit("disabled");
                },
                onDisabled: function onDisabled(evt) {
                    if (!evt || evt.type !== "disabled") {
                        return;
                    }
                    this.$emit("update:disabled", true);
                    this.$emit("enabled");
                },
                bringItBack: function bringItBack() {
                    if (this.$el && this.$refs.title) {
                        this.$el.appendChild(this.$refs.title);
                    }
                    if (this.$el && this.$refs.content) {
                        this.$el.appendChild(this.$refs.content);
                    }
                },
                setObservers: function setObservers(on) {
                    if (on) {
                        if (this.$refs.title) {
                            this._obs_title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a"])(this.$refs.title, this.updatePosition.bind(this), OBSERVER_CONFIG);
                        }
                        if (this.$refs.content) {
                            this._obs_content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a"])(this.$refs.content, this.updatePosition.bind(this), OBSERVER_CONFIG);
                        }
                    } else {
                        if (this._obs_title) {
                            this._obs_title.disconnect();
                            this._obs_title = null;
                        }
                        if (this._obs_content) {
                            this._obs_content.disconnect();
                            this._obs_content = null;
                        }
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        var BvEvent = function() {
            function BvEvent(type) {
                var eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, BvEvent);
                if (!type) {
                    throw new TypeError("Failed to construct '" + this.constructor.name + "'. 1 argument required, " + arguments.length + " given.");
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])(this, BvEvent.defaults(), eventInit, {
                    type: type
                });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["c"])(this, {
                    type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])(),
                    cancelable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])(),
                    nativeEvent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])(),
                    target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])(),
                    relatedTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])(),
                    vueTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d"])()
                });
                var defaultPrevented = false;
                this.preventDefault = function preventDefault() {
                    if (this.cancelable) {
                        defaultPrevented = true;
                    }
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e"])(this, "defaultPrevented", {
                    enumerable: true,
                    get: function get() {
                        return defaultPrevented;
                    }
                });
            }
            _createClass(BvEvent, null, [ {
                key: "defaults",
                value: function defaults() {
                    return {
                        type: "",
                        cancelable: true,
                        nativeEvent: null,
                        target: null,
                        relatedTarget: null,
                        vueTarget: null
                    };
                }
            } ]);
            return BvEvent;
        }();
        __webpack_exports__["a"] = BvEvent;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = identity;
        function identity(x) {
            return x;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__tooltip_class__ = __webpack_require__(51);
        var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__(5);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var NAME = "popover";
        var CLASS_PREFIX = "bs-popover";
        var BSCLS_PREFIX_REGEX = new RegExp("\\b" + CLASS_PREFIX + "\\S+", "g");
        var Defaults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["a"])({}, __WEBPACK_IMPORTED_MODULE_0__tooltip_class__["a"].Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
        });
        var ClassName = {
            FADE: "fade",
            SHOW: "show"
        };
        var Selector = {
            TITLE: ".popover-header",
            CONTENT: ".popover-body"
        };
        var PopOver = function(_ToolTip) {
            _inherits(PopOver, _ToolTip);
            function PopOver() {
                _classCallCheck(this, PopOver);
                return _possibleConstructorReturn(this, (PopOver.__proto__ || Object.getPrototypeOf(PopOver)).apply(this, arguments));
            }
            _createClass(PopOver, [ {
                key: "isWithContent",
                value: function isWithContent(tip) {
                    tip = tip || this.$tip;
                    if (!tip) {
                        return false;
                    }
                    var hasTitle = Boolean((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["i"])(Selector.TITLE, tip) || {}).innerHTML);
                    var hasContent = Boolean((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["i"])(Selector.CONTENT, tip) || {}).innerHTML);
                    return hasTitle || hasContent;
                }
            }, {
                key: "addAttachmentClass",
                value: function addAttachmentClass(attachment) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["d"])(this.getTipElement(), CLASS_PREFIX + "-" + attachment);
                }
            }, {
                key: "setContent",
                value: function setContent(tip) {
                    this.setElementContent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["i"])(Selector.TITLE, tip), this.getTitle());
                    this.setElementContent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["i"])(Selector.CONTENT, tip), this.getContent());
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["e"])(tip, ClassName.FADE);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["e"])(tip, ClassName.SHOW);
                }
            }, {
                key: "cleanTipClass",
                value: function cleanTipClass() {
                    var tip = this.getTipElement();
                    var tabClass = tip.className.match(BSCLS_PREFIX_REGEX);
                    if (tabClass !== null && tabClass.length > 0) {
                        tabClass.forEach(function(cls) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["e"])(tip, cls);
                        });
                    }
                }
            }, {
                key: "getTitle",
                value: function getTitle() {
                    var title = this.$config.title || "";
                    if (typeof title === "function") {
                        title = title(this.$element);
                    }
                    if ((typeof title === "undefined" ? "undefined" : _typeof(title)) === "object" && title.nodeType && !title.innerHTML.trim()) {
                        title = "";
                    }
                    if (typeof title === "string") {
                        title = title.trim();
                    }
                    if (!title) {
                        title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["j"])(this.$element, "title") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom__["j"])(this.$element, "data-original-title") || "";
                        title = title.trim();
                    }
                    return title;
                }
            }, {
                key: "getContent",
                value: function getContent() {
                    var content = this.$config.content || "";
                    if (typeof content === "function") {
                        content = content(this.$element);
                    }
                    if ((typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" && content.nodeType && !content.innerHTML.trim()) {
                        content = "";
                    }
                    if (typeof content === "string") {
                        content = content.trim();
                    }
                    return content;
                }
            } ], [ {
                key: "Default",
                get: function get() {
                    return Defaults;
                }
            }, {
                key: "NAME",
                get: function get() {
                    return NAME;
                }
            } ]);
            return PopOver;
        }(__WEBPACK_IMPORTED_MODULE_0__tooltip_class__["a"]);
        __webpack_exports__["a"] = PopOver;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return bindTargets;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return unbindTargets;
        });
        var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
        var allListenTypes = {
            hover: true,
            click: true,
            focus: true
        };
        var BVBoundListeners = "__BV_boundEventListeners__";
        var bindTargets = function bindTargets(vnode, binding, listenTypes, fn) {
            var targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(binding.modifiers || {}).filter(function(t) {
                return !allListenTypes[t];
            });
            if (binding.value) {
                targets.push(binding.value);
            }
            var listener = function listener() {
                fn({
                    targets: targets,
                    vnode: vnode
                });
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(allListenTypes).forEach(function(type) {
                if (listenTypes[type] || binding.modifiers[type]) {
                    vnode.elm.addEventListener(type, listener);
                    var boundListeners = vnode.elm[BVBoundListeners] || {};
                    boundListeners[type] = boundListeners[type] || [];
                    boundListeners[type].push(listener);
                    vnode.elm[BVBoundListeners] = boundListeners;
                }
            });
            return targets;
        };
        var unbindTargets = function unbindTargets(vnode, binding, listenTypes) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["b"])(allListenTypes).forEach(function(type) {
                if (listenTypes[type] || binding.modifiers[type]) {
                    var boundListeners = vnode.elm[BVBoundListeners] && vnode.elm[BVBoundListeners][type];
                    if (boundListeners) {
                        boundListeners.forEach(function(listener) {
                            return vnode.elm.removeEventListener(type, listener);
                        });
                        delete vnode.elm[BVBoundListeners][type];
                    }
                }
            });
        };
        __webpack_exports__["c"] = bindTargets;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = upperFirst;
        function upperFirst(str) {
            if (typeof str !== "string") {
                str = String(str);
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    }, function(module, exports) {
        module.exports = function(it) {
            if (it == undefined) throw TypeError("Can't call method on  " + it);
            return it;
        };
    }, function(module, exports) {
        var ceil = Math.ceil;
        var floor = Math.floor;
        module.exports = function(it) {
            return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
    }, function(module, exports, __webpack_require__) {
        var IObject = __webpack_require__(196);
        var defined = __webpack_require__(160);
        module.exports = function(it) {
            return IObject(defined(it));
        };
    }, function(module, exports, __webpack_require__) {
        (function(global) {
            var FUNC_ERROR_TEXT = "Expected a function";
            var HASH_UNDEFINED = "__lodash_hash_undefined__";
            var INFINITY = 1 / 0;
            var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
            var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
            var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
            var reEscapeChar = /\\(\\)?/g;
            var reIsHostCtor = /^\[object .+?Constructor\]$/;
            var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
            var freeSelf = typeof self == "object" && self && self.Object === Object && self;
            var root = freeGlobal || freeSelf || Function("return this")();
            function getValue(object, key) {
                return object == null ? undefined : object[key];
            }
            function isHostObject(value) {
                var result = false;
                if (value != null && typeof value.toString != "function") {
                    try {
                        result = !!(value + "");
                    } catch (e) {}
                }
                return result;
            }
            var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
            var coreJsData = root["__core-js_shared__"];
            var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
                return uid ? "Symbol(src)_1." + uid : "";
            }();
            var funcToString = funcProto.toString;
            var hasOwnProperty = objectProto.hasOwnProperty;
            var objectToString = objectProto.toString;
            var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            var Symbol = root.Symbol, splice = arrayProto.splice;
            var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function Hash(entries) {
                var index = -1, length = entries ? entries.length : 0;
                this.clear();
                while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
            }
            function hashDelete(key) {
                return this.has(key) && delete this.__data__[key];
            }
            function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            function hashSet(key, value) {
                var data = this.__data__;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            Hash.prototype.clear = hashClear;
            Hash.prototype["delete"] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            function ListCache(entries) {
                var index = -1, length = entries ? entries.length : 0;
                this.clear();
                while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function listCacheClear() {
                this.__data__ = [];
            }
            function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    return false;
                }
                var lastIndex = data.length - 1;
                if (index == lastIndex) {
                    data.pop();
                } else {
                    splice.call(data, index, 1);
                }
                return true;
            }
            function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    data.push([ key, value ]);
                } else {
                    data[index][1] = value;
                }
                return this;
            }
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype["delete"] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            function MapCache(entries) {
                var index = -1, length = entries ? entries.length : 0;
                this.clear();
                while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function mapCacheClear() {
                this.__data__ = {
                    hash: new Hash(),
                    map: new (Map || ListCache)(),
                    string: new Hash()
                };
            }
            function mapCacheDelete(key) {
                return getMapData(this, key)["delete"](key);
            }
            function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            function mapCacheSet(key, value) {
                getMapData(this, key).set(key, value);
                return this;
            }
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype["delete"] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            function assocIndexOf(array, key) {
                var length = array.length;
                while (length--) {
                    if (eq(array[length][0], key)) {
                        return length;
                    }
                }
                return -1;
            }
            function baseGet(object, path) {
                path = isKey(path, object) ? [ path ] : castPath(path);
                var index = 0, length = path.length;
                while (object != null && index < length) {
                    object = object[toKey(path[index++])];
                }
                return index && index == length ? object : undefined;
            }
            function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) {
                    return false;
                }
                var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            function baseToString(value) {
                if (typeof value == "string") {
                    return value;
                }
                if (isSymbol(value)) {
                    return symbolToString ? symbolToString.call(value) : "";
                }
                var result = value + "";
                return result == "0" && 1 / value == -INFINITY ? "-0" : result;
            }
            function castPath(value) {
                return isArray(value) ? value : stringToPath(value);
            }
            function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
            }
            function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            function isKey(value, object) {
                if (isArray(value)) {
                    return false;
                }
                var type = typeof value;
                if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
                    return true;
                }
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
            }
            function isKeyable(value) {
                var type = typeof value;
                return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
            }
            function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            var stringToPath = memoize(function(string) {
                string = toString(string);
                var result = [];
                if (reLeadingDot.test(string)) {
                    result.push("");
                }
                string.replace(rePropName, function(match, number, quote, string) {
                    result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
                });
                return result;
            });
            function toKey(value) {
                if (typeof value == "string" || isSymbol(value)) {
                    return value;
                }
                var result = value + "";
                return result == "0" && 1 / value == -INFINITY ? "-0" : result;
            }
            function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + "";
                    } catch (e) {}
                }
                return "";
            }
            function memoize(func, resolver) {
                if (typeof func != "function" || resolver && typeof resolver != "function") {
                    throw new TypeError(FUNC_ERROR_TEXT);
                }
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) {
                        return cache.get(key);
                    }
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result);
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache)();
                return memoized;
            }
            memoize.Cache = MapCache;
            function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            var isArray = Array.isArray;
            function isFunction(value) {
                var tag = isObject(value) ? objectToString.call(value) : "";
                return tag == funcTag || tag == genTag;
            }
            function isObject(value) {
                var type = typeof value;
                return !!value && (type == "object" || type == "function");
            }
            function isObjectLike(value) {
                return !!value && typeof value == "object";
            }
            function isSymbol(value) {
                return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
            }
            function toString(value) {
                return value == null ? "" : baseToString(value);
            }
            function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            module.exports = get;
        }).call(exports, __webpack_require__(13));
    }, function(module, exports, __webpack_require__) {
        (function(global) {
            var INFINITY = 1 / 0;
            var symbolTag = "[object Symbol]";
            var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
            var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
            var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", rsComboSymbolsRange = "\\u20d0-\\u20f0", rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
            var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboMarksRange + rsComboSymbolsRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
            var rsLowerMisc = "(?:" + rsLower + "|" + rsMisc + ")", rsUpperMisc = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptLowerContr = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptUpperContr = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [ rsNonAstral, rsRegional, rsSurrPair ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [ rsDingbat, rsRegional, rsSurrPair ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [ rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral ].join("|") + ")";
            var reApos = RegExp(rsApos, "g");
            var reComboMark = RegExp(rsCombo, "g");
            var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
            var reUnicodeWord = RegExp([ rsUpper + "?" + rsLower + "+" + rsOptLowerContr + "(?=" + [ rsBreak, rsUpper, "$" ].join("|") + ")", rsUpperMisc + "+" + rsOptUpperContr + "(?=" + [ rsBreak, rsUpper + rsLowerMisc, "$" ].join("|") + ")", rsUpper + "?" + rsLowerMisc + "+" + rsOptLowerContr, rsUpper + "+" + rsOptUpperContr, rsDigits, rsEmoji ].join("|"), "g");
            var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + "]");
            var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
            var deburredLetters = {
                "À": "A",
                "Á": "A",
                "Â": "A",
                "Ã": "A",
                "Ä": "A",
                "Å": "A",
                "à": "a",
                "á": "a",
                "â": "a",
                "ã": "a",
                "ä": "a",
                "å": "a",
                "Ç": "C",
                "ç": "c",
                "Ð": "D",
                "ð": "d",
                "È": "E",
                "É": "E",
                "Ê": "E",
                "Ë": "E",
                "è": "e",
                "é": "e",
                "ê": "e",
                "ë": "e",
                "Ì": "I",
                "Í": "I",
                "Î": "I",
                "Ï": "I",
                "ì": "i",
                "í": "i",
                "î": "i",
                "ï": "i",
                "Ñ": "N",
                "ñ": "n",
                "Ò": "O",
                "Ó": "O",
                "Ô": "O",
                "Õ": "O",
                "Ö": "O",
                "Ø": "O",
                "ò": "o",
                "ó": "o",
                "ô": "o",
                "õ": "o",
                "ö": "o",
                "ø": "o",
                "Ù": "U",
                "Ú": "U",
                "Û": "U",
                "Ü": "U",
                "ù": "u",
                "ú": "u",
                "û": "u",
                "ü": "u",
                "Ý": "Y",
                "ý": "y",
                "ÿ": "y",
                "Æ": "Ae",
                "æ": "ae",
                "Þ": "Th",
                "þ": "th",
                "ß": "ss",
                "Ā": "A",
                "Ă": "A",
                "Ą": "A",
                "ā": "a",
                "ă": "a",
                "ą": "a",
                "Ć": "C",
                "Ĉ": "C",
                "Ċ": "C",
                "Č": "C",
                "ć": "c",
                "ĉ": "c",
                "ċ": "c",
                "č": "c",
                "Ď": "D",
                "Đ": "D",
                "ď": "d",
                "đ": "d",
                "Ē": "E",
                "Ĕ": "E",
                "Ė": "E",
                "Ę": "E",
                "Ě": "E",
                "ē": "e",
                "ĕ": "e",
                "ė": "e",
                "ę": "e",
                "ě": "e",
                "Ĝ": "G",
                "Ğ": "G",
                "Ġ": "G",
                "Ģ": "G",
                "ĝ": "g",
                "ğ": "g",
                "ġ": "g",
                "ģ": "g",
                "Ĥ": "H",
                "Ħ": "H",
                "ĥ": "h",
                "ħ": "h",
                "Ĩ": "I",
                "Ī": "I",
                "Ĭ": "I",
                "Į": "I",
                "İ": "I",
                "ĩ": "i",
                "ī": "i",
                "ĭ": "i",
                "į": "i",
                "ı": "i",
                "Ĵ": "J",
                "ĵ": "j",
                "Ķ": "K",
                "ķ": "k",
                "ĸ": "k",
                "Ĺ": "L",
                "Ļ": "L",
                "Ľ": "L",
                "Ŀ": "L",
                "Ł": "L",
                "ĺ": "l",
                "ļ": "l",
                "ľ": "l",
                "ŀ": "l",
                "ł": "l",
                "Ń": "N",
                "Ņ": "N",
                "Ň": "N",
                "Ŋ": "N",
                "ń": "n",
                "ņ": "n",
                "ň": "n",
                "ŋ": "n",
                "Ō": "O",
                "Ŏ": "O",
                "Ő": "O",
                "ō": "o",
                "ŏ": "o",
                "ő": "o",
                "Ŕ": "R",
                "Ŗ": "R",
                "Ř": "R",
                "ŕ": "r",
                "ŗ": "r",
                "ř": "r",
                "Ś": "S",
                "Ŝ": "S",
                "Ş": "S",
                "Š": "S",
                "ś": "s",
                "ŝ": "s",
                "ş": "s",
                "š": "s",
                "Ţ": "T",
                "Ť": "T",
                "Ŧ": "T",
                "ţ": "t",
                "ť": "t",
                "ŧ": "t",
                "Ũ": "U",
                "Ū": "U",
                "Ŭ": "U",
                "Ů": "U",
                "Ű": "U",
                "Ų": "U",
                "ũ": "u",
                "ū": "u",
                "ŭ": "u",
                "ů": "u",
                "ű": "u",
                "ų": "u",
                "Ŵ": "W",
                "ŵ": "w",
                "Ŷ": "Y",
                "ŷ": "y",
                "Ÿ": "Y",
                "Ź": "Z",
                "Ż": "Z",
                "Ž": "Z",
                "ź": "z",
                "ż": "z",
                "ž": "z",
                "Ĳ": "IJ",
                "ĳ": "ij",
                "Œ": "Oe",
                "œ": "oe",
                "ŉ": "'n",
                "ſ": "ss"
            };
            var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
            var freeSelf = typeof self == "object" && self && self.Object === Object && self;
            var root = freeGlobal || freeSelf || Function("return this")();
            function arrayReduce(array, iteratee, accumulator, initAccum) {
                var index = -1, length = array ? array.length : 0;
                if (initAccum && length) {
                    accumulator = array[++index];
                }
                while (++index < length) {
                    accumulator = iteratee(accumulator, array[index], index, array);
                }
                return accumulator;
            }
            function asciiToArray(string) {
                return string.split("");
            }
            function asciiWords(string) {
                return string.match(reAsciiWord) || [];
            }
            function basePropertyOf(object) {
                return function(key) {
                    return object == null ? undefined : object[key];
                };
            }
            var deburrLetter = basePropertyOf(deburredLetters);
            function hasUnicode(string) {
                return reHasUnicode.test(string);
            }
            function hasUnicodeWord(string) {
                return reHasUnicodeWord.test(string);
            }
            function stringToArray(string) {
                return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
            }
            function unicodeToArray(string) {
                return string.match(reUnicode) || [];
            }
            function unicodeWords(string) {
                return string.match(reUnicodeWord) || [];
            }
            var objectProto = Object.prototype;
            var objectToString = objectProto.toString;
            var Symbol = root.Symbol;
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) {
                    start = -start > length ? 0 : length + start;
                }
                end = end > length ? length : end;
                if (end < 0) {
                    end += length;
                }
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array(length);
                while (++index < length) {
                    result[index] = array[index + start];
                }
                return result;
            }
            function baseToString(value) {
                if (typeof value == "string") {
                    return value;
                }
                if (isSymbol(value)) {
                    return symbolToString ? symbolToString.call(value) : "";
                }
                var result = value + "";
                return result == "0" && 1 / value == -INFINITY ? "-0" : result;
            }
            function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
                };
            }
            function isObjectLike(value) {
                return !!value && typeof value == "object";
            }
            function isSymbol(value) {
                return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
            }
            function toString(value) {
                return value == null ? "" : baseToString(value);
            }
            function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
            }
            var startCase = createCompounder(function(result, word, index) {
                return result + (index ? " " : "") + upperFirst(word);
            });
            var upperFirst = createCaseFirst("toUpperCase");
            function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) {
                    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                }
                return string.match(pattern) || [];
            }
            module.exports = startCase;
        }).call(exports, __webpack_require__(13));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__ = __webpack_require__(58);
        var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d3891e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__ = __webpack_require__(224);
        function injectStyle(ssrContext) {
            __webpack_require__(214);
        }
        var normalizeComponent = __webpack_require__(28);
        var __vue_template_functional__ = false;
        var __vue_styles__ = injectStyle;
        var __vue_scopeId__ = "data-v-92d3891e";
        var __vue_module_identifier__ = null;
        var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__["a"], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d3891e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__["a"], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);
        __webpack_exports__["a"] = Component.exports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
        var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
        var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(227);
        var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(220);
        var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__(168);
        var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components__ = __webpack_require__(170);
        var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_directives__ = __webpack_require__(171);
        var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(167);
        __webpack_require__.d(__webpack_exports__, "BootstrapVue", function() {
            return __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "pylon_vue_components", function() {
            return __WEBPACK_IMPORTED_MODULE_6__components__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bootstrap_vue_components", function() {
            return __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components__;
        });
        __webpack_require__.d(__webpack_exports__, "bootstrap_vue_directives", function() {
            return __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_directives__;
        });
        var __WEBPACK_IMPORTED_MODULE_7__components_Custom_Custom_vue__ = __webpack_require__(165);
        var __WEBPACK_IMPORTED_MODULE_8__components_LiteGrid_LiteGrid_vue__ = __webpack_require__(222);
        var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_es_components_alert__ = __webpack_require__(63);
        var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_badge__ = __webpack_require__(65);
        var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_es_components_breadcrumb__ = __webpack_require__(67);
        var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_es_components_button__ = __webpack_require__(72);
        var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_es_components_button_group__ = __webpack_require__(69);
        var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_es_components_button_toolbar__ = __webpack_require__(71);
        var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_es_components_input_group__ = __webpack_require__(104);
        var __WEBPACK_IMPORTED_MODULE_16_bootstrap_vue_es_components_card__ = __webpack_require__(75);
        var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue_es_components_carousel__ = __webpack_require__(78);
        var __WEBPACK_IMPORTED_MODULE_18_bootstrap_vue_es_components_layout__ = __webpack_require__(109);
        var __WEBPACK_IMPORTED_MODULE_19_bootstrap_vue_es_components_collapse__ = __webpack_require__(35);
        var __WEBPACK_IMPORTED_MODULE_20_bootstrap_vue_es_components_dropdown__ = __webpack_require__(20);
        var __WEBPACK_IMPORTED_MODULE_21_bootstrap_vue_es_components_embed__ = __webpack_require__(86);
        var __WEBPACK_IMPORTED_MODULE_22_bootstrap_vue_es_components_form__ = __webpack_require__(101);
        var __WEBPACK_IMPORTED_MODULE_23_bootstrap_vue_es_components_form_group__ = __webpack_require__(92);
        var __WEBPACK_IMPORTED_MODULE_24_bootstrap_vue_es_components_form_checkbox__ = __webpack_require__(88);
        var __WEBPACK_IMPORTED_MODULE_25_bootstrap_vue_es_components_form_radio__ = __webpack_require__(96);
        var __WEBPACK_IMPORTED_MODULE_26_bootstrap_vue_es_components_form_input__ = __webpack_require__(94);
        var __WEBPACK_IMPORTED_MODULE_27_bootstrap_vue_es_components_form_textarea__ = __webpack_require__(100);
        var __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue_es_components_form_file__ = __webpack_require__(90);
        var __WEBPACK_IMPORTED_MODULE_29_bootstrap_vue_es_components_form_select__ = __webpack_require__(98);
        var __WEBPACK_IMPORTED_MODULE_30_bootstrap_vue_es_components_image__ = __webpack_require__(103);
        var __WEBPACK_IMPORTED_MODULE_31_bootstrap_vue_es_components_jumbotron__ = __webpack_require__(106);
        var __WEBPACK_IMPORTED_MODULE_32_bootstrap_vue_es_components_link__ = __webpack_require__(111);
        var __WEBPACK_IMPORTED_MODULE_33_bootstrap_vue_es_components_list_group__ = __webpack_require__(112);
        var __WEBPACK_IMPORTED_MODULE_34_bootstrap_vue_es_components_media__ = __webpack_require__(115);
        var __WEBPACK_IMPORTED_MODULE_35_bootstrap_vue_es_components_modal__ = __webpack_require__(117);
        var __WEBPACK_IMPORTED_MODULE_36_bootstrap_vue_es_components_nav__ = __webpack_require__(47);
        var __WEBPACK_IMPORTED_MODULE_37_bootstrap_vue_es_components_navbar__ = __webpack_require__(124);
        var __WEBPACK_IMPORTED_MODULE_38_bootstrap_vue_es_components_pagination__ = __webpack_require__(131);
        var __WEBPACK_IMPORTED_MODULE_39_bootstrap_vue_es_components_pagination_nav__ = __webpack_require__(129);
        var __WEBPACK_IMPORTED_MODULE_40_bootstrap_vue_es_components_popover__ = __webpack_require__(133);
        var __WEBPACK_IMPORTED_MODULE_41_bootstrap_vue_es_components_progress__ = __webpack_require__(135);
        var __WEBPACK_IMPORTED_MODULE_42_bootstrap_vue_es_components_table__ = __webpack_require__(137);
        var __WEBPACK_IMPORTED_MODULE_43_bootstrap_vue_es_components_tabs__ = __webpack_require__(139);
        var __WEBPACK_IMPORTED_MODULE_44_bootstrap_vue_es_components_tooltip__ = __webpack_require__(142);
        var __WEBPACK_IMPORTED_MODULE_45_bootstrap_vue_es_components_alert_alert__ = __webpack_require__(62);
        var __WEBPACK_IMPORTED_MODULE_46_bootstrap_vue_es_components_badge_badge__ = __webpack_require__(64);
        var __WEBPACK_IMPORTED_MODULE_47_bootstrap_vue_es_components_breadcrumb_breadcrumb__ = __webpack_require__(66);
        var __WEBPACK_IMPORTED_MODULE_48_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__ = __webpack_require__(29);
        var __WEBPACK_IMPORTED_MODULE_49_bootstrap_vue_es_components_breadcrumb_breadcrumb_link__ = __webpack_require__(30);
        var __WEBPACK_IMPORTED_MODULE_50_bootstrap_vue_es_components_button_button__ = __webpack_require__(19);
        var __WEBPACK_IMPORTED_MODULE_51_bootstrap_vue_es_components_button_button_close__ = __webpack_require__(18);
        var __WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_es_components_button_group_button_group__ = __webpack_require__(68);
        var __WEBPACK_IMPORTED_MODULE_53_bootstrap_vue_es_components_button_toolbar_button_toolbar__ = __webpack_require__(70);
        var __WEBPACK_IMPORTED_MODULE_54_bootstrap_vue_es_components_card_card__ = __webpack_require__(74);
        var __WEBPACK_IMPORTED_MODULE_55_bootstrap_vue_es_components_card_card_header__ = __webpack_require__(33);
        var __WEBPACK_IMPORTED_MODULE_56_bootstrap_vue_es_components_card_card_body__ = __webpack_require__(31);
        var __WEBPACK_IMPORTED_MODULE_57_bootstrap_vue_es_components_card_card_footer__ = __webpack_require__(32);
        var __WEBPACK_IMPORTED_MODULE_58_bootstrap_vue_es_components_card_card_img__ = __webpack_require__(34);
        var __WEBPACK_IMPORTED_MODULE_59_bootstrap_vue_es_components_card_card_group__ = __webpack_require__(73);
        var __WEBPACK_IMPORTED_MODULE_60_bootstrap_vue_es_components_carousel_carousel__ = __webpack_require__(77);
        var __WEBPACK_IMPORTED_MODULE_61_bootstrap_vue_es_components_carousel_carousel_slide__ = __webpack_require__(76);
        var __WEBPACK_IMPORTED_MODULE_62_bootstrap_vue_es_components_collapse_collapse__ = __webpack_require__(79);
        var __WEBPACK_IMPORTED_MODULE_63_bootstrap_vue_es_components_dropdown_dropdown__ = __webpack_require__(84);
        var __WEBPACK_IMPORTED_MODULE_64_bootstrap_vue_es_components_dropdown_dropdown_item__ = __webpack_require__(83);
        var __WEBPACK_IMPORTED_MODULE_65_bootstrap_vue_es_components_dropdown_dropdown_item_button__ = __webpack_require__(82);
        var __WEBPACK_IMPORTED_MODULE_66_bootstrap_vue_es_components_dropdown_dropdown_header__ = __webpack_require__(81);
        var __WEBPACK_IMPORTED_MODULE_67_bootstrap_vue_es_components_dropdown_dropdown_divider__ = __webpack_require__(80);
        var __WEBPACK_IMPORTED_MODULE_68_bootstrap_vue_es_components_embed_embed__ = __webpack_require__(85);
        var __WEBPACK_IMPORTED_MODULE_69_bootstrap_vue_es_components_form_form__ = __webpack_require__(41);
        var __WEBPACK_IMPORTED_MODULE_70_bootstrap_vue_es_components_form_form_text__ = __webpack_require__(39);
        var __WEBPACK_IMPORTED_MODULE_71_bootstrap_vue_es_components_form_form_invalid_feedback__ = __webpack_require__(38);
        var __WEBPACK_IMPORTED_MODULE_72_bootstrap_vue_es_components_form_form_valid_feedback__ = __webpack_require__(40);
        var __WEBPACK_IMPORTED_MODULE_73_bootstrap_vue_es_components_form_checkbox_form_checkbox__ = __webpack_require__(36);
        var __WEBPACK_IMPORTED_MODULE_74_bootstrap_vue_es_components_form_checkbox_form_checkbox_group__ = __webpack_require__(87);
        var __WEBPACK_IMPORTED_MODULE_75_bootstrap_vue_es_components_form_file_form_file__ = __webpack_require__(89);
        var __WEBPACK_IMPORTED_MODULE_76_bootstrap_vue_es_components_form_group_form_group__ = __webpack_require__(91);
        var __WEBPACK_IMPORTED_MODULE_77_bootstrap_vue_es_components_form_input_form_input__ = __webpack_require__(93);
        var __WEBPACK_IMPORTED_MODULE_78_bootstrap_vue_es_components_form_radio_form_radio__ = __webpack_require__(37);
        var __WEBPACK_IMPORTED_MODULE_79_bootstrap_vue_es_components_form_radio_form_radio_group__ = __webpack_require__(95);
        var __WEBPACK_IMPORTED_MODULE_80_bootstrap_vue_es_components_form_select_form_select__ = __webpack_require__(97);
        var __WEBPACK_IMPORTED_MODULE_81_bootstrap_vue_es_components_form_textarea_form_textarea__ = __webpack_require__(99);
        var __WEBPACK_IMPORTED_MODULE_82_bootstrap_vue_es_components_image_img__ = __webpack_require__(21);
        var __WEBPACK_IMPORTED_MODULE_83_bootstrap_vue_es_components_image_img_lazy__ = __webpack_require__(102);
        var __WEBPACK_IMPORTED_MODULE_84_bootstrap_vue_es_components_input_group_input_group__ = __webpack_require__(105);
        var __WEBPACK_IMPORTED_MODULE_85_bootstrap_vue_es_components_input_group_input_group_addon__ = __webpack_require__(22);
        var __WEBPACK_IMPORTED_MODULE_86_bootstrap_vue_es_components_input_group_input_group_text__ = __webpack_require__(23);
        var __WEBPACK_IMPORTED_MODULE_87_bootstrap_vue_es_components_input_group_input_group_prepend__ = __webpack_require__(43);
        var __WEBPACK_IMPORTED_MODULE_88_bootstrap_vue_es_components_input_group_input_group_append__ = __webpack_require__(42);
        var __WEBPACK_IMPORTED_MODULE_89_bootstrap_vue_es_components_jumbotron_jumbotron__ = __webpack_require__(107);
        var __WEBPACK_IMPORTED_MODULE_90_bootstrap_vue_es_components_layout_container__ = __webpack_require__(44);
        var __WEBPACK_IMPORTED_MODULE_91_bootstrap_vue_es_components_layout_row__ = __webpack_require__(110);
        var __WEBPACK_IMPORTED_MODULE_92_bootstrap_vue_es_components_layout_col__ = __webpack_require__(108);
        var __WEBPACK_IMPORTED_MODULE_93_bootstrap_vue_es_components_layout_form_row__ = __webpack_require__(24);
        var __WEBPACK_IMPORTED_MODULE_94_bootstrap_vue_es_components_link_link__ = __webpack_require__(6);
        var __WEBPACK_IMPORTED_MODULE_95_bootstrap_vue_es_components_list_group_list_group__ = __webpack_require__(114);
        var __WEBPACK_IMPORTED_MODULE_96_bootstrap_vue_es_components_list_group_list_group_item__ = __webpack_require__(113);
        var __WEBPACK_IMPORTED_MODULE_97_bootstrap_vue_es_components_media_media__ = __webpack_require__(116);
        var __WEBPACK_IMPORTED_MODULE_98_bootstrap_vue_es_components_media_media_aside__ = __webpack_require__(45);
        var __WEBPACK_IMPORTED_MODULE_99_bootstrap_vue_es_components_media_media_body__ = __webpack_require__(46);
        var __WEBPACK_IMPORTED_MODULE_100_bootstrap_vue_es_components_modal_modal__ = __webpack_require__(118);
        var __WEBPACK_IMPORTED_MODULE_101_bootstrap_vue_es_components_nav_nav__ = __webpack_require__(123);
        var __WEBPACK_IMPORTED_MODULE_102_bootstrap_vue_es_components_nav_nav_item__ = __webpack_require__(121);
        var __WEBPACK_IMPORTED_MODULE_103_bootstrap_vue_es_components_nav_nav_text__ = __webpack_require__(122);
        var __WEBPACK_IMPORTED_MODULE_104_bootstrap_vue_es_components_nav_nav_form__ = __webpack_require__(119);
        var __WEBPACK_IMPORTED_MODULE_105_bootstrap_vue_es_components_nav_nav_item_dropdown__ = __webpack_require__(120);
        var __WEBPACK_IMPORTED_MODULE_106_bootstrap_vue_es_components_navbar_navbar__ = __webpack_require__(128);
        var __WEBPACK_IMPORTED_MODULE_107_bootstrap_vue_es_components_navbar_navbar_nav__ = __webpack_require__(126);
        var __WEBPACK_IMPORTED_MODULE_108_bootstrap_vue_es_components_navbar_navbar_brand__ = __webpack_require__(125);
        var __WEBPACK_IMPORTED_MODULE_109_bootstrap_vue_es_components_navbar_navbar_toggle__ = __webpack_require__(127);
        var __WEBPACK_IMPORTED_MODULE_110_bootstrap_vue_es_components_pagination_pagination__ = __webpack_require__(132);
        var __WEBPACK_IMPORTED_MODULE_111_bootstrap_vue_es_components_pagination_nav_pagination_nav__ = __webpack_require__(130);
        var __WEBPACK_IMPORTED_MODULE_112_bootstrap_vue_es_components_popover_popover__ = __webpack_require__(134);
        var __WEBPACK_IMPORTED_MODULE_113_bootstrap_vue_es_components_progress_progress__ = __webpack_require__(136);
        var __WEBPACK_IMPORTED_MODULE_114_bootstrap_vue_es_components_progress_progress_bar__ = __webpack_require__(48);
        var __WEBPACK_IMPORTED_MODULE_115_bootstrap_vue_es_components_table_table__ = __webpack_require__(138);
        var __WEBPACK_IMPORTED_MODULE_116_bootstrap_vue_es_components_tabs_tabs__ = __webpack_require__(141);
        var __WEBPACK_IMPORTED_MODULE_117_bootstrap_vue_es_components_tabs_tab__ = __webpack_require__(140);
        var __WEBPACK_IMPORTED_MODULE_118_bootstrap_vue_es_components_tooltip_tooltip__ = __webpack_require__(143);
        var __WEBPACK_IMPORTED_MODULE_119_bootstrap_vue_es_directives_toggle_toggle__ = __webpack_require__(149);
        var __WEBPACK_IMPORTED_MODULE_120_bootstrap_vue_es_directives_modal_modal__ = __webpack_require__(145);
        var __WEBPACK_IMPORTED_MODULE_121_bootstrap_vue_es_directives_popover_popover__ = __webpack_require__(146);
        var __WEBPACK_IMPORTED_MODULE_122_bootstrap_vue_es_directives_scrollspy_scrollspy__ = __webpack_require__(147);
        var __WEBPACK_IMPORTED_MODULE_123_bootstrap_vue_es_directives_tooltip_tooltip__ = __webpack_require__(150);
        __webpack_require__.d(__webpack_exports__, "Custom", function() {
            return __WEBPACK_IMPORTED_MODULE_7__components_Custom_Custom_vue__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "LiteGrid", function() {
            return __WEBPACK_IMPORTED_MODULE_8__components_LiteGrid_LiteGrid_vue__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Alert", function() {
            return __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_es_components_alert__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Badge", function() {
            return __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_badge__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() {
            return __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_es_components_breadcrumb__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Button", function() {
            return __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_es_components_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() {
            return __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_es_components_button_toolbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_es_components_button_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Card", function() {
            return __WEBPACK_IMPORTED_MODULE_16_bootstrap_vue_es_components_card__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Carousel", function() {
            return __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue_es_components_carousel__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Collapse", function() {
            return __WEBPACK_IMPORTED_MODULE_19_bootstrap_vue_es_components_collapse__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Dropdown", function() {
            return __WEBPACK_IMPORTED_MODULE_20_bootstrap_vue_es_components_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Embed", function() {
            return __WEBPACK_IMPORTED_MODULE_21_bootstrap_vue_es_components_embed__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Form", function() {
            return __WEBPACK_IMPORTED_MODULE_22_bootstrap_vue_es_components_form__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_23_bootstrap_vue_es_components_form_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormInput", function() {
            return __WEBPACK_IMPORTED_MODULE_26_bootstrap_vue_es_components_form_input__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormTextarea", function() {
            return __WEBPACK_IMPORTED_MODULE_27_bootstrap_vue_es_components_form_textarea__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormFile", function() {
            return __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue_es_components_form_file__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormCheckbox", function() {
            return __WEBPACK_IMPORTED_MODULE_24_bootstrap_vue_es_components_form_checkbox__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormRadio", function() {
            return __WEBPACK_IMPORTED_MODULE_25_bootstrap_vue_es_components_form_radio__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormSelect", function() {
            return __WEBPACK_IMPORTED_MODULE_29_bootstrap_vue_es_components_form_select__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Image", function() {
            return __WEBPACK_IMPORTED_MODULE_30_bootstrap_vue_es_components_image__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "InputGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_es_components_input_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Jumbotron", function() {
            return __WEBPACK_IMPORTED_MODULE_31_bootstrap_vue_es_components_jumbotron__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Layout", function() {
            return __WEBPACK_IMPORTED_MODULE_18_bootstrap_vue_es_components_layout__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Link", function() {
            return __WEBPACK_IMPORTED_MODULE_32_bootstrap_vue_es_components_link__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ListGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_33_bootstrap_vue_es_components_list_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Media", function() {
            return __WEBPACK_IMPORTED_MODULE_34_bootstrap_vue_es_components_media__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Modal", function() {
            return __WEBPACK_IMPORTED_MODULE_35_bootstrap_vue_es_components_modal__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Nav", function() {
            return __WEBPACK_IMPORTED_MODULE_36_bootstrap_vue_es_components_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Navbar", function() {
            return __WEBPACK_IMPORTED_MODULE_37_bootstrap_vue_es_components_navbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Pagination", function() {
            return __WEBPACK_IMPORTED_MODULE_38_bootstrap_vue_es_components_pagination__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "PaginationNav", function() {
            return __WEBPACK_IMPORTED_MODULE_39_bootstrap_vue_es_components_pagination_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Popover", function() {
            return __WEBPACK_IMPORTED_MODULE_40_bootstrap_vue_es_components_popover__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Progress", function() {
            return __WEBPACK_IMPORTED_MODULE_41_bootstrap_vue_es_components_progress__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Table", function() {
            return __WEBPACK_IMPORTED_MODULE_42_bootstrap_vue_es_components_table__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Tabs", function() {
            return __WEBPACK_IMPORTED_MODULE_43_bootstrap_vue_es_components_tabs__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Tooltip", function() {
            return __WEBPACK_IMPORTED_MODULE_44_bootstrap_vue_es_components_tooltip__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bTabs", function() {
            return __WEBPACK_IMPORTED_MODULE_116_bootstrap_vue_es_components_tabs_tabs__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bTab", function() {
            return __WEBPACK_IMPORTED_MODULE_117_bootstrap_vue_es_components_tabs_tab__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bAlert", function() {
            return __WEBPACK_IMPORTED_MODULE_45_bootstrap_vue_es_components_alert_alert__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBadge", function() {
            return __WEBPACK_IMPORTED_MODULE_46_bootstrap_vue_es_components_badge_badge__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBreadcrumb", function() {
            return __WEBPACK_IMPORTED_MODULE_47_bootstrap_vue_es_components_breadcrumb_breadcrumb__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBreadcrumbItem", function() {
            return __WEBPACK_IMPORTED_MODULE_48_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBreadcrumbLink", function() {
            return __WEBPACK_IMPORTED_MODULE_49_bootstrap_vue_es_components_breadcrumb_breadcrumb_link__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bButton", function() {
            return __WEBPACK_IMPORTED_MODULE_50_bootstrap_vue_es_components_button_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBtn", function() {
            return __WEBPACK_IMPORTED_MODULE_50_bootstrap_vue_es_components_button_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bButtonClose", function() {
            return __WEBPACK_IMPORTED_MODULE_51_bootstrap_vue_es_components_button_button_close__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBtnClose", function() {
            return __WEBPACK_IMPORTED_MODULE_51_bootstrap_vue_es_components_button_button_close__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bButtonGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_es_components_button_group_button_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBtnGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_es_components_button_group_button_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bButtonToolbar", function() {
            return __WEBPACK_IMPORTED_MODULE_53_bootstrap_vue_es_components_button_toolbar_button_toolbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bBtnToolbar", function() {
            return __WEBPACK_IMPORTED_MODULE_53_bootstrap_vue_es_components_button_toolbar_button_toolbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCard", function() {
            return __WEBPACK_IMPORTED_MODULE_54_bootstrap_vue_es_components_card_card__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCardHeader", function() {
            return __WEBPACK_IMPORTED_MODULE_55_bootstrap_vue_es_components_card_card_header__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCardBody", function() {
            return __WEBPACK_IMPORTED_MODULE_56_bootstrap_vue_es_components_card_card_body__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCardFooter", function() {
            return __WEBPACK_IMPORTED_MODULE_57_bootstrap_vue_es_components_card_card_footer__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCardImg", function() {
            return __WEBPACK_IMPORTED_MODULE_58_bootstrap_vue_es_components_card_card_img__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCardGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_59_bootstrap_vue_es_components_card_card_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCarousel", function() {
            return __WEBPACK_IMPORTED_MODULE_60_bootstrap_vue_es_components_carousel_carousel__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCarouselSlide", function() {
            return __WEBPACK_IMPORTED_MODULE_61_bootstrap_vue_es_components_carousel_carousel_slide__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCollapse", function() {
            return __WEBPACK_IMPORTED_MODULE_62_bootstrap_vue_es_components_collapse_collapse__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdown", function() {
            return __WEBPACK_IMPORTED_MODULE_63_bootstrap_vue_es_components_dropdown_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDd", function() {
            return __WEBPACK_IMPORTED_MODULE_63_bootstrap_vue_es_components_dropdown_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdownItem", function() {
            return __WEBPACK_IMPORTED_MODULE_64_bootstrap_vue_es_components_dropdown_dropdown_item__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDdItem", function() {
            return __WEBPACK_IMPORTED_MODULE_64_bootstrap_vue_es_components_dropdown_dropdown_item__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdownItemButton", function() {
            return __WEBPACK_IMPORTED_MODULE_65_bootstrap_vue_es_components_dropdown_dropdown_item_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdownItemBtn", function() {
            return __WEBPACK_IMPORTED_MODULE_65_bootstrap_vue_es_components_dropdown_dropdown_item_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDdItemButton", function() {
            return __WEBPACK_IMPORTED_MODULE_65_bootstrap_vue_es_components_dropdown_dropdown_item_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDdItemBtn", function() {
            return __WEBPACK_IMPORTED_MODULE_65_bootstrap_vue_es_components_dropdown_dropdown_item_button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdownHeader", function() {
            return __WEBPACK_IMPORTED_MODULE_66_bootstrap_vue_es_components_dropdown_dropdown_header__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDdHeader", function() {
            return __WEBPACK_IMPORTED_MODULE_66_bootstrap_vue_es_components_dropdown_dropdown_header__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDropdownDivider", function() {
            return __WEBPACK_IMPORTED_MODULE_67_bootstrap_vue_es_components_dropdown_dropdown_divider__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bDdDivider", function() {
            return __WEBPACK_IMPORTED_MODULE_67_bootstrap_vue_es_components_dropdown_dropdown_divider__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bEmbed", function() {
            return __WEBPACK_IMPORTED_MODULE_68_bootstrap_vue_es_components_embed_embed__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bForm", function() {
            return __WEBPACK_IMPORTED_MODULE_69_bootstrap_vue_es_components_form_form__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormText", function() {
            return __WEBPACK_IMPORTED_MODULE_70_bootstrap_vue_es_components_form_form_text__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormInvalidFeedback", function() {
            return __WEBPACK_IMPORTED_MODULE_71_bootstrap_vue_es_components_form_form_invalid_feedback__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormFeedback", function() {
            return __WEBPACK_IMPORTED_MODULE_71_bootstrap_vue_es_components_form_form_invalid_feedback__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormValidFeedback", function() {
            return __WEBPACK_IMPORTED_MODULE_72_bootstrap_vue_es_components_form_form_valid_feedback__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormCheckbox", function() {
            return __WEBPACK_IMPORTED_MODULE_73_bootstrap_vue_es_components_form_checkbox_form_checkbox__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCheck", function() {
            return __WEBPACK_IMPORTED_MODULE_73_bootstrap_vue_es_components_form_checkbox_form_checkbox__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCheckbox", function() {
            return __WEBPACK_IMPORTED_MODULE_73_bootstrap_vue_es_components_form_checkbox_form_checkbox__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormCheckboxGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_74_bootstrap_vue_es_components_form_checkbox_form_checkbox_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCheckboxGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_74_bootstrap_vue_es_components_form_checkbox_form_checkbox_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCheckGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_74_bootstrap_vue_es_components_form_checkbox_form_checkbox_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormFile", function() {
            return __WEBPACK_IMPORTED_MODULE_75_bootstrap_vue_es_components_form_file_form_file__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFile", function() {
            return __WEBPACK_IMPORTED_MODULE_75_bootstrap_vue_es_components_form_file_form_file__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_76_bootstrap_vue_es_components_form_group_form_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormFieldset", function() {
            return __WEBPACK_IMPORTED_MODULE_76_bootstrap_vue_es_components_form_group_form_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormInput", function() {
            return __WEBPACK_IMPORTED_MODULE_77_bootstrap_vue_es_components_form_input_form_input__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInput", function() {
            return __WEBPACK_IMPORTED_MODULE_77_bootstrap_vue_es_components_form_input_form_input__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormRadio", function() {
            return __WEBPACK_IMPORTED_MODULE_78_bootstrap_vue_es_components_form_radio_form_radio__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bRadio", function() {
            return __WEBPACK_IMPORTED_MODULE_78_bootstrap_vue_es_components_form_radio_form_radio__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormRadioGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_79_bootstrap_vue_es_components_form_radio_form_radio_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bRadioGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_79_bootstrap_vue_es_components_form_radio_form_radio_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormSelect", function() {
            return __WEBPACK_IMPORTED_MODULE_80_bootstrap_vue_es_components_form_select_form_select__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bSelect", function() {
            return __WEBPACK_IMPORTED_MODULE_80_bootstrap_vue_es_components_form_select_form_select__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormTextarea", function() {
            return __WEBPACK_IMPORTED_MODULE_81_bootstrap_vue_es_components_form_textarea_form_textarea__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bTextarea", function() {
            return __WEBPACK_IMPORTED_MODULE_81_bootstrap_vue_es_components_form_textarea_form_textarea__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bImg", function() {
            return __WEBPACK_IMPORTED_MODULE_82_bootstrap_vue_es_components_image_img__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bImgLazy", function() {
            return __WEBPACK_IMPORTED_MODULE_83_bootstrap_vue_es_components_image_img_lazy__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInputGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_84_bootstrap_vue_es_components_input_group_input_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInputGroupAddon", function() {
            return __WEBPACK_IMPORTED_MODULE_85_bootstrap_vue_es_components_input_group_input_group_addon__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInputGroupText", function() {
            return __WEBPACK_IMPORTED_MODULE_86_bootstrap_vue_es_components_input_group_input_group_text__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInputGroupPrepend", function() {
            return __WEBPACK_IMPORTED_MODULE_87_bootstrap_vue_es_components_input_group_input_group_prepend__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bInputGroupAppend", function() {
            return __WEBPACK_IMPORTED_MODULE_88_bootstrap_vue_es_components_input_group_input_group_append__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bJumbotron", function() {
            return __WEBPACK_IMPORTED_MODULE_89_bootstrap_vue_es_components_jumbotron_jumbotron__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bContainer", function() {
            return __WEBPACK_IMPORTED_MODULE_90_bootstrap_vue_es_components_layout_container__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bRow", function() {
            return __WEBPACK_IMPORTED_MODULE_91_bootstrap_vue_es_components_layout_row__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bCol", function() {
            return __WEBPACK_IMPORTED_MODULE_92_bootstrap_vue_es_components_layout_col__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bFormRow", function() {
            return __WEBPACK_IMPORTED_MODULE_93_bootstrap_vue_es_components_layout_form_row__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bLink", function() {
            return __WEBPACK_IMPORTED_MODULE_94_bootstrap_vue_es_components_link_link__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bListGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_95_bootstrap_vue_es_components_list_group_list_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bListGroupItem", function() {
            return __WEBPACK_IMPORTED_MODULE_96_bootstrap_vue_es_components_list_group_list_group_item__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bMedia", function() {
            return __WEBPACK_IMPORTED_MODULE_97_bootstrap_vue_es_components_media_media__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bMediaAside", function() {
            return __WEBPACK_IMPORTED_MODULE_98_bootstrap_vue_es_components_media_media_aside__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bMediaBody", function() {
            return __WEBPACK_IMPORTED_MODULE_99_bootstrap_vue_es_components_media_media_body__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bModal", function() {
            return __WEBPACK_IMPORTED_MODULE_100_bootstrap_vue_es_components_modal_modal__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNav", function() {
            return __WEBPACK_IMPORTED_MODULE_101_bootstrap_vue_es_components_nav_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavItem", function() {
            return __WEBPACK_IMPORTED_MODULE_102_bootstrap_vue_es_components_nav_nav_item__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavText", function() {
            return __WEBPACK_IMPORTED_MODULE_103_bootstrap_vue_es_components_nav_nav_text__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavForm", function() {
            return __WEBPACK_IMPORTED_MODULE_104_bootstrap_vue_es_components_nav_nav_form__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavItemDropdown", function() {
            return __WEBPACK_IMPORTED_MODULE_105_bootstrap_vue_es_components_nav_nav_item_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavItemDd", function() {
            return __WEBPACK_IMPORTED_MODULE_105_bootstrap_vue_es_components_nav_nav_item_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavDropdown", function() {
            return __WEBPACK_IMPORTED_MODULE_105_bootstrap_vue_es_components_nav_nav_item_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavDd", function() {
            return __WEBPACK_IMPORTED_MODULE_105_bootstrap_vue_es_components_nav_nav_item_dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavbar", function() {
            return __WEBPACK_IMPORTED_MODULE_106_bootstrap_vue_es_components_navbar_navbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavbarNav", function() {
            return __WEBPACK_IMPORTED_MODULE_107_bootstrap_vue_es_components_navbar_navbar_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavbarBrand", function() {
            return __WEBPACK_IMPORTED_MODULE_108_bootstrap_vue_es_components_navbar_navbar_brand__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavbarToggle", function() {
            return __WEBPACK_IMPORTED_MODULE_109_bootstrap_vue_es_components_navbar_navbar_toggle__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bNavToggle", function() {
            return __WEBPACK_IMPORTED_MODULE_109_bootstrap_vue_es_components_navbar_navbar_toggle__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bPagination", function() {
            return __WEBPACK_IMPORTED_MODULE_110_bootstrap_vue_es_components_pagination_pagination__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bPaginationNav", function() {
            return __WEBPACK_IMPORTED_MODULE_111_bootstrap_vue_es_components_pagination_nav_pagination_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bPopover", function() {
            return __WEBPACK_IMPORTED_MODULE_112_bootstrap_vue_es_components_popover_popover__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bProgress", function() {
            return __WEBPACK_IMPORTED_MODULE_113_bootstrap_vue_es_components_progress_progress__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bProgressBar", function() {
            return __WEBPACK_IMPORTED_MODULE_114_bootstrap_vue_es_components_progress_progress_bar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bTable", function() {
            return __WEBPACK_IMPORTED_MODULE_115_bootstrap_vue_es_components_table_table__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "bTooltip", function() {
            return __WEBPACK_IMPORTED_MODULE_118_bootstrap_vue_es_components_tooltip_tooltip__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "vBToggle", function() {
            return __WEBPACK_IMPORTED_MODULE_119_bootstrap_vue_es_directives_toggle_toggle__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "vBModal", function() {
            return __WEBPACK_IMPORTED_MODULE_120_bootstrap_vue_es_directives_modal_modal__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "vBPopover", function() {
            return __WEBPACK_IMPORTED_MODULE_121_bootstrap_vue_es_directives_popover_popover__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "vBScrollspy", function() {
            return __WEBPACK_IMPORTED_MODULE_122_bootstrap_vue_es_directives_scrollspy_scrollspy__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "vBTooltip", function() {
            return __WEBPACK_IMPORTED_MODULE_123_bootstrap_vue_es_directives_tooltip_tooltip__["a"];
        });
        __WEBPACK_IMPORTED_MODULE_1_vue__["a"].config.productionTip = false;
        console.log("--- before install --- ");
        var PylonBootstrapVue = {
            install: function install(Vue) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                console.log("--- starting install fn  --- ", options.components);
                if (Vue._pylon_vue_installed) {
                    return;
                }
                if (options.components) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__components__["a"]).forEach(function(key) {
                        var component = __WEBPACK_IMPORTED_MODULE_6__components__["a"].key;
                        Vue.component(component.name, component);
                    });
                }
                if (!options.pylon_vue_components) {
                    for (var componentName in __WEBPACK_IMPORTED_MODULE_6__components__["a"]) {
                        var component = __WEBPACK_IMPORTED_MODULE_6__components__["a"][componentName];
                        if (component && componentName !== "install") {
                            Vue.component(component.name, component);
                        }
                    }
                }
                console.log("--- Inside install fn  --- ");
                Vue._pylon_vue_installed = true;
            }
        };
        if (typeof window !== "undefined" && window.Vue) {
            window.Vue.use(PylonBootstrapVue);
        }
        __webpack_exports__["default"] = PylonBootstrapVue;
        new __WEBPACK_IMPORTED_MODULE_1_vue__["a"]({
            el: "#app",
            template: "<App/>",
            components: {
                App: __WEBPACK_IMPORTED_MODULE_2__App__["a"]
            }
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__components_Custom_Custom_vue__ = __webpack_require__(165);
        console.log("--- component.js --- ");
        __webpack_exports__["a"] = {
            Custom: __WEBPACK_IMPORTED_MODULE_0__components_Custom_Custom_vue__["a"]
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1_popper_js__ = __webpack_require__(17);
        var __WEBPACK_IMPORTED_MODULE_2_lodash_startcase__ = __webpack_require__(164);
        var __WEBPACK_IMPORTED_MODULE_2_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startcase__);
        var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(163);
        var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var classCallCheck = function(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        };
        var createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var defineProperty = function(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }
            return obj;
        };
        var inherits = function(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        };
        var possibleConstructorReturn = function(self, call) {
            if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self;
        };
        var toConsumableArray = function(arr) {
            if (Array.isArray(arr)) {
                for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
                return arr2;
            } else {
                return Array.from(arr);
            }
        };
        var props = {
            disabled: {
                type: Boolean,
                default: false
            },
            ariaLabel: {
                type: String,
                default: "Close"
            },
            textVariant: {
                type: String,
                default: null
            }
        };
        var bBtnClose = {
            functional: true,
            props: props,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, listeners = _ref.listeners, slots = _ref.slots;
                var componentData = {
                    staticClass: "close",
                    class: defineProperty({}, "text-" + props.textVariant, props.textVariant),
                    attrs: {
                        type: "button",
                        disabled: props.disabled,
                        "aria-label": props.ariaLabel ? String(props.ariaLabel) : null
                    },
                    on: {
                        click: function click(e) {
                            if (props.disabled && e instanceof Event) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }
                    }
                };
                if (!slots().default) {
                    componentData.domProps = {
                        innerHTML: "&times;"
                    };
                }
                return h("button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), slots().default);
            }
        };
        var bAlert = {
            components: {
                bButtonClose: bBtnClose
            },
            render: function render(h) {
                if (!this.localShow) {
                    return h(false);
                }
                var dismissBtn = h(false);
                if (this.dismissible) {
                    dismissBtn = h("b-button-close", {
                        attrs: {
                            "aria-label": this.dismissLabel
                        },
                        on: {
                            click: this.dismiss
                        }
                    }, [ this.$slots.dismiss ]);
                }
                return h("div", {
                    class: this.classObject,
                    attrs: {
                        role: "alert",
                        "aria-live": "polite",
                        "aria-atomic": true
                    }
                }, [ dismissBtn, this.$slots.default ]);
            },
            model: {
                prop: "show",
                event: "input"
            },
            data: function data() {
                return {
                    countDownTimerId: null,
                    dismissed: false
                };
            },
            computed: {
                classObject: function classObject() {
                    return [ "alert", this.alertVariant, this.dismissible ? "alert-dismissible" : "" ];
                },
                alertVariant: function alertVariant() {
                    var variant = this.variant;
                    return "alert-" + variant;
                },
                localShow: function localShow() {
                    return !this.dismissed && (this.countDownTimerId || this.show);
                }
            },
            props: {
                variant: {
                    type: String,
                    default: "info"
                },
                dismissible: {
                    type: Boolean,
                    default: false
                },
                dismissLabel: {
                    type: String,
                    default: "Close"
                },
                show: {
                    type: [ Boolean, Number ],
                    default: false
                }
            },
            watch: {
                show: function show() {
                    this.showChanged();
                }
            },
            mounted: function mounted() {
                this.showChanged();
            },
            destroyed: function destroyed() {
                this.clearCounter();
            },
            methods: {
                dismiss: function dismiss() {
                    this.clearCounter();
                    this.dismissed = true;
                    this.$emit("dismissed");
                    this.$emit("input", false);
                    if (typeof this.show === "number") {
                        this.$emit("dismiss-count-down", 0);
                        this.$emit("input", 0);
                    } else {
                        this.$emit("input", false);
                    }
                },
                clearCounter: function clearCounter() {
                    if (this.countDownTimerId) {
                        clearInterval(this.countDownTimerId);
                        this.countDownTimerId = null;
                    }
                },
                showChanged: function showChanged() {
                    var _this = this;
                    this.clearCounter();
                    this.dismissed = false;
                    if (this.show === true || this.show === false || this.show === null || this.show === 0) {
                        return;
                    }
                    var dismissCountDown = this.show;
                    this.countDownTimerId = setInterval(function() {
                        if (dismissCountDown < 1) {
                            _this.dismiss();
                            return;
                        }
                        dismissCountDown--;
                        _this.$emit("dismiss-count-down", dismissCountDown);
                        _this.$emit("input", dismissCountDown);
                    }, 1e3);
                }
            }
        };
        function registerComponent(Vue, name, def) {
            Vue._bootstrap_vue_components_ = Vue._bootstrap_vue_components_ || {};
            var loaded = Vue._bootstrap_vue_components_[name];
            if (!loaded && def && name) {
                Vue._bootstrap_vue_components_[name] = true;
                Vue.component(name, def);
            }
            return loaded;
        }
        function registerComponents(Vue, components) {
            for (var component in components) {
                registerComponent(Vue, component, components[component]);
            }
        }
        function registerDirective(Vue, name, def) {
            Vue._bootstrap_vue_directives_ = Vue._bootstrap_vue_directives_ || {};
            var loaded = Vue._bootstrap_vue_directives_[name];
            if (!loaded && def && name) {
                Vue._bootstrap_vue_directives_[name] = true;
                Vue.directive(name, def);
            }
            return loaded;
        }
        function registerDirectives(Vue, directives) {
            for (var directive in directives) {
                registerDirective(Vue, directive, directives[directive]);
            }
        }
        function vueUse(VuePlugin) {
            if (typeof window !== "undefined" && window.Vue) {
                window.Vue.use(VuePlugin);
            }
        }
        var components = {
            bAlert: bAlert
        };
        var VuePlugin = {
            install: function install(Vue) {
                registerComponents(Vue, components);
            }
        };
        vueUse(VuePlugin);
        if (typeof Object.assign !== "function") {
            Object.assign = function(target, varArgs) {
                if (target == null) {
                    throw new TypeError("Cannot convert undefined or null to object");
                }
                var to = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];
                    if (nextSource != null) {
                        for (var nextKey in nextSource) {
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            };
        }
        if (!Object.is) {
            Object.is = function(x, y) {
                if (x === y) {
                    return x !== 0 || 1 / x === 1 / y;
                } else {
                    return x !== x && y !== y;
                }
            };
        }
        var assign = Object.assign;
        var keys = Object.keys;
        var defineProperties = Object.defineProperties;
        var defineProperty$1 = Object.defineProperty;
        var create = Object.create;
        function readonlyDescriptor() {
            return {
                enumerable: true,
                configurable: false,
                writable: false
            };
        }
        if (!Array.from) {
            Array.from = function() {
                var toStr = Object.prototype.toString;
                var isCallable = function isCallable(fn) {
                    return typeof fn === "function" || toStr.call(fn) === "[object Function]";
                };
                var toInteger = function toInteger(value) {
                    var number = Number(value);
                    if (isNaN(number)) {
                        return 0;
                    }
                    if (number === 0 || !isFinite(number)) {
                        return number;
                    }
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function toLength(value) {
                    return Math.min(Math.max(toInteger(value), 0), maxSafeInteger);
                };
                return function from(arrayLike) {
                    var C = this;
                    var items = Object(arrayLike);
                    if (arrayLike == null) {
                        throw new TypeError("Array.from requires an array-like object - not null or undefined");
                    }
                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                    var T = void 0;
                    if (typeof mapFn !== "undefined") {
                        if (!isCallable(mapFn)) {
                            throw new TypeError("Array.from: when provided, the second argument must be a function");
                        }
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }
                    var len = toLength(items.length);
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                    var k = 0;
                    var kValue = void 0;
                    while (k < len) {
                        kValue = items[k];
                        if (mapFn) {
                            A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        } else {
                            A[k] = kValue;
                        }
                        k += 1;
                    }
                    A.length = len;
                    return A;
                };
            }();
        }
        if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    var len = o.length >>> 0;
                    if (typeof predicate !== "function") {
                        throw new TypeError("predicate must be a function");
                    }
                    var thisArg = arguments[1];
                    var k = 0;
                    while (k < len) {
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        k++;
                    }
                    return undefined;
                }
            });
        }
        if (!Array.isArray) {
            Array.isArray = function(arg) {
                return Object.prototype.toString.call(arg) === "[object Array]";
            };
        }
        var from = Array.from;
        var isArray = Array.isArray;
        var arrayIncludes = function arrayIncludes(array, value) {
            return array.indexOf(value) !== -1;
        };
        function concat() {
            return Array.prototype.concat.apply([], arguments);
        }
        function identity(x) {
            return x;
        }
        function pluckProps(keysToPluck, objToPluck) {
            var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
            return (isArray(keysToPluck) ? keysToPluck.slice() : keys(keysToPluck)).reduce(function(memo, prop) {
                return memo[transformFn(prop)] = objToPluck[prop], memo;
            }, {});
        }
        function propsFactory() {
            return {
                href: {
                    type: String,
                    default: null
                },
                rel: {
                    type: String,
                    default: null
                },
                target: {
                    type: String,
                    default: "_self"
                },
                active: {
                    type: Boolean,
                    default: false
                },
                activeClass: {
                    type: String,
                    default: "active"
                },
                append: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                event: {
                    type: [ String, Array ],
                    default: "click"
                },
                exact: {
                    type: Boolean,
                    default: false
                },
                exactActiveClass: {
                    type: String,
                    default: "active"
                },
                replace: {
                    type: Boolean,
                    default: false
                },
                routerTag: {
                    type: String,
                    default: "a"
                },
                to: {
                    type: [ String, Object ],
                    default: null
                }
            };
        }
        function pickLinkProps(propsToPick) {
            var freshLinkProps = propsFactory();
            propsToPick = concat(propsToPick);
            return keys(freshLinkProps).reduce(function(memo, prop) {
                if (arrayIncludes(propsToPick, prop)) {
                    memo[prop] = freshLinkProps[prop];
                }
                return memo;
            }, {});
        }
        function computeTag(props, parent) {
            return Boolean(parent.$router) && props.to && !props.disabled ? "router-link" : "a";
        }
        function computeHref(_ref, tag) {
            var disabled = _ref.disabled, href = _ref.href, to = _ref.to;
            if (tag === "router-link") return void 0;
            if (href) return href;
            if (to) {
                if (typeof to === "string") return to;
                if ((typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" && typeof to.path === "string") return to.path;
            }
            return "#";
        }
        function computeRel(_ref2) {
            var target = _ref2.target, rel = _ref2.rel;
            if (target === "_blank" && rel === null) {
                return "noopener";
            }
            return rel || null;
        }
        function clickHandlerFactory(_ref3) {
            var disabled = _ref3.disabled, tag = _ref3.tag, href = _ref3.href, suppliedHandler = _ref3.suppliedHandler, parent = _ref3.parent;
            var isRouterLink = tag === "router-link";
            return function onClick(e) {
                if (disabled && e instanceof Event) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                } else {
                    parent.$root.$emit("clicked::link", e);
                    if (isRouterLink && e.target.__vue__) {
                        e.target.__vue__.$emit("click", e);
                    }
                    if (typeof suppliedHandler === "function") {
                        suppliedHandler.apply(undefined, arguments);
                    }
                }
                if (!isRouterLink && href === "#" || disabled) {
                    e.preventDefault();
                }
            };
        }
        var bLink = {
            functional: true,
            props: propsFactory(),
            render: function render(h, _ref4) {
                var props = _ref4.props, data = _ref4.data, parent = _ref4.parent, children = _ref4.children;
                var tag = computeTag(props, parent);
                var rel = computeRel(props);
                var href = computeHref(props, tag);
                var eventType = tag === "router-link" ? "nativeOn" : "on";
                var suppliedHandler = (data[eventType] || {}).click;
                var handlers = {
                    click: clickHandlerFactory({
                        tag: tag,
                        href: href,
                        disabled: props.disabled,
                        suppliedHandler: suppliedHandler,
                        parent: parent
                    })
                };
                var componentData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: [ props.active ? props.exact ? props.exactActiveClass : props.activeClass : null, {
                        disabled: props.disabled
                    } ],
                    attrs: {
                        rel: rel,
                        href: href,
                        target: props.target,
                        tabindex: props.disabled ? "-1" : data.attrs ? data.attrs.tabindex : null,
                        "aria-disabled": tag === "a" && props.disabled ? "true" : null
                    },
                    props: assign(props, {
                        tag: props.routerTag
                    })
                });
                if (!componentData.attrs.href) {
                    delete componentData.attrs.href;
                }
                componentData[eventType] = assign(componentData[eventType] || {}, handlers);
                return h(tag, componentData, children);
            }
        };
        var linkProps = propsFactory();
        delete linkProps.href.default;
        delete linkProps.to.default;
        var props$2 = assign(linkProps, {
            tag: {
                type: String,
                default: "span"
            },
            variant: {
                type: String,
                default: "secondary"
            },
            pill: {
                type: Boolean,
                default: false
            }
        });
        var bBadge = {
            functional: true,
            props: props$2,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var tag = !props.href && !props.to ? props.tag : bLink;
                var componentData = {
                    staticClass: "badge",
                    class: [ !props.variant ? "badge-secondary" : "badge-" + props.variant, {
                        "badge-pill": Boolean(props.pill),
                        active: props.active,
                        disabled: props.disabled
                    } ],
                    props: pluckProps(linkProps, props)
                };
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
        var components$1 = {
            bBadge: bBadge
        };
        var VuePlugin$1 = {
            install: function install(Vue) {
                registerComponents(Vue, components$1);
            }
        };
        vueUse(VuePlugin$1);
        var props$3 = assign(propsFactory(), {
            text: {
                type: String,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            href: {
                type: String,
                default: "#"
            },
            ariaCurrent: {
                type: String,
                default: "location"
            }
        });
        var BreadcrumbLink = {
            functional: true,
            props: props$3,
            render: function render(h, _ref) {
                var suppliedProps = _ref.props, data = _ref.data, children = _ref.children;
                var tag = suppliedProps.active ? "span" : bLink;
                var componentData = {
                    props: pluckProps(props$3, suppliedProps),
                    domProps: {
                        innerHTML: suppliedProps.text
                    }
                };
                if (suppliedProps.active) {
                    componentData.attrs = {
                        "aria-current": suppliedProps.ariaCurrent
                    };
                } else {
                    componentData.attrs = {
                        href: suppliedProps.href
                    };
                }
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
        var props$4 = assign({}, props$3, {
            text: {
                type: String,
                default: null
            },
            href: {
                type: String,
                default: null
            }
        });
        var BreadcrumbItem = {
            functional: true,
            props: props$4,
            render: function render(h, _ref) {
                var props$$1 = _ref.props, data = _ref.data, children = _ref.children;
                return h("li", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "breadcrumb-item",
                    class: {
                        active: props$$1.active
                    },
                    attrs: {
                        role: "presentation"
                    }
                }), [ h(BreadcrumbLink, {
                    props: props$$1
                }, children) ]);
            }
        };
        var props$5 = {
            items: {
                type: Array,
                default: null
            }
        };
        var bBreadcrumb = {
            functional: true,
            props: props$5,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var childNodes = children;
                if (isArray(props.items)) {
                    var activeDefined = false;
                    childNodes = props.items.map(function(item, idx) {
                        if ((typeof item === "undefined" ? "undefined" : _typeof(item)) !== "object") {
                            item = {
                                text: item
                            };
                        }
                        var active = item.active;
                        if (active) {
                            activeDefined = true;
                        }
                        if (!active && !activeDefined) {
                            active = idx + 1 === props.items.length;
                        }
                        return h(BreadcrumbItem, {
                            props: assign({}, item, {
                                active: active
                            })
                        });
                    });
                }
                return h("ol", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "breadcrumb"
                }), childNodes);
            }
        };
        var components$2 = {
            bBreadcrumb: bBreadcrumb,
            bBreadcrumbItem: BreadcrumbItem,
            bBreadcrumbLink: BreadcrumbLink
        };
        var VuePlugin$2 = {
            install: function install(Vue) {
                registerComponents(Vue, components$2);
            }
        };
        vueUse(VuePlugin$2);
        var isElement = function isElement(el) {
            return el && el.nodeType === Node.ELEMENT_NODE;
        };
        var isVisible = function isVisible(el) {
            return isElement(el) && document.body.contains(el) && el.getBoundingClientRect().height > 0 && el.getBoundingClientRect().width > 0;
        };
        var isDisabled = function isDisabled(el) {
            return !isElement(el) || el.disabled || el.classList.contains("disabled") || Boolean(el.getAttribute("disabled"));
        };
        var reflow = function reflow(el) {
            return isElement(el) && el.offsetHeight;
        };
        var selectAll = function selectAll(selector, root) {
            if (!isElement(root)) {
                root = document;
            }
            return from(root.querySelectorAll(selector));
        };
        var select = function select(selector, root) {
            if (!isElement(root)) {
                root = document;
            }
            return root.querySelector(selector) || null;
        };
        var matches = function matches(el, selector) {
            if (!isElement(el)) {
                return false;
            }
            var proto = Element.prototype;
            var Matches = proto.matches || proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector || function(sel) {
                var element = this;
                var m = selectAll(sel, element.document || element.ownerDocument);
                var i = m.length;
                while (--i >= 0 && m.item(i) !== element) {}
                return i > -1;
            };
            return Matches.call(el, selector);
        };
        var closest = function closest(selector, root) {
            if (!isElement(root)) {
                return null;
            }
            var Closest = Element.prototype.closest || function(sel) {
                var element = this;
                if (!document.documentElement.contains(element)) {
                    return null;
                }
                do {
                    if (matches(element, sel)) {
                        return element;
                    }
                    element = element.parentElement;
                } while (element !== null);
                return null;
            };
            var el = Closest.call(root, selector);
            return el === root ? null : el;
        };
        var getById = function getById(id) {
            return document.getElementById(/^#/.test(id) ? id.slice(1) : id) || null;
        };
        var addClass = function addClass(el, className) {
            if (className && isElement(el)) {
                el.classList.add(className);
            }
        };
        var removeClass = function removeClass(el, className) {
            if (className && isElement(el)) {
                el.classList.remove(className);
            }
        };
        var hasClass = function hasClass(el, className) {
            if (className && isElement(el)) {
                return el.classList.contains(className);
            }
            return false;
        };
        var setAttr = function setAttr(el, attr, value) {
            if (attr && isElement(el)) {
                el.setAttribute(attr, value);
            }
        };
        var removeAttr = function removeAttr(el, attr) {
            if (attr && isElement(el)) {
                el.removeAttribute(attr);
            }
        };
        var getAttr = function getAttr(el, attr) {
            if (attr && isElement(el)) {
                return el.getAttribute(attr);
            }
            return null;
        };
        var hasAttr = function hasAttr(el, attr) {
            if (attr && isElement(el)) {
                return el.hasAttribute(attr);
            }
            return null;
        };
        var getBCR = function getBCR(el) {
            return isElement(el) ? el.getBoundingClientRect() : null;
        };
        var getCS = function getCS(el) {
            return isElement(el) ? window.getComputedStyle(el) : {};
        };
        var offset = function offset(el) {
            if (isElement(el)) {
                if (!el.getClientRects().length) {
                    return {
                        top: 0,
                        left: 0
                    };
                }
                var bcr = getBCR(el);
                var win = el.ownerDocument.defaultView;
                return {
                    top: bcr.top + win.pageYOffset,
                    left: bcr.left + win.pageXOffset
                };
            }
        };
        var position = function position(el) {
            if (!isElement(el)) {
                return;
            }
            var parentOffset = {
                top: 0,
                left: 0
            };
            var offsetSelf = void 0;
            var offsetParent = void 0;
            if (getCS(el).position === "fixed") {
                offsetSelf = getBCR(el);
            } else {
                offsetSelf = offset(el);
                var doc = el.ownerDocument;
                offsetParent = el.offsetParent || doc.documentElement;
                while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && getCS(offsetParent).position === "static") {
                    offsetParent = offsetParent.parentNode;
                }
                if (offsetParent && offsetParent !== el && offsetParent.nodeType === Node.ELEMENT_NODE) {
                    parentOffset = offset(offsetParent);
                    parentOffset.top += parseFloat(getCS(offsetParent).borderTopWidth);
                    parentOffset.left += parseFloat(getCS(offsetParent).borderLeftWidth);
                }
            }
            return {
                top: offsetSelf.top - parentOffset.top - parseFloat(getCS(el).marginTop),
                left: offsetSelf.left - parentOffset.left - parseFloat(getCS(el).marginLeft)
            };
        };
        var eventOn = function eventOn(el, evtName, handler) {
            if (el && el.addEventListener) {
                el.addEventListener(evtName, handler);
            }
        };
        var eventOff = function eventOff(el, evtName, handler) {
            if (el && el.removeEventListener) {
                el.removeEventListener(evtName, handler);
            }
        };
        var btnProps = {
            block: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: null
            },
            variant: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: "button"
            },
            pressed: {
                type: Boolean,
                default: null
            }
        };
        var linkProps$1 = propsFactory();
        delete linkProps$1.href.default;
        delete linkProps$1.to.default;
        var linkPropKeys = keys(linkProps$1);
        var props$6 = assign(linkProps$1, btnProps);
        function handleFocus(evt) {
            if (evt.type === "focusin") {
                addClass(evt.target, "focus");
            } else if (evt.type === "focusout") {
                removeClass(evt.target, "focus");
            }
        }
        var bBtn = {
            functional: true,
            props: props$6,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, listeners = _ref.listeners, children = _ref.children;
                var isLink = Boolean(props.href || props.to);
                var isToggle = typeof props.pressed === "boolean";
                var on = {
                    click: function click(e) {
                        if (props.disabled && e instanceof Event) {
                            e.stopPropagation();
                            e.preventDefault();
                        } else if (isToggle) {
                            concat(listeners["update:pressed"]).forEach(function(fn) {
                                if (typeof fn === "function") {
                                    fn(!props.pressed);
                                }
                            });
                        }
                    }
                };
                if (isToggle) {
                    on.focusin = handleFocus;
                    on.focusout = handleFocus;
                }
                var componentData = {
                    staticClass: "btn",
                    class: [ props.variant ? "btn-" + props.variant : "btn-secondary", (_ref2 = {}, 
                    defineProperty(_ref2, "btn-" + props.size, Boolean(props.size)), defineProperty(_ref2, "btn-block", props.block), 
                    defineProperty(_ref2, "disabled", props.disabled), defineProperty(_ref2, "active", props.pressed), 
                    _ref2) ],
                    props: isLink ? pluckProps(linkPropKeys, props) : null,
                    attrs: {
                        type: isLink ? null : props.type,
                        disabled: isLink ? null : props.disabled,
                        "data-toggle": isToggle ? "button" : null,
                        "aria-pressed": isToggle ? String(props.pressed) : null,
                        tabindex: props.disabled && isLink ? "-1" : data.attrs ? data.attrs["tabindex"] : null
                    },
                    on: on
                };
                return h(isLink ? bLink : "button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
        var components$3 = {
            bButton: bBtn,
            bBtn: bBtn,
            bButtonClose: bBtnClose,
            bBtnClose: bBtnClose
        };
        var VuePlugin$3 = {
            install: function install(Vue) {
                registerComponents(Vue, components$3);
            }
        };
        vueUse(VuePlugin$3);
        var props$7 = {
            vertical: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: null,
                validator: function validator(size) {
                    return arrayIncludes([ "sm", "", "lg" ], size);
                }
            },
            tag: {
                type: String,
                default: "div"
            },
            ariaRole: {
                type: String,
                default: "group"
            }
        };
        var bButtonGroup = {
            functional: true,
            props: props$7,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: defineProperty({
                        "btn-group": !props.vertical,
                        "btn-group-vertical": props.vertical
                    }, "btn-group-" + props.size, Boolean(props.size)),
                    attrs: {
                        role: props.ariaRole
                    }
                }), children);
            }
        };
        var components$4 = {
            bButtonGroup: bButtonGroup,
            bBtnGroup: bButtonGroup
        };
        var VuePlugin$4 = {
            install: function install(Vue) {
                registerComponents(Vue, components$4);
            }
        };
        vueUse(VuePlugin$4);
        var KeyCodes = {
            SPACE: 32,
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            PAGEUP: 33,
            PAGEDOWN: 34,
            HOME: 36,
            END: 35
        };
        var ITEM_SELECTOR = [ ".btn:not(.disabled):not([disabled]):not(.dropdown-item)", ".form-control:not(.disabled):not([disabled])", "select:not(.disabled):not([disabled])", 'input[type="checkbox"]:not(.disabled)', 'input[type="radio"]:not(.disabled)' ].join(",");
        var bButtonToolbar = {
            render: function render(h) {
                return h("div", {
                    class: this.classObject,
                    attrs: {
                        role: "toolbar",
                        tabindex: this.keyNav ? "0" : null
                    },
                    on: {
                        focusin: this.onFocusin,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
            },
            computed: {
                classObject: function classObject() {
                    return [ "btn-toolbar", this.justify && !this.vertical ? "justify-content-between" : "" ];
                }
            },
            props: {
                justify: {
                    type: Boolean,
                    default: false
                },
                keyNav: {
                    type: Boolean,
                    default: false
                }
            },
            methods: {
                onFocusin: function onFocusin(evt) {
                    if (evt.target === this.$el) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.focusFirst(evt);
                    }
                },
                onKeydown: function onKeydown(evt) {
                    if (!this.keyNav) {
                        return;
                    }
                    var key = evt.keyCode;
                    var shift = evt.shiftKey;
                    if (key === KeyCodes.UP || key === KeyCodes.LEFT) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (shift) {
                            this.focusFirst(evt);
                        } else {
                            this.focusNext(evt, true);
                        }
                    } else if (key === KeyCodes.DOWN || key === KeyCodes.RIGHT) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (shift) {
                            this.focusLast(evt);
                        } else {
                            this.focusNext(evt, false);
                        }
                    }
                },
                setItemFocus: function setItemFocus(item) {
                    this.$nextTick(function() {
                        item.focus();
                    });
                },
                focusNext: function focusNext(evt, prev) {
                    var items = this.getItems();
                    if (items.length < 1) {
                        return;
                    }
                    var index = items.indexOf(evt.target);
                    if (prev && index > 0) {
                        index--;
                    } else if (!prev && index < items.length - 1) {
                        index++;
                    }
                    if (index < 0) {
                        index = 0;
                    }
                    this.setItemFocus(items[index]);
                },
                focusFirst: function focusFirst(evt) {
                    var items = this.getItems();
                    if (items.length > 0) {
                        this.setItemFocus(items[0]);
                    }
                },
                focusLast: function focusLast(evt) {
                    var items = this.getItems();
                    if (items.length > 0) {
                        this.setItemFocus([ items.length - 1 ]);
                    }
                },
                getItems: function getItems() {
                    var items = selectAll(ITEM_SELECTOR, this.$el);
                    items.forEach(function(item) {
                        item.tabIndex = -1;
                    });
                    return items.filter(function(el) {
                        return isVisible(el);
                    });
                }
            },
            mounted: function mounted() {
                if (this.keyNav) {
                    this.getItems();
                }
            }
        };
        var components$5 = {
            bButtonToolbar: bButtonToolbar,
            bBtnToolbar: bButtonToolbar
        };
        var VuePlugin$5 = {
            install: function install(Vue) {
                registerComponents(Vue, components$5);
            }
        };
        vueUse(VuePlugin$5);
        var props$8 = {
            tag: {
                type: String,
                default: "div"
            }
        };
        var InputGroupText = {
            props: props$8,
            functional: true,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group-text"
                }), children);
            }
        };
        var propsFactory$1 = function propsFactory(append) {
            return {
                id: {
                    type: String,
                    default: null
                },
                tag: {
                    type: String,
                    default: "div"
                },
                append: {
                    type: Boolean,
                    default: append
                },
                isText: {
                    type: Boolean,
                    default: false
                }
            };
        };
        var InputGroupAddon = {
            functional: true,
            props: propsFactory$1(false),
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group-" + (props.append ? "append" : "prepend"),
                    attrs: {
                        id: props.id
                    }
                }), props.isText ? [ h(InputGroupText, children) ] : children);
            }
        };
        var InputGroupPrepend = {
            functional: true,
            props: propsFactory$1(false),
            render: InputGroupAddon.render
        };
        var InputGroupAppend = {
            functional: true,
            props: propsFactory$1(true),
            render: InputGroupAddon.render
        };
        var props$9 = {
            id: {
                type: String,
                default: null
            },
            size: {
                type: String,
                default: null
            },
            prepend: {
                type: String,
                default: null
            },
            append: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            }
        };
        var bInputGroup = {
            functional: true,
            props: props$9,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var $slots = slots();
                var childNodes = [];
                if (props.prepend) {
                    childNodes.push(h(InputGroupPrepend, [ h(InputGroupText, {
                        domProps: {
                            innerHTML: props.prepend
                        }
                    }) ]));
                }
                if ($slots.prepend) {
                    childNodes.push(h(InputGroupPrepend, $slots.prepend));
                }
                childNodes.push($slots.default);
                if (props.append) {
                    childNodes.push(h(InputGroupAppend, [ h(InputGroupText, {
                        domProps: {
                            innerHTML: props.append
                        }
                    }) ]));
                }
                if ($slots.append) {
                    childNodes.push(h(InputGroupAppend, $slots.append));
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "input-group",
                    class: defineProperty({}, "input-group-" + props.size, Boolean(props.size)),
                    attrs: {
                        id: props.id || null,
                        role: "group"
                    }
                }), childNodes);
            }
        };
        var components$6 = {
            bInputGroup: bInputGroup,
            bInputGroupAddon: InputGroupAddon,
            bInputGroupPrepend: InputGroupPrepend,
            bInputGroupAppend: InputGroupAppend,
            bInputGroupText: InputGroupText
        };
        var VuePlugin$6 = {
            install: function install(Vue) {
                registerComponents(Vue, components$6);
            }
        };
        vueUse(VuePlugin$6);
        function upperFirst(str) {
            if (typeof str !== "string") {
                str = String(str);
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        function prefixPropName(prefix, value) {
            return prefix + upperFirst(value);
        }
        function lowerFirst(str) {
            if (typeof str !== "string") {
                str = String(str);
            }
            return str.charAt(0).toLowerCase() + str.slice(1);
        }
        function unPrefixPropName(prefix, value) {
            return lowerFirst(value.replace(prefix, ""));
        }
        function copyProps(props) {
            var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
            if (isArray(props)) {
                return props.map(transformFn);
            }
            var copied = {};
            for (var prop in props) {
                if (props.hasOwnProperty(prop)) {
                    if ((typeof prop === "undefined" ? "undefined" : _typeof(prop)) === "object") {
                        copied[transformFn(prop)] = assign({}, props[prop]);
                    } else {
                        copied[transformFn(prop)] = props[prop];
                    }
                }
            }
            return copied;
        }
        var cardMixin = {
            props: {
                tag: {
                    type: String,
                    default: "div"
                },
                bgVariant: {
                    type: String,
                    default: null
                },
                borderVariant: {
                    type: String,
                    default: null
                },
                textVariant: {
                    type: String,
                    default: null
                }
            }
        };
        var props$10 = assign({}, copyProps(cardMixin.props, prefixPropName.bind(null, "body")), {
            bodyClass: {
                type: [ String, Object, Array ],
                default: null
            },
            title: {
                type: String,
                default: null
            },
            titleTag: {
                type: String,
                default: "h4"
            },
            subTitle: {
                type: String,
                default: null
            },
            subTitleTag: {
                type: String,
                default: "h6"
            },
            overlay: {
                type: Boolean,
                default: false
            }
        });
        var CardBody = {
            functional: true,
            props: props$10,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var cardBodyChildren = [];
                if (props.title) {
                    cardBodyChildren.push(h(props.titleTag, {
                        staticClass: "card-title",
                        domProps: {
                            innerHTML: props.title
                        }
                    }));
                }
                if (props.subTitle) {
                    cardBodyChildren.push(h(props.subTitleTag, {
                        staticClass: "card-subtitle mb-2 text-muted",
                        domProps: {
                            innerHTML: props.subTitle
                        }
                    }));
                }
                cardBodyChildren.push(slots().default);
                return h(props.bodyTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-body",
                    class: [ (_ref2 = {
                        "card-img-overlay": props.overlay
                    }, defineProperty(_ref2, "bg-" + props.bodyBgVariant, Boolean(props.bodyBgVariant)), 
                    defineProperty(_ref2, "border-" + props.bodyBorderVariant, Boolean(props.bodyBorderVariant)), 
                    defineProperty(_ref2, "text-" + props.bodyTextVariant, Boolean(props.bodyTextVariant)), 
                    _ref2), props.bodyClass || {} ]
                }), cardBodyChildren);
            }
        };
        var props$11 = assign({}, copyProps(cardMixin.props, prefixPropName.bind(null, "header")), {
            header: {
                type: String,
                default: null
            },
            headerClass: {
                type: [ String, Object, Array ],
                default: null
            }
        });
        var CardHeader = {
            functional: true,
            props: props$11,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                return h(props.headerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-header",
                    class: [ props.headerClass, (_ref2 = {}, defineProperty(_ref2, "bg-" + props.headerBgVariant, Boolean(props.headerBgVariant)), 
                    defineProperty(_ref2, "border-" + props.headerBorderVariant, Boolean(props.headerBorderVariant)), 
                    defineProperty(_ref2, "text-" + props.headerTextVariant, Boolean(props.headerTextVariant)), 
                    _ref2) ]
                }), children || [ h("div", {
                    domProps: {
                        innerHTML: props.header
                    }
                }) ]);
            }
        };
        var props$12 = assign({}, copyProps(cardMixin.props, prefixPropName.bind(null, "footer")), {
            footer: {
                type: String,
                default: null
            },
            footerClass: {
                type: [ String, Object, Array ],
                default: null
            }
        });
        var CardFooter = {
            functional: true,
            props: props$12,
            render: function render(h, _ref) {
                var _ref2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                return h(props.footerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card-footer",
                    class: [ props.footerClass, (_ref2 = {}, defineProperty(_ref2, "bg-" + props.footerBgVariant, Boolean(props.footerBgVariant)), 
                    defineProperty(_ref2, "border-" + props.footerBorderVariant, Boolean(props.footerBorderVariant)), 
                    defineProperty(_ref2, "text-" + props.footerTextVariant, Boolean(props.footerTextVariant)), 
                    _ref2) ]
                }), children || [ h("div", {
                    domProps: {
                        innerHTML: props.footer
                    }
                }) ]);
            }
        };
        var props$13 = {
            src: {
                type: String,
                default: null,
                required: true
            },
            alt: {
                type: String,
                default: null
            },
            top: {
                type: Boolean,
                default: false
            },
            bottom: {
                type: Boolean,
                default: false
            },
            fluid: {
                type: Boolean,
                default: false
            }
        };
        var CardImg = {
            functional: true,
            props: props$13,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var staticClass = "card-img";
                if (props.top) {
                    staticClass += "-top";
                } else if (props.bottom) {
                    staticClass += "-bottom";
                }
                return h("img", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: staticClass,
                    class: {
                        "img-fluid": props.fluid
                    },
                    attrs: {
                        src: props.src,
                        alt: props.alt
                    }
                }));
            }
        };
        var cardImgProps = copyProps(props$13, prefixPropName.bind(null, "img"));
        cardImgProps.imgSrc.required = false;
        var props$14 = assign({}, props$10, props$11, props$12, cardImgProps, copyProps(cardMixin.props), {
            align: {
                type: String,
                default: null
            },
            noBody: {
                type: Boolean,
                default: false
            }
        });
        var bCard = {
            functional: true,
            props: props$14,
            render: function render(h, _ref) {
                var _class;
                var props$$1 = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                var childNodes = [];
                var $slots = slots();
                var img = props$$1.imgSrc ? h(CardImg, {
                    props: pluckProps(cardImgProps, props$$1, unPrefixPropName.bind(null, "img"))
                }) : null;
                if (img) {
                    if (props$$1.imgTop || !props$$1.imgBottom) {
                        childNodes.push(img);
                    }
                }
                if (props$$1.header || $slots.header) {
                    childNodes.push(h(CardHeader, {
                        props: pluckProps(props$11, props$$1)
                    }, $slots.header));
                }
                if (props$$1.noBody) {
                    childNodes.push($slots.default);
                } else {
                    childNodes.push(h(CardBody, {
                        props: pluckProps(props$10, props$$1)
                    }, $slots.default));
                }
                if (props$$1.footer || $slots.footer) {
                    childNodes.push(h(CardFooter, {
                        props: pluckProps(props$12, props$$1)
                    }, $slots.footer));
                }
                if (img && props$$1.imgBottom) {
                    childNodes.push(img);
                }
                return h(props$$1.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "card",
                    class: (_class = {}, defineProperty(_class, "text-" + props$$1.align, Boolean(props$$1.align)), 
                    defineProperty(_class, "bg-" + props$$1.bgVariant, Boolean(props$$1.bgVariant)), 
                    defineProperty(_class, "border-" + props$$1.borderVariant, Boolean(props$$1.borderVariant)), 
                    defineProperty(_class, "text-" + props$$1.textVariant, Boolean(props$$1.textVariant)), 
                    _class)
                }), childNodes);
            }
        };
        var props$15 = {
            tag: {
                type: String,
                default: "div"
            },
            deck: {
                type: Boolean,
                default: false
            },
            columns: {
                type: Boolean,
                default: false
            }
        };
        var bCardGroup = {
            functional: true,
            props: props$15,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var staticClass = "card-group";
                if (props.columns) {
                    staticClass = "card-columns";
                }
                if (props.deck) {
                    staticClass = "card-deck";
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: staticClass
                }), children);
            }
        };
        var components$7 = {
            bCard: bCard,
            bCardHeader: CardHeader,
            bCardBody: CardBody,
            bCardFooter: CardFooter,
            bCardImg: CardImg,
            bCardGroup: bCardGroup
        };
        var VuePlugin$7 = {
            install: function install(Vue) {
                registerComponents(Vue, components$7);
            }
        };
        vueUse(VuePlugin$7);
        function observeDOM(el, callback, opts) {
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            var eventListenerSupported = window.addEventListener;
            el = el ? el.$el || el : null;
            if (!isElement(el)) {
                return null;
            }
            var obs = null;
            if (MutationObserver) {
                obs = new MutationObserver(function(mutations) {
                    var changed = false;
                    for (var i = 0; i < mutations.length && !changed; i++) {
                        var mutation = mutations[i];
                        var type = mutation.type;
                        var target = mutation.target;
                        if (type === "characterData" && target.nodeType === Node.TEXT_NODE) {
                            changed = true;
                        } else if (type === "attributes") {
                            changed = true;
                        } else if (type === "childList" && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
                            changed = true;
                        }
                    }
                    if (changed) {
                        callback();
                    }
                });
                obs.observe(el, assign({
                    childList: true,
                    subtree: true
                }, opts));
            } else if (eventListenerSupported) {
                el.addEventListener("DOMNodeInserted", callback, false);
                el.addEventListener("DOMNodeRemoved", callback, false);
            }
            return obs;
        }
        var idMixin = {
            props: {
                id: {
                    type: String,
                    default: null
                }
            },
            methods: {
                safeId: function safeId() {
                    var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    var id = this.id || this.localId_ || null;
                    if (!id) {
                        return null;
                    }
                    suffix = String(suffix).replace(/\s+/g, "_");
                    return suffix ? id + "_" + suffix : id;
                }
            },
            computed: {
                localId_: function localId_() {
                    if (!this.$isServer && !this.id && typeof this._uid !== "undefined") {
                        return "__BVID__" + this._uid;
                    }
                }
            }
        };
        var DIRECTION = {
            next: {
                dirClass: "carousel-item-left",
                overlayClass: "carousel-item-next"
            },
            prev: {
                dirClass: "carousel-item-right",
                overlayClass: "carousel-item-prev"
            }
        };
        var TRANS_DURATION = 600 + 50;
        var TransitionEndEvents = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "otransitionend oTransitionEnd",
            transition: "transitionend"
        };
        function getTransisionEndEvent(el) {
            for (var name in TransitionEndEvents) {
                if (el.style[name] !== undefined) {
                    return TransitionEndEvents[name];
                }
            }
            return null;
        }
        var bCarousel = {
            mixins: [ idMixin ],
            render: function render(h) {
                var _this = this;
                var inner = h("div", {
                    ref: "inner",
                    class: [ "carousel-inner" ],
                    attrs: {
                        id: this.safeId("__BV_inner_"),
                        role: "list"
                    }
                }, [ this.$slots.default ]);
                var controls = h(false);
                if (this.controls) {
                    controls = [ h("a", {
                        class: [ "carousel-control-prev" ],
                        attrs: {
                            href: "#",
                            role: "button",
                            "aria-controls": this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this.prev();
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === KeyCodes.SPACE || keyCode === KeyCodes.ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.prev();
                                }
                            }
                        }
                    }, [ h("span", {
                        class: [ "carousel-control-prev-icon" ],
                        attrs: {
                            "aria-hidden": "true"
                        }
                    }), h("span", {
                        class: [ "sr-only" ]
                    }, [ this.labelPrev ]) ]), h("a", {
                        class: [ "carousel-control-next" ],
                        attrs: {
                            href: "#",
                            role: "button",
                            "aria-controls": this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this.next();
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === KeyCodes.SPACE || keyCode === KeyCodes.ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.next();
                                }
                            }
                        }
                    }, [ h("span", {
                        class: [ "carousel-control-next-icon" ],
                        attrs: {
                            "aria-hidden": "true"
                        }
                    }), h("span", {
                        class: [ "sr-only" ]
                    }, [ this.labelNext ]) ]) ];
                }
                var indicators = h("ol", {
                    class: [ "carousel-indicators" ],
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: this.indicators,
                        expression: "indicators"
                    } ],
                    attrs: {
                        id: this.safeId("__BV_indicators_"),
                        "aria-hidden": this.indicators ? "false" : "true",
                        "aria-label": this.labelIndicators,
                        "aria-owns": this.safeId("__BV_inner_")
                    }
                }, this.slides.map(function(slide, n) {
                    return h("li", {
                        key: "slide_" + n,
                        class: {
                            active: n === _this.index
                        },
                        attrs: {
                            role: "button",
                            id: _this.safeId("__BV_indicator_" + (n + 1) + "_"),
                            tabindex: _this.indicators ? "0" : "-1",
                            "aria-current": n === _this.index ? "true" : "false",
                            "aria-label": _this.labelGotoSlide + " " + (n + 1),
                            "aria-describedby": _this.slides[n].id || null,
                            "aria-controls": _this.safeId("__BV_inner_")
                        },
                        on: {
                            click: function click(evt) {
                                _this.setSlide(n);
                            },
                            keydown: function keydown(evt) {
                                var keyCode = evt.keyCode;
                                if (keyCode === KeyCodes.SPACE || keyCode === KeyCodes.ENTER) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    _this.setSlide(n);
                                }
                            }
                        }
                    });
                }));
                return h("div", {
                    class: [ "carousel", "slide" ],
                    style: {
                        background: this.background
                    },
                    attrs: {
                        role: "region",
                        id: this.safeId(),
                        "aria-busy": this.isSliding ? "true" : "false"
                    },
                    on: {
                        mouseenter: this.pause,
                        mouseleave: this.restart,
                        focusin: this.pause,
                        focusout: this.restart,
                        keydown: function keydown(evt) {
                            var keyCode = evt.keyCode;
                            if (keyCode === KeyCodes.LEFT || keyCode === KeyCodes.RIGHT) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                _this[keyCode === KeyCodes.LEFT ? "prev" : "next"]();
                            }
                        }
                    }
                }, [ inner, controls, indicators ]);
            },
            data: function data() {
                return {
                    index: this.value || 0,
                    isSliding: false,
                    intervalId: null,
                    transitionEndEvent: null,
                    slides: [],
                    direction: null
                };
            },
            props: {
                labelPrev: {
                    type: String,
                    default: "Previous Slide"
                },
                labelNext: {
                    type: String,
                    default: "Next Slide"
                },
                labelGotoSlide: {
                    type: String,
                    default: "Goto Slide"
                },
                labelIndicators: {
                    type: String,
                    default: "Select a slide to display"
                },
                interval: {
                    type: Number,
                    default: 5e3
                },
                indicators: {
                    type: Boolean,
                    default: false
                },
                controls: {
                    type: Boolean,
                    default: false
                },
                imgWidth: {
                    type: [ Number, String ]
                },
                imgHeight: {
                    type: [ Number, String ]
                },
                background: {
                    type: String
                },
                value: {
                    type: Number,
                    default: 0
                }
            },
            computed: {
                isCycling: function isCycling() {
                    return Boolean(this.intervalId);
                }
            },
            methods: {
                setSlide: function setSlide(slide) {
                    var _this2 = this;
                    if (typeof document !== "undefined" && document.visibilityState && document.hidden) {
                        return;
                    }
                    var len = this.slides.length;
                    if (len === 0) {
                        return;
                    }
                    if (this.isSliding) {
                        this.$once("sliding-end", function() {
                            return _this2.setSlide(slide);
                        });
                        return;
                    }
                    slide = Math.floor(slide);
                    this.index = slide >= len ? 0 : slide >= 0 ? slide : len - 1;
                },
                prev: function prev() {
                    this.direction = "prev";
                    this.setSlide(this.index - 1);
                },
                next: function next() {
                    this.direction = "next";
                    this.setSlide(this.index + 1);
                },
                pause: function pause() {
                    if (this.isCycling) {
                        clearInterval(this.intervalId);
                        this.intervalId = null;
                        if (this.slides[this.index]) {
                            this.slides[this.index].tabIndex = 0;
                        }
                    }
                },
                start: function start() {
                    var _this3 = this;
                    if (!this.interval || this.isCycling) {
                        return;
                    }
                    this.slides.forEach(function(slide) {
                        slide.tabIndex = -1;
                    });
                    this.intervalId = setInterval(function() {
                        _this3.next();
                    }, Math.max(1e3, this.interval));
                },
                restart: function restart(evt) {
                    if (!this.$el.contains(document.activeElement)) {
                        this.start();
                    }
                },
                updateSlides: function updateSlides() {
                    this.pause();
                    this.slides = selectAll(".carousel-item", this.$refs.inner);
                    var numSlides = this.slides.length;
                    var index = Math.max(0, Math.min(Math.floor(this.index), numSlides - 1));
                    this.slides.forEach(function(slide, idx) {
                        var n = idx + 1;
                        if (idx === index) {
                            addClass(slide, "active");
                        } else {
                            removeClass(slide, "active");
                        }
                        setAttr(slide, "aria-current", idx === index ? "true" : "false");
                        setAttr(slide, "aria-posinset", String(n));
                        setAttr(slide, "aria-setsize", String(numSlides));
                        slide.tabIndex = -1;
                    });
                    this.setSlide(index);
                    this.start();
                },
                calcDirection: function calcDirection() {
                    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var curIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var nextIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    if (!direction) {
                        return nextIndex > curIndex ? DIRECTION.next : DIRECTION.prev;
                    }
                    return DIRECTION[direction];
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.setSlide(newVal);
                    }
                },
                interval: function interval(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    if (!newVal) {
                        this.pause();
                    } else {
                        this.pause();
                        this.start();
                    }
                },
                index: function index(val, oldVal) {
                    var _this4 = this;
                    if (val === oldVal || this.isSliding) {
                        return;
                    }
                    var direction = this.calcDirection(this.direction, oldVal, val);
                    var currentSlide = this.slides[oldVal];
                    var nextSlide = this.slides[val];
                    if (!currentSlide || !nextSlide) {
                        return;
                    }
                    this.isSliding = true;
                    this.$emit("sliding-start", val);
                    this.$emit("input", this.index);
                    nextSlide.classList.add(direction.overlayClass);
                    reflow(nextSlide);
                    addClass(currentSlide, direction.dirClass);
                    addClass(nextSlide, direction.dirClass);
                    var called = false;
                    var onceTransEnd = function onceTransEnd(evt) {
                        if (called) {
                            return;
                        }
                        called = true;
                        if (_this4.transitionEndEvent) {
                            var events = _this4.transitionEndEvent.split(/\s+/);
                            events.forEach(function(event) {
                                eventOff(currentSlide, event, onceTransEnd);
                            });
                        }
                        _this4._animationTimeout = null;
                        removeClass(nextSlide, direction.dirClass);
                        removeClass(nextSlide, direction.overlayClass);
                        addClass(nextSlide, "active");
                        removeClass(currentSlide, "active");
                        removeClass(currentSlide, direction.dirClass);
                        removeClass(currentSlide, direction.overlayClass);
                        setAttr(currentSlide, "aria-current", "false");
                        setAttr(nextSlide, "aria-current", "true");
                        setAttr(currentSlide, "aria-hidden", "true");
                        setAttr(nextSlide, "aria-hidden", "false");
                        currentSlide.tabIndex = -1;
                        nextSlide.tabIndex = -1;
                        if (!_this4.isCycling) {
                            nextSlide.tabIndex = 0;
                            _this4.$nextTick(function() {
                                nextSlide.focus();
                            });
                        }
                        _this4.isSliding = false;
                        _this4.direction = null;
                        _this4.$nextTick(function() {
                            return _this4.$emit("sliding-end", val);
                        });
                    };
                    if (this.transitionEndEvent) {
                        var events = this.transitionEndEvent.split(/\s+/);
                        events.forEach(function(event) {
                            eventOn(currentSlide, event, onceTransEnd);
                        });
                    }
                    this._animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
                }
            },
            created: function created() {
                this._animationTimeout = null;
            },
            mounted: function mounted() {
                this.transitionEndEvent = getTransisionEndEvent(this.$el) || null;
                this.updateSlides();
                observeDOM(this.$refs.inner, this.updateSlides.bind(this), {
                    subtree: false,
                    childList: true,
                    attributes: true,
                    attributeFilter: [ "id" ]
                });
            },
            beforeDestroy: function beforeDestroy() {
                clearInterval(this.intervalId);
                clearTimeout(this._animationTimeout);
                this.intervalId = null;
                this._animationTimeout = null;
            }
        };
        var BLANK_TEMPLATE = '<svg width="%{w}" height="%{h}" ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'viewBox="0 0 %{w} %{h}" preserveAspectRatio="none">' + '<rect width="100%" height="100%" style="fill:%{f};"></rect>' + "</svg>";
        function makeBlankImgSrc(width, height, color) {
            var src = encodeURIComponent(BLANK_TEMPLATE.replace("%{w}", String(width)).replace("%{h}", String(height)).replace("%{f}", color));
            return "data:image/svg+xml;charset=UTF-8," + src;
        }
        var props$16 = {
            src: {
                type: String,
                default: null
            },
            alt: {
                type: String,
                default: null
            },
            width: {
                type: [ Number, String ],
                default: null
            },
            height: {
                type: [ Number, String ],
                default: null
            },
            block: {
                type: Boolean,
                default: false
            },
            fluid: {
                type: Boolean,
                default: false
            },
            fluidGrow: {
                type: Boolean,
                default: false
            },
            rounded: {
                type: [ Boolean, String ],
                default: false
            },
            thumbnail: {
                type: Boolean,
                default: false
            },
            left: {
                type: Boolean,
                default: false
            },
            right: {
                type: Boolean,
                default: false
            },
            center: {
                type: Boolean,
                default: false
            },
            blank: {
                type: Boolean,
                default: false
            },
            blankColor: {
                type: String,
                default: "transparent"
            }
        };
        var bImg = {
            functional: true,
            props: props$16,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data;
                var src = props.src;
                var width = parseInt(props.width, 10) ? parseInt(props.width, 10) : null;
                var height = parseInt(props.height, 10) ? parseInt(props.height, 10) : null;
                var align = null;
                var block = props.block;
                if (props.blank) {
                    if (!height && Boolean(width)) {
                        height = width;
                    } else if (!width && Boolean(height)) {
                        width = height;
                    }
                    if (!width && !height) {
                        width = 1;
                        height = 1;
                    }
                    src = makeBlankImgSrc(width, height, props.blankColor || "transparent");
                }
                if (props.left) {
                    align = "float-left";
                } else if (props.right) {
                    align = "float-right";
                } else if (props.center) {
                    align = "mx-auto";
                    block = true;
                }
                return h("img", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    attrs: {
                        src: src,
                        alt: props.alt,
                        width: width ? String(width) : null,
                        height: height ? String(height) : null
                    },
                    class: (_class = {
                        "img-thumbnail": props.thumbnail,
                        "img-fluid": props.fluid || props.fluidGrow,
                        "w-100": props.fluidGrow,
                        rounded: props.rounded === "" || props.rounded === true
                    }, defineProperty(_class, "rounded-" + props.rounded, typeof props.rounded === "string" && props.rounded !== ""), 
                    defineProperty(_class, align, Boolean(align)), defineProperty(_class, "d-block", block), 
                    _class)
                }));
            }
        };
        function warn(message) {
            console.warn("[Bootstrap-Vue warn]: " + message);
        }
        var bCarouselSlide = {
            components: {
                bImg: bImg
            },
            mixins: [ idMixin ],
            render: function render(h) {
                var $slots = this.$slots;
                var img = $slots.img;
                if (!img && (this.imgSrc || this.imgBlank)) {
                    img = h("b-img", {
                        props: {
                            fluidGrow: true,
                            block: true,
                            src: this.imgSrc,
                            blank: this.imgBlank,
                            blankColor: this.imgBlankColor,
                            width: this.computedWidth,
                            height: this.computedHeight,
                            alt: this.imgAlt
                        }
                    });
                }
                var content = h(this.contentTag, {
                    class: this.contentClasses
                }, [ this.caption ? h(this.captionTag, {
                    domProps: {
                        innerHTML: this.caption
                    }
                }) : h(false), this.text ? h(this.textTag, {
                    domProps: {
                        innerHTML: this.text
                    }
                }) : h(false), $slots.default ]);
                return h("div", {
                    class: [ "carousel-item" ],
                    style: {
                        background: this.background
                    },
                    attrs: {
                        id: this.safeId(),
                        role: "listitem"
                    }
                }, [ img, content ]);
            },
            props: {
                imgSrc: {
                    type: String,
                    default: function _default() {
                        if (this && this.src) {
                            warn("b-carousel-slide: prop 'src' has been deprecated. Use 'img-src' instead");
                            return this.src;
                        }
                        return null;
                    }
                },
                src: {
                    type: String
                },
                imgAlt: {
                    type: String
                },
                imgWidth: {
                    type: [ Number, String ]
                },
                imgHeight: {
                    type: [ Number, String ]
                },
                imgBlank: {
                    type: Boolean,
                    default: false
                },
                imgBlankColor: {
                    type: String,
                    default: "transparent"
                },
                contentVisibleUp: {
                    type: String
                },
                contentTag: {
                    type: String,
                    default: "div"
                },
                caption: {
                    type: String
                },
                captionTag: {
                    type: String,
                    default: "h3"
                },
                text: {
                    type: String
                },
                textTag: {
                    type: String,
                    default: "p"
                },
                background: {
                    type: String
                }
            },
            computed: {
                contentClasses: function contentClasses() {
                    return [ "carousel-caption", this.contentVisibleUp ? "d-none" : "", this.contentVisibleUp ? "d-" + this.contentVisibleUp + "-block" : "" ];
                },
                computedWidth: function computedWidth() {
                    return this.imgWidth || this.$parent.imgWidth;
                },
                computedHeight: function computedHeight() {
                    return this.imgHeight || this.$parent.imgHeight;
                }
            }
        };
        var components$8 = {
            bCarousel: bCarousel,
            bCarouselSlide: bCarouselSlide
        };
        var VuePlugin$8 = {
            install: function install(Vue) {
                registerComponents(Vue, components$8);
            }
        };
        vueUse(VuePlugin$8);
        var props$17 = {
            tag: {
                type: String,
                default: "div"
            },
            fluid: {
                type: Boolean,
                default: false
            }
        };
        var Container = {
            functional: true,
            props: props$17,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        container: !props.fluid,
                        "container-fluid": props.fluid
                    }
                }), children);
            }
        };
        var COMMON_ALIGNMENT = [ "start", "end", "center" ];
        var props$18 = {
            tag: {
                type: String,
                default: "div"
            },
            noGutters: {
                type: Boolean,
                default: false
            },
            alignV: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return arrayIncludes(COMMON_ALIGNMENT.concat([ "baseline", "stretch" ]), str);
                }
            },
            alignH: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return arrayIncludes(COMMON_ALIGNMENT.concat([ "between", "around" ]), str);
                }
            },
            alignContent: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return arrayIncludes(COMMON_ALIGNMENT.concat([ "between", "around", "stretch" ]), str);
                }
            }
        };
        var bRow = {
            functional: true,
            props: props$18,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "row",
                    class: (_class = {
                        "no-gutters": props.noGutters
                    }, defineProperty(_class, "align-items-" + props.alignV, props.alignV), defineProperty(_class, "justify-content-" + props.alignH, props.alignH), 
                    defineProperty(_class, "align-content-" + props.alignContent, props.alignContent), 
                    _class)
                }), children);
            }
        };
        function memoize(fn) {
            var cache = create(null);
            return function memoizedFn() {
                var args = JSON.stringify(arguments);
                return cache[args] = cache[args] || fn.apply(null, arguments);
            };
        }
        function suffixPropName(suffix, str) {
            return str + (suffix ? upperFirst(suffix) : "");
        }
        function boolStrNum() {
            return {
                type: [ Boolean, String, Number ],
                default: false
            };
        }
        function strNum() {
            return {
                type: [ String, Number ],
                default: null
            };
        }
        var computeBkPtClass = memoize(function computeBkPt(type, breakpoint, val) {
            var className = type;
            if (val === false || val === null || val === undefined) {
                return undefined;
            }
            if (breakpoint) {
                className += "-" + breakpoint;
            }
            if (type === "col" && (val === "" || val === true)) {
                return className.toLowerCase();
            }
            className += "-" + val;
            return className.toLowerCase();
        });
        var BREAKPOINTS = [ "sm", "md", "lg", "xl" ];
        var breakpointCol = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[breakpoint] = boolStrNum(), propMap;
        }, create(null));
        var breakpointOffset = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[suffixPropName(breakpoint, "offset")] = strNum(), propMap;
        }, create(null));
        var breakpointOrder = BREAKPOINTS.reduce(function(propMap, breakpoint) {
            return propMap[suffixPropName(breakpoint, "order")] = strNum(), propMap;
        }, create(null));
        var breakpointPropMap = assign(create(null), {
            col: keys(breakpointCol),
            offset: keys(breakpointOffset),
            order: keys(breakpointOrder)
        });
        var props$19 = assign({}, breakpointCol, breakpointOffset, breakpointOrder, {
            tag: {
                type: String,
                default: "div"
            },
            col: {
                type: Boolean,
                default: false
            },
            cols: strNum(),
            offset: strNum(),
            order: strNum(),
            alignSelf: {
                type: String,
                default: null,
                validator: function validator(str) {
                    return arrayIncludes([ "auto", "start", "end", "center", "baseline", "stretch" ], str);
                }
            }
        });
        var bCol = {
            functional: true,
            props: props$19,
            render: function render(h, _ref) {
                var _classList$push;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var classList = [];
                for (var type in breakpointPropMap) {
                    var _keys = breakpointPropMap[type];
                    for (var i = 0; i < _keys.length; i++) {
                        var c = computeBkPtClass(type, _keys[i].replace(type, ""), props[_keys[i]]);
                        if (c) {
                            classList.push(c);
                        }
                    }
                }
                classList.push((_classList$push = {
                    col: props.col || classList.length === 0 && !props.cols
                }, defineProperty(_classList$push, "col-" + props.cols, props.cols), defineProperty(_classList$push, "offset-" + props.offset, props.offset), 
                defineProperty(_classList$push, "order-" + props.order, props.order), defineProperty(_classList$push, "align-self-" + props.alignSelf, props.alignSelf), 
                _classList$push));
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: classList
                }), children);
            }
        };
        var props$20 = {
            tag: {
                type: String,
                default: "div"
            }
        };
        var bFormRow = {
            functional: true,
            props: props$20,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "form-row"
                }), children);
            }
        };
        var components$9 = {
            bContainer: Container,
            bRow: bRow,
            bCol: bCol,
            bFormRow: bFormRow
        };
        var VuePlugin$9 = {
            install: function install(Vue) {
                registerComponents(Vue, components$9);
            }
        };
        vueUse(VuePlugin$9);
        var BVRL = "__BV_root_listeners__";
        var listenOnRootMixin = {
            methods: {
                listenOnRoot: function listenOnRoot(event, callback) {
                    if (!this[BVRL] || !isArray(this[BVRL])) {
                        this[BVRL] = [];
                    }
                    this[BVRL].push({
                        event: event,
                        callback: callback
                    });
                    this.$root.$on(event, callback);
                    return this;
                },
                emitOnRoot: function emitOnRoot(event) {
                    var _$root;
                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }
                    (_$root = this.$root).$emit.apply(_$root, [ event ].concat(toConsumableArray(args)));
                    return this;
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (this[BVRL] && isArray(this[BVRL])) {
                    while (this[BVRL].length > 0) {
                        var _BVRL$shift = this[BVRL].shift(), event = _BVRL$shift.event, callback = _BVRL$shift.callback;
                        this.$root.$off(event, callback);
                    }
                }
            }
        };
        var EVENT_STATE = "bv::collapse::state";
        var EVENT_ACCORDION = "bv::collapse::accordion";
        var EVENT_TOGGLE = "bv::toggle::collapse";
        var bCollapse = {
            mixins: [ listenOnRootMixin ],
            render: function render(h) {
                var content = h(this.tag, {
                    class: this.classObject,
                    directives: [ {
                        name: "show",
                        value: this.show
                    } ],
                    attrs: {
                        id: this.id || null
                    },
                    on: {
                        click: this.clickHandler
                    }
                }, [ this.$slots.default ]);
                return h("transition", {
                    props: {
                        enterClass: "",
                        enterActiveClass: "collapsing",
                        enterToClass: "",
                        leaveClass: "",
                        leaveActiveClass: "collapsing",
                        leaveToClass: ""
                    },
                    on: {
                        enter: this.onEnter,
                        afterEnter: this.onAfterEnter,
                        leave: this.onLeave,
                        afterLeave: this.onAfterLeave
                    }
                }, [ content ]);
            },
            data: function data() {
                return {
                    show: this.visible,
                    transitioning: false
                };
            },
            model: {
                prop: "visible",
                event: "input"
            },
            props: {
                id: {
                    type: String,
                    required: true
                },
                isNav: {
                    type: Boolean,
                    default: false
                },
                accordion: {
                    type: String,
                    default: null
                },
                visible: {
                    type: Boolean,
                    default: false
                },
                tag: {
                    type: String,
                    default: "div"
                }
            },
            watch: {
                visible: function visible(newVal) {
                    if (newVal !== this.show) {
                        this.show = newVal;
                    }
                },
                show: function show(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.emitState();
                    }
                }
            },
            computed: {
                classObject: function classObject() {
                    return {
                        "navbar-collapse": this.isNav,
                        collapse: !this.transitioning,
                        show: this.show && !this.transitioning
                    };
                }
            },
            methods: {
                toggle: function toggle() {
                    this.show = !this.show;
                },
                onEnter: function onEnter(el) {
                    el.style.height = 0;
                    reflow(el);
                    el.style.height = el.scrollHeight + "px";
                    this.transitioning = true;
                    this.$emit("show");
                },
                onAfterEnter: function onAfterEnter(el) {
                    el.style.height = null;
                    this.transitioning = false;
                    this.$emit("shown");
                },
                onLeave: function onLeave(el) {
                    el.style.height = "auto";
                    el.style.display = "block";
                    el.style.height = el.getBoundingClientRect().height + "px";
                    reflow(el);
                    this.transitioning = true;
                    el.style.height = 0;
                    this.$emit("hide");
                },
                onAfterLeave: function onAfterLeave(el) {
                    el.style.height = null;
                    this.transitioning = false;
                    this.$emit("hidden");
                },
                emitState: function emitState() {
                    this.$emit("input", this.show);
                    this.$root.$emit(EVENT_STATE, this.id, this.show);
                    if (this.accordion && this.show) {
                        this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
                    }
                },
                clickHandler: function clickHandler(evt) {
                    var el = evt.target;
                    if (!this.isNav || !el || getComputedStyle(this.$el).display !== "block") {
                        return;
                    }
                    if (hasClass(el, "nav-link") || hasClass(el, "dropdown-item")) {
                        this.show = false;
                    }
                },
                handleToggleEvt: function handleToggleEvt(target) {
                    if (target !== this.id) {
                        return;
                    }
                    this.toggle();
                },
                handleAccordionEvt: function handleAccordionEvt(openedId, accordion) {
                    if (!this.accordion || accordion !== this.accordion) {
                        return;
                    }
                    if (openedId === this.id) {
                        if (!this.show) {
                            this.toggle();
                        }
                    } else {
                        if (this.show) {
                            this.toggle();
                        }
                    }
                },
                handleResize: function handleResize() {
                    this.show = getComputedStyle(this.$el).display === "block";
                }
            },
            created: function created() {
                this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);
                this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
            },
            mounted: function mounted() {
                if (this.isNav && typeof document !== "undefined") {
                    window.addEventListener("resize", this.handleResize, false);
                    window.addEventListener("orientationchange", this.handleResize, false);
                    this.handleResize();
                }
                this.emitState();
            },
            beforeDestroy: function beforeDestroy() {
                if (this.isNav && typeof document !== "undefined") {
                    window.removeEventListener("resize", this.handleResize, false);
                    window.removeEventListener("orientationchange", this.handleResize, false);
                }
            }
        };
        var allListenTypes = {
            hover: true,
            click: true,
            focus: true
        };
        var BVBoundListeners = "__BV_boundEventListeners__";
        var bindTargets = function bindTargets(vnode, binding, listenTypes, fn) {
            var targets = keys(binding.modifiers || {}).filter(function(t) {
                return !allListenTypes[t];
            });
            if (binding.value) {
                targets.push(binding.value);
            }
            var listener = function listener() {
                fn({
                    targets: targets,
                    vnode: vnode
                });
            };
            keys(allListenTypes).forEach(function(type) {
                if (listenTypes[type] || binding.modifiers[type]) {
                    vnode.elm.addEventListener(type, listener);
                    var boundListeners = vnode.elm[BVBoundListeners] || {};
                    boundListeners[type] = boundListeners[type] || [];
                    boundListeners[type].push(listener);
                    vnode.elm[BVBoundListeners] = boundListeners;
                }
            });
            return targets;
        };
        var unbindTargets = function unbindTargets(vnode, binding, listenTypes) {
            keys(allListenTypes).forEach(function(type) {
                if (listenTypes[type] || binding.modifiers[type]) {
                    var boundListeners = vnode.elm[BVBoundListeners] && vnode.elm[BVBoundListeners][type];
                    if (boundListeners) {
                        boundListeners.forEach(function(listener) {
                            return vnode.elm.removeEventListener(type, listener);
                        });
                        delete vnode.elm[BVBoundListeners][type];
                    }
                }
            });
        };
        var inBrowser = typeof window !== "undefined";
        var listenTypes = {
            click: true
        };
        var BVT = "__BV_toggle__";
        var EVENT_TOGGLE$1 = "bv::toggle::collapse";
        var EVENT_STATE$1 = "bv::collapse::state";
        var bToggle = {
            bind: function bind(el, binding, vnode) {
                var targets = bindTargets(vnode, binding, listenTypes, function(_ref) {
                    var targets = _ref.targets, vnode = _ref.vnode;
                    targets.forEach(function(target) {
                        vnode.context.$root.$emit(EVENT_TOGGLE$1, target);
                    });
                });
                if (inBrowser && vnode.context && targets.length > 0) {
                    setAttr(el, "aria-controls", targets.join(" "));
                    setAttr(el, "aria-expanded", "false");
                    if (el.tagName !== "BUTTON") {
                        setAttr(el, "role", "button");
                    }
                    el[BVT] = function toggleDirectiveHandler(id, state) {
                        if (targets.indexOf(id) !== -1) {
                            setAttr(el, "aria-expanded", state ? "true" : "false");
                            if (state) {
                                removeClass(el, "collapsed");
                            } else {
                                addClass(el, "collapsed");
                            }
                        }
                    };
                    vnode.context.$root.$on(EVENT_STATE$1, el[BVT]);
                }
            },
            unbind: function unbind(el, binding, vnode) {
                if (el[BVT]) {
                    vnode.context.$root.$off(EVENT_STATE$1, el[BVT]);
                    el[BVT] = null;
                }
            }
        };
        var directives = {
            bToggle: bToggle
        };
        var VuePlugin$10 = {
            install: function install(Vue) {
                registerDirectives(Vue, directives);
            }
        };
        vueUse(VuePlugin$10);
        var components$10 = {
            bCollapse: bCollapse
        };
        var VuePlugin$11 = {
            install: function install(Vue) {
                registerComponents(Vue, components$10);
                Vue.use(VuePlugin$10);
            }
        };
        vueUse(VuePlugin$11);
        var clickoutMixin = {
            mounted: function mounted() {
                if (typeof document !== "undefined") {
                    document.documentElement.addEventListener("click", this._clickOutListener);
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (typeof document !== "undefined") {
                    document.documentElement.removeEventListener("click", this._clickOutListener);
                }
            },
            methods: {
                _clickOutListener: function _clickOutListener(e) {
                    if (!this.$el.contains(e.target)) {
                        if (this.clickOutListener) {
                            this.clickOutListener();
                        }
                    }
                }
            }
        };
        function filterVisible(els) {
            return (els || []).filter(isVisible);
        }
        var ITEM_SELECTOR$1 = ".dropdown-item:not(.disabled):not([disabled])";
        var AttachmentMap = {
            TOP: "top-start",
            TOPEND: "top-end",
            BOTTOM: "bottom-start",
            BOTTOMEND: "bottom-end"
        };
        var dropdownMixin = {
            mixins: [ clickoutMixin, listenOnRootMixin ],
            props: {
                disabled: {
                    type: Boolean,
                    default: false
                },
                text: {
                    type: String,
                    default: ""
                },
                dropup: {
                    type: Boolean,
                    default: false
                },
                right: {
                    type: Boolean,
                    default: false
                },
                offset: {
                    type: [ Number, String ],
                    default: 0
                },
                noFlip: {
                    type: Boolean,
                    default: false
                },
                popperOpts: {
                    type: Object,
                    default: function _default() {}
                }
            },
            data: function data() {
                return {
                    visible: false,
                    inNavbar: null
                };
            },
            created: function created() {
                this._popper = null;
            },
            mounted: function mounted() {
                this.listenOnRoot("bv::dropdown::shown", this.rootCloseListener);
                this.listenOnRoot("clicked::link", this.rootCloseListener);
                this.listenOnRoot("bv::link::clicked", this.rootCloseListener);
            },
            deactivated: function deactivated() {
                this.visible = false;
                this.setTouchStart(false);
                this.removePopper();
            },
            beforeDestroy: function beforeDestroy() {
                this.visible = false;
                this.setTouchStart(false);
                this.removePopper();
            },
            watch: {
                visible: function visible(state, old) {
                    if (state === old) {
                        return;
                    }
                    if (state) {
                        this.showMenu();
                    } else {
                        this.hideMenu();
                    }
                },
                disabled: function disabled(state, old) {
                    if (state !== old && state && this.visible) {
                        this.visible = false;
                    }
                }
            },
            computed: {
                toggler: function toggler() {
                    return this.$refs.toggle.$el || this.$refs.toggle;
                }
            },
            methods: {
                showMenu: function showMenu() {
                    if (this.disabled) {
                        return;
                    }
                    this.$emit("show");
                    this.emitOnRoot("bv::dropdown::shown", this);
                    if (this.inNavbar === null && this.isNav) {
                        this.inNavbar = Boolean(closest(".navbar", this.$el));
                    }
                    if (!this.inNavbar) {
                        if (typeof __WEBPACK_IMPORTED_MODULE_1_popper_js__["a"] === "undefined") {
                            warn("b-dropdown: Popper.js not found. Falling back to CSS positioning.");
                        } else {
                            var element = this.dropup && this.right || this.split ? this.$el : this.$refs.toggle;
                            element = element.$el || element;
                            this.createPopper(element);
                        }
                    }
                    this.setTouchStart(true);
                    this.$emit("shown");
                    this.$nextTick(this.focusFirstItem);
                },
                hideMenu: function hideMenu() {
                    this.$emit("hide");
                    this.setTouchStart(false);
                    this.emitOnRoot("bv::dropdown::hidden", this);
                    this.$emit("hidden");
                    this.removePopper();
                },
                createPopper: function createPopper(element) {
                    this.removePopper();
                    this._popper = new __WEBPACK_IMPORTED_MODULE_1_popper_js__["a"](element, this.$refs.menu, this.getPopperConfig());
                },
                removePopper: function removePopper() {
                    if (this._popper) {
                        this._popper.destroy();
                    }
                    this._popper = null;
                },
                getPopperConfig: function getPopperConfig() {
                    var placement = AttachmentMap.BOTTOM;
                    if (this.dropup && this.right) {
                        placement = AttachmentMap.TOPEND;
                    } else if (this.dropup) {
                        placement = AttachmentMap.TOP;
                    } else if (this.right) {
                        placement = AttachmentMap.BOTTOMEND;
                    }
                    var popperConfig = {
                        placement: placement,
                        modifiers: {
                            offset: {
                                offset: this.offset || 0
                            },
                            flip: {
                                enabled: !this.noFlip
                            }
                        }
                    };
                    if (this.boundary) {
                        popperConfig.modifiers.preventOverflow = {
                            boundariesElement: this.boundary
                        };
                    }
                    return assign(popperConfig, this.popperOpts || {});
                },
                setTouchStart: function setTouchStart(on) {
                    var _this = this;
                    if ("ontouchstart" in document.documentElement) {
                        var children = from(document.body.children);
                        children.forEach(function(el) {
                            if (on) {
                                eventOn("mouseover", _this._noop);
                            } else {
                                eventOff("mouseover", _this._noop);
                            }
                        });
                    }
                },
                _noop: function _noop() {},
                rootCloseListener: function rootCloseListener(vm) {
                    if (vm !== this) {
                        this.visible = false;
                    }
                },
                clickOutListener: function clickOutListener() {
                    this.visible = false;
                },
                show: function show() {
                    if (this.disabled) {
                        return;
                    }
                    this.visible = true;
                },
                hide: function hide() {
                    if (this.disabled) {
                        return;
                    }
                    this.visible = false;
                },
                toggle: function toggle(evt) {
                    evt = evt || {};
                    var type = evt.type;
                    var key = evt.keyCode;
                    if (type !== "click" && !(type === "keydown" && (key === KeyCodes.ENTER || key === KeyCodes.SPACE || key === KeyCodes.DOWN))) {
                        return;
                    }
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.disabled) {
                        this.visible = false;
                        return;
                    }
                    this.visible = !this.visible;
                },
                click: function click(evt) {
                    if (this.disabled) {
                        this.visible = false;
                        return;
                    }
                    this.$emit("click", evt);
                },
                onKeydown: function onKeydown(evt) {
                    var key = evt.keyCode;
                    if (key === KeyCodes.ESC) {
                        this.onEsc(evt);
                    } else if (key === KeyCodes.TAB) {
                        this.onTab(evt);
                    } else if (key === KeyCodes.DOWN) {
                        this.focusNext(evt, false);
                    } else if (key === KeyCodes.UP) {
                        this.focusNext(evt, true);
                    }
                },
                onEsc: function onEsc(evt) {
                    if (this.visible) {
                        this.visible = false;
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.$nextTick(this.focusToggler);
                    }
                },
                onTab: function onTab(evt) {
                    if (this.visible) {
                        this.visible = false;
                    }
                },
                onFocusOut: function onFocusOut(evt) {
                    if (this.$refs.menu.contains(evt.relatedTarget)) {
                        return;
                    }
                    this.visible = false;
                },
                onMouseOver: function onMouseOver(evt) {
                    var item = evt.target;
                    if (item.classList.contains("dropdown-item") && !item.disabled && !item.classList.contains("disabled") && item.focus) {
                        item.focus();
                    }
                },
                focusNext: function focusNext(evt, up) {
                    var _this2 = this;
                    if (!this.visible) {
                        return;
                    }
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.$nextTick(function() {
                        var items = _this2.getItems();
                        if (items.length < 1) {
                            return;
                        }
                        var index = items.indexOf(evt.target);
                        if (up && index > 0) {
                            index--;
                        } else if (!up && index < items.length - 1) {
                            index++;
                        }
                        if (index < 0) {
                            index = 0;
                        }
                        _this2.focusItem(index, items);
                    });
                },
                focusItem: function focusItem(idx, items) {
                    var el = items.find(function(el, i) {
                        return i === idx;
                    });
                    if (el && getAttr(el, "tabindex") !== "-1") {
                        el.focus();
                    }
                },
                getItems: function getItems() {
                    return filterVisible(selectAll(ITEM_SELECTOR$1, this.$refs.menu));
                },
                getFirstItem: function getFirstItem() {
                    var item = this.getItems()[0];
                    return item || null;
                },
                focusFirstItem: function focusFirstItem() {
                    var item = this.getFirstItem();
                    if (item) {
                        this.focusItem(0, [ item ]);
                    }
                },
                focusToggler: function focusToggler() {
                    var toggler = this.toggler;
                    if (toggler && toggler.focus) {
                        toggler.focus();
                    }
                }
            }
        };
        var bDropdown = {
            mixins: [ idMixin, dropdownMixin ],
            components: {
                bButton: bBtn
            },
            render: function render(h) {
                var split = h(false);
                if (this.split) {
                    split = h("b-button", {
                        ref: "button",
                        props: {
                            disabled: this.disabled,
                            variant: this.variant,
                            size: this.size
                        },
                        attrs: {
                            id: this.safeId("_BV_button_")
                        },
                        on: {
                            click: this.click
                        }
                    }, [ this.$slots["button-content"] || this.$slots.text || this.text ]);
                }
                var toggle = h("b-button", {
                    ref: "toggle",
                    class: this.toggleClasses,
                    props: {
                        variant: this.variant,
                        size: this.size,
                        disabled: this.disabled
                    },
                    attrs: {
                        id: this.safeId("_BV_toggle_"),
                        "aria-haspopup": "true",
                        "aria-expanded": this.visible ? "true" : "false"
                    },
                    on: {
                        click: this.toggle,
                        keydown: this.toggle
                    }
                }, [ this.split ? h("span", {
                    class: [ "sr-only" ]
                }, [ this.toggleText ]) : this.$slots["button-content"] || this.$slots.text || this.text ]);
                var menu = h("div", {
                    ref: "menu",
                    class: this.menuClasses,
                    attrs: {
                        role: this.role,
                        "aria-labelledby": this.safeId(this.split ? "_BV_toggle_" : "_BV_button_")
                    },
                    on: {
                        mouseover: this.onMouseOver,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
                return h("div", {
                    attrs: {
                        id: this.safeId()
                    },
                    class: this.dropdownClasses
                }, [ split, toggle, menu ]);
            },
            props: {
                split: {
                    type: Boolean,
                    default: false
                },
                toggleText: {
                    type: String,
                    default: "Toggle Dropdown"
                },
                size: {
                    type: String,
                    default: null
                },
                variant: {
                    type: String,
                    default: null
                },
                menuClass: {
                    type: [ String, Array ],
                    default: null
                },
                toggleClass: {
                    type: [ String, Array ],
                    default: null
                },
                noCaret: {
                    type: Boolean,
                    default: false
                },
                role: {
                    type: String,
                    default: "menu"
                },
                boundary: {
                    type: [ String, Object ],
                    default: "scrollParent"
                }
            },
            computed: {
                dropdownClasses: function dropdownClasses() {
                    var position = "";
                    if (this.boundary !== "scrollParent" || !this.boundary) {
                        position = "position-static";
                    }
                    return [ "btn-group", "b-dropdown", "dropdown", this.dropup ? "dropup" : "", this.visible ? "show" : "", position ];
                },
                menuClasses: function menuClasses() {
                    return [ "dropdown-menu", {
                        "dropdown-menu-right": this.right,
                        show: this.visible
                    }, this.menuClass ];
                },
                toggleClasses: function toggleClasses() {
                    return [ {
                        "dropdown-toggle": !this.noCaret || this.split,
                        "dropdown-toggle-split": this.split
                    }, this.toggleClass ];
                }
            }
        };
        var props$21 = propsFactory();
        var bDropdownItem = {
            functional: true,
            props: props$21,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(bLink, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    props: props,
                    staticClass: "dropdown-item",
                    attrs: {
                        role: "menuitem"
                    }
                }), children);
            }
        };
        var props$22 = {
            disabled: {
                type: Boolean,
                default: false
            }
        };
        var bDropdownItemButton = {
            functional: true,
            props: props$22,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, parent = _ref.parent, children = _ref.children;
                return h("button", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    props: props,
                    staticClass: "dropdown-item",
                    attrs: {
                        role: "menuitem",
                        type: "button",
                        disabled: props.disabled
                    },
                    on: {
                        click: function click(e) {
                            parent.$root.$emit("clicked::link", e);
                        }
                    }
                }), children);
            }
        };
        var props$23 = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "h6"
            }
        };
        var bDropdownHeader = {
            functional: true,
            props: props$23,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "dropdown-header",
                    attrs: {
                        id: props.id || null
                    }
                }), children);
            }
        };
        var props$24 = {
            tag: {
                type: String,
                default: "div"
            }
        };
        var bDropdownDivider = {
            functional: true,
            props: props$24,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "dropdown-divider",
                    attrs: {
                        role: "separator"
                    }
                }));
            }
        };
        var components$11 = {
            bDropdown: bDropdown,
            bDd: bDropdown,
            bDropdownItem: bDropdownItem,
            bDdItem: bDropdownItem,
            bDropdownItemButton: bDropdownItemButton,
            bDropdownItemBtn: bDropdownItemButton,
            bDdItemButton: bDropdownItemButton,
            bDdItemBtn: bDropdownItemButton,
            bDropdownHeader: bDropdownHeader,
            bDdHeader: bDropdownHeader,
            bDropdownDivider: bDropdownDivider,
            bDdDivider: bDropdownDivider
        };
        var VuePlugin$12 = {
            install: function install(Vue) {
                registerComponents(Vue, components$11);
            }
        };
        vueUse(VuePlugin$12);
        var props$25 = {
            type: {
                type: String,
                default: "iframe",
                validator: function validator(str) {
                    return arrayIncludes([ "iframe", "embed", "video", "object", "img", "b-img", "b-img-lazy" ], str);
                }
            },
            tag: {
                type: String,
                default: "div"
            },
            aspect: {
                type: String,
                default: "16by9"
            }
        };
        var bEmbed = {
            functional: true,
            props: props$25,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, {
                    ref: data.ref,
                    staticClass: "embed-responsive",
                    class: defineProperty({}, "embed-responsive-" + props.aspect, Boolean(props.aspect))
                }, [ h(props.type, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    ref: "",
                    staticClass: "embed-responsive-item"
                }), children) ]);
            }
        };
        var components$12 = {
            bEmbed: bEmbed
        };
        var VuePlugin$13 = {
            install: function install(Vue) {
                registerComponents(Vue, components$12);
            }
        };
        vueUse(VuePlugin$13);
        var props$26 = {
            id: {
                type: String,
                default: null
            },
            inline: {
                type: Boolean,
                default: false
            },
            novalidate: {
                type: Boolean,
                default: false
            },
            validated: {
                type: Boolean,
                default: false
            }
        };
        var Form = {
            functional: true,
            props: props$26,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h("form", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        "form-inline": props.inline,
                        "was-validated": props.validated
                    },
                    attrs: {
                        id: props.id,
                        novalidate: props.novalidate
                    }
                }), children);
            }
        };
        var props$27 = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "small"
            },
            textVariant: {
                type: String,
                default: "muted"
            },
            inline: {
                type: Boolean,
                default: false
            }
        };
        var bFormText = {
            functional: true,
            props: props$27,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: defineProperty({
                        "form-text": !props.inline
                    }, "text-" + props.textVariant, Boolean(props.textVariant)),
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
        var props$28 = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            },
            forceShow: {
                type: Boolean,
                default: false
            }
        };
        var bFormInvalidFeedback = {
            functional: true,
            props: props$28,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "invalid-feedback",
                    class: {
                        "d-block": props.forceShow
                    },
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
        var props$29 = {
            id: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: "div"
            },
            forceShow: {
                type: Boolean,
                default: false
            }
        };
        var bFormValidFeedback = {
            functional: true,
            props: props$29,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "valid-feedback",
                    class: {
                        "d-block": props.forceShow
                    },
                    attrs: {
                        id: props.id
                    }
                }), children);
            }
        };
        var components$13 = {
            bForm: Form,
            bFormRow: bFormRow,
            bFormText: bFormText,
            bFormInvalidFeedback: bFormInvalidFeedback,
            bFormFeedback: bFormInvalidFeedback,
            bFormValidFeedback: bFormValidFeedback
        };
        var VuePlugin$14 = {
            install: function install(Vue) {
                registerComponents(Vue, components$13);
            }
        };
        vueUse(VuePlugin$14);
        var formStateMixin = {
            props: {
                state: {
                    type: [ Boolean, String ],
                    default: null
                }
            },
            computed: {
                computedState: function computedState() {
                    var state = this.state;
                    if (state === true || state === "valid") {
                        return true;
                    } else if (state === false || state === "invalid") {
                        return false;
                    }
                    return null;
                },
                stateClass: function stateClass() {
                    var state = this.computedState;
                    if (state === true) {
                        return "is-valid";
                    } else if (state === false) {
                        return "is-invalid";
                    }
                    return null;
                }
            }
        };
        var SELECTOR = "input:not(:disabled),textarea:not(:disabled),select:not(:disabled)";
        var bFormGroup = {
            mixins: [ idMixin, formStateMixin ],
            components: {
                bFormRow: bFormRow,
                bFormText: bFormText,
                bFormInvalidFeedback: bFormInvalidFeedback,
                bFormValidFeedback: bFormValidFeedback
            },
            render: function render(h) {
                var $slots = this.$slots;
                var legend = h(false);
                if (this.hasLabel) {
                    var children = $slots["label"];
                    var legendTag = this.labelFor ? "label" : "legend";
                    var legendDomProps = children ? {} : {
                        innerHTML: this.label
                    };
                    var legendAttrs = {
                        id: this.labelId,
                        for: this.labelFor || null
                    };
                    var legendClick = this.labelFor || this.labelSrOnly ? {} : {
                        click: this.legendClick
                    };
                    if (this.horizontal) {
                        if (this.labelSrOnly) {
                            children = h(legendTag, {
                                class: [ "sr-only" ],
                                attrs: legendAttrs,
                                domProps: legendDomProps
                            }, children);
                            legend = h("div", {
                                class: this.labelLayoutClasses
                            }, [ children ]);
                        } else {
                            legend = h(legendTag, {
                                class: [ this.labelLayoutClasses, this.labelClasses ],
                                attrs: legendAttrs,
                                domProps: legendDomProps,
                                on: legendClick
                            }, children);
                        }
                    } else {
                        legend = h(legendTag, {
                            class: this.labelSrOnly ? [ "sr-only" ] : this.labelClasses,
                            attrs: legendAttrs,
                            domProps: legendDomProps,
                            on: legendClick
                        }, children);
                    }
                } else if (this.horizontal) {
                    legend = h("div", {
                        class: this.labelLayoutClasses
                    });
                }
                var invalidFeedback = h(false);
                if (this.hasInvalidFeedback) {
                    var domProps = {};
                    if (!$slots["invalid-feedback"] && !$slots["feedback"]) {
                        domProps = {
                            innerHTML: this.invalidFeedback || this.feedback || ""
                        };
                    }
                    invalidFeedback = h("b-form-invalid-feedback", {
                        props: {
                            id: this.invalidFeedbackId,
                            forceShow: this.computedState === false
                        },
                        attrs: {
                            role: "alert",
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                        },
                        domProps: domProps
                    }, $slots["invalid-feedback"] || $slots["feedback"]);
                }
                var validFeedback = h(false);
                if (this.hasValidFeedback) {
                    var _domProps = $slots["valid-feedback"] ? {} : {
                        innerHTML: this.validFeedback || ""
                    };
                    validFeedback = h("b-form-valid-feedback", {
                        props: {
                            id: this.validFeedbackId,
                            forceShow: this.computedState === true
                        },
                        attrs: {
                            role: "alert",
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                        },
                        domProps: _domProps
                    }, $slots["valid-feedback"]);
                }
                var description = h(false);
                if (this.hasDescription) {
                    var _domProps2 = $slots["description"] ? {} : {
                        innerHTML: this.description || ""
                    };
                    description = h("b-form-text", {
                        attrs: {
                            id: this.descriptionId
                        },
                        domProps: _domProps2
                    }, $slots["description"]);
                }
                var content = h("div", {
                    ref: "content",
                    class: this.inputLayoutClasses,
                    attrs: this.labelFor ? {} : {
                        role: "group",
                        "aria-labelledby": this.labelId
                    }
                }, [ $slots["default"], invalidFeedback, validFeedback, description ]);
                return h(this.labelFor ? "div" : "fieldset", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        disabled: this.disabled,
                        role: "group",
                        "aria-invalid": this.computedState === false ? "true" : null,
                        "aria-labelledby": this.labelId,
                        "aria-describedby": this.labelFor ? null : this.describedByIds
                    }
                }, this.horizontal ? [ h("b-form-row", {}, [ legend, content ]) ] : [ legend, content ]);
            },
            props: {
                horizontal: {
                    type: Boolean,
                    default: false
                },
                labelCols: {
                    type: [ Number, String ],
                    default: 3,
                    validator: function validator(value) {
                        if (Number(value) >= 1 && Number(value) <= 11) {
                            return true;
                        }
                        warn("b-form-group: label-cols must be a value between 1 and 11");
                        return false;
                    }
                },
                breakpoint: {
                    type: String,
                    default: "sm"
                },
                labelTextAlign: {
                    type: String,
                    default: null
                },
                label: {
                    type: String,
                    default: null
                },
                labelFor: {
                    type: String,
                    default: null
                },
                labelSize: {
                    type: String,
                    default: null
                },
                labelSrOnly: {
                    type: Boolean,
                    default: false
                },
                labelClass: {
                    type: [ String, Array ],
                    default: null
                },
                description: {
                    type: String,
                    default: null
                },
                invalidFeedback: {
                    type: String,
                    default: null
                },
                feedback: {
                    type: String,
                    default: null
                },
                validFeedback: {
                    type: String,
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    return [ "b-form-group", "form-group", this.validated ? "was-validated" : null, this.stateClass ];
                },
                labelClasses: function labelClasses() {
                    return [ "col-form-label", this.labelSize ? "col-form-label-" + this.labelSize : null, this.labelTextAlign ? "text-" + this.labelTextAlign : null, this.horizontal ? null : "pt-0", this.labelClass ];
                },
                labelLayoutClasses: function labelLayoutClasses() {
                    return [ this.horizontal ? "col-" + this.breakpoint + "-" + this.labelCols : null ];
                },
                inputLayoutClasses: function inputLayoutClasses() {
                    return [ this.horizontal ? "col-" + this.breakpoint + "-" + (12 - Number(this.labelCols)) : null ];
                },
                hasLabel: function hasLabel() {
                    return this.label || this.$slots["label"];
                },
                hasDescription: function hasDescription() {
                    return this.description || this.$slots["description"];
                },
                hasInvalidFeedback: function hasInvalidFeedback() {
                    if (this.computedState === true) {
                        return false;
                    }
                    return this.invalidFeedback || this.feedback || this.$slots["invalid-feedback"] || this.$slots["feedback"];
                },
                hasValidFeedback: function hasValidFeedback() {
                    if (this.computedState === false) {
                        return false;
                    }
                    return this.validFeedback || this.$slots["valid-feedback"];
                },
                labelId: function labelId() {
                    return this.hasLabel ? this.safeId("_BV_label_") : null;
                },
                descriptionId: function descriptionId() {
                    return this.hasDescription ? this.safeId("_BV_description_") : null;
                },
                invalidFeedbackId: function invalidFeedbackId() {
                    return this.hasInvalidFeedback ? this.safeId("_BV_feedback_invalid_") : null;
                },
                validFeedbackId: function validFeedbackId() {
                    return this.hasValidFeedback ? this.safeId("_BV_feedback_valid_") : null;
                },
                describedByIds: function describedByIds() {
                    return [ this.descriptionId, this.invalidFeedbackId, this.validFeedbackId ].filter(function(i) {
                        return i;
                    }).join(" ") || null;
                }
            },
            watch: {
                describedByIds: function describedByIds(add, remove) {
                    if (add !== remove) {
                        this.setInputDescribedBy(add, remove);
                    }
                }
            },
            methods: {
                legendClick: function legendClick(evt) {
                    var tagName = evt.target ? evt.target.tagName : "";
                    if (/^(input|select|textarea|label)$/i.test(tagName)) {
                        return;
                    }
                    var inputs = selectAll(SELECTOR, this.$refs.content).filter(isVisible);
                    if (inputs[0] && inputs[0].focus) {
                        inputs[0].focus();
                    }
                },
                setInputDescribedBy: function setInputDescribedBy(add, remove) {
                    if (this.labelFor && typeof document !== "undefined") {
                        var input = select("#" + this.labelFor, this.$refs.content);
                        if (input) {
                            var adb = "aria-describedby";
                            var ids = (getAttr(input, adb) || "").split(/\s+/);
                            remove = (remove || "").split(/\s+/);
                            ids = ids.filter(function(id) {
                                return remove.indexOf(id) === -1;
                            }).concat(add || "").join(" ").trim();
                            if (ids) {
                                setAttr(input, adb, ids);
                            } else {
                                removeAttr(input, adb);
                            }
                        }
                    }
                }
            },
            mounted: function mounted() {
                var _this = this;
                this.$nextTick(function() {
                    _this.setInputDescribedBy(_this.describedByIds);
                });
            }
        };
        var components$14 = {
            bFormGroup: bFormGroup,
            bFormFieldset: bFormGroup
        };
        var VuePlugin$15 = {
            install: function install(Vue) {
                registerComponents(Vue, components$14);
            }
        };
        vueUse(VuePlugin$15);
        var formRadioCheckMixin = {
            data: function data() {
                return {
                    localChecked: this.checked,
                    hasFocus: false
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                value: {},
                checked: {},
                buttonVariant: {
                    type: String,
                    default: null
                }
            },
            computed: {
                computedLocalChecked: {
                    get: function get$$1() {
                        if (this.is_Child) {
                            return this.$parent.localChecked;
                        } else {
                            return this.localChecked;
                        }
                    },
                    set: function set(val) {
                        if (this.is_Child) {
                            this.$parent.localChecked = val;
                        } else {
                            this.localChecked = val;
                        }
                    }
                },
                is_Child: function is_Child() {
                    return Boolean(this.$parent && this.$parent.is_RadioCheckGroup);
                },
                is_Disabled: function is_Disabled() {
                    return Boolean(this.is_Child ? this.$parent.disabled || this.disabled : this.disabled);
                },
                is_Required: function is_Required() {
                    return Boolean(this.is_Child ? this.$parent.required : this.required);
                },
                is_Plain: function is_Plain() {
                    return Boolean(this.is_Child ? this.$parent.plain : this.plain);
                },
                is_Custom: function is_Custom() {
                    return !this.is_Plain;
                },
                get_Size: function get_Size() {
                    return this.is_Child ? this.$parent.size : this.size;
                },
                get_State: function get_State() {
                    if (this.is_Child && typeof this.$parent.get_State === "boolean") {
                        return this.$parent.get_State;
                    }
                    return this.computedState;
                },
                get_StateClass: function get_StateClass() {
                    return typeof this.get_State === "boolean" ? this.get_State ? "is-valid" : "is-invalid" : "";
                },
                is_Stacked: function is_Stacked() {
                    return Boolean(this.is_Child && this.$parent.stacked);
                },
                is_Inline: function is_Inline() {
                    return !this.is_Stacked;
                },
                is_ButtonMode: function is_ButtonMode() {
                    return Boolean(this.is_Child && this.$parent.buttons);
                },
                get_ButtonVariant: function get_ButtonVariant() {
                    return this.buttonVariant || (this.is_Child ? this.$parent.buttonVariant : null) || "secondary";
                },
                get_Name: function get_Name() {
                    return (this.is_Child ? this.$parent.name || this.$parent.safeId() : this.name) || null;
                },
                buttonClasses: function buttonClasses() {
                    return [ "btn", "btn-" + this.get_ButtonVariant, this.get_Size ? "btn-" + this.get_Size : "", this.is_Disabled ? "disabled" : "", this.is_Checked ? "active" : "", this.hasFocus ? "focus" : "" ];
                }
            },
            methods: {
                handleFocus: function handleFocus(evt) {
                    if (this.is_ButtonMode && evt.target) {
                        if (evt.type === "focus") {
                            this.hasFocus = true;
                        } else if (evt.type === "blur") {
                            this.hasFocus = false;
                        }
                    }
                }
            }
        };
        var formMixin = {
            props: {
                name: {
                    type: String
                },
                id: {
                    type: String
                },
                disabled: {
                    type: Boolean
                },
                required: {
                    type: Boolean,
                    default: false
                }
            }
        };
        var formSizeMixin = {
            props: {
                size: {
                    type: String,
                    default: null
                }
            },
            computed: {
                sizeFormClass: function sizeFormClass() {
                    return [ this.size ? "form-control-" + this.size : null ];
                },
                sizeBtnClass: function sizeBtnClass() {
                    return [ this.size ? "btn-" + this.size : null ];
                }
            }
        };
        var formCustomMixin = {
            computed: {
                custom: function custom() {
                    return !this.plain;
                }
            },
            props: {
                plain: {
                    type: Boolean,
                    default: false
                }
            }
        };
        function isObject(obj) {
            return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
        }
        function looseEqual(a, b) {
            if (a === b) return true;
            var isObjectA = isObject(a);
            var isObjectB = isObject(b);
            if (isObjectA && isObjectB) {
                try {
                    var isArrayA = isArray(a);
                    var isArrayB = isArray(b);
                    if (isArrayA && isArrayB) {
                        return a.length === b.length && a.every(function(e, i) {
                            return looseEqual(e, b[i]);
                        });
                    } else if (!isArrayA && !isArrayB) {
                        var keysA = keys(a);
                        var keysB = keys(b);
                        return keysA.length === keysB.length && keysA.every(function(key) {
                            return looseEqual(a[key], b[key]);
                        });
                    } else {
                        return false;
                    }
                } catch (e) {
                    return false;
                }
            } else if (!isObjectA && !isObjectB) {
                return String(a) === String(b);
            } else {
                return false;
            }
        }
        var bFormCheckbox = {
            mixins: [ idMixin, formRadioCheckMixin, formMixin, formSizeMixin, formStateMixin, formCustomMixin ],
            render: function render(h) {
                var _this = this;
                var input = h("input", {
                    ref: "check",
                    class: [ this.is_ButtonMode ? "" : this.is_Plain ? "form-check-input" : "custom-control-input", this.get_StateClass ],
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.computedLocalChecked,
                        expression: "computedLocalChecked"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        type: "checkbox",
                        name: this.get_Name,
                        disabled: this.is_Disabled,
                        required: this.is_Required,
                        autocomplete: "off",
                        "true-value": this.value,
                        "false-value": this.uncheckedValue,
                        "aria-required": this.is_Required ? "true" : null
                    },
                    domProps: {
                        value: this.value,
                        checked: this.is_Checked
                    },
                    on: {
                        focus: this.handleFocus,
                        blur: this.handleFocus,
                        change: this.emitChange,
                        __c: function __c(evt) {
                            var $$a = _this.computedLocalChecked;
                            var $$el = evt.target;
                            if (isArray($$a)) {
                                var $$v = _this.value;
                                var $$i = _this._i($$a, $$v);
                                if ($$el.checked) {
                                    $$i < 0 && (_this.computedLocalChecked = $$a.concat([ $$v ]));
                                } else {
                                    $$i > -1 && (_this.computedLocalChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                                }
                            } else {
                                _this.computedLocalChecked = $$el.checked ? _this.value : _this.uncheckedValue;
                            }
                        }
                    }
                });
                var description = h(this.is_ButtonMode ? "span" : "label", {
                    class: this.is_ButtonMode ? null : this.is_Plain ? "form-check-label" : "custom-control-label",
                    attrs: {
                        for: this.is_ButtonMode ? null : this.safeId()
                    }
                }, [ this.$slots.default ]);
                if (!this.is_ButtonMode) {
                    return h("div", {
                        class: [ this.is_Plain ? "form-check" : this.labelClasses, {
                            "form-check-inline": this.is_Plain && !this.is_Stacked
                        }, {
                            "custom-control-inline": !this.is_Plain && !this.is_Stacked
                        } ]
                    }, [ input, description ]);
                } else {
                    return h("label", {
                        class: [ this.buttonClasses ]
                    }, [ input, description ]);
                }
            },
            props: {
                value: {
                    default: true
                },
                uncheckedValue: {
                    default: false
                },
                indeterminate: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                labelClasses: function labelClasses() {
                    return [ "custom-control", "custom-checkbox", this.get_Size ? "form-control-" + this.get_Size : "", this.get_StateClass ];
                },
                is_Checked: function is_Checked() {
                    var checked = this.computedLocalChecked;
                    if (isArray(checked)) {
                        for (var i = 0; i < checked.length; i++) {
                            if (looseEqual(checked[i], this.value)) {
                                return true;
                            }
                        }
                        return false;
                    } else {
                        return looseEqual(checked, this.value);
                    }
                }
            },
            watch: {
                computedLocalChecked: function computedLocalChecked(newVal, oldVal) {
                    if (looseEqual(newVal, oldVal)) {
                        return;
                    }
                    this.$emit("input", newVal);
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                },
                checked: function checked(newVal, oldVal) {
                    if (this.is_Child || looseEqual(newVal, oldVal)) {
                        return;
                    }
                    this.computedLocalChecked = newVal;
                },
                indeterminate: function indeterminate(newVal, oldVal) {
                    this.setIndeterminate(newVal);
                }
            },
            methods: {
                emitChange: function emitChange(_ref) {
                    var checked = _ref.target.checked;
                    if (this.is_Child || isArray(this.computedLocalChecked)) {
                        this.$emit("change", checked ? this.value : null);
                        if (this.is_Child) {
                            this.$parent.$emit("change", this.computedLocalChecked);
                        }
                    } else {
                        this.$emit("change", checked ? this.value : this.uncheckedValue);
                    }
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                },
                setIndeterminate: function setIndeterminate(state) {
                    if (this.is_Child || isArray(this.computedLocalChecked)) {
                        return;
                    }
                    this.$refs.check.indeterminate = state;
                    this.$emit("update:indeterminate", this.$refs.check.indeterminate);
                }
            },
            mounted: function mounted() {
                this.setIndeterminate(this.indeterminate);
            }
        };
        function isObject$1(obj) {
            return obj && {}.toString.call(obj) === "[object Object]";
        }
        var formOptionsMixin = {
            props: {
                options: {
                    type: [ Array, Object ],
                    default: function _default() {
                        return [];
                    }
                },
                valueField: {
                    type: String,
                    default: "value"
                },
                textField: {
                    type: String,
                    default: "text"
                },
                disabledField: {
                    type: String,
                    default: "disabled"
                }
            },
            computed: {
                formOptions: function formOptions() {
                    var options = this.options;
                    var valueField = this.valueField;
                    var textField = this.textField;
                    var disabledField = this.disabledField;
                    if (isArray(options)) {
                        return options.map(function(option) {
                            if (isObject$1(option)) {
                                return {
                                    value: option[valueField],
                                    text: String(option[textField]),
                                    disabled: option[disabledField] || false
                                };
                            }
                            return {
                                value: option,
                                text: String(option),
                                disabled: false
                            };
                        });
                    } else {
                        return keys(options).map(function(key) {
                            var option = options[key] || {};
                            if (isObject$1(option)) {
                                var value = option[valueField];
                                var text = option[textField];
                                return {
                                    value: typeof value === "undefined" ? key : value,
                                    text: typeof text === "undefined" ? key : String(text),
                                    disabled: option[disabledField] || false
                                };
                            }
                            return {
                                value: key,
                                text: String(option),
                                disabled: false
                            };
                        });
                    }
                }
            }
        };
        var bFormCheckboxGroup = {
            mixins: [ idMixin, formMixin, formSizeMixin, formStateMixin, formCustomMixin, formOptionsMixin ],
            components: {
                bFormCheckbox: bFormCheckbox
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var checks = this.formOptions.map(function(option, idx) {
                    return h("b-form-checkbox", {
                        key: "check_" + idx + "_opt",
                        props: {
                            id: _this.safeId("_BV_check_" + idx + "_opt_"),
                            name: _this.name,
                            value: option.value,
                            required: _this.name && _this.required,
                            disabled: option.disabled
                        }
                    }, [ h("span", {
                        domProps: {
                            innerHTML: option.text
                        }
                    }) ]);
                });
                return h("div", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        role: "group",
                        tabindex: "-1",
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    }
                }, [ $slots.first, checks, $slots.default ]);
            },
            data: function data() {
                return {
                    localChecked: this.checked || [],
                    is_RadioCheckGroup: true
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                checked: {
                    type: [ String, Number, Object, Array, Boolean ],
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: Boolean,
                    default: false
                },
                buttons: {
                    type: Boolean,
                    default: false
                },
                buttonVariant: {
                    type: String,
                    default: "secondary"
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.localChecked = this.checked;
                },
                localChecked: function localChecked(newVal, oldVal) {
                    this.$emit("input", newVal);
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    if (this.buttons) {
                        return [ "btn-group-toggle", this.stacked ? "btn-group-vertical" : "btn-group", this.size ? "btn-group-" + this.size : "", this.validated ? "was-validated" : "" ];
                    }
                    return [ this.sizeFormClass, this.stacked && this.custom ? "custom-controls-stacked" : "", this.validated ? "was-validated" : "" ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true" || this.ariaInvalid === "") {
                        return "true";
                    }
                    return this.get_State === false ? "true" : null;
                },
                get_State: function get_State() {
                    return this.computedState;
                }
            }
        };
        var components$15 = {
            bFormCheckbox: bFormCheckbox,
            bCheckbox: bFormCheckbox,
            bCheck: bFormCheckbox,
            bFormCheckboxGroup: bFormCheckboxGroup,
            bCheckboxGroup: bFormCheckboxGroup,
            bCheckGroup: bFormCheckboxGroup
        };
        var VuePlugin$16 = {
            install: function install(Vue) {
                registerComponents(Vue, components$15);
            }
        };
        vueUse(VuePlugin$16);
        var bFormRadio = {
            mixins: [ idMixin, formRadioCheckMixin, formMixin, formStateMixin ],
            render: function render(h) {
                var _this = this;
                var input = h("input", {
                    ref: "radio",
                    class: [ this.is_ButtonMode ? "" : this.is_Plain ? "form-check-input" : "custom-control-input", this.get_StateClass ],
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.computedLocalChecked,
                        expression: "computedLocalChecked"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        type: "radio",
                        name: this.get_Name,
                        required: this.get_Name && this.is_Required,
                        disabled: this.is_Disabled,
                        autocomplete: "off"
                    },
                    domProps: {
                        value: this.value,
                        checked: looseEqual(this.computedLocalChecked, this.value)
                    },
                    on: {
                        focus: this.handleFocus,
                        blur: this.handleFocus,
                        change: this.emitChange,
                        __c: function __c(evt) {
                            _this.computedLocalChecked = _this.value;
                        }
                    }
                });
                var description = h(this.is_ButtonMode ? "span" : "label", {
                    class: this.is_ButtonMode ? null : this.is_Plain ? "form-check-label" : "custom-control-label",
                    attrs: {
                        for: this.is_ButtonMode ? null : this.safeId()
                    }
                }, [ this.$slots.default ]);
                if (!this.is_ButtonMode) {
                    return h("div", {
                        class: [ this.is_Plain ? "form-check" : this.labelClasses, {
                            "form-check-inline": this.is_Plain && !this.is_Stacked
                        }, {
                            "custom-control-inline": !this.is_Plain && !this.is_Stacked
                        } ]
                    }, [ input, description ]);
                } else {
                    return h("label", {
                        class: [ this.buttonClasses ]
                    }, [ input, description ]);
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.computedLocalChecked = newVal;
                },
                computedLocalChceked: function computedLocalChceked(newVal, oldVal) {
                    this.$emit("input", this.computedLocalChceked);
                }
            },
            computed: {
                is_Checked: function is_Checked() {
                    return looseEqual(this.value, this.computedLocalChecked);
                },
                labelClasses: function labelClasses() {
                    return [ this.get_Size ? "form-control-" + this.get_Size : "", "custom-control", "custom-radio", this.get_StateClass ];
                }
            },
            methods: {
                emitChange: function emitChange(_ref) {
                    var checked = _ref.target.checked;
                    this.$emit("change", checked ? this.value : null);
                    if (this.is_Child) {
                        this.$parent.$emit("change", this.computedLocalChecked);
                    }
                }
            }
        };
        var bFormRadioGroup = {
            mixins: [ idMixin, formMixin, formSizeMixin, formStateMixin, formCustomMixin, formOptionsMixin ],
            components: {
                bFormRadio: bFormRadio
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var radios = this.formOptions.map(function(option, idx) {
                    return h("b-form-radio", {
                        key: "radio_" + idx + "_opt",
                        props: {
                            id: _this.safeId("_BV_radio_" + idx + "_opt_"),
                            name: _this.name,
                            value: option.value,
                            required: Boolean(_this.name && _this.required),
                            disabled: option.disabled
                        }
                    }, [ h("span", {
                        domProps: {
                            innerHTML: option.text
                        }
                    }) ]);
                });
                return h("div", {
                    class: this.groupClasses,
                    attrs: {
                        id: this.safeId(),
                        role: "radiogroup",
                        tabindex: "-1",
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    }
                }, [ $slots.first, radios, $slots.default ]);
            },
            data: function data() {
                return {
                    localChecked: this.checked,
                    is_RadioCheckGroup: true
                };
            },
            model: {
                prop: "checked",
                event: "input"
            },
            props: {
                checked: {
                    type: [ String, Object, Number, Boolean ],
                    default: null
                },
                validated: {
                    type: Boolean,
                    default: false
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: Boolean,
                    default: false
                },
                buttons: {
                    type: Boolean,
                    default: false
                },
                buttonVariant: {
                    type: String,
                    default: "secondary"
                }
            },
            watch: {
                checked: function checked(newVal, oldVal) {
                    this.localChecked = this.checked;
                },
                localChecked: function localChecked(newVal, oldVal) {
                    this.$emit("input", newVal);
                }
            },
            computed: {
                groupClasses: function groupClasses() {
                    if (this.buttons) {
                        return [ "btn-group-toggle", this.stacked ? "btn-group-vertical" : "btn-group", this.size ? "btn-group-" + this.size : "", this.validated ? "was-validated" : "" ];
                    }
                    return [ this.sizeFormClass, this.stacked && this.custom ? "custom-controls-stacked" : "", this.validated ? "was-validated" : "" ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true" || this.ariaInvalid === "") {
                        return "true";
                    }
                    return this.get_State === false ? "true" : null;
                },
                get_State: function get_State() {
                    return this.computedState;
                }
            }
        };
        var components$16 = {
            bFormRadio: bFormRadio,
            bRadio: bFormRadio,
            bFormRadioGroup: bFormRadioGroup,
            bRadioGroup: bFormRadioGroup
        };
        var VuePlugin$17 = {
            install: function install(Vue) {
                registerComponents(Vue, components$16);
            }
        };
        vueUse(VuePlugin$17);
        var TYPES = [ "text", "password", "email", "number", "url", "tel", "search", "range", "color", "date", "time", "datetime", "datetime-local", "month", "week" ];
        var bFormInput = {
            mixins: [ idMixin, formMixin, formSizeMixin, formStateMixin ],
            render: function render(h) {
                return h("input", {
                    ref: "input",
                    class: this.inputClass,
                    domProps: {
                        value: this.localValue
                    },
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        type: this.localType,
                        disabled: this.disabled,
                        required: this.required,
                        readonly: this.readonly || this.plaintext,
                        placeholder: this.placeholder,
                        autocomplete: this.autocomplete || null,
                        step: this.step || null,
                        min: this.min || null,
                        max: this.max || null,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        input: this.onInput,
                        change: this.onChange
                    }
                });
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            props: {
                value: {
                    default: null
                },
                type: {
                    type: String,
                    default: "text",
                    validator: function validator(type) {
                        return arrayIncludes(TYPES, type);
                    }
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                readonly: {
                    type: Boolean,
                    default: false
                },
                plaintext: {
                    type: Boolean,
                    default: false
                },
                autocomplete: {
                    type: String,
                    default: null
                },
                placeholder: {
                    type: String,
                    default: null
                },
                formatter: {
                    type: Function
                },
                lazyFormatter: {
                    type: Boolean,
                    default: false
                },
                step: {
                    type: Number,
                    default: null
                },
                min: {
                    type: Number,
                    default: null
                },
                max: {
                    type: Number,
                    default: null
                }
            },
            computed: {
                localType: function localType() {
                    return arrayIncludes(TYPES, this.type) ? this.type : "text";
                },
                inputClass: function inputClass() {
                    return [ this.plaintext ? "form-control-plaintext" : "form-control", this.sizeFormClass, this.stateClass ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (!this.ariaInvalid || this.ariaInvalid === "false") {
                        return this.computedState === false ? "true" : null;
                    }
                    if (this.ariaInvalid === true) {
                        return "true";
                    }
                    return this.ariaInvalid;
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.localValue = newVal;
                    }
                },
                localValue: function localValue(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                format: function format(value, e) {
                    if (this.formatter) {
                        var formattedValue = this.formatter(value, e);
                        if (formattedValue !== value) {
                            return formattedValue;
                        }
                    }
                    return value;
                },
                onInput: function onInput(evt) {
                    var value = evt.target.value;
                    if (this.lazyFormatter) {
                        this.localValue = value;
                    } else {
                        this.localValue = this.format(value, evt);
                    }
                },
                onChange: function onChange(evt) {
                    this.localValue = this.format(evt.target.value, evt);
                    this.$emit("change", this.localValue);
                },
                focus: function focus() {
                    if (!this.disabled) {
                        this.$el.focus();
                    }
                }
            }
        };
        var components$17 = {
            bFormInput: bFormInput,
            bInput: bFormInput
        };
        var VuePlugin$18 = {
            install: function install(Vue) {
                registerComponents(Vue, components$17);
            }
        };
        vueUse(VuePlugin$18);
        var bFormTextarea = {
            mixins: [ idMixin, formMixin, formSizeMixin, formStateMixin ],
            render: function render(h) {
                var _this = this;
                return h("textarea", {
                    ref: "input",
                    class: this.inputClass,
                    style: this.inputStyle,
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.localValue,
                        expression: "localValue"
                    } ],
                    domProps: {
                        value: this.value
                    },
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        disabled: this.disabled,
                        placeholder: this.placeholder,
                        required: this.required,
                        autocomplete: this.autocomplete || null,
                        readonly: this.readonly || this.plaintext,
                        rows: this.rowsCount,
                        wrap: this.wrap || null,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        input: function input(evt) {
                            _this.localValue = evt.target.value;
                        }
                    }
                });
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            props: {
                value: {
                    type: String,
                    default: ""
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                },
                readonly: {
                    type: Boolean,
                    default: false
                },
                plaintext: {
                    type: Boolean,
                    default: false
                },
                autocomplete: {
                    type: String,
                    default: null
                },
                placeholder: {
                    type: String,
                    default: null
                },
                rows: {
                    type: [ Number, String ],
                    default: null
                },
                maxRows: {
                    type: [ Number, String ],
                    default: null
                },
                wrap: {
                    type: String,
                    default: "soft"
                },
                noResize: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                rowsCount: function rowsCount() {
                    var rows = parseInt(this.rows, 10) || 1;
                    var maxRows = parseInt(this.maxRows, 10) || 0;
                    var lines = (this.localValue || "").toString().split("\n").length;
                    return maxRows ? Math.min(maxRows, Math.max(rows, lines)) : Math.max(rows, lines);
                },
                inputClass: function inputClass() {
                    return [ this.plaintext ? "form-control-plaintext" : "form-control", this.sizeFormClass, this.stateClass ];
                },
                inputStyle: function inputStyle() {
                    return {
                        width: this.plaintext ? "100%" : null,
                        resize: this.noResize ? "none" : null
                    };
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (!this.ariaInvalid || this.ariaInvalid === "false") {
                        return this.computedState === false ? "true" : null;
                    }
                    if (this.ariaInvalid === true) {
                        return "true";
                    }
                    return this.ariaInvalid;
                }
            },
            watch: {
                value: function value(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.localValue = newVal;
                    }
                },
                localValue: function localValue(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                focus: function focus() {
                    if (!this.disabled) {
                        this.$el.focus();
                    }
                }
            }
        };
        var components$18 = {
            bFormTextarea: bFormTextarea,
            bTextarea: bFormTextarea
        };
        var VuePlugin$19 = {
            install: function install(Vue) {
                registerComponents(Vue, components$18);
            }
        };
        vueUse(VuePlugin$19);
        var bFormFile = {
            mixins: [ idMixin, formMixin, formStateMixin, formCustomMixin ],
            render: function render(h) {
                var input = h("input", {
                    ref: "input",
                    class: [ {
                        "form-control-file": this.plain,
                        "custom-file-input": this.custom,
                        focus: this.custom && this.hasFocus
                    }, this.stateClass ],
                    attrs: {
                        type: "file",
                        id: this.safeId(),
                        name: this.name,
                        disabled: this.disabled,
                        required: this.required,
                        capture: this.capture || null,
                        accept: this.accept || null,
                        multiple: this.multiple,
                        webkitdirectory: this.directory,
                        "aria-required": this.required ? "true" : null,
                        "aria-describedby": this.plain ? null : this.safeId("_BV_file_control_")
                    },
                    on: {
                        change: this.onFileChange,
                        focusin: this.focusHandler,
                        focusout: this.focusHandler
                    }
                });
                if (this.plain) {
                    return input;
                }
                var label = h("label", {
                    class: [ "custom-file-label", this.dragging ? "dragging" : null ],
                    attrs: {
                        id: this.safeId("_BV_file_control_")
                    }
                }, this.selectLabel);
                return h("div", {
                    class: [ "custom-file", "b-form-file", this.stateClass ],
                    attrs: {
                        id: this.safeId("_BV_file_outer_")
                    },
                    on: {
                        dragover: this.dragover
                    }
                }, [ input, label ]);
            },
            data: function data() {
                return {
                    selectedFile: null,
                    dragging: false,
                    hasFocus: false
                };
            },
            props: {
                accept: {
                    type: String,
                    default: ""
                },
                capture: {
                    type: Boolean,
                    default: false
                },
                placeholder: {
                    type: String,
                    default: undefined
                },
                multiple: {
                    type: Boolean,
                    default: false
                },
                directory: {
                    type: Boolean,
                    default: false
                },
                noTraverse: {
                    type: Boolean,
                    default: false
                },
                noDrop: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                selectLabel: function selectLabel() {
                    if (!this.selectedFile || this.selectedFile.length === 0) {
                        return this.placeholder;
                    }
                    if (this.multiple) {
                        if (this.selectedFile.length === 1) {
                            return this.selectedFile[0].name;
                        }
                        return this.selectedFile.map(function(file) {
                            return file.name;
                        }).join(", ");
                    }
                    return this.selectedFile.name;
                }
            },
            watch: {
                selectedFile: function selectedFile(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    if (!newVal && this.multiple) {
                        this.$emit("input", []);
                    } else {
                        this.$emit("input", newVal);
                    }
                }
            },
            methods: {
                focusHandler: function focusHandler(evt) {
                    if (this.plain || evt.type === "focusout") {
                        this.hasFocus = false;
                    } else {
                        this.hasFocus = true;
                    }
                },
                reset: function reset() {
                    try {
                        this.$refs.input.value = "";
                    } catch (e) {}
                    this.$refs.input.type = "";
                    this.$refs.input.type = "file";
                    this.selectedFile = this.multiple ? [] : null;
                },
                onFileChange: function onFileChange(evt) {
                    var _this = this;
                    this.$emit("change", evt);
                    var items = evt.dataTransfer && evt.dataTransfer.items;
                    if (items && !this.noTraverse) {
                        var queue = [];
                        for (var i = 0; i < items.length; i++) {
                            var item = items[i].webkitGetAsEntry();
                            if (item) {
                                queue.push(this.traverseFileTree(item));
                            }
                        }
                        Promise.all(queue).then(function(filesArr) {
                            _this.setFiles(from(filesArr));
                        });
                        return;
                    }
                    this.setFiles(evt.target.files || evt.dataTransfer.files);
                },
                setFiles: function setFiles(files) {
                    if (!files) {
                        this.selectedFile = null;
                        return;
                    }
                    if (!this.multiple) {
                        this.selectedFile = files[0];
                        return;
                    }
                    var filesArray = [];
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].type.match(this.accept)) {
                            filesArray.push(files[i]);
                        }
                    }
                    this.selectedFile = filesArray;
                },
                dragover: function dragover(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.noDrop || !this.custom) {
                        return;
                    }
                    this.dragging = true;
                    evt.dataTransfer.dropEffect = "copy";
                },
                dragleave: function dragleave(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.dragging = false;
                },
                drop: function drop(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (this.noDrop) {
                        return;
                    }
                    this.dragging = false;
                    if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                        this.onFileChange(evt);
                    }
                },
                traverseFileTree: function traverseFileTree(item, path) {
                    var _this2 = this;
                    return new Promise(function(resolve) {
                        path = path || "";
                        if (item.isFile) {
                            item.file(function(file) {
                                file.$path = path;
                                resolve(file);
                            });
                        } else if (item.isDirectory) {
                            item.createReader().readEntries(function(entries) {
                                var queue = [];
                                for (var i = 0; i < entries.length; i++) {
                                    queue.push(_this2.traverseFileTree(entries[i], path + item.name + "/"));
                                }
                                Promise.all(queue).then(function(filesArr) {
                                    resolve(from(filesArr));
                                });
                            });
                        }
                    });
                }
            }
        };
        var components$19 = {
            bFormFile: bFormFile,
            bFile: bFormFile
        };
        var VuePlugin$20 = {
            install: function install(Vue) {
                registerComponents(Vue, components$19);
            }
        };
        vueUse(VuePlugin$20);
        var bFormSelect = {
            mixins: [ idMixin, formMixin, formSizeMixin, formStateMixin, formCustomMixin, formOptionsMixin ],
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var options = this.formOptions.map(function(option, index) {
                    return h("option", {
                        key: "option_" + index + "_opt",
                        attrs: {
                            disabled: Boolean(option.disabled)
                        },
                        domProps: {
                            innerHTML: option.text,
                            value: option.value
                        }
                    });
                });
                return h("select", {
                    ref: "input",
                    class: this.inputClass,
                    directives: [ {
                        name: "model",
                        rawName: "v-model",
                        value: this.localValue,
                        expression: "localValue"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        name: this.name,
                        multiple: this.multiple || null,
                        size: this.computedSelectSize,
                        disabled: this.disabled,
                        required: this.required,
                        "aria-required": this.required ? "true" : null,
                        "aria-invalid": this.computedAriaInvalid
                    },
                    on: {
                        change: function change(evt) {
                            var target = evt.target;
                            var selectedVal = from(target.options).filter(function(o) {
                                return o.selected;
                            }).map(function(o) {
                                return "_value" in o ? o._value : o.value;
                            });
                            _this.localValue = target.multiple ? selectedVal : selectedVal[0];
                            _this.$emit("change", _this.localValue);
                        }
                    }
                }, [ $slots.first, options, $slots.default ]);
            },
            data: function data() {
                return {
                    localValue: this.value
                };
            },
            watch: {
                value: function value(newVal, oldVal) {
                    this.localValue = newVal;
                },
                localValue: function localValue(newVal, oldVal) {
                    this.$emit("input", this.localValue);
                }
            },
            props: {
                value: {},
                multiple: {
                    type: Boolean,
                    default: false
                },
                selectSize: {
                    type: Number,
                    default: 0
                },
                ariaInvalid: {
                    type: [ Boolean, String ],
                    default: false
                }
            },
            computed: {
                computedSelectSize: function computedSelectSize() {
                    return !this.plain && this.selectSize === 0 ? null : this.selectSize;
                },
                inputClass: function inputClass() {
                    return [ "form-control", this.stateClass, this.sizeFormClass, this.plain ? null : "custom-select", this.plain || !this.size ? null : "custom-select-" + this.size ];
                },
                computedAriaInvalid: function computedAriaInvalid() {
                    if (this.ariaInvalid === true || this.ariaInvalid === "true") {
                        return "true";
                    }
                    return this.stateClass === "is-invalid" ? "true" : null;
                }
            }
        };
        var components$20 = {
            bFormSelect: bFormSelect,
            bSelect: bFormSelect
        };
        var VuePlugin$21 = {
            install: function install(Vue) {
                registerComponents(Vue, components$20);
            }
        };
        vueUse(VuePlugin$21);
        var THROTTLE = 100;
        var bImgLazy = {
            components: {
                bImg: bImg
            },
            render: function render(h) {
                return h("b-img", {
                    props: {
                        src: this.computedSrc,
                        alt: this.alt,
                        blank: this.computedBlank,
                        blankColor: this.blankColor,
                        width: this.computedWidth,
                        height: this.computedHeight,
                        fluid: this.fluid,
                        fluidGrow: this.fluidGrow,
                        block: this.block,
                        thumbnail: this.thumbnail,
                        rounded: this.rounded,
                        left: this.left,
                        right: this.right,
                        center: this.center
                    }
                });
            },
            data: function data() {
                return {
                    isShown: false,
                    scrollTimeout: null
                };
            },
            props: {
                src: {
                    type: String,
                    default: null,
                    required: true
                },
                alt: {
                    type: String,
                    default: null
                },
                width: {
                    type: [ Number, String ],
                    default: null
                },
                height: {
                    type: [ Number, String ],
                    default: null
                },
                blankSrc: {
                    type: String,
                    default: null
                },
                blankColor: {
                    type: String,
                    default: "transparent"
                },
                blankWidth: {
                    type: [ Number, String ],
                    default: null
                },
                blankHeight: {
                    type: [ Number, String ],
                    default: null
                },
                fluid: {
                    type: Boolean,
                    default: false
                },
                fluidGrow: {
                    type: Boolean,
                    default: false
                },
                block: {
                    type: Boolean,
                    default: false
                },
                thumbnail: {
                    type: Boolean,
                    default: false
                },
                rounded: {
                    type: [ Boolean, String ],
                    default: false
                },
                left: {
                    type: Boolean,
                    default: false
                },
                right: {
                    type: Boolean,
                    default: false
                },
                center: {
                    type: Boolean,
                    default: false
                },
                offset: {
                    type: [ Number, String ],
                    default: 360
                },
                throttle: {
                    type: [ Number, String ],
                    default: THROTTLE
                }
            },
            computed: {
                computedSrc: function computedSrc() {
                    return !this.blankSrc || this.isShown ? this.src : this.blankSrc;
                },
                computedBlank: function computedBlank() {
                    return !(this.isShown || this.blankSrc);
                },
                computedWidth: function computedWidth() {
                    return this.isShown ? this.width : this.blankWidth || this.width;
                },
                computedHeight: function computedHeight() {
                    return this.isShown ? this.height : this.blankHeight || this.height;
                }
            },
            mounted: function mounted() {
                this.setListeners(true);
                this.checkView();
            },
            activated: function activated() {
                this.setListeners(true);
                this.checkView();
            },
            deactivated: function deactivated() {
                this.setListeners(false);
            },
            beforeDdestroy: function beforeDdestroy() {
                this.setListeners(false);
            },
            methods: {
                setListeners: function setListeners(on) {
                    clearTimeout(this.scrollTimer);
                    this.scrollTimout = null;
                    var root = window;
                    if (on) {
                        eventOn(root, "scroll", this.onScroll);
                        eventOn(root, "resize", this.onScroll);
                        eventOn(root, "orientationchange", this.onScroll);
                    } else {
                        eventOff(root, "scroll", this.onScroll);
                        eventOff(root, "resize", this.onScroll);
                        eventOff(root, "orientationchange", this.onScroll);
                    }
                },
                checkView: function checkView() {
                    if (!isVisible(this.$el)) {
                        return;
                    }
                    var offset$$1 = parseInt(this.offset, 10) || 0;
                    var docElement = document.documentElement;
                    var view = {
                        l: 0 - offset$$1,
                        t: 0 - offset$$1,
                        b: docElement.clientHeight + offset$$1,
                        r: docElement.clientWidth + offset$$1
                    };
                    var box = getBCR(this.$el);
                    if (box.right >= view.l && box.bottom >= view.t && box.left <= view.r && box.top <= view.b) {
                        this.isShown = true;
                        this.setListeners(false);
                    }
                },
                onScroll: function onScroll() {
                    if (this.isShown) {
                        this.setListeners(false);
                    } else {
                        clearTimeout(this.scrollTimeout);
                        this.scrollTimeout = setTimeout(this.checkView, parseInt(this.throttle, 10) || THROTTLE);
                    }
                }
            }
        };
        var components$21 = {
            bImg: bImg,
            bImgLazy: bImgLazy
        };
        var VuePlugin$22 = {
            install: function install(Vue) {
                registerComponents(Vue, components$21);
            }
        };
        vueUse(VuePlugin$22);
        var props$30 = {
            fluid: {
                type: Boolean,
                default: false
            },
            containerFluid: {
                type: Boolean,
                default: false
            },
            header: {
                type: String,
                default: null
            },
            headerTag: {
                type: String,
                default: "h1"
            },
            headerLevel: {
                type: [ Number, String ],
                default: "3"
            },
            lead: {
                type: String,
                default: null
            },
            leadTag: {
                type: String,
                default: "p"
            },
            tag: {
                type: String,
                default: "div"
            },
            bgVariant: {
                type: String,
                default: null
            },
            borderVariant: {
                type: String,
                default: null
            },
            textVariant: {
                type: String,
                default: null
            }
        };
        var bJumbotron = {
            functional: true,
            props: props$30,
            render: function render(h, _ref) {
                var _class2;
                var props = _ref.props, data = _ref.data, slots = _ref.slots;
                var childNodes = [];
                var $slots = slots();
                if (props.header || $slots.header) {
                    childNodes.push(h(props.headerTag, {
                        class: defineProperty({}, "display-" + props.headerLevel, Boolean(props.headerLevel))
                    }, $slots.header || props.header));
                }
                if (props.lead || $slots.lead) {
                    childNodes.push(h(props.leadTag, {
                        staticClass: "lead"
                    }, $slots.lead || props.lead));
                }
                if ($slots.default) {
                    childNodes.push($slots.default);
                }
                if (props.fluid) {
                    childNodes = [ h(Container, {
                        props: {
                            fluid: props.containerFluid
                        }
                    }, childNodes) ];
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "jumbotron",
                    class: (_class2 = {
                        "jumbotron-fluid": props.fluid
                    }, defineProperty(_class2, "text-" + props.textVariant, Boolean(props.textVariant)), 
                    defineProperty(_class2, "bg-" + props.bgVariant, Boolean(props.bgVariant)), defineProperty(_class2, "border-" + props.borderVariant, Boolean(props.borderVariant)), 
                    defineProperty(_class2, "border", Boolean(props.borderVariant)), _class2)
                }), childNodes);
            }
        };
        var components$22 = {
            bJumbotron: bJumbotron
        };
        var VuePlugin$23 = {
            install: function install(Vue) {
                registerComponents(Vue, components$22);
            }
        };
        vueUse(VuePlugin$23);
        var components$23 = {
            bLink: bLink
        };
        var VuePlugin$24 = {
            install: function install(Vue) {
                registerComponents(Vue, components$23);
            }
        };
        vueUse(VuePlugin$24);
        var props$31 = {
            tag: {
                type: String,
                default: "div"
            },
            flush: {
                type: Boolean,
                default: false
            }
        };
        var bListGroup = {
            functional: true,
            props: props$31,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var componentData = {
                    staticClass: "list-group",
                    class: {
                        "list-group-flush": props.flush
                    }
                };
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
        var actionTags = [ "a", "router-link", "button", "b-link" ];
        var linkProps$2 = propsFactory();
        delete linkProps$2.href.default;
        delete linkProps$2.to.default;
        var props$32 = assign({
            tag: {
                type: String,
                default: "div"
            },
            action: {
                type: Boolean,
                default: null
            },
            button: {
                type: Boolean,
                default: null
            },
            variant: {
                type: String,
                default: null
            }
        }, linkProps$2);
        var bListGroupItem = {
            functional: true,
            props: props$32,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var tag = props.button ? "button" : !props.href && !props.to ? props.tag : bLink;
                var isAction = Boolean(props.href || props.to || props.action || props.button || arrayIncludes(actionTags, props.tag));
                var componentData = {
                    staticClass: "list-group-item",
                    class: (_class = {}, defineProperty(_class, "list-group-item-" + props.variant, Boolean(props.variant)), 
                    defineProperty(_class, "list-group-item-action", isAction), defineProperty(_class, "active", props.active), 
                    defineProperty(_class, "disabled", props.disabled), _class),
                    attrs: tag === "button" && props.disabled ? {
                        disabled: true
                    } : {},
                    props: props.button ? {} : pluckProps(linkProps$2, props)
                };
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, componentData), children);
            }
        };
        var components$24 = {
            bListGroup: bListGroup,
            bListGroupItem: bListGroupItem
        };
        var VuePlugin$25 = {
            install: function install(Vue) {
                registerComponents(Vue, components$24);
            }
        };
        vueUse(VuePlugin$25);
        var props$33 = {
            tag: {
                type: String,
                default: "div"
            }
        };
        var MediaBody = {
            functional: true,
            props: props$33,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "media-body"
                }), children);
            }
        };
        var props$34 = {
            tag: {
                type: String,
                default: "div"
            },
            verticalAlign: {
                type: String,
                default: "top"
            }
        };
        var MediaAside = {
            functional: true,
            props: props$34,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "d-flex",
                    class: defineProperty({}, "align-self-" + props.verticalAlign, props.verticalAlign)
                }), children);
            }
        };
        var props$35 = {
            tag: {
                type: String,
                default: "div"
            },
            rightAlign: {
                type: Boolean,
                default: false
            },
            verticalAlign: {
                type: String,
                default: "top"
            },
            noBody: {
                type: Boolean,
                default: false
            }
        };
        var bMedia = {
            functional: true,
            props: props$35,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, slots = _ref.slots, children = _ref.children;
                var childNodes = props.noBody ? children : [];
                var $slots = slots();
                if (!props.noBody) {
                    if ($slots.aside && !props.rightAlign) {
                        childNodes.push(h(MediaAside, {
                            staticClass: "mr-3",
                            props: {
                                verticalAlign: props.verticalAlign
                            }
                        }, $slots.aside));
                    }
                    childNodes.push(h(MediaBody, $slots.default));
                    if ($slots.aside && props.rightAlign) {
                        childNodes.push(h(MediaAside, {
                            staticClass: "ml-3",
                            props: {
                                verticalAlign: props.verticalAlign
                            }
                        }, $slots.aside));
                    }
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "media"
                }), childNodes);
            }
        };
        var components$25 = {
            bMedia: bMedia,
            bMediaAside: MediaAside,
            bMediaBody: MediaBody
        };
        var VuePlugin$26 = {
            install: function install(Vue) {
                registerComponents(Vue, components$25);
            }
        };
        vueUse(VuePlugin$26);
        var BvEvent = function() {
            function BvEvent(type) {
                var eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                classCallCheck(this, BvEvent);
                if (!type) {
                    throw new TypeError("Failed to construct '" + this.constructor.name + "'. 1 argument required, " + arguments.length + " given.");
                }
                assign(this, BvEvent.defaults(), eventInit, {
                    type: type
                });
                defineProperties(this, {
                    type: readonlyDescriptor(),
                    cancelable: readonlyDescriptor(),
                    nativeEvent: readonlyDescriptor(),
                    target: readonlyDescriptor(),
                    relatedTarget: readonlyDescriptor(),
                    vueTarget: readonlyDescriptor()
                });
                var defaultPrevented = false;
                this.preventDefault = function preventDefault() {
                    if (this.cancelable) {
                        defaultPrevented = true;
                    }
                };
                defineProperty$1(this, "defaultPrevented", {
                    enumerable: true,
                    get: function get$$1() {
                        return defaultPrevented;
                    }
                });
            }
            createClass(BvEvent, null, [ {
                key: "defaults",
                value: function defaults$$1() {
                    return {
                        type: "",
                        cancelable: true,
                        nativeEvent: null,
                        target: null,
                        relatedTarget: null,
                        vueTarget: null
                    };
                }
            } ]);
            return BvEvent;
        }();
        var Selector = {
            FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
            STICKY_CONTENT: ".sticky-top",
            NAVBAR_TOGGLER: ".navbar-toggler"
        };
        var OBSERVER_CONFIG = {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: [ "style", "class" ]
        };
        var bModal = {
            mixins: [ idMixin, listenOnRootMixin ],
            components: {
                bBtn: bBtn,
                bBtnClose: bBtnClose
            },
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var header = h(false);
                if (!this.hideHeader) {
                    var modalHeader = $slots["modal-header"];
                    if (!modalHeader) {
                        var closeButton = h(false);
                        if (!this.hideHeaderClose) {
                            closeButton = h("b-btn-close", {
                                props: {
                                    disabled: this.is_transitioning,
                                    ariaLabel: this.headerCloseLabel,
                                    textVariant: this.headerTextVariant
                                },
                                on: {
                                    click: function click(evt) {
                                        _this.hide("header-close");
                                    }
                                }
                            }, [ $slots["modal-header-close"] ]);
                        }
                        modalHeader = [ h(this.titleTag, {
                            class: [ "modal-title" ]
                        }, [ $slots["modal-title"] || this.title ]), closeButton ];
                    }
                    header = h("header", {
                        ref: "header",
                        class: this.headerClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_header_")
                        }
                    }, [ modalHeader ]);
                }
                var body = h("div", {
                    ref: "body",
                    class: this.bodyClasses,
                    attrs: {
                        id: this.safeId("__BV_modal_body_")
                    }
                }, [ $slots.default ]);
                var footer = h(false);
                if (!this.hideFooter) {
                    var modalFooter = $slots["modal-footer"];
                    if (!modalFooter) {
                        var cancelButton = h(false);
                        if (!this.okOnly) {
                            cancelButton = h("b-btn", {
                                props: {
                                    variant: this.cancelVariant,
                                    size: this.buttonSize,
                                    disabled: this.cancelDisabled || this.busy || this.is_transitioning
                                },
                                on: {
                                    click: function click(evt) {
                                        _this.hide("cancel");
                                    }
                                }
                            }, [ $slots["modal-cancel"] || this.cancelTitle ]);
                        }
                        var okButton = h("b-btn", {
                            props: {
                                variant: this.okVariant,
                                size: this.buttonSize,
                                disabled: this.okDisabled || this.busy || this.is_transitioning
                            },
                            on: {
                                click: function click(evt) {
                                    _this.hide("ok");
                                }
                            }
                        }, [ $slots["modal-ok"] || this.okTitle ]);
                        modalFooter = [ cancelButton, okButton ];
                    }
                    footer = h("footer", {
                        ref: "footer",
                        class: this.footerClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_footer_")
                        }
                    }, [ modalFooter ]);
                }
                var modalContent = h("div", {
                    ref: "content",
                    class: [ "modal-content" ],
                    attrs: {
                        tabindex: "-1",
                        role: "document",
                        "aria-labelledby": this.hideHeader ? null : this.safeId("__BV_modal_header_"),
                        "aria-describedby": this.safeId("__BV_modal_body_")
                    },
                    on: {
                        focusout: this.onFocusout,
                        click: function click(evt) {
                            evt.stopPropagation();
                            _this.$root.$emit("bv::dropdown::shown");
                        }
                    }
                }, [ header, body, footer ]);
                var modalDialog = h("div", {
                    class: this.dialogClasses
                }, [ modalContent ]);
                var modal = h("div", {
                    ref: "modal",
                    class: this.modalClasses,
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: this.is_visible,
                        expression: "is_visible"
                    } ],
                    attrs: {
                        id: this.safeId(),
                        role: "dialog",
                        "aria-hidden": this.is_visible ? null : "true"
                    },
                    on: {
                        click: this.onClickOut,
                        keydown: this.onEsc
                    }
                }, [ modalDialog ]);
                modal = h("transition", {
                    props: {
                        enterClass: "",
                        enterToClass: "",
                        enterActiveClass: "",
                        leaveClass: "",
                        leaveActiveClass: "",
                        leaveToClass: ""
                    },
                    on: {
                        "before-enter": this.onBeforeEnter,
                        enter: this.onEnter,
                        "after-enter": this.onAfterEnter,
                        "before-leave": this.onBeforeLeave,
                        leave: this.onLeave,
                        "after-leave": this.onAfterLeave
                    }
                }, [ modal ]);
                var backdrop = h(false);
                if (!this.hideBackdrop && (this.is_visible || this.is_transitioning)) {
                    backdrop = h("div", {
                        class: this.backdropClasses,
                        attrs: {
                            id: this.safeId("__BV_modal_backdrop_")
                        }
                    });
                }
                var outer = h(false);
                if (!this.is_hidden) {
                    outer = h("div", {
                        attrs: {
                            id: this.safeId("__BV_modal_outer_")
                        }
                    }, [ modal, backdrop ]);
                }
                return h("div", {}, [ outer ]);
            },
            data: function data() {
                return {
                    is_hidden: this.lazy || false,
                    is_visible: false,
                    is_transitioning: false,
                    is_show: false,
                    is_block: false,
                    scrollbarWidth: 0,
                    isBodyOverflowing: false,
                    return_focus: this.returnFocus || null
                };
            },
            model: {
                prop: "visible",
                event: "change"
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                titleTag: {
                    type: String,
                    default: "h5"
                },
                size: {
                    type: String,
                    default: "md"
                },
                centered: {
                    type: Boolean,
                    default: false
                },
                buttonSize: {
                    type: String,
                    default: ""
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                noCloseOnBackdrop: {
                    type: Boolean,
                    default: false
                },
                noCloseOnEsc: {
                    type: Boolean,
                    default: false
                },
                noEnforceFocus: {
                    type: Boolean,
                    default: false
                },
                headerBgVariant: {
                    type: String,
                    default: null
                },
                headerBorderVariant: {
                    type: String,
                    default: null
                },
                headerTextVariant: {
                    type: String,
                    default: null
                },
                headerClass: {
                    type: [ String, Array ],
                    default: null
                },
                bodyBgVariant: {
                    type: String,
                    default: null
                },
                bodyTextVariant: {
                    type: String,
                    default: null
                },
                modalClass: {
                    type: [ String, Array ],
                    default: null
                },
                bodyClass: {
                    type: [ String, Array ],
                    default: null
                },
                footerBgVariant: {
                    type: String,
                    default: null
                },
                footerBorderVariant: {
                    type: String,
                    default: null
                },
                footerTextVariant: {
                    type: String,
                    default: null
                },
                footerClass: {
                    type: [ String, Array ],
                    default: null
                },
                hideHeader: {
                    type: Boolean,
                    default: false
                },
                hideFooter: {
                    type: Boolean,
                    default: false
                },
                hideHeaderClose: {
                    type: Boolean,
                    default: false
                },
                hideBackdrop: {
                    type: Boolean,
                    default: false
                },
                okOnly: {
                    type: Boolean,
                    default: false
                },
                okDisabled: {
                    type: Boolean,
                    default: false
                },
                cancelDisabled: {
                    type: Boolean,
                    default: false
                },
                visible: {
                    type: Boolean,
                    default: false
                },
                returnFocus: {
                    default: null
                },
                headerCloseLabel: {
                    type: String,
                    default: "Close"
                },
                cancelTitle: {
                    type: String,
                    default: "Cancel"
                },
                okTitle: {
                    type: String,
                    default: "OK"
                },
                cancelVariant: {
                    type: String,
                    default: "secondary"
                },
                okVariant: {
                    type: String,
                    default: "primary"
                },
                lazy: {
                    type: Boolean,
                    default: false
                },
                busy: {
                    type: Boolean,
                    default: false
                }
            },
            computed: {
                modalClasses: function modalClasses() {
                    return [ "modal", {
                        fade: !this.noFade,
                        show: this.is_show,
                        "d-block": this.is_block
                    }, this.modalClass ];
                },
                dialogClasses: function dialogClasses() {
                    var _ref;
                    return [ "modal-dialog", (_ref = {}, defineProperty(_ref, "modal-" + this.size, Boolean(this.size)), 
                    defineProperty(_ref, "modal-dialog-centered", this.centered), _ref) ];
                },
                backdropClasses: function backdropClasses() {
                    return [ "modal-backdrop", {
                        fade: !this.noFade,
                        show: this.is_show || this.noFade
                    } ];
                },
                headerClasses: function headerClasses() {
                    var _ref2;
                    return [ "modal-header", (_ref2 = {}, defineProperty(_ref2, "bg-" + this.headerBgVariant, Boolean(this.headerBgVariant)), 
                    defineProperty(_ref2, "text-" + this.headerTextVariant, Boolean(this.headerTextVariant)), 
                    defineProperty(_ref2, "border-" + this.headerBorderVariant, Boolean(this.headerBorderVariant)), 
                    _ref2), this.headerClass ];
                },
                bodyClasses: function bodyClasses() {
                    var _ref3;
                    return [ "modal-body", (_ref3 = {}, defineProperty(_ref3, "bg-" + this.bodyBgVariant, Boolean(this.bodyBgVariant)), 
                    defineProperty(_ref3, "text-" + this.bodyTextVariant, Boolean(this.bodyTextVariant)), 
                    _ref3), this.bodyClass ];
                },
                footerClasses: function footerClasses() {
                    var _ref4;
                    return [ "modal-footer", (_ref4 = {}, defineProperty(_ref4, "bg-" + this.footerBgVariant, Boolean(this.footerBgVariant)), 
                    defineProperty(_ref4, "text-" + this.footerTextVariant, Boolean(this.footerTextVariant)), 
                    defineProperty(_ref4, "border-" + this.footerBorderVariant, Boolean(this.footerBorderVariant)), 
                    _ref4), this.footerClass ];
                }
            },
            watch: {
                visible: function visible(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    this[newVal ? "show" : "hide"]();
                }
            },
            methods: {
                show: function show() {
                    if (this.is_visible) {
                        return;
                    }
                    var showEvt = new BvEvent("show", {
                        cancelable: true,
                        vueTarget: this,
                        target: this.$refs.modal,
                        relatedTarget: null
                    });
                    this.emitEvent(showEvt);
                    if (showEvt.defaultPrevented || this.is_visible) {
                        return;
                    }
                    if (hasClass(document.body, "modal-open")) {
                        this.$root.$once("bv::modal::hidden", this.doShow);
                    } else {
                        this.doShow();
                    }
                },
                hide: function hide(trigger) {
                    if (!this.is_visible) {
                        return;
                    }
                    var hideEvt = new BvEvent("hide", {
                        cancelable: true,
                        vueTarget: this,
                        target: this.$refs.modal,
                        relatedTarget: null,
                        isOK: trigger || null,
                        trigger: trigger || null,
                        cancel: function cancel() {
                            warn("b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().");
                            this.preventDefault();
                        }
                    });
                    if (trigger === "ok") {
                        this.$emit("ok", hideEvt);
                    } else if (trigger === "cancel") {
                        this.$emit("cancel", hideEvt);
                    }
                    this.emitEvent(hideEvt);
                    if (hideEvt.defaultPrevented || !this.is_visible) {
                        return;
                    }
                    if (this._observer) {
                        this._observer.disconnect();
                        this._observer = null;
                    }
                    this.is_visible = false;
                    this.$emit("change", false);
                },
                doShow: function doShow() {
                    var _this2 = this;
                    this.is_hidden = false;
                    this.$nextTick(function() {
                        _this2.is_visible = true;
                        _this2.$emit("change", true);
                        _this2._observer = observeDOM(_this2.$refs.content, _this2.adjustDialog.bind(_this2), OBSERVER_CONFIG);
                    });
                },
                onBeforeEnter: function onBeforeEnter() {
                    this.is_transitioning = true;
                    this.checkScrollbar();
                    this.setScrollbar();
                    this.adjustDialog();
                    addClass(document.body, "modal-open");
                    this.setResizeEvent(true);
                },
                onEnter: function onEnter() {
                    this.is_block = true;
                    this.$refs.modal.scrollTop = 0;
                },
                onAfterEnter: function onAfterEnter() {
                    var _this3 = this;
                    this.is_show = true;
                    this.is_transitioning = false;
                    this.$nextTick(function() {
                        _this3.focusFirst();
                        var shownEvt = new BvEvent("shown", {
                            cancelable: false,
                            vueTarget: _this3,
                            target: _this3.$refs.modal,
                            relatedTarget: null
                        });
                        _this3.emitEvent(shownEvt);
                    });
                },
                onBeforeLeave: function onBeforeLeave() {
                    this.is_transitioning = true;
                    this.setResizeEvent(false);
                },
                onLeave: function onLeave() {
                    this.is_show = false;
                },
                onAfterLeave: function onAfterLeave() {
                    var _this4 = this;
                    this.is_block = false;
                    this.resetAdjustments();
                    this.resetScrollbar();
                    this.is_transitioning = false;
                    removeClass(document.body, "modal-open");
                    this.$nextTick(function() {
                        _this4.is_hidden = _this4.lazy || false;
                        _this4.returnFocusTo();
                        var hiddenEvt = new BvEvent("hidden", {
                            cancelable: false,
                            vueTarget: _this4,
                            target: _this4.lazy ? null : _this4.$refs.modal,
                            relatedTarget: null
                        });
                        _this4.emitEvent(hiddenEvt);
                    });
                },
                emitEvent: function emitEvent(bvEvt) {
                    var type = bvEvt.type;
                    this.$emit(type, bvEvt);
                    this.$root.$emit("bv::modal::" + type, bvEvt);
                },
                onClickOut: function onClickOut(evt) {
                    if (this.is_visible && !this.noCloseOnBackdrop) {
                        this.hide("backdrop");
                    }
                },
                onEsc: function onEsc(evt) {
                    if (evt.keyCode === KeyCodes.ESC && this.is_visible && !this.noCloseOnEsc) {
                        this.hide("esc");
                    }
                },
                onFocusout: function onFocusout(evt) {
                    var content = this.$refs.content;
                    if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                        content.focus();
                    }
                },
                setResizeEvent: function setResizeEvent(on) {
                    var _this5 = this;
                    [ "resize", "orientationchange" ].forEach(function(evtName) {
                        if (on) {
                            eventOn(window, evtName, _this5.adjustDialog);
                        } else {
                            eventOff(window, evtName, _this5.adjustDialog);
                        }
                    });
                },
                showHandler: function showHandler(id, triggerEl) {
                    if (id === this.id) {
                        this.return_focus = triggerEl || null;
                        this.show();
                    }
                },
                hideHandler: function hideHandler(id) {
                    if (id === this.id) {
                        this.hide();
                    }
                },
                modalListener: function modalListener(bvEvt) {
                    if (bvEvt.vueTarget !== this) {
                        this.hide();
                    }
                },
                focusFirst: function focusFirst() {
                    if (typeof document === "undefined") {
                        return;
                    }
                    var content = this.$refs.content;
                    var modal = this.$refs.modal;
                    var activeElement = document.activeElement;
                    if (activeElement && content && content.contains(activeElement)) {} else if (content) {
                        if (modal) {
                            modal.scrollTop = 0;
                        }
                        content.focus();
                    }
                },
                returnFocusTo: function returnFocusTo() {
                    var el = this.returnFocus || this.return_focus || null;
                    if (typeof el === "string") {
                        el = select(el);
                    }
                    if (el) {
                        el = el.$el || el;
                        if (isVisible(el)) {
                            el.focus();
                        }
                    }
                },
                getScrollbarWidth: function getScrollbarWidth() {
                    var scrollDiv = document.createElement("div");
                    scrollDiv.className = "modal-scrollbar-measure";
                    document.body.appendChild(scrollDiv);
                    this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                },
                adjustDialog: function adjustDialog() {
                    if (!this.is_visible) {
                        return;
                    }
                    var modal = this.$refs.modal;
                    var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
                    if (!this.isBodyOverflowing && isModalOverflowing) {
                        modal.style.paddingLeft = this.scrollbarWidth + "px";
                    }
                    if (this.isBodyOverflowing && !isModalOverflowing) {
                        modal.style.paddingRight = this.scrollbarWidth + "px";
                    }
                },
                resetAdjustments: function resetAdjustments() {
                    var modal = this.$refs.modal;
                    if (modal) {
                        modal.style.paddingLeft = "";
                        modal.style.paddingRight = "";
                    }
                },
                checkScrollbar: function checkScrollbar() {
                    var rect = getBCR(document.body);
                    this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
                },
                setScrollbar: function setScrollbar() {
                    if (this.isBodyOverflowing) {
                        var computedStyle = window.getComputedStyle;
                        var body = document.body;
                        var scrollbarWidth = this.scrollbarWidth;
                        selectAll(Selector.FIXED_CONTENT).forEach(function(el) {
                            var actualPadding = el.style.paddingRight;
                            var calculatedPadding = computedStyle(el).paddingRight || 0;
                            setAttr(el, "data-padding-right", actualPadding);
                            el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + "px";
                        });
                        selectAll(Selector.STICKY_CONTENT).forEach(function(el) {
                            var actualMargin = el.style.marginRight;
                            var calculatedMargin = computedStyle(el).marginRight || 0;
                            setAttr(el, "data-margin-right", actualMargin);
                            el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + "px";
                        });
                        selectAll(Selector.NAVBAR_TOGGLER).forEach(function(el) {
                            var actualMargin = el.style.marginRight;
                            var calculatedMargin = computedStyle(el).marginRight || 0;
                            setAttr(el, "data-margin-right", actualMargin);
                            el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + "px";
                        });
                        var actualPadding = body.style.paddingRight;
                        var calculatedPadding = computedStyle(body).paddingRight;
                        setAttr(body, "data-padding-right", actualPadding);
                        body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + "px";
                    }
                },
                resetScrollbar: function resetScrollbar() {
                    selectAll(Selector.FIXED_CONTENT).forEach(function(el) {
                        if (hasAttr(el, "data-padding-right")) {
                            el.style.paddingRight = getAttr(el, "data-padding-right") || "";
                            removeAttr(el, "data-padding-right");
                        }
                    });
                    selectAll(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).forEach(function(el) {
                        if (hasAttr(el, "data-margin-right")) {
                            el.style.marginRight = getAttr(el, "data-margin-right") || "";
                            removeAttr(el, "data-margin-right");
                        }
                    });
                    var body = document.body;
                    if (hasAttr(body, "data-padding-right")) {
                        body.style.paddingRight = getAttr(body, "data-padding-right") || "";
                        removeAttr(body, "data-padding-right");
                    }
                }
            },
            created: function created() {
                this._observer = null;
            },
            mounted: function mounted() {
                this.getScrollbarWidth();
                this.listenOnRoot("bv::show::modal", this.showHandler);
                this.listenOnRoot("bv::hide::modal", this.hideHandler);
                this.listenOnRoot("bv::modal::show", this.modalListener);
                if (this.visible === true) {
                    this.show();
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (this._observer) {
                    this._observer.disconnect();
                    this._observer = null;
                }
                this.setResizeEvent(false);
                removeClass(document.body, "modal-open");
                this.resetAdjustments();
                this.resetScrollbar();
            }
        };
        var listenTypes$1 = {
            click: true
        };
        var bModal$1 = {
            bind: function bind(el, binding, vnode) {
                bindTargets(vnode, binding, listenTypes$1, function(_ref) {
                    var targets = _ref.targets, vnode = _ref.vnode;
                    targets.forEach(function(target) {
                        vnode.context.$root.$emit("bv::show::modal", target, vnode.elm);
                    });
                });
                if (el.tagName !== "BUTTON") {
                    setAttr(el, "role", "button");
                }
            },
            unbind: function unbind(el, binding, vnode) {
                unbindTargets(vnode, binding, listenTypes$1);
                if (el.tagName !== "BUTTON") {
                    removeAttr(el, "role", "button");
                }
            }
        };
        var directives$1 = {
            bModal: bModal$1
        };
        var VuePlugin$27 = {
            install: function install(Vue) {
                registerDirectives(Vue, directives$1);
            }
        };
        vueUse(VuePlugin$27);
        var components$26 = {
            bModal: bModal
        };
        var VuePlugin$28 = {
            install: function install(Vue) {
                registerComponents(Vue, components$26);
                Vue.use(VuePlugin$27);
            }
        };
        vueUse(VuePlugin$28);
        var props$36 = {
            tag: {
                type: String,
                default: "ul"
            },
            fill: {
                type: Boolean,
                default: false
            },
            justified: {
                type: Boolean,
                default: false
            },
            tabs: {
                type: Boolean,
                default: false
            },
            pills: {
                type: Boolean,
                default: false
            },
            vertical: {
                type: Boolean,
                default: false
            },
            isNavBar: {
                type: Boolean,
                default: false
            }
        };
        var bNav = {
            functional: true,
            props: props$36,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                if (props.isNavBar) {
                    warn("b-nav: Prop 'is-nav-bar' is deprecated. Please use component '<b-navbar-nav>' instead.");
                }
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    class: {
                        nav: !props.isNavBar,
                        "navbar-nav": props.isNavBar,
                        "nav-tabs": props.tabs && !props.isNavBar,
                        "nav-pills": props.pills && !props.isNavBar,
                        "flex-column": props.vertical && !props.isNavBar,
                        "nav-fill": props.fill,
                        "nav-justified": props.justified
                    }
                }), children);
            }
        };
        var props$37 = propsFactory();
        var bNavItem = {
            functional: true,
            props: props$37,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h("li", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "nav-item"
                }), [ h(bLink, {
                    staticClass: "nav-link",
                    props: props
                }, children) ]);
            }
        };
        var props$38 = {
            tag: {
                type: String,
                default: "span"
            }
        };
        var bNavText = {
            functional: true,
            props: props$38,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-text"
                }), children);
            }
        };
        var bNavForm = {
            functional: true,
            props: {
                id: {
                    type: String,
                    default: null
                }
            },
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(Form, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    attrs: {
                        id: props.id
                    },
                    props: {
                        inline: true
                    }
                }), children);
            }
        };
        var bNavItemDropdown = {
            mixins: [ idMixin, dropdownMixin ],
            render: function render(h) {
                var button = h("a", {
                    class: this.toggleClasses,
                    ref: "toggle",
                    attrs: {
                        href: "#",
                        id: this.safeId("_BV_button_"),
                        disabled: this.disabled,
                        "aria-haspopup": "true",
                        "aria-expanded": this.visible ? "true" : "false"
                    },
                    on: {
                        click: this.toggle,
                        keydown: this.toggle
                    }
                }, [ this.$slots["button-content"] || this.$slots.text || h("span", {
                    domProps: {
                        innerHTML: this.text
                    }
                }) ]);
                var menu = h("div", {
                    class: this.menuClasses,
                    ref: "menu",
                    attrs: {
                        "aria-labelledby": this.safeId("_BV_button_")
                    },
                    on: {
                        mouseover: this.onMouseOver,
                        keydown: this.onKeydown
                    }
                }, [ this.$slots.default ]);
                return h("li", {
                    attrs: {
                        id: this.safeId()
                    },
                    class: this.dropdownClasses
                }, [ button, menu ]);
            },
            computed: {
                isNav: function isNav() {
                    return true;
                },
                dropdownClasses: function dropdownClasses() {
                    return [ "nav-item", "b-nav-dropdown", "dropdown", this.dropup ? "dropup" : "", this.visible ? "show" : "" ];
                },
                toggleClasses: function toggleClasses() {
                    return [ "nav-link", this.noCaret ? "" : "dropdown-toggle", this.disabled ? "disabled" : "", this.extraToggleClasses ? this.extraToggleClasses : "" ];
                },
                menuClasses: function menuClasses() {
                    return [ "dropdown-menu", this.right ? "dropdown-menu-right" : "dropdown-menu-left", this.visible ? "show" : "", this.extraMenuClasses ? this.extraMenuClasses : "" ];
                }
            },
            props: {
                noCaret: {
                    type: Boolean,
                    default: false
                },
                extraToggleClasses: {
                    type: String,
                    default: ""
                },
                extraMenuClasses: {
                    type: String,
                    default: ""
                },
                role: {
                    type: String,
                    default: "menu"
                }
            }
        };
        var components$27 = {
            bNav: bNav,
            bNavItem: bNavItem,
            bNavText: bNavText,
            bNavForm: bNavForm,
            bNavItemDropdown: bNavItemDropdown,
            bNavItemDd: bNavItemDropdown,
            bNavDropdown: bNavItemDropdown,
            bNavDd: bNavItemDropdown
        };
        var VuePlugin$29 = {
            install: function install(Vue) {
                registerComponents(Vue, components$27);
                Vue.use(VuePlugin$12);
            }
        };
        vueUse(VuePlugin$29);
        var props$39 = {
            tag: {
                type: String,
                default: "nav"
            },
            type: {
                type: String,
                default: "light"
            },
            variant: {
                type: String
            },
            toggleable: {
                type: [ Boolean, String ],
                default: false
            },
            toggleBreakpoint: {
                type: String,
                default: null
            },
            fixed: {
                type: String
            },
            sticky: {
                type: Boolean,
                default: false
            }
        };
        var bNavbar = {
            functional: true,
            props: props$39,
            render: function render(h, _ref) {
                var _class;
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var breakpoint = props.toggleBreakpoint || (props.toggleable === true ? "sm" : props.toggleable) || "sm";
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar",
                    class: (_class = {}, defineProperty(_class, "navbar-" + props.type, Boolean(props.type)), 
                    defineProperty(_class, "bg-" + props.variant, Boolean(props.variant)), defineProperty(_class, "fixed-" + props.fixed, Boolean(props.fixed)), 
                    defineProperty(_class, "sticky-top", props.sticky), defineProperty(_class, "navbar-expand-" + breakpoint, props.toggleable !== false), 
                    _class)
                }), children);
            }
        };
        var props$40 = {
            tag: {
                type: String,
                default: "ul"
            },
            fill: {
                type: Boolean,
                default: false
            },
            justified: {
                type: Boolean,
                default: false
            }
        };
        var bNavbarNav = {
            functional: true,
            props: props$40,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-nav",
                    class: {
                        "nav-fill": props.fill,
                        "nav-justified": props.justified
                    }
                }), children);
            }
        };
        var linkProps$3 = propsFactory();
        linkProps$3.href.default = undefined;
        linkProps$3.to.default = undefined;
        var props$41 = assign(linkProps$3, {
            tag: {
                type: String,
                default: "div"
            }
        });
        var bNavbarBrand = {
            functional: true,
            props: props$41,
            render: function render(h, _ref) {
                var props = _ref.props, data = _ref.data, children = _ref.children;
                var isLink = Boolean(props.to || props.href);
                var tag = isLink ? bLink : props.tag;
                return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a"])(data, {
                    staticClass: "navbar-brand",
                    props: isLink ? pluckProps(linkProps$3, props) : {}
                }), children);
            }
        };
        var bNavbarToggle = {
            mixins: [ listenOnRootMixin ],
            render: function render(h) {
                return h("button", {
                    class: [ "navbar-toggler" ],
                    attrs: {
                        type: "button",
                        "aria-label": this.label,
                        "aria-controls": this.target,
                        "aria-expanded": this.toggleState ? "true" : "false"
                    },
                    on: {
                        click: this.onClick
                    }
                }, [ this.$slots.default || h("span", {
                    class: [ "navbar-toggler-icon" ]
                }) ]);
            },
            data: function data() {
                return {
                    toggleState: false
                };
            },
            props: {
                label: {
                    type: String,
                    default: "Toggle navigation"
                },
                target: {
                    type: String,
                    required: true
                }
            },
            methods: {
                onClick: function onClick() {
                    this.$root.$emit("bv::toggle::collapse", this.target);
                },
                handleStateEvt: function handleStateEvt(id, state) {
                    if (id === this.target) {
                        this.toggleState = state;
                    }
                }
            },
            created: function created() {
                this.listenOnRoot("bv::collapse::state", this.handleStateEvt);
            }
        };
        var components$28 = {
            bNavbar: bNavbar,
            bNavbarNav: bNavbarNav,
            bNavbarBrand: bNavbarBrand,
            bNavbarToggle: bNavbarToggle,
            bNavToggle: bNavbarToggle
        };
        var VuePlugin$30 = {
            install: function install(Vue) {
                registerComponents(Vue, components$28);
                Vue.use(VuePlugin$29);
                Vue.use(VuePlugin$11);
                Vue.use(VuePlugin$12);
            }
        };
        vueUse(VuePlugin$30);
        var range = function(length) {
            return Array.apply(null, {
                length: length
            });
        };
        function makePageArray(startNum, numPages) {
            return range(numPages).map(function(value, index) {
                return {
                    number: index + startNum,
                    className: null
                };
            });
        }
        var ELLIPSIS_THRESHOLD = 3;
        var props$42 = {
            disabled: {
                type: Boolean,
                default: false
            },
            value: {
                type: Number,
                default: 1
            },
            limit: {
                type: Number,
                default: 5
            },
            size: {
                type: String,
                default: "md"
            },
            align: {
                type: String,
                default: "left"
            },
            hideGotoEndButtons: {
                type: Boolean,
                default: false
            },
            ariaLabel: {
                type: String,
                default: "Pagination"
            },
            labelFirstPage: {
                type: String,
                default: "Goto first page"
            },
            firstText: {
                type: String,
                default: "&laquo;"
            },
            labelPrevPage: {
                type: String,
                default: "Goto previous page"
            },
            prevText: {
                type: String,
                default: "&lsaquo;"
            },
            labelNextPage: {
                type: String,
                default: "Goto next page"
            },
            nextText: {
                type: String,
                default: "&rsaquo;"
            },
            labelLastPage: {
                type: String,
                default: "Goto last page"
            },
            lastText: {
                type: String,
                default: "&raquo;"
            },
            labelPage: {
                type: String,
                default: "Goto page"
            },
            hideEllipsis: {
                type: Boolean,
                default: false
            },
            ellipsisText: {
                type: String,
                default: "&hellip;"
            }
        };
        var paginationMixin = {
            components: {
                bLink: bLink
            },
            data: function data() {
                return {
                    showFirstDots: false,
                    showLastDots: false,
                    currentPage: this.value
                };
            },
            props: props$42,
            render: function render(h) {
                var _this = this;
                var buttons = [];
                var makeEndBtns = function makeEndBtns(linkTo, ariaLabel, btnText, pageTest) {
                    var button = void 0;
                    pageTest = pageTest || linkTo;
                    if (_this.disabled || _this.isActive(pageTest)) {
                        button = h("li", {
                            class: [ "page-item", "disabled" ],
                            attrs: {
                                role: "none presentation",
                                "aria-hidden": "true"
                            }
                        }, [ h("span", {
                            class: [ "page-link" ],
                            domProps: {
                                innerHTML: btnText
                            }
                        }) ]);
                    } else {
                        button = h("li", {
                            class: [ "page-item" ],
                            attrs: {
                                role: "none presentation"
                            }
                        }, [ h("b-link", {
                            class: [ "page-link" ],
                            props: _this.linkProps(linkTo),
                            attrs: {
                                role: "menuitem",
                                tabindex: "-1",
                                "aria-label": ariaLabel,
                                "aria-controls": _this.ariaControls || null
                            },
                            on: {
                                click: function click(evt) {
                                    _this.onClick(linkTo, evt);
                                },
                                keydown: function keydown(evt) {
                                    if (evt.keyCode === KeyCodes.SPACE) {
                                        evt.preventDefault();
                                        _this.onClick(linkTo, evt);
                                    }
                                }
                            }
                        }, [ h("span", {
                            attrs: {
                                "aria-hidden": "true"
                            },
                            domProps: {
                                innerHTML: btnText
                            }
                        }) ]) ]);
                    }
                    return button;
                };
                var makeEllipsis = function makeEllipsis() {
                    return h("li", {
                        class: [ "page-item", "disabled", "d-none", "d-sm-flex" ],
                        attrs: {
                            role: "separator"
                        }
                    }, [ h("span", {
                        class: [ "page-link" ],
                        domProps: {
                            innerHTML: _this.ellipsisText
                        }
                    }) ]);
                };
                buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(1, this.labelFirstPage, this.firstText));
                buttons.push(makeEndBtns(this.currentPage - 1, this.labelPrevPage, this.prevText, 1));
                buttons.push(this.showFirstDots ? makeEllipsis() : h(false));
                this.pageList.forEach(function(page) {
                    var inner = void 0;
                    var pageNum = _this.makePage(page.number);
                    if (_this.disabled) {
                        inner = h("span", {
                            class: [ "page-link" ],
                            domProps: {
                                innerHTML: pageNum
                            }
                        });
                    } else {
                        var active = _this.isActive(page.number);
                        inner = h("b-link", {
                            class: _this.pageLinkClasses(page),
                            props: _this.linkProps(page.number),
                            attrs: {
                                role: "menuitemradio",
                                tabindex: active ? "0" : "-1",
                                "aria-controls": _this.ariaControls || null,
                                "aria-label": _this.labelPage + " " + page.number,
                                "aria-checked": active ? "true" : "false",
                                "aria-posinset": page.number,
                                "aria-setsize": _this.numberOfPages
                            },
                            domProps: {
                                innerHTML: pageNum
                            },
                            on: {
                                click: function click(evt) {
                                    _this.onClick(page.number, evt);
                                },
                                keydown: function keydown(evt) {
                                    if (evt.keyCode === KeyCodes.SPACE) {
                                        evt.preventDefault();
                                        _this.onClick(page.number, evt);
                                    }
                                }
                            }
                        });
                    }
                    buttons.push(h("li", {
                        key: page.number,
                        class: _this.pageItemClasses(page),
                        attrs: {
                            role: "none presentation"
                        }
                    }, [ inner ]));
                });
                buttons.push(this.showLastDots ? makeEllipsis() : h(false));
                buttons.push(makeEndBtns(this.currentPage + 1, this.labelNextPage, this.nextText, this.numberOfPages));
                buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(this.numberOfPages, this.labelLastPage, this.lastText));
                var pagination = h("ul", {
                    ref: "ul",
                    class: [ "pagination", "b-pagination", this.btnSize, this.alignment ],
                    attrs: {
                        role: "menubar",
                        "aria-disabled": this.disabled ? "true" : "false",
                        "aria-label": this.ariaLabel || null
                    },
                    on: {
                        keydown: function keydown(evt) {
                            var keyCode = evt.keyCode;
                            var shift = evt.shiftKey;
                            if (keyCode === KeyCodes.LEFT) {
                                evt.preventDefault();
                                shift ? _this.focusFirst() : _this.focusPrev();
                            } else if (keyCode === KeyCodes.RIGHT) {
                                evt.preventDefault();
                                shift ? _this.focusLast() : _this.focusNext();
                            }
                        }
                    }
                }, buttons);
                return this.isNav ? h("nav", {}, [ pagination ]) : pagination;
            },
            watch: {
                currentPage: function currentPage(newPage, oldPage) {
                    if (newPage !== oldPage) {
                        this.$emit("input", newPage);
                    }
                },
                value: function value(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        this.currentPage = newValue;
                    }
                }
            },
            computed: {
                btnSize: function btnSize() {
                    return this.size ? "pagination-" + this.size : "";
                },
                alignment: function alignment() {
                    if (this.align === "center") {
                        return "justify-content-center";
                    } else if (this.align === "end" || this.align === "right") {
                        return "justify-content-end";
                    }
                    return "";
                },
                pageList: function pageList() {
                    if (this.currentPage > this.numberOfPages) {
                        this.currentPage = this.numberOfPages;
                    } else if (this.currentPage < 1) {
                        this.currentPage = 1;
                    }
                    this.showFirstDots = false;
                    this.showLastDots = false;
                    var numLinks = this.limit;
                    var startNum = 1;
                    if (this.numberOfPages <= this.limit) {
                        numLinks = this.numberOfPages;
                    } else if (this.currentPage < this.limit - 1 && this.limit > ELLIPSIS_THRESHOLD) {
                        if (!this.hideEllipsis) {
                            numLinks = this.limit - 1;
                            this.showLastDots = true;
                        }
                    } else if (this.numberOfPages - this.currentPage + 2 < this.limit && this.limit > ELLIPSIS_THRESHOLD) {
                        if (!this.hideEllipsis) {
                            this.showFirstDots = true;
                            numLinks = this.limit - 1;
                        }
                        startNum = this.numberOfPages - numLinks + 1;
                    } else {
                        if (this.limit > ELLIPSIS_THRESHOLD && !this.hideEllipsis) {
                            this.showFirstDots = true;
                            this.showLastDots = true;
                            numLinks = this.limit - 2;
                        }
                        startNum = this.currentPage - Math.floor(numLinks / 2);
                    }
                    if (startNum < 1) {
                        startNum = 1;
                    } else if (startNum > this.numberOfPages - numLinks) {
                        startNum = this.numberOfPages - numLinks + 1;
                    }
                    var pages = makePageArray(startNum, numLinks);
                    if (pages.length > 3) {
                        var idx = this.currentPage - startNum;
                        if (idx === 0) {
                            for (var i = 3; i < pages.length; i++) {
                                pages[i].className = "d-none d-sm-flex";
                            }
                        } else if (idx === pages.length - 1) {
                            for (var _i = 0; _i < pages.length - 3; _i++) {
                                pages[_i].className = "d-none d-sm-flex";
                            }
                        } else {
                            for (var _i2 = 0; _i2 < idx - 1; _i2++) {
                                pages[_i2].className = "d-none d-sm-flex";
                            }
                            for (var _i3 = pages.length - 1; _i3 > idx + 1; _i3--) {
                                pages[_i3].className = "d-none d-sm-flex";
                            }
                        }
                    }
                    return pages;
                }
            },
            methods: {
                isActive: function isActive(pagenum) {
                    return pagenum === this.currentPage;
                },
                pageItemClasses: function pageItemClasses(page) {
                    return [ "page-item", this.disabled ? "disabled" : "", this.isActive(page.number) ? "active" : "", page.className ];
                },
                pageLinkClasses: function pageLinkClasses(page) {
                    return [ "page-link", this.disabled ? "disabled" : "", this.isActive(page.number) ? "btn-primary" : "" ];
                },
                getButtons: function getButtons() {
                    return selectAll("a.page-link", this.$el).filter(function(btn) {
                        return isVisible(btn);
                    });
                },
                setBtnFocus: function setBtnFocus(btn) {
                    this.$nextTick(function() {
                        btn.focus();
                    });
                },
                focusCurrent: function focusCurrent() {
                    var _this2 = this;
                    var btn = this.getButtons().find(function(el) {
                        return parseInt(getAttr(el, "aria-posinset"), 10) === _this2.currentPage;
                    });
                    if (btn && btn.focus) {
                        this.setBtnFocus(btn);
                    } else {
                        this.focusFirst();
                    }
                },
                focusFirst: function focusFirst() {
                    var btn = this.getButtons().find(function(el) {
                        return !isDisabled(el);
                    });
                    if (btn && btn.focus && btn !== document.activeElement) {
                        this.setBtnFocus(btn);
                    }
                },
                focusLast: function focusLast() {
                    var btn = this.getButtons().reverse().find(function(el) {
                        return !isDisabled(el);
                    });
                    if (btn && btn.focus && btn !== document.activeElement) {
                        this.setBtnFocus(btn);
                    }
                },
                focusPrev: function focusPrev() {
                    var buttons = this.getButtons();
                    var idx = buttons.indexOf(document.activeElement);
                    if (idx > 0 && !isDisabled(buttons[idx - 1]) && buttons[idx - 1].focus) {
                        this.setBtnFocus(buttons[idx - 1]);
                    }
                },
                focusNext: function focusNext() {
                    var buttons = this.getButtons();
                    var idx = buttons.indexOf(document.activeElement);
                    var cnt = buttons.length - 1;
                    if (idx < cnt && !isDisabled(buttons[idx + 1]) && buttons[idx + 1].focus) {
                        this.setBtnFocus(buttons[idx + 1]);
                    }
                }
            }
        };
        var props$43 = {
            perPage: {
                type: Number,
                default: 20
            },
            totalRows: {
                type: Number,
                default: 20
            },
            ariaControls: {
                type: String,
                default: null
            }
        };
        var bPagination = {
            mixins: [ paginationMixin ],
            props: props$43,
            computed: {
                numberOfPages: function numberOfPages() {
                    var result = Math.ceil(this.totalRows / this.perPage);
                    return result < 1 ? 1 : result;
                }
            },
            methods: {
                onClick: function onClick(num, evt) {
                    var _this = this;
                    if (num > this.numberOfPages) {
                        num = this.numberOfPages;
                    } else if (num < 1) {
                        num = 1;
                    }
                    this.currentPage = num;
                    this.$nextTick(function() {
                        var target = evt.target;
                        if (isVisible(target) && _this.$el.contains(target) && target.focus) {
                            target.focus();
                        } else {
                            _this.focusCurrent();
                        }
                    });
                    this.$emit("change", this.currentPage);
                },
                makePage: function makePage(pagenum) {
                    return pagenum;
                },
                linkProps: function linkProps(pagenum) {
                    return {
                        href: "#"
                    };
                }
            }
        };
        var components$29 = {
            bPagination: bPagination
        };
        var VuePlugin$31 = {
            install: function install(Vue) {
                registerComponents(Vue, components$29);
            }
        };
        vueUse(VuePlugin$31);
        var routerProps = pickLinkProps("activeClass", "exactActiveClass", "append", "exact", "replace", "target", "rel");
        var props$44 = assign({
            numberOfPages: {
                type: Number,
                default: 1
            },
            baseUrl: {
                type: String,
                default: "/"
            },
            useRouter: {
                type: Boolean,
                default: false
            },
            linkGen: {
                type: Function,
                default: null
            },
            pageGen: {
                type: Function,
                default: null
            }
        }, routerProps);
        var bPaginationNav = {
            mixins: [ paginationMixin ],
            props: props$44,
            computed: {
                isNav: function isNav() {
                    return true;
                }
            },
            methods: {
                onClick: function onClick(pageNum, evt) {
                    this.currentPage = pageNum;
                },
                makePage: function makePage(pagenum) {
                    if (this.pageGen && typeof this.pageGen === "function") {
                        return this.pageGen(pagenum);
                    }
                    return pagenum;
                },
                makeLink: function makeLink(pagenum) {
                    if (this.linkGen && typeof this.linkGen === "function") {
                        return this.linkGen(pagenum);
                    }
                    var link = "" + this.baseUrl + pagenum;
                    return this.useRouter ? {
                        path: link
                    } : link;
                },
                linkProps: function linkProps(pagenum) {
                    var link = this.makeLink(pagenum);
                    var props = {
                        href: typeof link === "string" ? link : void 0,
                        target: this.target || null,
                        rel: this.rel || null,
                        disabled: this.disabled
                    };
                    if (this.useRouter || (typeof link === "undefined" ? "undefined" : _typeof(link)) === "object") {
                        props = assign(props, {
                            to: link,
                            exact: this.exact,
                            activeClass: this.activeClass,
                            exactActiveClass: this.exactActiveClass,
                            append: this.append,
                            replace: this.replace
                        });
                    }
                    return props;
                }
            }
        };
        var components$30 = {
            bPaginationNav: bPaginationNav
        };
        var VuePlugin$32 = {
            install: function install(Vue) {
                registerComponents(Vue, components$30);
            }
        };
        vueUse(VuePlugin$32);
        var NAME = "tooltip";
        var CLASS_PREFIX = "bs-tooltip";
        var BSCLS_PREFIX_REGEX = new RegExp("\\b" + CLASS_PREFIX + "\\S+", "g");
        var TRANSITION_DURATION = 150;
        var MODAL_CLOSE_EVENT = "bv::modal::hidden";
        var MODAL_CLASS = ".modal-content";
        var AttachmentMap$1 = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left",
            TOPLEFT: "top",
            TOPRIGHT: "top",
            RIGHTTOP: "right",
            RIGHTBOTTOM: "right",
            BOTTOMLEFT: "bottom",
            BOTTOMRIGHT: "bottom",
            LEFTTOP: "left",
            LEFTBOTTOM: "left"
        };
        var OffsetMap = {
            AUTO: 0,
            TOPLEFT: -1,
            TOP: 0,
            TOPRIGHT: +1,
            RIGHTTOP: -1,
            RIGHT: 0,
            RIGHTBOTTOM: +1,
            BOTTOMLEFT: -1,
            BOTTOM: 0,
            BOTTOMRIGHT: +1,
            LEFTTOP: -1,
            LEFT: 0,
            LEFTBOTTOM: +1
        };
        var HoverState = {
            SHOW: "show",
            OUT: "out"
        };
        var ClassName = {
            FADE: "fade",
            SHOW: "show"
        };
        var Selector$1 = {
            TOOLTIP: ".tooltip",
            TOOLTIP_INNER: ".tooltip-inner",
            ARROW: ".arrow"
        };
        var Defaults = {
            animation: true,
            template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div>' + "</div>",
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: false,
            placement: "top",
            offset: 0,
            arrowPadding: 6,
            container: false,
            fallbackPlacement: "flip",
            callbacks: {},
            boundary: "scrollParent"
        };
        var TransitionEndEvents$1 = {
            WebkitTransition: [ "webkitTransitionEnd" ],
            MozTransition: [ "transitionend" ],
            OTransition: [ "otransitionend", "oTransitionEnd" ],
            transition: [ "transitionend" ]
        };
        var NEXTID = 1;
        function generateId(name) {
            return "__BV_" + name + "_" + NEXTID++ + "__";
        }
        var ToolTip = function() {
            function ToolTip(element, config, $root) {
                classCallCheck(this, ToolTip);
                this.$isEnabled = true;
                this.$fadeTimeout = null;
                this.$hoverTimeout = null;
                this.$visibleInterval = null;
                this.$hoverState = "";
                this.$activeTrigger = {};
                this.$popper = null;
                this.$element = element;
                this.$tip = null;
                this.$id = generateId(this.constructor.NAME);
                this.$root = $root || null;
                this.$routeWatcher = null;
                this.$forceHide = this.forceHide.bind(this);
                this.$doHide = this.doHide.bind(this);
                this.$doShow = this.doShow.bind(this);
                this.$doDisable = this.doDisable.bind(this);
                this.$doEnable = this.doEnable.bind(this);
                this.updateConfig(config);
            }
            createClass(ToolTip, [ {
                key: "updateConfig",
                value: function updateConfig(config) {
                    var updatedConfig = assign({}, this.constructor.Default, config);
                    if (config.delay && typeof config.delay === "number") {
                        updatedConfig.delay = {
                            show: config.delay,
                            hide: config.delay
                        };
                    }
                    if (config.title && typeof config.title === "number") {
                        updatedConfig.title = config.title.toString();
                    }
                    if (config.content && typeof config.content === "number") {
                        updatedConfig.content = config.content.toString();
                    }
                    this.fixTitle();
                    this.$config = updatedConfig;
                    this.unListen();
                    this.listen();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.unListen();
                    this.setWhileOpenListeners(false);
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverTimeout = null;
                    clearTimeout(this.$fadeTimeout);
                    this.$fadeTimeout = null;
                    if (this.$popper) {
                        this.$popper.destroy();
                    }
                    this.$popper = null;
                    if (this.$tip && this.$tip.parentElement) {
                        this.$tip.parentElement.removeChild(this.$tip);
                    }
                    this.$tip = null;
                    this.$id = null;
                    this.$isEnabled = null;
                    this.$root = null;
                    this.$element = null;
                    this.$config = null;
                    this.$hoverState = null;
                    this.$activeTrigger = null;
                    this.$forceHide = null;
                    this.$doHide = null;
                    this.$doShow = null;
                    this.$doDisable = null;
                    this.$doEnable = null;
                }
            }, {
                key: "enable",
                value: function enable() {
                    var enabledEvt = new BvEvent("enabled", {
                        cancelable: false,
                        target: this.$element,
                        relatedTarget: null
                    });
                    this.$isEnabled = true;
                    this.emitEvent(enabledEvt);
                }
            }, {
                key: "disable",
                value: function disable() {
                    var disabledEvt = new BvEvent("disabled", {
                        cancelable: false,
                        target: this.$element,
                        relatedTarget: null
                    });
                    this.$isEnabled = false;
                    this.emitEvent(disabledEvt);
                }
            }, {
                key: "toggle",
                value: function toggle(event) {
                    if (!this.$isEnabled) {
                        return;
                    }
                    if (event) {
                        this.$activeTrigger.click = !this.$activeTrigger.click;
                        if (this.isWithActiveTrigger()) {
                            this.enter(null);
                        } else {
                            this.leave(null);
                        }
                    } else {
                        if (hasClass(this.getTipElement(), ClassName.SHOW)) {
                            this.leave(null);
                        } else {
                            this.enter(null);
                        }
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (!document.body.contains(this.$element) || !isVisible(this.$element)) {
                        return;
                    }
                    var tip = this.getTipElement();
                    this.fixTitle();
                    this.setContent(tip);
                    if (!this.isWithContent(tip)) {
                        this.$tip = null;
                        return;
                    }
                    setAttr(tip, "id", this.$id);
                    this.addAriaDescribedby();
                    if (this.$config.animation) {
                        addClass(tip, ClassName.FADE);
                    } else {
                        removeClass(tip, ClassName.FADE);
                    }
                    var placement = this.getPlacement();
                    var attachment = this.constructor.getAttachment(placement);
                    this.addAttachmentClass(attachment);
                    var showEvt = new BvEvent("show", {
                        cancelable: true,
                        target: this.$element,
                        relatedTarget: tip
                    });
                    this.emitEvent(showEvt);
                    if (showEvt.defaultPrevented) {
                        this.$tip = null;
                        return;
                    }
                    var container = this.getContainer();
                    if (!document.body.contains(tip)) {
                        container.appendChild(tip);
                    }
                    this.removePopper();
                    this.$popper = new __WEBPACK_IMPORTED_MODULE_1_popper_js__["a"](this.$element, tip, this.getPopperConfig(placement, tip));
                    var complete = function complete() {
                        if (_this.$config.animation) {
                            _this.fixTransition(tip);
                        }
                        var prevHoverState = _this.$hoverState;
                        _this.$hoverState = null;
                        if (prevHoverState === HoverState.OUT) {
                            _this.leave(null);
                        }
                        var shownEvt = new BvEvent("shown", {
                            cancelable: false,
                            target: _this.$element,
                            relatedTarget: tip
                        });
                        _this.emitEvent(shownEvt);
                    };
                    this.setWhileOpenListeners(true);
                    addClass(tip, ClassName.SHOW);
                    this.transitionOnce(tip, complete);
                }
            }, {
                key: "visibleCheck",
                value: function visibleCheck(on) {
                    var _this2 = this;
                    clearInterval(this.$visibleInterval);
                    this.$visibleInterval = null;
                    if (on) {
                        this.$visibleInterval = setInterval(function() {
                            var tip = _this2.getTipElement();
                            if (tip && !isVisible(_this2.$element) && hasClass(tip, ClassName.SHOW)) {
                                _this2.forceHide();
                            }
                        }, 100);
                    }
                }
            }, {
                key: "setWhileOpenListeners",
                value: function setWhileOpenListeners(on) {
                    this.setModalListener(on);
                    this.visibleCheck(on);
                    this.setRouteWatcher(on);
                    this.setOnTouchStartListener(on);
                    if (on && /(focus|blur)/.test(this.$config.trigger)) {
                        eventOn(this.$tip, "focusout", this);
                    } else {
                        eventOff(this.$tip, "focusout", this);
                    }
                }
            }, {
                key: "forceHide",
                value: function forceHide() {
                    if (!this.$tip || !hasClass(this.$tip, ClassName.SHOW)) {
                        return;
                    }
                    this.setWhileOpenListeners(false);
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverTimeout = null;
                    this.$hoverState = "";
                    this.hide(null, true);
                }
            }, {
                key: "hide",
                value: function hide(callback, force) {
                    var _this3 = this;
                    var tip = this.$tip;
                    if (!tip) {
                        return;
                    }
                    var hideEvt = new BvEvent("hide", {
                        cancelable: !force,
                        target: this.$element,
                        relatedTarget: tip
                    });
                    this.emitEvent(hideEvt);
                    if (hideEvt.defaultPrevented) {
                        return;
                    }
                    var complete = function complete() {
                        if (_this3.$hoverState !== HoverState.SHOW && tip.parentNode) {
                            tip.parentNode.removeChild(tip);
                            _this3.removeAriaDescribedby();
                            _this3.removePopper();
                            _this3.$tip = null;
                        }
                        if (callback) {
                            callback();
                        }
                        var hiddenEvt = new BvEvent("hidden", {
                            cancelable: false,
                            target: _this3.$element,
                            relatedTarget: null
                        });
                        _this3.emitEvent(hiddenEvt);
                    };
                    this.setWhileOpenListeners(false);
                    if (force) {
                        removeClass(tip, ClassName.FADE);
                    }
                    removeClass(tip, ClassName.SHOW);
                    this.$activeTrigger.click = false;
                    this.$activeTrigger.focus = false;
                    this.$activeTrigger.hover = false;
                    this.transitionOnce(tip, complete);
                    this.$hoverState = "";
                }
            }, {
                key: "emitEvent",
                value: function emitEvent(evt) {
                    var evtName = evt.type;
                    if (this.$root && this.$root.$emit) {
                        this.$root.$emit("bv::" + this.constructor.NAME + "::" + evtName, evt);
                    }
                    var callbacks = this.$config.callbacks || {};
                    if (typeof callbacks[evtName] === "function") {
                        callbacks[evtName](evt);
                    }
                }
            }, {
                key: "getContainer",
                value: function getContainer() {
                    var container = this.$config.container;
                    var body = document.body;
                    return container === false ? closest(MODAL_CLASS, this.$element) || body : select(container, body) || body;
                }
            }, {
                key: "addAriaDescribedby",
                value: function addAriaDescribedby() {
                    var desc = getAttr(this.$element, "aria-describedby") || "";
                    desc = desc.split(/\s+/).concat(this.$id).join(" ").trim();
                    setAttr(this.$element, "aria-describedby", desc);
                }
            }, {
                key: "removeAriaDescribedby",
                value: function removeAriaDescribedby() {
                    var _this4 = this;
                    var desc = getAttr(this.$element, "aria-describedby") || "";
                    desc = desc.split(/\s+/).filter(function(d) {
                        return d !== _this4.$id;
                    }).join(" ").trim();
                    if (desc) {
                        setAttr(this.$element, "aria-describedby", desc);
                    } else {
                        removeAttr(this.$element, "aria-describedby");
                    }
                }
            }, {
                key: "removePopper",
                value: function removePopper() {
                    if (this.$popper) {
                        this.$popper.destroy();
                    }
                    this.$popper = null;
                }
            }, {
                key: "transitionOnce",
                value: function transitionOnce(tip, complete) {
                    var _this5 = this;
                    var transEvents = this.getTransitionEndEvents();
                    var called = false;
                    clearTimeout(this.$fadeTimeout);
                    this.$fadeTimeout = null;
                    var fnOnce = function fnOnce() {
                        if (called) {
                            return;
                        }
                        called = true;
                        clearTimeout(_this5.$fadeTimeout);
                        _this5.$fadeTimeout = null;
                        transEvents.forEach(function(evtName) {
                            eventOff(tip, evtName, fnOnce);
                        });
                        complete();
                    };
                    if (hasClass(tip, ClassName.FADE)) {
                        transEvents.forEach(function(evtName) {
                            eventOn(tip, evtName, fnOnce);
                        });
                        this.$fadeTimeout = setTimeout(fnOnce, TRANSITION_DURATION);
                    } else {
                        fnOnce();
                    }
                }
            }, {
                key: "getTransitionEndEvents",
                value: function getTransitionEndEvents() {
                    for (var name in TransitionEndEvents$1) {
                        if (this.$element.style[name] !== undefined) {
                            return TransitionEndEvents$1[name];
                        }
                    }
                    return [];
                }
            }, {
                key: "update",
                value: function update() {
                    if (this.$popper !== null) {
                        this.$popper.scheduleUpdate();
                    }
                }
            }, {
                key: "isWithContent",
                value: function isWithContent(tip) {
                    tip = tip || this.$tip;
                    if (!tip) {
                        return false;
                    }
                    return Boolean((select(Selector$1.TOOLTIP_INNER, tip) || {}).innerHTML);
                }
            }, {
                key: "addAttachmentClass",
                value: function addAttachmentClass(attachment) {
                    addClass(this.getTipElement(), CLASS_PREFIX + "-" + attachment);
                }
            }, {
                key: "getTipElement",
                value: function getTipElement() {
                    if (!this.$tip) {
                        this.$tip = this.compileTemplate(this.$config.template) || this.compileTemplate(this.constructor.Default.template);
                    }
                    this.$tip.tabIndex = -1;
                    return this.$tip;
                }
            }, {
                key: "compileTemplate",
                value: function compileTemplate(html) {
                    if (!html || typeof html !== "string") {
                        return null;
                    }
                    var div = document.createElement("div");
                    div.innerHTML = html.trim();
                    var node = div.firstElementChild ? div.removeChild(div.firstElementChild) : null;
                    div = null;
                    return node;
                }
            }, {
                key: "setContent",
                value: function setContent(tip) {
                    this.setElementContent(select(Selector$1.TOOLTIP_INNER, tip), this.getTitle());
                    removeClass(tip, ClassName.FADE);
                    removeClass(tip, ClassName.SHOW);
                }
            }, {
                key: "setElementContent",
                value: function setElementContent(container, content) {
                    if (!container) {
                        return;
                    }
                    var allowHtml = this.$config.html;
                    if ((typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" && content.nodeType) {
                        if (allowHtml) {
                            if (content.parentElement !== container) {
                                container.innerHtml = "";
                                container.appendChild(content);
                            }
                        } else {
                            container.innerText = content.innerText;
                        }
                    } else {
                        container[allowHtml ? "innerHTML" : "innerText"] = content;
                    }
                }
            }, {
                key: "getTitle",
                value: function getTitle() {
                    var title = this.$config.title || "";
                    if (typeof title === "function") {
                        title = title(this.$element);
                    }
                    if ((typeof title === "undefined" ? "undefined" : _typeof(title)) === "object" && title.nodeType && !title.innerHTML.trim()) {
                        title = "";
                    }
                    if (typeof title === "string") {
                        title = title.trim();
                    }
                    if (!title) {
                        title = getAttr(this.$element, "title") || getAttr(this.$element, "data-original-title") || "";
                        title = title.trim();
                    }
                    return title;
                }
            }, {
                key: "listen",
                value: function listen() {
                    var _this6 = this;
                    var triggers = this.$config.trigger.trim().split(/\s+/);
                    var el = this.$element;
                    this.setRootListener(true);
                    triggers.forEach(function(trigger) {
                        if (trigger === "click") {
                            eventOn(el, "click", _this6);
                        } else if (trigger === "focus") {
                            eventOn(el, "focusin", _this6);
                            eventOn(el, "focusout", _this6);
                        } else if (trigger === "blur") {
                            eventOn(el, "focusout", _this6);
                        } else if (trigger === "hover") {
                            eventOn(el, "mouseenter", _this6);
                            eventOn(el, "mouseleave", _this6);
                        }
                    }, this);
                }
            }, {
                key: "unListen",
                value: function unListen() {
                    var _this7 = this;
                    var events = [ "click", "focusin", "focusout", "mouseenter", "mouseleave" ];
                    events.forEach(function(evt) {
                        eventOff(_this7.$element, evt, _this7);
                    }, this);
                    this.setRootListener(false);
                }
            }, {
                key: "handleEvent",
                value: function handleEvent(e) {
                    if (isDisabled(this.$element)) {
                        return;
                    }
                    if (!this.$isEnabled) {
                        return;
                    }
                    var type = e.type;
                    var target = e.target;
                    var relatedTarget = e.relatedTarget;
                    var $element = this.$element;
                    var $tip = this.$tip;
                    if (type === "click") {
                        this.toggle(e);
                    } else if (type === "focusin" || type === "mouseenter") {
                        this.enter(e);
                    } else if (type === "focusout") {
                        if ($tip && $element && $element.contains(target) && $tip.contains(relatedTarget)) {
                            return;
                        }
                        if ($tip && $element && $tip.contains(target) && $element.contains(relatedTarget)) {
                            return;
                        }
                        if ($tip && $tip.contains(target) && $tip.contains(relatedTarget)) {
                            return;
                        }
                        if ($element && $element.contains(target) && $element.contains(relatedTarget)) {
                            return;
                        }
                        this.leave(e);
                    } else if (type === "mouseleave") {
                        this.leave(e);
                    }
                }
            }, {
                key: "setRouteWatcher",
                value: function setRouteWatcher(on) {
                    var _this8 = this;
                    if (on) {
                        this.setRouteWatcher(false);
                        if (this.$root && Boolean(this.$root.$route)) {
                            this.$routeWatcher = this.$root.$watch("$route", function(newVal, oldVal) {
                                if (newVal === oldVal) {
                                    return;
                                }
                                _this8.forceHide();
                            });
                        }
                    } else {
                        if (this.$routeWatcher) {
                            this.$routeWatcher();
                            this.$routeWatcher = null;
                        }
                    }
                }
            }, {
                key: "setModalListener",
                value: function setModalListener(on) {
                    var modal = closest(MODAL_CLASS, this.$element);
                    if (!modal) {
                        return;
                    }
                    if (this.$root) {
                        this.$root[on ? "$on" : "$off"](MODAL_CLOSE_EVENT, this.$forceHide);
                    }
                }
            }, {
                key: "setRootListener",
                value: function setRootListener(on) {
                    if (this.$root) {
                        this.$root[on ? "$on" : "$off"]("bv::hide::" + this.constructor.NAME, this.$doHide);
                        this.$root[on ? "$on" : "$off"]("bv::show::" + this.constructor.NAME, this.$doShow);
                        this.$root[on ? "$on" : "$off"]("bv::disable::" + this.constructor.NAME, this.$doDisable);
                        this.$root[on ? "$on" : "$off"]("bv::enable::" + this.constructor.NAME, this.$doEnable);
                    }
                }
            }, {
                key: "doHide",
                value: function doHide(id) {
                    if (!id) {
                        this.forceHide();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.hide();
                    }
                }
            }, {
                key: "doShow",
                value: function doShow(id) {
                    if (!id) {
                        this.show();
                    } else if (id && this.$element && this.$element.id && this.$element.id === id) {
                        this.show();
                    }
                }
            }, {
                key: "doDisable",
                value: function doDisable(id) {
                    if (!id) {
                        this.disable();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.disable();
                    }
                }
            }, {
                key: "doEnable",
                value: function doEnable(id) {
                    if (!id) {
                        this.enable();
                    } else if (this.$element && this.$element.id && this.$element.id === id) {
                        this.enable();
                    }
                }
            }, {
                key: "setOnTouchStartListener",
                value: function setOnTouchStartListener(on) {
                    var _this9 = this;
                    if ("ontouchstart" in document.documentElement) {
                        from(document.body.children).forEach(function(el) {
                            if (on) {
                                eventOn(el, "mouseover", _this9._noop);
                            } else {
                                eventOff(el, "mouseover", _this9._noop);
                            }
                        });
                    }
                }
            }, {
                key: "_noop",
                value: function _noop() {}
            }, {
                key: "fixTitle",
                value: function fixTitle() {
                    var el = this.$element;
                    var titleType = _typeof(getAttr(el, "data-original-title"));
                    if (getAttr(el, "title") || titleType !== "string") {
                        setAttr(el, "data-original-title", getAttr(el, "title") || "");
                        setAttr(el, "title", "");
                    }
                }
            }, {
                key: "enter",
                value: function enter(e) {
                    var _this10 = this;
                    if (e) {
                        this.$activeTrigger[e.type === "focusin" ? "focus" : "hover"] = true;
                    }
                    if (hasClass(this.getTipElement(), ClassName.SHOW) || this.$hoverState === HoverState.SHOW) {
                        this.$hoverState = HoverState.SHOW;
                        return;
                    }
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverState = HoverState.SHOW;
                    if (!this.$config.delay || !this.$config.delay.show) {
                        this.show();
                        return;
                    }
                    this.$hoverTimeout = setTimeout(function() {
                        if (_this10.$hoverState === HoverState.SHOW) {
                            _this10.show();
                        }
                    }, this.$config.delay.show);
                }
            }, {
                key: "leave",
                value: function leave(e) {
                    var _this11 = this;
                    if (e) {
                        this.$activeTrigger[e.type === "focusout" ? "focus" : "hover"] = false;
                        if (e.type === "focusout" && /blur/.test(this.$config.trigger)) {
                            this.$activeTrigger.click = false;
                            this.$activeTrigger.hover = false;
                        }
                    }
                    if (this.isWithActiveTrigger()) {
                        return;
                    }
                    clearTimeout(this.$hoverTimeout);
                    this.$hoverState = HoverState.OUT;
                    if (!this.$config.delay || !this.$config.delay.hide) {
                        this.hide();
                        return;
                    }
                    this.$hoverTimeout = setTimeout(function() {
                        if (_this11.$hoverState === HoverState.OUT) {
                            _this11.hide();
                        }
                    }, this.$config.delay.hide);
                }
            }, {
                key: "getPopperConfig",
                value: function getPopperConfig(placement, tip) {
                    var _this12 = this;
                    return {
                        placement: this.constructor.getAttachment(placement),
                        modifiers: {
                            offset: {
                                offset: this.getOffset(placement, tip)
                            },
                            flip: {
                                behavior: this.$config.fallbackPlacement
                            },
                            arrow: {
                                element: ".arrow"
                            },
                            preventOverflow: {
                                boundariesElement: this.$config.boundary
                            }
                        },
                        onCreate: function onCreate(data) {
                            if (data.originalPlacement !== data.placement) {
                                _this12.handlePopperPlacementChange(data);
                            }
                        },
                        onUpdate: function onUpdate(data) {
                            _this12.handlePopperPlacementChange(data);
                        }
                    };
                }
            }, {
                key: "getOffset",
                value: function getOffset(placement, tip) {
                    if (!this.$config.offset) {
                        var arrow = select(Selector$1.ARROW, tip);
                        var arrowOffset = parseFloat(getCS(arrow).width) + parseFloat(this.$config.arrowPadding);
                        switch (OffsetMap[placement.toUpperCase()]) {
                          case +1:
                            return "+50%p - " + arrowOffset + "px";

                          case -1:
                            return "-50%p + " + arrowOffset + "px";

                          default:
                            return 0;
                        }
                    }
                    return parseFloat(this.$config.offset);
                }
            }, {
                key: "getPlacement",
                value: function getPlacement() {
                    var placement = this.$config.placement;
                    if (typeof placement === "function") {
                        return placement.call(this, this.$tip, this.$element);
                    }
                    return placement;
                }
            }, {
                key: "isWithActiveTrigger",
                value: function isWithActiveTrigger() {
                    for (var trigger in this.$activeTrigger) {
                        if (this.$activeTrigger[trigger]) {
                            return true;
                        }
                    }
                    return false;
                }
            }, {
                key: "cleanTipClass",
                value: function cleanTipClass() {
                    var tip = this.getTipElement();
                    var tabClass = tip.className.match(BSCLS_PREFIX_REGEX);
                    if (tabClass !== null && tabClass.length > 0) {
                        tabClass.forEach(function(cls) {
                            removeClass(tip, cls);
                        });
                    }
                }
            }, {
                key: "handlePopperPlacementChange",
                value: function handlePopperPlacementChange(data) {
                    this.cleanTipClass();
                    this.addAttachmentClass(this.constructor.getAttachment(data.placement));
                }
            }, {
                key: "fixTransition",
                value: function fixTransition(tip) {
                    var initConfigAnimation = this.$config.animation || false;
                    if (getAttr(tip, "x-placement") !== null) {
                        return;
                    }
                    removeClass(tip, ClassName.FADE);
                    this.$config.animation = false;
                    this.hide();
                    this.show();
                    this.$config.animation = initConfigAnimation;
                }
            } ], [ {
                key: "getAttachment",
                value: function getAttachment(placement) {
                    return AttachmentMap$1[placement.toUpperCase()];
                }
            }, {
                key: "Default",
                get: function get$$1() {
                    return Defaults;
                }
            }, {
                key: "NAME",
                get: function get$$1() {
                    return NAME;
                }
            } ]);
            return ToolTip;
        }();
        var NAME$1 = "popover";
        var CLASS_PREFIX$1 = "bs-popover";
        var BSCLS_PREFIX_REGEX$1 = new RegExp("\\b" + CLASS_PREFIX$1 + "\\S+", "g");
        var Defaults$1 = assign({}, ToolTip.Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
        });
        var ClassName$1 = {
            FADE: "fade",
            SHOW: "show"
        };
        var Selector$2 = {
            TITLE: ".popover-header",
            CONTENT: ".popover-body"
        };
        var PopOver = function(_ToolTip) {
            inherits(PopOver, _ToolTip);
            function PopOver() {
                classCallCheck(this, PopOver);
                return possibleConstructorReturn(this, (PopOver.__proto__ || Object.getPrototypeOf(PopOver)).apply(this, arguments));
            }
            createClass(PopOver, [ {
                key: "isWithContent",
                value: function isWithContent(tip) {
                    tip = tip || this.$tip;
                    if (!tip) {
                        return false;
                    }
                    var hasTitle = Boolean((select(Selector$2.TITLE, tip) || {}).innerHTML);
                    var hasContent = Boolean((select(Selector$2.CONTENT, tip) || {}).innerHTML);
                    return hasTitle || hasContent;
                }
            }, {
                key: "addAttachmentClass",
                value: function addAttachmentClass(attachment) {
                    addClass(this.getTipElement(), CLASS_PREFIX$1 + "-" + attachment);
                }
            }, {
                key: "setContent",
                value: function setContent(tip) {
                    this.setElementContent(select(Selector$2.TITLE, tip), this.getTitle());
                    this.setElementContent(select(Selector$2.CONTENT, tip), this.getContent());
                    removeClass(tip, ClassName$1.FADE);
                    removeClass(tip, ClassName$1.SHOW);
                }
            }, {
                key: "cleanTipClass",
                value: function cleanTipClass() {
                    var tip = this.getTipElement();
                    var tabClass = tip.className.match(BSCLS_PREFIX_REGEX$1);
                    if (tabClass !== null && tabClass.length > 0) {
                        tabClass.forEach(function(cls) {
                            removeClass(tip, cls);
                        });
                    }
                }
            }, {
                key: "getTitle",
                value: function getTitle() {
                    var title = this.$config.title || "";
                    if (typeof title === "function") {
                        title = title(this.$element);
                    }
                    if ((typeof title === "undefined" ? "undefined" : _typeof(title)) === "object" && title.nodeType && !title.innerHTML.trim()) {
                        title = "";
                    }
                    if (typeof title === "string") {
                        title = title.trim();
                    }
                    if (!title) {
                        title = getAttr(this.$element, "title") || getAttr(this.$element, "data-original-title") || "";
                        title = title.trim();
                    }
                    return title;
                }
            }, {
                key: "getContent",
                value: function getContent() {
                    var content = this.$config.content || "";
                    if (typeof content === "function") {
                        content = content(this.$element);
                    }
                    if ((typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" && content.nodeType && !content.innerHTML.trim()) {
                        content = "";
                    }
                    if (typeof content === "string") {
                        content = content.trim();
                    }
                    return content;
                }
            } ], [ {
                key: "Default",
                get: function get$$1() {
                    return Defaults$1;
                }
            }, {
                key: "NAME",
                get: function get$$1() {
                    return NAME$1;
                }
            } ]);
            return PopOver;
        }(ToolTip);
        var isSSR = typeof window === "undefined";
        var HTMLElement = isSSR ? Object : window.HTMLElement;
        var PLACEMENTS = {
            top: "top",
            topleft: "topleft",
            topright: "topright",
            right: "right",
            righttop: "righttop",
            rightbottom: "rightbottom",
            bottom: "bottom",
            bottomleft: "bottomleft",
            bottomright: "bottomright",
            left: "left",
            lefttop: "lefttop",
            leftbottom: "leftbottom",
            auto: "auto"
        };
        var OBSERVER_CONFIG$1 = {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: [ "class", "style" ]
        };
        var toolpopMixin = {
            props: {
                target: {
                    type: [ String, Object, HTMLElement, Function ]
                },
                delay: {
                    type: [ Number, Object, String ],
                    default: 0
                },
                offset: {
                    type: [ Number, String ],
                    default: 0
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                container: {
                    type: String,
                    default: null
                },
                boundary: {
                    type: [ String, Object ],
                    default: "scrollParent"
                },
                show: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                }
            },
            watch: {
                show: function show(_show, old) {
                    if (_show === old) {
                        return;
                    }
                    _show ? this.onOpen() : this.onClose();
                },
                disabled: function disabled(_disabled, old) {
                    if (_disabled === old) {
                        return;
                    }
                    _disabled ? this.onDisable() : this.onEnable();
                }
            },
            created: function created() {
                this._toolpop = null;
                this._obs_title = null;
                this._obs_content = null;
            },
            mounted: function mounted() {
                var _this = this;
                this.$nextTick(function() {
                    if (_this.createToolpop()) {
                        if (_this.disabled) {
                            _this.onDisable();
                        }
                        _this.$on("open", _this.onOpen);
                        _this.$on("close", _this.onClose);
                        _this.$on("disable", _this.onDisable);
                        _this.$on("enable", _this.onEnable);
                        _this.setObservers(true);
                        if (_this.show) {
                            _this.onOpen();
                        }
                    }
                });
            },
            updated: function updated() {
                if (this._toolpop) {
                    this._toolpop.updateConfig(this.getConfig());
                }
            },
            activated: function activated() {
                this.setObservers(true);
            },
            deactivated: function deactivated() {
                if (this._toolpop) {
                    this.setObservers(false);
                    this._toolpop.hide();
                }
            },
            beforeDestroy: function beforeDestroy() {
                this.$off("open", this.onOpen);
                this.$off("close", this.onClose);
                this.$off("disable", this.onDisable);
                this.$off("enable", this.onEnable);
                this.setObservers(false);
                this.bringItBack();
                if (this._toolpop) {
                    this._toolpop.destroy();
                    this._toolpop = null;
                }
            },
            computed: {
                baseConfig: function baseConfig() {
                    var cont = this.container;
                    var delay = _typeof(this.delay) === "object" ? this.delay : parseInt(this.delay, 10) || 0;
                    return {
                        title: (this.title || "").trim() || "",
                        content: (this.content || "").trim() || "",
                        placement: PLACEMENTS[this.placement] || "auto",
                        container: cont ? /^#/.test(cont) ? cont : "#" + cont : false,
                        boundary: this.boundary,
                        delay: delay || 0,
                        offset: this.offset || 0,
                        animation: !this.noFade,
                        trigger: isArray(this.triggers) ? this.triggers.join(" ") : this.triggers,
                        callbacks: {
                            show: this.onShow,
                            shown: this.onShown,
                            hide: this.onHide,
                            hidden: this.onHidden,
                            enabled: this.onEnabled,
                            disabled: this.onDisabled
                        }
                    };
                }
            },
            methods: {
                getConfig: function getConfig() {
                    var cfg = assign({}, this.baseConfig);
                    if (this.$refs.title && this.$refs.title.innerHTML.trim()) {
                        cfg.title = this.$refs.title;
                        cfg.html = true;
                    }
                    if (this.$refs.content && this.$refs.content.innerHTML.trim()) {
                        cfg.content = this.$refs.content;
                        cfg.html = true;
                    }
                    return cfg;
                },
                onOpen: function onOpen() {
                    if (this._toolpop) {
                        this._toolpop.show();
                    }
                },
                onClose: function onClose(callback) {
                    if (this._toolpop) {
                        this._toolpop.hide(callback);
                    } else if (typeof callback === "function") {
                        callback();
                    }
                },
                onDisable: function onDisable() {
                    if (this._toolpop) {
                        this._toolpop.disable();
                    }
                },
                onEnable: function onEnable() {
                    if (this._toolpop) {
                        this._toolpop.enable();
                    }
                },
                updatePosition: function updatePosition() {
                    if (this._toolpop) {
                        this._toolpop.update();
                    }
                },
                getTarget: function getTarget() {
                    var target = this.target;
                    if (typeof target === "function") {
                        target = target();
                    }
                    if (typeof target === "string") {
                        return getById(target);
                    } else if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object" && isElement(target.$el)) {
                        return target.$el;
                    } else if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object" && isElement(target)) {
                        return target;
                    }
                    return null;
                },
                onShow: function onShow(evt) {
                    this.$emit("show", evt);
                },
                onShown: function onShown(evt) {
                    this.setObservers(true);
                    this.$emit("update:show", true);
                    this.$emit("shown", evt);
                },
                onHide: function onHide(evt) {
                    this.$emit("hide", evt);
                },
                onHidden: function onHidden(evt) {
                    this.setObservers(false);
                    this.bringItBack();
                    this.$emit("update:show", false);
                    this.$emit("hidden", evt);
                },
                onEnabled: function onEnabled(evt) {
                    if (!evt || evt.type !== "enabled") {
                        return;
                    }
                    this.$emit("update:disabled", false);
                    this.$emit("disabled");
                },
                onDisabled: function onDisabled(evt) {
                    if (!evt || evt.type !== "disabled") {
                        return;
                    }
                    this.$emit("update:disabled", true);
                    this.$emit("enabled");
                },
                bringItBack: function bringItBack() {
                    if (this.$el && this.$refs.title) {
                        this.$el.appendChild(this.$refs.title);
                    }
                    if (this.$el && this.$refs.content) {
                        this.$el.appendChild(this.$refs.content);
                    }
                },
                setObservers: function setObservers(on) {
                    if (on) {
                        if (this.$refs.title) {
                            this._obs_title = observeDOM(this.$refs.title, this.updatePosition.bind(this), OBSERVER_CONFIG$1);
                        }
                        if (this.$refs.content) {
                            this._obs_content = observeDOM(this.$refs.content, this.updatePosition.bind(this), OBSERVER_CONFIG$1);
                        }
                    } else {
                        if (this._obs_title) {
                            this._obs_title.disconnect();
                            this._obs_title = null;
                        }
                        if (this._obs_content) {
                            this._obs_content.disconnect();
                            this._obs_content = null;
                        }
                    }
                }
            }
        };
        var bPopover = {
            mixins: [ toolpopMixin ],
            render: function render(h) {
                return h("div", {
                    class: [ "d-none" ],
                    style: {
                        display: "none"
                    },
                    attrs: {
                        "aria-hidden": true
                    }
                }, [ h("div", {
                    ref: "title"
                }, this.$slots.title), h("div", {
                    ref: "content"
                }, this.$slots.default) ]);
            },
            data: function data() {
                return {};
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                content: {
                    type: String,
                    default: ""
                },
                triggers: {
                    type: [ String, Array ],
                    default: "click"
                },
                placement: {
                    type: String,
                    default: "right"
                }
            },
            methods: {
                createToolpop: function createToolpop() {
                    var target = this.getTarget();
                    if (target) {
                        this._toolpop = new PopOver(target, this.getConfig(), this.$root);
                    } else {
                        this._toolpop = null;
                        warn("b-popover: 'target' element not found!");
                    }
                    return this._toolpop;
                }
            }
        };
        var components$31 = {
            bPopover: bPopover
        };
        var VuePlugin$33 = {
            install: function install(Vue) {
                registerComponents(Vue, components$31);
            }
        };
        vueUse(VuePlugin$33);
        var bProgressBar = {
            render: function render(h) {
                var childNodes = h(false);
                if (this.$slots.default) {
                    childNodes = this.$slots.default;
                } else if (this.label) {
                    childNodes = h("span", {
                        domProps: {
                            innerHTML: this.label
                        }
                    });
                } else if (this.computedShowProgress) {
                    childNodes = this.progress.toFixed(this.computedPrecision);
                } else if (this.computedShowValue) {
                    childNodes = this.value.toFixed(this.computedPrecision);
                }
                return h("div", {
                    class: this.progressBarClasses,
                    style: this.progressBarStyles,
                    attrs: {
                        role: "progressbar",
                        "aria-valuemin": "0",
                        "aria-valuemax": this.computedMax.toString(),
                        "aria-valuenow": this.value.toFixed(this.computedPrecision)
                    }
                }, [ childNodes ]);
            },
            computed: {
                progressBarClasses: function progressBarClasses() {
                    return [ "progress-bar", this.computedVariant ? "bg-" + this.computedVariant : "", this.computedStriped || this.computedAnimated ? "progress-bar-striped" : "", this.computedAnimated ? "progress-bar-animated" : "" ];
                },
                progressBarStyles: function progressBarStyles() {
                    return {
                        width: 100 * (this.value / this.computedMax) + "%"
                    };
                },
                progress: function progress() {
                    var p = Math.pow(10, this.computedPrecision);
                    return Math.round(100 * p * this.value / this.computedMax) / p;
                },
                computedMax: function computedMax() {
                    return typeof this.max === "number" ? this.max : this.$parent.max || 100;
                },
                computedVariant: function computedVariant() {
                    return this.variant || this.$parent.variant;
                },
                computedPrecision: function computedPrecision() {
                    return typeof this.precision === "number" ? this.precision : this.$parent.precision || 0;
                },
                computedStriped: function computedStriped() {
                    return typeof this.striped === "boolean" ? this.striped : this.$parent.striped || false;
                },
                computedAnimated: function computedAnimated() {
                    return typeof this.animated === "boolean" ? this.animated : this.$parent.animated || false;
                },
                computedShowProgress: function computedShowProgress() {
                    return typeof this.showProgress === "boolean" ? this.showProgress : this.$parent.showProgress || false;
                },
                computedShowValue: function computedShowValue() {
                    return typeof this.showValue === "boolean" ? this.showValue : this.$parent.showValue || false;
                }
            },
            props: {
                value: {
                    type: Number,
                    default: 0
                },
                label: {
                    type: String,
                    default: null
                },
                max: {
                    type: Number,
                    default: null
                },
                precision: {
                    type: Number,
                    default: null
                },
                variant: {
                    type: String,
                    default: null
                },
                striped: {
                    type: Boolean,
                    default: null
                },
                animated: {
                    type: Boolean,
                    default: null
                },
                showProgress: {
                    type: Boolean,
                    default: null
                },
                showValue: {
                    type: Boolean,
                    default: null
                }
            }
        };
        var bProgress = {
            components: {
                bProgressBar: bProgressBar
            },
            render: function render(h) {
                var childNodes = this.$slots.default;
                if (!childNodes) {
                    childNodes = h("b-progress-bar", {
                        props: {
                            value: this.value,
                            max: this.max,
                            precision: this.precision,
                            variant: this.variant,
                            animated: this.animated,
                            striped: this.striped,
                            showProgress: this.showProgress,
                            showValue: this.showValue
                        }
                    });
                }
                return h("div", {
                    class: [ "progress" ],
                    style: this.progressHeight
                }, [ childNodes ]);
            },
            props: {
                variant: {
                    type: String,
                    default: null
                },
                striped: {
                    type: Boolean,
                    default: false
                },
                animated: {
                    type: Boolean,
                    default: false
                },
                height: {
                    type: String,
                    default: null
                },
                precision: {
                    type: Number,
                    default: 0
                },
                showProgress: {
                    type: Boolean,
                    default: false
                },
                showValue: {
                    type: Boolean,
                    default: false
                },
                max: {
                    type: Number,
                    default: 100
                },
                value: {
                    type: Number,
                    default: 0
                }
            },
            computed: {
                progressHeight: function progressHeight() {
                    return {
                        height: this.height || null
                    };
                }
            }
        };
        var components$32 = {
            bProgress: bProgress,
            bProgressBar: bProgressBar
        };
        var VuePlugin$34 = {
            install: function install(Vue) {
                registerComponents(Vue, components$32);
            }
        };
        vueUse(VuePlugin$34);
        function stableSort(array, compareFn) {
            return array.map(function(a, index) {
                return [ index, a ];
            }).sort(function(a, b) {
                return this(a[1], b[1]) || a[0] - b[0];
            }.bind(compareFn)).map(function(e) {
                return e[1];
            });
        }
        function toString(v) {
            if (!v) {
                return "";
            }
            if (v instanceof Object) {
                return keys(v).map(function(k) {
                    return toString(v[k]);
                }).join(" ");
            }
            return String(v);
        }
        function recToString(obj) {
            if (!(obj instanceof Object)) {
                return "";
            }
            return toString(keys(obj).reduce(function(o, k) {
                if (!/^_/.test(k)) {
                    o[k] = obj[k];
                }
                return o;
            }, {}));
        }
        function defaultSortCompare(a, b, sortBy) {
            if (typeof a[sortBy] === "number" && typeof b[sortBy] === "number") {
                return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
            }
            return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
                numeric: true
            });
        }
        function processField(key, value) {
            var field = null;
            if (typeof value === "string") {
                field = {
                    key: key,
                    label: value
                };
            } else if (typeof value === "function") {
                field = {
                    key: key,
                    formatter: value
                };
            } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
                field = assign({}, value);
                field.key = field.key || key;
            } else if (value !== false) {
                field = {
                    key: key
                };
            }
            return field;
        }
        var bTable = {
            mixins: [ idMixin, listenOnRootMixin ],
            render: function render(h) {
                var _this = this;
                var $slots = this.$slots;
                var $scoped = this.$scopedSlots;
                var fields = this.computedFields;
                var items = this.computedItems;
                var caption = h(false);
                if (this.caption || $slots["table-caption"]) {
                    var data = {
                        style: this.captionStyles
                    };
                    if (!$slots["table-caption"]) {
                        data.domProps = {
                            innerHTML: this.caption
                        };
                    }
                    caption = h("caption", data, $slots["table-caption"]);
                }
                var colgroup = $slots["table-colgroup"] ? h("colgroup", {}, $slots["table-colgroup"]) : h(false);
                var makeHeadCells = function makeHeadCells() {
                    var isFoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    return fields.map(function(field, colIndex) {
                        var data = {
                            key: field.key,
                            class: _this.fieldClasses(field),
                            style: field.thStyle || {},
                            attrs: {
                                tabindex: field.sortable ? "0" : null,
                                abbr: field.headerAbbr || null,
                                title: field.headerTitle || null,
                                "aria-colindex": String(colIndex + 1),
                                "aria-label": field.sortable ? _this.localSortDesc && _this.localSortBy === field.key ? _this.labelSortAsc : _this.labelSortDesc : null,
                                "aria-sort": field.sortable && _this.localSortBy === field.key ? _this.localSortDesc ? "descending" : "ascending" : null
                            },
                            on: {
                                click: function click(evt) {
                                    evt.stopPropagation();
                                    evt.preventDefault();
                                    _this.headClicked(evt, field);
                                },
                                keydown: function keydown(evt) {
                                    var keyCode = evt.keyCode;
                                    if (keyCode === KeyCodes.ENTER || keyCode === KeyCodes.SPACE) {
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                        _this.headClicked(evt, field);
                                    }
                                }
                            }
                        };
                        var slot = isFoot && $scoped["FOOT_" + field.key] ? $scoped["FOOT_" + field.key] : $scoped["HEAD_" + field.key];
                        if (slot) {
                            slot = [ slot({
                                label: field.label,
                                column: field.key,
                                field: field
                            }) ];
                        } else {
                            data.domProps = {
                                innerHTML: field.label
                            };
                        }
                        return h("th", data, slot);
                    });
                };
                var thead = h(false);
                if (this.isStacked !== true) {
                    thead = h("thead", {
                        class: this.headClasses
                    }, [ h("tr", {
                        class: this.theadTrClass
                    }, makeHeadCells(false)) ]);
                }
                var tfoot = h(false);
                if (this.footClone && this.isStacked !== true) {
                    tfoot = h("tfoot", {
                        class: this.footClasses
                    }, [ h("tr", {
                        class: this.tfootTrClass
                    }, makeHeadCells(true)) ]);
                }
                var rows = [];
                if ($scoped["top-row"] && this.isStacked !== true) {
                    rows.push(h("tr", {
                        key: "top-row",
                        class: [ "b-table-top-row", this.tbodyTrClass ]
                    }, [ $scoped["top-row"]({
                        columns: fields.length,
                        fields: fields
                    }) ]));
                } else {
                    rows.push(h(false));
                }
                items.forEach(function(item, rowIndex) {
                    var detailsSlot = $scoped["row-details"];
                    var rowShowDetails = Boolean(item._showDetails && detailsSlot);
                    var detailsId = rowShowDetails ? _this.safeId("_details_" + rowIndex + "_") : null;
                    var toggleDetailsFn = function toggleDetailsFn() {
                        if (detailsSlot) {
                            _this.$set(item, "_showDetails", !item._showDetails);
                        }
                    };
                    var tds = fields.map(function(field, colIndex) {
                        var data = {
                            key: "row-" + rowIndex + "-cell-" + colIndex,
                            class: _this.tdClasses(field, item),
                            attrs: field.tdAttr || {},
                            domProps: {}
                        };
                        data.attrs["aria-colindex"] = String(colIndex + 1);
                        var childNodes = void 0;
                        if ($scoped[field.key]) {
                            childNodes = [ $scoped[field.key]({
                                item: item,
                                index: rowIndex,
                                field: field,
                                unformatted: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, field.key),
                                value: _this.getFormattedValue(item, field),
                                toggleDetails: toggleDetailsFn,
                                detailsShowing: Boolean(item._showDetails)
                            }) ];
                            if (_this.isStacked) {
                                childNodes = [ h("div", {}, [ childNodes ]) ];
                            }
                        } else {
                            var formatted = _this.getFormattedValue(item, field);
                            if (_this.isStacked) {
                                childNodes = [ h("div", formatted) ];
                            } else {
                                childNodes = formatted;
                            }
                        }
                        if (_this.isStacked) {
                            data.attrs["data-label"] = field.label;
                            if (field.isRowHeader) {
                                data.attrs["role"] = "rowheader";
                            } else {
                                data.attrs["role"] = "cell";
                            }
                        }
                        return h(field.isRowHeader ? "th" : "td", data, childNodes);
                    });
                    var ariaRowIndex = null;
                    if (_this.currentPage && _this.perPage && _this.perPage > 0) {
                        ariaRowIndex = (_this.currentPage - 1) * _this.perPage + rowIndex + 1;
                    }
                    rows.push(h("tr", {
                        key: "row-" + rowIndex,
                        class: [ _this.rowClasses(item), {
                            "b-table-has-details": rowShowDetails
                        } ],
                        attrs: {
                            "aria-describedby": detailsId,
                            "aria-rowindex": ariaRowIndex,
                            role: _this.isStacked ? "row" : null
                        },
                        on: {
                            click: function click(evt) {
                                _this.rowClicked(evt, item, rowIndex);
                            },
                            dblclick: function dblclick(evt) {
                                _this.rowDblClicked(evt, item, rowIndex);
                            },
                            mouseenter: function mouseenter(evt) {
                                _this.rowHovered(evt, item, rowIndex);
                            }
                        }
                    }, tds));
                    if (rowShowDetails) {
                        var tdAttrs = {
                            colspan: String(fields.length)
                        };
                        var trAttrs = {
                            id: detailsId
                        };
                        if (_this.isStacked) {
                            tdAttrs["role"] = "cell";
                            trAttrs["role"] = "row";
                        }
                        var details = h("td", {
                            attrs: tdAttrs
                        }, [ detailsSlot({
                            item: item,
                            index: rowIndex,
                            fields: fields,
                            toggleDetails: toggleDetailsFn
                        }) ]);
                        rows.push(h("tr", {
                            key: "details-" + rowIndex,
                            class: [ "b-table-details", _this.tbodyTrClass ],
                            attrs: trAttrs
                        }, [ details ]));
                    } else if (detailsSlot) {
                        rows.push(h(false));
                    }
                });
                if (this.showEmpty && (!items || items.length === 0)) {
                    var empty = this.filter ? $slots["emptyfiltered"] : $slots["empty"];
                    if (!empty) {
                        empty = h("div", {
                            class: [ "text-center", "my-2" ],
                            domProps: {
                                innerHTML: this.filter ? this.emptyFilteredText : this.emptyText
                            }
                        });
                    }
                    empty = h("td", {
                        attrs: {
                            colspan: String(fields.length),
                            role: this.isStacked ? "cell" : null
                        }
                    }, [ h("div", {
                        attrs: {
                            role: "alert",
                            "aria-live": "polite"
                        }
                    }, [ empty ]) ]);
                    rows.push(h("tr", {
                        key: "empty-row",
                        class: [ "b-table-empty-row", this.tbodyTrClass ],
                        attrs: this.isStacked ? {
                            role: "row"
                        } : {}
                    }, [ empty ]));
                } else {
                    rows.push(h(false));
                }
                if ($scoped["bottom-row"] && this.isStacked !== true) {
                    rows.push(h("tr", {
                        key: "bottom-row",
                        class: [ "b-table-bottom-row", this.tbodyTrClass ]
                    }, [ $scoped["bottom-row"]({
                        columns: fields.length,
                        fields: fields
                    }) ]));
                } else {
                    rows.push(h(false));
                }
                var tbody = h("tbody", {
                    class: this.bodyClasses,
                    attrs: this.isStacked ? {
                        role: "rowgroup"
                    } : {}
                }, rows);
                var table = h("table", {
                    class: this.tableClasses,
                    attrs: {
                        id: this.safeId(),
                        role: this.isStacked ? "table" : null,
                        "aria-busy": this.computedBusy ? "true" : "false",
                        "aria-colcount": String(fields.length),
                        "aria-rowcount": this.$attrs["aria-rowcount"] || this.perPage && this.perPage > 0 ? "-1" : null
                    }
                }, [ caption, colgroup, thead, tfoot, tbody ]);
                return this.isResponsive ? h("div", {
                    class: this.responsiveClass
                }, [ table ]) : table;
            },
            data: function data() {
                return {
                    localSortBy: this.sortBy || "",
                    localSortDesc: this.sortDesc || false,
                    localItems: [],
                    filteredItems: [],
                    localBusy: false
                };
            },
            props: {
                items: {
                    type: [ Array, Function ],
                    default: function _default() {
                        return [];
                    }
                },
                fields: {
                    type: [ Object, Array ],
                    default: null
                },
                sortBy: {
                    type: String,
                    default: null
                },
                sortDesc: {
                    type: Boolean,
                    default: false
                },
                caption: {
                    type: String,
                    default: null
                },
                captionTop: {
                    type: Boolean,
                    default: false
                },
                striped: {
                    type: Boolean,
                    default: false
                },
                bordered: {
                    type: Boolean,
                    default: false
                },
                outlined: {
                    type: Boolean,
                    default: false
                },
                dark: {
                    type: Boolean,
                    default: function _default() {
                        if (this && typeof this.inverse === "boolean") {
                            warn("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
                            return this.dark;
                        }
                        return false;
                    }
                },
                inverse: {
                    type: Boolean,
                    default: null
                },
                hover: {
                    type: Boolean,
                    default: false
                },
                small: {
                    type: Boolean,
                    default: false
                },
                fixed: {
                    type: Boolean,
                    default: false
                },
                footClone: {
                    type: Boolean,
                    default: false
                },
                responsive: {
                    type: [ Boolean, String ],
                    default: false
                },
                stacked: {
                    type: [ Boolean, String ],
                    default: false
                },
                headVariant: {
                    type: String,
                    default: ""
                },
                footVariant: {
                    type: String,
                    default: ""
                },
                theadClass: {
                    type: [ String, Array ],
                    default: null
                },
                theadTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                tbodyClass: {
                    type: [ String, Array ],
                    default: null
                },
                tbodyTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                tfootClass: {
                    type: [ String, Array ],
                    default: null
                },
                tfootTrClass: {
                    type: [ String, Array ],
                    default: null
                },
                perPage: {
                    type: Number,
                    default: 0
                },
                currentPage: {
                    type: Number,
                    default: 1
                },
                filter: {
                    type: [ String, RegExp, Function ],
                    default: null
                },
                sortCompare: {
                    type: Function,
                    default: null
                },
                noLocalSorting: {
                    type: Boolean,
                    default: false
                },
                noProviderPaging: {
                    type: Boolean,
                    default: false
                },
                noProviderSorting: {
                    type: Boolean,
                    default: false
                },
                noProviderFiltering: {
                    type: Boolean,
                    default: false
                },
                busy: {
                    type: Boolean,
                    default: false
                },
                value: {
                    type: Array,
                    default: function _default() {
                        return [];
                    }
                },
                labelSortAsc: {
                    type: String,
                    default: "Click to sort Ascending"
                },
                labelSortDesc: {
                    type: String,
                    default: "Click to sort Descending"
                },
                showEmpty: {
                    type: Boolean,
                    default: false
                },
                emptyText: {
                    type: String,
                    default: "There are no records to show"
                },
                emptyFilteredText: {
                    type: String,
                    default: "There are no records matching your request"
                },
                apiUrl: {
                    type: String,
                    default: ""
                }
            },
            watch: {
                items: function items(newVal, oldVal) {
                    if (oldVal !== newVal) {
                        this._providerUpdate();
                    }
                },
                context: function context(newVal, oldVal) {
                    if (!looseEqual(newVal, oldVal)) {
                        this.$emit("context-changed", newVal);
                    }
                },
                filteredItems: function filteredItems(newVal, oldVal) {
                    if (this.localFiltering && newVal.length !== oldVal.length) {
                        this.$emit("filtered", newVal);
                    }
                },
                sortDesc: function sortDesc(newVal, oldVal) {
                    if (newVal === this.localSortDesc) {
                        return;
                    }
                    this.localSortDesc = newVal || false;
                },
                localSortDesc: function localSortDesc(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:sortDesc", newVal);
                        if (!this.noProviderSorting) {
                            this._providerUpdate();
                        }
                    }
                },
                sortBy: function sortBy(newVal, oldVal) {
                    if (newVal === this.localSortBy) {
                        return;
                    }
                    this.localSortBy = newVal || null;
                },
                localSortBy: function localSortBy(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:sortBy", newVal);
                        if (!this.noProviderSorting) {
                            this._providerUpdate();
                        }
                    }
                },
                perPage: function perPage(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderPaging) {
                        this._providerUpdate();
                    }
                },
                currentPage: function currentPage(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderPaging) {
                        this._providerUpdate();
                    }
                },
                filter: function filter(newVal, oldVal) {
                    if (oldVal !== newVal && !this.noProviderFiltering) {
                        this._providerUpdate();
                    }
                },
                localBusy: function localBusy(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.$emit("update:busy", newVal);
                    }
                }
            },
            mounted: function mounted() {
                var _this2 = this;
                this.localSortBy = this.sortBy;
                this.localSortDesc = this.sortDesc;
                if (this.hasProvider) {
                    this._providerUpdate();
                }
                this.listenOnRoot("bv::refresh::table", function(id) {
                    if (id === _this2.id || id === _this2) {
                        _this2._providerUpdate();
                    }
                });
            },
            computed: {
                isStacked: function isStacked() {
                    return this.stacked === "" ? true : this.stacked;
                },
                isResponsive: function isResponsive() {
                    var responsive = this.responsive === "" ? true : this.responsive;
                    return this.isStacked ? false : responsive;
                },
                responsiveClass: function responsiveClass() {
                    return this.isResponsive === true ? "table-responsive" : this.isResponsive ? "table-responsive-" + this.responsive : "";
                },
                tableClasses: function tableClasses() {
                    return [ "table", "b-table", this.striped ? "table-striped" : "", this.hover ? "table-hover" : "", this.dark ? "table-dark" : "", this.bordered ? "table-bordered" : "", this.small ? "table-sm" : "", this.outlined ? "border" : "", this.fixed ? "b-table-fixed" : "", this.isStacked === true ? "b-table-stacked" : this.isStacked ? "b-table-stacked-" + this.stacked : "" ];
                },
                headClasses: function headClasses() {
                    return [ this.headVariant ? "thead-" + this.headVariant : "", this.theadClass ];
                },
                bodyClasses: function bodyClasses() {
                    return [ this.tbodyClass ];
                },
                footClasses: function footClasses() {
                    var variant = this.footVariant || this.headVariant || null;
                    return [ variant ? "thead-" + variant : "", this.tfootClass ];
                },
                captionStyles: function captionStyles() {
                    return this.captionTop ? {
                        captionSide: "top"
                    } : {};
                },
                hasProvider: function hasProvider() {
                    return this.items instanceof Function;
                },
                localFiltering: function localFiltering() {
                    return this.hasProvider ? this.noProviderFiltering : true;
                },
                localSorting: function localSorting() {
                    return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
                },
                localPaging: function localPaging() {
                    return this.hasProvider ? this.noProviderPaging : true;
                },
                context: function context() {
                    return {
                        perPage: this.perPage,
                        currentPage: this.currentPage,
                        filter: this.filter,
                        sortBy: this.localSortBy,
                        sortDesc: this.localSortDesc,
                        apiUrl: this.apiUrl
                    };
                },
                computedFields: function computedFields() {
                    var _this3 = this;
                    var fields = [];
                    if (isArray(this.fields)) {
                        this.fields.filter(function(f) {
                            return f;
                        }).forEach(function(f) {
                            if (typeof f === "string") {
                                fields.push({
                                    key: f,
                                    label: __WEBPACK_IMPORTED_MODULE_2_lodash_startcase___default()(f)
                                });
                            } else if ((typeof f === "undefined" ? "undefined" : _typeof(f)) === "object" && f.key && typeof f.key === "string") {
                                fields.push(assign({}, f));
                            } else if ((typeof f === "undefined" ? "undefined" : _typeof(f)) === "object" && keys(f).length === 1) {
                                var key = keys(f)[0];
                                var field = processField(key, f[key]);
                                if (field) {
                                    fields.push(field);
                                }
                            }
                        });
                    } else if (this.fields && _typeof(this.fields) === "object" && keys(this.fields).length > 0) {
                        keys(this.fields).forEach(function(key) {
                            var field = processField(key, _this3.fields[key]);
                            if (field) {
                                fields.push(field);
                            }
                        });
                    }
                    if (fields.length === 0 && this.computedItems.length > 0) {
                        var sample = this.computedItems[0];
                        var ignoredKeys = [ "_rowVariant", "_cellVariants", "_showDetails" ];
                        keys(sample).forEach(function(k) {
                            if (!ignoredKeys.includes(k)) {
                                fields.push({
                                    key: k,
                                    label: __WEBPACK_IMPORTED_MODULE_2_lodash_startcase___default()(k)
                                });
                            }
                        });
                    }
                    var memo = {};
                    return fields.filter(function(f) {
                        if (!memo[f.key]) {
                            memo[f.key] = true;
                            f.label = typeof f.label === "string" ? f.label : __WEBPACK_IMPORTED_MODULE_2_lodash_startcase___default()(f.key);
                            return true;
                        }
                        return false;
                    });
                },
                computedItems: function computedItems() {
                    var perPage = this.perPage;
                    var currentPage = this.currentPage;
                    var filter = this.filter;
                    var sortBy = this.localSortBy;
                    var sortDesc = this.localSortDesc;
                    var sortCompare = this.sortCompare;
                    var localFiltering = this.localFiltering;
                    var localSorting = this.localSorting;
                    var localPaging = this.localPaging;
                    var items = this.hasProvider ? this.localItems : this.items;
                    if (!items) {
                        this.$nextTick(this._providerUpdate);
                        return [];
                    }
                    items = items.slice();
                    if (filter && localFiltering) {
                        if (filter instanceof Function) {
                            items = items.filter(filter);
                        } else {
                            var regex = void 0;
                            if (filter instanceof RegExp) {
                                regex = filter;
                            } else {
                                regex = new RegExp(".*" + filter + ".*", "ig");
                            }
                            items = items.filter(function(item) {
                                var test = regex.test(recToString(item));
                                regex.lastIndex = 0;
                                return test;
                            });
                        }
                    }
                    if (localFiltering) {
                        this.filteredItems = items.slice();
                    }
                    if (sortBy && localSorting) {
                        items = stableSort(items, function(a, b) {
                            var ret = null;
                            if (typeof sortCompare === "function") {
                                ret = sortCompare(a, b, sortBy);
                            }
                            if (ret === null || ret === undefined) {
                                ret = defaultSortCompare(a, b, sortBy);
                            }
                            return (ret || 0) * (sortDesc ? -1 : 1);
                        });
                    }
                    if (Boolean(perPage) && localPaging) {
                        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
                    }
                    this.$emit("input", items);
                    return items;
                },
                computedBusy: function computedBusy() {
                    return this.busy || this.localBusy;
                }
            },
            methods: {
                keys: keys,
                fieldClasses: function fieldClasses(field) {
                    return [ field.sortable ? "sorting" : "", field.sortable && this.localSortBy === field.key ? "sorting_" + (this.localSortDesc ? "desc" : "asc") : "", field.variant ? "table-" + field.variant : "", field.class ? field.class : "", field.thClass ? field.thClass : "" ];
                },
                tdClasses: function tdClasses(field, item) {
                    var t = this;
                    var cellVariant = "";
                    if (item._cellVariants && item._cellVariants[field.key]) {
                        cellVariant = (this.dark ? "bg" : "table") + "-" + item._cellVariants[field.key];
                    }
                    return [ field.variant && !cellVariant ? (this.dark ? "bg" : "table") + "-" + field.variant : "", cellVariant, field.class ? field.class : "", t.getTdClasses(item, field) ];
                },
                rowClasses: function rowClasses(item) {
                    return [ item._rowVariant ? (this.dark ? "bg" : "table") + "-" + item._rowVariant : "", this.tbodyTrClass ];
                },
                rowClicked: function rowClicked(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-clicked", item, index, e);
                },
                rowDblClicked: function rowDblClicked(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-dblclicked", item, index, e);
                },
                rowHovered: function rowHovered(e, item, index) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    this.$emit("row-hovered", item, index, e);
                },
                headClicked: function headClicked(e, field) {
                    if (this.stopIfBusy(e)) {
                        return;
                    }
                    var sortChanged = false;
                    if (field.sortable) {
                        if (field.key === this.localSortBy) {
                            this.localSortDesc = !this.localSortDesc;
                        } else {
                            this.localSortBy = field.key;
                            this.localSortDesc = false;
                        }
                        sortChanged = true;
                    } else if (this.localSortBy) {
                        this.localSortBy = null;
                        this.localSortDesc = false;
                        sortChanged = true;
                    }
                    this.$emit("head-clicked", field.key, field, e);
                    if (sortChanged) {
                        this.$emit("sort-changed", this.context);
                    }
                },
                stopIfBusy: function stopIfBusy(evt) {
                    if (this.computedBusy) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        return true;
                    }
                    return false;
                },
                refresh: function refresh() {
                    if (this.hasProvider) {
                        this._providerUpdate();
                    }
                },
                _providerSetLocal: function _providerSetLocal(items) {
                    this.localItems = items && items.length > 0 ? items.slice() : [];
                    this.localBusy = false;
                    this.$emit("refreshed");
                    this.emitOnRoot("table::refreshed", this.id);
                    if (this.id) {
                        this.emitOnRoot("bv::table::refreshed", this.id);
                    }
                },
                _providerUpdate: function _providerUpdate() {
                    var _this4 = this;
                    if (this.computedBusy || !this.hasProvider) {
                        return;
                    }
                    this.localBusy = true;
                    var data = this.items(this.context, this._providerSetLocal);
                    if (data && data.then && typeof data.then === "function") {
                        data.then(function(items) {
                            _this4._providerSetLocal(items);
                        });
                    } else {
                        this._providerSetLocal(data);
                    }
                },
                getTdClasses: function getTdClasses(item, field) {
                    var key = field.key;
                    var tdClass = field.tdClass;
                    var parent = this.$parent;
                    if (tdClass) {
                        if (typeof tdClass === "function") {
                            var value = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, key);
                            return tdClass(value, key, item);
                        } else if (typeof tdClass === "string" && typeof parent[tdClass] === "function") {
                            var _value = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, key);
                            return parent[tdClass](_value, key, item);
                        }
                        return tdClass;
                    }
                    return "";
                },
                getFormattedValue: function getFormattedValue(item, field) {
                    var key = field.key;
                    var formatter = field.formatter;
                    var parent = this.$parent;
                    var value = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, key);
                    if (formatter) {
                        if (typeof formatter === "function") {
                            value = formatter(value, key, item);
                        } else if (typeof formatter === "string" && typeof parent[formatter] === "function") {
                            value = parent[formatter](value, key, item);
                        }
                    }
                    return value;
                }
            }
        };
        var components$33 = {
            bTable: bTable
        };
        var VuePlugin$35 = {
            install: function install(Vue) {
                registerComponents(Vue, components$33);
            }
        };
        vueUse(VuePlugin$35);
        var bTabButtonHelper = {
            name: "bTabButtonHelper",
            props: {
                content: {
                    type: [ String, Array ],
                    default: ""
                },
                href: {
                    type: String,
                    default: "#"
                },
                posInSet: {
                    type: Number,
                    default: null
                },
                setSize: {
                    type: Number,
                    default: null
                },
                controls: {
                    type: String,
                    default: null
                },
                id: {
                    type: String,
                    default: null
                },
                active: {
                    type: Boolean,
                    default: false
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                linkClass: {
                    default: null
                },
                itemClass: {
                    default: null
                },
                noKeyNav: {
                    type: Boolean,
                    default: false
                }
            },
            render: function render(h) {
                var link = h("a", {
                    class: [ "nav-link", {
                        active: this.active,
                        disabled: this.disabled
                    }, this.linkClass ],
                    attrs: {
                        role: "tab",
                        tabindex: this.noKeyNav ? null : "-1",
                        href: this.href,
                        id: this.id,
                        disabled: this.disabled,
                        "aria-selected": this.active ? "true" : "false",
                        "aria-setsize": this.setSize,
                        "aria-posinset": this.posInSet,
                        "aria-controls": this.controls
                    },
                    on: {
                        click: this.handleClick,
                        keydown: this.handleClick
                    }
                }, this.content);
                return h("li", {
                    class: [ "nav-item", this.itemClass ],
                    attrs: {
                        role: "presentation"
                    }
                }, [ link ]);
            },
            methods: {
                handleClick: function handleClick(evt) {
                    function stop() {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    if (evt.type !== "click" && this.noKeyNav) {
                        return;
                    }
                    if (this.disabled) {
                        stop();
                        return;
                    }
                    if (evt.type === "click" || evt.keyCode === KeyCodes.ENTER || evt.keyCode === KeyCodes.SPACE) {
                        stop();
                        this.$emit("click", evt);
                    }
                }
            }
        };
        var bTabs = {
            mixins: [ idMixin ],
            render: function render(h) {
                var _this = this, _ref;
                var tabs = this.tabs;
                var buttons = tabs.map(function(tab, index) {
                    return h(bTabButtonHelper, {
                        key: index,
                        props: {
                            content: tab.$slots.title || tab.title,
                            href: tab.href,
                            id: tab.controlledBy || _this.safeId("_BV_tab_" + (index + 1) + "_"),
                            active: tab.localActive,
                            disabled: tab.disabled,
                            setSize: tabs.length,
                            posInSet: index + 1,
                            controls: _this.safeId("_BV_tab_container_"),
                            linkClass: tab.titleLinkClass,
                            itemClass: tab.titleItemClass,
                            noKeyNav: _this.noKeyNav
                        },
                        on: {
                            click: function click(evt) {
                                _this.setTab(index);
                            }
                        }
                    });
                });
                var navs = h("ul", {
                    class: [ "nav", (_ref = {}, defineProperty(_ref, "nav-" + this.navStyle, !this.noNavStyle), 
                    defineProperty(_ref, "card-header-" + this.navStyle, this.card && !this.vertical), 
                    defineProperty(_ref, "card-header", this.card && this.vertical), defineProperty(_ref, "h-100", this.card && this.vertical), 
                    defineProperty(_ref, "flex-column", this.vertical), defineProperty(_ref, "border-bottom-0", this.vertical), 
                    defineProperty(_ref, "rounded-0", this.vertical), defineProperty(_ref, "small", this.small), 
                    _ref), this.navClass ],
                    attrs: {
                        role: "tablist",
                        tabindex: this.noKeyNav ? null : "0",
                        id: this.safeId("_BV_tab_controls_")
                    },
                    on: {
                        keydown: this.onKeynav
                    }
                }, [ buttons, this.$slots.tabs ]);
                navs = h("div", {
                    class: [ {
                        "card-header": this.card && !this.vertical && !(this.end || this.bottom),
                        "card-footer": this.card && !this.vertical && (this.end || this.bottom),
                        "col-auto": this.vertical
                    }, this.navWrapperClass ]
                }, [ navs ]);
                var empty = void 0;
                if (tabs && tabs.length) {
                    empty = h(false);
                } else {
                    empty = h("div", {
                        class: [ "tab-pane", "active", {
                            "card-body": this.card
                        } ]
                    }, this.$slots.empty);
                }
                var content = h("div", {
                    ref: "tabsContainer",
                    class: [ "tab-content", {
                        col: this.vertical
                    }, this.contentClass ],
                    attrs: {
                        id: this.safeId("_BV_tab_container_")
                    }
                }, [ this.$slots.default, empty ]);
                return h(this.tag, {
                    class: [ "tabs", {
                        row: this.vertical,
                        "no-gutters": this.vertical && this.card
                    } ],
                    attrs: {
                        id: this.safeId()
                    }
                }, [ this.end || this.bottom ? content : h(false), [ navs ], this.end || this.bottom ? h(false) : content ]);
            },
            data: function data() {
                return {
                    currentTab: this.value,
                    tabs: []
                };
            },
            props: {
                tag: {
                    type: String,
                    default: "div"
                },
                card: {
                    type: Boolean,
                    default: false
                },
                small: {
                    type: Boolean,
                    default: false
                },
                value: {
                    type: Number,
                    default: null
                },
                pills: {
                    type: Boolean,
                    default: false
                },
                vertical: {
                    type: Boolean,
                    default: false
                },
                bottom: {
                    type: Boolean,
                    default: false
                },
                end: {
                    type: Boolean,
                    default: false
                },
                noFade: {
                    type: Boolean,
                    default: false
                },
                noNavStyle: {
                    type: Boolean,
                    default: false
                },
                noKeyNav: {
                    type: Boolean,
                    default: false
                },
                lazy: {
                    type: Boolean,
                    default: false
                },
                contentClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                navClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                navWrapperClass: {
                    type: [ String, Array, Object ],
                    default: null
                }
            },
            watch: {
                currentTab: function currentTab(val, old) {
                    if (val === old) {
                        return;
                    }
                    this.$root.$emit("changed::tab", this, val, this.tabs[val]);
                    this.$emit("input", val);
                    this.tabs[val].$emit("click");
                },
                value: function value(val, old) {
                    if (val === old) {
                        return;
                    }
                    if (typeof old !== "number") {
                        old = 0;
                    }
                    var direction = val < old ? -1 : 1;
                    this.setTab(val, false, direction);
                }
            },
            computed: {
                fade: function fade() {
                    return !this.noFade;
                },
                navStyle: function navStyle() {
                    return this.pills ? "pills" : "tabs";
                }
            },
            methods: {
                sign: function sign(x) {
                    return x === 0 ? 0 : x > 0 ? 1 : -1;
                },
                onKeynav: function onKeynav(evt) {
                    if (this.noKeyNav) {
                        return;
                    }
                    var key = evt.keyCode;
                    var shift = evt.shiftKey;
                    function stop() {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    if (key === KeyCodes.UP || key === KeyCodes.LEFT) {
                        stop();
                        if (shift) {
                            this.setTab(0, false, 1);
                        } else {
                            this.previousTab();
                        }
                    } else if (key === KeyCodes.DOWN || key === KeyCodes.RIGHT) {
                        stop();
                        if (shift) {
                            this.setTab(this.tabs.length - 1, false, -1);
                        } else {
                            this.nextTab();
                        }
                    }
                },
                nextTab: function nextTab() {
                    this.setTab(this.currentTab + 1, false, 1);
                },
                previousTab: function previousTab() {
                    this.setTab(this.currentTab - 1, false, -1);
                },
                setTab: function setTab(index, force, direction) {
                    var _this2 = this;
                    direction = this.sign(direction || 0);
                    index = index || 0;
                    if (!force && index === this.currentTab) {
                        return;
                    }
                    var tab = this.tabs[index];
                    if (!tab) {
                        this.$emit("input", this.currentTab);
                        return;
                    }
                    if (tab.disabled) {
                        if (direction) {
                            this.setTab(index + direction, force, direction);
                        }
                        return;
                    }
                    this.tabs.forEach(function(t) {
                        if (t === tab) {
                            _this2.$set(t, "localActive", true);
                        } else {
                            _this2.$set(t, "localActive", false);
                        }
                    });
                    this.currentTab = index;
                },
                updateTabs: function updateTabs() {
                    this.tabs = this.$children.filter(function(child) {
                        return child._isTab;
                    });
                    var tabIndex = null;
                    this.tabs.forEach(function(tab, index) {
                        if (tab.localActive && !tab.disabled) {
                            tabIndex = index;
                        }
                    });
                    if (tabIndex === null) {
                        if (this.currentTab >= this.tabs.length) {
                            this.setTab(this.tabs.length - 1, true, -1);
                            return;
                        } else if (this.tabs[this.currentTab] && !this.tabs[this.currentTab].disabled) {
                            tabIndex = this.currentTab;
                        }
                    }
                    if (tabIndex === null) {
                        this.tabs.forEach(function(tab, index) {
                            if (!tab.disabled && tabIndex === null) {
                                tabIndex = index;
                            }
                        });
                    }
                    this.setTab(tabIndex || 0, true, 0);
                }
            },
            mounted: function mounted() {
                this.updateTabs();
                observeDOM(this.$refs.tabsContainer, this.updateTabs.bind(this), {
                    subtree: false
                });
            }
        };
        var bTab = {
            mixins: [ idMixin ],
            render: function render(h) {
                var content = h(false);
                if (this.localActive || !this.computedLazy) {
                    content = h(this.tag, {
                        ref: "panel",
                        class: this.tabClasses,
                        directives: [ {
                            name: "show",
                            value: this.localActive
                        } ],
                        attrs: {
                            role: "tabpanel",
                            id: this.safeId(),
                            "aria-hidden": this.localActive ? "false" : "true",
                            "aria-expanded": this.localActive ? "true" : "false",
                            "aria-lablelledby": this.controlledBy || null
                        }
                    }, [ this.$slots.default ]);
                }
                return h("transition", {
                    props: {
                        mode: "out-in"
                    },
                    on: {
                        beforeEnter: this.beforeEnter,
                        afterEnter: this.afterEnter,
                        afterLeave: this.afterLeave
                    }
                }, [ content ]);
            },
            methods: {
                beforeEnter: function beforeEnter() {
                    this.show = false;
                },
                afterEnter: function afterEnter() {
                    this.show = true;
                },
                afterLeave: function afterLeave() {
                    this.show = false;
                }
            },
            data: function data() {
                return {
                    localActive: this.active && !this.disabled,
                    show: false
                };
            },
            mounted: function mounted() {
                this.show = this.localActive;
            },
            computed: {
                tabClasses: function tabClasses() {
                    return [ "tab-pane", this.$parent && this.$parent.card && !this.noBody ? "card-body" : "", this.show ? "show" : "", this.computedFade ? "fade" : "", this.disabled ? "disabled" : "", this.localActive ? "active" : "" ];
                },
                controlledBy: function controlledBy() {
                    return this.buttonId || this.safeId("__BV_tab_button__");
                },
                computedFade: function computedFade() {
                    return this.$parent.fade;
                },
                computedLazy: function computedLazy() {
                    return this.$parent.lazy;
                },
                _isTab: function _isTab() {
                    return true;
                }
            },
            props: {
                active: {
                    type: Boolean,
                    default: false
                },
                tag: {
                    type: String,
                    default: "div"
                },
                buttonId: {
                    type: String,
                    default: ""
                },
                title: {
                    type: String,
                    default: ""
                },
                titleItemClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                titleLinkClass: {
                    type: [ String, Array, Object ],
                    default: null
                },
                headHtml: {
                    type: String,
                    default: null
                },
                disabled: {
                    type: Boolean,
                    default: false
                },
                noBody: {
                    type: Boolean,
                    default: false
                },
                href: {
                    type: String,
                    default: "#"
                }
            }
        };
        var components$34 = {
            bTabs: bTabs,
            bTab: bTab
        };
        var VuePlugin$36 = {
            install: function install(Vue) {
                registerComponents(Vue, components$34);
            }
        };
        vueUse(VuePlugin$36);
        var bTooltip = {
            mixins: [ toolpopMixin ],
            render: function render(h) {
                return h("div", {
                    class: [ "d-none" ],
                    style: {
                        display: "none"
                    },
                    attrs: {
                        "aria-hidden": true
                    }
                }, [ h("div", {
                    ref: "title"
                }, this.$slots.default) ]);
            },
            data: function data() {
                return {};
            },
            props: {
                title: {
                    type: String,
                    default: ""
                },
                triggers: {
                    type: [ String, Array ],
                    default: "hover focus"
                },
                placement: {
                    type: String,
                    default: "top"
                }
            },
            methods: {
                createToolpop: function createToolpop() {
                    var target = this.getTarget();
                    if (target) {
                        this._toolpop = new ToolTip(target, this.getConfig(), this.$root);
                    } else {
                        this._toolpop = null;
                        warn("b-tooltip: 'target' element not found!");
                    }
                    return this._toolpop;
                }
            }
        };
        var components$35 = {
            bTooltip: bTooltip
        };
        var VuePlugin$37 = {
            install: function install(Vue) {
                registerComponents(Vue, components$35);
            }
        };
        vueUse(VuePlugin$37);
        var components$36 = Object.freeze({
            Alert: VuePlugin,
            Badge: VuePlugin$1,
            Breadcrumb: VuePlugin$2,
            Button: VuePlugin$3,
            ButtonToolbar: VuePlugin$5,
            ButtonGroup: VuePlugin$4,
            Card: VuePlugin$7,
            Carousel: VuePlugin$8,
            Collapse: VuePlugin$11,
            Dropdown: VuePlugin$12,
            Embed: VuePlugin$13,
            Form: VuePlugin$14,
            FormGroup: VuePlugin$15,
            FormInput: VuePlugin$18,
            FormTextarea: VuePlugin$19,
            FormFile: VuePlugin$20,
            FormCheckbox: VuePlugin$16,
            FormRadio: VuePlugin$17,
            FormSelect: VuePlugin$21,
            Image: VuePlugin$22,
            InputGroup: VuePlugin$6,
            Jumbotron: VuePlugin$23,
            Layout: VuePlugin$9,
            Link: VuePlugin$24,
            ListGroup: VuePlugin$25,
            Media: VuePlugin$26,
            Modal: VuePlugin$28,
            Nav: VuePlugin$29,
            Navbar: VuePlugin$30,
            Pagination: VuePlugin$31,
            PaginationNav: VuePlugin$32,
            Popover: VuePlugin$33,
            Progress: VuePlugin$34,
            Table: VuePlugin$35,
            Tabs: VuePlugin$36,
            Tooltip: VuePlugin$37
        });
        var NAME$2 = "v-b-scrollspy";
        var ACTIVATE_EVENT = "bv::scrollspy::activate";
        var Default = {
            element: "body",
            offset: 10,
            method: "auto",
            throttle: 75
        };
        var DefaultType = {
            element: "(string|element|component)",
            offset: "number",
            method: "string",
            throttle: "number"
        };
        var ClassName$2 = {
            DROPDOWN_ITEM: "dropdown-item",
            ACTIVE: "active"
        };
        var Selector$3 = {
            ACTIVE: ".active",
            NAV_LIST_GROUP: ".nav, .list-group",
            NAV_LINKS: ".nav-link",
            NAV_ITEMS: ".nav-item",
            LIST_ITEMS: ".list-group-item",
            DROPDOWN: ".dropdown, .dropup",
            DROPDOWN_ITEMS: ".dropdown-item",
            DROPDOWN_TOGGLE: ".dropdown-toggle"
        };
        var OffsetMethod = {
            OFFSET: "offset",
            POSITION: "position"
        };
        var HREF_REGEX = /^#[^\/!]+/;
        var TransitionEndEvents$2 = [ "webkitTransitionEnd", "transitionend", "otransitionend", "oTransitionEnd" ];
        function toType(obj) {
            return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        }
        function typeCheckConfig(componentName, config, configTypes) {
            for (var property in configTypes) {
                if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                    var expectedTypes = configTypes[property];
                    var value = config[property];
                    var valueType = value && isElement(value) ? "element" : toType(value);
                    valueType = value && value._isVue ? "component" : valueType;
                    if (!new RegExp(expectedTypes).test(valueType)) {
                        warn(componentName + ': Option "' + property + '" provided type "' + valueType + '", but expected type "' + expectedTypes + '"');
                    }
                }
            }
        }
        var ScrollSpy = function() {
            function ScrollSpy(element, config, $root) {
                classCallCheck(this, ScrollSpy);
                this.$el = element;
                this.$scroller = null;
                this.$selector = [ Selector$3.NAV_LINKS, Selector$3.LIST_ITEMS, Selector$3.DROPDOWN_ITEMS ].join(",");
                this.$offsets = [];
                this.$targets = [];
                this.$activeTarget = null;
                this.$scrollHeight = 0;
                this.$resizeTimeout = null;
                this.$obs_scroller = null;
                this.$obs_targets = null;
                this.$root = $root || null;
                this.$config = null;
                this.updateConfig(config);
            }
            createClass(ScrollSpy, [ {
                key: "updateConfig",
                value: function updateConfig(config, $root) {
                    if (this.$scroller) {
                        this.unlisten();
                        this.$scroller = null;
                    }
                    var cfg = assign({}, this.constructor.Default, config);
                    if ($root) {
                        this.$root = $root;
                    }
                    typeCheckConfig(this.constructor.Name, cfg, this.constructor.DefaultType);
                    this.$config = cfg;
                    if (this.$root) {
                        var self = this;
                        this.$root.$nextTick(function() {
                            self.listen();
                        });
                    } else {
                        this.listen();
                    }
                }
            }, {
                key: "dispose",
                value: function dispose() {
                    this.unlisten();
                    clearTimeout(this.$resizeTimeout);
                    this.$resizeTimeout = null;
                    this.$el = null;
                    this.$config = null;
                    this.$scroller = null;
                    this.$selector = null;
                    this.$offsets = null;
                    this.$targets = null;
                    this.$activeTarget = null;
                    this.$scrollHeight = null;
                }
            }, {
                key: "listen",
                value: function listen() {
                    var _this = this;
                    var scroller = this.getScroller();
                    if (scroller && scroller.tagName !== "BODY") {
                        eventOn(scroller, "scroll", this);
                    }
                    eventOn(window, "scroll", this);
                    eventOn(window, "resize", this);
                    eventOn(window, "orientationchange", this);
                    TransitionEndEvents$2.forEach(function(evtName) {
                        eventOn(window, evtName, _this);
                    });
                    this.setObservers(true);
                    this.handleEvent("refresh");
                }
            }, {
                key: "unlisten",
                value: function unlisten() {
                    var _this2 = this;
                    var scroller = this.getScroller();
                    this.setObservers(false);
                    if (scroller && scroller.tagName !== "BODY") {
                        eventOff(scroller, "scroll", this);
                    }
                    eventOff(window, "scroll", this);
                    eventOff(window, "resize", this);
                    eventOff(window, "orientationchange", this);
                    TransitionEndEvents$2.forEach(function(evtName) {
                        eventOff(window, evtName, _this2);
                    });
                }
            }, {
                key: "setObservers",
                value: function setObservers(on) {
                    var _this3 = this;
                    if (this.$obs_scroller) {
                        this.$obs_scroller.disconnect();
                        this.$obs_scroller = null;
                    }
                    if (this.$obs_targets) {
                        this.$obs_targets.disconnect();
                        this.$obs_targets = null;
                    }
                    if (on) {
                        this.$obs_targets = observeDOM(this.$el, function() {
                            _this3.handleEvent("mutation");
                        }, {
                            subtree: true,
                            childList: true,
                            attributes: true,
                            attributeFilter: [ "href" ]
                        });
                        this.$obs_scroller = observeDOM(this.getScroller(), function() {
                            _this3.handleEvent("mutation");
                        }, {
                            subtree: true,
                            childList: true,
                            characterData: true,
                            attributes: true,
                            attributeFilter: [ "id", "style", "class" ]
                        });
                    }
                }
            }, {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var type = typeof evt === "string" ? evt : evt.type;
                    var self = this;
                    function resizeThrottle() {
                        if (!self.$resizeTimeout) {
                            self.$resizeTimeout = setTimeout(function() {
                                self.refresh();
                                self.process();
                                self.$resizeTimeout = null;
                            }, self.$config.throttle);
                        }
                    }
                    if (type === "scroll") {
                        if (!this.$obs_scroller) {
                            this.listen();
                        }
                        this.process();
                    } else if (/(resize|orientationchange|mutation|refresh)/.test(type)) {
                        resizeThrottle();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    var _this4 = this;
                    var scroller = this.getScroller();
                    if (!scroller) {
                        return;
                    }
                    var autoMethod = scroller !== scroller.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;
                    var method = this.$config.method === "auto" ? autoMethod : this.$config.method;
                    var methodFn = method === OffsetMethod.POSITION ? position : offset;
                    var offsetBase = method === OffsetMethod.POSITION ? this.getScrollTop() : 0;
                    this.$offsets = [];
                    this.$targets = [];
                    this.$scrollHeight = this.getScrollHeight();
                    selectAll(this.$selector, this.$el).map(function(link) {
                        return getAttr(link, "href");
                    }).filter(function(href) {
                        return HREF_REGEX.test(href || "");
                    }).map(function(href) {
                        var el = select(href, scroller);
                        if (isVisible(el)) {
                            return {
                                offset: parseInt(methodFn(el).top, 10) + offsetBase,
                                target: href
                            };
                        }
                        return null;
                    }).filter(function(item) {
                        return item;
                    }).sort(function(a, b) {
                        return a.offset - b.offset;
                    }).reduce(function(memo, item) {
                        if (!memo[item.target]) {
                            _this4.$offsets.push(item.offset);
                            _this4.$targets.push(item.target);
                            memo[item.target] = true;
                        }
                        return memo;
                    }, {});
                    return this;
                }
            }, {
                key: "process",
                value: function process() {
                    var scrollTop = this.getScrollTop() + this.$config.offset;
                    var scrollHeight = this.getScrollHeight();
                    var maxScroll = this.$config.offset + scrollHeight - this.getOffsetHeight();
                    if (this.$scrollHeight !== scrollHeight) {
                        this.refresh();
                    }
                    if (scrollTop >= maxScroll) {
                        var target = this.$targets[this.$targets.length - 1];
                        if (this.$activeTarget !== target) {
                            this.activate(target);
                        }
                        return;
                    }
                    if (this.$activeTarget && scrollTop < this.$offsets[0] && this.$offsets[0] > 0) {
                        this.$activeTarget = null;
                        this.clear();
                        return;
                    }
                    for (var i = this.$offsets.length; i--; ) {
                        var isActiveTarget = this.$activeTarget !== this.$targets[i] && scrollTop >= this.$offsets[i] && (typeof this.$offsets[i + 1] === "undefined" || scrollTop < this.$offsets[i + 1]);
                        if (isActiveTarget) {
                            this.activate(this.$targets[i]);
                        }
                    }
                }
            }, {
                key: "getScroller",
                value: function getScroller() {
                    if (this.$scroller) {
                        return this.$scroller;
                    }
                    var scroller = this.$config.element;
                    if (!scroller) {
                        return null;
                    } else if (isElement(scroller.$el)) {
                        scroller = scroller.$el;
                    } else if (typeof scroller === "string") {
                        scroller = select(scroller);
                    }
                    if (!scroller) {
                        return null;
                    }
                    this.$scroller = scroller.tagName === "BODY" ? window : scroller;
                    return this.$scroller;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    var scroller = this.getScroller();
                    return scroller === window ? scroller.pageYOffset : scroller.scrollTop;
                }
            }, {
                key: "getScrollHeight",
                value: function getScrollHeight() {
                    return this.getScroller().scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
                }
            }, {
                key: "getOffsetHeight",
                value: function getOffsetHeight() {
                    var scroller = this.getScroller();
                    return scroller === window ? window.innerHeight : getBCR(scroller).height;
                }
            }, {
                key: "activate",
                value: function activate(target) {
                    var _this5 = this;
                    this.$activeTarget = target;
                    this.clear();
                    var links = selectAll(this.$selector.split(",").map(function(selector) {
                        return selector + '[href="' + target + '"]';
                    }).join(","), this.$el);
                    links.forEach(function(link) {
                        if (hasClass(link, ClassName$2.DROPDOWN_ITEM)) {
                            var dropdown = closest(Selector$3.DROPDOWN, link);
                            if (dropdown) {
                                _this5.setActiveState(select(Selector$3.DROPDOWN_TOGGLE, dropdown), true);
                            }
                            _this5.setActiveState(link, true);
                        } else {
                            _this5.setActiveState(link, true);
                            if (matches(link.parentElement, Selector$3.NAV_ITEMS)) {
                                _this5.setActiveState(link.parentElement, true);
                            }
                            var el = link;
                            while (el) {
                                el = closest(Selector$3.NAV_LIST_GROUP, el);
                                var sibling = el ? el.previousElementSibling : null;
                                if (matches(sibling, Selector$3.NAV_LINKS + ", " + Selector$3.LIST_ITEMS)) {
                                    _this5.setActiveState(sibling, true);
                                }
                                if (matches(sibling, Selector$3.NAV_ITEMS)) {
                                    _this5.setActiveState(select(Selector$3.NAV_LINKS, sibling), true);
                                    _this5.setActiveState(sibling, true);
                                }
                            }
                        }
                    });
                    if (links && links.length > 0 && this.$root) {
                        this.$root.$emit(ACTIVATE_EVENT, target, links);
                    }
                }
            }, {
                key: "clear",
                value: function clear() {
                    var _this6 = this;
                    selectAll(this.$selector + ", " + Selector$3.NAV_ITEMS, this.$el).filter(function(el) {
                        return hasClass(el, ClassName$2.ACTIVE);
                    }).forEach(function(el) {
                        return _this6.setActiveState(el, false);
                    });
                }
            }, {
                key: "setActiveState",
                value: function setActiveState(el, active) {
                    if (!el) {
                        return;
                    }
                    if (active) {
                        addClass(el, ClassName$2.ACTIVE);
                    } else {
                        removeClass(el, ClassName$2.ACTIVE);
                    }
                }
            } ], [ {
                key: "Name",
                get: function get$$1() {
                    return NAME$2;
                }
            }, {
                key: "Default",
                get: function get$$1() {
                    return Default;
                }
            }, {
                key: "DefaultType",
                get: function get$$1() {
                    return DefaultType;
                }
            } ]);
            return ScrollSpy;
        }();
        var inBrowser$1 = typeof window !== "undefined";
        var isServer = !inBrowser$1;
        var BVSS = "__BV_ScrollSpy__";
        function makeConfig(binding) {
            var config = {};
            if (binding.arg) {
                config.element = "#" + binding.arg;
            }
            keys(binding.modifiers).forEach(function(mod) {
                if (/^\d+$/.test(mod)) {
                    config.offset = parseInt(mod, 10);
                } else if (/^(auto|position|offset)$/.test(mod)) {
                    config.method = mod;
                }
            });
            if (typeof binding.value === "string") {
                config.element = binding.value;
            } else if (typeof binding.value === "number") {
                config.offset = Math.round(binding.value);
            } else if (_typeof(binding.value) === "object") {
                keys(binding.value).filter(function(k) {
                    return Boolean(ScrollSpy.DefaultType[k]);
                }).forEach(function(k) {
                    config[k] = binding.value[k];
                });
            }
            return config;
        }
        function addBVSS(el, binding, vnode) {
            if (isServer) {
                return;
            }
            var cfg = makeConfig(binding);
            if (!el[BVSS]) {
                el[BVSS] = new ScrollSpy(el, cfg, vnode.context.$root);
            } else {
                el[BVSS].updateConfig(cfg, vnode.context.$root);
            }
            return el[BVSS];
        }
        function removeBVSS(el) {
            if (el[BVSS]) {
                el[BVSS].dispose();
                el[BVSS] = null;
            }
        }
        var bScrollspy = {
            bind: function bind(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            inserted: function inserted(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            update: function update(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            componentUpdated: function componentUpdated(el, binding, vnode) {
                addBVSS(el, binding, vnode);
            },
            unbind: function unbind(el) {
                if (isServer) {
                    return;
                }
                removeBVSS(el);
            }
        };
        var directives$2 = {
            bScrollspy: bScrollspy
        };
        var VuePlugin$38 = {
            install: function install(Vue) {
                registerDirectives(Vue, directives$2);
            }
        };
        vueUse(VuePlugin$38);
        var inBrowser$2 = typeof window !== "undefined" && typeof document !== "undefined";
        var BVTT = "__BV_ToolTip__";
        var validTriggers = {
            focus: true,
            hover: true,
            click: true,
            blur: true
        };
        function parseBindings(bindings) {
            var config = {};
            if (typeof bindings.value === "string") {
                config.title = bindings.value;
            } else if (typeof bindings.value === "function") {
                config.title = bindings.value;
            } else if (_typeof(bindings.value) === "object") {
                config = assign(bindings.value);
            }
            if (bindings.arg) {
                config.container = "#" + bindings.arg;
            }
            keys(bindings.modifiers).forEach(function(mod) {
                if (/^html$/.test(mod)) {
                    config.html = true;
                } else if (/^nofade$/.test(mod)) {
                    config.animation = false;
                } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
                    config.placement = mod;
                } else if (/^(window|viewport)$/.test(mod)) {
                    config.boundary = mod;
                } else if (/^d\d+$/.test(mod)) {
                    var delay = parseInt(mod.slice(1), 10) || 0;
                    if (delay) {
                        config.delay = delay;
                    }
                } else if (/^o-?\d+$/.test(mod)) {
                    var offset = parseInt(mod.slice(1), 10) || 0;
                    if (offset) {
                        config.offset = offset;
                    }
                }
            });
            var selectedTriggers = {};
            var triggers = typeof config.trigger === "string" ? config.trigger.trim().split(/\s+/) : [];
            triggers.forEach(function(trigger) {
                if (validTriggers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            keys(validTriggers).forEach(function(trigger) {
                if (bindings.modifiers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            config.trigger = keys(selectedTriggers).join(" ");
            if (config.trigger === "blur") {
                config.trigger = "focus";
            }
            if (!config.trigger) {
                delete config.trigger;
            }
            return config;
        }
        function applyBVTT(el, bindings, vnode) {
            if (!inBrowser$2) {
                return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_1_popper_js__["a"]) {
                warn("v-b-tooltip: Popper.js is required for tooltips to work");
                return;
            }
            if (el[BVTT]) {
                el[BVTT].updateConfig(parseBindings(bindings));
            } else {
                el[BVTT] = new ToolTip(el, parseBindings(bindings), vnode.context.$root);
            }
        }
        function removeBVTT(el) {
            if (!inBrowser$2) {
                return;
            }
            if (el[BVTT]) {
                el[BVTT].destroy();
                el[BVTT] = null;
                delete el[BVTT];
            }
        }
        var bTooltip$1 = {
            bind: function bind(el, bindings, vnode) {
                applyBVTT(el, bindings, vnode);
            },
            inserted: function inserted(el, bindings, vnode) {
                applyBVTT(el, bindings, vnode);
            },
            update: function update(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVTT(el, bindings, vnode);
                }
            },
            componentUpdated: function componentUpdated(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVTT(el, bindings, vnode);
                }
            },
            unbind: function unbind(el) {
                removeBVTT(el);
            }
        };
        var directives$3 = {
            bTooltip: bTooltip$1
        };
        var VuePlugin$39 = {
            install: function install(Vue) {
                registerDirectives(Vue, directives$3);
            }
        };
        vueUse(VuePlugin$39);
        var inBrowser$3 = typeof window !== "undefined" && typeof document !== "undefined";
        var BVPO = "__BV_PopOver__";
        var validTriggers$1 = {
            focus: true,
            hover: true,
            click: true,
            blur: true
        };
        function parseBindings$1(bindings) {
            var config = {};
            if (typeof bindings.value === "string") {
                config.content = bindings.value;
            } else if (typeof bindings.value === "function") {
                config.content = bindings.value;
            } else if (_typeof(bindings.value) === "object") {
                config = assign(bindings.value);
            }
            if (bindings.arg) {
                config.container = "#" + bindings.arg;
            }
            keys(bindings.modifiers).forEach(function(mod) {
                if (/^html$/.test(mod)) {
                    config.html = true;
                } else if (/^nofade$/.test(mod)) {
                    config.animation = false;
                } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
                    config.placement = mod;
                } else if (/^(window|viewport)$/.test(mod)) {
                    config.boundary = mod;
                } else if (/^d\d+$/.test(mod)) {
                    var delay = parseInt(mod.slice(1), 10) || 0;
                    if (delay) {
                        config.delay = delay;
                    }
                } else if (/^o-?\d+$/.test(mod)) {
                    var offset = parseInt(mod.slice(1), 10) || 0;
                    if (offset) {
                        config.offset = offset;
                    }
                }
            });
            var selectedTriggers = {};
            var triggers = typeof config.trigger === "string" ? config.trigger.trim().split(/\s+/) : [];
            triggers.forEach(function(trigger) {
                if (validTriggers$1[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            keys(validTriggers$1).forEach(function(trigger) {
                if (bindings.modifiers[trigger]) {
                    selectedTriggers[trigger] = true;
                }
            });
            config.trigger = keys(selectedTriggers).join(" ");
            if (config.trigger === "blur") {
                config.trigger = "focus";
            }
            if (!config.trigger) {
                delete config.trigger;
            }
            return config;
        }
        function applyBVPO(el, bindings, vnode) {
            if (!inBrowser$3) {
                return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_1_popper_js__["a"]) {
                warn("v-b-popover: Popper.js is required for popovers to work");
                return;
            }
            if (el[BVPO]) {
                el[BVPO].updateConfig(parseBindings$1(bindings));
            } else {
                el[BVPO] = new PopOver(el, parseBindings$1(bindings), vnode.context.$root);
            }
        }
        function removeBVPO(el) {
            if (!inBrowser$3) {
                return;
            }
            if (el[BVPO]) {
                el[BVPO].destroy();
                el[BVPO] = null;
                delete el[BVPO];
            }
        }
        var bPopover$1 = {
            bind: function bind(el, bindings, vnode) {
                applyBVPO(el, bindings, vnode);
            },
            inserted: function inserted(el, bindings, vnode) {
                applyBVPO(el, bindings, vnode);
            },
            update: function update(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVPO(el, bindings, vnode);
                }
            },
            componentUpdated: function componentUpdated(el, bindings, vnode) {
                if (bindings.value !== bindings.oldValue) {
                    applyBVPO(el, bindings, vnode);
                }
            },
            unbind: function unbind(el) {
                removeBVPO(el);
            }
        };
        var directives$4 = {
            bPopover: bPopover$1
        };
        var VuePlugin$40 = {
            install: function install(Vue) {
                registerDirectives(Vue, directives$4);
            }
        };
        vueUse(VuePlugin$40);
        var directives$5 = Object.freeze({
            Toggle: VuePlugin$10,
            Modal: VuePlugin$27,
            Scrollspy: VuePlugin$38,
            Tooltip: VuePlugin$39,
            Popover: VuePlugin$40
        });
        var VuePlugin$41 = {
            install: function install(Vue) {
                if (Vue._bootstrap_vue_installed) {
                    return;
                }
                Vue._bootstrap_vue_installed = true;
                for (var plugin in components$36) {
                    Vue.use(components$36[plugin]);
                }
                for (var _plugin in directives$5) {
                    Vue.use(directives$5[_plugin]);
                }
            }
        };
        vueUse(VuePlugin$41);
        __webpack_exports__["a"] = VuePlugin$41;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__layout_form_row__ = __webpack_require__(24);
        __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__layout_form_row__["a"];
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(63);
        var __WEBPACK_IMPORTED_MODULE_1__badge__ = __webpack_require__(65);
        var __WEBPACK_IMPORTED_MODULE_2__breadcrumb__ = __webpack_require__(67);
        var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(72);
        var __WEBPACK_IMPORTED_MODULE_4__button_group__ = __webpack_require__(69);
        var __WEBPACK_IMPORTED_MODULE_5__button_toolbar__ = __webpack_require__(71);
        var __WEBPACK_IMPORTED_MODULE_6__input_group__ = __webpack_require__(104);
        var __WEBPACK_IMPORTED_MODULE_7__card__ = __webpack_require__(75);
        var __WEBPACK_IMPORTED_MODULE_8__carousel__ = __webpack_require__(78);
        var __WEBPACK_IMPORTED_MODULE_9__layout__ = __webpack_require__(109);
        var __WEBPACK_IMPORTED_MODULE_10__collapse__ = __webpack_require__(35);
        var __WEBPACK_IMPORTED_MODULE_11__dropdown__ = __webpack_require__(20);
        var __WEBPACK_IMPORTED_MODULE_12__embed__ = __webpack_require__(86);
        var __WEBPACK_IMPORTED_MODULE_13__form__ = __webpack_require__(101);
        var __WEBPACK_IMPORTED_MODULE_14__form_group__ = __webpack_require__(92);
        var __WEBPACK_IMPORTED_MODULE_15__form_checkbox__ = __webpack_require__(88);
        var __WEBPACK_IMPORTED_MODULE_16__form_radio__ = __webpack_require__(96);
        var __WEBPACK_IMPORTED_MODULE_17__form_input__ = __webpack_require__(94);
        var __WEBPACK_IMPORTED_MODULE_18__form_textarea__ = __webpack_require__(100);
        var __WEBPACK_IMPORTED_MODULE_19__form_file__ = __webpack_require__(90);
        var __WEBPACK_IMPORTED_MODULE_20__form_select__ = __webpack_require__(98);
        var __WEBPACK_IMPORTED_MODULE_21__image__ = __webpack_require__(103);
        var __WEBPACK_IMPORTED_MODULE_22__jumbotron__ = __webpack_require__(106);
        var __WEBPACK_IMPORTED_MODULE_23__link__ = __webpack_require__(111);
        var __WEBPACK_IMPORTED_MODULE_24__list_group__ = __webpack_require__(112);
        var __WEBPACK_IMPORTED_MODULE_25__media__ = __webpack_require__(115);
        var __WEBPACK_IMPORTED_MODULE_26__modal__ = __webpack_require__(117);
        var __WEBPACK_IMPORTED_MODULE_27__nav__ = __webpack_require__(47);
        var __WEBPACK_IMPORTED_MODULE_28__navbar__ = __webpack_require__(124);
        var __WEBPACK_IMPORTED_MODULE_29__pagination__ = __webpack_require__(131);
        var __WEBPACK_IMPORTED_MODULE_30__pagination_nav__ = __webpack_require__(129);
        var __WEBPACK_IMPORTED_MODULE_31__popover__ = __webpack_require__(133);
        var __WEBPACK_IMPORTED_MODULE_32__progress__ = __webpack_require__(135);
        var __WEBPACK_IMPORTED_MODULE_33__table__ = __webpack_require__(137);
        var __WEBPACK_IMPORTED_MODULE_34__tabs__ = __webpack_require__(139);
        var __WEBPACK_IMPORTED_MODULE_35__tooltip__ = __webpack_require__(142);
        __webpack_require__.d(__webpack_exports__, "Alert", function() {
            return __WEBPACK_IMPORTED_MODULE_0__alert__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Badge", function() {
            return __WEBPACK_IMPORTED_MODULE_1__badge__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() {
            return __WEBPACK_IMPORTED_MODULE_2__breadcrumb__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Button", function() {
            return __WEBPACK_IMPORTED_MODULE_3__button__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() {
            return __WEBPACK_IMPORTED_MODULE_5__button_toolbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_4__button_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Card", function() {
            return __WEBPACK_IMPORTED_MODULE_7__card__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Carousel", function() {
            return __WEBPACK_IMPORTED_MODULE_8__carousel__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Collapse", function() {
            return __WEBPACK_IMPORTED_MODULE_10__collapse__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Dropdown", function() {
            return __WEBPACK_IMPORTED_MODULE_11__dropdown__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Embed", function() {
            return __WEBPACK_IMPORTED_MODULE_12__embed__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Form", function() {
            return __WEBPACK_IMPORTED_MODULE_13__form__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_14__form_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormInput", function() {
            return __WEBPACK_IMPORTED_MODULE_17__form_input__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormTextarea", function() {
            return __WEBPACK_IMPORTED_MODULE_18__form_textarea__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormFile", function() {
            return __WEBPACK_IMPORTED_MODULE_19__form_file__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormCheckbox", function() {
            return __WEBPACK_IMPORTED_MODULE_15__form_checkbox__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormRadio", function() {
            return __WEBPACK_IMPORTED_MODULE_16__form_radio__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "FormSelect", function() {
            return __WEBPACK_IMPORTED_MODULE_20__form_select__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Image", function() {
            return __WEBPACK_IMPORTED_MODULE_21__image__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "InputGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_6__input_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Jumbotron", function() {
            return __WEBPACK_IMPORTED_MODULE_22__jumbotron__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Layout", function() {
            return __WEBPACK_IMPORTED_MODULE_9__layout__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Link", function() {
            return __WEBPACK_IMPORTED_MODULE_23__link__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "ListGroup", function() {
            return __WEBPACK_IMPORTED_MODULE_24__list_group__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Media", function() {
            return __WEBPACK_IMPORTED_MODULE_25__media__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Modal", function() {
            return __WEBPACK_IMPORTED_MODULE_26__modal__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Nav", function() {
            return __WEBPACK_IMPORTED_MODULE_27__nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Navbar", function() {
            return __WEBPACK_IMPORTED_MODULE_28__navbar__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Pagination", function() {
            return __WEBPACK_IMPORTED_MODULE_29__pagination__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "PaginationNav", function() {
            return __WEBPACK_IMPORTED_MODULE_30__pagination_nav__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Popover", function() {
            return __WEBPACK_IMPORTED_MODULE_31__popover__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Progress", function() {
            return __WEBPACK_IMPORTED_MODULE_32__progress__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Table", function() {
            return __WEBPACK_IMPORTED_MODULE_33__table__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Tabs", function() {
            return __WEBPACK_IMPORTED_MODULE_34__tabs__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Tooltip", function() {
            return __WEBPACK_IMPORTED_MODULE_35__tooltip__["a"];
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        var __WEBPACK_IMPORTED_MODULE_0__toggle__ = __webpack_require__(148);
        var __WEBPACK_IMPORTED_MODULE_1__modal__ = __webpack_require__(144);
        var __WEBPACK_IMPORTED_MODULE_2__scrollspy__ = __webpack_require__(173);
        var __WEBPACK_IMPORTED_MODULE_3__tooltip__ = __webpack_require__(175);
        var __WEBPACK_IMPORTED_MODULE_4__popover__ = __webpack_require__(172);
        __webpack_require__.d(__webpack_exports__, "Toggle", function() {
            return __WEBPACK_IMPORTED_MODULE_0__toggle__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Modal", function() {
            return __WEBPACK_IMPORTED_MODULE_1__modal__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Scrollspy", function() {
            return __WEBPACK_IMPORTED_MODULE_2__scrollspy__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Tooltip", function() {
            return __WEBPACK_IMPORTED_MODULE_3__tooltip__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "Popover", function() {
            return __WEBPACK_IMPORTED_MODULE_4__popover__["a"];
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(146);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var directives = {
            bPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c"])(Vue, directives);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__scrollspy__ = __webpack_require__(147);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var directives = {
            bScrollspy: __WEBPACK_IMPORTED_MODULE_0__scrollspy__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c"])(Vue, directives);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__ = __webpack_require__(16);
        var __WEBPACK_IMPORTED_MODULE_2__utils_warn__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(5);
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        var NAME = "v-b-scrollspy";
        var ACTIVATE_EVENT = "bv::scrollspy::activate";
        var Default = {
            element: "body",
            offset: 10,
            method: "auto",
            throttle: 75
        };
        var DefaultType = {
            element: "(string|element|component)",
            offset: "number",
            method: "string",
            throttle: "number"
        };
        var ClassName = {
            DROPDOWN_ITEM: "dropdown-item",
            ACTIVE: "active"
        };
        var Selector = {
            ACTIVE: ".active",
            NAV_LIST_GROUP: ".nav, .list-group",
            NAV_LINKS: ".nav-link",
            NAV_ITEMS: ".nav-item",
            LIST_ITEMS: ".list-group-item",
            DROPDOWN: ".dropdown, .dropup",
            DROPDOWN_ITEMS: ".dropdown-item",
            DROPDOWN_TOGGLE: ".dropdown-toggle"
        };
        var OffsetMethod = {
            OFFSET: "offset",
            POSITION: "position"
        };
        var HREF_REGEX = /^#[^\/!]+/;
        var TransitionEndEvents = [ "webkitTransitionEnd", "transitionend", "otransitionend", "oTransitionEnd" ];
        function toType(obj) {
            return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        }
        function typeCheckConfig(componentName, config, configTypes) {
            for (var property in configTypes) {
                if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                    var expectedTypes = configTypes[property];
                    var value = config[property];
                    var valueType = value && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n"])(value) ? "element" : toType(value);
                    valueType = value && value._isVue ? "component" : valueType;
                    if (!new RegExp(expectedTypes).test(valueType)) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_warn__["a"])(componentName + ': Option "' + property + '" provided type "' + valueType + '", but expected type "' + expectedTypes + '"');
                    }
                }
            }
        }
        var ScrollSpy = function() {
            function ScrollSpy(element, config, $root) {
                _classCallCheck(this, ScrollSpy);
                this.$el = element;
                this.$scroller = null;
                this.$selector = [ Selector.NAV_LINKS, Selector.LIST_ITEMS, Selector.DROPDOWN_ITEMS ].join(",");
                this.$offsets = [];
                this.$targets = [];
                this.$activeTarget = null;
                this.$scrollHeight = 0;
                this.$resizeTimeout = null;
                this.$obs_scroller = null;
                this.$obs_targets = null;
                this.$root = $root || null;
                this.$config = null;
                this.updateConfig(config);
            }
            _createClass(ScrollSpy, [ {
                key: "updateConfig",
                value: function updateConfig(config, $root) {
                    if (this.$scroller) {
                        this.unlisten();
                        this.$scroller = null;
                    }
                    var cfg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a"])({}, this.constructor.Default, config);
                    if ($root) {
                        this.$root = $root;
                    }
                    typeCheckConfig(this.constructor.Name, cfg, this.constructor.DefaultType);
                    this.$config = cfg;
                    if (this.$root) {
                        var self = this;
                        this.$root.$nextTick(function() {
                            self.listen();
                        });
                    } else {
                        this.listen();
                    }
                }
            }, {
                key: "dispose",
                value: function dispose() {
                    this.unlisten();
                    clearTimeout(this.$resizeTimeout);
                    this.$resizeTimeout = null;
                    this.$el = null;
                    this.$config = null;
                    this.$scroller = null;
                    this.$selector = null;
                    this.$offsets = null;
                    this.$targets = null;
                    this.$activeTarget = null;
                    this.$scrollHeight = null;
                }
            }, {
                key: "listen",
                value: function listen() {
                    var _this = this;
                    var scroller = this.getScroller();
                    if (scroller && scroller.tagName !== "BODY") {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f"])(scroller, "scroll", this);
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f"])(window, "scroll", this);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f"])(window, "resize", this);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f"])(window, "orientationchange", this);
                    TransitionEndEvents.forEach(function(evtName) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f"])(window, evtName, _this);
                    });
                    this.setObservers(true);
                    this.handleEvent("refresh");
                }
            }, {
                key: "unlisten",
                value: function unlisten() {
                    var _this2 = this;
                    var scroller = this.getScroller();
                    this.setObservers(false);
                    if (scroller && scroller.tagName !== "BODY") {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["g"])(scroller, "scroll", this);
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["g"])(window, "scroll", this);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["g"])(window, "resize", this);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["g"])(window, "orientationchange", this);
                    TransitionEndEvents.forEach(function(evtName) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["g"])(window, evtName, _this2);
                    });
                }
            }, {
                key: "setObservers",
                value: function setObservers(on) {
                    var _this3 = this;
                    if (this.$obs_scroller) {
                        this.$obs_scroller.disconnect();
                        this.$obs_scroller = null;
                    }
                    if (this.$obs_targets) {
                        this.$obs_targets.disconnect();
                        this.$obs_targets = null;
                    }
                    if (on) {
                        this.$obs_targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a"])(this.$el, function() {
                            _this3.handleEvent("mutation");
                        }, {
                            subtree: true,
                            childList: true,
                            attributes: true,
                            attributeFilter: [ "href" ]
                        });
                        this.$obs_scroller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a"])(this.getScroller(), function() {
                            _this3.handleEvent("mutation");
                        }, {
                            subtree: true,
                            childList: true,
                            characterData: true,
                            attributes: true,
                            attributeFilter: [ "id", "style", "class" ]
                        });
                    }
                }
            }, {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var type = typeof evt === "string" ? evt : evt.type;
                    var self = this;
                    function resizeThrottle() {
                        if (!self.$resizeTimeout) {
                            self.$resizeTimeout = setTimeout(function() {
                                self.refresh();
                                self.process();
                                self.$resizeTimeout = null;
                            }, self.$config.throttle);
                        }
                    }
                    if (type === "scroll") {
                        if (!this.$obs_scroller) {
                            this.listen();
                        }
                        this.process();
                    } else if (/(resize|orientationchange|mutation|refresh)/.test(type)) {
                        resizeThrottle();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    var _this4 = this;
                    var scroller = this.getScroller();
                    if (!scroller) {
                        return;
                    }
                    var autoMethod = scroller !== scroller.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;
                    var method = this.$config.method === "auto" ? autoMethod : this.$config.method;
                    var methodFn = method === OffsetMethod.POSITION ? __WEBPACK_IMPORTED_MODULE_3__utils_dom__["o"] : __WEBPACK_IMPORTED_MODULE_3__utils_dom__["p"];
                    var offsetBase = method === OffsetMethod.POSITION ? this.getScrollTop() : 0;
                    this.$offsets = [];
                    this.$targets = [];
                    this.$scrollHeight = this.getScrollHeight();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["q"])(this.$selector, this.$el).map(function(link) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["j"])(link, "href");
                    }).filter(function(href) {
                        return HREF_REGEX.test(href || "");
                    }).map(function(href) {
                        var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["i"])(href, scroller);
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b"])(el)) {
                            return {
                                offset: parseInt(methodFn(el).top, 10) + offsetBase,
                                target: href
                            };
                        }
                        return null;
                    }).filter(function(item) {
                        return item;
                    }).sort(function(a, b) {
                        return a.offset - b.offset;
                    }).reduce(function(memo, item) {
                        if (!memo[item.target]) {
                            _this4.$offsets.push(item.offset);
                            _this4.$targets.push(item.target);
                            memo[item.target] = true;
                        }
                        return memo;
                    }, {});
                    return this;
                }
            }, {
                key: "process",
                value: function process() {
                    var scrollTop = this.getScrollTop() + this.$config.offset;
                    var scrollHeight = this.getScrollHeight();
                    var maxScroll = this.$config.offset + scrollHeight - this.getOffsetHeight();
                    if (this.$scrollHeight !== scrollHeight) {
                        this.refresh();
                    }
                    if (scrollTop >= maxScroll) {
                        var target = this.$targets[this.$targets.length - 1];
                        if (this.$activeTarget !== target) {
                            this.activate(target);
                        }
                        return;
                    }
                    if (this.$activeTarget && scrollTop < this.$offsets[0] && this.$offsets[0] > 0) {
                        this.$activeTarget = null;
                        this.clear();
                        return;
                    }
                    for (var i = this.$offsets.length; i--; ) {
                        var isActiveTarget = this.$activeTarget !== this.$targets[i] && scrollTop >= this.$offsets[i] && (typeof this.$offsets[i + 1] === "undefined" || scrollTop < this.$offsets[i + 1]);
                        if (isActiveTarget) {
                            this.activate(this.$targets[i]);
                        }
                    }
                }
            }, {
                key: "getScroller",
                value: function getScroller() {
                    if (this.$scroller) {
                        return this.$scroller;
                    }
                    var scroller = this.$config.element;
                    if (!scroller) {
                        return null;
                    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n"])(scroller.$el)) {
                        scroller = scroller.$el;
                    } else if (typeof scroller === "string") {
                        scroller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["i"])(scroller);
                    }
                    if (!scroller) {
                        return null;
                    }
                    this.$scroller = scroller.tagName === "BODY" ? window : scroller;
                    return this.$scroller;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    var scroller = this.getScroller();
                    return scroller === window ? scroller.pageYOffset : scroller.scrollTop;
                }
            }, {
                key: "getScrollHeight",
                value: function getScrollHeight() {
                    return this.getScroller().scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
                }
            }, {
                key: "getOffsetHeight",
                value: function getOffsetHeight() {
                    var scroller = this.getScroller();
                    return scroller === window ? window.innerHeight : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["r"])(scroller).height;
                }
            }, {
                key: "activate",
                value: function activate(target) {
                    var _this5 = this;
                    this.$activeTarget = target;
                    this.clear();
                    var links = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["q"])(this.$selector.split(",").map(function(selector) {
                        return selector + '[href="' + target + '"]';
                    }).join(","), this.$el);
                    links.forEach(function(link) {
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a"])(link, ClassName.DROPDOWN_ITEM)) {
                            var dropdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["h"])(Selector.DROPDOWN, link);
                            if (dropdown) {
                                _this5.setActiveState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["i"])(Selector.DROPDOWN_TOGGLE, dropdown), true);
                            }
                            _this5.setActiveState(link, true);
                        } else {
                            _this5.setActiveState(link, true);
                            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s"])(link.parentElement, Selector.NAV_ITEMS)) {
                                _this5.setActiveState(link.parentElement, true);
                            }
                            var el = link;
                            while (el) {
                                el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["h"])(Selector.NAV_LIST_GROUP, el);
                                var sibling = el ? el.previousElementSibling : null;
                                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s"])(sibling, Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS)) {
                                    _this5.setActiveState(sibling, true);
                                }
                                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s"])(sibling, Selector.NAV_ITEMS)) {
                                    _this5.setActiveState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["i"])(Selector.NAV_LINKS, sibling), true);
                                    _this5.setActiveState(sibling, true);
                                }
                            }
                        }
                    });
                    if (links && links.length > 0 && this.$root) {
                        this.$root.$emit(ACTIVATE_EVENT, target, links);
                    }
                }
            }, {
                key: "clear",
                value: function clear() {
                    var _this6 = this;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["q"])(this.$selector + ", " + Selector.NAV_ITEMS, this.$el).filter(function(el) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a"])(el, ClassName.ACTIVE);
                    }).forEach(function(el) {
                        return _this6.setActiveState(el, false);
                    });
                }
            }, {
                key: "setActiveState",
                value: function setActiveState(el, active) {
                    if (!el) {
                        return;
                    }
                    if (active) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d"])(el, ClassName.ACTIVE);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e"])(el, ClassName.ACTIVE);
                    }
                }
            } ], [ {
                key: "Name",
                get: function get() {
                    return NAME;
                }
            }, {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }, {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            } ]);
            return ScrollSpy;
        }();
        __webpack_exports__["a"] = ScrollSpy;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(150);
        var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);
        var directives = {
            bTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a"]
        };
        var VuePlugin = {
            install: function install(Vue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c"])(Vue, directives);
            }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b"])(VuePlugin);
        __webpack_exports__["a"] = VuePlugin;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = {
            mounted: function mounted() {
                if (typeof document !== "undefined") {
                    document.documentElement.addEventListener("click", this._clickOutListener);
                }
            },
            beforeDestroy: function beforeDestroy() {
                if (typeof document !== "undefined") {
                    document.documentElement.removeEventListener("click", this._clickOutListener);
                }
            },
            methods: {
                _clickOutListener: function _clickOutListener(e) {
                    if (!this.$el.contains(e.target)) {
                        if (this.clickOutListener) {
                            this.clickOutListener();
                        }
                    }
                }
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = lowerFirst;
        function lowerFirst(str) {
            if (typeof str !== "string") {
                str = String(str);
            }
            return str.charAt(0).toLowerCase() + str.slice(1);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = memoize;
        var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);
        function memoize(fn) {
            var cache = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["f"])(null);
            return function memoizedFn() {
                var args = JSON.stringify(arguments);
                return cache[args] = cache[args] || fn.apply(null, arguments);
            };
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = function(length) {
            return Array.apply(null, {
                length: length
            });
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return HTMLElement;
        });
        var isSSR = typeof window === "undefined";
        var HTMLElement = isSSR ? Object : window.HTMLElement;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = stableSort;
        function stableSort(array, compareFn) {
            return array.map(function(a, index) {
                return [ index, a ];
            }).sort(function(a, b) {
                return this(a[1], b[1]) || a[0] - b[0];
            }.bind(compareFn)).map(function(e) {
                return e[1];
            });
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = suffixPropName;
        var __WEBPACK_IMPORTED_MODULE_0__upper_first__ = __webpack_require__(159);
        function suffixPropName(suffix, str) {
            return str + (suffix ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__upper_first__["a"])(suffix) : "");
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_exports__["a"] = unPrefixPropName;
        var __WEBPACK_IMPORTED_MODULE_0__lower_first__ = __webpack_require__(177);
        function unPrefixPropName(prefix, value) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lower_first__["a"])(value.replace(prefix, ""));
        }
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(209);
        module.exports = __webpack_require__(52).Object.keys;
    }, function(module, exports) {
        module.exports = function(it) {
            if (typeof it != "function") throw TypeError(it + " is not a function!");
            return it;
        };
    }, function(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(56);
        module.exports = function(it) {
            if (!isObject(it)) throw TypeError(it + " is not an object!");
            return it;
        };
    }, function(module, exports, __webpack_require__) {
        var toIObject = __webpack_require__(162);
        var toLength = __webpack_require__(205);
        var toAbsoluteIndex = __webpack_require__(204);
        module.exports = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIObject($this);
                var length = toLength(O.length);
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                if (IS_INCLUDES && el != el) while (length > index) {
                    value = O[index++];
                    if (value != value) return true;
                } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
                    if (O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
    }, function(module, exports) {
        var toString = {}.toString;
        module.exports = function(it) {
            return toString.call(it).slice(8, -1);
        };
    }, function(module, exports, __webpack_require__) {
        var aFunction = __webpack_require__(185);
        module.exports = function(fn, that, length) {
            aFunction(fn);
            if (that === undefined) return fn;
            switch (length) {
              case 1:
                return function(a) {
                    return fn.call(that, a);
                };

              case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };

              case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
            }
            return function() {
                return fn.apply(that, arguments);
            };
        };
    }, function(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(56);
        var document = __webpack_require__(55).document;
        var is = isObject(document) && isObject(document.createElement);
        module.exports = function(it) {
            return is ? document.createElement(it) : {};
        };
    }, function(module, exports) {
        module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function(module, exports, __webpack_require__) {
        var global = __webpack_require__(55);
        var core = __webpack_require__(52);
        var ctx = __webpack_require__(189);
        var hide = __webpack_require__(194);
        var PROTOTYPE = "prototype";
        var $export = function(type, name, source) {
            var IS_FORCED = type & $export.F;
            var IS_GLOBAL = type & $export.G;
            var IS_STATIC = type & $export.S;
            var IS_PROTO = type & $export.P;
            var IS_BIND = type & $export.B;
            var IS_WRAP = type & $export.W;
            var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
            var expProto = exports[PROTOTYPE];
            var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
            var key, own, out;
            if (IS_GLOBAL) source = name;
            for (key in source) {
                own = !IS_FORCED && target && target[key] !== undefined;
                if (own && key in exports) continue;
                out = own ? target[key] : source[key];
                exports[key] = IS_GLOBAL && typeof target[key] != "function" ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? function(C) {
                    var F = function(a, b, c) {
                        if (this instanceof C) {
                            switch (arguments.length) {
                              case 0:
                                return new C();

                              case 1:
                                return new C(a);

                              case 2:
                                return new C(a, b);
                            }
                            return new C(a, b, c);
                        }
                        return C.apply(this, arguments);
                    };
                    F[PROTOTYPE] = C[PROTOTYPE];
                    return F;
                }(out) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
                if (IS_PROTO) {
                    (exports.virtual || (exports.virtual = {}))[key] = out;
                    if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                }
            }
        };
        $export.F = 1;
        $export.G = 2;
        $export.S = 4;
        $export.P = 8;
        $export.B = 16;
        $export.W = 32;
        $export.U = 64;
        $export.R = 128;
        module.exports = $export;
    }, function(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;
        module.exports = function(it, key) {
            return hasOwnProperty.call(it, key);
        };
    }, function(module, exports, __webpack_require__) {
        var dP = __webpack_require__(197);
        var createDesc = __webpack_require__(201);
        module.exports = __webpack_require__(53) ? function(object, key, value) {
            return dP.f(object, key, createDesc(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
    }, function(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(53) && !__webpack_require__(54)(function() {
            return Object.defineProperty(__webpack_require__(190)("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a != 7;
        });
    }, function(module, exports, __webpack_require__) {
        var cof = __webpack_require__(188);
        module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
            return cof(it) == "String" ? it.split("") : Object(it);
        };
    }, function(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(186);
        var IE8_DOM_DEFINE = __webpack_require__(195);
        var toPrimitive = __webpack_require__(207);
        var dP = Object.defineProperty;
        exports.f = __webpack_require__(53) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPrimitive(P, true);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return dP(O, P, Attributes);
            } catch (e) {}
            if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
            if ("value" in Attributes) O[P] = Attributes.value;
            return O;
        };
    }, function(module, exports, __webpack_require__) {
        var has = __webpack_require__(193);
        var toIObject = __webpack_require__(162);
        var arrayIndexOf = __webpack_require__(187)(false);
        var IE_PROTO = __webpack_require__(202)("IE_PROTO");
        module.exports = function(object, names) {
            var O = toIObject(object);
            var i = 0;
            var result = [];
            var key;
            for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
            while (names.length > i) if (has(O, key = names[i++])) {
                ~arrayIndexOf(result, key) || result.push(key);
            }
            return result;
        };
    }, function(module, exports, __webpack_require__) {
        var $keys = __webpack_require__(198);
        var enumBugKeys = __webpack_require__(191);
        module.exports = Object.keys || function keys(O) {
            return $keys(O, enumBugKeys);
        };
    }, function(module, exports, __webpack_require__) {
        var $export = __webpack_require__(192);
        var core = __webpack_require__(52);
        var fails = __webpack_require__(54);
        module.exports = function(KEY, exec) {
            var fn = (core.Object || {})[KEY] || Object[KEY];
            var exp = {};
            exp[KEY] = exec(fn);
            $export($export.S + $export.F * fails(function() {
                fn(1);
            }), "Object", exp);
        };
    }, function(module, exports) {
        module.exports = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
    }, function(module, exports, __webpack_require__) {
        var shared = __webpack_require__(203)("keys");
        var uid = __webpack_require__(208);
        module.exports = function(key) {
            return shared[key] || (shared[key] = uid(key));
        };
    }, function(module, exports, __webpack_require__) {
        var global = __webpack_require__(55);
        var SHARED = "__core-js_shared__";
        var store = global[SHARED] || (global[SHARED] = {});
        module.exports = function(key) {
            return store[key] || (store[key] = {});
        };
    }, function(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(161);
        var max = Math.max;
        var min = Math.min;
        module.exports = function(index, length) {
            index = toInteger(index);
            return index < 0 ? max(index + length, 0) : min(index, length);
        };
    }, function(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(161);
        var min = Math.min;
        module.exports = function(it) {
            return it > 0 ? min(toInteger(it), 9007199254740991) : 0;
        };
    }, function(module, exports, __webpack_require__) {
        var defined = __webpack_require__(160);
        module.exports = function(it) {
            return Object(defined(it));
        };
    }, function(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(56);
        module.exports = function(it, S) {
            if (!isObject(it)) return it;
            var fn, val;
            if (S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
            if (typeof (fn = it.valueOf) == "function" && !isObject(val = fn.call(it))) return val;
            if (!S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
            throw TypeError("Can't convert object to primitive value");
        };
    }, function(module, exports) {
        var id = 0;
        var px = Math.random();
        module.exports = function(key) {
            return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + px).toString(36));
        };
    }, function(module, exports, __webpack_require__) {
        var toObject = __webpack_require__(206);
        var $keys = __webpack_require__(199);
        __webpack_require__(200)("keys", function() {
            return function keys(it) {
                return $keys(toObject(it));
            };
        });
    }, function(module, exports) {}, function(module, exports) {}, function(module, exports) {}, function(module, exports) {}, function(module, exports) {}, function(module, exports) {}, function(module, exports) {}, function(module, exports) {
        var process = module.exports = {};
        var cachedSetTimeout;
        var cachedClearTimeout;
        function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
        }
        (function() {
            try {
                if (typeof setTimeout === "function") {
                    cachedSetTimeout = setTimeout;
                } else {
                    cachedSetTimeout = defaultSetTimout;
                }
            } catch (e) {
                cachedSetTimeout = defaultSetTimout;
            }
            try {
                if (typeof clearTimeout === "function") {
                    cachedClearTimeout = clearTimeout;
                } else {
                    cachedClearTimeout = defaultClearTimeout;
                }
            } catch (e) {
                cachedClearTimeout = defaultClearTimeout;
            }
        })();
        function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) {
                return setTimeout(fun, 0);
            }
            if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                cachedSetTimeout = setTimeout;
                return setTimeout(fun, 0);
            }
            try {
                return cachedSetTimeout(fun, 0);
            } catch (e) {
                try {
                    return cachedSetTimeout.call(null, fun, 0);
                } catch (e) {
                    return cachedSetTimeout.call(this, fun, 0);
                }
            }
        }
        function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) {
                return clearTimeout(marker);
            }
            if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                cachedClearTimeout = clearTimeout;
                return clearTimeout(marker);
            }
            try {
                return cachedClearTimeout(marker);
            } catch (e) {
                try {
                    return cachedClearTimeout.call(null, marker);
                } catch (e) {
                    return cachedClearTimeout.call(this, marker);
                }
            }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;
        function cleanUpNextTick() {
            if (!draining || !currentQueue) {
                return;
            }
            draining = false;
            if (currentQueue.length) {
                queue = currentQueue.concat(queue);
            } else {
                queueIndex = -1;
            }
            if (queue.length) {
                drainQueue();
            }
        }
        function drainQueue() {
            if (draining) {
                return;
            }
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while (len) {
                currentQueue = queue;
                queue = [];
                while (++queueIndex < len) {
                    if (currentQueue) {
                        currentQueue[queueIndex].run();
                    }
                }
                queueIndex = -1;
                len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
        }
        process.nextTick = function(fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                    args[i - 1] = arguments[i];
                }
            }
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) {
                runTimeout(drainQueue);
            }
        };
        function Item(fun, array) {
            this.fun = fun;
            this.array = array;
        }
        Item.prototype.run = function() {
            this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = "";
        process.versions = {};
        function noop() {}
        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;
        process.listeners = function(name) {
            return [];
        };
        process.binding = function(name) {
            throw new Error("process.binding is not supported");
        };
        process.cwd = function() {
            return "/";
        };
        process.chdir = function(dir) {
            throw new Error("process.chdir is not supported");
        };
        process.umask = function() {
            return 0;
        };
    }, function(module, exports, __webpack_require__) {
        (function(global, process) {
            (function(global, undefined) {
                "use strict";
                if (global.setImmediate) {
                    return;
                }
                var nextHandle = 1;
                var tasksByHandle = {};
                var currentlyRunningATask = false;
                var doc = global.document;
                var registerImmediate;
                function setImmediate(callback) {
                    if (typeof callback !== "function") {
                        callback = new Function("" + callback);
                    }
                    var args = new Array(arguments.length - 1);
                    for (var i = 0; i < args.length; i++) {
                        args[i] = arguments[i + 1];
                    }
                    var task = {
                        callback: callback,
                        args: args
                    };
                    tasksByHandle[nextHandle] = task;
                    registerImmediate(nextHandle);
                    return nextHandle++;
                }
                function clearImmediate(handle) {
                    delete tasksByHandle[handle];
                }
                function run(task) {
                    var callback = task.callback;
                    var args = task.args;
                    switch (args.length) {
                      case 0:
                        callback();
                        break;

                      case 1:
                        callback(args[0]);
                        break;

                      case 2:
                        callback(args[0], args[1]);
                        break;

                      case 3:
                        callback(args[0], args[1], args[2]);
                        break;

                      default:
                        callback.apply(undefined, args);
                        break;
                    }
                }
                function runIfPresent(handle) {
                    if (currentlyRunningATask) {
                        setTimeout(runIfPresent, 0, handle);
                    } else {
                        var task = tasksByHandle[handle];
                        if (task) {
                            currentlyRunningATask = true;
                            try {
                                run(task);
                            } finally {
                                clearImmediate(handle);
                                currentlyRunningATask = false;
                            }
                        }
                    }
                }
                function installNextTickImplementation() {
                    registerImmediate = function(handle) {
                        process.nextTick(function() {
                            runIfPresent(handle);
                        });
                    };
                }
                function canUsePostMessage() {
                    if (global.postMessage && !global.importScripts) {
                        var postMessageIsAsynchronous = true;
                        var oldOnMessage = global.onmessage;
                        global.onmessage = function() {
                            postMessageIsAsynchronous = false;
                        };
                        global.postMessage("", "*");
                        global.onmessage = oldOnMessage;
                        return postMessageIsAsynchronous;
                    }
                }
                function installPostMessageImplementation() {
                    var messagePrefix = "setImmediate$" + Math.random() + "$";
                    var onGlobalMessage = function(event) {
                        if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                            runIfPresent(+event.data.slice(messagePrefix.length));
                        }
                    };
                    if (global.addEventListener) {
                        global.addEventListener("message", onGlobalMessage, false);
                    } else {
                        global.attachEvent("onmessage", onGlobalMessage);
                    }
                    registerImmediate = function(handle) {
                        global.postMessage(messagePrefix + handle, "*");
                    };
                }
                function installMessageChannelImplementation() {
                    var channel = new MessageChannel();
                    channel.port1.onmessage = function(event) {
                        var handle = event.data;
                        runIfPresent(handle);
                    };
                    registerImmediate = function(handle) {
                        channel.port2.postMessage(handle);
                    };
                }
                function installReadyStateChangeImplementation() {
                    var html = doc.documentElement;
                    registerImmediate = function(handle) {
                        var script = doc.createElement("script");
                        script.onreadystatechange = function() {
                            runIfPresent(handle);
                            script.onreadystatechange = null;
                            html.removeChild(script);
                            script = null;
                        };
                        html.appendChild(script);
                    };
                }
                function installSetTimeoutImplementation() {
                    registerImmediate = function(handle) {
                        setTimeout(runIfPresent, 0, handle);
                    };
                }
                var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
                attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
                if ({}.toString.call(global.process) === "[object process]") {
                    installNextTickImplementation();
                } else if (canUsePostMessage()) {
                    installPostMessageImplementation();
                } else if (global.MessageChannel) {
                    installMessageChannelImplementation();
                } else if (doc && "onreadystatechange" in doc.createElement("script")) {
                    installReadyStateChangeImplementation();
                } else {
                    installSetTimeoutImplementation();
                }
                attachTo.setImmediate = setImmediate;
                attachTo.clearImmediate = clearImmediate;
            })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
        }).call(exports, __webpack_require__(13), __webpack_require__(217));
    }, function(module, exports, __webpack_require__) {
        (function(global) {
            var apply = Function.prototype.apply;
            exports.setTimeout = function() {
                return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
            };
            exports.setInterval = function() {
                return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
            };
            exports.clearTimeout = exports.clearInterval = function(timeout) {
                if (timeout) {
                    timeout.close();
                }
            };
            function Timeout(id, clearFn) {
                this._id = id;
                this._clearFn = clearFn;
            }
            Timeout.prototype.unref = Timeout.prototype.ref = function() {};
            Timeout.prototype.close = function() {
                this._clearFn.call(window, this._id);
            };
            exports.enroll = function(item, msecs) {
                clearTimeout(item._idleTimeoutId);
                item._idleTimeout = msecs;
            };
            exports.unenroll = function(item) {
                clearTimeout(item._idleTimeoutId);
                item._idleTimeout = -1;
            };
            exports._unrefActive = exports.active = function(item) {
                clearTimeout(item._idleTimeoutId);
                var msecs = item._idleTimeout;
                if (msecs >= 0) {
                    item._idleTimeoutId = setTimeout(function onTimeout() {
                        if (item._onTimeout) item._onTimeout();
                    }, msecs);
                }
            };
            __webpack_require__(218);
            exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
            exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
        }).call(exports, __webpack_require__(13));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(57);
        var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfea1adc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(226);
        function injectStyle(ssrContext) {
            __webpack_require__(216);
        }
        var normalizeComponent = __webpack_require__(28);
        var __vue_template_functional__ = false;
        var __vue_styles__ = injectStyle;
        var __vue_scopeId__ = null;
        var __vue_module_identifier__ = null;
        var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a"], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfea1adc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a"], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);
        __webpack_exports__["a"] = Component.exports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(59);
        var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3d697c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(225);
        function injectStyle(ssrContext) {
            __webpack_require__(215);
        }
        var normalizeComponent = __webpack_require__(28);
        var __vue_template_functional__ = false;
        var __vue_styles__ = injectStyle;
        var __vue_scopeId__ = "data-v-b3d697c2";
        var __vue_module_identifier__ = null;
        var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a"], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3d697c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a"], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);
        __webpack_exports__["a"] = Component.exports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiteGrid_vue__ = __webpack_require__(60);
        var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ded1cda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiteGrid_vue__ = __webpack_require__(223);
        function injectStyle(ssrContext) {
            __webpack_require__(213);
        }
        var normalizeComponent = __webpack_require__(28);
        var __vue_template_functional__ = false;
        var __vue_styles__ = injectStyle;
        var __vue_scopeId__ = "data-v-4ded1cda";
        var __vue_module_identifier__ = null;
        var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiteGrid_vue__["a"], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ded1cda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiteGrid_vue__["a"], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);
        __webpack_exports__["a"] = Component.exports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var render = function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("table", [ _c("thead", [ _c("tr", _vm._l(_vm.columns, function(key) {
                return _c("th", {
                    class: {
                        active: _vm.sortKey == key
                    },
                    on: {
                        click: function($event) {
                            _vm.sortBy(key);
                        }
                    }
                }, [ _vm._v("\n      " + _vm._s(_vm._f("capitalize")(key)) + "\n      "), _c("span", {
                    staticClass: "arrow",
                    class: _vm.sortOrders[key] > 0 ? "asc" : "dsc"
                }) ]);
            })) ]), _vm._v(" "), _c("tbody", _vm._l(_vm.filteredData, function(entry) {
                return _c("tr", _vm._l(_vm.columns, function(key) {
                    return _c("td", [ _vm._v("\n      " + _vm._s(entry[key]) + "\n    ") ]);
                }));
            })) ]);
        };
        var staticRenderFns = [];
        var esExports = {
            render: render,
            staticRenderFns: staticRenderFns
        };
        __webpack_exports__["a"] = esExports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var render = function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("div", {
                staticClass: "custom"
            }, [ _c("strong", [ _vm._v(_vm._s(_vm.msg)) ]), _vm._v(" "), _c("svg", {
                staticStyle: {
                    position: "relative"
                },
                attrs: {
                    height: "210",
                    width: "500"
                }
            }, [ _c("polygon", {
                staticStyle: {
                    fill: "lime",
                    stroke: "purple",
                    "stroke-width": "5",
                    "fill-rule": "evenodd"
                },
                attrs: {
                    points: "100,10 40,198 190,78 10,78 160,198"
                }
            }), _vm._v("\n    Sorry, your browser does not support inline SVG.\n  ") ]) ]);
        };
        var staticRenderFns = [];
        var esExports = {
            render: render,
            staticRenderFns: staticRenderFns
        };
        __webpack_exports__["a"] = esExports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var render = function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("div", {
                staticClass: "hello"
            }, [ _vm._v("\nHello app\n    "), _c("div", {
                staticClass: "row"
            }, [ _vm._l([ "primary", "secondary", "success", "outline-success", "warning", "danger", "link" ], function(variant) {
                return _vm._l([ "sm", "", "lg" ], function(size) {
                    return _c("div", {
                        key: variant + "_" + size,
                        staticClass: "col-md-4 pb-2"
                    }, [ _c("b-button", {
                        attrs: {
                            size: size,
                            variant: variant
                        }
                    }, [ _vm._v("\n            " + _vm._s(variant) + " " + _vm._s(size) + "\n          ") ]) ], 1);
                });
            }) ], 2), _vm._v(" "), _c("h1", [ _vm._v(_vm._s(_vm.msg)) ]), _vm._v(" "), _c("h2", [ _vm._v("Essential Links") ]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c("h2", [ _vm._v("Ecosystem") ]), _vm._v(" "), _vm._m(1) ]);
        };
        var staticRenderFns = [ function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("ul", [ _c("li", [ _c("a", {
                attrs: {
                    href: "https://vuejs.org",
                    target: "_blank"
                }
            }, [ _vm._v("Core Docs") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "https://forum.vuejs.org",
                    target: "_blank"
                }
            }, [ _vm._v("Forum") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "https://chat.vuejs.org",
                    target: "_blank"
                }
            }, [ _vm._v("Community Chat") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "https://twitter.com/vuejs",
                    target: "_blank"
                }
            }, [ _vm._v("Twitter") ]) ]), _vm._v(" "), _c("br"), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "http://vuejs-templates.github.io/webpack/",
                    target: "_blank"
                }
            }, [ _vm._v("Docs for This Template") ]) ]) ]);
        }, function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("ul", [ _c("li", [ _c("a", {
                attrs: {
                    href: "http://router.vuejs.org/",
                    target: "_blank"
                }
            }, [ _vm._v("vue-router") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "http://vuex.vuejs.org/",
                    target: "_blank"
                }
            }, [ _vm._v("vuex") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "http://vue-loader.vuejs.org/",
                    target: "_blank"
                }
            }, [ _vm._v("vue-loader") ]) ]), _vm._v(" "), _c("li", [ _c("a", {
                attrs: {
                    href: "https://github.com/vuejs/awesome-vue",
                    target: "_blank"
                }
            }, [ _vm._v("awesome-vue") ]) ]) ]);
        } ];
        var esExports = {
            render: render,
            staticRenderFns: staticRenderFns
        };
        __webpack_exports__["a"] = esExports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var render = function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("div", {
                attrs: {
                    id: "app"
                }
            }, [ _c("img", {
                staticStyle: {
                    "margin-bottom": "20px"
                },
                attrs: {
                    src: "https://codeshare.ice.citrix.com/pages/pylon-www/assets/images/pylon-framework-2.png",
                    width: "100"
                }
            }), _vm._v(" "), _c("h4", [ _vm._v("Build successful") ]), _vm._v(" "), _c("b-button", {
                attrs: {
                    name: "search",
                    variant: "primary"
                }
            }, [ _vm._v("Search") ]) ], 1);
        };
        var staticRenderFns = [];
        var esExports = {
            render: render,
            staticRenderFns: staticRenderFns
        };
        __webpack_exports__["a"] = esExports;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        (function(global, setImmediate) {
            /*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
            var emptyObject = Object.freeze({});
            function isUndef(v) {
                return v === undefined || v === null;
            }
            function isDef(v) {
                return v !== undefined && v !== null;
            }
            function isTrue(v) {
                return v === true;
            }
            function isFalse(v) {
                return v === false;
            }
            function isPrimitive(value) {
                return typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "boolean";
            }
            function isObject(obj) {
                return obj !== null && typeof obj === "object";
            }
            var _toString = Object.prototype.toString;
            function toRawType(value) {
                return _toString.call(value).slice(8, -1);
            }
            function isPlainObject(obj) {
                return _toString.call(obj) === "[object Object]";
            }
            function isRegExp(v) {
                return _toString.call(v) === "[object RegExp]";
            }
            function isValidArrayIndex(val) {
                var n = parseFloat(String(val));
                return n >= 0 && Math.floor(n) === n && isFinite(val);
            }
            function toString(val) {
                return val == null ? "" : typeof val === "object" ? JSON.stringify(val, null, 2) : String(val);
            }
            function toNumber(val) {
                var n = parseFloat(val);
                return isNaN(n) ? val : n;
            }
            function makeMap(str, expectsLowerCase) {
                var map = Object.create(null);
                var list = str.split(",");
                for (var i = 0; i < list.length; i++) {
                    map[list[i]] = true;
                }
                return expectsLowerCase ? function(val) {
                    return map[val.toLowerCase()];
                } : function(val) {
                    return map[val];
                };
            }
            var isBuiltInTag = makeMap("slot,component", true);
            var isReservedAttribute = makeMap("key,ref,slot,slot-scope,is");
            function remove(arr, item) {
                if (arr.length) {
                    var index = arr.indexOf(item);
                    if (index > -1) {
                        return arr.splice(index, 1);
                    }
                }
            }
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            function hasOwn(obj, key) {
                return hasOwnProperty.call(obj, key);
            }
            function cached(fn) {
                var cache = Object.create(null);
                return function cachedFn(str) {
                    var hit = cache[str];
                    return hit || (cache[str] = fn(str));
                };
            }
            var camelizeRE = /-(\w)/g;
            var camelize = cached(function(str) {
                return str.replace(camelizeRE, function(_, c) {
                    return c ? c.toUpperCase() : "";
                });
            });
            var capitalize = cached(function(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            });
            var hyphenateRE = /\B([A-Z])/g;
            var hyphenate = cached(function(str) {
                return str.replace(hyphenateRE, "-$1").toLowerCase();
            });
            function polyfillBind(fn, ctx) {
                function boundFn(a) {
                    var l = arguments.length;
                    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
                }
                boundFn._length = fn.length;
                return boundFn;
            }
            function nativeBind(fn, ctx) {
                return fn.bind(ctx);
            }
            var bind = Function.prototype.bind ? nativeBind : polyfillBind;
            function toArray(list, start) {
                start = start || 0;
                var i = list.length - start;
                var ret = new Array(i);
                while (i--) {
                    ret[i] = list[i + start];
                }
                return ret;
            }
            function extend(to, _from) {
                for (var key in _from) {
                    to[key] = _from[key];
                }
                return to;
            }
            function toObject(arr) {
                var res = {};
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i]) {
                        extend(res, arr[i]);
                    }
                }
                return res;
            }
            function noop(a, b, c) {}
            var no = function(a, b, c) {
                return false;
            };
            var identity = function(_) {
                return _;
            };
            function genStaticKeys(modules) {
                return modules.reduce(function(keys, m) {
                    return keys.concat(m.staticKeys || []);
                }, []).join(",");
            }
            function looseEqual(a, b) {
                if (a === b) {
                    return true;
                }
                var isObjectA = isObject(a);
                var isObjectB = isObject(b);
                if (isObjectA && isObjectB) {
                    try {
                        var isArrayA = Array.isArray(a);
                        var isArrayB = Array.isArray(b);
                        if (isArrayA && isArrayB) {
                            return a.length === b.length && a.every(function(e, i) {
                                return looseEqual(e, b[i]);
                            });
                        } else if (!isArrayA && !isArrayB) {
                            var keysA = Object.keys(a);
                            var keysB = Object.keys(b);
                            return keysA.length === keysB.length && keysA.every(function(key) {
                                return looseEqual(a[key], b[key]);
                            });
                        } else {
                            return false;
                        }
                    } catch (e) {
                        return false;
                    }
                } else if (!isObjectA && !isObjectB) {
                    return String(a) === String(b);
                } else {
                    return false;
                }
            }
            function looseIndexOf(arr, val) {
                for (var i = 0; i < arr.length; i++) {
                    if (looseEqual(arr[i], val)) {
                        return i;
                    }
                }
                return -1;
            }
            function once(fn) {
                var called = false;
                return function() {
                    if (!called) {
                        called = true;
                        fn.apply(this, arguments);
                    }
                };
            }
            var SSR_ATTR = "data-server-rendered";
            var ASSET_TYPES = [ "component", "directive", "filter" ];
            var LIFECYCLE_HOOKS = [ "beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured" ];
            var config = {
                optionMergeStrategies: Object.create(null),
                silent: false,
                productionTip: "production" !== "production",
                devtools: "production" !== "production",
                performance: false,
                errorHandler: null,
                warnHandler: null,
                ignoredElements: [],
                keyCodes: Object.create(null),
                isReservedTag: no,
                isReservedAttr: no,
                isUnknownElement: no,
                getTagNamespace: noop,
                parsePlatformTagName: identity,
                mustUseProp: no,
                _lifecycleHooks: LIFECYCLE_HOOKS
            };
            function isReserved(str) {
                var c = (str + "").charCodeAt(0);
                return c === 36 || c === 95;
            }
            function def(obj, key, val, enumerable) {
                Object.defineProperty(obj, key, {
                    value: val,
                    enumerable: !!enumerable,
                    writable: true,
                    configurable: true
                });
            }
            var bailRE = /[^\w.$]/;
            function parsePath(path) {
                if (bailRE.test(path)) {
                    return;
                }
                var segments = path.split(".");
                return function(obj) {
                    for (var i = 0; i < segments.length; i++) {
                        if (!obj) {
                            return;
                        }
                        obj = obj[segments[i]];
                    }
                    return obj;
                };
            }
            var hasProto = "__proto__" in {};
            var inBrowser = typeof window !== "undefined";
            var inWeex = typeof WXEnvironment !== "undefined" && !!WXEnvironment.platform;
            var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
            var UA = inBrowser && window.navigator.userAgent.toLowerCase();
            var isIE = UA && /msie|trident/.test(UA);
            var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
            var isEdge = UA && UA.indexOf("edge/") > 0;
            var isAndroid = UA && UA.indexOf("android") > 0 || weexPlatform === "android";
            var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === "ios";
            var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
            var nativeWatch = {}.watch;
            var supportsPassive = false;
            if (inBrowser) {
                try {
                    var opts = {};
                    Object.defineProperty(opts, "passive", {
                        get: function get() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener("test-passive", null, opts);
                } catch (e) {}
            }
            var _isServer;
            var isServerRendering = function() {
                if (_isServer === undefined) {
                    if (!inBrowser && !inWeex && typeof global !== "undefined") {
                        _isServer = global["process"].env.VUE_ENV === "server";
                    } else {
                        _isServer = false;
                    }
                }
                return _isServer;
            };
            var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
            function isNative(Ctor) {
                return typeof Ctor === "function" && /native code/.test(Ctor.toString());
            }
            var hasSymbol = typeof Symbol !== "undefined" && isNative(Symbol) && typeof Reflect !== "undefined" && isNative(Reflect.ownKeys);
            var _Set;
            if (typeof Set !== "undefined" && isNative(Set)) {
                _Set = Set;
            } else {
                _Set = function() {
                    function Set() {
                        this.set = Object.create(null);
                    }
                    Set.prototype.has = function has(key) {
                        return this.set[key] === true;
                    };
                    Set.prototype.add = function add(key) {
                        this.set[key] = true;
                    };
                    Set.prototype.clear = function clear() {
                        this.set = Object.create(null);
                    };
                    return Set;
                }();
            }
            var warn = noop;
            var tip = noop;
            var generateComponentTrace = noop;
            var formatComponentName = noop;
            if (false) {
                var hasConsole = typeof console !== "undefined";
                var classifyRE = /(?:^|[-_])(\w)/g;
                var classify = function(str) {
                    return str.replace(classifyRE, function(c) {
                        return c.toUpperCase();
                    }).replace(/[-_]/g, "");
                };
                warn = function(msg, vm) {
                    var trace = vm ? generateComponentTrace(vm) : "";
                    if (config.warnHandler) {
                        config.warnHandler.call(null, msg, vm, trace);
                    } else if (hasConsole && !config.silent) {
                        console.error("[Vue warn]: " + msg + trace);
                    }
                };
                tip = function(msg, vm) {
                    if (hasConsole && !config.silent) {
                        console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ""));
                    }
                };
                formatComponentName = function(vm, includeFile) {
                    if (vm.$root === vm) {
                        return "<Root>";
                    }
                    var options = typeof vm === "function" && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
                    var name = options.name || options._componentTag;
                    var file = options.__file;
                    if (!name && file) {
                        var match = file.match(/([^\/\\]+)\.vue$/);
                        name = match && match[1];
                    }
                    return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : "");
                };
                var repeat = function(str, n) {
                    var res = "";
                    while (n) {
                        if (n % 2 === 1) {
                            res += str;
                        }
                        if (n > 1) {
                            str += str;
                        }
                        n >>= 1;
                    }
                    return res;
                };
                generateComponentTrace = function(vm) {
                    if (vm._isVue && vm.$parent) {
                        var tree = [];
                        var currentRecursiveSequence = 0;
                        while (vm) {
                            if (tree.length > 0) {
                                var last = tree[tree.length - 1];
                                if (last.constructor === vm.constructor) {
                                    currentRecursiveSequence++;
                                    vm = vm.$parent;
                                    continue;
                                } else if (currentRecursiveSequence > 0) {
                                    tree[tree.length - 1] = [ last, currentRecursiveSequence ];
                                    currentRecursiveSequence = 0;
                                }
                            }
                            tree.push(vm);
                            vm = vm.$parent;
                        }
                        return "\n\nfound in\n\n" + tree.map(function(vm, i) {
                            return "" + (i === 0 ? "---\x3e " : repeat(" ", 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
                        }).join("\n");
                    } else {
                        return "\n\n(found in " + formatComponentName(vm) + ")";
                    }
                };
            }
            var uid = 0;
            var Dep = function Dep() {
                this.id = uid++;
                this.subs = [];
            };
            Dep.prototype.addSub = function addSub(sub) {
                this.subs.push(sub);
            };
            Dep.prototype.removeSub = function removeSub(sub) {
                remove(this.subs, sub);
            };
            Dep.prototype.depend = function depend() {
                if (Dep.target) {
                    Dep.target.addDep(this);
                }
            };
            Dep.prototype.notify = function notify() {
                var subs = this.subs.slice();
                for (var i = 0, l = subs.length; i < l; i++) {
                    subs[i].update();
                }
            };
            Dep.target = null;
            var targetStack = [];
            function pushTarget(_target) {
                if (Dep.target) {
                    targetStack.push(Dep.target);
                }
                Dep.target = _target;
            }
            function popTarget() {
                Dep.target = targetStack.pop();
            }
            var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
                this.tag = tag;
                this.data = data;
                this.children = children;
                this.text = text;
                this.elm = elm;
                this.ns = undefined;
                this.context = context;
                this.fnContext = undefined;
                this.fnOptions = undefined;
                this.fnScopeId = undefined;
                this.key = data && data.key;
                this.componentOptions = componentOptions;
                this.componentInstance = undefined;
                this.parent = undefined;
                this.raw = false;
                this.isStatic = false;
                this.isRootInsert = true;
                this.isComment = false;
                this.isCloned = false;
                this.isOnce = false;
                this.asyncFactory = asyncFactory;
                this.asyncMeta = undefined;
                this.isAsyncPlaceholder = false;
            };
            var prototypeAccessors = {
                child: {
                    configurable: true
                }
            };
            prototypeAccessors.child.get = function() {
                return this.componentInstance;
            };
            Object.defineProperties(VNode.prototype, prototypeAccessors);
            var createEmptyVNode = function(text) {
                if (text === void 0) text = "";
                var node = new VNode();
                node.text = text;
                node.isComment = true;
                return node;
            };
            function createTextVNode(val) {
                return new VNode(undefined, undefined, undefined, String(val));
            }
            function cloneVNode(vnode) {
                var cloned = new VNode(vnode.tag, vnode.data, vnode.children, vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
                cloned.ns = vnode.ns;
                cloned.isStatic = vnode.isStatic;
                cloned.key = vnode.key;
                cloned.isComment = vnode.isComment;
                cloned.fnContext = vnode.fnContext;
                cloned.fnOptions = vnode.fnOptions;
                cloned.fnScopeId = vnode.fnScopeId;
                cloned.isCloned = true;
                return cloned;
            }
            var arrayProto = Array.prototype;
            var arrayMethods = Object.create(arrayProto);
            var methodsToPatch = [ "push", "pop", "shift", "unshift", "splice", "sort", "reverse" ];
            methodsToPatch.forEach(function(method) {
                var original = arrayProto[method];
                def(arrayMethods, method, function mutator() {
                    var args = [], len = arguments.length;
                    while (len--) args[len] = arguments[len];
                    var result = original.apply(this, args);
                    var ob = this.__ob__;
                    var inserted;
                    switch (method) {
                      case "push":
                      case "unshift":
                        inserted = args;
                        break;

                      case "splice":
                        inserted = args.slice(2);
                        break;
                    }
                    if (inserted) {
                        ob.observeArray(inserted);
                    }
                    ob.dep.notify();
                    return result;
                });
            });
            var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
            var shouldObserve = true;
            function toggleObserving(value) {
                shouldObserve = value;
            }
            var Observer = function Observer(value) {
                this.value = value;
                this.dep = new Dep();
                this.vmCount = 0;
                def(value, "__ob__", this);
                if (Array.isArray(value)) {
                    var augment = hasProto ? protoAugment : copyAugment;
                    augment(value, arrayMethods, arrayKeys);
                    this.observeArray(value);
                } else {
                    this.walk(value);
                }
            };
            Observer.prototype.walk = function walk(obj) {
                var keys = Object.keys(obj);
                for (var i = 0; i < keys.length; i++) {
                    defineReactive(obj, keys[i]);
                }
            };
            Observer.prototype.observeArray = function observeArray(items) {
                for (var i = 0, l = items.length; i < l; i++) {
                    observe(items[i]);
                }
            };
            function protoAugment(target, src, keys) {
                target.__proto__ = src;
            }
            function copyAugment(target, src, keys) {
                for (var i = 0, l = keys.length; i < l; i++) {
                    var key = keys[i];
                    def(target, key, src[key]);
                }
            }
            function observe(value, asRootData) {
                if (!isObject(value) || value instanceof VNode) {
                    return;
                }
                var ob;
                if (hasOwn(value, "__ob__") && value.__ob__ instanceof Observer) {
                    ob = value.__ob__;
                } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
                    ob = new Observer(value);
                }
                if (asRootData && ob) {
                    ob.vmCount++;
                }
                return ob;
            }
            function defineReactive(obj, key, val, customSetter, shallow) {
                var dep = new Dep();
                var property = Object.getOwnPropertyDescriptor(obj, key);
                if (property && property.configurable === false) {
                    return;
                }
                var getter = property && property.get;
                if (!getter && arguments.length === 2) {
                    val = obj[key];
                }
                var setter = property && property.set;
                var childOb = !shallow && observe(val);
                Object.defineProperty(obj, key, {
                    enumerable: true,
                    configurable: true,
                    get: function reactiveGetter() {
                        var value = getter ? getter.call(obj) : val;
                        if (Dep.target) {
                            dep.depend();
                            if (childOb) {
                                childOb.dep.depend();
                                if (Array.isArray(value)) {
                                    dependArray(value);
                                }
                            }
                        }
                        return value;
                    },
                    set: function reactiveSetter(newVal) {
                        var value = getter ? getter.call(obj) : val;
                        if (newVal === value || newVal !== newVal && value !== value) {
                            return;
                        }
                        if (false) {
                            customSetter();
                        }
                        if (setter) {
                            setter.call(obj, newVal);
                        } else {
                            val = newVal;
                        }
                        childOb = !shallow && observe(newVal);
                        dep.notify();
                    }
                });
            }
            function set(target, key, val) {
                if (false) {
                    warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
                }
                if (Array.isArray(target) && isValidArrayIndex(key)) {
                    target.length = Math.max(target.length, key);
                    target.splice(key, 1, val);
                    return val;
                }
                if (key in target && !(key in Object.prototype)) {
                    target[key] = val;
                    return val;
                }
                var ob = target.__ob__;
                if (target._isVue || ob && ob.vmCount) {
                    "production" !== "production" && warn("Avoid adding reactive properties to a Vue instance or its root $data " + "at runtime - declare it upfront in the data option.");
                    return val;
                }
                if (!ob) {
                    target[key] = val;
                    return val;
                }
                defineReactive(ob.value, key, val);
                ob.dep.notify();
                return val;
            }
            function del(target, key) {
                if (false) {
                    warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
                }
                if (Array.isArray(target) && isValidArrayIndex(key)) {
                    target.splice(key, 1);
                    return;
                }
                var ob = target.__ob__;
                if (target._isVue || ob && ob.vmCount) {
                    "production" !== "production" && warn("Avoid deleting properties on a Vue instance or its root $data " + "- just set it to null.");
                    return;
                }
                if (!hasOwn(target, key)) {
                    return;
                }
                delete target[key];
                if (!ob) {
                    return;
                }
                ob.dep.notify();
            }
            function dependArray(value) {
                for (var e = void 0, i = 0, l = value.length; i < l; i++) {
                    e = value[i];
                    e && e.__ob__ && e.__ob__.dep.depend();
                    if (Array.isArray(e)) {
                        dependArray(e);
                    }
                }
            }
            var strats = config.optionMergeStrategies;
            if (false) {
                strats.el = strats.propsData = function(parent, child, vm, key) {
                    if (!vm) {
                        warn('option "' + key + '" can only be used during instance ' + "creation with the `new` keyword.");
                    }
                    return defaultStrat(parent, child);
                };
            }
            function mergeData(to, from) {
                if (!from) {
                    return to;
                }
                var key, toVal, fromVal;
                var keys = Object.keys(from);
                for (var i = 0; i < keys.length; i++) {
                    key = keys[i];
                    toVal = to[key];
                    fromVal = from[key];
                    if (!hasOwn(to, key)) {
                        set(to, key, fromVal);
                    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
                        mergeData(toVal, fromVal);
                    }
                }
                return to;
            }
            function mergeDataOrFn(parentVal, childVal, vm) {
                if (!vm) {
                    if (!childVal) {
                        return parentVal;
                    }
                    if (!parentVal) {
                        return childVal;
                    }
                    return function mergedDataFn() {
                        return mergeData(typeof childVal === "function" ? childVal.call(this, this) : childVal, typeof parentVal === "function" ? parentVal.call(this, this) : parentVal);
                    };
                } else {
                    return function mergedInstanceDataFn() {
                        var instanceData = typeof childVal === "function" ? childVal.call(vm, vm) : childVal;
                        var defaultData = typeof parentVal === "function" ? parentVal.call(vm, vm) : parentVal;
                        if (instanceData) {
                            return mergeData(instanceData, defaultData);
                        } else {
                            return defaultData;
                        }
                    };
                }
            }
            strats.data = function(parentVal, childVal, vm) {
                if (!vm) {
                    if (childVal && typeof childVal !== "function") {
                        "production" !== "production" && warn('The "data" option should be a function ' + "that returns a per-instance value in component " + "definitions.", vm);
                        return parentVal;
                    }
                    return mergeDataOrFn(parentVal, childVal);
                }
                return mergeDataOrFn(parentVal, childVal, vm);
            };
            function mergeHook(parentVal, childVal) {
                return childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [ childVal ] : parentVal;
            }
            LIFECYCLE_HOOKS.forEach(function(hook) {
                strats[hook] = mergeHook;
            });
            function mergeAssets(parentVal, childVal, vm, key) {
                var res = Object.create(parentVal || null);
                if (childVal) {
                    "production" !== "production" && assertObjectType(key, childVal, vm);
                    return extend(res, childVal);
                } else {
                    return res;
                }
            }
            ASSET_TYPES.forEach(function(type) {
                strats[type + "s"] = mergeAssets;
            });
            strats.watch = function(parentVal, childVal, vm, key) {
                if (parentVal === nativeWatch) {
                    parentVal = undefined;
                }
                if (childVal === nativeWatch) {
                    childVal = undefined;
                }
                if (!childVal) {
                    return Object.create(parentVal || null);
                }
                if (false) {
                    assertObjectType(key, childVal, vm);
                }
                if (!parentVal) {
                    return childVal;
                }
                var ret = {};
                extend(ret, parentVal);
                for (var key$1 in childVal) {
                    var parent = ret[key$1];
                    var child = childVal[key$1];
                    if (parent && !Array.isArray(parent)) {
                        parent = [ parent ];
                    }
                    ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [ child ];
                }
                return ret;
            };
            strats.props = strats.methods = strats.inject = strats.computed = function(parentVal, childVal, vm, key) {
                if (childVal && "production" !== "production") {
                    assertObjectType(key, childVal, vm);
                }
                if (!parentVal) {
                    return childVal;
                }
                var ret = Object.create(null);
                extend(ret, parentVal);
                if (childVal) {
                    extend(ret, childVal);
                }
                return ret;
            };
            strats.provide = mergeDataOrFn;
            var defaultStrat = function(parentVal, childVal) {
                return childVal === undefined ? parentVal : childVal;
            };
            function checkComponents(options) {
                for (var key in options.components) {
                    validateComponentName(key);
                }
            }
            function validateComponentName(name) {
                if (!/^[a-zA-Z][\w-]*$/.test(name)) {
                    warn('Invalid component name: "' + name + '". Component names ' + "can only contain alphanumeric characters and the hyphen, " + "and must start with a letter.");
                }
                if (isBuiltInTag(name) || config.isReservedTag(name)) {
                    warn("Do not use built-in or reserved HTML elements as component " + "id: " + name);
                }
            }
            function normalizeProps(options, vm) {
                var props = options.props;
                if (!props) {
                    return;
                }
                var res = {};
                var i, val, name;
                if (Array.isArray(props)) {
                    i = props.length;
                    while (i--) {
                        val = props[i];
                        if (typeof val === "string") {
                            name = camelize(val);
                            res[name] = {
                                type: null
                            };
                        } else if (false) {
                            warn("props must be strings when using array syntax.");
                        }
                    }
                } else if (isPlainObject(props)) {
                    for (var key in props) {
                        val = props[key];
                        name = camelize(key);
                        res[name] = isPlainObject(val) ? val : {
                            type: val
                        };
                    }
                } else if (false) {
                    warn('Invalid value for option "props": expected an Array or an Object, ' + "but got " + toRawType(props) + ".", vm);
                }
                options.props = res;
            }
            function normalizeInject(options, vm) {
                var inject = options.inject;
                if (!inject) {
                    return;
                }
                var normalized = options.inject = {};
                if (Array.isArray(inject)) {
                    for (var i = 0; i < inject.length; i++) {
                        normalized[inject[i]] = {
                            from: inject[i]
                        };
                    }
                } else if (isPlainObject(inject)) {
                    for (var key in inject) {
                        var val = inject[key];
                        normalized[key] = isPlainObject(val) ? extend({
                            from: key
                        }, val) : {
                            from: val
                        };
                    }
                } else if (false) {
                    warn('Invalid value for option "inject": expected an Array or an Object, ' + "but got " + toRawType(inject) + ".", vm);
                }
            }
            function normalizeDirectives(options) {
                var dirs = options.directives;
                if (dirs) {
                    for (var key in dirs) {
                        var def = dirs[key];
                        if (typeof def === "function") {
                            dirs[key] = {
                                bind: def,
                                update: def
                            };
                        }
                    }
                }
            }
            function assertObjectType(name, value, vm) {
                if (!isPlainObject(value)) {
                    warn('Invalid value for option "' + name + '": expected an Object, ' + "but got " + toRawType(value) + ".", vm);
                }
            }
            function mergeOptions(parent, child, vm) {
                if (false) {
                    checkComponents(child);
                }
                if (typeof child === "function") {
                    child = child.options;
                }
                normalizeProps(child, vm);
                normalizeInject(child, vm);
                normalizeDirectives(child);
                var extendsFrom = child.extends;
                if (extendsFrom) {
                    parent = mergeOptions(parent, extendsFrom, vm);
                }
                if (child.mixins) {
                    for (var i = 0, l = child.mixins.length; i < l; i++) {
                        parent = mergeOptions(parent, child.mixins[i], vm);
                    }
                }
                var options = {};
                var key;
                for (key in parent) {
                    mergeField(key);
                }
                for (key in child) {
                    if (!hasOwn(parent, key)) {
                        mergeField(key);
                    }
                }
                function mergeField(key) {
                    var strat = strats[key] || defaultStrat;
                    options[key] = strat(parent[key], child[key], vm, key);
                }
                return options;
            }
            function resolveAsset(options, type, id, warnMissing) {
                if (typeof id !== "string") {
                    return;
                }
                var assets = options[type];
                if (hasOwn(assets, id)) {
                    return assets[id];
                }
                var camelizedId = camelize(id);
                if (hasOwn(assets, camelizedId)) {
                    return assets[camelizedId];
                }
                var PascalCaseId = capitalize(camelizedId);
                if (hasOwn(assets, PascalCaseId)) {
                    return assets[PascalCaseId];
                }
                var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
                if (false) {
                    warn("Failed to resolve " + type.slice(0, -1) + ": " + id, options);
                }
                return res;
            }
            function validateProp(key, propOptions, propsData, vm) {
                var prop = propOptions[key];
                var absent = !hasOwn(propsData, key);
                var value = propsData[key];
                var booleanIndex = getTypeIndex(Boolean, prop.type);
                if (booleanIndex > -1) {
                    if (absent && !hasOwn(prop, "default")) {
                        value = false;
                    } else if (value === "" || value === hyphenate(key)) {
                        var stringIndex = getTypeIndex(String, prop.type);
                        if (stringIndex < 0 || booleanIndex < stringIndex) {
                            value = true;
                        }
                    }
                }
                if (value === undefined) {
                    value = getPropDefaultValue(vm, prop, key);
                    var prevShouldObserve = shouldObserve;
                    toggleObserving(true);
                    observe(value);
                    toggleObserving(prevShouldObserve);
                }
                if (false) {
                    assertProp(prop, key, value, vm, absent);
                }
                return value;
            }
            function getPropDefaultValue(vm, prop, key) {
                if (!hasOwn(prop, "default")) {
                    return undefined;
                }
                var def = prop.default;
                if (false) {
                    warn('Invalid default value for prop "' + key + '": ' + "Props with type Object/Array must use a factory function " + "to return the default value.", vm);
                }
                if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
                    return vm._props[key];
                }
                return typeof def === "function" && getType(prop.type) !== "Function" ? def.call(vm) : def;
            }
            function assertProp(prop, name, value, vm, absent) {
                if (prop.required && absent) {
                    warn('Missing required prop: "' + name + '"', vm);
                    return;
                }
                if (value == null && !prop.required) {
                    return;
                }
                var type = prop.type;
                var valid = !type || type === true;
                var expectedTypes = [];
                if (type) {
                    if (!Array.isArray(type)) {
                        type = [ type ];
                    }
                    for (var i = 0; i < type.length && !valid; i++) {
                        var assertedType = assertType(value, type[i]);
                        expectedTypes.push(assertedType.expectedType || "");
                        valid = assertedType.valid;
                    }
                }
                if (!valid) {
                    warn('Invalid prop: type check failed for prop "' + name + '".' + " Expected " + expectedTypes.map(capitalize).join(", ") + ", got " + toRawType(value) + ".", vm);
                    return;
                }
                var validator = prop.validator;
                if (validator) {
                    if (!validator(value)) {
                        warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
                    }
                }
            }
            var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
            function assertType(value, type) {
                var valid;
                var expectedType = getType(type);
                if (simpleCheckRE.test(expectedType)) {
                    var t = typeof value;
                    valid = t === expectedType.toLowerCase();
                    if (!valid && t === "object") {
                        valid = value instanceof type;
                    }
                } else if (expectedType === "Object") {
                    valid = isPlainObject(value);
                } else if (expectedType === "Array") {
                    valid = Array.isArray(value);
                } else {
                    valid = value instanceof type;
                }
                return {
                    valid: valid,
                    expectedType: expectedType
                };
            }
            function getType(fn) {
                var match = fn && fn.toString().match(/^\s*function (\w+)/);
                return match ? match[1] : "";
            }
            function isSameType(a, b) {
                return getType(a) === getType(b);
            }
            function getTypeIndex(type, expectedTypes) {
                if (!Array.isArray(expectedTypes)) {
                    return isSameType(expectedTypes, type) ? 0 : -1;
                }
                for (var i = 0, len = expectedTypes.length; i < len; i++) {
                    if (isSameType(expectedTypes[i], type)) {
                        return i;
                    }
                }
                return -1;
            }
            function handleError(err, vm, info) {
                if (vm) {
                    var cur = vm;
                    while (cur = cur.$parent) {
                        var hooks = cur.$options.errorCaptured;
                        if (hooks) {
                            for (var i = 0; i < hooks.length; i++) {
                                try {
                                    var capture = hooks[i].call(cur, err, vm, info) === false;
                                    if (capture) {
                                        return;
                                    }
                                } catch (e) {
                                    globalHandleError(e, cur, "errorCaptured hook");
                                }
                            }
                        }
                    }
                }
                globalHandleError(err, vm, info);
            }
            function globalHandleError(err, vm, info) {
                if (config.errorHandler) {
                    try {
                        return config.errorHandler.call(null, err, vm, info);
                    } catch (e) {
                        logError(e, null, "config.errorHandler");
                    }
                }
                logError(err, vm, info);
            }
            function logError(err, vm, info) {
                if (false) {
                    warn("Error in " + info + ': "' + err.toString() + '"', vm);
                }
                if ((inBrowser || inWeex) && typeof console !== "undefined") {
                    console.error(err);
                } else {
                    throw err;
                }
            }
            var callbacks = [];
            var pending = false;
            function flushCallbacks() {
                pending = false;
                var copies = callbacks.slice(0);
                callbacks.length = 0;
                for (var i = 0; i < copies.length; i++) {
                    copies[i]();
                }
            }
            var microTimerFunc;
            var macroTimerFunc;
            var useMacroTask = false;
            if (typeof setImmediate !== "undefined" && isNative(setImmediate)) {
                macroTimerFunc = function() {
                    setImmediate(flushCallbacks);
                };
            } else if (typeof MessageChannel !== "undefined" && (isNative(MessageChannel) || MessageChannel.toString() === "[object MessageChannelConstructor]")) {
                var channel = new MessageChannel();
                var port = channel.port2;
                channel.port1.onmessage = flushCallbacks;
                macroTimerFunc = function() {
                    port.postMessage(1);
                };
            } else {
                macroTimerFunc = function() {
                    setTimeout(flushCallbacks, 0);
                };
            }
            if (typeof Promise !== "undefined" && isNative(Promise)) {
                var p = Promise.resolve();
                microTimerFunc = function() {
                    p.then(flushCallbacks);
                    if (isIOS) {
                        setTimeout(noop);
                    }
                };
            } else {
                microTimerFunc = macroTimerFunc;
            }
            function withMacroTask(fn) {
                return fn._withTask || (fn._withTask = function() {
                    useMacroTask = true;
                    var res = fn.apply(null, arguments);
                    useMacroTask = false;
                    return res;
                });
            }
            function nextTick(cb, ctx) {
                var _resolve;
                callbacks.push(function() {
                    if (cb) {
                        try {
                            cb.call(ctx);
                        } catch (e) {
                            handleError(e, ctx, "nextTick");
                        }
                    } else if (_resolve) {
                        _resolve(ctx);
                    }
                });
                if (!pending) {
                    pending = true;
                    if (useMacroTask) {
                        macroTimerFunc();
                    } else {
                        microTimerFunc();
                    }
                }
                if (!cb && typeof Promise !== "undefined") {
                    return new Promise(function(resolve) {
                        _resolve = resolve;
                    });
                }
            }
            var mark;
            var measure;
            if (false) {
                var perf = inBrowser && window.performance;
                if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
                    mark = function(tag) {
                        return perf.mark(tag);
                    };
                    measure = function(name, startTag, endTag) {
                        perf.measure(name, startTag, endTag);
                        perf.clearMarks(startTag);
                        perf.clearMarks(endTag);
                        perf.clearMeasures(name);
                    };
                }
            }
            var initProxy;
            if (false) {
                var allowedGlobals = makeMap("Infinity,undefined,NaN,isFinite,isNaN," + "parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent," + "Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl," + "require");
                var warnNonPresent = function(target, key) {
                    warn('Property or method "' + key + '" is not defined on the instance but ' + "referenced during render. Make sure that this property is reactive, " + "either in the data option, or for class-based components, by " + "initializing the property. " + "See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.", target);
                };
                var hasProxy = typeof Proxy !== "undefined" && isNative(Proxy);
                if (hasProxy) {
                    var isBuiltInModifier = makeMap("stop,prevent,self,ctrl,shift,alt,meta,exact");
                    config.keyCodes = new Proxy(config.keyCodes, {
                        set: function set(target, key, value) {
                            if (isBuiltInModifier(key)) {
                                warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
                                return false;
                            } else {
                                target[key] = value;
                                return true;
                            }
                        }
                    });
                }
                var hasHandler = {
                    has: function has(target, key) {
                        var has = key in target;
                        var isAllowed = allowedGlobals(key) || key.charAt(0) === "_";
                        if (!has && !isAllowed) {
                            warnNonPresent(target, key);
                        }
                        return has || !isAllowed;
                    }
                };
                var getHandler = {
                    get: function get(target, key) {
                        if (typeof key === "string" && !(key in target)) {
                            warnNonPresent(target, key);
                        }
                        return target[key];
                    }
                };
                initProxy = function initProxy(vm) {
                    if (hasProxy) {
                        var options = vm.$options;
                        var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
                        vm._renderProxy = new Proxy(vm, handlers);
                    } else {
                        vm._renderProxy = vm;
                    }
                };
            }
            var seenObjects = new _Set();
            function traverse(val) {
                _traverse(val, seenObjects);
                seenObjects.clear();
            }
            function _traverse(val, seen) {
                var i, keys;
                var isA = Array.isArray(val);
                if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
                    return;
                }
                if (val.__ob__) {
                    var depId = val.__ob__.dep.id;
                    if (seen.has(depId)) {
                        return;
                    }
                    seen.add(depId);
                }
                if (isA) {
                    i = val.length;
                    while (i--) {
                        _traverse(val[i], seen);
                    }
                } else {
                    keys = Object.keys(val);
                    i = keys.length;
                    while (i--) {
                        _traverse(val[keys[i]], seen);
                    }
                }
            }
            var normalizeEvent = cached(function(name) {
                var passive = name.charAt(0) === "&";
                name = passive ? name.slice(1) : name;
                var once$$1 = name.charAt(0) === "~";
                name = once$$1 ? name.slice(1) : name;
                var capture = name.charAt(0) === "!";
                name = capture ? name.slice(1) : name;
                return {
                    name: name,
                    once: once$$1,
                    capture: capture,
                    passive: passive
                };
            });
            function createFnInvoker(fns) {
                function invoker() {
                    var arguments$1 = arguments;
                    var fns = invoker.fns;
                    if (Array.isArray(fns)) {
                        var cloned = fns.slice();
                        for (var i = 0; i < cloned.length; i++) {
                            cloned[i].apply(null, arguments$1);
                        }
                    } else {
                        return fns.apply(null, arguments);
                    }
                }
                invoker.fns = fns;
                return invoker;
            }
            function updateListeners(on, oldOn, add, remove$$1, vm) {
                var name, def, cur, old, event;
                for (name in on) {
                    def = cur = on[name];
                    old = oldOn[name];
                    event = normalizeEvent(name);
                    if (isUndef(cur)) {
                        "production" !== "production" && warn('Invalid handler for event "' + event.name + '": got ' + String(cur), vm);
                    } else if (isUndef(old)) {
                        if (isUndef(cur.fns)) {
                            cur = on[name] = createFnInvoker(cur);
                        }
                        add(event.name, cur, event.once, event.capture, event.passive, event.params);
                    } else if (cur !== old) {
                        old.fns = cur;
                        on[name] = old;
                    }
                }
                for (name in oldOn) {
                    if (isUndef(on[name])) {
                        event = normalizeEvent(name);
                        remove$$1(event.name, oldOn[name], event.capture);
                    }
                }
            }
            function mergeVNodeHook(def, hookKey, hook) {
                if (def instanceof VNode) {
                    def = def.data.hook || (def.data.hook = {});
                }
                var invoker;
                var oldHook = def[hookKey];
                function wrappedHook() {
                    hook.apply(this, arguments);
                    remove(invoker.fns, wrappedHook);
                }
                if (isUndef(oldHook)) {
                    invoker = createFnInvoker([ wrappedHook ]);
                } else {
                    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
                        invoker = oldHook;
                        invoker.fns.push(wrappedHook);
                    } else {
                        invoker = createFnInvoker([ oldHook, wrappedHook ]);
                    }
                }
                invoker.merged = true;
                def[hookKey] = invoker;
            }
            function extractPropsFromVNodeData(data, Ctor, tag) {
                var propOptions = Ctor.options.props;
                if (isUndef(propOptions)) {
                    return;
                }
                var res = {};
                var attrs = data.attrs;
                var props = data.props;
                if (isDef(attrs) || isDef(props)) {
                    for (var key in propOptions) {
                        var altKey = hyphenate(key);
                        if (false) {
                            var keyInLowerCase = key.toLowerCase();
                            if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                                tip('Prop "' + keyInLowerCase + '" is passed to component ' + formatComponentName(tag || Ctor) + ", but the declared prop name is" + ' "' + key + '". ' + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + 'templates. You should probably use "' + altKey + '" instead of "' + key + '".');
                            }
                        }
                        checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
                    }
                }
                return res;
            }
            function checkProp(res, hash, key, altKey, preserve) {
                if (isDef(hash)) {
                    if (hasOwn(hash, key)) {
                        res[key] = hash[key];
                        if (!preserve) {
                            delete hash[key];
                        }
                        return true;
                    } else if (hasOwn(hash, altKey)) {
                        res[key] = hash[altKey];
                        if (!preserve) {
                            delete hash[altKey];
                        }
                        return true;
                    }
                }
                return false;
            }
            function simpleNormalizeChildren(children) {
                for (var i = 0; i < children.length; i++) {
                    if (Array.isArray(children[i])) {
                        return Array.prototype.concat.apply([], children);
                    }
                }
                return children;
            }
            function normalizeChildren(children) {
                return isPrimitive(children) ? [ createTextVNode(children) ] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
            }
            function isTextNode(node) {
                return isDef(node) && isDef(node.text) && isFalse(node.isComment);
            }
            function normalizeArrayChildren(children, nestedIndex) {
                var res = [];
                var i, c, lastIndex, last;
                for (i = 0; i < children.length; i++) {
                    c = children[i];
                    if (isUndef(c) || typeof c === "boolean") {
                        continue;
                    }
                    lastIndex = res.length - 1;
                    last = res[lastIndex];
                    if (Array.isArray(c)) {
                        if (c.length > 0) {
                            c = normalizeArrayChildren(c, (nestedIndex || "") + "_" + i);
                            if (isTextNode(c[0]) && isTextNode(last)) {
                                res[lastIndex] = createTextVNode(last.text + c[0].text);
                                c.shift();
                            }
                            res.push.apply(res, c);
                        }
                    } else if (isPrimitive(c)) {
                        if (isTextNode(last)) {
                            res[lastIndex] = createTextVNode(last.text + c);
                        } else if (c !== "") {
                            res.push(createTextVNode(c));
                        }
                    } else {
                        if (isTextNode(c) && isTextNode(last)) {
                            res[lastIndex] = createTextVNode(last.text + c.text);
                        } else {
                            if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
                                c.key = "__vlist" + nestedIndex + "_" + i + "__";
                            }
                            res.push(c);
                        }
                    }
                }
                return res;
            }
            function ensureCtor(comp, base) {
                if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === "Module") {
                    comp = comp.default;
                }
                return isObject(comp) ? base.extend(comp) : comp;
            }
            function createAsyncPlaceholder(factory, data, context, children, tag) {
                var node = createEmptyVNode();
                node.asyncFactory = factory;
                node.asyncMeta = {
                    data: data,
                    context: context,
                    children: children,
                    tag: tag
                };
                return node;
            }
            function resolveAsyncComponent(factory, baseCtor, context) {
                if (isTrue(factory.error) && isDef(factory.errorComp)) {
                    return factory.errorComp;
                }
                if (isDef(factory.resolved)) {
                    return factory.resolved;
                }
                if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
                    return factory.loadingComp;
                }
                if (isDef(factory.contexts)) {
                    factory.contexts.push(context);
                } else {
                    var contexts = factory.contexts = [ context ];
                    var sync = true;
                    var forceRender = function() {
                        for (var i = 0, l = contexts.length; i < l; i++) {
                            contexts[i].$forceUpdate();
                        }
                    };
                    var resolve = once(function(res) {
                        factory.resolved = ensureCtor(res, baseCtor);
                        if (!sync) {
                            forceRender();
                        }
                    });
                    var reject = once(function(reason) {
                        "production" !== "production" && warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ""));
                        if (isDef(factory.errorComp)) {
                            factory.error = true;
                            forceRender();
                        }
                    });
                    var res = factory(resolve, reject);
                    if (isObject(res)) {
                        if (typeof res.then === "function") {
                            if (isUndef(factory.resolved)) {
                                res.then(resolve, reject);
                            }
                        } else if (isDef(res.component) && typeof res.component.then === "function") {
                            res.component.then(resolve, reject);
                            if (isDef(res.error)) {
                                factory.errorComp = ensureCtor(res.error, baseCtor);
                            }
                            if (isDef(res.loading)) {
                                factory.loadingComp = ensureCtor(res.loading, baseCtor);
                                if (res.delay === 0) {
                                    factory.loading = true;
                                } else {
                                    setTimeout(function() {
                                        if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                            factory.loading = true;
                                            forceRender();
                                        }
                                    }, res.delay || 200);
                                }
                            }
                            if (isDef(res.timeout)) {
                                setTimeout(function() {
                                    if (isUndef(factory.resolved)) {
                                        reject(false ? "timeout (" + res.timeout + "ms)" : null);
                                    }
                                }, res.timeout);
                            }
                        }
                    }
                    sync = false;
                    return factory.loading ? factory.loadingComp : factory.resolved;
                }
            }
            function isAsyncPlaceholder(node) {
                return node.isComment && node.asyncFactory;
            }
            function getFirstComponentChild(children) {
                if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                        var c = children[i];
                        if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                            return c;
                        }
                    }
                }
            }
            function initEvents(vm) {
                vm._events = Object.create(null);
                vm._hasHookEvent = false;
                var listeners = vm.$options._parentListeners;
                if (listeners) {
                    updateComponentListeners(vm, listeners);
                }
            }
            var target;
            function add(event, fn, once) {
                if (once) {
                    target.$once(event, fn);
                } else {
                    target.$on(event, fn);
                }
            }
            function remove$1(event, fn) {
                target.$off(event, fn);
            }
            function updateComponentListeners(vm, listeners, oldListeners) {
                target = vm;
                updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
                target = undefined;
            }
            function eventsMixin(Vue) {
                var hookRE = /^hook:/;
                Vue.prototype.$on = function(event, fn) {
                    var this$1 = this;
                    var vm = this;
                    if (Array.isArray(event)) {
                        for (var i = 0, l = event.length; i < l; i++) {
                            this$1.$on(event[i], fn);
                        }
                    } else {
                        (vm._events[event] || (vm._events[event] = [])).push(fn);
                        if (hookRE.test(event)) {
                            vm._hasHookEvent = true;
                        }
                    }
                    return vm;
                };
                Vue.prototype.$once = function(event, fn) {
                    var vm = this;
                    function on() {
                        vm.$off(event, on);
                        fn.apply(vm, arguments);
                    }
                    on.fn = fn;
                    vm.$on(event, on);
                    return vm;
                };
                Vue.prototype.$off = function(event, fn) {
                    var this$1 = this;
                    var vm = this;
                    if (!arguments.length) {
                        vm._events = Object.create(null);
                        return vm;
                    }
                    if (Array.isArray(event)) {
                        for (var i = 0, l = event.length; i < l; i++) {
                            this$1.$off(event[i], fn);
                        }
                        return vm;
                    }
                    var cbs = vm._events[event];
                    if (!cbs) {
                        return vm;
                    }
                    if (!fn) {
                        vm._events[event] = null;
                        return vm;
                    }
                    if (fn) {
                        var cb;
                        var i$1 = cbs.length;
                        while (i$1--) {
                            cb = cbs[i$1];
                            if (cb === fn || cb.fn === fn) {
                                cbs.splice(i$1, 1);
                                break;
                            }
                        }
                    }
                    return vm;
                };
                Vue.prototype.$emit = function(event) {
                    var vm = this;
                    if (false) {
                        var lowerCaseEvent = event.toLowerCase();
                        if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                            tip('Event "' + lowerCaseEvent + '" is emitted in component ' + formatComponentName(vm) + ' but the handler is registered for "' + event + '". ' + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + 'You should probably use "' + hyphenate(event) + '" instead of "' + event + '".');
                        }
                    }
                    var cbs = vm._events[event];
                    if (cbs) {
                        cbs = cbs.length > 1 ? toArray(cbs) : cbs;
                        var args = toArray(arguments, 1);
                        for (var i = 0, l = cbs.length; i < l; i++) {
                            try {
                                cbs[i].apply(vm, args);
                            } catch (e) {
                                handleError(e, vm, 'event handler for "' + event + '"');
                            }
                        }
                    }
                    return vm;
                };
            }
            function resolveSlots(children, context) {
                var slots = {};
                if (!children) {
                    return slots;
                }
                for (var i = 0, l = children.length; i < l; i++) {
                    var child = children[i];
                    var data = child.data;
                    if (data && data.attrs && data.attrs.slot) {
                        delete data.attrs.slot;
                    }
                    if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
                        var name = data.slot;
                        var slot = slots[name] || (slots[name] = []);
                        if (child.tag === "template") {
                            slot.push.apply(slot, child.children || []);
                        } else {
                            slot.push(child);
                        }
                    } else {
                        (slots.default || (slots.default = [])).push(child);
                    }
                }
                for (var name$1 in slots) {
                    if (slots[name$1].every(isWhitespace)) {
                        delete slots[name$1];
                    }
                }
                return slots;
            }
            function isWhitespace(node) {
                return node.isComment && !node.asyncFactory || node.text === " ";
            }
            function resolveScopedSlots(fns, res) {
                res = res || {};
                for (var i = 0; i < fns.length; i++) {
                    if (Array.isArray(fns[i])) {
                        resolveScopedSlots(fns[i], res);
                    } else {
                        res[fns[i].key] = fns[i].fn;
                    }
                }
                return res;
            }
            var activeInstance = null;
            var isUpdatingChildComponent = false;
            function initLifecycle(vm) {
                var options = vm.$options;
                var parent = options.parent;
                if (parent && !options.abstract) {
                    while (parent.$options.abstract && parent.$parent) {
                        parent = parent.$parent;
                    }
                    parent.$children.push(vm);
                }
                vm.$parent = parent;
                vm.$root = parent ? parent.$root : vm;
                vm.$children = [];
                vm.$refs = {};
                vm._watcher = null;
                vm._inactive = null;
                vm._directInactive = false;
                vm._isMounted = false;
                vm._isDestroyed = false;
                vm._isBeingDestroyed = false;
            }
            function lifecycleMixin(Vue) {
                Vue.prototype._update = function(vnode, hydrating) {
                    var vm = this;
                    if (vm._isMounted) {
                        callHook(vm, "beforeUpdate");
                    }
                    var prevEl = vm.$el;
                    var prevVnode = vm._vnode;
                    var prevActiveInstance = activeInstance;
                    activeInstance = vm;
                    vm._vnode = vnode;
                    if (!prevVnode) {
                        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false, vm.$options._parentElm, vm.$options._refElm);
                        vm.$options._parentElm = vm.$options._refElm = null;
                    } else {
                        vm.$el = vm.__patch__(prevVnode, vnode);
                    }
                    activeInstance = prevActiveInstance;
                    if (prevEl) {
                        prevEl.__vue__ = null;
                    }
                    if (vm.$el) {
                        vm.$el.__vue__ = vm;
                    }
                    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
                        vm.$parent.$el = vm.$el;
                    }
                };
                Vue.prototype.$forceUpdate = function() {
                    var vm = this;
                    if (vm._watcher) {
                        vm._watcher.update();
                    }
                };
                Vue.prototype.$destroy = function() {
                    var vm = this;
                    if (vm._isBeingDestroyed) {
                        return;
                    }
                    callHook(vm, "beforeDestroy");
                    vm._isBeingDestroyed = true;
                    var parent = vm.$parent;
                    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
                        remove(parent.$children, vm);
                    }
                    if (vm._watcher) {
                        vm._watcher.teardown();
                    }
                    var i = vm._watchers.length;
                    while (i--) {
                        vm._watchers[i].teardown();
                    }
                    if (vm._data.__ob__) {
                        vm._data.__ob__.vmCount--;
                    }
                    vm._isDestroyed = true;
                    vm.__patch__(vm._vnode, null);
                    callHook(vm, "destroyed");
                    vm.$off();
                    if (vm.$el) {
                        vm.$el.__vue__ = null;
                    }
                    if (vm.$vnode) {
                        vm.$vnode.parent = null;
                    }
                };
            }
            function mountComponent(vm, el, hydrating) {
                vm.$el = el;
                if (!vm.$options.render) {
                    vm.$options.render = createEmptyVNode;
                    if (false) {
                        if (vm.$options.template && vm.$options.template.charAt(0) !== "#" || vm.$options.el || el) {
                            warn("You are using the runtime-only build of Vue where the template " + "compiler is not available. Either pre-compile the templates into " + "render functions, or use the compiler-included build.", vm);
                        } else {
                            warn("Failed to mount component: template or render function not defined.", vm);
                        }
                    }
                }
                callHook(vm, "beforeMount");
                var updateComponent;
                if (false) {
                    updateComponent = function() {
                        var name = vm._name;
                        var id = vm._uid;
                        var startTag = "vue-perf-start:" + id;
                        var endTag = "vue-perf-end:" + id;
                        mark(startTag);
                        var vnode = vm._render();
                        mark(endTag);
                        measure("vue " + name + " render", startTag, endTag);
                        mark(startTag);
                        vm._update(vnode, hydrating);
                        mark(endTag);
                        measure("vue " + name + " patch", startTag, endTag);
                    };
                } else {
                    updateComponent = function() {
                        vm._update(vm._render(), hydrating);
                    };
                }
                new Watcher(vm, updateComponent, noop, null, true);
                hydrating = false;
                if (vm.$vnode == null) {
                    vm._isMounted = true;
                    callHook(vm, "mounted");
                }
                return vm;
            }
            function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
                if (false) {
                    isUpdatingChildComponent = true;
                }
                var hasChildren = !!(renderChildren || vm.$options._renderChildren || parentVnode.data.scopedSlots || vm.$scopedSlots !== emptyObject);
                vm.$options._parentVnode = parentVnode;
                vm.$vnode = parentVnode;
                if (vm._vnode) {
                    vm._vnode.parent = parentVnode;
                }
                vm.$options._renderChildren = renderChildren;
                vm.$attrs = parentVnode.data.attrs || emptyObject;
                vm.$listeners = listeners || emptyObject;
                if (propsData && vm.$options.props) {
                    toggleObserving(false);
                    var props = vm._props;
                    var propKeys = vm.$options._propKeys || [];
                    for (var i = 0; i < propKeys.length; i++) {
                        var key = propKeys[i];
                        var propOptions = vm.$options.props;
                        props[key] = validateProp(key, propOptions, propsData, vm);
                    }
                    toggleObserving(true);
                    vm.$options.propsData = propsData;
                }
                listeners = listeners || emptyObject;
                var oldListeners = vm.$options._parentListeners;
                vm.$options._parentListeners = listeners;
                updateComponentListeners(vm, listeners, oldListeners);
                if (hasChildren) {
                    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
                    vm.$forceUpdate();
                }
                if (false) {
                    isUpdatingChildComponent = false;
                }
            }
            function isInInactiveTree(vm) {
                while (vm && (vm = vm.$parent)) {
                    if (vm._inactive) {
                        return true;
                    }
                }
                return false;
            }
            function activateChildComponent(vm, direct) {
                if (direct) {
                    vm._directInactive = false;
                    if (isInInactiveTree(vm)) {
                        return;
                    }
                } else if (vm._directInactive) {
                    return;
                }
                if (vm._inactive || vm._inactive === null) {
                    vm._inactive = false;
                    for (var i = 0; i < vm.$children.length; i++) {
                        activateChildComponent(vm.$children[i]);
                    }
                    callHook(vm, "activated");
                }
            }
            function deactivateChildComponent(vm, direct) {
                if (direct) {
                    vm._directInactive = true;
                    if (isInInactiveTree(vm)) {
                        return;
                    }
                }
                if (!vm._inactive) {
                    vm._inactive = true;
                    for (var i = 0; i < vm.$children.length; i++) {
                        deactivateChildComponent(vm.$children[i]);
                    }
                    callHook(vm, "deactivated");
                }
            }
            function callHook(vm, hook) {
                pushTarget();
                var handlers = vm.$options[hook];
                if (handlers) {
                    for (var i = 0, j = handlers.length; i < j; i++) {
                        try {
                            handlers[i].call(vm);
                        } catch (e) {
                            handleError(e, vm, hook + " hook");
                        }
                    }
                }
                if (vm._hasHookEvent) {
                    vm.$emit("hook:" + hook);
                }
                popTarget();
            }
            var MAX_UPDATE_COUNT = 100;
            var queue = [];
            var activatedChildren = [];
            var has = {};
            var circular = {};
            var waiting = false;
            var flushing = false;
            var index = 0;
            function resetSchedulerState() {
                index = queue.length = activatedChildren.length = 0;
                has = {};
                if (false) {
                    circular = {};
                }
                waiting = flushing = false;
            }
            function flushSchedulerQueue() {
                flushing = true;
                var watcher, id;
                queue.sort(function(a, b) {
                    return a.id - b.id;
                });
                for (index = 0; index < queue.length; index++) {
                    watcher = queue[index];
                    id = watcher.id;
                    has[id] = null;
                    watcher.run();
                    if (false) {
                        circular[id] = (circular[id] || 0) + 1;
                        if (circular[id] > MAX_UPDATE_COUNT) {
                            warn("You may have an infinite update loop " + (watcher.user ? 'in watcher with expression "' + watcher.expression + '"' : "in a component render function."), watcher.vm);
                            break;
                        }
                    }
                }
                var activatedQueue = activatedChildren.slice();
                var updatedQueue = queue.slice();
                resetSchedulerState();
                callActivatedHooks(activatedQueue);
                callUpdatedHooks(updatedQueue);
                if (devtools && config.devtools) {
                    devtools.emit("flush");
                }
            }
            function callUpdatedHooks(queue) {
                var i = queue.length;
                while (i--) {
                    var watcher = queue[i];
                    var vm = watcher.vm;
                    if (vm._watcher === watcher && vm._isMounted) {
                        callHook(vm, "updated");
                    }
                }
            }
            function queueActivatedComponent(vm) {
                vm._inactive = false;
                activatedChildren.push(vm);
            }
            function callActivatedHooks(queue) {
                for (var i = 0; i < queue.length; i++) {
                    queue[i]._inactive = true;
                    activateChildComponent(queue[i], true);
                }
            }
            function queueWatcher(watcher) {
                var id = watcher.id;
                if (has[id] == null) {
                    has[id] = true;
                    if (!flushing) {
                        queue.push(watcher);
                    } else {
                        var i = queue.length - 1;
                        while (i > index && queue[i].id > watcher.id) {
                            i--;
                        }
                        queue.splice(i + 1, 0, watcher);
                    }
                    if (!waiting) {
                        waiting = true;
                        nextTick(flushSchedulerQueue);
                    }
                }
            }
            var uid$1 = 0;
            var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
                this.vm = vm;
                if (isRenderWatcher) {
                    vm._watcher = this;
                }
                vm._watchers.push(this);
                if (options) {
                    this.deep = !!options.deep;
                    this.user = !!options.user;
                    this.lazy = !!options.lazy;
                    this.sync = !!options.sync;
                } else {
                    this.deep = this.user = this.lazy = this.sync = false;
                }
                this.cb = cb;
                this.id = ++uid$1;
                this.active = true;
                this.dirty = this.lazy;
                this.deps = [];
                this.newDeps = [];
                this.depIds = new _Set();
                this.newDepIds = new _Set();
                this.expression = false ? expOrFn.toString() : "";
                if (typeof expOrFn === "function") {
                    this.getter = expOrFn;
                } else {
                    this.getter = parsePath(expOrFn);
                    if (!this.getter) {
                        this.getter = function() {};
                        "production" !== "production" && warn('Failed watching path: "' + expOrFn + '" ' + "Watcher only accepts simple dot-delimited paths. " + "For full control, use a function instead.", vm);
                    }
                }
                this.value = this.lazy ? undefined : this.get();
            };
            Watcher.prototype.get = function get() {
                pushTarget(this);
                var value;
                var vm = this.vm;
                try {
                    value = this.getter.call(vm, vm);
                } catch (e) {
                    if (this.user) {
                        handleError(e, vm, 'getter for watcher "' + this.expression + '"');
                    } else {
                        throw e;
                    }
                } finally {
                    if (this.deep) {
                        traverse(value);
                    }
                    popTarget();
                    this.cleanupDeps();
                }
                return value;
            };
            Watcher.prototype.addDep = function addDep(dep) {
                var id = dep.id;
                if (!this.newDepIds.has(id)) {
                    this.newDepIds.add(id);
                    this.newDeps.push(dep);
                    if (!this.depIds.has(id)) {
                        dep.addSub(this);
                    }
                }
            };
            Watcher.prototype.cleanupDeps = function cleanupDeps() {
                var this$1 = this;
                var i = this.deps.length;
                while (i--) {
                    var dep = this$1.deps[i];
                    if (!this$1.newDepIds.has(dep.id)) {
                        dep.removeSub(this$1);
                    }
                }
                var tmp = this.depIds;
                this.depIds = this.newDepIds;
                this.newDepIds = tmp;
                this.newDepIds.clear();
                tmp = this.deps;
                this.deps = this.newDeps;
                this.newDeps = tmp;
                this.newDeps.length = 0;
            };
            Watcher.prototype.update = function update() {
                if (this.lazy) {
                    this.dirty = true;
                } else if (this.sync) {
                    this.run();
                } else {
                    queueWatcher(this);
                }
            };
            Watcher.prototype.run = function run() {
                if (this.active) {
                    var value = this.get();
                    if (value !== this.value || isObject(value) || this.deep) {
                        var oldValue = this.value;
                        this.value = value;
                        if (this.user) {
                            try {
                                this.cb.call(this.vm, value, oldValue);
                            } catch (e) {
                                handleError(e, this.vm, 'callback for watcher "' + this.expression + '"');
                            }
                        } else {
                            this.cb.call(this.vm, value, oldValue);
                        }
                    }
                }
            };
            Watcher.prototype.evaluate = function evaluate() {
                this.value = this.get();
                this.dirty = false;
            };
            Watcher.prototype.depend = function depend() {
                var this$1 = this;
                var i = this.deps.length;
                while (i--) {
                    this$1.deps[i].depend();
                }
            };
            Watcher.prototype.teardown = function teardown() {
                var this$1 = this;
                if (this.active) {
                    if (!this.vm._isBeingDestroyed) {
                        remove(this.vm._watchers, this);
                    }
                    var i = this.deps.length;
                    while (i--) {
                        this$1.deps[i].removeSub(this$1);
                    }
                    this.active = false;
                }
            };
            var sharedPropertyDefinition = {
                enumerable: true,
                configurable: true,
                get: noop,
                set: noop
            };
            function proxy(target, sourceKey, key) {
                sharedPropertyDefinition.get = function proxyGetter() {
                    return this[sourceKey][key];
                };
                sharedPropertyDefinition.set = function proxySetter(val) {
                    this[sourceKey][key] = val;
                };
                Object.defineProperty(target, key, sharedPropertyDefinition);
            }
            function initState(vm) {
                vm._watchers = [];
                var opts = vm.$options;
                if (opts.props) {
                    initProps(vm, opts.props);
                }
                if (opts.methods) {
                    initMethods(vm, opts.methods);
                }
                if (opts.data) {
                    initData(vm);
                } else {
                    observe(vm._data = {}, true);
                }
                if (opts.computed) {
                    initComputed(vm, opts.computed);
                }
                if (opts.watch && opts.watch !== nativeWatch) {
                    initWatch(vm, opts.watch);
                }
            }
            function initProps(vm, propsOptions) {
                var propsData = vm.$options.propsData || {};
                var props = vm._props = {};
                var keys = vm.$options._propKeys = [];
                var isRoot = !vm.$parent;
                if (!isRoot) {
                    toggleObserving(false);
                }
                var loop = function(key) {
                    keys.push(key);
                    var value = validateProp(key, propsOptions, propsData, vm);
                    if (false) {
                        var hyphenatedKey = hyphenate(key);
                        if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
                            warn('"' + hyphenatedKey + '" is a reserved attribute and cannot be used as component prop.', vm);
                        }
                        defineReactive(props, key, value, function() {
                            if (vm.$parent && !isUpdatingChildComponent) {
                                warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + 'value. Prop being mutated: "' + key + '"', vm);
                            }
                        });
                    } else {
                        defineReactive(props, key, value);
                    }
                    if (!(key in vm)) {
                        proxy(vm, "_props", key);
                    }
                };
                for (var key in propsOptions) loop(key);
                toggleObserving(true);
            }
            function initData(vm) {
                var data = vm.$options.data;
                data = vm._data = typeof data === "function" ? getData(data, vm) : data || {};
                if (!isPlainObject(data)) {
                    data = {};
                    "production" !== "production" && warn("data functions should return an object:\n" + "https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function", vm);
                }
                var keys = Object.keys(data);
                var props = vm.$options.props;
                var methods = vm.$options.methods;
                var i = keys.length;
                while (i--) {
                    var key = keys[i];
                    if (false) {
                        if (methods && hasOwn(methods, key)) {
                            warn('Method "' + key + '" has already been defined as a data property.', vm);
                        }
                    }
                    if (props && hasOwn(props, key)) {
                        "production" !== "production" && warn('The data property "' + key + '" is already declared as a prop. ' + "Use prop default value instead.", vm);
                    } else if (!isReserved(key)) {
                        proxy(vm, "_data", key);
                    }
                }
                observe(data, true);
            }
            function getData(data, vm) {
                pushTarget();
                try {
                    return data.call(vm, vm);
                } catch (e) {
                    handleError(e, vm, "data()");
                    return {};
                } finally {
                    popTarget();
                }
            }
            var computedWatcherOptions = {
                lazy: true
            };
            function initComputed(vm, computed) {
                var watchers = vm._computedWatchers = Object.create(null);
                var isSSR = isServerRendering();
                for (var key in computed) {
                    var userDef = computed[key];
                    var getter = typeof userDef === "function" ? userDef : userDef.get;
                    if (false) {
                        warn('Getter is missing for computed property "' + key + '".', vm);
                    }
                    if (!isSSR) {
                        watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
                    }
                    if (!(key in vm)) {
                        defineComputed(vm, key, userDef);
                    } else if (false) {
                        if (key in vm.$data) {
                            warn('The computed property "' + key + '" is already defined in data.', vm);
                        } else if (vm.$options.props && key in vm.$options.props) {
                            warn('The computed property "' + key + '" is already defined as a prop.', vm);
                        }
                    }
                }
            }
            function defineComputed(target, key, userDef) {
                var shouldCache = !isServerRendering();
                if (typeof userDef === "function") {
                    sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : userDef;
                    sharedPropertyDefinition.set = noop;
                } else {
                    sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : userDef.get : noop;
                    sharedPropertyDefinition.set = userDef.set ? userDef.set : noop;
                }
                if (false) {
                    sharedPropertyDefinition.set = function() {
                        warn('Computed property "' + key + '" was assigned to but it has no setter.', this);
                    };
                }
                Object.defineProperty(target, key, sharedPropertyDefinition);
            }
            function createComputedGetter(key) {
                return function computedGetter() {
                    var watcher = this._computedWatchers && this._computedWatchers[key];
                    if (watcher) {
                        if (watcher.dirty) {
                            watcher.evaluate();
                        }
                        if (Dep.target) {
                            watcher.depend();
                        }
                        return watcher.value;
                    }
                };
            }
            function initMethods(vm, methods) {
                var props = vm.$options.props;
                for (var key in methods) {
                    if (false) {
                        if (methods[key] == null) {
                            warn('Method "' + key + '" has an undefined value in the component definition. ' + "Did you reference the function correctly?", vm);
                        }
                        if (props && hasOwn(props, key)) {
                            warn('Method "' + key + '" has already been defined as a prop.', vm);
                        }
                        if (key in vm && isReserved(key)) {
                            warn('Method "' + key + '" conflicts with an existing Vue instance method. ' + "Avoid defining component methods that start with _ or $.");
                        }
                    }
                    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
                }
            }
            function initWatch(vm, watch) {
                for (var key in watch) {
                    var handler = watch[key];
                    if (Array.isArray(handler)) {
                        for (var i = 0; i < handler.length; i++) {
                            createWatcher(vm, key, handler[i]);
                        }
                    } else {
                        createWatcher(vm, key, handler);
                    }
                }
            }
            function createWatcher(vm, expOrFn, handler, options) {
                if (isPlainObject(handler)) {
                    options = handler;
                    handler = handler.handler;
                }
                if (typeof handler === "string") {
                    handler = vm[handler];
                }
                return vm.$watch(expOrFn, handler, options);
            }
            function stateMixin(Vue) {
                var dataDef = {};
                dataDef.get = function() {
                    return this._data;
                };
                var propsDef = {};
                propsDef.get = function() {
                    return this._props;
                };
                if (false) {
                    dataDef.set = function(newData) {
                        warn("Avoid replacing instance root $data. " + "Use nested data properties instead.", this);
                    };
                    propsDef.set = function() {
                        warn("$props is readonly.", this);
                    };
                }
                Object.defineProperty(Vue.prototype, "$data", dataDef);
                Object.defineProperty(Vue.prototype, "$props", propsDef);
                Vue.prototype.$set = set;
                Vue.prototype.$delete = del;
                Vue.prototype.$watch = function(expOrFn, cb, options) {
                    var vm = this;
                    if (isPlainObject(cb)) {
                        return createWatcher(vm, expOrFn, cb, options);
                    }
                    options = options || {};
                    options.user = true;
                    var watcher = new Watcher(vm, expOrFn, cb, options);
                    if (options.immediate) {
                        cb.call(vm, watcher.value);
                    }
                    return function unwatchFn() {
                        watcher.teardown();
                    };
                };
            }
            function initProvide(vm) {
                var provide = vm.$options.provide;
                if (provide) {
                    vm._provided = typeof provide === "function" ? provide.call(vm) : provide;
                }
            }
            function initInjections(vm) {
                var result = resolveInject(vm.$options.inject, vm);
                if (result) {
                    toggleObserving(false);
                    Object.keys(result).forEach(function(key) {
                        if (false) {
                            defineReactive(vm, key, result[key], function() {
                                warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + 'injection being mutated: "' + key + '"', vm);
                            });
                        } else {
                            defineReactive(vm, key, result[key]);
                        }
                    });
                    toggleObserving(true);
                }
            }
            function resolveInject(inject, vm) {
                if (inject) {
                    var result = Object.create(null);
                    var keys = hasSymbol ? Reflect.ownKeys(inject).filter(function(key) {
                        return Object.getOwnPropertyDescriptor(inject, key).enumerable;
                    }) : Object.keys(inject);
                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        var provideKey = inject[key].from;
                        var source = vm;
                        while (source) {
                            if (source._provided && hasOwn(source._provided, provideKey)) {
                                result[key] = source._provided[provideKey];
                                break;
                            }
                            source = source.$parent;
                        }
                        if (!source) {
                            if ("default" in inject[key]) {
                                var provideDefault = inject[key].default;
                                result[key] = typeof provideDefault === "function" ? provideDefault.call(vm) : provideDefault;
                            } else if (false) {
                                warn('Injection "' + key + '" not found', vm);
                            }
                        }
                    }
                    return result;
                }
            }
            function renderList(val, render) {
                var ret, i, l, keys, key;
                if (Array.isArray(val) || typeof val === "string") {
                    ret = new Array(val.length);
                    for (i = 0, l = val.length; i < l; i++) {
                        ret[i] = render(val[i], i);
                    }
                } else if (typeof val === "number") {
                    ret = new Array(val);
                    for (i = 0; i < val; i++) {
                        ret[i] = render(i + 1, i);
                    }
                } else if (isObject(val)) {
                    keys = Object.keys(val);
                    ret = new Array(keys.length);
                    for (i = 0, l = keys.length; i < l; i++) {
                        key = keys[i];
                        ret[i] = render(val[key], key, i);
                    }
                }
                if (isDef(ret)) {
                    ret._isVList = true;
                }
                return ret;
            }
            function renderSlot(name, fallback, props, bindObject) {
                var scopedSlotFn = this.$scopedSlots[name];
                var nodes;
                if (scopedSlotFn) {
                    props = props || {};
                    if (bindObject) {
                        if (false) {
                            warn("slot v-bind without argument expects an Object", this);
                        }
                        props = extend(extend({}, bindObject), props);
                    }
                    nodes = scopedSlotFn(props) || fallback;
                } else {
                    var slotNodes = this.$slots[name];
                    if (slotNodes) {
                        if (false) {
                            warn('Duplicate presence of slot "' + name + '" found in the same render tree ' + "- this will likely cause render errors.", this);
                        }
                        slotNodes._rendered = true;
                    }
                    nodes = slotNodes || fallback;
                }
                var target = props && props.slot;
                if (target) {
                    return this.$createElement("template", {
                        slot: target
                    }, nodes);
                } else {
                    return nodes;
                }
            }
            function resolveFilter(id) {
                return resolveAsset(this.$options, "filters", id, true) || identity;
            }
            function isKeyNotMatch(expect, actual) {
                if (Array.isArray(expect)) {
                    return expect.indexOf(actual) === -1;
                } else {
                    return expect !== actual;
                }
            }
            function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
                var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
                if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
                    return isKeyNotMatch(builtInKeyName, eventKeyName);
                } else if (mappedKeyCode) {
                    return isKeyNotMatch(mappedKeyCode, eventKeyCode);
                } else if (eventKeyName) {
                    return hyphenate(eventKeyName) !== key;
                }
            }
            function bindObjectProps(data, tag, value, asProp, isSync) {
                if (value) {
                    if (!isObject(value)) {
                        "production" !== "production" && warn("v-bind without argument expects an Object or Array value", this);
                    } else {
                        if (Array.isArray(value)) {
                            value = toObject(value);
                        }
                        var hash;
                        var loop = function(key) {
                            if (key === "class" || key === "style" || isReservedAttribute(key)) {
                                hash = data;
                            } else {
                                var type = data.attrs && data.attrs.type;
                                hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
                            }
                            if (!(key in hash)) {
                                hash[key] = value[key];
                                if (isSync) {
                                    var on = data.on || (data.on = {});
                                    on["update:" + key] = function($event) {
                                        value[key] = $event;
                                    };
                                }
                            }
                        };
                        for (var key in value) loop(key);
                    }
                }
                return data;
            }
            function renderStatic(index, isInFor) {
                var cached = this._staticTrees || (this._staticTrees = []);
                var tree = cached[index];
                if (tree && !isInFor) {
                    return tree;
                }
                tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this);
                markStatic(tree, "__static__" + index, false);
                return tree;
            }
            function markOnce(tree, index, key) {
                markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
                return tree;
            }
            function markStatic(tree, key, isOnce) {
                if (Array.isArray(tree)) {
                    for (var i = 0; i < tree.length; i++) {
                        if (tree[i] && typeof tree[i] !== "string") {
                            markStaticNode(tree[i], key + "_" + i, isOnce);
                        }
                    }
                } else {
                    markStaticNode(tree, key, isOnce);
                }
            }
            function markStaticNode(node, key, isOnce) {
                node.isStatic = true;
                node.key = key;
                node.isOnce = isOnce;
            }
            function bindObjectListeners(data, value) {
                if (value) {
                    if (!isPlainObject(value)) {
                        "production" !== "production" && warn("v-on without argument expects an Object value", this);
                    } else {
                        var on = data.on = data.on ? extend({}, data.on) : {};
                        for (var key in value) {
                            var existing = on[key];
                            var ours = value[key];
                            on[key] = existing ? [].concat(existing, ours) : ours;
                        }
                    }
                }
                return data;
            }
            function installRenderHelpers(target) {
                target._o = markOnce;
                target._n = toNumber;
                target._s = toString;
                target._l = renderList;
                target._t = renderSlot;
                target._q = looseEqual;
                target._i = looseIndexOf;
                target._m = renderStatic;
                target._f = resolveFilter;
                target._k = checkKeyCodes;
                target._b = bindObjectProps;
                target._v = createTextVNode;
                target._e = createEmptyVNode;
                target._u = resolveScopedSlots;
                target._g = bindObjectListeners;
            }
            function FunctionalRenderContext(data, props, children, parent, Ctor) {
                var options = Ctor.options;
                var contextVm;
                if (hasOwn(parent, "_uid")) {
                    contextVm = Object.create(parent);
                    contextVm._original = parent;
                } else {
                    contextVm = parent;
                    parent = parent._original;
                }
                var isCompiled = isTrue(options._compiled);
                var needNormalization = !isCompiled;
                this.data = data;
                this.props = props;
                this.children = children;
                this.parent = parent;
                this.listeners = data.on || emptyObject;
                this.injections = resolveInject(options.inject, parent);
                this.slots = function() {
                    return resolveSlots(children, parent);
                };
                if (isCompiled) {
                    this.$options = options;
                    this.$slots = this.slots();
                    this.$scopedSlots = data.scopedSlots || emptyObject;
                }
                if (options._scopeId) {
                    this._c = function(a, b, c, d) {
                        var vnode = createElement(contextVm, a, b, c, d, needNormalization);
                        if (vnode && !Array.isArray(vnode)) {
                            vnode.fnScopeId = options._scopeId;
                            vnode.fnContext = parent;
                        }
                        return vnode;
                    };
                } else {
                    this._c = function(a, b, c, d) {
                        return createElement(contextVm, a, b, c, d, needNormalization);
                    };
                }
            }
            installRenderHelpers(FunctionalRenderContext.prototype);
            function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
                var options = Ctor.options;
                var props = {};
                var propOptions = options.props;
                if (isDef(propOptions)) {
                    for (var key in propOptions) {
                        props[key] = validateProp(key, propOptions, propsData || emptyObject);
                    }
                } else {
                    if (isDef(data.attrs)) {
                        mergeProps(props, data.attrs);
                    }
                    if (isDef(data.props)) {
                        mergeProps(props, data.props);
                    }
                }
                var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
                var vnode = options.render.call(null, renderContext._c, renderContext);
                if (vnode instanceof VNode) {
                    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options);
                } else if (Array.isArray(vnode)) {
                    var vnodes = normalizeChildren(vnode) || [];
                    var res = new Array(vnodes.length);
                    for (var i = 0; i < vnodes.length; i++) {
                        res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
                    }
                    return res;
                }
            }
            function cloneAndMarkFunctionalResult(vnode, data, contextVm, options) {
                var clone = cloneVNode(vnode);
                clone.fnContext = contextVm;
                clone.fnOptions = options;
                if (data.slot) {
                    (clone.data || (clone.data = {})).slot = data.slot;
                }
                return clone;
            }
            function mergeProps(to, from) {
                for (var key in from) {
                    to[camelize(key)] = from[key];
                }
            }
            var componentVNodeHooks = {
                init: function init(vnode, hydrating, parentElm, refElm) {
                    if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
                        var mountedNode = vnode;
                        componentVNodeHooks.prepatch(mountedNode, mountedNode);
                    } else {
                        var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance, parentElm, refElm);
                        child.$mount(hydrating ? vnode.elm : undefined, hydrating);
                    }
                },
                prepatch: function prepatch(oldVnode, vnode) {
                    var options = vnode.componentOptions;
                    var child = vnode.componentInstance = oldVnode.componentInstance;
                    updateChildComponent(child, options.propsData, options.listeners, vnode, options.children);
                },
                insert: function insert(vnode) {
                    var context = vnode.context;
                    var componentInstance = vnode.componentInstance;
                    if (!componentInstance._isMounted) {
                        componentInstance._isMounted = true;
                        callHook(componentInstance, "mounted");
                    }
                    if (vnode.data.keepAlive) {
                        if (context._isMounted) {
                            queueActivatedComponent(componentInstance);
                        } else {
                            activateChildComponent(componentInstance, true);
                        }
                    }
                },
                destroy: function destroy(vnode) {
                    var componentInstance = vnode.componentInstance;
                    if (!componentInstance._isDestroyed) {
                        if (!vnode.data.keepAlive) {
                            componentInstance.$destroy();
                        } else {
                            deactivateChildComponent(componentInstance, true);
                        }
                    }
                }
            };
            var hooksToMerge = Object.keys(componentVNodeHooks);
            function createComponent(Ctor, data, context, children, tag) {
                if (isUndef(Ctor)) {
                    return;
                }
                var baseCtor = context.$options._base;
                if (isObject(Ctor)) {
                    Ctor = baseCtor.extend(Ctor);
                }
                if (typeof Ctor !== "function") {
                    if (false) {
                        warn("Invalid Component definition: " + String(Ctor), context);
                    }
                    return;
                }
                var asyncFactory;
                if (isUndef(Ctor.cid)) {
                    asyncFactory = Ctor;
                    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
                    if (Ctor === undefined) {
                        return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
                    }
                }
                data = data || {};
                resolveConstructorOptions(Ctor);
                if (isDef(data.model)) {
                    transformModel(Ctor.options, data);
                }
                var propsData = extractPropsFromVNodeData(data, Ctor, tag);
                if (isTrue(Ctor.options.functional)) {
                    return createFunctionalComponent(Ctor, propsData, data, context, children);
                }
                var listeners = data.on;
                data.on = data.nativeOn;
                if (isTrue(Ctor.options.abstract)) {
                    var slot = data.slot;
                    data = {};
                    if (slot) {
                        data.slot = slot;
                    }
                }
                installComponentHooks(data);
                var name = Ctor.options.name || tag;
                var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ""), data, undefined, undefined, undefined, context, {
                    Ctor: Ctor,
                    propsData: propsData,
                    listeners: listeners,
                    tag: tag,
                    children: children
                }, asyncFactory);
                return vnode;
            }
            function createComponentInstanceForVnode(vnode, parent, parentElm, refElm) {
                var options = {
                    _isComponent: true,
                    parent: parent,
                    _parentVnode: vnode,
                    _parentElm: parentElm || null,
                    _refElm: refElm || null
                };
                var inlineTemplate = vnode.data.inlineTemplate;
                if (isDef(inlineTemplate)) {
                    options.render = inlineTemplate.render;
                    options.staticRenderFns = inlineTemplate.staticRenderFns;
                }
                return new vnode.componentOptions.Ctor(options);
            }
            function installComponentHooks(data) {
                var hooks = data.hook || (data.hook = {});
                for (var i = 0; i < hooksToMerge.length; i++) {
                    var key = hooksToMerge[i];
                    hooks[key] = componentVNodeHooks[key];
                }
            }
            function transformModel(options, data) {
                var prop = options.model && options.model.prop || "value";
                var event = options.model && options.model.event || "input";
                (data.props || (data.props = {}))[prop] = data.model.value;
                var on = data.on || (data.on = {});
                if (isDef(on[event])) {
                    on[event] = [ data.model.callback ].concat(on[event]);
                } else {
                    on[event] = data.model.callback;
                }
            }
            var SIMPLE_NORMALIZE = 1;
            var ALWAYS_NORMALIZE = 2;
            function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
                if (Array.isArray(data) || isPrimitive(data)) {
                    normalizationType = children;
                    children = data;
                    data = undefined;
                }
                if (isTrue(alwaysNormalize)) {
                    normalizationType = ALWAYS_NORMALIZE;
                }
                return _createElement(context, tag, data, children, normalizationType);
            }
            function _createElement(context, tag, data, children, normalizationType) {
                if (isDef(data) && isDef(data.__ob__)) {
                    "production" !== "production" && warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + "Always create fresh vnode data objects in each render!", context);
                    return createEmptyVNode();
                }
                if (isDef(data) && isDef(data.is)) {
                    tag = data.is;
                }
                if (!tag) {
                    return createEmptyVNode();
                }
                if (false) {
                    {
                        warn("Avoid using non-primitive value as key, " + "use string/number value instead.", context);
                    }
                }
                if (Array.isArray(children) && typeof children[0] === "function") {
                    data = data || {};
                    data.scopedSlots = {
                        default: children[0]
                    };
                    children.length = 0;
                }
                if (normalizationType === ALWAYS_NORMALIZE) {
                    children = normalizeChildren(children);
                } else if (normalizationType === SIMPLE_NORMALIZE) {
                    children = simpleNormalizeChildren(children);
                }
                var vnode, ns;
                if (typeof tag === "string") {
                    var Ctor;
                    ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
                    if (config.isReservedTag(tag)) {
                        vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
                    } else if (isDef(Ctor = resolveAsset(context.$options, "components", tag))) {
                        vnode = createComponent(Ctor, data, context, children, tag);
                    } else {
                        vnode = new VNode(tag, data, children, undefined, undefined, context);
                    }
                } else {
                    vnode = createComponent(tag, data, context, children);
                }
                if (Array.isArray(vnode)) {
                    return vnode;
                } else if (isDef(vnode)) {
                    if (isDef(ns)) {
                        applyNS(vnode, ns);
                    }
                    if (isDef(data)) {
                        registerDeepBindings(data);
                    }
                    return vnode;
                } else {
                    return createEmptyVNode();
                }
            }
            function applyNS(vnode, ns, force) {
                vnode.ns = ns;
                if (vnode.tag === "foreignObject") {
                    ns = undefined;
                    force = true;
                }
                if (isDef(vnode.children)) {
                    for (var i = 0, l = vnode.children.length; i < l; i++) {
                        var child = vnode.children[i];
                        if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== "svg")) {
                            applyNS(child, ns, force);
                        }
                    }
                }
            }
            function registerDeepBindings(data) {
                if (isObject(data.style)) {
                    traverse(data.style);
                }
                if (isObject(data.class)) {
                    traverse(data.class);
                }
            }
            function initRender(vm) {
                vm._vnode = null;
                vm._staticTrees = null;
                var options = vm.$options;
                var parentVnode = vm.$vnode = options._parentVnode;
                var renderContext = parentVnode && parentVnode.context;
                vm.$slots = resolveSlots(options._renderChildren, renderContext);
                vm.$scopedSlots = emptyObject;
                vm._c = function(a, b, c, d) {
                    return createElement(vm, a, b, c, d, false);
                };
                vm.$createElement = function(a, b, c, d) {
                    return createElement(vm, a, b, c, d, true);
                };
                var parentData = parentVnode && parentVnode.data;
                if (false) {
                    defineReactive(vm, "$attrs", parentData && parentData.attrs || emptyObject, function() {
                        !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
                    }, true);
                    defineReactive(vm, "$listeners", options._parentListeners || emptyObject, function() {
                        !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
                    }, true);
                } else {
                    defineReactive(vm, "$attrs", parentData && parentData.attrs || emptyObject, null, true);
                    defineReactive(vm, "$listeners", options._parentListeners || emptyObject, null, true);
                }
            }
            function renderMixin(Vue) {
                installRenderHelpers(Vue.prototype);
                Vue.prototype.$nextTick = function(fn) {
                    return nextTick(fn, this);
                };
                Vue.prototype._render = function() {
                    var vm = this;
                    var ref = vm.$options;
                    var render = ref.render;
                    var _parentVnode = ref._parentVnode;
                    if (false) {
                        for (var key in vm.$slots) {
                            vm.$slots[key]._rendered = false;
                        }
                    }
                    if (_parentVnode) {
                        vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
                    }
                    vm.$vnode = _parentVnode;
                    var vnode;
                    try {
                        vnode = render.call(vm._renderProxy, vm.$createElement);
                    } catch (e) {
                        handleError(e, vm, "render");
                        if (false) {
                            if (vm.$options.renderError) {
                                try {
                                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                                } catch (e) {
                                    handleError(e, vm, "renderError");
                                    vnode = vm._vnode;
                                }
                            } else {
                                vnode = vm._vnode;
                            }
                        } else {
                            vnode = vm._vnode;
                        }
                    }
                    if (!(vnode instanceof VNode)) {
                        if (false) {
                            warn("Multiple root nodes returned from render function. Render function " + "should return a single root node.", vm);
                        }
                        vnode = createEmptyVNode();
                    }
                    vnode.parent = _parentVnode;
                    return vnode;
                };
            }
            var uid$3 = 0;
            function initMixin(Vue) {
                Vue.prototype._init = function(options) {
                    var vm = this;
                    vm._uid = uid$3++;
                    var startTag, endTag;
                    if (false) {
                        startTag = "vue-perf-start:" + vm._uid;
                        endTag = "vue-perf-end:" + vm._uid;
                        mark(startTag);
                    }
                    vm._isVue = true;
                    if (options && options._isComponent) {
                        initInternalComponent(vm, options);
                    } else {
                        vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
                    }
                    if (false) {
                        initProxy(vm);
                    } else {
                        vm._renderProxy = vm;
                    }
                    vm._self = vm;
                    initLifecycle(vm);
                    initEvents(vm);
                    initRender(vm);
                    callHook(vm, "beforeCreate");
                    initInjections(vm);
                    initState(vm);
                    initProvide(vm);
                    callHook(vm, "created");
                    if (false) {
                        vm._name = formatComponentName(vm, false);
                        mark(endTag);
                        measure("vue " + vm._name + " init", startTag, endTag);
                    }
                    if (vm.$options.el) {
                        vm.$mount(vm.$options.el);
                    }
                };
            }
            function initInternalComponent(vm, options) {
                var opts = vm.$options = Object.create(vm.constructor.options);
                var parentVnode = options._parentVnode;
                opts.parent = options.parent;
                opts._parentVnode = parentVnode;
                opts._parentElm = options._parentElm;
                opts._refElm = options._refElm;
                var vnodeComponentOptions = parentVnode.componentOptions;
                opts.propsData = vnodeComponentOptions.propsData;
                opts._parentListeners = vnodeComponentOptions.listeners;
                opts._renderChildren = vnodeComponentOptions.children;
                opts._componentTag = vnodeComponentOptions.tag;
                if (options.render) {
                    opts.render = options.render;
                    opts.staticRenderFns = options.staticRenderFns;
                }
            }
            function resolveConstructorOptions(Ctor) {
                var options = Ctor.options;
                if (Ctor.super) {
                    var superOptions = resolveConstructorOptions(Ctor.super);
                    var cachedSuperOptions = Ctor.superOptions;
                    if (superOptions !== cachedSuperOptions) {
                        Ctor.superOptions = superOptions;
                        var modifiedOptions = resolveModifiedOptions(Ctor);
                        if (modifiedOptions) {
                            extend(Ctor.extendOptions, modifiedOptions);
                        }
                        options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
                        if (options.name) {
                            options.components[options.name] = Ctor;
                        }
                    }
                }
                return options;
            }
            function resolveModifiedOptions(Ctor) {
                var modified;
                var latest = Ctor.options;
                var extended = Ctor.extendOptions;
                var sealed = Ctor.sealedOptions;
                for (var key in latest) {
                    if (latest[key] !== sealed[key]) {
                        if (!modified) {
                            modified = {};
                        }
                        modified[key] = dedupe(latest[key], extended[key], sealed[key]);
                    }
                }
                return modified;
            }
            function dedupe(latest, extended, sealed) {
                if (Array.isArray(latest)) {
                    var res = [];
                    sealed = Array.isArray(sealed) ? sealed : [ sealed ];
                    extended = Array.isArray(extended) ? extended : [ extended ];
                    for (var i = 0; i < latest.length; i++) {
                        if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
                            res.push(latest[i]);
                        }
                    }
                    return res;
                } else {
                    return latest;
                }
            }
            function Vue(options) {
                if (false) {
                    warn("Vue is a constructor and should be called with the `new` keyword");
                }
                this._init(options);
            }
            initMixin(Vue);
            stateMixin(Vue);
            eventsMixin(Vue);
            lifecycleMixin(Vue);
            renderMixin(Vue);
            function initUse(Vue) {
                Vue.use = function(plugin) {
                    var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
                    if (installedPlugins.indexOf(plugin) > -1) {
                        return this;
                    }
                    var args = toArray(arguments, 1);
                    args.unshift(this);
                    if (typeof plugin.install === "function") {
                        plugin.install.apply(plugin, args);
                    } else if (typeof plugin === "function") {
                        plugin.apply(null, args);
                    }
                    installedPlugins.push(plugin);
                    return this;
                };
            }
            function initMixin$1(Vue) {
                Vue.mixin = function(mixin) {
                    this.options = mergeOptions(this.options, mixin);
                    return this;
                };
            }
            function initExtend(Vue) {
                Vue.cid = 0;
                var cid = 1;
                Vue.extend = function(extendOptions) {
                    extendOptions = extendOptions || {};
                    var Super = this;
                    var SuperId = Super.cid;
                    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
                    if (cachedCtors[SuperId]) {
                        return cachedCtors[SuperId];
                    }
                    var name = extendOptions.name || Super.options.name;
                    if (false) {
                        validateComponentName(name);
                    }
                    var Sub = function VueComponent(options) {
                        this._init(options);
                    };
                    Sub.prototype = Object.create(Super.prototype);
                    Sub.prototype.constructor = Sub;
                    Sub.cid = cid++;
                    Sub.options = mergeOptions(Super.options, extendOptions);
                    Sub["super"] = Super;
                    if (Sub.options.props) {
                        initProps$1(Sub);
                    }
                    if (Sub.options.computed) {
                        initComputed$1(Sub);
                    }
                    Sub.extend = Super.extend;
                    Sub.mixin = Super.mixin;
                    Sub.use = Super.use;
                    ASSET_TYPES.forEach(function(type) {
                        Sub[type] = Super[type];
                    });
                    if (name) {
                        Sub.options.components[name] = Sub;
                    }
                    Sub.superOptions = Super.options;
                    Sub.extendOptions = extendOptions;
                    Sub.sealedOptions = extend({}, Sub.options);
                    cachedCtors[SuperId] = Sub;
                    return Sub;
                };
            }
            function initProps$1(Comp) {
                var props = Comp.options.props;
                for (var key in props) {
                    proxy(Comp.prototype, "_props", key);
                }
            }
            function initComputed$1(Comp) {
                var computed = Comp.options.computed;
                for (var key in computed) {
                    defineComputed(Comp.prototype, key, computed[key]);
                }
            }
            function initAssetRegisters(Vue) {
                ASSET_TYPES.forEach(function(type) {
                    Vue[type] = function(id, definition) {
                        if (!definition) {
                            return this.options[type + "s"][id];
                        } else {
                            if (false) {
                                validateComponentName(id);
                            }
                            if (type === "component" && isPlainObject(definition)) {
                                definition.name = definition.name || id;
                                definition = this.options._base.extend(definition);
                            }
                            if (type === "directive" && typeof definition === "function") {
                                definition = {
                                    bind: definition,
                                    update: definition
                                };
                            }
                            this.options[type + "s"][id] = definition;
                            return definition;
                        }
                    };
                });
            }
            function getComponentName(opts) {
                return opts && (opts.Ctor.options.name || opts.tag);
            }
            function matches(pattern, name) {
                if (Array.isArray(pattern)) {
                    return pattern.indexOf(name) > -1;
                } else if (typeof pattern === "string") {
                    return pattern.split(",").indexOf(name) > -1;
                } else if (isRegExp(pattern)) {
                    return pattern.test(name);
                }
                return false;
            }
            function pruneCache(keepAliveInstance, filter) {
                var cache = keepAliveInstance.cache;
                var keys = keepAliveInstance.keys;
                var _vnode = keepAliveInstance._vnode;
                for (var key in cache) {
                    var cachedNode = cache[key];
                    if (cachedNode) {
                        var name = getComponentName(cachedNode.componentOptions);
                        if (name && !filter(name)) {
                            pruneCacheEntry(cache, key, keys, _vnode);
                        }
                    }
                }
            }
            function pruneCacheEntry(cache, key, keys, current) {
                var cached$$1 = cache[key];
                if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
                    cached$$1.componentInstance.$destroy();
                }
                cache[key] = null;
                remove(keys, key);
            }
            var patternTypes = [ String, RegExp, Array ];
            var KeepAlive = {
                name: "keep-alive",
                abstract: true,
                props: {
                    include: patternTypes,
                    exclude: patternTypes,
                    max: [ String, Number ]
                },
                created: function created() {
                    this.cache = Object.create(null);
                    this.keys = [];
                },
                destroyed: function destroyed() {
                    var this$1 = this;
                    for (var key in this$1.cache) {
                        pruneCacheEntry(this$1.cache, key, this$1.keys);
                    }
                },
                mounted: function mounted() {
                    var this$1 = this;
                    this.$watch("include", function(val) {
                        pruneCache(this$1, function(name) {
                            return matches(val, name);
                        });
                    });
                    this.$watch("exclude", function(val) {
                        pruneCache(this$1, function(name) {
                            return !matches(val, name);
                        });
                    });
                },
                render: function render() {
                    var slot = this.$slots.default;
                    var vnode = getFirstComponentChild(slot);
                    var componentOptions = vnode && vnode.componentOptions;
                    if (componentOptions) {
                        var name = getComponentName(componentOptions);
                        var ref = this;
                        var include = ref.include;
                        var exclude = ref.exclude;
                        if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                            return vnode;
                        }
                        var ref$1 = this;
                        var cache = ref$1.cache;
                        var keys = ref$1.keys;
                        var key = vnode.key == null ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : "") : vnode.key;
                        if (cache[key]) {
                            vnode.componentInstance = cache[key].componentInstance;
                            remove(keys, key);
                            keys.push(key);
                        } else {
                            cache[key] = vnode;
                            keys.push(key);
                            if (this.max && keys.length > parseInt(this.max)) {
                                pruneCacheEntry(cache, keys[0], keys, this._vnode);
                            }
                        }
                        vnode.data.keepAlive = true;
                    }
                    return vnode || slot && slot[0];
                }
            };
            var builtInComponents = {
                KeepAlive: KeepAlive
            };
            function initGlobalAPI(Vue) {
                var configDef = {};
                configDef.get = function() {
                    return config;
                };
                if (false) {
                    configDef.set = function() {
                        warn("Do not replace the Vue.config object, set individual fields instead.");
                    };
                }
                Object.defineProperty(Vue, "config", configDef);
                Vue.util = {
                    warn: warn,
                    extend: extend,
                    mergeOptions: mergeOptions,
                    defineReactive: defineReactive
                };
                Vue.set = set;
                Vue.delete = del;
                Vue.nextTick = nextTick;
                Vue.options = Object.create(null);
                ASSET_TYPES.forEach(function(type) {
                    Vue.options[type + "s"] = Object.create(null);
                });
                Vue.options._base = Vue;
                extend(Vue.options.components, builtInComponents);
                initUse(Vue);
                initMixin$1(Vue);
                initExtend(Vue);
                initAssetRegisters(Vue);
            }
            initGlobalAPI(Vue);
            Object.defineProperty(Vue.prototype, "$isServer", {
                get: isServerRendering
            });
            Object.defineProperty(Vue.prototype, "$ssrContext", {
                get: function get() {
                    return this.$vnode && this.$vnode.ssrContext;
                }
            });
            Object.defineProperty(Vue, "FunctionalRenderContext", {
                value: FunctionalRenderContext
            });
            Vue.version = "2.5.16";
            var isReservedAttr = makeMap("style,class");
            var acceptValue = makeMap("input,textarea,option,select,progress");
            var mustUseProp = function(tag, type, attr) {
                return attr === "value" && acceptValue(tag) && type !== "button" || attr === "selected" && tag === "option" || attr === "checked" && tag === "input" || attr === "muted" && tag === "video";
            };
            var isEnumeratedAttr = makeMap("contenteditable,draggable,spellcheck");
            var isBooleanAttr = makeMap("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare," + "default,defaultchecked,defaultmuted,defaultselected,defer,disabled," + "enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple," + "muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly," + "required,reversed,scoped,seamless,selected,sortable,translate," + "truespeed,typemustmatch,visible");
            var xlinkNS = "http://www.w3.org/1999/xlink";
            var isXlink = function(name) {
                return name.charAt(5) === ":" && name.slice(0, 5) === "xlink";
            };
            var getXlinkProp = function(name) {
                return isXlink(name) ? name.slice(6, name.length) : "";
            };
            var isFalsyAttrValue = function(val) {
                return val == null || val === false;
            };
            function genClassForVnode(vnode) {
                var data = vnode.data;
                var parentNode = vnode;
                var childNode = vnode;
                while (isDef(childNode.componentInstance)) {
                    childNode = childNode.componentInstance._vnode;
                    if (childNode && childNode.data) {
                        data = mergeClassData(childNode.data, data);
                    }
                }
                while (isDef(parentNode = parentNode.parent)) {
                    if (parentNode && parentNode.data) {
                        data = mergeClassData(data, parentNode.data);
                    }
                }
                return renderClass(data.staticClass, data.class);
            }
            function mergeClassData(child, parent) {
                return {
                    staticClass: concat(child.staticClass, parent.staticClass),
                    class: isDef(child.class) ? [ child.class, parent.class ] : parent.class
                };
            }
            function renderClass(staticClass, dynamicClass) {
                if (isDef(staticClass) || isDef(dynamicClass)) {
                    return concat(staticClass, stringifyClass(dynamicClass));
                }
                return "";
            }
            function concat(a, b) {
                return a ? b ? a + " " + b : a : b || "";
            }
            function stringifyClass(value) {
                if (Array.isArray(value)) {
                    return stringifyArray(value);
                }
                if (isObject(value)) {
                    return stringifyObject(value);
                }
                if (typeof value === "string") {
                    return value;
                }
                return "";
            }
            function stringifyArray(value) {
                var res = "";
                var stringified;
                for (var i = 0, l = value.length; i < l; i++) {
                    if (isDef(stringified = stringifyClass(value[i])) && stringified !== "") {
                        if (res) {
                            res += " ";
                        }
                        res += stringified;
                    }
                }
                return res;
            }
            function stringifyObject(value) {
                var res = "";
                for (var key in value) {
                    if (value[key]) {
                        if (res) {
                            res += " ";
                        }
                        res += key;
                    }
                }
                return res;
            }
            var namespaceMap = {
                svg: "http://www.w3.org/2000/svg",
                math: "http://www.w3.org/1998/Math/MathML"
            };
            var isHTMLTag = makeMap("html,body,base,head,link,meta,style,title," + "address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section," + "div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul," + "a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby," + "s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video," + "embed,object,param,source,canvas,script,noscript,del,ins," + "caption,col,colgroup,table,thead,tbody,td,th,tr," + "button,datalist,fieldset,form,input,label,legend,meter,optgroup,option," + "output,progress,select,textarea," + "details,dialog,menu,menuitem,summary," + "content,element,shadow,template,blockquote,iframe,tfoot");
            var isSVG = makeMap("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face," + "foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern," + "polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", true);
            var isPreTag = function(tag) {
                return tag === "pre";
            };
            var isReservedTag = function(tag) {
                return isHTMLTag(tag) || isSVG(tag);
            };
            function getTagNamespace(tag) {
                if (isSVG(tag)) {
                    return "svg";
                }
                if (tag === "math") {
                    return "math";
                }
            }
            var unknownElementCache = Object.create(null);
            function isUnknownElement(tag) {
                if (!inBrowser) {
                    return true;
                }
                if (isReservedTag(tag)) {
                    return false;
                }
                tag = tag.toLowerCase();
                if (unknownElementCache[tag] != null) {
                    return unknownElementCache[tag];
                }
                var el = document.createElement(tag);
                if (tag.indexOf("-") > -1) {
                    return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
                } else {
                    return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
                }
            }
            var isTextInputType = makeMap("text,number,password,search,email,tel,url");
            function query(el) {
                if (typeof el === "string") {
                    var selected = document.querySelector(el);
                    if (!selected) {
                        "production" !== "production" && warn("Cannot find element: " + el);
                        return document.createElement("div");
                    }
                    return selected;
                } else {
                    return el;
                }
            }
            function createElement$1(tagName, vnode) {
                var elm = document.createElement(tagName);
                if (tagName !== "select") {
                    return elm;
                }
                if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
                    elm.setAttribute("multiple", "multiple");
                }
                return elm;
            }
            function createElementNS(namespace, tagName) {
                return document.createElementNS(namespaceMap[namespace], tagName);
            }
            function createTextNode(text) {
                return document.createTextNode(text);
            }
            function createComment(text) {
                return document.createComment(text);
            }
            function insertBefore(parentNode, newNode, referenceNode) {
                parentNode.insertBefore(newNode, referenceNode);
            }
            function removeChild(node, child) {
                node.removeChild(child);
            }
            function appendChild(node, child) {
                node.appendChild(child);
            }
            function parentNode(node) {
                return node.parentNode;
            }
            function nextSibling(node) {
                return node.nextSibling;
            }
            function tagName(node) {
                return node.tagName;
            }
            function setTextContent(node, text) {
                node.textContent = text;
            }
            function setStyleScope(node, scopeId) {
                node.setAttribute(scopeId, "");
            }
            var nodeOps = Object.freeze({
                createElement: createElement$1,
                createElementNS: createElementNS,
                createTextNode: createTextNode,
                createComment: createComment,
                insertBefore: insertBefore,
                removeChild: removeChild,
                appendChild: appendChild,
                parentNode: parentNode,
                nextSibling: nextSibling,
                tagName: tagName,
                setTextContent: setTextContent,
                setStyleScope: setStyleScope
            });
            var ref = {
                create: function create(_, vnode) {
                    registerRef(vnode);
                },
                update: function update(oldVnode, vnode) {
                    if (oldVnode.data.ref !== vnode.data.ref) {
                        registerRef(oldVnode, true);
                        registerRef(vnode);
                    }
                },
                destroy: function destroy(vnode) {
                    registerRef(vnode, true);
                }
            };
            function registerRef(vnode, isRemoval) {
                var key = vnode.data.ref;
                if (!isDef(key)) {
                    return;
                }
                var vm = vnode.context;
                var ref = vnode.componentInstance || vnode.elm;
                var refs = vm.$refs;
                if (isRemoval) {
                    if (Array.isArray(refs[key])) {
                        remove(refs[key], ref);
                    } else if (refs[key] === ref) {
                        refs[key] = undefined;
                    }
                } else {
                    if (vnode.data.refInFor) {
                        if (!Array.isArray(refs[key])) {
                            refs[key] = [ ref ];
                        } else if (refs[key].indexOf(ref) < 0) {
                            refs[key].push(ref);
                        }
                    } else {
                        refs[key] = ref;
                    }
                }
            }
            var emptyNode = new VNode("", {}, []);
            var hooks = [ "create", "activate", "update", "remove", "destroy" ];
            function sameVnode(a, b) {
                return a.key === b.key && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && a.asyncFactory === b.asyncFactory && isUndef(b.asyncFactory.error));
            }
            function sameInputType(a, b) {
                if (a.tag !== "input") {
                    return true;
                }
                var i;
                var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
                var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
                return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
            }
            function createKeyToOldIdx(children, beginIdx, endIdx) {
                var i, key;
                var map = {};
                for (i = beginIdx; i <= endIdx; ++i) {
                    key = children[i].key;
                    if (isDef(key)) {
                        map[key] = i;
                    }
                }
                return map;
            }
            function createPatchFunction(backend) {
                var i, j;
                var cbs = {};
                var modules = backend.modules;
                var nodeOps = backend.nodeOps;
                for (i = 0; i < hooks.length; ++i) {
                    cbs[hooks[i]] = [];
                    for (j = 0; j < modules.length; ++j) {
                        if (isDef(modules[j][hooks[i]])) {
                            cbs[hooks[i]].push(modules[j][hooks[i]]);
                        }
                    }
                }
                function emptyNodeAt(elm) {
                    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
                }
                function createRmCb(childElm, listeners) {
                    function remove() {
                        if (--remove.listeners === 0) {
                            removeNode(childElm);
                        }
                    }
                    remove.listeners = listeners;
                    return remove;
                }
                function removeNode(el) {
                    var parent = nodeOps.parentNode(el);
                    if (isDef(parent)) {
                        nodeOps.removeChild(parent, el);
                    }
                }
                function isUnknownElement$$1(vnode, inVPre) {
                    return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function(ignore) {
                        return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
                    })) && config.isUnknownElement(vnode.tag);
                }
                var creatingElmInVPre = 0;
                function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
                    if (isDef(vnode.elm) && isDef(ownerArray)) {
                        vnode = ownerArray[index] = cloneVNode(vnode);
                    }
                    vnode.isRootInsert = !nested;
                    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
                        return;
                    }
                    var data = vnode.data;
                    var children = vnode.children;
                    var tag = vnode.tag;
                    if (isDef(tag)) {
                        if (false) {
                            if (data && data.pre) {
                                creatingElmInVPre++;
                            }
                            if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
                                warn("Unknown custom element: <" + tag + "> - did you " + "register the component correctly? For recursive components, " + 'make sure to provide the "name" option.', vnode.context);
                            }
                        }
                        vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
                        setScope(vnode);
                        {
                            createChildren(vnode, children, insertedVnodeQueue);
                            if (isDef(data)) {
                                invokeCreateHooks(vnode, insertedVnodeQueue);
                            }
                            insert(parentElm, vnode.elm, refElm);
                        }
                        if (false) {
                            creatingElmInVPre--;
                        }
                    } else if (isTrue(vnode.isComment)) {
                        vnode.elm = nodeOps.createComment(vnode.text);
                        insert(parentElm, vnode.elm, refElm);
                    } else {
                        vnode.elm = nodeOps.createTextNode(vnode.text);
                        insert(parentElm, vnode.elm, refElm);
                    }
                }
                function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
                    var i = vnode.data;
                    if (isDef(i)) {
                        var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
                        if (isDef(i = i.hook) && isDef(i = i.init)) {
                            i(vnode, false, parentElm, refElm);
                        }
                        if (isDef(vnode.componentInstance)) {
                            initComponent(vnode, insertedVnodeQueue);
                            if (isTrue(isReactivated)) {
                                reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                            }
                            return true;
                        }
                    }
                }
                function initComponent(vnode, insertedVnodeQueue) {
                    if (isDef(vnode.data.pendingInsert)) {
                        insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
                        vnode.data.pendingInsert = null;
                    }
                    vnode.elm = vnode.componentInstance.$el;
                    if (isPatchable(vnode)) {
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        setScope(vnode);
                    } else {
                        registerRef(vnode);
                        insertedVnodeQueue.push(vnode);
                    }
                }
                function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
                    var i;
                    var innerNode = vnode;
                    while (innerNode.componentInstance) {
                        innerNode = innerNode.componentInstance._vnode;
                        if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
                            for (i = 0; i < cbs.activate.length; ++i) {
                                cbs.activate[i](emptyNode, innerNode);
                            }
                            insertedVnodeQueue.push(innerNode);
                            break;
                        }
                    }
                    insert(parentElm, vnode.elm, refElm);
                }
                function insert(parent, elm, ref$$1) {
                    if (isDef(parent)) {
                        if (isDef(ref$$1)) {
                            if (ref$$1.parentNode === parent) {
                                nodeOps.insertBefore(parent, elm, ref$$1);
                            }
                        } else {
                            nodeOps.appendChild(parent, elm);
                        }
                    }
                }
                function createChildren(vnode, children, insertedVnodeQueue) {
                    if (Array.isArray(children)) {
                        if (false) {
                            checkDuplicateKeys(children);
                        }
                        for (var i = 0; i < children.length; ++i) {
                            createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
                        }
                    } else if (isPrimitive(vnode.text)) {
                        nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
                    }
                }
                function isPatchable(vnode) {
                    while (vnode.componentInstance) {
                        vnode = vnode.componentInstance._vnode;
                    }
                    return isDef(vnode.tag);
                }
                function invokeCreateHooks(vnode, insertedVnodeQueue) {
                    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                        cbs.create[i$1](emptyNode, vnode);
                    }
                    i = vnode.data.hook;
                    if (isDef(i)) {
                        if (isDef(i.create)) {
                            i.create(emptyNode, vnode);
                        }
                        if (isDef(i.insert)) {
                            insertedVnodeQueue.push(vnode);
                        }
                    }
                }
                function setScope(vnode) {
                    var i;
                    if (isDef(i = vnode.fnScopeId)) {
                        nodeOps.setStyleScope(vnode.elm, i);
                    } else {
                        var ancestor = vnode;
                        while (ancestor) {
                            if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
                                nodeOps.setStyleScope(vnode.elm, i);
                            }
                            ancestor = ancestor.parent;
                        }
                    }
                    if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
                        nodeOps.setStyleScope(vnode.elm, i);
                    }
                }
                function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
                    for (;startIdx <= endIdx; ++startIdx) {
                        createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
                    }
                }
                function invokeDestroyHook(vnode) {
                    var i, j;
                    var data = vnode.data;
                    if (isDef(data)) {
                        if (isDef(i = data.hook) && isDef(i = i.destroy)) {
                            i(vnode);
                        }
                        for (i = 0; i < cbs.destroy.length; ++i) {
                            cbs.destroy[i](vnode);
                        }
                    }
                    if (isDef(i = vnode.children)) {
                        for (j = 0; j < vnode.children.length; ++j) {
                            invokeDestroyHook(vnode.children[j]);
                        }
                    }
                }
                function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
                    for (;startIdx <= endIdx; ++startIdx) {
                        var ch = vnodes[startIdx];
                        if (isDef(ch)) {
                            if (isDef(ch.tag)) {
                                removeAndInvokeRemoveHook(ch);
                                invokeDestroyHook(ch);
                            } else {
                                removeNode(ch.elm);
                            }
                        }
                    }
                }
                function removeAndInvokeRemoveHook(vnode, rm) {
                    if (isDef(rm) || isDef(vnode.data)) {
                        var i;
                        var listeners = cbs.remove.length + 1;
                        if (isDef(rm)) {
                            rm.listeners += listeners;
                        } else {
                            rm = createRmCb(vnode.elm, listeners);
                        }
                        if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
                            removeAndInvokeRemoveHook(i, rm);
                        }
                        for (i = 0; i < cbs.remove.length; ++i) {
                            cbs.remove[i](vnode, rm);
                        }
                        if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
                            i(vnode, rm);
                        } else {
                            rm();
                        }
                    } else {
                        removeNode(vnode.elm);
                    }
                }
                function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
                    var oldStartIdx = 0;
                    var newStartIdx = 0;
                    var oldEndIdx = oldCh.length - 1;
                    var oldStartVnode = oldCh[0];
                    var oldEndVnode = oldCh[oldEndIdx];
                    var newEndIdx = newCh.length - 1;
                    var newStartVnode = newCh[0];
                    var newEndVnode = newCh[newEndIdx];
                    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
                    var canMove = !removeOnly;
                    if (false) {
                        checkDuplicateKeys(newCh);
                    }
                    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
                        if (isUndef(oldStartVnode)) {
                            oldStartVnode = oldCh[++oldStartIdx];
                        } else if (isUndef(oldEndVnode)) {
                            oldEndVnode = oldCh[--oldEndIdx];
                        } else if (sameVnode(oldStartVnode, newStartVnode)) {
                            patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                            oldStartVnode = oldCh[++oldStartIdx];
                            newStartVnode = newCh[++newStartIdx];
                        } else if (sameVnode(oldEndVnode, newEndVnode)) {
                            patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                            oldEndVnode = oldCh[--oldEndIdx];
                            newEndVnode = newCh[--newEndIdx];
                        } else if (sameVnode(oldStartVnode, newEndVnode)) {
                            patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                            canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                            oldStartVnode = oldCh[++oldStartIdx];
                            newEndVnode = newCh[--newEndIdx];
                        } else if (sameVnode(oldEndVnode, newStartVnode)) {
                            patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                            canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                            oldEndVnode = oldCh[--oldEndIdx];
                            newStartVnode = newCh[++newStartIdx];
                        } else {
                            if (isUndef(oldKeyToIdx)) {
                                oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                            }
                            idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                            if (isUndef(idxInOld)) {
                                createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                            } else {
                                vnodeToMove = oldCh[idxInOld];
                                if (sameVnode(vnodeToMove, newStartVnode)) {
                                    patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
                                    oldCh[idxInOld] = undefined;
                                    canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                                } else {
                                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                                }
                            }
                            newStartVnode = newCh[++newStartIdx];
                        }
                    }
                    if (oldStartIdx > oldEndIdx) {
                        refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
                        addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
                    } else if (newStartIdx > newEndIdx) {
                        removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
                    }
                }
                function checkDuplicateKeys(children) {
                    var seenKeys = {};
                    for (var i = 0; i < children.length; i++) {
                        var vnode = children[i];
                        var key = vnode.key;
                        if (isDef(key)) {
                            if (seenKeys[key]) {
                                warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
                            } else {
                                seenKeys[key] = true;
                            }
                        }
                    }
                }
                function findIdxInOld(node, oldCh, start, end) {
                    for (var i = start; i < end; i++) {
                        var c = oldCh[i];
                        if (isDef(c) && sameVnode(node, c)) {
                            return i;
                        }
                    }
                }
                function patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly) {
                    if (oldVnode === vnode) {
                        return;
                    }
                    var elm = vnode.elm = oldVnode.elm;
                    if (isTrue(oldVnode.isAsyncPlaceholder)) {
                        if (isDef(vnode.asyncFactory.resolved)) {
                            hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
                        } else {
                            vnode.isAsyncPlaceholder = true;
                        }
                        return;
                    }
                    if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
                        vnode.componentInstance = oldVnode.componentInstance;
                        return;
                    }
                    var i;
                    var data = vnode.data;
                    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
                        i(oldVnode, vnode);
                    }
                    var oldCh = oldVnode.children;
                    var ch = vnode.children;
                    if (isDef(data) && isPatchable(vnode)) {
                        for (i = 0; i < cbs.update.length; ++i) {
                            cbs.update[i](oldVnode, vnode);
                        }
                        if (isDef(i = data.hook) && isDef(i = i.update)) {
                            i(oldVnode, vnode);
                        }
                    }
                    if (isUndef(vnode.text)) {
                        if (isDef(oldCh) && isDef(ch)) {
                            if (oldCh !== ch) {
                                updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
                            }
                        } else if (isDef(ch)) {
                            if (isDef(oldVnode.text)) {
                                nodeOps.setTextContent(elm, "");
                            }
                            addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
                        } else if (isDef(oldCh)) {
                            removeVnodes(elm, oldCh, 0, oldCh.length - 1);
                        } else if (isDef(oldVnode.text)) {
                            nodeOps.setTextContent(elm, "");
                        }
                    } else if (oldVnode.text !== vnode.text) {
                        nodeOps.setTextContent(elm, vnode.text);
                    }
                    if (isDef(data)) {
                        if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
                            i(oldVnode, vnode);
                        }
                    }
                }
                function invokeInsertHook(vnode, queue, initial) {
                    if (isTrue(initial) && isDef(vnode.parent)) {
                        vnode.parent.data.pendingInsert = queue;
                    } else {
                        for (var i = 0; i < queue.length; ++i) {
                            queue[i].data.hook.insert(queue[i]);
                        }
                    }
                }
                var hydrationBailed = false;
                var isRenderedModule = makeMap("attrs,class,staticClass,staticStyle,key");
                function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
                    var i;
                    var tag = vnode.tag;
                    var data = vnode.data;
                    var children = vnode.children;
                    inVPre = inVPre || data && data.pre;
                    vnode.elm = elm;
                    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
                        vnode.isAsyncPlaceholder = true;
                        return true;
                    }
                    if (false) {
                        if (!assertNodeMatch(elm, vnode, inVPre)) {
                            return false;
                        }
                    }
                    if (isDef(data)) {
                        if (isDef(i = data.hook) && isDef(i = i.init)) {
                            i(vnode, true);
                        }
                        if (isDef(i = vnode.componentInstance)) {
                            initComponent(vnode, insertedVnodeQueue);
                            return true;
                        }
                    }
                    if (isDef(tag)) {
                        if (isDef(children)) {
                            if (!elm.hasChildNodes()) {
                                createChildren(vnode, children, insertedVnodeQueue);
                            } else {
                                if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
                                    if (i !== elm.innerHTML) {
                                        if (false) {
                                            hydrationBailed = true;
                                            console.warn("Parent: ", elm);
                                            console.warn("server innerHTML: ", i);
                                            console.warn("client innerHTML: ", elm.innerHTML);
                                        }
                                        return false;
                                    }
                                } else {
                                    var childrenMatch = true;
                                    var childNode = elm.firstChild;
                                    for (var i$1 = 0; i$1 < children.length; i$1++) {
                                        if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                                            childrenMatch = false;
                                            break;
                                        }
                                        childNode = childNode.nextSibling;
                                    }
                                    if (!childrenMatch || childNode) {
                                        if (false) {
                                            hydrationBailed = true;
                                            console.warn("Parent: ", elm);
                                            console.warn("Mismatching childNodes vs. VNodes: ", elm.childNodes, children);
                                        }
                                        return false;
                                    }
                                }
                            }
                        }
                        if (isDef(data)) {
                            var fullInvoke = false;
                            for (var key in data) {
                                if (!isRenderedModule(key)) {
                                    fullInvoke = true;
                                    invokeCreateHooks(vnode, insertedVnodeQueue);
                                    break;
                                }
                            }
                            if (!fullInvoke && data["class"]) {
                                traverse(data["class"]);
                            }
                        }
                    } else if (elm.data !== vnode.text) {
                        elm.data = vnode.text;
                    }
                    return true;
                }
                function assertNodeMatch(node, vnode, inVPre) {
                    if (isDef(vnode.tag)) {
                        return vnode.tag.indexOf("vue-component") === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
                    } else {
                        return node.nodeType === (vnode.isComment ? 8 : 3);
                    }
                }
                return function patch(oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
                    if (isUndef(vnode)) {
                        if (isDef(oldVnode)) {
                            invokeDestroyHook(oldVnode);
                        }
                        return;
                    }
                    var isInitialPatch = false;
                    var insertedVnodeQueue = [];
                    if (isUndef(oldVnode)) {
                        isInitialPatch = true;
                        createElm(vnode, insertedVnodeQueue, parentElm, refElm);
                    } else {
                        var isRealElement = isDef(oldVnode.nodeType);
                        if (!isRealElement && sameVnode(oldVnode, vnode)) {
                            patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
                        } else {
                            if (isRealElement) {
                                if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                                    oldVnode.removeAttribute(SSR_ATTR);
                                    hydrating = true;
                                }
                                if (isTrue(hydrating)) {
                                    if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                                        invokeInsertHook(vnode, insertedVnodeQueue, true);
                                        return oldVnode;
                                    } else if (false) {
                                        warn("The client-side rendered virtual DOM tree is not matching " + "server-rendered content. This is likely caused by incorrect " + "HTML markup, for example nesting block-level elements inside " + "<p>, or missing <tbody>. Bailing hydration and performing " + "full client-side render.");
                                    }
                                }
                                oldVnode = emptyNodeAt(oldVnode);
                            }
                            var oldElm = oldVnode.elm;
                            var parentElm$1 = nodeOps.parentNode(oldElm);
                            createElm(vnode, insertedVnodeQueue, oldElm._leaveCb ? null : parentElm$1, nodeOps.nextSibling(oldElm));
                            if (isDef(vnode.parent)) {
                                var ancestor = vnode.parent;
                                var patchable = isPatchable(vnode);
                                while (ancestor) {
                                    for (var i = 0; i < cbs.destroy.length; ++i) {
                                        cbs.destroy[i](ancestor);
                                    }
                                    ancestor.elm = vnode.elm;
                                    if (patchable) {
                                        for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                                            cbs.create[i$1](emptyNode, ancestor);
                                        }
                                        var insert = ancestor.data.hook.insert;
                                        if (insert.merged) {
                                            for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                                                insert.fns[i$2]();
                                            }
                                        }
                                    } else {
                                        registerRef(ancestor);
                                    }
                                    ancestor = ancestor.parent;
                                }
                            }
                            if (isDef(parentElm$1)) {
                                removeVnodes(parentElm$1, [ oldVnode ], 0, 0);
                            } else if (isDef(oldVnode.tag)) {
                                invokeDestroyHook(oldVnode);
                            }
                        }
                    }
                    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
                    return vnode.elm;
                };
            }
            var directives = {
                create: updateDirectives,
                update: updateDirectives,
                destroy: function unbindDirectives(vnode) {
                    updateDirectives(vnode, emptyNode);
                }
            };
            function updateDirectives(oldVnode, vnode) {
                if (oldVnode.data.directives || vnode.data.directives) {
                    _update(oldVnode, vnode);
                }
            }
            function _update(oldVnode, vnode) {
                var isCreate = oldVnode === emptyNode;
                var isDestroy = vnode === emptyNode;
                var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
                var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
                var dirsWithInsert = [];
                var dirsWithPostpatch = [];
                var key, oldDir, dir;
                for (key in newDirs) {
                    oldDir = oldDirs[key];
                    dir = newDirs[key];
                    if (!oldDir) {
                        callHook$1(dir, "bind", vnode, oldVnode);
                        if (dir.def && dir.def.inserted) {
                            dirsWithInsert.push(dir);
                        }
                    } else {
                        dir.oldValue = oldDir.value;
                        callHook$1(dir, "update", vnode, oldVnode);
                        if (dir.def && dir.def.componentUpdated) {
                            dirsWithPostpatch.push(dir);
                        }
                    }
                }
                if (dirsWithInsert.length) {
                    var callInsert = function() {
                        for (var i = 0; i < dirsWithInsert.length; i++) {
                            callHook$1(dirsWithInsert[i], "inserted", vnode, oldVnode);
                        }
                    };
                    if (isCreate) {
                        mergeVNodeHook(vnode, "insert", callInsert);
                    } else {
                        callInsert();
                    }
                }
                if (dirsWithPostpatch.length) {
                    mergeVNodeHook(vnode, "postpatch", function() {
                        for (var i = 0; i < dirsWithPostpatch.length; i++) {
                            callHook$1(dirsWithPostpatch[i], "componentUpdated", vnode, oldVnode);
                        }
                    });
                }
                if (!isCreate) {
                    for (key in oldDirs) {
                        if (!newDirs[key]) {
                            callHook$1(oldDirs[key], "unbind", oldVnode, oldVnode, isDestroy);
                        }
                    }
                }
            }
            var emptyModifiers = Object.create(null);
            function normalizeDirectives$1(dirs, vm) {
                var res = Object.create(null);
                if (!dirs) {
                    return res;
                }
                var i, dir;
                for (i = 0; i < dirs.length; i++) {
                    dir = dirs[i];
                    if (!dir.modifiers) {
                        dir.modifiers = emptyModifiers;
                    }
                    res[getRawDirName(dir)] = dir;
                    dir.def = resolveAsset(vm.$options, "directives", dir.name, true);
                }
                return res;
            }
            function getRawDirName(dir) {
                return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join(".");
            }
            function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
                var fn = dir.def && dir.def[hook];
                if (fn) {
                    try {
                        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
                    } catch (e) {
                        handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
                    }
                }
            }
            var baseModules = [ ref, directives ];
            function updateAttrs(oldVnode, vnode) {
                var opts = vnode.componentOptions;
                if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
                    return;
                }
                if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
                    return;
                }
                var key, cur, old;
                var elm = vnode.elm;
                var oldAttrs = oldVnode.data.attrs || {};
                var attrs = vnode.data.attrs || {};
                if (isDef(attrs.__ob__)) {
                    attrs = vnode.data.attrs = extend({}, attrs);
                }
                for (key in attrs) {
                    cur = attrs[key];
                    old = oldAttrs[key];
                    if (old !== cur) {
                        setAttr(elm, key, cur);
                    }
                }
                if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
                    setAttr(elm, "value", attrs.value);
                }
                for (key in oldAttrs) {
                    if (isUndef(attrs[key])) {
                        if (isXlink(key)) {
                            elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
                        } else if (!isEnumeratedAttr(key)) {
                            elm.removeAttribute(key);
                        }
                    }
                }
            }
            function setAttr(el, key, value) {
                if (el.tagName.indexOf("-") > -1) {
                    baseSetAttr(el, key, value);
                } else if (isBooleanAttr(key)) {
                    if (isFalsyAttrValue(value)) {
                        el.removeAttribute(key);
                    } else {
                        value = key === "allowfullscreen" && el.tagName === "EMBED" ? "true" : key;
                        el.setAttribute(key, value);
                    }
                } else if (isEnumeratedAttr(key)) {
                    el.setAttribute(key, isFalsyAttrValue(value) || value === "false" ? "false" : "true");
                } else if (isXlink(key)) {
                    if (isFalsyAttrValue(value)) {
                        el.removeAttributeNS(xlinkNS, getXlinkProp(key));
                    } else {
                        el.setAttributeNS(xlinkNS, key, value);
                    }
                } else {
                    baseSetAttr(el, key, value);
                }
            }
            function baseSetAttr(el, key, value) {
                if (isFalsyAttrValue(value)) {
                    el.removeAttribute(key);
                } else {
                    if (isIE && !isIE9 && el.tagName === "TEXTAREA" && key === "placeholder" && !el.__ieph) {
                        var blocker = function(e) {
                            e.stopImmediatePropagation();
                            el.removeEventListener("input", blocker);
                        };
                        el.addEventListener("input", blocker);
                        el.__ieph = true;
                    }
                    el.setAttribute(key, value);
                }
            }
            var attrs = {
                create: updateAttrs,
                update: updateAttrs
            };
            function updateClass(oldVnode, vnode) {
                var el = vnode.elm;
                var data = vnode.data;
                var oldData = oldVnode.data;
                if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
                    return;
                }
                var cls = genClassForVnode(vnode);
                var transitionClass = el._transitionClasses;
                if (isDef(transitionClass)) {
                    cls = concat(cls, stringifyClass(transitionClass));
                }
                if (cls !== el._prevClass) {
                    el.setAttribute("class", cls);
                    el._prevClass = cls;
                }
            }
            var klass = {
                create: updateClass,
                update: updateClass
            };
            var validDivisionCharRE = /[\w).+\-_$\]]/;
            function parseFilters(exp) {
                var inSingle = false;
                var inDouble = false;
                var inTemplateString = false;
                var inRegex = false;
                var curly = 0;
                var square = 0;
                var paren = 0;
                var lastFilterIndex = 0;
                var c, prev, i, expression, filters;
                for (i = 0; i < exp.length; i++) {
                    prev = c;
                    c = exp.charCodeAt(i);
                    if (inSingle) {
                        if (c === 39 && prev !== 92) {
                            inSingle = false;
                        }
                    } else if (inDouble) {
                        if (c === 34 && prev !== 92) {
                            inDouble = false;
                        }
                    } else if (inTemplateString) {
                        if (c === 96 && prev !== 92) {
                            inTemplateString = false;
                        }
                    } else if (inRegex) {
                        if (c === 47 && prev !== 92) {
                            inRegex = false;
                        }
                    } else if (c === 124 && exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
                        if (expression === undefined) {
                            lastFilterIndex = i + 1;
                            expression = exp.slice(0, i).trim();
                        } else {
                            pushFilter();
                        }
                    } else {
                        switch (c) {
                          case 34:
                            inDouble = true;
                            break;

                          case 39:
                            inSingle = true;
                            break;

                          case 96:
                            inTemplateString = true;
                            break;

                          case 40:
                            paren++;
                            break;

                          case 41:
                            paren--;
                            break;

                          case 91:
                            square++;
                            break;

                          case 93:
                            square--;
                            break;

                          case 123:
                            curly++;
                            break;

                          case 125:
                            curly--;
                            break;
                        }
                        if (c === 47) {
                            var j = i - 1;
                            var p = void 0;
                            for (;j >= 0; j--) {
                                p = exp.charAt(j);
                                if (p !== " ") {
                                    break;
                                }
                            }
                            if (!p || !validDivisionCharRE.test(p)) {
                                inRegex = true;
                            }
                        }
                    }
                }
                if (expression === undefined) {
                    expression = exp.slice(0, i).trim();
                } else if (lastFilterIndex !== 0) {
                    pushFilter();
                }
                function pushFilter() {
                    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
                    lastFilterIndex = i + 1;
                }
                if (filters) {
                    for (i = 0; i < filters.length; i++) {
                        expression = wrapFilter(expression, filters[i]);
                    }
                }
                return expression;
            }
            function wrapFilter(exp, filter) {
                var i = filter.indexOf("(");
                if (i < 0) {
                    return '_f("' + filter + '")(' + exp + ")";
                } else {
                    var name = filter.slice(0, i);
                    var args = filter.slice(i + 1);
                    return '_f("' + name + '")(' + exp + (args !== ")" ? "," + args : args);
                }
            }
            function baseWarn(msg) {
                console.error("[Vue compiler]: " + msg);
            }
            function pluckModuleFunction(modules, key) {
                return modules ? modules.map(function(m) {
                    return m[key];
                }).filter(function(_) {
                    return _;
                }) : [];
            }
            function addProp(el, name, value) {
                (el.props || (el.props = [])).push({
                    name: name,
                    value: value
                });
                el.plain = false;
            }
            function addAttr(el, name, value) {
                (el.attrs || (el.attrs = [])).push({
                    name: name,
                    value: value
                });
                el.plain = false;
            }
            function addRawAttr(el, name, value) {
                el.attrsMap[name] = value;
                el.attrsList.push({
                    name: name,
                    value: value
                });
            }
            function addDirective(el, name, rawName, value, arg, modifiers) {
                (el.directives || (el.directives = [])).push({
                    name: name,
                    rawName: rawName,
                    value: value,
                    arg: arg,
                    modifiers: modifiers
                });
                el.plain = false;
            }
            function addHandler(el, name, value, modifiers, important, warn) {
                modifiers = modifiers || emptyObject;
                if (false) {
                    warn("passive and prevent can't be used together. " + "Passive handler can't prevent default event.");
                }
                if (modifiers.capture) {
                    delete modifiers.capture;
                    name = "!" + name;
                }
                if (modifiers.once) {
                    delete modifiers.once;
                    name = "~" + name;
                }
                if (modifiers.passive) {
                    delete modifiers.passive;
                    name = "&" + name;
                }
                if (name === "click") {
                    if (modifiers.right) {
                        name = "contextmenu";
                        delete modifiers.right;
                    } else if (modifiers.middle) {
                        name = "mouseup";
                    }
                }
                var events;
                if (modifiers.native) {
                    delete modifiers.native;
                    events = el.nativeEvents || (el.nativeEvents = {});
                } else {
                    events = el.events || (el.events = {});
                }
                var newHandler = {
                    value: value.trim()
                };
                if (modifiers !== emptyObject) {
                    newHandler.modifiers = modifiers;
                }
                var handlers = events[name];
                if (Array.isArray(handlers)) {
                    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
                } else if (handlers) {
                    events[name] = important ? [ newHandler, handlers ] : [ handlers, newHandler ];
                } else {
                    events[name] = newHandler;
                }
                el.plain = false;
            }
            function getBindingAttr(el, name, getStatic) {
                var dynamicValue = getAndRemoveAttr(el, ":" + name) || getAndRemoveAttr(el, "v-bind:" + name);
                if (dynamicValue != null) {
                    return parseFilters(dynamicValue);
                } else if (getStatic !== false) {
                    var staticValue = getAndRemoveAttr(el, name);
                    if (staticValue != null) {
                        return JSON.stringify(staticValue);
                    }
                }
            }
            function getAndRemoveAttr(el, name, removeFromMap) {
                var val;
                if ((val = el.attrsMap[name]) != null) {
                    var list = el.attrsList;
                    for (var i = 0, l = list.length; i < l; i++) {
                        if (list[i].name === name) {
                            list.splice(i, 1);
                            break;
                        }
                    }
                }
                if (removeFromMap) {
                    delete el.attrsMap[name];
                }
                return val;
            }
            function genComponentModel(el, value, modifiers) {
                var ref = modifiers || {};
                var number = ref.number;
                var trim = ref.trim;
                var baseValueExpression = "$$v";
                var valueExpression = baseValueExpression;
                if (trim) {
                    valueExpression = "(typeof " + baseValueExpression + " === 'string'" + "? " + baseValueExpression + ".trim()" + ": " + baseValueExpression + ")";
                }
                if (number) {
                    valueExpression = "_n(" + valueExpression + ")";
                }
                var assignment = genAssignmentCode(value, valueExpression);
                el.model = {
                    value: "(" + value + ")",
                    expression: '"' + value + '"',
                    callback: "function (" + baseValueExpression + ") {" + assignment + "}"
                };
            }
            function genAssignmentCode(value, assignment) {
                var res = parseModel(value);
                if (res.key === null) {
                    return value + "=" + assignment;
                } else {
                    return "$set(" + res.exp + ", " + res.key + ", " + assignment + ")";
                }
            }
            var len;
            var str;
            var chr;
            var index$1;
            var expressionPos;
            var expressionEndPos;
            function parseModel(val) {
                val = val.trim();
                len = val.length;
                if (val.indexOf("[") < 0 || val.lastIndexOf("]") < len - 1) {
                    index$1 = val.lastIndexOf(".");
                    if (index$1 > -1) {
                        return {
                            exp: val.slice(0, index$1),
                            key: '"' + val.slice(index$1 + 1) + '"'
                        };
                    } else {
                        return {
                            exp: val,
                            key: null
                        };
                    }
                }
                str = val;
                index$1 = expressionPos = expressionEndPos = 0;
                while (!eof()) {
                    chr = next();
                    if (isStringStart(chr)) {
                        parseString(chr);
                    } else if (chr === 91) {
                        parseBracket(chr);
                    }
                }
                return {
                    exp: val.slice(0, expressionPos),
                    key: val.slice(expressionPos + 1, expressionEndPos)
                };
            }
            function next() {
                return str.charCodeAt(++index$1);
            }
            function eof() {
                return index$1 >= len;
            }
            function isStringStart(chr) {
                return chr === 34 || chr === 39;
            }
            function parseBracket(chr) {
                var inBracket = 1;
                expressionPos = index$1;
                while (!eof()) {
                    chr = next();
                    if (isStringStart(chr)) {
                        parseString(chr);
                        continue;
                    }
                    if (chr === 91) {
                        inBracket++;
                    }
                    if (chr === 93) {
                        inBracket--;
                    }
                    if (inBracket === 0) {
                        expressionEndPos = index$1;
                        break;
                    }
                }
            }
            function parseString(chr) {
                var stringQuote = chr;
                while (!eof()) {
                    chr = next();
                    if (chr === stringQuote) {
                        break;
                    }
                }
            }
            var warn$1;
            var RANGE_TOKEN = "__r";
            var CHECKBOX_RADIO_TOKEN = "__c";
            function model(el, dir, _warn) {
                warn$1 = _warn;
                var value = dir.value;
                var modifiers = dir.modifiers;
                var tag = el.tag;
                var type = el.attrsMap.type;
                if (false) {
                    if (tag === "input" && type === "file") {
                        warn$1("<" + el.tag + ' v-model="' + value + '" type="file">:\n' + "File inputs are read only. Use a v-on:change listener instead.");
                    }
                }
                if (el.component) {
                    genComponentModel(el, value, modifiers);
                    return false;
                } else if (tag === "select") {
                    genSelect(el, value, modifiers);
                } else if (tag === "input" && type === "checkbox") {
                    genCheckboxModel(el, value, modifiers);
                } else if (tag === "input" && type === "radio") {
                    genRadioModel(el, value, modifiers);
                } else if (tag === "input" || tag === "textarea") {
                    genDefaultModel(el, value, modifiers);
                } else if (!config.isReservedTag(tag)) {
                    genComponentModel(el, value, modifiers);
                    return false;
                } else if (false) {
                    warn$1("<" + el.tag + ' v-model="' + value + '">: ' + "v-model is not supported on this element type. " + "If you are working with contenteditable, it's recommended to " + "wrap a library dedicated for that purpose inside a custom component.");
                }
                return true;
            }
            function genCheckboxModel(el, value, modifiers) {
                var number = modifiers && modifiers.number;
                var valueBinding = getBindingAttr(el, "value") || "null";
                var trueValueBinding = getBindingAttr(el, "true-value") || "true";
                var falseValueBinding = getBindingAttr(el, "false-value") || "false";
                addProp(el, "checked", "Array.isArray(" + value + ")" + "?_i(" + value + "," + valueBinding + ")>-1" + (trueValueBinding === "true" ? ":(" + value + ")" : ":_q(" + value + "," + trueValueBinding + ")"));
                addHandler(el, "change", "var $$a=" + value + "," + "$$el=$event.target," + "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" + "if(Array.isArray($$a)){" + "var $$v=" + (number ? "_n(" + valueBinding + ")" : valueBinding) + "," + "$$i=_i($$a,$$v);" + "if($$el.checked){$$i<0&&(" + genAssignmentCode(value, "$$a.concat([$$v])") + ")}" + "else{$$i>-1&&(" + genAssignmentCode(value, "$$a.slice(0,$$i).concat($$a.slice($$i+1))") + ")}" + "}else{" + genAssignmentCode(value, "$$c") + "}", null, true);
            }
            function genRadioModel(el, value, modifiers) {
                var number = modifiers && modifiers.number;
                var valueBinding = getBindingAttr(el, "value") || "null";
                valueBinding = number ? "_n(" + valueBinding + ")" : valueBinding;
                addProp(el, "checked", "_q(" + value + "," + valueBinding + ")");
                addHandler(el, "change", genAssignmentCode(value, valueBinding), null, true);
            }
            function genSelect(el, value, modifiers) {
                var number = modifiers && modifiers.number;
                var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + '.map(function(o){var val = "_value" in o ? o._value : o.value;' + "return " + (number ? "_n(val)" : "val") + "})";
                var assignment = "$event.target.multiple ? $$selectedVal : $$selectedVal[0]";
                var code = "var $$selectedVal = " + selectedVal + ";";
                code = code + " " + genAssignmentCode(value, assignment);
                addHandler(el, "change", code, null, true);
            }
            function genDefaultModel(el, value, modifiers) {
                var type = el.attrsMap.type;
                if (false) {
                    var value$1 = el.attrsMap["v-bind:value"] || el.attrsMap[":value"];
                    var typeBinding = el.attrsMap["v-bind:type"] || el.attrsMap[":type"];
                    if (value$1 && !typeBinding) {
                        var binding = el.attrsMap["v-bind:value"] ? "v-bind:value" : ":value";
                        warn$1(binding + '="' + value$1 + '" conflicts with v-model on the same element ' + "because the latter already expands to a value binding internally");
                    }
                }
                var ref = modifiers || {};
                var lazy = ref.lazy;
                var number = ref.number;
                var trim = ref.trim;
                var needCompositionGuard = !lazy && type !== "range";
                var event = lazy ? "change" : type === "range" ? RANGE_TOKEN : "input";
                var valueExpression = "$event.target.value";
                if (trim) {
                    valueExpression = "$event.target.value.trim()";
                }
                if (number) {
                    valueExpression = "_n(" + valueExpression + ")";
                }
                var code = genAssignmentCode(value, valueExpression);
                if (needCompositionGuard) {
                    code = "if($event.target.composing)return;" + code;
                }
                addProp(el, "value", "(" + value + ")");
                addHandler(el, event, code, null, true);
                if (trim || number) {
                    addHandler(el, "blur", "$forceUpdate()");
                }
            }
            function normalizeEvents(on) {
                if (isDef(on[RANGE_TOKEN])) {
                    var event = isIE ? "change" : "input";
                    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
                    delete on[RANGE_TOKEN];
                }
                if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
                    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
                    delete on[CHECKBOX_RADIO_TOKEN];
                }
            }
            var target$1;
            function createOnceHandler(handler, event, capture) {
                var _target = target$1;
                return function onceHandler() {
                    var res = handler.apply(null, arguments);
                    if (res !== null) {
                        remove$2(event, onceHandler, capture, _target);
                    }
                };
            }
            function add$1(event, handler, once$$1, capture, passive) {
                handler = withMacroTask(handler);
                if (once$$1) {
                    handler = createOnceHandler(handler, event, capture);
                }
                target$1.addEventListener(event, handler, supportsPassive ? {
                    capture: capture,
                    passive: passive
                } : capture);
            }
            function remove$2(event, handler, capture, _target) {
                (_target || target$1).removeEventListener(event, handler._withTask || handler, capture);
            }
            function updateDOMListeners(oldVnode, vnode) {
                if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
                    return;
                }
                var on = vnode.data.on || {};
                var oldOn = oldVnode.data.on || {};
                target$1 = vnode.elm;
                normalizeEvents(on);
                updateListeners(on, oldOn, add$1, remove$2, vnode.context);
                target$1 = undefined;
            }
            var events = {
                create: updateDOMListeners,
                update: updateDOMListeners
            };
            function updateDOMProps(oldVnode, vnode) {
                if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
                    return;
                }
                var key, cur;
                var elm = vnode.elm;
                var oldProps = oldVnode.data.domProps || {};
                var props = vnode.data.domProps || {};
                if (isDef(props.__ob__)) {
                    props = vnode.data.domProps = extend({}, props);
                }
                for (key in oldProps) {
                    if (isUndef(props[key])) {
                        elm[key] = "";
                    }
                }
                for (key in props) {
                    cur = props[key];
                    if (key === "textContent" || key === "innerHTML") {
                        if (vnode.children) {
                            vnode.children.length = 0;
                        }
                        if (cur === oldProps[key]) {
                            continue;
                        }
                        if (elm.childNodes.length === 1) {
                            elm.removeChild(elm.childNodes[0]);
                        }
                    }
                    if (key === "value") {
                        elm._value = cur;
                        var strCur = isUndef(cur) ? "" : String(cur);
                        if (shouldUpdateValue(elm, strCur)) {
                            elm.value = strCur;
                        }
                    } else {
                        elm[key] = cur;
                    }
                }
            }
            function shouldUpdateValue(elm, checkVal) {
                return !elm.composing && (elm.tagName === "OPTION" || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
            }
            function isNotInFocusAndDirty(elm, checkVal) {
                var notInFocus = true;
                try {
                    notInFocus = document.activeElement !== elm;
                } catch (e) {}
                return notInFocus && elm.value !== checkVal;
            }
            function isDirtyWithModifiers(elm, newVal) {
                var value = elm.value;
                var modifiers = elm._vModifiers;
                if (isDef(modifiers)) {
                    if (modifiers.lazy) {
                        return false;
                    }
                    if (modifiers.number) {
                        return toNumber(value) !== toNumber(newVal);
                    }
                    if (modifiers.trim) {
                        return value.trim() !== newVal.trim();
                    }
                }
                return value !== newVal;
            }
            var domProps = {
                create: updateDOMProps,
                update: updateDOMProps
            };
            var parseStyleText = cached(function(cssText) {
                var res = {};
                var listDelimiter = /;(?![^(]*\))/g;
                var propertyDelimiter = /:(.+)/;
                cssText.split(listDelimiter).forEach(function(item) {
                    if (item) {
                        var tmp = item.split(propertyDelimiter);
                        tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
                    }
                });
                return res;
            });
            function normalizeStyleData(data) {
                var style = normalizeStyleBinding(data.style);
                return data.staticStyle ? extend(data.staticStyle, style) : style;
            }
            function normalizeStyleBinding(bindingStyle) {
                if (Array.isArray(bindingStyle)) {
                    return toObject(bindingStyle);
                }
                if (typeof bindingStyle === "string") {
                    return parseStyleText(bindingStyle);
                }
                return bindingStyle;
            }
            function getStyle(vnode, checkChild) {
                var res = {};
                var styleData;
                if (checkChild) {
                    var childNode = vnode;
                    while (childNode.componentInstance) {
                        childNode = childNode.componentInstance._vnode;
                        if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
                            extend(res, styleData);
                        }
                    }
                }
                if (styleData = normalizeStyleData(vnode.data)) {
                    extend(res, styleData);
                }
                var parentNode = vnode;
                while (parentNode = parentNode.parent) {
                    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
                        extend(res, styleData);
                    }
                }
                return res;
            }
            var cssVarRE = /^--/;
            var importantRE = /\s*!important$/;
            var setProp = function(el, name, val) {
                if (cssVarRE.test(name)) {
                    el.style.setProperty(name, val);
                } else if (importantRE.test(val)) {
                    el.style.setProperty(name, val.replace(importantRE, ""), "important");
                } else {
                    var normalizedName = normalize(name);
                    if (Array.isArray(val)) {
                        for (var i = 0, len = val.length; i < len; i++) {
                            el.style[normalizedName] = val[i];
                        }
                    } else {
                        el.style[normalizedName] = val;
                    }
                }
            };
            var vendorNames = [ "Webkit", "Moz", "ms" ];
            var emptyStyle;
            var normalize = cached(function(prop) {
                emptyStyle = emptyStyle || document.createElement("div").style;
                prop = camelize(prop);
                if (prop !== "filter" && prop in emptyStyle) {
                    return prop;
                }
                var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
                for (var i = 0; i < vendorNames.length; i++) {
                    var name = vendorNames[i] + capName;
                    if (name in emptyStyle) {
                        return name;
                    }
                }
            });
            function updateStyle(oldVnode, vnode) {
                var data = vnode.data;
                var oldData = oldVnode.data;
                if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
                    return;
                }
                var cur, name;
                var el = vnode.elm;
                var oldStaticStyle = oldData.staticStyle;
                var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
                var oldStyle = oldStaticStyle || oldStyleBinding;
                var style = normalizeStyleBinding(vnode.data.style) || {};
                vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
                var newStyle = getStyle(vnode, true);
                for (name in oldStyle) {
                    if (isUndef(newStyle[name])) {
                        setProp(el, name, "");
                    }
                }
                for (name in newStyle) {
                    cur = newStyle[name];
                    if (cur !== oldStyle[name]) {
                        setProp(el, name, cur == null ? "" : cur);
                    }
                }
            }
            var style = {
                create: updateStyle,
                update: updateStyle
            };
            function addClass(el, cls) {
                if (!cls || !(cls = cls.trim())) {
                    return;
                }
                if (el.classList) {
                    if (cls.indexOf(" ") > -1) {
                        cls.split(/\s+/).forEach(function(c) {
                            return el.classList.add(c);
                        });
                    } else {
                        el.classList.add(cls);
                    }
                } else {
                    var cur = " " + (el.getAttribute("class") || "") + " ";
                    if (cur.indexOf(" " + cls + " ") < 0) {
                        el.setAttribute("class", (cur + cls).trim());
                    }
                }
            }
            function removeClass(el, cls) {
                if (!cls || !(cls = cls.trim())) {
                    return;
                }
                if (el.classList) {
                    if (cls.indexOf(" ") > -1) {
                        cls.split(/\s+/).forEach(function(c) {
                            return el.classList.remove(c);
                        });
                    } else {
                        el.classList.remove(cls);
                    }
                    if (!el.classList.length) {
                        el.removeAttribute("class");
                    }
                } else {
                    var cur = " " + (el.getAttribute("class") || "") + " ";
                    var tar = " " + cls + " ";
                    while (cur.indexOf(tar) >= 0) {
                        cur = cur.replace(tar, " ");
                    }
                    cur = cur.trim();
                    if (cur) {
                        el.setAttribute("class", cur);
                    } else {
                        el.removeAttribute("class");
                    }
                }
            }
            function resolveTransition(def) {
                if (!def) {
                    return;
                }
                if (typeof def === "object") {
                    var res = {};
                    if (def.css !== false) {
                        extend(res, autoCssTransition(def.name || "v"));
                    }
                    extend(res, def);
                    return res;
                } else if (typeof def === "string") {
                    return autoCssTransition(def);
                }
            }
            var autoCssTransition = cached(function(name) {
                return {
                    enterClass: name + "-enter",
                    enterToClass: name + "-enter-to",
                    enterActiveClass: name + "-enter-active",
                    leaveClass: name + "-leave",
                    leaveToClass: name + "-leave-to",
                    leaveActiveClass: name + "-leave-active"
                };
            });
            var hasTransition = inBrowser && !isIE9;
            var TRANSITION = "transition";
            var ANIMATION = "animation";
            var transitionProp = "transition";
            var transitionEndEvent = "transitionend";
            var animationProp = "animation";
            var animationEndEvent = "animationend";
            if (hasTransition) {
                if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
                    transitionProp = "WebkitTransition";
                    transitionEndEvent = "webkitTransitionEnd";
                }
                if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
                    animationProp = "WebkitAnimation";
                    animationEndEvent = "webkitAnimationEnd";
                }
            }
            var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : function(fn) {
                return fn();
            };
            function nextFrame(fn) {
                raf(function() {
                    raf(fn);
                });
            }
            function addTransitionClass(el, cls) {
                var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
                if (transitionClasses.indexOf(cls) < 0) {
                    transitionClasses.push(cls);
                    addClass(el, cls);
                }
            }
            function removeTransitionClass(el, cls) {
                if (el._transitionClasses) {
                    remove(el._transitionClasses, cls);
                }
                removeClass(el, cls);
            }
            function whenTransitionEnds(el, expectedType, cb) {
                var ref = getTransitionInfo(el, expectedType);
                var type = ref.type;
                var timeout = ref.timeout;
                var propCount = ref.propCount;
                if (!type) {
                    return cb();
                }
                var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
                var ended = 0;
                var end = function() {
                    el.removeEventListener(event, onEnd);
                    cb();
                };
                var onEnd = function(e) {
                    if (e.target === el) {
                        if (++ended >= propCount) {
                            end();
                        }
                    }
                };
                setTimeout(function() {
                    if (ended < propCount) {
                        end();
                    }
                }, timeout + 1);
                el.addEventListener(event, onEnd);
            }
            var transformRE = /\b(transform|all)(,|$)/;
            function getTransitionInfo(el, expectedType) {
                var styles = window.getComputedStyle(el);
                var transitionDelays = styles[transitionProp + "Delay"].split(", ");
                var transitionDurations = styles[transitionProp + "Duration"].split(", ");
                var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
                var animationDelays = styles[animationProp + "Delay"].split(", ");
                var animationDurations = styles[animationProp + "Duration"].split(", ");
                var animationTimeout = getTimeout(animationDelays, animationDurations);
                var type;
                var timeout = 0;
                var propCount = 0;
                if (expectedType === TRANSITION) {
                    if (transitionTimeout > 0) {
                        type = TRANSITION;
                        timeout = transitionTimeout;
                        propCount = transitionDurations.length;
                    }
                } else if (expectedType === ANIMATION) {
                    if (animationTimeout > 0) {
                        type = ANIMATION;
                        timeout = animationTimeout;
                        propCount = animationDurations.length;
                    }
                } else {
                    timeout = Math.max(transitionTimeout, animationTimeout);
                    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
                    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
                }
                var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + "Property"]);
                return {
                    type: type,
                    timeout: timeout,
                    propCount: propCount,
                    hasTransform: hasTransform
                };
            }
            function getTimeout(delays, durations) {
                while (delays.length < durations.length) {
                    delays = delays.concat(delays);
                }
                return Math.max.apply(null, durations.map(function(d, i) {
                    return toMs(d) + toMs(delays[i]);
                }));
            }
            function toMs(s) {
                return Number(s.slice(0, -1)) * 1e3;
            }
            function enter(vnode, toggleDisplay) {
                var el = vnode.elm;
                if (isDef(el._leaveCb)) {
                    el._leaveCb.cancelled = true;
                    el._leaveCb();
                }
                var data = resolveTransition(vnode.data.transition);
                if (isUndef(data)) {
                    return;
                }
                if (isDef(el._enterCb) || el.nodeType !== 1) {
                    return;
                }
                var css = data.css;
                var type = data.type;
                var enterClass = data.enterClass;
                var enterToClass = data.enterToClass;
                var enterActiveClass = data.enterActiveClass;
                var appearClass = data.appearClass;
                var appearToClass = data.appearToClass;
                var appearActiveClass = data.appearActiveClass;
                var beforeEnter = data.beforeEnter;
                var enter = data.enter;
                var afterEnter = data.afterEnter;
                var enterCancelled = data.enterCancelled;
                var beforeAppear = data.beforeAppear;
                var appear = data.appear;
                var afterAppear = data.afterAppear;
                var appearCancelled = data.appearCancelled;
                var duration = data.duration;
                var context = activeInstance;
                var transitionNode = activeInstance.$vnode;
                while (transitionNode && transitionNode.parent) {
                    transitionNode = transitionNode.parent;
                    context = transitionNode.context;
                }
                var isAppear = !context._isMounted || !vnode.isRootInsert;
                if (isAppear && !appear && appear !== "") {
                    return;
                }
                var startClass = isAppear && appearClass ? appearClass : enterClass;
                var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
                var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
                var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
                var enterHook = isAppear ? typeof appear === "function" ? appear : enter : enter;
                var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
                var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
                var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
                if (false) {
                    checkDuration(explicitEnterDuration, "enter", vnode);
                }
                var expectsCSS = css !== false && !isIE9;
                var userWantsControl = getHookArgumentsLength(enterHook);
                var cb = el._enterCb = once(function() {
                    if (expectsCSS) {
                        removeTransitionClass(el, toClass);
                        removeTransitionClass(el, activeClass);
                    }
                    if (cb.cancelled) {
                        if (expectsCSS) {
                            removeTransitionClass(el, startClass);
                        }
                        enterCancelledHook && enterCancelledHook(el);
                    } else {
                        afterEnterHook && afterEnterHook(el);
                    }
                    el._enterCb = null;
                });
                if (!vnode.data.show) {
                    mergeVNodeHook(vnode, "insert", function() {
                        var parent = el.parentNode;
                        var pendingNode = parent && parent._pending && parent._pending[vnode.key];
                        if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
                            pendingNode.elm._leaveCb();
                        }
                        enterHook && enterHook(el, cb);
                    });
                }
                beforeEnterHook && beforeEnterHook(el);
                if (expectsCSS) {
                    addTransitionClass(el, startClass);
                    addTransitionClass(el, activeClass);
                    nextFrame(function() {
                        removeTransitionClass(el, startClass);
                        if (!cb.cancelled) {
                            addTransitionClass(el, toClass);
                            if (!userWantsControl) {
                                if (isValidDuration(explicitEnterDuration)) {
                                    setTimeout(cb, explicitEnterDuration);
                                } else {
                                    whenTransitionEnds(el, type, cb);
                                }
                            }
                        }
                    });
                }
                if (vnode.data.show) {
                    toggleDisplay && toggleDisplay();
                    enterHook && enterHook(el, cb);
                }
                if (!expectsCSS && !userWantsControl) {
                    cb();
                }
            }
            function leave(vnode, rm) {
                var el = vnode.elm;
                if (isDef(el._enterCb)) {
                    el._enterCb.cancelled = true;
                    el._enterCb();
                }
                var data = resolveTransition(vnode.data.transition);
                if (isUndef(data) || el.nodeType !== 1) {
                    return rm();
                }
                if (isDef(el._leaveCb)) {
                    return;
                }
                var css = data.css;
                var type = data.type;
                var leaveClass = data.leaveClass;
                var leaveToClass = data.leaveToClass;
                var leaveActiveClass = data.leaveActiveClass;
                var beforeLeave = data.beforeLeave;
                var leave = data.leave;
                var afterLeave = data.afterLeave;
                var leaveCancelled = data.leaveCancelled;
                var delayLeave = data.delayLeave;
                var duration = data.duration;
                var expectsCSS = css !== false && !isIE9;
                var userWantsControl = getHookArgumentsLength(leave);
                var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
                if (false) {
                    checkDuration(explicitLeaveDuration, "leave", vnode);
                }
                var cb = el._leaveCb = once(function() {
                    if (el.parentNode && el.parentNode._pending) {
                        el.parentNode._pending[vnode.key] = null;
                    }
                    if (expectsCSS) {
                        removeTransitionClass(el, leaveToClass);
                        removeTransitionClass(el, leaveActiveClass);
                    }
                    if (cb.cancelled) {
                        if (expectsCSS) {
                            removeTransitionClass(el, leaveClass);
                        }
                        leaveCancelled && leaveCancelled(el);
                    } else {
                        rm();
                        afterLeave && afterLeave(el);
                    }
                    el._leaveCb = null;
                });
                if (delayLeave) {
                    delayLeave(performLeave);
                } else {
                    performLeave();
                }
                function performLeave() {
                    if (cb.cancelled) {
                        return;
                    }
                    if (!vnode.data.show) {
                        (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
                    }
                    beforeLeave && beforeLeave(el);
                    if (expectsCSS) {
                        addTransitionClass(el, leaveClass);
                        addTransitionClass(el, leaveActiveClass);
                        nextFrame(function() {
                            removeTransitionClass(el, leaveClass);
                            if (!cb.cancelled) {
                                addTransitionClass(el, leaveToClass);
                                if (!userWantsControl) {
                                    if (isValidDuration(explicitLeaveDuration)) {
                                        setTimeout(cb, explicitLeaveDuration);
                                    } else {
                                        whenTransitionEnds(el, type, cb);
                                    }
                                }
                            }
                        });
                    }
                    leave && leave(el, cb);
                    if (!expectsCSS && !userWantsControl) {
                        cb();
                    }
                }
            }
            function checkDuration(val, name, vnode) {
                if (typeof val !== "number") {
                    warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
                } else if (isNaN(val)) {
                    warn("<transition> explicit " + name + " duration is NaN - " + "the duration expression might be incorrect.", vnode.context);
                }
            }
            function isValidDuration(val) {
                return typeof val === "number" && !isNaN(val);
            }
            function getHookArgumentsLength(fn) {
                if (isUndef(fn)) {
                    return false;
                }
                var invokerFns = fn.fns;
                if (isDef(invokerFns)) {
                    return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
                } else {
                    return (fn._length || fn.length) > 1;
                }
            }
            function _enter(_, vnode) {
                if (vnode.data.show !== true) {
                    enter(vnode);
                }
            }
            var transition = inBrowser ? {
                create: _enter,
                activate: _enter,
                remove: function remove$$1(vnode, rm) {
                    if (vnode.data.show !== true) {
                        leave(vnode, rm);
                    } else {
                        rm();
                    }
                }
            } : {};
            var platformModules = [ attrs, klass, events, domProps, style, transition ];
            var modules = platformModules.concat(baseModules);
            var patch = createPatchFunction({
                nodeOps: nodeOps,
                modules: modules
            });
            if (isIE9) {
                document.addEventListener("selectionchange", function() {
                    var el = document.activeElement;
                    if (el && el.vmodel) {
                        trigger(el, "input");
                    }
                });
            }
            var directive = {
                inserted: function inserted(el, binding, vnode, oldVnode) {
                    if (vnode.tag === "select") {
                        if (oldVnode.elm && !oldVnode.elm._vOptions) {
                            mergeVNodeHook(vnode, "postpatch", function() {
                                directive.componentUpdated(el, binding, vnode);
                            });
                        } else {
                            setSelected(el, binding, vnode.context);
                        }
                        el._vOptions = [].map.call(el.options, getValue);
                    } else if (vnode.tag === "textarea" || isTextInputType(el.type)) {
                        el._vModifiers = binding.modifiers;
                        if (!binding.modifiers.lazy) {
                            el.addEventListener("compositionstart", onCompositionStart);
                            el.addEventListener("compositionend", onCompositionEnd);
                            el.addEventListener("change", onCompositionEnd);
                            if (isIE9) {
                                el.vmodel = true;
                            }
                        }
                    }
                },
                componentUpdated: function componentUpdated(el, binding, vnode) {
                    if (vnode.tag === "select") {
                        setSelected(el, binding, vnode.context);
                        var prevOptions = el._vOptions;
                        var curOptions = el._vOptions = [].map.call(el.options, getValue);
                        if (curOptions.some(function(o, i) {
                            return !looseEqual(o, prevOptions[i]);
                        })) {
                            var needReset = el.multiple ? binding.value.some(function(v) {
                                return hasNoMatchingOption(v, curOptions);
                            }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
                            if (needReset) {
                                trigger(el, "change");
                            }
                        }
                    }
                }
            };
            function setSelected(el, binding, vm) {
                actuallySetSelected(el, binding, vm);
                if (isIE || isEdge) {
                    setTimeout(function() {
                        actuallySetSelected(el, binding, vm);
                    }, 0);
                }
            }
            function actuallySetSelected(el, binding, vm) {
                var value = binding.value;
                var isMultiple = el.multiple;
                if (isMultiple && !Array.isArray(value)) {
                    "production" !== "production" && warn('<select multiple v-model="' + binding.expression + '"> ' + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
                    return;
                }
                var selected, option;
                for (var i = 0, l = el.options.length; i < l; i++) {
                    option = el.options[i];
                    if (isMultiple) {
                        selected = looseIndexOf(value, getValue(option)) > -1;
                        if (option.selected !== selected) {
                            option.selected = selected;
                        }
                    } else {
                        if (looseEqual(getValue(option), value)) {
                            if (el.selectedIndex !== i) {
                                el.selectedIndex = i;
                            }
                            return;
                        }
                    }
                }
                if (!isMultiple) {
                    el.selectedIndex = -1;
                }
            }
            function hasNoMatchingOption(value, options) {
                return options.every(function(o) {
                    return !looseEqual(o, value);
                });
            }
            function getValue(option) {
                return "_value" in option ? option._value : option.value;
            }
            function onCompositionStart(e) {
                e.target.composing = true;
            }
            function onCompositionEnd(e) {
                if (!e.target.composing) {
                    return;
                }
                e.target.composing = false;
                trigger(e.target, "input");
            }
            function trigger(el, type) {
                var e = document.createEvent("HTMLEvents");
                e.initEvent(type, true, true);
                el.dispatchEvent(e);
            }
            function locateNode(vnode) {
                return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
            }
            var show = {
                bind: function bind(el, ref, vnode) {
                    var value = ref.value;
                    vnode = locateNode(vnode);
                    var transition$$1 = vnode.data && vnode.data.transition;
                    var originalDisplay = el.__vOriginalDisplay = el.style.display === "none" ? "" : el.style.display;
                    if (value && transition$$1) {
                        vnode.data.show = true;
                        enter(vnode, function() {
                            el.style.display = originalDisplay;
                        });
                    } else {
                        el.style.display = value ? originalDisplay : "none";
                    }
                },
                update: function update(el, ref, vnode) {
                    var value = ref.value;
                    var oldValue = ref.oldValue;
                    if (!value === !oldValue) {
                        return;
                    }
                    vnode = locateNode(vnode);
                    var transition$$1 = vnode.data && vnode.data.transition;
                    if (transition$$1) {
                        vnode.data.show = true;
                        if (value) {
                            enter(vnode, function() {
                                el.style.display = el.__vOriginalDisplay;
                            });
                        } else {
                            leave(vnode, function() {
                                el.style.display = "none";
                            });
                        }
                    } else {
                        el.style.display = value ? el.__vOriginalDisplay : "none";
                    }
                },
                unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
                    if (!isDestroy) {
                        el.style.display = el.__vOriginalDisplay;
                    }
                }
            };
            var platformDirectives = {
                model: directive,
                show: show
            };
            var transitionProps = {
                name: String,
                appear: Boolean,
                css: Boolean,
                mode: String,
                type: String,
                enterClass: String,
                leaveClass: String,
                enterToClass: String,
                leaveToClass: String,
                enterActiveClass: String,
                leaveActiveClass: String,
                appearClass: String,
                appearActiveClass: String,
                appearToClass: String,
                duration: [ Number, String, Object ]
            };
            function getRealChild(vnode) {
                var compOptions = vnode && vnode.componentOptions;
                if (compOptions && compOptions.Ctor.options.abstract) {
                    return getRealChild(getFirstComponentChild(compOptions.children));
                } else {
                    return vnode;
                }
            }
            function extractTransitionData(comp) {
                var data = {};
                var options = comp.$options;
                for (var key in options.propsData) {
                    data[key] = comp[key];
                }
                var listeners = options._parentListeners;
                for (var key$1 in listeners) {
                    data[camelize(key$1)] = listeners[key$1];
                }
                return data;
            }
            function placeholder(h, rawChild) {
                if (/\d-keep-alive$/.test(rawChild.tag)) {
                    return h("keep-alive", {
                        props: rawChild.componentOptions.propsData
                    });
                }
            }
            function hasParentTransition(vnode) {
                while (vnode = vnode.parent) {
                    if (vnode.data.transition) {
                        return true;
                    }
                }
            }
            function isSameChild(child, oldChild) {
                return oldChild.key === child.key && oldChild.tag === child.tag;
            }
            var Transition = {
                name: "transition",
                props: transitionProps,
                abstract: true,
                render: function render(h) {
                    var this$1 = this;
                    var children = this.$slots.default;
                    if (!children) {
                        return;
                    }
                    children = children.filter(function(c) {
                        return c.tag || isAsyncPlaceholder(c);
                    });
                    if (!children.length) {
                        return;
                    }
                    if (false) {
                        warn("<transition> can only be used on a single element. Use " + "<transition-group> for lists.", this.$parent);
                    }
                    var mode = this.mode;
                    if (false) {
                        warn("invalid <transition> mode: " + mode, this.$parent);
                    }
                    var rawChild = children[0];
                    if (hasParentTransition(this.$vnode)) {
                        return rawChild;
                    }
                    var child = getRealChild(rawChild);
                    if (!child) {
                        return rawChild;
                    }
                    if (this._leaving) {
                        return placeholder(h, rawChild);
                    }
                    var id = "__transition-" + this._uid + "-";
                    child.key = child.key == null ? child.isComment ? id + "comment" : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
                    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
                    var oldRawChild = this._vnode;
                    var oldChild = getRealChild(oldRawChild);
                    if (child.data.directives && child.data.directives.some(function(d) {
                        return d.name === "show";
                    })) {
                        child.data.show = true;
                    }
                    if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) && !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
                        var oldData = oldChild.data.transition = extend({}, data);
                        if (mode === "out-in") {
                            this._leaving = true;
                            mergeVNodeHook(oldData, "afterLeave", function() {
                                this$1._leaving = false;
                                this$1.$forceUpdate();
                            });
                            return placeholder(h, rawChild);
                        } else if (mode === "in-out") {
                            if (isAsyncPlaceholder(child)) {
                                return oldRawChild;
                            }
                            var delayedLeave;
                            var performLeave = function() {
                                delayedLeave();
                            };
                            mergeVNodeHook(data, "afterEnter", performLeave);
                            mergeVNodeHook(data, "enterCancelled", performLeave);
                            mergeVNodeHook(oldData, "delayLeave", function(leave) {
                                delayedLeave = leave;
                            });
                        }
                    }
                    return rawChild;
                }
            };
            var props = extend({
                tag: String,
                moveClass: String
            }, transitionProps);
            delete props.mode;
            var TransitionGroup = {
                props: props,
                render: function render(h) {
                    var tag = this.tag || this.$vnode.data.tag || "span";
                    var map = Object.create(null);
                    var prevChildren = this.prevChildren = this.children;
                    var rawChildren = this.$slots.default || [];
                    var children = this.children = [];
                    var transitionData = extractTransitionData(this);
                    for (var i = 0; i < rawChildren.length; i++) {
                        var c = rawChildren[i];
                        if (c.tag) {
                            if (c.key != null && String(c.key).indexOf("__vlist") !== 0) {
                                children.push(c);
                                map[c.key] = c;
                                (c.data || (c.data = {})).transition = transitionData;
                            } else if (false) {
                                var opts = c.componentOptions;
                                var name = opts ? opts.Ctor.options.name || opts.tag || "" : c.tag;
                                warn("<transition-group> children must be keyed: <" + name + ">");
                            }
                        }
                    }
                    if (prevChildren) {
                        var kept = [];
                        var removed = [];
                        for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
                            var c$1 = prevChildren[i$1];
                            c$1.data.transition = transitionData;
                            c$1.data.pos = c$1.elm.getBoundingClientRect();
                            if (map[c$1.key]) {
                                kept.push(c$1);
                            } else {
                                removed.push(c$1);
                            }
                        }
                        this.kept = h(tag, null, kept);
                        this.removed = removed;
                    }
                    return h(tag, null, children);
                },
                beforeUpdate: function beforeUpdate() {
                    this.__patch__(this._vnode, this.kept, false, true);
                    this._vnode = this.kept;
                },
                updated: function updated() {
                    var children = this.prevChildren;
                    var moveClass = this.moveClass || (this.name || "v") + "-move";
                    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
                        return;
                    }
                    children.forEach(callPendingCbs);
                    children.forEach(recordPosition);
                    children.forEach(applyTranslation);
                    this._reflow = document.body.offsetHeight;
                    children.forEach(function(c) {
                        if (c.data.moved) {
                            var el = c.elm;
                            var s = el.style;
                            addTransitionClass(el, moveClass);
                            s.transform = s.WebkitTransform = s.transitionDuration = "";
                            el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
                                if (!e || /transform$/.test(e.propertyName)) {
                                    el.removeEventListener(transitionEndEvent, cb);
                                    el._moveCb = null;
                                    removeTransitionClass(el, moveClass);
                                }
                            });
                        }
                    });
                },
                methods: {
                    hasMove: function hasMove(el, moveClass) {
                        if (!hasTransition) {
                            return false;
                        }
                        if (this._hasMove) {
                            return this._hasMove;
                        }
                        var clone = el.cloneNode();
                        if (el._transitionClasses) {
                            el._transitionClasses.forEach(function(cls) {
                                removeClass(clone, cls);
                            });
                        }
                        addClass(clone, moveClass);
                        clone.style.display = "none";
                        this.$el.appendChild(clone);
                        var info = getTransitionInfo(clone);
                        this.$el.removeChild(clone);
                        return this._hasMove = info.hasTransform;
                    }
                }
            };
            function callPendingCbs(c) {
                if (c.elm._moveCb) {
                    c.elm._moveCb();
                }
                if (c.elm._enterCb) {
                    c.elm._enterCb();
                }
            }
            function recordPosition(c) {
                c.data.newPos = c.elm.getBoundingClientRect();
            }
            function applyTranslation(c) {
                var oldPos = c.data.pos;
                var newPos = c.data.newPos;
                var dx = oldPos.left - newPos.left;
                var dy = oldPos.top - newPos.top;
                if (dx || dy) {
                    c.data.moved = true;
                    var s = c.elm.style;
                    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
                    s.transitionDuration = "0s";
                }
            }
            var platformComponents = {
                Transition: Transition,
                TransitionGroup: TransitionGroup
            };
            Vue.config.mustUseProp = mustUseProp;
            Vue.config.isReservedTag = isReservedTag;
            Vue.config.isReservedAttr = isReservedAttr;
            Vue.config.getTagNamespace = getTagNamespace;
            Vue.config.isUnknownElement = isUnknownElement;
            extend(Vue.options.directives, platformDirectives);
            extend(Vue.options.components, platformComponents);
            Vue.prototype.__patch__ = inBrowser ? patch : noop;
            Vue.prototype.$mount = function(el, hydrating) {
                el = el && inBrowser ? query(el) : undefined;
                return mountComponent(this, el, hydrating);
            };
            if (inBrowser) {
                setTimeout(function() {
                    if (config.devtools) {
                        if (devtools) {
                            devtools.emit("init", Vue);
                        } else if (false) {
                            console[console.info ? "info" : "log"]("Download the Vue Devtools extension for a better development experience:\n" + "https://github.com/vuejs/vue-devtools");
                        }
                    }
                    if (false) {
                        console[console.info ? "info" : "log"]("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
                    }
                }, 0);
            }
            var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
            var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
            var buildRegex = cached(function(delimiters) {
                var open = delimiters[0].replace(regexEscapeRE, "\\$&");
                var close = delimiters[1].replace(regexEscapeRE, "\\$&");
                return new RegExp(open + "((?:.|\\n)+?)" + close, "g");
            });
            function parseText(text, delimiters) {
                var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
                if (!tagRE.test(text)) {
                    return;
                }
                var tokens = [];
                var rawTokens = [];
                var lastIndex = tagRE.lastIndex = 0;
                var match, index, tokenValue;
                while (match = tagRE.exec(text)) {
                    index = match.index;
                    if (index > lastIndex) {
                        rawTokens.push(tokenValue = text.slice(lastIndex, index));
                        tokens.push(JSON.stringify(tokenValue));
                    }
                    var exp = parseFilters(match[1].trim());
                    tokens.push("_s(" + exp + ")");
                    rawTokens.push({
                        "@binding": exp
                    });
                    lastIndex = index + match[0].length;
                }
                if (lastIndex < text.length) {
                    rawTokens.push(tokenValue = text.slice(lastIndex));
                    tokens.push(JSON.stringify(tokenValue));
                }
                return {
                    expression: tokens.join("+"),
                    tokens: rawTokens
                };
            }
            function transformNode(el, options) {
                var warn = options.warn || baseWarn;
                var staticClass = getAndRemoveAttr(el, "class");
                if (false) {
                    var res = parseText(staticClass, options.delimiters);
                    if (res) {
                        warn('class="' + staticClass + '": ' + "Interpolation inside attributes has been removed. " + "Use v-bind or the colon shorthand instead. For example, " + 'instead of <div class="{{ val }}">, use <div :class="val">.');
                    }
                }
                if (staticClass) {
                    el.staticClass = JSON.stringify(staticClass);
                }
                var classBinding = getBindingAttr(el, "class", false);
                if (classBinding) {
                    el.classBinding = classBinding;
                }
            }
            function genData(el) {
                var data = "";
                if (el.staticClass) {
                    data += "staticClass:" + el.staticClass + ",";
                }
                if (el.classBinding) {
                    data += "class:" + el.classBinding + ",";
                }
                return data;
            }
            var klass$1 = {
                staticKeys: [ "staticClass" ],
                transformNode: transformNode,
                genData: genData
            };
            function transformNode$1(el, options) {
                var warn = options.warn || baseWarn;
                var staticStyle = getAndRemoveAttr(el, "style");
                if (staticStyle) {
                    if (false) {
                        var res = parseText(staticStyle, options.delimiters);
                        if (res) {
                            warn('style="' + staticStyle + '": ' + "Interpolation inside attributes has been removed. " + "Use v-bind or the colon shorthand instead. For example, " + 'instead of <div style="{{ val }}">, use <div :style="val">.');
                        }
                    }
                    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
                }
                var styleBinding = getBindingAttr(el, "style", false);
                if (styleBinding) {
                    el.styleBinding = styleBinding;
                }
            }
            function genData$1(el) {
                var data = "";
                if (el.staticStyle) {
                    data += "staticStyle:" + el.staticStyle + ",";
                }
                if (el.styleBinding) {
                    data += "style:(" + el.styleBinding + "),";
                }
                return data;
            }
            var style$1 = {
                staticKeys: [ "staticStyle" ],
                transformNode: transformNode$1,
                genData: genData$1
            };
            var decoder;
            var he = {
                decode: function decode(html) {
                    decoder = decoder || document.createElement("div");
                    decoder.innerHTML = html;
                    return decoder.textContent;
                }
            };
            var isUnaryTag = makeMap("area,base,br,col,embed,frame,hr,img,input,isindex,keygen," + "link,meta,param,source,track,wbr");
            var canBeLeftOpenTag = makeMap("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source");
            var isNonPhrasingTag = makeMap("address,article,aside,base,blockquote,body,caption,col,colgroup,dd," + "details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form," + "h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta," + "optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead," + "title,tr,track");
            /*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */
            var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
            var ncname = "[a-zA-Z_][\\w\\-\\.]*";
            var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
            var startTagOpen = new RegExp("^<" + qnameCapture);
            var startTagClose = /^\s*(\/?)>/;
            var endTag = new RegExp("^<\\/" + qnameCapture + "[^>]*>");
            var doctype = /^<!DOCTYPE [^>]+>/i;
            var comment = /^<!\--/;
            var conditionalComment = /^<!\[/;
            var IS_REGEX_CAPTURING_BROKEN = false;
            "x".replace(/x(.)?/g, function(m, g) {
                IS_REGEX_CAPTURING_BROKEN = g === "";
            });
            var isPlainTextElement = makeMap("script,style,textarea", true);
            var reCache = {};
            var decodingMap = {
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&amp;": "&",
                "&#10;": "\n",
                "&#9;": "\t"
            };
            var encodedAttr = /&(?:lt|gt|quot|amp);/g;
            var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;
            var isIgnoreNewlineTag = makeMap("pre,textarea", true);
            var shouldIgnoreFirstNewline = function(tag, html) {
                return tag && isIgnoreNewlineTag(tag) && html[0] === "\n";
            };
            function decodeAttr(value, shouldDecodeNewlines) {
                var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
                return value.replace(re, function(match) {
                    return decodingMap[match];
                });
            }
            function parseHTML(html, options) {
                var stack = [];
                var expectHTML = options.expectHTML;
                var isUnaryTag$$1 = options.isUnaryTag || no;
                var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
                var index = 0;
                var last, lastTag;
                while (html) {
                    last = html;
                    if (!lastTag || !isPlainTextElement(lastTag)) {
                        var textEnd = html.indexOf("<");
                        if (textEnd === 0) {
                            if (comment.test(html)) {
                                var commentEnd = html.indexOf("--\x3e");
                                if (commentEnd >= 0) {
                                    if (options.shouldKeepComment) {
                                        options.comment(html.substring(4, commentEnd));
                                    }
                                    advance(commentEnd + 3);
                                    continue;
                                }
                            }
                            if (conditionalComment.test(html)) {
                                var conditionalEnd = html.indexOf("]>");
                                if (conditionalEnd >= 0) {
                                    advance(conditionalEnd + 2);
                                    continue;
                                }
                            }
                            var doctypeMatch = html.match(doctype);
                            if (doctypeMatch) {
                                advance(doctypeMatch[0].length);
                                continue;
                            }
                            var endTagMatch = html.match(endTag);
                            if (endTagMatch) {
                                var curIndex = index;
                                advance(endTagMatch[0].length);
                                parseEndTag(endTagMatch[1], curIndex, index);
                                continue;
                            }
                            var startTagMatch = parseStartTag();
                            if (startTagMatch) {
                                handleStartTag(startTagMatch);
                                if (shouldIgnoreFirstNewline(lastTag, html)) {
                                    advance(1);
                                }
                                continue;
                            }
                        }
                        var text = void 0, rest = void 0, next = void 0;
                        if (textEnd >= 0) {
                            rest = html.slice(textEnd);
                            while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
                                next = rest.indexOf("<", 1);
                                if (next < 0) {
                                    break;
                                }
                                textEnd += next;
                                rest = html.slice(textEnd);
                            }
                            text = html.substring(0, textEnd);
                            advance(textEnd);
                        }
                        if (textEnd < 0) {
                            text = html;
                            html = "";
                        }
                        if (options.chars && text) {
                            options.chars(text);
                        }
                    } else {
                        var endTagLength = 0;
                        var stackedTag = lastTag.toLowerCase();
                        var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp("([\\s\\S]*?)(</" + stackedTag + "[^>]*>)", "i"));
                        var rest$1 = html.replace(reStackedTag, function(all, text, endTag) {
                            endTagLength = endTag.length;
                            if (!isPlainTextElement(stackedTag) && stackedTag !== "noscript") {
                                text = text.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1");
                            }
                            if (shouldIgnoreFirstNewline(stackedTag, text)) {
                                text = text.slice(1);
                            }
                            if (options.chars) {
                                options.chars(text);
                            }
                            return "";
                        });
                        index += html.length - rest$1.length;
                        html = rest$1;
                        parseEndTag(stackedTag, index - endTagLength, index);
                    }
                    if (html === last) {
                        options.chars && options.chars(html);
                        if (false) {
                            options.warn('Mal-formatted tag at end of template: "' + html + '"');
                        }
                        break;
                    }
                }
                parseEndTag();
                function advance(n) {
                    index += n;
                    html = html.substring(n);
                }
                function parseStartTag() {
                    var start = html.match(startTagOpen);
                    if (start) {
                        var match = {
                            tagName: start[1],
                            attrs: [],
                            start: index
                        };
                        advance(start[0].length);
                        var end, attr;
                        while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
                            advance(attr[0].length);
                            match.attrs.push(attr);
                        }
                        if (end) {
                            match.unarySlash = end[1];
                            advance(end[0].length);
                            match.end = index;
                            return match;
                        }
                    }
                }
                function handleStartTag(match) {
                    var tagName = match.tagName;
                    var unarySlash = match.unarySlash;
                    if (expectHTML) {
                        if (lastTag === "p" && isNonPhrasingTag(tagName)) {
                            parseEndTag(lastTag);
                        }
                        if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
                            parseEndTag(tagName);
                        }
                    }
                    var unary = isUnaryTag$$1(tagName) || !!unarySlash;
                    var l = match.attrs.length;
                    var attrs = new Array(l);
                    for (var i = 0; i < l; i++) {
                        var args = match.attrs[i];
                        if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
                            if (args[3] === "") {
                                delete args[3];
                            }
                            if (args[4] === "") {
                                delete args[4];
                            }
                            if (args[5] === "") {
                                delete args[5];
                            }
                        }
                        var value = args[3] || args[4] || args[5] || "";
                        var shouldDecodeNewlines = tagName === "a" && args[1] === "href" ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
                        attrs[i] = {
                            name: args[1],
                            value: decodeAttr(value, shouldDecodeNewlines)
                        };
                    }
                    if (!unary) {
                        stack.push({
                            tag: tagName,
                            lowerCasedTag: tagName.toLowerCase(),
                            attrs: attrs
                        });
                        lastTag = tagName;
                    }
                    if (options.start) {
                        options.start(tagName, attrs, unary, match.start, match.end);
                    }
                }
                function parseEndTag(tagName, start, end) {
                    var pos, lowerCasedTagName;
                    if (start == null) {
                        start = index;
                    }
                    if (end == null) {
                        end = index;
                    }
                    if (tagName) {
                        lowerCasedTagName = tagName.toLowerCase();
                    }
                    if (tagName) {
                        for (pos = stack.length - 1; pos >= 0; pos--) {
                            if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                                break;
                            }
                        }
                    } else {
                        pos = 0;
                    }
                    if (pos >= 0) {
                        for (var i = stack.length - 1; i >= pos; i--) {
                            if (false) {
                                options.warn("tag <" + stack[i].tag + "> has no matching end tag.");
                            }
                            if (options.end) {
                                options.end(stack[i].tag, start, end);
                            }
                        }
                        stack.length = pos;
                        lastTag = pos && stack[pos - 1].tag;
                    } else if (lowerCasedTagName === "br") {
                        if (options.start) {
                            options.start(tagName, [], true, start, end);
                        }
                    } else if (lowerCasedTagName === "p") {
                        if (options.start) {
                            options.start(tagName, [], false, start, end);
                        }
                        if (options.end) {
                            options.end(tagName, start, end);
                        }
                    }
                }
            }
            var onRE = /^@|^v-on:/;
            var dirRE = /^v-|^@|^:/;
            var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
            var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
            var stripParensRE = /^\(|\)$/g;
            var argRE = /:(.*)$/;
            var bindRE = /^:|^v-bind:/;
            var modifierRE = /\.[^.]+/g;
            var decodeHTMLCached = cached(he.decode);
            var warn$2;
            var delimiters;
            var transforms;
            var preTransforms;
            var postTransforms;
            var platformIsPreTag;
            var platformMustUseProp;
            var platformGetTagNamespace;
            function createASTElement(tag, attrs, parent) {
                return {
                    type: 1,
                    tag: tag,
                    attrsList: attrs,
                    attrsMap: makeAttrsMap(attrs),
                    parent: parent,
                    children: []
                };
            }
            function parse(template, options) {
                warn$2 = options.warn || baseWarn;
                platformIsPreTag = options.isPreTag || no;
                platformMustUseProp = options.mustUseProp || no;
                platformGetTagNamespace = options.getTagNamespace || no;
                transforms = pluckModuleFunction(options.modules, "transformNode");
                preTransforms = pluckModuleFunction(options.modules, "preTransformNode");
                postTransforms = pluckModuleFunction(options.modules, "postTransformNode");
                delimiters = options.delimiters;
                var stack = [];
                var preserveWhitespace = options.preserveWhitespace !== false;
                var root;
                var currentParent;
                var inVPre = false;
                var inPre = false;
                var warned = false;
                function warnOnce(msg) {
                    if (!warned) {
                        warned = true;
                        warn$2(msg);
                    }
                }
                function closeElement(element) {
                    if (element.pre) {
                        inVPre = false;
                    }
                    if (platformIsPreTag(element.tag)) {
                        inPre = false;
                    }
                    for (var i = 0; i < postTransforms.length; i++) {
                        postTransforms[i](element, options);
                    }
                }
                parseHTML(template, {
                    warn: warn$2,
                    expectHTML: options.expectHTML,
                    isUnaryTag: options.isUnaryTag,
                    canBeLeftOpenTag: options.canBeLeftOpenTag,
                    shouldDecodeNewlines: options.shouldDecodeNewlines,
                    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
                    shouldKeepComment: options.comments,
                    start: function start(tag, attrs, unary) {
                        var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag);
                        if (isIE && ns === "svg") {
                            attrs = guardIESVGBug(attrs);
                        }
                        var element = createASTElement(tag, attrs, currentParent);
                        if (ns) {
                            element.ns = ns;
                        }
                        if (isForbiddenTag(element) && !isServerRendering()) {
                            element.forbidden = true;
                            "production" !== "production" && warn$2("Templates should only be responsible for mapping the state to the " + "UI. Avoid placing tags with side-effects in your templates, such as " + "<" + tag + ">" + ", as they will not be parsed.");
                        }
                        for (var i = 0; i < preTransforms.length; i++) {
                            element = preTransforms[i](element, options) || element;
                        }
                        if (!inVPre) {
                            processPre(element);
                            if (element.pre) {
                                inVPre = true;
                            }
                        }
                        if (platformIsPreTag(element.tag)) {
                            inPre = true;
                        }
                        if (inVPre) {
                            processRawAttrs(element);
                        } else if (!element.processed) {
                            processFor(element);
                            processIf(element);
                            processOnce(element);
                            processElement(element, options);
                        }
                        function checkRootConstraints(el) {
                            if (false) {
                                if (el.tag === "slot" || el.tag === "template") {
                                    warnOnce("Cannot use <" + el.tag + "> as component root element because it may " + "contain multiple nodes.");
                                }
                                if (el.attrsMap.hasOwnProperty("v-for")) {
                                    warnOnce("Cannot use v-for on stateful component root element because " + "it renders multiple elements.");
                                }
                            }
                        }
                        if (!root) {
                            root = element;
                            checkRootConstraints(root);
                        } else if (!stack.length) {
                            if (root.if && (element.elseif || element.else)) {
                                checkRootConstraints(element);
                                addIfCondition(root, {
                                    exp: element.elseif,
                                    block: element
                                });
                            } else if (false) {
                                warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.");
                            }
                        }
                        if (currentParent && !element.forbidden) {
                            if (element.elseif || element.else) {
                                processIfConditions(element, currentParent);
                            } else if (element.slotScope) {
                                currentParent.plain = false;
                                var name = element.slotTarget || '"default"';
                                (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
                            } else {
                                currentParent.children.push(element);
                                element.parent = currentParent;
                            }
                        }
                        if (!unary) {
                            currentParent = element;
                            stack.push(element);
                        } else {
                            closeElement(element);
                        }
                    },
                    end: function end() {
                        var element = stack[stack.length - 1];
                        var lastNode = element.children[element.children.length - 1];
                        if (lastNode && lastNode.type === 3 && lastNode.text === " " && !inPre) {
                            element.children.pop();
                        }
                        stack.length -= 1;
                        currentParent = stack[stack.length - 1];
                        closeElement(element);
                    },
                    chars: function chars(text) {
                        if (!currentParent) {
                            if (false) {
                                if (text === template) {
                                    warnOnce("Component template requires a root element, rather than just text.");
                                } else if (text = text.trim()) {
                                    warnOnce('text "' + text + '" outside root element will be ignored.');
                                }
                            }
                            return;
                        }
                        if (isIE && currentParent.tag === "textarea" && currentParent.attrsMap.placeholder === text) {
                            return;
                        }
                        var children = currentParent.children;
                        text = inPre || text.trim() ? isTextTag(currentParent) ? text : decodeHTMLCached(text) : preserveWhitespace && children.length ? " " : "";
                        if (text) {
                            var res;
                            if (!inVPre && text !== " " && (res = parseText(text, delimiters))) {
                                children.push({
                                    type: 2,
                                    expression: res.expression,
                                    tokens: res.tokens,
                                    text: text
                                });
                            } else if (text !== " " || !children.length || children[children.length - 1].text !== " ") {
                                children.push({
                                    type: 3,
                                    text: text
                                });
                            }
                        }
                    },
                    comment: function comment(text) {
                        currentParent.children.push({
                            type: 3,
                            text: text,
                            isComment: true
                        });
                    }
                });
                return root;
            }
            function processPre(el) {
                if (getAndRemoveAttr(el, "v-pre") != null) {
                    el.pre = true;
                }
            }
            function processRawAttrs(el) {
                var l = el.attrsList.length;
                if (l) {
                    var attrs = el.attrs = new Array(l);
                    for (var i = 0; i < l; i++) {
                        attrs[i] = {
                            name: el.attrsList[i].name,
                            value: JSON.stringify(el.attrsList[i].value)
                        };
                    }
                } else if (!el.pre) {
                    el.plain = true;
                }
            }
            function processElement(element, options) {
                processKey(element);
                element.plain = !element.key && !element.attrsList.length;
                processRef(element);
                processSlot(element);
                processComponent(element);
                for (var i = 0; i < transforms.length; i++) {
                    element = transforms[i](element, options) || element;
                }
                processAttrs(element);
            }
            function processKey(el) {
                var exp = getBindingAttr(el, "key");
                if (exp) {
                    if (false) {
                        warn$2("<template> cannot be keyed. Place the key on real elements instead.");
                    }
                    el.key = exp;
                }
            }
            function processRef(el) {
                var ref = getBindingAttr(el, "ref");
                if (ref) {
                    el.ref = ref;
                    el.refInFor = checkInFor(el);
                }
            }
            function processFor(el) {
                var exp;
                if (exp = getAndRemoveAttr(el, "v-for")) {
                    var res = parseFor(exp);
                    if (res) {
                        extend(el, res);
                    } else if (false) {
                        warn$2("Invalid v-for expression: " + exp);
                    }
                }
            }
            function parseFor(exp) {
                var inMatch = exp.match(forAliasRE);
                if (!inMatch) {
                    return;
                }
                var res = {};
                res.for = inMatch[2].trim();
                var alias = inMatch[1].trim().replace(stripParensRE, "");
                var iteratorMatch = alias.match(forIteratorRE);
                if (iteratorMatch) {
                    res.alias = alias.replace(forIteratorRE, "");
                    res.iterator1 = iteratorMatch[1].trim();
                    if (iteratorMatch[2]) {
                        res.iterator2 = iteratorMatch[2].trim();
                    }
                } else {
                    res.alias = alias;
                }
                return res;
            }
            function processIf(el) {
                var exp = getAndRemoveAttr(el, "v-if");
                if (exp) {
                    el.if = exp;
                    addIfCondition(el, {
                        exp: exp,
                        block: el
                    });
                } else {
                    if (getAndRemoveAttr(el, "v-else") != null) {
                        el.else = true;
                    }
                    var elseif = getAndRemoveAttr(el, "v-else-if");
                    if (elseif) {
                        el.elseif = elseif;
                    }
                }
            }
            function processIfConditions(el, parent) {
                var prev = findPrevElement(parent.children);
                if (prev && prev.if) {
                    addIfCondition(prev, {
                        exp: el.elseif,
                        block: el
                    });
                } else if (false) {
                    warn$2("v-" + (el.elseif ? 'else-if="' + el.elseif + '"' : "else") + " " + "used on element <" + el.tag + "> without corresponding v-if.");
                }
            }
            function findPrevElement(children) {
                var i = children.length;
                while (i--) {
                    if (children[i].type === 1) {
                        return children[i];
                    } else {
                        if (false) {
                            warn$2('text "' + children[i].text.trim() + '" between v-if and v-else(-if) ' + "will be ignored.");
                        }
                        children.pop();
                    }
                }
            }
            function addIfCondition(el, condition) {
                if (!el.ifConditions) {
                    el.ifConditions = [];
                }
                el.ifConditions.push(condition);
            }
            function processOnce(el) {
                var once$$1 = getAndRemoveAttr(el, "v-once");
                if (once$$1 != null) {
                    el.once = true;
                }
            }
            function processSlot(el) {
                if (el.tag === "slot") {
                    el.slotName = getBindingAttr(el, "name");
                    if (false) {
                        warn$2("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.");
                    }
                } else {
                    var slotScope;
                    if (el.tag === "template") {
                        slotScope = getAndRemoveAttr(el, "scope");
                        if (false) {
                            warn$2('the "scope" attribute for scoped slots have been deprecated and ' + 'replaced by "slot-scope" since 2.5. The new "slot-scope" attribute ' + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", true);
                        }
                        el.slotScope = slotScope || getAndRemoveAttr(el, "slot-scope");
                    } else if (slotScope = getAndRemoveAttr(el, "slot-scope")) {
                        if (false) {
                            warn$2("Ambiguous combined usage of slot-scope and v-for on <" + el.tag + "> " + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", true);
                        }
                        el.slotScope = slotScope;
                    }
                    var slotTarget = getBindingAttr(el, "slot");
                    if (slotTarget) {
                        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
                        if (el.tag !== "template" && !el.slotScope) {
                            addAttr(el, "slot", slotTarget);
                        }
                    }
                }
            }
            function processComponent(el) {
                var binding;
                if (binding = getBindingAttr(el, "is")) {
                    el.component = binding;
                }
                if (getAndRemoveAttr(el, "inline-template") != null) {
                    el.inlineTemplate = true;
                }
            }
            function processAttrs(el) {
                var list = el.attrsList;
                var i, l, name, rawName, value, modifiers, isProp;
                for (i = 0, l = list.length; i < l; i++) {
                    name = rawName = list[i].name;
                    value = list[i].value;
                    if (dirRE.test(name)) {
                        el.hasBindings = true;
                        modifiers = parseModifiers(name);
                        if (modifiers) {
                            name = name.replace(modifierRE, "");
                        }
                        if (bindRE.test(name)) {
                            name = name.replace(bindRE, "");
                            value = parseFilters(value);
                            isProp = false;
                            if (modifiers) {
                                if (modifiers.prop) {
                                    isProp = true;
                                    name = camelize(name);
                                    if (name === "innerHtml") {
                                        name = "innerHTML";
                                    }
                                }
                                if (modifiers.camel) {
                                    name = camelize(name);
                                }
                                if (modifiers.sync) {
                                    addHandler(el, "update:" + camelize(name), genAssignmentCode(value, "$event"));
                                }
                            }
                            if (isProp || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                                addProp(el, name, value);
                            } else {
                                addAttr(el, name, value);
                            }
                        } else if (onRE.test(name)) {
                            name = name.replace(onRE, "");
                            addHandler(el, name, value, modifiers, false, warn$2);
                        } else {
                            name = name.replace(dirRE, "");
                            var argMatch = name.match(argRE);
                            var arg = argMatch && argMatch[1];
                            if (arg) {
                                name = name.slice(0, -(arg.length + 1));
                            }
                            addDirective(el, name, rawName, value, arg, modifiers);
                            if (false) {
                                checkForAliasModel(el, value);
                            }
                        }
                    } else {
                        if (false) {
                            var res = parseText(value, delimiters);
                            if (res) {
                                warn$2(name + '="' + value + '": ' + "Interpolation inside attributes has been removed. " + "Use v-bind or the colon shorthand instead. For example, " + 'instead of <div id="{{ val }}">, use <div :id="val">.');
                            }
                        }
                        addAttr(el, name, JSON.stringify(value));
                        if (!el.component && name === "muted" && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                            addProp(el, name, "true");
                        }
                    }
                }
            }
            function checkInFor(el) {
                var parent = el;
                while (parent) {
                    if (parent.for !== undefined) {
                        return true;
                    }
                    parent = parent.parent;
                }
                return false;
            }
            function parseModifiers(name) {
                var match = name.match(modifierRE);
                if (match) {
                    var ret = {};
                    match.forEach(function(m) {
                        ret[m.slice(1)] = true;
                    });
                    return ret;
                }
            }
            function makeAttrsMap(attrs) {
                var map = {};
                for (var i = 0, l = attrs.length; i < l; i++) {
                    if (false) {
                        warn$2("duplicate attribute: " + attrs[i].name);
                    }
                    map[attrs[i].name] = attrs[i].value;
                }
                return map;
            }
            function isTextTag(el) {
                return el.tag === "script" || el.tag === "style";
            }
            function isForbiddenTag(el) {
                return el.tag === "style" || el.tag === "script" && (!el.attrsMap.type || el.attrsMap.type === "text/javascript");
            }
            var ieNSBug = /^xmlns:NS\d+/;
            var ieNSPrefix = /^NS\d+:/;
            function guardIESVGBug(attrs) {
                var res = [];
                for (var i = 0; i < attrs.length; i++) {
                    var attr = attrs[i];
                    if (!ieNSBug.test(attr.name)) {
                        attr.name = attr.name.replace(ieNSPrefix, "");
                        res.push(attr);
                    }
                }
                return res;
            }
            function checkForAliasModel(el, value) {
                var _el = el;
                while (_el) {
                    if (_el.for && _el.alias === value) {
                        warn$2("<" + el.tag + ' v-model="' + value + '">: ' + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.");
                    }
                    _el = _el.parent;
                }
            }
            function preTransformNode(el, options) {
                if (el.tag === "input") {
                    var map = el.attrsMap;
                    if (!map["v-model"]) {
                        return;
                    }
                    var typeBinding;
                    if (map[":type"] || map["v-bind:type"]) {
                        typeBinding = getBindingAttr(el, "type");
                    }
                    if (!map.type && !typeBinding && map["v-bind"]) {
                        typeBinding = "(" + map["v-bind"] + ").type";
                    }
                    if (typeBinding) {
                        var ifCondition = getAndRemoveAttr(el, "v-if", true);
                        var ifConditionExtra = ifCondition ? "&&(" + ifCondition + ")" : "";
                        var hasElse = getAndRemoveAttr(el, "v-else", true) != null;
                        var elseIfCondition = getAndRemoveAttr(el, "v-else-if", true);
                        var branch0 = cloneASTElement(el);
                        processFor(branch0);
                        addRawAttr(branch0, "type", "checkbox");
                        processElement(branch0, options);
                        branch0.processed = true;
                        branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
                        addIfCondition(branch0, {
                            exp: branch0.if,
                            block: branch0
                        });
                        var branch1 = cloneASTElement(el);
                        getAndRemoveAttr(branch1, "v-for", true);
                        addRawAttr(branch1, "type", "radio");
                        processElement(branch1, options);
                        addIfCondition(branch0, {
                            exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
                            block: branch1
                        });
                        var branch2 = cloneASTElement(el);
                        getAndRemoveAttr(branch2, "v-for", true);
                        addRawAttr(branch2, ":type", typeBinding);
                        processElement(branch2, options);
                        addIfCondition(branch0, {
                            exp: ifCondition,
                            block: branch2
                        });
                        if (hasElse) {
                            branch0.else = true;
                        } else if (elseIfCondition) {
                            branch0.elseif = elseIfCondition;
                        }
                        return branch0;
                    }
                }
            }
            function cloneASTElement(el) {
                return createASTElement(el.tag, el.attrsList.slice(), el.parent);
            }
            var model$2 = {
                preTransformNode: preTransformNode
            };
            var modules$1 = [ klass$1, style$1, model$2 ];
            function text(el, dir) {
                if (dir.value) {
                    addProp(el, "textContent", "_s(" + dir.value + ")");
                }
            }
            function html(el, dir) {
                if (dir.value) {
                    addProp(el, "innerHTML", "_s(" + dir.value + ")");
                }
            }
            var directives$1 = {
                model: model,
                text: text,
                html: html
            };
            var baseOptions = {
                expectHTML: true,
                modules: modules$1,
                directives: directives$1,
                isPreTag: isPreTag,
                isUnaryTag: isUnaryTag,
                mustUseProp: mustUseProp,
                canBeLeftOpenTag: canBeLeftOpenTag,
                isReservedTag: isReservedTag,
                getTagNamespace: getTagNamespace,
                staticKeys: genStaticKeys(modules$1)
            };
            var isStaticKey;
            var isPlatformReservedTag;
            var genStaticKeysCached = cached(genStaticKeys$1);
            function optimize(root, options) {
                if (!root) {
                    return;
                }
                isStaticKey = genStaticKeysCached(options.staticKeys || "");
                isPlatformReservedTag = options.isReservedTag || no;
                markStatic$1(root);
                markStaticRoots(root, false);
            }
            function genStaticKeys$1(keys) {
                return makeMap("type,tag,attrsList,attrsMap,plain,parent,children,attrs" + (keys ? "," + keys : ""));
            }
            function markStatic$1(node) {
                node.static = isStatic(node);
                if (node.type === 1) {
                    if (!isPlatformReservedTag(node.tag) && node.tag !== "slot" && node.attrsMap["inline-template"] == null) {
                        return;
                    }
                    for (var i = 0, l = node.children.length; i < l; i++) {
                        var child = node.children[i];
                        markStatic$1(child);
                        if (!child.static) {
                            node.static = false;
                        }
                    }
                    if (node.ifConditions) {
                        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
                            var block = node.ifConditions[i$1].block;
                            markStatic$1(block);
                            if (!block.static) {
                                node.static = false;
                            }
                        }
                    }
                }
            }
            function markStaticRoots(node, isInFor) {
                if (node.type === 1) {
                    if (node.static || node.once) {
                        node.staticInFor = isInFor;
                    }
                    if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
                        node.staticRoot = true;
                        return;
                    } else {
                        node.staticRoot = false;
                    }
                    if (node.children) {
                        for (var i = 0, l = node.children.length; i < l; i++) {
                            markStaticRoots(node.children[i], isInFor || !!node.for);
                        }
                    }
                    if (node.ifConditions) {
                        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
                            markStaticRoots(node.ifConditions[i$1].block, isInFor);
                        }
                    }
                }
            }
            function isStatic(node) {
                if (node.type === 2) {
                    return false;
                }
                if (node.type === 3) {
                    return true;
                }
                return !!(node.pre || !node.hasBindings && !node.if && !node.for && !isBuiltInTag(node.tag) && isPlatformReservedTag(node.tag) && !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
            }
            function isDirectChildOfTemplateFor(node) {
                while (node.parent) {
                    node = node.parent;
                    if (node.tag !== "template") {
                        return false;
                    }
                    if (node.for) {
                        return true;
                    }
                }
                return false;
            }
            var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
            var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
            var keyCodes = {
                esc: 27,
                tab: 9,
                enter: 13,
                space: 32,
                up: 38,
                left: 37,
                right: 39,
                down: 40,
                delete: [ 8, 46 ]
            };
            var keyNames = {
                esc: "Escape",
                tab: "Tab",
                enter: "Enter",
                space: " ",
                up: [ "Up", "ArrowUp" ],
                left: [ "Left", "ArrowLeft" ],
                right: [ "Right", "ArrowRight" ],
                down: [ "Down", "ArrowDown" ],
                delete: [ "Backspace", "Delete" ]
            };
            var genGuard = function(condition) {
                return "if(" + condition + ")return null;";
            };
            var modifierCode = {
                stop: "$event.stopPropagation();",
                prevent: "$event.preventDefault();",
                self: genGuard("$event.target !== $event.currentTarget"),
                ctrl: genGuard("!$event.ctrlKey"),
                shift: genGuard("!$event.shiftKey"),
                alt: genGuard("!$event.altKey"),
                meta: genGuard("!$event.metaKey"),
                left: genGuard("'button' in $event && $event.button !== 0"),
                middle: genGuard("'button' in $event && $event.button !== 1"),
                right: genGuard("'button' in $event && $event.button !== 2")
            };
            function genHandlers(events, isNative, warn) {
                var res = isNative ? "nativeOn:{" : "on:{";
                for (var name in events) {
                    res += '"' + name + '":' + genHandler(name, events[name]) + ",";
                }
                return res.slice(0, -1) + "}";
            }
            function genHandler(name, handler) {
                if (!handler) {
                    return "function(){}";
                }
                if (Array.isArray(handler)) {
                    return "[" + handler.map(function(handler) {
                        return genHandler(name, handler);
                    }).join(",") + "]";
                }
                var isMethodPath = simplePathRE.test(handler.value);
                var isFunctionExpression = fnExpRE.test(handler.value);
                if (!handler.modifiers) {
                    if (isMethodPath || isFunctionExpression) {
                        return handler.value;
                    }
                    return "function($event){" + handler.value + "}";
                } else {
                    var code = "";
                    var genModifierCode = "";
                    var keys = [];
                    for (var key in handler.modifiers) {
                        if (modifierCode[key]) {
                            genModifierCode += modifierCode[key];
                            if (keyCodes[key]) {
                                keys.push(key);
                            }
                        } else if (key === "exact") {
                            var modifiers = handler.modifiers;
                            genModifierCode += genGuard([ "ctrl", "shift", "alt", "meta" ].filter(function(keyModifier) {
                                return !modifiers[keyModifier];
                            }).map(function(keyModifier) {
                                return "$event." + keyModifier + "Key";
                            }).join("||"));
                        } else {
                            keys.push(key);
                        }
                    }
                    if (keys.length) {
                        code += genKeyFilter(keys);
                    }
                    if (genModifierCode) {
                        code += genModifierCode;
                    }
                    var handlerCode = isMethodPath ? "return " + handler.value + "($event)" : isFunctionExpression ? "return (" + handler.value + ")($event)" : handler.value;
                    return "function($event){" + code + handlerCode + "}";
                }
            }
            function genKeyFilter(keys) {
                return "if(!('button' in $event)&&" + keys.map(genFilterCode).join("&&") + ")return null;";
            }
            function genFilterCode(key) {
                var keyVal = parseInt(key, 10);
                if (keyVal) {
                    return "$event.keyCode!==" + keyVal;
                }
                var keyCode = keyCodes[key];
                var keyName = keyNames[key];
                return "_k($event.keyCode," + JSON.stringify(key) + "," + JSON.stringify(keyCode) + "," + "$event.key," + "" + JSON.stringify(keyName) + ")";
            }
            function on(el, dir) {
                if (false) {
                    warn("v-on without argument does not support modifiers.");
                }
                el.wrapListeners = function(code) {
                    return "_g(" + code + "," + dir.value + ")";
                };
            }
            function bind$1(el, dir) {
                el.wrapData = function(code) {
                    return "_b(" + code + ",'" + el.tag + "'," + dir.value + "," + (dir.modifiers && dir.modifiers.prop ? "true" : "false") + (dir.modifiers && dir.modifiers.sync ? ",true" : "") + ")";
                };
            }
            var baseDirectives = {
                on: on,
                bind: bind$1,
                cloak: noop
            };
            var CodegenState = function CodegenState(options) {
                this.options = options;
                this.warn = options.warn || baseWarn;
                this.transforms = pluckModuleFunction(options.modules, "transformCode");
                this.dataGenFns = pluckModuleFunction(options.modules, "genData");
                this.directives = extend(extend({}, baseDirectives), options.directives);
                var isReservedTag = options.isReservedTag || no;
                this.maybeComponent = function(el) {
                    return !isReservedTag(el.tag);
                };
                this.onceId = 0;
                this.staticRenderFns = [];
            };
            function generate(ast, options) {
                var state = new CodegenState(options);
                var code = ast ? genElement(ast, state) : '_c("div")';
                return {
                    render: "with(this){return " + code + "}",
                    staticRenderFns: state.staticRenderFns
                };
            }
            function genElement(el, state) {
                if (el.staticRoot && !el.staticProcessed) {
                    return genStatic(el, state);
                } else if (el.once && !el.onceProcessed) {
                    return genOnce(el, state);
                } else if (el.for && !el.forProcessed) {
                    return genFor(el, state);
                } else if (el.if && !el.ifProcessed) {
                    return genIf(el, state);
                } else if (el.tag === "template" && !el.slotTarget) {
                    return genChildren(el, state) || "void 0";
                } else if (el.tag === "slot") {
                    return genSlot(el, state);
                } else {
                    var code;
                    if (el.component) {
                        code = genComponent(el.component, el, state);
                    } else {
                        var data = el.plain ? undefined : genData$2(el, state);
                        var children = el.inlineTemplate ? null : genChildren(el, state, true);
                        code = "_c('" + el.tag + "'" + (data ? "," + data : "") + (children ? "," + children : "") + ")";
                    }
                    for (var i = 0; i < state.transforms.length; i++) {
                        code = state.transforms[i](el, code);
                    }
                    return code;
                }
            }
            function genStatic(el, state) {
                el.staticProcessed = true;
                state.staticRenderFns.push("with(this){return " + genElement(el, state) + "}");
                return "_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ",true" : "") + ")";
            }
            function genOnce(el, state) {
                el.onceProcessed = true;
                if (el.if && !el.ifProcessed) {
                    return genIf(el, state);
                } else if (el.staticInFor) {
                    var key = "";
                    var parent = el.parent;
                    while (parent) {
                        if (parent.for) {
                            key = parent.key;
                            break;
                        }
                        parent = parent.parent;
                    }
                    if (!key) {
                        "production" !== "production" && state.warn("v-once can only be used inside v-for that is keyed. ");
                        return genElement(el, state);
                    }
                    return "_o(" + genElement(el, state) + "," + state.onceId++ + "," + key + ")";
                } else {
                    return genStatic(el, state);
                }
            }
            function genIf(el, state, altGen, altEmpty) {
                el.ifProcessed = true;
                return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
            }
            function genIfConditions(conditions, state, altGen, altEmpty) {
                if (!conditions.length) {
                    return altEmpty || "_e()";
                }
                var condition = conditions.shift();
                if (condition.exp) {
                    return "(" + condition.exp + ")?" + genTernaryExp(condition.block) + ":" + genIfConditions(conditions, state, altGen, altEmpty);
                } else {
                    return "" + genTernaryExp(condition.block);
                }
                function genTernaryExp(el) {
                    return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
                }
            }
            function genFor(el, state, altGen, altHelper) {
                var exp = el.for;
                var alias = el.alias;
                var iterator1 = el.iterator1 ? "," + el.iterator1 : "";
                var iterator2 = el.iterator2 ? "," + el.iterator2 : "";
                if (false) {
                    state.warn("<" + el.tag + ' v-for="' + alias + " in " + exp + '">: component lists rendered with ' + "v-for should have explicit keys. " + "See https://vuejs.org/guide/list.html#key for more info.", true);
                }
                el.forProcessed = true;
                return (altHelper || "_l") + "((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + (altGen || genElement)(el, state) + "})";
            }
            function genData$2(el, state) {
                var data = "{";
                var dirs = genDirectives(el, state);
                if (dirs) {
                    data += dirs + ",";
                }
                if (el.key) {
                    data += "key:" + el.key + ",";
                }
                if (el.ref) {
                    data += "ref:" + el.ref + ",";
                }
                if (el.refInFor) {
                    data += "refInFor:true,";
                }
                if (el.pre) {
                    data += "pre:true,";
                }
                if (el.component) {
                    data += 'tag:"' + el.tag + '",';
                }
                for (var i = 0; i < state.dataGenFns.length; i++) {
                    data += state.dataGenFns[i](el);
                }
                if (el.attrs) {
                    data += "attrs:{" + genProps(el.attrs) + "},";
                }
                if (el.props) {
                    data += "domProps:{" + genProps(el.props) + "},";
                }
                if (el.events) {
                    data += genHandlers(el.events, false, state.warn) + ",";
                }
                if (el.nativeEvents) {
                    data += genHandlers(el.nativeEvents, true, state.warn) + ",";
                }
                if (el.slotTarget && !el.slotScope) {
                    data += "slot:" + el.slotTarget + ",";
                }
                if (el.scopedSlots) {
                    data += genScopedSlots(el.scopedSlots, state) + ",";
                }
                if (el.model) {
                    data += "model:{value:" + el.model.value + ",callback:" + el.model.callback + ",expression:" + el.model.expression + "},";
                }
                if (el.inlineTemplate) {
                    var inlineTemplate = genInlineTemplate(el, state);
                    if (inlineTemplate) {
                        data += inlineTemplate + ",";
                    }
                }
                data = data.replace(/,$/, "") + "}";
                if (el.wrapData) {
                    data = el.wrapData(data);
                }
                if (el.wrapListeners) {
                    data = el.wrapListeners(data);
                }
                return data;
            }
            function genDirectives(el, state) {
                var dirs = el.directives;
                if (!dirs) {
                    return;
                }
                var res = "directives:[";
                var hasRuntime = false;
                var i, l, dir, needRuntime;
                for (i = 0, l = dirs.length; i < l; i++) {
                    dir = dirs[i];
                    needRuntime = true;
                    var gen = state.directives[dir.name];
                    if (gen) {
                        needRuntime = !!gen(el, dir, state.warn);
                    }
                    if (needRuntime) {
                        hasRuntime = true;
                        res += '{name:"' + dir.name + '",rawName:"' + dir.rawName + '"' + (dir.value ? ",value:(" + dir.value + "),expression:" + JSON.stringify(dir.value) : "") + (dir.arg ? ',arg:"' + dir.arg + '"' : "") + (dir.modifiers ? ",modifiers:" + JSON.stringify(dir.modifiers) : "") + "},";
                    }
                }
                if (hasRuntime) {
                    return res.slice(0, -1) + "]";
                }
            }
            function genInlineTemplate(el, state) {
                var ast = el.children[0];
                if (false) {
                    state.warn("Inline-template components must have exactly one child element.");
                }
                if (ast.type === 1) {
                    var inlineRenderFns = generate(ast, state.options);
                    return "inlineTemplate:{render:function(){" + inlineRenderFns.render + "},staticRenderFns:[" + inlineRenderFns.staticRenderFns.map(function(code) {
                        return "function(){" + code + "}";
                    }).join(",") + "]}";
                }
            }
            function genScopedSlots(slots, state) {
                return "scopedSlots:_u([" + Object.keys(slots).map(function(key) {
                    return genScopedSlot(key, slots[key], state);
                }).join(",") + "])";
            }
            function genScopedSlot(key, el, state) {
                if (el.for && !el.forProcessed) {
                    return genForScopedSlot(key, el, state);
                }
                var fn = "function(" + String(el.slotScope) + "){" + "return " + (el.tag === "template" ? el.if ? el.if + "?" + (genChildren(el, state) || "undefined") + ":undefined" : genChildren(el, state) || "undefined" : genElement(el, state)) + "}";
                return "{key:" + key + ",fn:" + fn + "}";
            }
            function genForScopedSlot(key, el, state) {
                var exp = el.for;
                var alias = el.alias;
                var iterator1 = el.iterator1 ? "," + el.iterator1 : "";
                var iterator2 = el.iterator2 ? "," + el.iterator2 : "";
                el.forProcessed = true;
                return "_l((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + genScopedSlot(key, el, state) + "})";
            }
            function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
                var children = el.children;
                if (children.length) {
                    var el$1 = children[0];
                    if (children.length === 1 && el$1.for && el$1.tag !== "template" && el$1.tag !== "slot") {
                        return (altGenElement || genElement)(el$1, state);
                    }
                    var normalizationType = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
                    var gen = altGenNode || genNode;
                    return "[" + children.map(function(c) {
                        return gen(c, state);
                    }).join(",") + "]" + (normalizationType ? "," + normalizationType : "");
                }
            }
            function getNormalizationType(children, maybeComponent) {
                var res = 0;
                for (var i = 0; i < children.length; i++) {
                    var el = children[i];
                    if (el.type !== 1) {
                        continue;
                    }
                    if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function(c) {
                        return needsNormalization(c.block);
                    })) {
                        res = 2;
                        break;
                    }
                    if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function(c) {
                        return maybeComponent(c.block);
                    })) {
                        res = 1;
                    }
                }
                return res;
            }
            function needsNormalization(el) {
                return el.for !== undefined || el.tag === "template" || el.tag === "slot";
            }
            function genNode(node, state) {
                if (node.type === 1) {
                    return genElement(node, state);
                }
                if (node.type === 3 && node.isComment) {
                    return genComment(node);
                } else {
                    return genText(node);
                }
            }
            function genText(text) {
                return "_v(" + (text.type === 2 ? text.expression : transformSpecialNewlines(JSON.stringify(text.text))) + ")";
            }
            function genComment(comment) {
                return "_e(" + JSON.stringify(comment.text) + ")";
            }
            function genSlot(el, state) {
                var slotName = el.slotName || '"default"';
                var children = genChildren(el, state);
                var res = "_t(" + slotName + (children ? "," + children : "");
                var attrs = el.attrs && "{" + el.attrs.map(function(a) {
                    return camelize(a.name) + ":" + a.value;
                }).join(",") + "}";
                var bind$$1 = el.attrsMap["v-bind"];
                if ((attrs || bind$$1) && !children) {
                    res += ",null";
                }
                if (attrs) {
                    res += "," + attrs;
                }
                if (bind$$1) {
                    res += (attrs ? "" : ",null") + "," + bind$$1;
                }
                return res + ")";
            }
            function genComponent(componentName, el, state) {
                var children = el.inlineTemplate ? null : genChildren(el, state, true);
                return "_c(" + componentName + "," + genData$2(el, state) + (children ? "," + children : "") + ")";
            }
            function genProps(props) {
                var res = "";
                for (var i = 0; i < props.length; i++) {
                    var prop = props[i];
                    {
                        res += '"' + prop.name + '":' + transformSpecialNewlines(prop.value) + ",";
                    }
                }
                return res.slice(0, -1);
            }
            function transformSpecialNewlines(text) {
                return text.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
            }
            var prohibitedKeywordRE = new RegExp("\\b" + ("do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const," + "super,throw,while,yield,delete,export,import,return,switch,default," + "extends,finally,continue,debugger,function,arguments").split(",").join("\\b|\\b") + "\\b");
            var unaryOperatorsRE = new RegExp("\\b" + "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") + "\\s*\\([^\\)]*\\)");
            var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
            function detectErrors(ast) {
                var errors = [];
                if (ast) {
                    checkNode(ast, errors);
                }
                return errors;
            }
            function checkNode(node, errors) {
                if (node.type === 1) {
                    for (var name in node.attrsMap) {
                        if (dirRE.test(name)) {
                            var value = node.attrsMap[name];
                            if (value) {
                                if (name === "v-for") {
                                    checkFor(node, 'v-for="' + value + '"', errors);
                                } else if (onRE.test(name)) {
                                    checkEvent(value, name + '="' + value + '"', errors);
                                } else {
                                    checkExpression(value, name + '="' + value + '"', errors);
                                }
                            }
                        }
                    }
                    if (node.children) {
                        for (var i = 0; i < node.children.length; i++) {
                            checkNode(node.children[i], errors);
                        }
                    }
                } else if (node.type === 2) {
                    checkExpression(node.expression, node.text, errors);
                }
            }
            function checkEvent(exp, text, errors) {
                var stipped = exp.replace(stripStringRE, "");
                var keywordMatch = stipped.match(unaryOperatorsRE);
                if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== "$") {
                    errors.push("avoid using JavaScript unary operator as property name: " + '"' + keywordMatch[0] + '" in expression ' + text.trim());
                }
                checkExpression(exp, text, errors);
            }
            function checkFor(node, text, errors) {
                checkExpression(node.for || "", text, errors);
                checkIdentifier(node.alias, "v-for alias", text, errors);
                checkIdentifier(node.iterator1, "v-for iterator", text, errors);
                checkIdentifier(node.iterator2, "v-for iterator", text, errors);
            }
            function checkIdentifier(ident, type, text, errors) {
                if (typeof ident === "string") {
                    try {
                        new Function("var " + ident + "=_");
                    } catch (e) {
                        errors.push("invalid " + type + ' "' + ident + '" in expression: ' + text.trim());
                    }
                }
            }
            function checkExpression(exp, text, errors) {
                try {
                    new Function("return " + exp);
                } catch (e) {
                    var keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
                    if (keywordMatch) {
                        errors.push("avoid using JavaScript keyword as property name: " + '"' + keywordMatch[0] + '"\n  Raw expression: ' + text.trim());
                    } else {
                        errors.push("invalid expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n");
                    }
                }
            }
            function createFunction(code, errors) {
                try {
                    return new Function(code);
                } catch (err) {
                    errors.push({
                        err: err,
                        code: code
                    });
                    return noop;
                }
            }
            function createCompileToFunctionFn(compile) {
                var cache = Object.create(null);
                return function compileToFunctions(template, options, vm) {
                    options = extend({}, options);
                    var warn$$1 = options.warn || warn;
                    delete options.warn;
                    if (false) {
                        try {
                            new Function("return 1");
                        } catch (e) {
                            if (e.toString().match(/unsafe-eval|CSP/)) {
                                warn$$1("It seems you are using the standalone build of Vue.js in an " + "environment with Content Security Policy that prohibits unsafe-eval. " + "The template compiler cannot work in this environment. Consider " + "relaxing the policy to allow unsafe-eval or pre-compiling your " + "templates into render functions.");
                            }
                        }
                    }
                    var key = options.delimiters ? String(options.delimiters) + template : template;
                    if (cache[key]) {
                        return cache[key];
                    }
                    var compiled = compile(template, options);
                    if (false) {
                        if (compiled.errors && compiled.errors.length) {
                            warn$$1("Error compiling template:\n\n" + template + "\n\n" + compiled.errors.map(function(e) {
                                return "- " + e;
                            }).join("\n") + "\n", vm);
                        }
                        if (compiled.tips && compiled.tips.length) {
                            compiled.tips.forEach(function(msg) {
                                return tip(msg, vm);
                            });
                        }
                    }
                    var res = {};
                    var fnGenErrors = [];
                    res.render = createFunction(compiled.render, fnGenErrors);
                    res.staticRenderFns = compiled.staticRenderFns.map(function(code) {
                        return createFunction(code, fnGenErrors);
                    });
                    if (false) {
                        if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                            warn$$1("Failed to generate render function:\n\n" + fnGenErrors.map(function(ref) {
                                var err = ref.err;
                                var code = ref.code;
                                return err.toString() + " in\n\n" + code + "\n";
                            }).join("\n"), vm);
                        }
                    }
                    return cache[key] = res;
                };
            }
            function createCompilerCreator(baseCompile) {
                return function createCompiler(baseOptions) {
                    function compile(template, options) {
                        var finalOptions = Object.create(baseOptions);
                        var errors = [];
                        var tips = [];
                        finalOptions.warn = function(msg, tip) {
                            (tip ? tips : errors).push(msg);
                        };
                        if (options) {
                            if (options.modules) {
                                finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                            }
                            if (options.directives) {
                                finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                            }
                            for (var key in options) {
                                if (key !== "modules" && key !== "directives") {
                                    finalOptions[key] = options[key];
                                }
                            }
                        }
                        var compiled = baseCompile(template, finalOptions);
                        if (false) {
                            errors.push.apply(errors, detectErrors(compiled.ast));
                        }
                        compiled.errors = errors;
                        compiled.tips = tips;
                        return compiled;
                    }
                    return {
                        compile: compile,
                        compileToFunctions: createCompileToFunctionFn(compile)
                    };
                };
            }
            var createCompiler = createCompilerCreator(function baseCompile(template, options) {
                var ast = parse(template.trim(), options);
                if (options.optimize !== false) {
                    optimize(ast, options);
                }
                var code = generate(ast, options);
                return {
                    ast: ast,
                    render: code.render,
                    staticRenderFns: code.staticRenderFns
                };
            });
            var ref$1 = createCompiler(baseOptions);
            var compileToFunctions = ref$1.compileToFunctions;
            var div;
            function getShouldDecode(href) {
                div = div || document.createElement("div");
                div.innerHTML = href ? '<a href="\n"/>' : '<div a="\n"/>';
                return div.innerHTML.indexOf("&#10;") > 0;
            }
            var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
            var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
            var idToTemplate = cached(function(id) {
                var el = query(id);
                return el && el.innerHTML;
            });
            var mount = Vue.prototype.$mount;
            Vue.prototype.$mount = function(el, hydrating) {
                el = el && query(el);
                if (el === document.body || el === document.documentElement) {
                    "production" !== "production" && warn("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
                    return this;
                }
                var options = this.$options;
                if (!options.render) {
                    var template = options.template;
                    if (template) {
                        if (typeof template === "string") {
                            if (template.charAt(0) === "#") {
                                template = idToTemplate(template);
                                if (false) {
                                    warn("Template element not found or is empty: " + options.template, this);
                                }
                            }
                        } else if (template.nodeType) {
                            template = template.innerHTML;
                        } else {
                            if (false) {
                                warn("invalid template option:" + template, this);
                            }
                            return this;
                        }
                    } else if (el) {
                        template = getOuterHTML(el);
                    }
                    if (template) {
                        if (false) {
                            mark("compile");
                        }
                        var ref = compileToFunctions(template, {
                            shouldDecodeNewlines: shouldDecodeNewlines,
                            shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                            delimiters: options.delimiters,
                            comments: options.comments
                        }, this);
                        var render = ref.render;
                        var staticRenderFns = ref.staticRenderFns;
                        options.render = render;
                        options.staticRenderFns = staticRenderFns;
                        if (false) {
                            mark("compile end");
                            measure("vue " + this._name + " compile", "compile", "compile end");
                        }
                    }
                }
                return mount.call(this, el, hydrating);
            };
            function getOuterHTML(el) {
                if (el.outerHTML) {
                    return el.outerHTML;
                } else {
                    var container = document.createElement("div");
                    container.appendChild(el.cloneNode(true));
                    return container.innerHTML;
                }
            }
            Vue.compile = compileToFunctions;
            __webpack_exports__["a"] = Vue;
        }).call(__webpack_exports__, __webpack_require__(13), __webpack_require__(219).setImmediate);
    }, function(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(166);
    } ]);
});
//# sourceMappingURL=pylon-bootstrap-vue.umd.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pylon-bootstrap-vue/dist/pylon-bootstrap-vue.umd.js
// module id = rI7h
// module chunks = 0